// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"gOt5b":[function(require,module,exports,__globalThis) {
var _createSections = require("./createSections");
var _input = require("./input");
var _parseInput = require("./parseInput");
// Parse the input files
const folderStructure = (0, _parseInput.createFolderStructure)((0, _input.files));
// Create the top section
const divTop = document.getElementById('top');
(0, _createSections.createTopSection)(divTop);
// Create the content section
const divContent = document.getElementById('content');
(0, _createSections.createContentSection)(divContent, folderStructure);

},{"./createSections":"dscZ0","./input":"g8yjT","./parseInput":"iSK2q"}],"dscZ0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createContentSection", ()=>createContentSection);
parcelHelpers.export(exports, "createTopSection", ()=>createTopSection);
var _input = require("./input");
var _crypto = require("crypto");
const createFormSubmit = (id, parameters)=>{
    const form = document.createElement('form');
    const input = document.createElement('input');
    const inputInner = document.createElement('input');
    form.action = 'https://codesandbox.io/api/v1/sandboxes/define';
    form.method = 'POST';
    form.target = '_blank';
    input.type = 'hidden';
    input.name = 'parameters';
    const paramsIdx = parameters.indexOf('?parameters=');
    input.value = paramsIdx !== -1 ? parameters.substring(paramsIdx + 12) : parameters;
    inputInner.type = "submit";
    inputInner.id = id;
    inputInner.style.display = "none";
    inputInner.value = "Create CodeSandbox";
    form.appendChild(input);
    form.appendChild(inputInner);
    return form;
};
const createId = (path)=>{
    const id = (0, _crypto.createHash)('sha256');
    id.update(path);
    return id.digest('hex');
};
/**
 * Traverse the folder structure and create a list of items
 * For each folder in the folder structure create a list item
 * 
 * @param parent 
 * @param folder 
 */ const traverseList = (parent, folder, path)=>{
    for(let f in folder)if (folder[f].href !== undefined) {
        // if the folder has a href it is a file
        const li = document.createElement("li");
        li.className = 'file';
        const div = document.createElement('div');
        div.className = 'button-container';
        // create a link to the file
        const a = document.createElement("a");
        a.textContent = folder[f].name.replace(/-/g, ' ').replace(/_/g, ' ');
        a.classList.add('a-example-link');
        a.href = folder[f].href;
        div.appendChild(a);
        // create an icon for the code sandbox link
        const codeSandBoxSpan = document.createElement("span");
        codeSandBoxSpan.id = 'codeSandBoxSpan-button';
        codeSandBoxSpan.className = `material-symbols-outlined button plausible-event-name=codeSandBox-button plausible-event-example=${folder[f].name}`;
        codeSandBoxSpan.textContent = 'deployed_code';
        const id = createId(folder[f].codeSandBox);
        const formSubmit = createFormSubmit(id, folder[f].codeSandBox);
        codeSandBoxSpan.appendChild(formSubmit);
        codeSandBoxSpan.onclick = ()=>document.getElementById(id).click();
        div.appendChild(codeSandBoxSpan);
        // create an icon for the github link
        const gitHubSpan = document.createElement("span");
        gitHubSpan.id = 'gitHub-button';
        gitHubSpan.className = `material-symbols-outlined button plausible-event-name=gitHub-button plausible-event-example=${folder[f].name}`;
        gitHubSpan.innerHTML = 'code';
        gitHubSpan.setAttribute('onclick', `window.open('${folder[f].github}', '_blank')`);
        div.appendChild(gitHubSpan);
        li.appendChild(div);
        // create a description for the file
        if (folder[f].description) {
            const newDiv = document.createElement('div');
            const description = document.createElement('p');
            description.textContent = folder[f].description;
            description.classList.add('description');
            newDiv.appendChild(description);
            li.appendChild(newDiv);
        }
        parent.appendChild(li);
    } else {
        // if the folder does not have a href it is a folder
        const ul = document.createElement('ul');
        const li = document.createElement("li");
        li.className = 'folder';
        const currentPath = path + f + '/';
        const markdownData = (0, _input.markdownFiles).find((file)=>file.path === currentPath);
        const div = document.createElement('div');
        div.classList.add('div-li');
        li.appendChild(div);
        let sectionName;
        if (markdownData) {
            const markdownElement = document.createElement('div');
            markdownElement.innerHTML = markdownData.markdown;
            // get first h3 element
            const h3 = markdownElement.querySelector('h3');
            if (h3) {
                sectionName = h3.textContent?.replace(/-/g, ' ').replace(/_/g, ' ').toLowerCase();
                h3.textContent = sectionName;
            }
            markdownElement.classList.add('markdown-element');
            div.appendChild(markdownElement);
        }
        if (sectionName === undefined) {
            const paragraphElement = document.createElement('p');
            sectionName = f.replace(/-/g, ' ').replace(/_/g, ' ');
            paragraphElement.textContent = sectionName;
            paragraphElement.classList.add('paragraph-element');
            div.prepend(paragraphElement);
        }
        li.id = sectionName;
        div.id = sectionName;
        parent.appendChild(li);
        li.appendChild(ul);
        traverseList(ul, folder[f], path + f + '/');
    }
    // order the list
    const order = [
        'showcase',
        'setup',
        'session',
        'viewport',
        'scene tree manipulation',
        'augmented reality',
        'materials',
        'html anchors',
        'animations',
        'three.js',
        'general',
        'drawing tools',
        'gumball transform',
        'rectangle transform',
        'interactions',
        'attribute visualization'
    ];
    // order the list
    const items = Array.from(parent.children);
    items.sort((a, b)=>{
        const aMainClass = a.className.split(" ")[0];
        const bMainClass = b.className.split(" ")[0];
        if (aMainClass === bMainClass) return order.indexOf(a.id) - order.indexOf(b.id);
        return aMainClass === 'folder' ? 1 : -1;
    });
    items.forEach((item)=>parent.appendChild(item));
};
const createContentSection = (parent, folderStructure)=>{
    // create the initial list
    const ul = document.createElement('ul');
    parent.appendChild(ul);
    traverseList(ul, folderStructure, 'examples/');
};
const createTopSection = (parent)=>{
    // create the header div
    const titleDiv = document.createElement('div');
    titleDiv.classList.add('title-container');
    parent.appendChild(titleDiv);
    // create the logo
    const logo = document.createElement('img');
    logo.src = 'https://viewer.shapediver.com/v3/graphics/logo.png';
    logo.classList.add('logo');
    titleDiv.appendChild(logo);
    // create the header
    const title = document.createElement('h1');
    title.innerText = 'ShapeDiver Viewer Examples';
    title.classList.add('title');
    titleDiv.appendChild(title);
    // create the main markdown element
    const markdownElement = document.createElement('div');
    markdownElement.className = 'main-markdown';
    markdownElement.innerHTML = (0, _input.markdownFiles).find((file)=>file.path === 'examples/').markdown;
    parent.appendChild(markdownElement);
};

},{"./input":"g8yjT","crypto":"h9QnT","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"g8yjT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "files", ()=>files);
parcelHelpers.export(exports, "markdownFiles", ()=>markdownFiles);
const files = [
    {
        "href": "examples/AR/default/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqcVZccARJsO4gmVlcAO4Q6AR4iFwAjAAMdQCkANxFWVEQAOaE1fVNrSLF6XDyUPxJ1WCwWAPFPPKUcBIQ1NX8enCUUACutLNzsGAE1f1tVgSU8ictZ1webamijOS6qvxwXOUFL6hvcB6sEw_P6PEzpVSgtDyXa3XKKAoQIj8Towe6DUQ5PIwAoLJbiVZcdabHZ7LiHY5cABMAFZ5DMuBcrlTaTM0cUyhU8AUatS6mz2jAuoRubz-VY4BpyAVCAR5HBEMZjJh1FBLpo4DhOpRKJ1YDgqERjPwNEqYCrLsYAFb8N7GRHI-B28gAfVUEBgJWdaGdxudqA9zq1Or0OxgzoALIF0PIcPJUJ0xaJqOQoBByABrAplDCUEo4VWCACCACUABQASkTYTajDg5A0EHkBAZSXhHiIlHQ21gIQlUo8fbtGGwOAI_xAgOMdYbTfCJkSKU4JhYUGEIAANCAIHAAEJoY1JJBgfhQFwAX03g7QmFwY7IICoNDoBAYsVQiIWGmbwAcGgEtAANXdEpPwIddf3_GBpHgJZqHA3wABlCwAcWdbwAE0AAUAFEuDPLgwA0SgiDuEAAAE4DkRRwU0Yw3Q9TQPAGThS3eJJUHILgKy4VxWC4YBMkVCD-FoQkuHokDKC_TJHxycTgNAnjCRKfgJGEwCFKkghSwE9FgXeap0EochthsGhNVsbDYDMggdySABJdBSw8fTx3LQkPgACW8ABZBCAGFXneKyYBs9c2nKap2ySICPVA_kz3LZiRCE-tILElw4Fg1AZOoOTMuypT-BUtS0pEqCYJWVAdLacQM1sRBbg8ABmQI6gANkpABOLrAnIPQ6mavR0HQcgAHZ2sCdqeXDdq9Ga8N-HDXk9DAMByGamAwFW_hyHatbKXQZrmrADqamGmoagW5quuauoajG8N5q6mouu6mlmva8N0G2saajAQI9C68NvupLrqUpMAxpgGA5q6sa6nQal2vWSkaiOmAHupfgrpqcNjspGBwxpOoobGsBIcpPRFupU7JpgCGwGO_bzqB0aGbG8hqUBrn0b0MbqRgdA9Hayake2mp2re_h-Ah5r-Ee8MXmaqmprAdqEf8HrutlxH0a6onmrGgWlemhnps2sb-Ha5qag8cL0Q7TAoFikpPA0KAopAGU5QVKd0A0aHtnIGocBgbZ_HIZ8NBPfxQ8ohQhbUTR9WI-2IvQL2iCSaCsqqhKkrfHhUqiDNPjABk8G3LhlTTGBPg-F55HWWBCQwMlKEELhBUqTQuBLLgpMr-uAEViwcTtUREUtGF0FJsyMkpy3zTv0AH1wPPYzjuN4_i2lk5sLnTOglIk0CcEEdBfDGTpS0QlC0Kw7CcB3TxpHQ50fIAeSUbDC_RCAFdSxny0jgCSLcYD2VQCWCs7ldLFGKqpZsICvxgOAlAmB_8rD4RgKeeu8CsgHy4AARy0BvRBakUEEH1H-cqhYNC52yghNA6ZSzbGHJAf06BwIEA0NsGAWDCF5WbPaFESl_QlC4PZJEKIKz7CsKImAOA-xKVIfI0QijlG5D1LiZY1AlIeCJFsXYqIQDqJ4JozEeoDAEAuCRDeHgmhMVuEZEyNkcALgvvIRQGB_JVygE5RRgieBnjaFQnAf4OzqGvsiUsR86CCLPAMRKcjOAbi3LufcGhDyIGPHgi8IBm4ZgdDgS0mxUD3kfLQegiAQACRAJgHxmAOLunHMgDwFEqJJ3UCaCSjEkAtRwGjIZHgLztlUjlAZW5hy4BXOnEA05Gxjg8O0hZdhpJTObpKXBnwZn4GIFALg_h_BqkmeFEAehtjQHQCsjwWyo6HMudc3ZN59kkFGec5USgYBNLoOQVpKz6n3Nwf4S5GBYAaFuSAAAeqHGolIcDUnmXCeA9YllQuhdSHA4ZEWjLPOk7ce5UAHiPCec8l5dDC0MKnVAkBOilPKZU6g1SXy1PqWgThEgYAIW1PITCRFaDkHxJMxAvD-HnKcOgYsuDV5f1QH43QKIVlipgOciSUK9BERKC4SFG4PC0CIKMcqULgVQFGQSzJxLsmkvyZuMcj46UMuoEyp8NS6kuWIvIaAmgv5Niqm0-pTtuymMag-YiHZUBlPmZEyg6h_LhufG0vJLhznwB8p2YNUDaBEXkMqvhqqByUG2NsnyCgVnJoLQ0mAKZjQiXzjalNHhMA1pjsK0tuaG2VvWSiAgULsLSHavMnIDYhV5vFR4ItBAVC6tDcMXteqQDYEUA2GyJ5vlUFbVJNpKrU1EAkOuqSIkpI-VsIIES_Ax2VqDbAaVxJdj1tDagSeHyPDYBTNsTAKyADaHgn2YGdNe-A8y50eAALr4s3ISrJOSK1njg0AA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/AR/default/src/index.ts",
        "description": "Either load the model in AR or create a QR-Code if not on a compatible device."
    },
    {
        "href": "examples/AR/hide_objects/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqcVZccARJsO4gmVlcAO4Q6AR4iFwAjAAMdQCkANxFWVEQAOaE1fVNrSLF6XDyUPxJ1WCwWAPFPPKUcBIQ1NX8enCUUACutLNzsGAE1f1tVgSU8ictZ1webamijOS6qvxwXOUFL6hvcB6sEw_P6PEzpVSgtDyXa3XKKAoQIj8Towe6DUQ5PIwAoLJbiVZcdabHZ7LiHY5cABMAFZ5DMuBcrlTaTM0cUyhU8AUatS6mz2jAuoRubz-VY4BpyAVCAR5HBEMZjJh1FBLpo4DhOpRKJ1YDgqERjPwNEqYCrLsYAFb8N7GRHI-B28gAfVUEBgJWdaGdxudqA9zq1Or0OxgzoALIF0PIcPJUJ0xaJqOQoBByABrAplDCUEo4VWCACCACUABQASkTYTajDg5A0EHkBAZSXhHiIlHQ21gIQlUo8fbtGGwOAI_xAgOMdYbTfCJkSKU4JhYUGEIAANCAIHAAEJoY1JJBgfhQFwAX03g7QmFwY7IICoNDoBAYsVQiIWGmbwAcGgEtAANXdEpPwIddf3_GBpHgJZqHA3wABlCwAcWdbwAE0AAUAFEuDPLgwA0SgiDuEAAAE4DkRRwU0Yw3Q9TQPAGThS3eJJUHILgKy4VxWC4YBMkVCD-FoQkuHokDKC_TJHxycTgNAnjCRKfgJGEwCFKkghSwE9FgXeap0EochthsGhNVsbDYDMggdySABJdBSw8fTx3LQkPgACW8ABZBCAGFXneKyYBs9c2nKap2ySICPVA_kz3LZiRCE-tILElw4Fg1AZOoOTMuypT-BUtS0pEqCYJWVAdLacQM1sRBbg8ABmQI6gANkpABOLrAnIPQ6mavR0HQcgAHZ2sCdqeXDdq9Ga8N-HDXk9DAMByGamAwFW_hyHatbKXQZrmrADqamGmoagW5quuauoajG8N5q6mouu6mlmva8N0G2saajAQI9C68NvupLrqUpMAxpgGA5q6sa6nQal2vWSkaiOmAHupfgrpqcNjspGBwxpOoobGsBIcpPRFupU7JpgCGwGO_bzqB0aGbG8hqUBrn0b0MbqRgdA9Hayake2mp2re_h-Ah5r-Ee8MXmaqmprAdqEf8HrutlxH0a6onmrGgWlemhnps2sb-Ha5qag8cL0Q7TAoFikpPA0KAopAGU5QVKd0A0aHtnIGocBgbZ_HIZ8NBPfxQ8ohQhbUTR9WI-2IvQL2iCSaCsqqhKkrfHhUqiDNPjABk8G3LhlTTGBPg-F55HWWBCQwMlKEELhBUqTQuBLLgpMr-uAEViwcTtUREUtGF0FJsyMkpy3zTv0AH1wPPYzjuN4_i2lk5sLnTOglIk0CcEEdBfDGTpS0QlC0Kw7CcB3TxpHQ50fIAeSUbDC5y9EQkq6YDboPXY0Jmx6CSNkWw4h4wfF7vJJYehoASGgRcAiJ4XBtCEr3P8DcuCoEoIQmG6AGTEO2PIdA5Vh7yTilpQeWhEHqGcFVQeFdEFEMwDg4wHlPjcEQbqAgFdHwsMKmAIeA9EEmQ0H-Gg4kTzbHgISfBf4u6UBhOiAqVULIEC_uA3YdkABy_AbDORALIGAUAwAeHLAAbTqAAXRwFwmAABCHAbpkGtw3seU8MBkpWAgBXUsZ8tKeOAi3GA9lUAlgrO5XSxRiqqWbGEr8ESPQxLif_Kw-ErEuD3uiHgB8uAAEctAb2SWpNJBB9RqNoIWDQudsoITQOmUs2xhyQH9OgcCBANBKJyVkEp9oURKX9CULg9kkQogrPsIJMyYA4D7Epcp8zRCjKWZiPUuJljUCUh4IkWxdiohAOsngmzlm5D1AYAgFwSIbw8E0JitwjImRsjgBcF95CKAwP5KuUAnKbKGTwM8RdRBCX4EcPuiCB5lXxNwauRl_R9KiIQyeDhdBcD0PXJEICvEQBDPXZEqkAHikqtQXR-jZSGKSCYsxHhLHWNsQ45xriPEEqJUpfpSjAmiBqTgP8HZ1DX2RKWI-dAhlngGIlOZnANxbl3PuDQh5EB-PPJuZuGYHQ4EtJsVA95Hy0HoIgEAAkQCYF-ZgDi7pxzIA8BRKiScWF0WAoxJALUcBoy9R4C87ZSUeEaluYcuAVzpxANORsY5A3mpyMaAggaPDN0lFY_hN58DECgFwfw_g1Q5Q3B4PQ2xoDoETSAZNUcs1FpLWmkcYaQB-otWaJQMArV0HILamNSbjSVv8EWjAsANBloAHqhxqJSHA1Jw1wngPWKNI7qQ4HDJO31Z4FXbj3KgA8R4sEwAvBG3QwtDCp1QJATour9WGuoMal8przVoG6RIGACFtTyEwkRWg5AEWBp5TAcK3tjToGLFY1eX9UD_N0CiH9Ay_0eAkmWvQRESguCHQWkAtAiCjHKmWitVjfXrqVVulVO7_H7rHI-M9F7qBXqfCas1LliLyGgJoL-TYqp2vNU7bspyg0Gg7KgPV4ahWUHUP5YiNk7XqtgyAeAPlOzcZibQIi8hoNKP_ZsbYKafIKEDVJ_9mAUzGhEvnEjLh9MwEMzHBF2mVOmek3YDQKIE0epANhaQ7Vw05AbF-1T0mNEEBUKhoNwxnP_uwIoBsNkTwtqoFZqSdrf1haIBIGLUkRJSR8rYQQIl-C-f_Vx2AwHiS7BM0G1xvqwtYBTNsbhSA7EeFcc6Ar8Bw0hY8I4tdm4N3KtVVJs8_WgA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/AR/hide_objects/src/index.ts",
        "description": "Hide objects that should not be shown in the AR scene."
    },
    {
        "href": "examples/AR/load_custom_scene/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1dR6poozkuqr8cFxFef2og3DdJuOTPSbpqvNw5BoQ8gRc2Yp5RJToAK6wIXAa5Hmn5MZomLgEUyCsJitrG-EmiSmcJixQwiAAGhAEDgACE0PwNEkkGB-FAXABfIGXa4YbA4e5kEBUGh0AgMTgQIjySgaTYAKi4Q20SgAalwwBpKEQuAByAACcDkikWmmMqggMHymlZXVQnAAFIxdClChhKPkAJQ4aR0riuGm0sWSoZJVDkLgSxXq1hcYBxLiwTYCoUksnldVU_L8CSanCrAS0WmC_J2ggS80iHhFMqsohJb220kEcqsgEWnizIZlRgACW8AFkADIAYQGQwAorAbDRWOhKOQDiWCDhmrYizBq6CkgBJdAS1lJuCsxUWhG9kRWzLwOAQagOjX8Z2u1W090aT0waQjseoAMJkboUPh5dwUfjuMb8TkADWtlDAGYYAAWa_lABs1_vlQvenKACZ0IEYBf0O_KteACsgQAe-MD3uQYDkIE5QwOU_BgHeD73ve5TXgA7BelTofwgHAXo6HkBegEvte5DXoEgH8PweiCNB77vrRACclT9IBOEURe17oIBTFMRR77oXoYDwZ-6Aoeh778JUjE3ve6DCehgFgIRrHEXoMDkDAgFvheCH8DAlQwHogTvuQhE3vwTHlIEKlQcZgQXkx_CSeQgEwGADG3mAAHlFpYABe-16VOgTGBGFejXkx94wOgxHoWAMAsWAXEXu-_i3t-WEXq-GH8BBZmAcR_GVNJlR6BpKm_oeQZcHsmBQJG-SeBoUChoQBDyHAiDGMYcDoBo6EwAc5DlDgw3-FpNAaHC_hjVyCixWomjusyNVWNg5BQAcmBNX63VcAA2h44Z7dG74eAAun2A4WjiWSNEUmCoHmEzUhq5aVtW86Lg21YSh4XYeMa1Lptmr2TH9eJijweBPXQENDDgWQ5DAOACqOejQBISSOh4cPoM9Hgw1wn1VniOCfDgCiKBgOZw1A7YE89iNwLdg62FwNq-udjpTi6myzj9_Bej6frrrVIZsqdYvnetohdmUzMI_mUwiP2FpDi4e6ru-fPToLdLC7Qu77mugZWFLYZJKbuvyzwx5ngQoYpehgQ0fwWFgIE956ExBHoThn4oRe6HOYE4noJheGAVUFlpXe178I5AiQWAwFMReqGheQ5AMSF_BgW796u5Rei-_e_DlJFV6VwR5SJe-TGIUxPHoR-n6BEBWGVBBIGYRHoeSehqEXuZUXJxHVQmdZfvGXo6DlAplRgOguG583JEie-YBMeZLmUXvcW7-QeiQf03GVIB3EwJRAi3w34H9P474wU5YFZw-JnoNekVuVHhE3zlTvO-VC9s6r7BgI1H0LU2psg6l1HqfVMAjTGhNKaBAZpQDmsjbkS11AaFWkQcBm1tq7VlmSA6x0QAyyjPaK6N1YgiAgGAQ03M_TvnRj6GisAWyoAAIIACUjTGgtqIfmrp2HnS4UKPhQijQkwRFwKBLgzQbnupsAAjloScBsuYUIIJwj0IsYD8I0LbagWY0AnglAcNEkBUCxQBFsDQBwYCKhJomagD0iT8DrI6Rx-QuAtiIH4mACiNy-LrMjM4jptGeJGKE6JKNYA4BJKOcQ1A8YgBonASg21aDE0iUktGKS0YGAIAQZk2TahFNqmTb6VMaZ0HQPTaA7YonuMUZwfsCjATAjBBCKEMI4SIiBPIfgp4wk4AAFZ5NQFiHEtB6CIBAOaEAmBabPXIIKB4yAPCcjwbyDQ_IfSaA8IgDwF4cDvjGhdEASITounFEgDwNx0S_A8PGEALx1j3AuesrIkICAXI8BMs4UCRholwL8Lg_h_CUFpl8jwegDjtNBSAcFWkoBcFRe0qFtx8DECgB4R5GyYCqCUDALZdAdnwABWCyE2L_CoowLADQGKAB6Y0Pw4EAsikA2x4CrD-VywCOBrx8tJQifpIJwSoEhNCRAsJ4QwCRD83QClDCrVQJAZosz5mLOoMs_Eqz1loAcRIGAWZKCIoAApMloOQTJLzECYLcd8pw6BBFQMoIIAA8i9OQqA6wXPdTAb53MMV6CZPkFwHLAQeFoMSKAJiMVYqgaS2VgyFXDOVaMtVQJ7g4j1Qa6gRrcQrLWYDZk8hoCaH9RsVcez1n1SODADFVAiB7FQHMgVC49jqBzMyaseyVUuG-fADM-x218NoEyeQYbXERo8Hkg4EKMwKAueOld5KtqQhFqubdBbvmYH3TNF1m7F0jNVd8uwGg6wgteSAAs0h7wCqyGsZ1S6PUeEoAcAgKgE2XI2SCJ9k6sCKDWNWOEVKqAXtJHs8Nk6iASDg6SEWpIMy2EECLfgP7d1ttgD6vJBSj3PtQJA0lEGto7Q7UgahlHMAAH0iP0sTaBrIV0ZVAjlUMpVO6ERCaAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/AR/load_custom_scene/src/index.ts",
        "description": "Load a different scene in a hidden viewport and create a QR-Code for it."
    },
    {
        "href": "examples/animations/hierarchical/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1Delw8lD8SWVgsFgN8pRwEhDUZfx6cJRQAK60DbBgBGWdXASU8ps1HqmijOS6qvxwXEV5p6jncIcmt_dHJumqr3DkGhDyBNtJRR5IiUdCLWAhOAach5KHkYxoTC4AgPECsExfH5_cImRIpTgmFhQYQgAA0IAgcAAQmh-BokkgwPwoC4AL7kuEIjDYHAosggKg0OgEBgQIhjDT_ABUXAu2iUADUuGANJQiFwPAABOByRTvTTGVQQGD5TQeOqcMUS_7ALgAR0W_AIpK46nIAGYuKzlar1R5mlB_EQnT8sObLeLKJKuDK5d4ABIAJQAosmfWqNSAShoYDBw6hOAAKRi6FKFDCUfIAShw0kVXFc8oVFoLqEFWQcOadMGk8iiOYbXELVCgUbKqEWRD0mhdYwm4mmXAnU80AG0ALpVsoJlPJnAAWXgeAbrC4wDiDmoHeaMDVtnpg9QJq4O9Ttb7mhgAHFbzYCPTC3KABWF1ygANlAsCqxbHh23-YNaB-ZlH2fV890PHUqQuCByH3bskKgQtbRHKMvWgi84K4GwdRQ_IXyTN8MLwQsbzvf8khdBDNAgZlyJEai8BwOdJmoHAXAIQthIXVBV0qddZ3GESZPKeSuCkqYZIAJk3GCuBzAhFg0bgBJbVkW04SjvgEWhExgcg7FQAMYEHYcFjHJdJ2nDQFPnDTx08tdN23Bj0KPE8zwoq9_lYv8H0bJ86LQnAqUMH82IAjpQMqLK-NgqKqPwnioFo-jdwPI8sImXDCuZIjL1HLRWVyy9UA7ASSqSpiWN_e8OIKxCiuagShMU6SxNsSTRo02TVPU6hVxUnylNXbTmv0wzjKPUzzNQQsLiSNshyrcLzxEWB_iNE1rUHfh8n4CQmxwKzuwVY18mtIiLx4Ioyg8Igkleq6owIDxSS-hwzguMpGHjbx9wAGQAYUhuBk1gGwaFYdBKHISdhRwG8CDRmAMYIKkkgASXQQsPGeC4PCrMGRB4I0Jj0aAJAGR6FQp6QKapCn4Yp7wAE0AH19wAeSUPcKYAOWkbwAEE5e8C8mp2vLWv-f9-HIABrOAyjrBUcAppXUDFJ0NO8DQ9f1jdBw3TXQilKUvplOXpbTcoPeMWIREo1BQRgcoSpNnBbdzOWQ8LZqI6-OgYCjmAcFVSgCBwQR0ERvBoGp4PMHKZrC9DrP0HQJQnX4QsEse7w8BzGAACs4Cruxhy7Whe37GBC0qLAwDAapqhdWSXWyrg5KrGfdNL8py8r6va-fCOG6b1v25r56bLshynP7wfh5HsegMn8_N1ni958XreV7otfG9zTfl53nsPxzQ-h5HyeFtHqeJ6Xz4pFbWS4Q7lDFg6J0YdGxQMzm_OOukg7gMgY6AgmlBxwPGgQJWWBKQWwPuDLBCDGbgzdO6HAKo1QKmZIseA_cJ6gVIczLg_g8IlBwAABQpqELgmkLzNV1gbOAQlFg6k-iw8Q1Eyjjy4AAFhdIEeS4NS7jnAUzKw5wljwBkeDHg89UHQJmhoqwYCi6GIIOUBayiWH6JQXAqx2kTFWAMQ41c7obGmLMaHCxmljF6O8RAuBfjFoBNcWgvxTiwn2Iie4zxpjwlGLks40QiTLHWJSXY8xbiom2MCRYqxHjwbxJ4PIJ0pRMyqjsNJUG4M0CITGH0aSv0QBQDQAIDQHh1bAJEMYN2HsuBexlnw1hspLYIQ0o0GAUBFBaFLn7AOWsOylwwfFVeipI5NxjpgRB19wGL1zvnWuIdNI9KWf8FZBTMFoKel3PuzVkGYE0r465TpsG4PwY5WANMWHELuXHFJ5DKG-hodouADCAEVGYVYNh5SuE8OMHwgRukhGG1EeI06VgpE6K4LIhRXAlEpNUd4zSgLaE4tXNEp5BT_F5MuW40JdKTk0tyV4-laDCklNScy4JtK2U8tiYy_l1LeWsoSQKp0fiPGZJJTS5JVKYDPIZVyrJiqWUqtlW4opLCuVlJKC0qp1tqC1JYfUzQjSjWoBaW0p8dITVWHkGoDOMjMqQrkt0l2fT3bM09t7Lg7oFmtnOd4z0ayH4bJTts-5c8TkHLzlAAuId3QlyTbfZeddH4bzbq_O5PdPyH2qN_X-5R3Tn0ATPFNmAKHZzvhmiNT8W7Zo7m_Wy9ldAHwHoW4-Y9yiBDLVPIBMaq1po7nW0269n5Nu3rmj-fdO2VCLWPTSpbGEDorS7R5MB3RXNgTckhSD8ql23cE15mdxIfLgAQ75RC93_OhaIIFVCiCgroeC_txcUmwo4dw3h_CRCCLtsI9FzFMWiGxUbXFk98WEpUSHNRVayVgt0UyqtcqNVHppUK8VqGcnoaTTS6VCrj2xPlShrdviMlEYo2Klx-HeWEbI8RpJeGcMcso4x9VMqMNavXMUlJeqKkeENTUskdShQaAtc0zMNqOn2tEI61QzrcUlv7e6kQGtFmu29aIX1wy5GjN0FbaSUyZmaG8YGkByyQ76bDfXLZsdK1brjUc0ucizktSs5gORO77S3ustGyzFzrMvN3W889eDL1fL7jet5JDAV2QoU-l99D333p4OwwSP7EV_p4AB-2Ij5BiJA-DcDMioOKK5cS1ziHX3IeFTAbzbjSP1ca2xrDtGvOcYVUqtjDGWsUea9hhrFH2vcs66Kljw36OTda8xrjwXlXzfG2xmjY2pu9d4zq_j5SDUZ0tXJ764nJN-Wk-0u1omWEKaUytFdbrNs8A00GrTAyhlpiAhZwOh6Q5AXDhG-zOzHNyOcwm45mAgKOaAiOmuY7I4Npfs2mdvcC0jyHkusCqnB17LB1D--9c4dTs7v51t-9vnzq7WPd0VRV3TyviIUukOa3pvWeO_Hd8355s_mThdYAKfo-p5jp7m6gI-b-f53Zn3QH05C75sLtgL1Xui78vz3YAVkIS8C6h5K32ro_eDDL8Lf3IovKigrRWJFYrFBS8rBLKtwe8SBMhWu6tDeF01ybru2vu662Rj3Ri-su4G173lo3VW-_QStIPsT_cdZgGHqxg2Y9x_Y_VpPq3Q8Efu6IXVO3Kl7ZEyks1EmFiWutWdzpF2HVOo2LizSfO7ses016gZiNJYK28J4RG3guAqwpvuJW3gKat64EofvStA3BsMxM6gW9fumwtkZjSd8PCT_22SbYgHDarsCM1Ff0kt5pxgIoJ0g5_x0N0gncgScU5p0oBnHHu_F_Vx3-My1--sh0hwS_6S4umri7JBSakWkekRkZkNkckMpA2fgG8HAVuagfkQUWgegRAEAc8EATARQbkNsY0VEZALUHUBQGAfUDQQ0N6M0JADwChTSBefhUTLMBtDwRADwSoHAXtIHSoDwdkP6e6AscgikbkXAIkWpEATEX4FEBg1A9_SUBgjwMpaEaZK4fg_AYgYqfwfwXYOgIQvQRYfOaQkAWQy_YqLQ_OBQpEJQkgDgsGNAmAVQJQQ_OgTALA-AcQmQukAw_wLQjAWAcvRgkAAAPQXnKE0hwHe1oOyEUBEL-F0N8MhyBxCNZFZH_0pBpFQDpAZEQCZBZBgHZGEN0HQAMFwEFEgGaBgPmFQHgOoEQJFGQNQLQEgEtloHhlv3kE4SqT3g0gYNPxgEsKcHQFslHEEEllQFznbTzCQE6MsMunyF0L0FVHyBcHL0sNoHFCaVGJ8P0OmQ4MSMAJSOAPSNAKyPJBREKJaBKLgOQAFAqOFAYFQKoHFGgE0Elj-A0hwNQJBDBAhF4NuJBFQFbiEJzBBHUERjVFJhwIyJcEsPgH3FBHBBgApnE12A6I0DoUsPmEMkvzwnkAYLBK6I8EwHID6DthEz2MyMsLxIJMtQxKxP2MWLpEJl0OTGkDAiEKyB-HskRORI8EoGWBUG8NxMpBBloOwFmUtxoGZFsKoEJKjBwPGI8BJgkHFKjCdCjEPDsHQGrnZJxJADeJhNsnmCWCJI8HmRAE4JAGwHxMWEwAYMpRAFLjFm1NgFRFJP5I8HXASPJCSKALSOxPiNZCAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/animations/hierarchical/src/index.ts",
        "description": "Create a hierarchical animation."
    },
    {
        "href": "examples/animations/hierarchical_advanced/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1Delw8lD8SWVgsFgN8pRwEhDUZfx6cJRQAK60DbBgBGWdXASU8ps1HqmijOS6qvxwXEV5p6jncIcmt_dHJumqr3DkGhDyBNtJRR5IiUdCLWAhOAach5KHkYxoTC4AgPECsExfH5_cImRIpTgmFhQYQgAA0IAgcAAQmh-BokkgwPwoC4AL7kuEIjDYHAosggKg0OgEBgQIhjDT_ABUXAu2iUADUuGANJQiFwPAABOByRTvTTGVQQGD5TQeOqcMUS_7ALgAR0W_AIpK46nIAGYuKzlar1R5mlB_EQnT8sObLeLKJKuDK5d4ABIAJQAosmfWqNSAShoYDBw6hOAAKRi6FKFDCUfIAShw0kVXFc8oVFoLqEFWQcOadMGk8iiOYbXELVCgUbKqEWRD0mhdYwm4mmXAnU80AG0ALpVsoJlPJnAAWXgeAbrC4wDiDmoHeaMDVtnpg9QJq4O9Ttb7mhgAHFbzYCPTC3KABWF1ygANlAsCqxbHh23-YNaB-ZlH2fV890PHUqQuCByH3bskKgQtbRHKMvWgi84K4GwdRQ_IXyTN8MLwQsbzvf8khdBDNAgZlyJEai8BwOdJmoHAXAIQthIXVBV0qddZ3GESZPKeSuCkqYZIAJk3GCuBzAhFg0bgBJbVkW04SjvgEWhExgcg7FQAMYEHYcFjHJdJ2nDQFPnDTx08tdN23Bj0KPE8zwoq9_lYv8H0bJ86LQnAqUMH82IAjpQMqLK-NgqKqPwnioFo-jdwPI8sImXDCuZIjL1HLRWVyy9UA7ASSqSpiWN_e8OIKxCiuagShMU6SxNsSTRo02TVPU6hVxUnylNXbTmv0wzjKPUzzNQQsLiSNshyrcLzxEWB_iNE1rUHfh8n4CQmxwKzuwVY18mtIiLx4Ioyg8Igkleq6owIDxSS-hwzguMpGHjbx9wAGQAYUhuBk1gGwaFYdBKHISdhRwG8CDRmAMYIKkkgASXQQsPGeC4PCrMGRB4I0Jj0aAJAGR6FQp6QKapCn4Yp7wAE0AH19wAeSUPcKYAOWkbwAEE5e8C8mp2vLWv-f9-HIABrOAyjrBUcAppXUDFJ0NO8DQ9f1jdBw3TXQilKUvplOXpbTcoPeMWIREo1BQRgcoSpNnBbdzOWQ8LZqI6-OgYCjmAcFVSgCBwQR0ERvBoGp4PMHKZrC9DrP0HQJQnX4QsEse7w8BzGAACs4Cruxhy7Whe37GBC0qLAwDAapqhdWSXWyrg5KrGfdNL8py8r6va-fCOG6b1v25r56bLshynP7wfh5HsegMn8_N1ni958XreV7otfG9zTfl53nsPxzQ-h5HyeFtHqeJ6Xz4pFbWS4Q7lDFg6J0YdGxQMzm_OOukg7gMgY6AgmlBxwPGgQJWWBKQWwPuDLBCDGbgzdO6HAKo1QKmZIseA_cJ6gVIczLg_g8IlBwAABQpqELgmkLzNV1gbOAQlFg6k-iw8Q1Eyjjy4AAFhdIEeS4NS7jnAUzKw5wljwBkeDHg89UHQJmhoqwYCi6GIIOUBayiWH6JQXAqx2kTFWAMQ41c7obGmLMaHCxmljF6O8RAuBfjFoBNcWgvxTiwn2Iie4zxpjwlGLks40QiTLHWJSXY8xbiom2MCRYqxHjwbxJ4PIJ0pRMyqjsNJUG4M0CITGH0aSv0QBQDQAIDQHh1bAJEMYN2HsuBexlnw1hspLYIQ0o0GAUBFBaFLn7AOWsOylwwfFVeipI5NxjpgRB19wGL1zvnWuIdNI9KWf8FZBTMFoKel3PuzVkGYE0r465TpsG4PwY5WANMWHELuXHFJ5DKG-hodouADCAEVGYVYdhgluG8P4SIQRdthGiPEadKwUidFcFkQorgSiUmqO8ZpQFtDsWrmiU8gp_i8mXLcaE2lJzqW5K8XStBhSSmpKZcEmlrLuWxIZXyqlPKWUJP5U6PxHjMnEupckylMBnn0s5VkhVzLlUyrcUUlhnKyklBaVU621BaksPqZoRphrUAtLaU-OkxqrDyDUBnGRmVIVyW6S7Pp7tmae29lwd0CzWznO8Z6NZD8Nkp22fcueJyDl5ygAXEO7oS6JtvsvOuj8N5t1fncnun5D7VG_r_co7pz6AJnsmzAFDs533TeGp-Lcs0dzfrZeyugD4DwLcfMe5RAilqnkA6NlbU0d1rabdez9G3bxzR_PuHbKiFrHppEtjD-3lpdo8mA7ormwJuSQpB-VS5buCa8zO4kPlwAId8ohu7_nQtEECqhRBQV0PBX24uKTYVcJ4cYPhAjdJCMNmi5iGLRBYqNjiyeeKCUqJDmoytpKwW6MZZW2V6rD3UsFWKlDOS0OJupVK-VR7YlyuQ5u3xGTCPkdFS4vDPKCOkaI0k3D2H2UUYY2q6V6HNXrmKSk3VFSPAGpqWSOpQoNDmuaZma1HS7WiAdaoJ1OLi19rdSIDWizXZetED64ZcjRm6CttJKZMzNDeIDSA5ZIc9Ohvrls2OFbN2xqOaXORZyWqWcwHI7d9ob3WSjRZi5VmXk7reWevBF6vl92vW8khgK7IUMfc--hb6708DYeUr9CK_0XgAyI-QYjgPgzAzIyDijOVEpcwhl9SGhUwC824kjtX6uscwzRzzHH5XNaMfRpr5HGtYbq-R1rXL2siuY4Nuj42uvpP621ibLWpsddI9NjlvHwb8f1RnC1snvpiYk35KT7TbUiZYfJxTK1l2up42ptznqPb3e9Q97TAag06kEN-Hq7EOohWSqlT7AFNL_0B5PKoDz8pvcwOw7iyEbOdQqthaqA1arETchoTYWAf5DzIvu0BEOYBMW-2VLqeO0qxT6njqHBFmrGB_bjDQOYaBQCSAVZoOEPIrmcBeCnR4Rq-VEuJQCl3J5n2atznUactu0BFoWT98Kf2BDB6A0uQFw7hrszshzcinPxuOZgICDmgLDprqOyO9aX4dzF3gK-gbNMDMRpLBW3hPCI28FwFWFN9xK28BTB3XAlBe6Vi99z_wDMTOoFvVXpsLaGY0nfDwofttkm2Ciw2K6Fe6QT9JLeacYCKCdIOf8dDdIJ3IEnFOEuM5G72uMi1W9mqZ9j9XMSdhJTR7D7teOGzE5PnL-nTOix5DoBepoCY1BdmoCauPskFJqS0npIyZkbJyRlINvwG8OBW7UH5IKWg9BEAgHPCATAihuRtmNKiZAWo3t6jUAaS6ppOlIA8BQzSC9-EiazPWjwiAPCVBwD2rXSoDwdkP6e6AsJ_CkbkXAIkWpEATEX4FEb_Q_LIOkEGCAspaEaZK4KA_AYgYqfwfwXYOgWAvQRYfOb_DwDA0vYqUg_ObApEXAkgYAsGI_GAVQJQXPOgTAM_eAJAygukag_wUgjAWAR_H_EAAAPQXnKE0hwCAlgOyEUHgL-AoMkMNy13kJAFZFZGn0pBpFQDpAZEQCZBZBgHZDgN0HQAMFwEFEgGaA33mFQG32oF3xFH30PzQEgEtloHhkoF2E4SqT3g0m_0LxgBYKcHQFslHEEEllQFzjbTzCQFCJYPv1UL0FVHyBcEfxYNoHFCaUSPEKoOmWAN0NnwMPn2MMXzMPJBRFsJaAcK32QAFBcOFAYEPyoHFGgE0Elj-A0gv0PxBDBAhAgI6JBFQFblgJzBBHUERjVFJgvxMJcBYPgH3FBHBBgApjE12BCI0DoRYPmEMlLzwnkG_0WLCI8EwHID6DtmE0qNMJYMuOuItWONOKqJyLpEJlUOTGkDAlgKyB-Hsh2L2I8EoGWBUDEIuMpDQOWKwFmTFGFGZA4KoBuKjAv2SI8BJgkCRKjCdCjEPDsCHzsCBPOJAEGPWNsnmCWFuI8HmS0JhKuMWEwG_wpRAFLjFjJNgFRAeKhI8HXB0PJD0LnyMLOO0NZCAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/animations/hierarchical_advanced/src/index.ts",
        "description": "Create a hierarchical animation."
    },
    {
        "href": "examples/animations/translation/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1Delw8lD8SWVgsFgN8pRwEhDUZfx6cJRQAK60DbBgBGWdXASU8ps1HqmijOS6qvxwXEV5p6jncIcmt_dHJumqr3DkGhDyBNtJRR5IiUdCLWAhOAach5KHkYxoTC4AgPECsExfH5_cImRIpTgmFhQYQgAA0IAgcAAQmh-BokkgwPwoC4AL7kuEIjDYHAosggKg0OgEBixVAQIhjDT_YBxLgAQXFRH44moShV_FJcu-Alo0ngE2oWpEOpVMAAahAYPkpQRjTwAJKKiUqqaobwafjkADWnFZXDAGkoRC4HgAAnA5Ip3ppjKorflNB46mKABQXJKochcVMASi4rlYXFlImMxgcGl1MC49nj1tt2uoWS4dZtlGlBZr-X4EgrVct9fbBFTJaszwuZXQlHIixsNBwzVsAFFYHOCFSkg70KmPOPUfmLlwABLeACyABkAMJnC4rmBr-2iIplDxEJIDtvSjxy1m5lOl8tTVoGtMgNN1G1QZsXDgQ1uFcLse3-ICYH1GC3RHOUeHEH1bEQTDRA8ABmcoAE4wHKAAWMBKkCchyhgAA2AB2fhAiYqj0ECCjCK9GByDAdBCIAJiqCiSKYpihMwPRKnIdA9AAVn4Sp5L0QiSMIwIFIUkihP4coFIYmBAkIpjCMqGAKIU8gFJgFiwFs2YFKEmADL0ejCIY9AKIo5TdLAJjykEfTCOI1yNIUmSwCEhT0BInzAn4MBCIo9BKkENK9HQJS9DAQISK44TIvEmAYBIxiqgYvQYpEhifK8gzWKq9zAj0CjKnKSj0Dykj0CEhySMqEiZMCYzyFa8qYD0fwmIU8oqpgUzyGquKGMSyo1Jsqy9CSniYDmmAPEfHgQUwKAP08DQoBfEBCAIeQ4EQMs4EwRY6JwGBFn8chhU9KB_HKHBIwUGAYw0HAqCII78OfUMQDfVDYO_ERf3_CDmwIT0fUergnSVV1qA9L1vQAbQAXU7En8NHKxtgleAyhJypSS4IScAUlmFLJ47RHOJYGa4JmWeZrgRZi4WJdFyXKm5_CeFQUEYDKaDYJwBXMB5nh5BVUo4cx3Q4D6VVUGhkQrDQWgNDGI23RuqA0AEDRkasVk5TJ_8eEFZt0A1TtUGtBV8eN9U7B3eGkmdZVjaO7Yse9OBJYUv8xR4FW3TVxWcB9uwcHkRZI1TbP-GTkQi5wStFBVTtMcWGAPa4MusjpAhI4J1A83r1tbRwRZ5GzmAO79XNB9QMkKWpWl6UZZk2XJbWfX4RccAAK3mUfkAFahaHoRAQFlEBMEUbksytVFkHDYHozUWNWyTJAiJwETH48dlXx7E374pblcCJaGQExX4KIPDn3_nYL8n9tbQhgFAK4398DEBgf4fwuw6B_z0IsaA6BgEeEgT9GB6DMGwKRPAkgL8tQHxgKoJQMAj6YBPvAYB-9cHQP8OgjAsAnafwAHqA3KGzBSf9siKAAX8bBIAuEKRwBRdmL9WRj0pDSVAdIGSICZCyGA7J_66HkoYCG1BIDNBXmvfkgpt4il3vvNAkBxS0HPJQXYAAFIMtByDRyQDXGA5CnDoAAErQMoIIAA8qgS8chUCLmAR48hrYxF6CDPkFwnDyG0ElEbQ6EC6R4JfvIieSip6qJnho8kKJBQGKMdQExW9hQMH3pDeQ0BNCBL-G6M--9TrgnSXhTeRAQSoFXn_SsIJ1CXmDGuM-aiXDkPgKeUEHSHRCiDPISJGha7kPmIsKBp4FDAImZ4jwmByB9E9G4gp6jyEHKOW3LZSzp5nI8GAxcBAxFLmkAxP-WQfiuOWasjwlBlgqE4V07oTyyQeGwIoH4a5mTUKoMc9sZ8olgqIBIGF7YVTtlPLYYKdhvl7PhrM2Afj5hLBOR4dW6TX4gGwIcxYmBgFUxAOSgA-u02AqJzmUhBWTOR5IFGTxUbs1kQqgA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/animations/translation/src/index.ts",
        "description": "Create a translation animation."
    },
    {
        "href": "examples/animations/translation_rotation/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1Delw8lD8SWVgsFgN8pRwEhDUZfx6cJRQAK60DbBgBGWdXASU8ps1HqmijOS6qvxwXEV5p6jncIcmt_dHJumqr3DkGhDyBNtJRR5IiUdCLWAhOAach5KHkYxoTC4AgPECsExfH5_cImRIpTgmFhQYQgAA0IAgcAAQmh-BokkgwPwoC4AL7kuEIjDYHAosggKg0OgEBixVAQIhjDT_YBxLgAQXFRH44moShV_FJcu-Alo0ngE2oWpEOpVMAAahAYPkpQRjTwAJKKiUqqaobwafjkADWnFZXDAGkoRC4HgAAnA5Ip3ppjKorflNB46pwJbauMAuABHRYq0lcdTkADMXH9geDoZAzSg_mVBB-WGTYoAFBckqhyFxmwBKLiuVgZuXGYwODS6mBcezx6227XULIFhPp1yT_L8CSj8eWmeUaXN2UiHjPC5ldCUciLGw0HDNWwAUVgV4IVKSDvQzY8x9RvYuXAAEt4ACyAAyADCZwXA-MBPvaohFGUHhEEk242ruBAeHKrLdimIjDpuZqTpkBpunOqALi4cCGtwK78GuG6mnqxHUPuco8OIPq2IgrGiB4RblAAnGA5QACxgJUgTkOUMAAGwAOz8IEsmieggTCUWXowOQYDoEWABMVTCfxsmybpmB6JU5DoHoACs_CVFZehFvxRaBNZ1n8bp_DlNZ0kwIERayUWlQwMJ1nkNZMDyWAEWzNZukwN5ehSUW0noMJwl2R5YCyeUgheUWfEJc51nmWAunWeg_HpYE_BgEWwnoJUgiNXo6C2XoYCBPxql6SVRkwDA_EyVU0l6OV-nSelqXeQpo1JYEejCZU5QiegnX8egunRfxlT8eZgR-eQC1DTAej-LJ1nlKNMABeQY2VdJNWVI54WhXotXqTAl0wB4sE8CCmBQChngaFACEgIQBDyHAiDDnAmCLJJOAwIs_jkMKno1uUOCRgoMAxhoOBUEQv3cfBlZIfqlEkSAmHYWKR7zv8Z67gA8ss8jLH2RHU9QN62OzUPLC-ABy_A2B-IBKJQu4eN2OCQBgzbNpQvb9lwACEGuUDgdaaBAzL0yaTNcCzGgi6CE4rhRVE4KgltE3g0DoGOqAK4iH6Hl25BqwO5B2-LVuuCuZuC5zBAazgRRyt2Gs4aRC45iqlTc0nBBE2OZo9jhjNkf8aflKnubpy4BDylglKKtWMCe1YacZ-OPZ_QWmlFgrQZEOazKLPAzaVPm_cVN2zeASqeA4AACg6Mc5w4Jv1l63pwOUZROkqrrUB6i8ANoALrc9v3EHlYbESvAZTb4Puk4NZ-ayTf-ZVLvzc8PbmCnjL5uWy_Bbd-fXCXwHkAiowkH5cEHoPESYCIHAIgc_biPB5Bj3BgvMifRVSoFJl7HgaBaAaDGOgt04MoBoAEBoDCXt2RHwQdsM-MMAFXzAbfLg99rLwOwVwN-MAP67gtpgH-5wlj_0PhwngadKiX3YSfUQ4jt7lCkdI7MxcJG6QUdI2RRY1En1kZULRddlFyL0TIgxqif5iIMZosxSiVTlEkVYguhj7HF1saYmh5ibHb0sW46xBAJG6KccnRx3jZGuNET4iRmiaFGKQSUcGQY7AYKwdI3BmgCEb1QMQ0hdIKFWFZHKXes9BQLnQBqQuK5UDWgVOvDB6o7CSyQs6OsNN8wLx9MvYBVQjZyhtm6O2DsSl2BwJzSMzYBleSNjwMZ2MxyKBVNzesPdZ5TJxnYaUjT0nZzlNOVC0ocCLHkAMmuRssKbNQGSCk1JaT0kZMyNk5IkE-n4LeHAAAreYZzkACmoLQegiAQCyhAJgRQ3IOxWlRMgcMuNoxqFjNspMSBeI4H0kijwVCQDKjQB4LiFJuS4CJKTEAmJfgoixQCrIdJ0IIpAEg6EMAoBXFxfgYg9L_D-F2HQAlehFjOyxR4Gl6N6VcudgypETKSCoq1ICmAqglAwGBZgUF8BSV8rpAK_wXKMCwHIVSgAetjco19rIEuyIoIlfxeUgB1dZHAoCjUgFZKyc5lIaSoDpAyRATIWQwHZIS3QVlDBE2oJAZorz3n8kFD8kUfyAVoEVhIGAwEZbyAnvEzSiSkALJgJKpw6AABKdLKCCFZqgUCchUC3ixZmyV2yLV6CDPkFw2rJW0ElOgn6VL-V0tRU6y5rrrketud68kKJBTBtDdQcN3zhQMABcTeQ0BNCsz-G6cFAKAbgnbdi4mIJUBvIJWOEE6hQLBifOCz1LhJXwEAqCDdDohRBnkJWjQPdJXzEWLS0ej6bleslZgcgfRPTpoHT-jwf6APpM_Vi89WaPCrNvJS7Fd5pDSQJVkH45AENVo8JQZYKhtXYu6JSy9WBFA_CfMyWVVBAO7nBVhkA0EJCUd3CqXcgFbB5TsE-l9iEb2wHzfMJYQGPBcIlR4bA_7FiYCxYfEAXCAD667YCol_ZSSlu9HXkmdVc910GHWsiAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/animations/translation_rotation/src/index.ts",
        "description": "Create a translation and rotation animation."
    },
    {
        "href": "examples/animations/translation_rotation_scale/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1Delw8lD8SWVgsFgN8pRwEhDUZfx6cJRQAK60DbBgBGWdXASU8ps1HqmijOS6qvxwXEV5p6jncIcmt_dHJumqr3DkGhDyBNtJRR5IiUdCLWAhOAach5KHkYxoTC4AgPECsExfH5_cImRIpTgmFhQYQgAA0IAgcAAQmh-BokkgwPwoC4AL7kuEIjDYHAosggKg0OgEBixVAQIhjDT_YBxLgAQXFRH44moShV_FJcu-Alo0ngE2oWpEOpVMAAahAYPkpQRjTwAJKKiUqqaobwafjkADWnFZXDAGkoRC4HgAAnA5Ip3ppjKorflNB46pwJbauMAuABHRYq0lcdTkADMXH9geDoZAzSg_mVBB-WGTYoAFBckqhyFxmwBKLiuVgZuXGYwODS6mBcezx6227XULIFhPp1yT_L8CSj8eWmeUaXN2UiHjPC5ldCUciLGw0HDNWwAUVgV4IVKSDvQzY8x9RvYuXAAEt4ACyAAyADCZwXA-MBPvaohFGUHhEEk242ruBAeHKrLdimIjDpuZqTpkBpunOqALi4cCGtwK78GuG6mnqxHUPuco8OIPq2IgrGiB4RblAAnGA5QACxgJUgTkOUMAAGwAOz8IEsmieggTCUWXowOQYDoEWABMVTCfxsmybpmB6JU5DoHoACs_CVFZehFvxRaBNZ1n8bp_DlNZ0kwIERayUWlQwMJ1nkNZMDyWAEWzNZukwN5ehSUW0noMJwl2R5YCyeUgheUWfEJc51nmWAunWeg_HpYE_BgEWwnoJUgiNXo6C2XoYCBPxql6SVRkwDA_EyVU0l6OV-nSelqXeQpo1JYEejCZU5QiegnX8egunRfxlT8eZgR-eQC1DTAej-LJ1nlKNMABeQY2VdJNWVI54WhXotXqTAl0wB4sE8CCmBQChngaFACEgIQBDyHAiDDnAmCLJJOAwIs_jkMKno1uUOCRgoMAxhoOBUEQv3cfBlZIfqlEkSAmHYWKR7zv8Z67gA8ss8jLH2RHU9QN62OzUPLC-ABy_A2B-IBKJQu4eN2OCQBgzbNpQvb9lwACEGuUDgdaaBAzL0yaTNcCzGgi6CE4rhRVE4KgltE3g0DoGOqAK4iH6Hl25BqwO5B2-LVuuCuZuC5zBAazgRRyt2Gs4aRC54LuEAAF7UHYUDeLsYdc9bTGoNx_MEDnz5JGLEseH-ydpzQzJZ_IcuF4r74q77mva7rZo_IbOGM2R_xJz8NcZ_XFuYNzNtunbDuOM7rvu0r3HNj7fZ-wHNh9sHjTV-ndfZxzyyR9HIix_Hxv99vQ-71AgFFCXE_54Xt7FwfpflzAktV1ftc39HIDdk3D2rdV7tx1nrbuUAjZ90TjvH-t90BjytjzW29tMCOznnQBe74l4r3Vv7VAgdN4rkHqna-8CS5H3QDHOODMHAmxIcPZkVJKAEB2EQe-edeYFy9kXEuotA6f1gRnZhrDgyNx4c3ZWqsQFazAV3A2kDe50Ivgw6-Ii2GIIflw6eaDZ5QBdpgyROC274MIcHYhQimEsLYRQqOVCT40O4dA_4OYVSVG5q4ggRMxxmh7EowUC5PHlA8bmLxLgCDyiwJSRU1YP7cU8d48cPY_oFk0kWBWQYiDmmZIseAzZKj5gKRUbsKTAIqjwDgAACg6GO_iTb1i9N6OA5QyhOiVK6agHpGkAG0AC63NuncQPFYNiEp4BlG6UU3SOBrL5lkjM_MVRekpJ4KgmAp4Zbm0tisgsOTxlcEmYUo5FRhILK4EUopIkzkXOORc5Z3EeDyHKeDBpZE-iqgLmSB5VwhQaDGO8t04MoBoAEBoDCXt2RDO-eIGwMMDlTLObMrg8zrL3K9qsy2GzdyIJ2ecJY-zBnotEJ4yoky0UjOJaE0l5RyUUuzFS7pulaUUpJd0oszKRmssqByqwrKaU7J4KyplAr6VuLZTyylKpyhkpFUE7p_LvmCtCdK4VirRUEGley2VDLuXarFQqolSqxWqsNeq0l7LvkSqeSUcGQY7AfNJkStAtA_kLA6agIFIK6TgqsKyOUvS6kX3QBqYJK5UDWgVO0j56o7CSyQs6OsNN8wNJ9M045VQjYJ3-CmppulWkJvdV0n0fSBlQqJTCglRSkVLJ2Wssoqif6j22d8vFuS4XysWZ2rgul8w9u7V28oiyrXPMrF8ZkP0vlOt-f891nrw3etphClJwyRkVvbVWxZurvl1svqQuBRQcUtr2e2wdFQu2VGuZe6tA7h02tHacCEk6KXOs0DOj5c7QU-tEJCr2K6rBromRuioW6iU7obcI6xwZD1EtbQS098He2If7WelDBqKXWtKPe8djrn3Trde-yswL51gsXb6_1gaFzBrsLpbm4b8iRpdNGjUcakgFodWSbYnpU19uEos4SmaRCTz5msnAVH-A4E5pGZsYnyhQNNiGnAY5FAqm5vWXJSiZM4zsNKNjbo_G0KE27ETYmJOLCk2J3ScmLOKZgMp_4K41MwA0xqaZWQ6QRKjXpgTPBpyoWlDgRY8gqMfyNlhfTqAyQUmpLSekjJmRsnJE8n0_Bbw4AAFbzAi8gAU6dhQMFlCATAihuQditKiZA4ZcbRjULGXzSYkC8RwPpJrHhIUgGVGgDwXEKTclwESUmIBMS_BRF1grbnpRdY8E86EMAoA_KRPgYgc3_D-F2HQAbehFjO0myAab6M5ubedvNnk_WQBtcwKoJQtm6CYFK_AUbU26T7f8JtjAsASPdYAHrY3KNM6yA3siKCG38Hbn3rI4FOf9s7rJIuUhpAQ2LiAmQshgOyQbugrKGCJtQSAzR0uZf5IKWg9BEAgAK2gRWEgYDARlvISpdrNLscQI5rUEM6ToAAEqzcoIIVmqBQJyFQLeLrLOPC-Z23oIM-QXAkdZ7QSU7yJ3db27N1rsPosI4ZEj-LqPyQokFLj_H1BCe5ZJ2Tz8wZ5DQE0KzP4bpysFYBuCJXFuiAglQBlgbY4QTqFAsGJ85XkcuFZ_AQCoJncOl-bsEXGhcms_mIsGbZSG5xZR6zzA5A-ieiZ0HmA6fNJZ_dcnrrue5d0mfjtu80hpIDayD8cg6EkCi5AJQZYKgPseG6I3kPWBFA_CfMyK7VBs-7nK836CEgh-7hVLuQCtg8p2Bj3HxC4fYBc_mEsJnHg1mtZ75nxYmAuuDJAGsgA-k72AqJ0-Ukb70mH5I4cxa17n1kr-gA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/animations/translation_rotation_scale/src/index.ts",
        "description": "Create a translation, rotation and scale animation."
    },
    {
        "href": "examples/attribute_visualization/attribute/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1Delw8lD8SWVgsFgN8pRwEhDUZfx6cJRQAK60DbBgBGWdXASU8ps1HqmijOS6qvxwXEV5p6jncIcmt_dHJumqr3DkGhDyBNtJRR5IiUdCLWAhOAach5KHkYxoTC4AgPECsExfH5_cImRIpTgmFhQYQgAA0IAgcAAQmh-BokkgwPwoC4AL7kuEIjDYHAosggKg0OgEBgQIhjDT_YBxBwaAS0aTwCbUUky77ymAANQgMHyEoIqpEACUAKIAOSUJtNRoA-t4AJoABRNhp40iUfjtTpNAAkAJJm7ycVlcMAaShELgeAACcDkinemmMqh1-U0HjqnDF-q40pEAEECAQfnpllrKYtmRAAF78cTUE2oZpoGCurh-6TFtDNQtd0u0Nv57zeI1-qk-E02zUdzz5gAyfoAWkO_QB5M3B0PhyMxuMKGCJjTJ1OaHBgeWLOVwHB1vtl_wpuCVqA1utTVAZ2KoAAUFySqHILhvwASi4VxWFzGVYH-FNdRzVwuH4fJ-AkWUNW1ODKElb88ysZ4LjKRgfW8ABZOcAGEzguE1YBsGhWHQShyEWOiCBwZpbBomBWKpJI_XQb8PHw1FgLbHgijKDwiCSDC9SwggPBlVlgMzERoMyJV3zAxDkNQ9U6xgRU4GVH9cNEcRyAAa1sRAZSsDxKj0GByCcgBOVz-H4AAWchKlmAB2fzKnKQJ0AANlcgBWcgvIAJj0PRXLAcgwHKfywH8mBIpgML_PIdBYsC8hYq8plAkCMLAnPGBAki9BXKqMBIsqc94pgPywAAZj0QR0D0LzOvKPROs6zA-sirzAhgWLYs8pz_IGyoFv4WLItcqrOrCmA9CCsACsCfywvIfzCuc7KYsiiL_MCJzIomsLKkCIaavCryBvQfhynCsL0HKWKIoK2LNpgTbZvIHL0pgDz-D8rz_MEcpykiwa9Bm2LXIe_wvLC1GBEqSLkvQfzOv4MAmT-_htvK9AWtW2Zyg8MSuBBTAoFkzwNCgSSQEIAh5DgRBjGMOBMEWchyhwGBFn8cGaA0Zl_AlvcEzUU8qCIRm7KudBuekoyTM1kQeCgShBGkYowDKYtFhgJSVJlWC5MlXlARgbTTQtK0rS9Z0cCHEcxwnaRVLVagskQosSzLbUnyrWt61QRtm1QN2EJT_IuF7KPaBj59XwTpOW0Eo2uEd_UZXtj8RFvbPy1jl94_fQuU5wRZ5A-2gs4gft4G_ABtLXGA7Lsmy7nvWDMqxrIGKMQCwABqJJSUyEfmkNqweGyRQyndT0HWdf1AxwaQA7NABxJmeEfPPG-mTPh1HcdvEnadpFnBdl28NczRwM_TXNG0AB1f0z8bSmiUFrVkMoAC6ldlIgVUmSCk1JaT0kZMyNk5J5D8CsvwDiOAABW8xUD8kFLQegiAQDShAJgRQ3IAI6lRMgXc8YDyqyPI7dMSAPCdRwLFCWsVNYgFjKww8x5dSnnPHWS88AbyR27vea-cc3zUA8LZEAvD-F8I8OyKSKEPzcIpNyXARIhGYl-CiNR1Csh0gUoY7B0IYBQCuMY_AxBnH-H8LsOgQjSzQHQGojwDjwbOL8VAdALikRuJIDo1UNCYCqCUDAOhmAGHwCsUEukIT_ClgwLADQgSQAAD0JZ_RwJFIRW94DfAsYUopkUcBeXKTo1kSDKQ0lQHSBkiAmQshgOyEAcBdB9UMDgQUkBmiEOIaQ6g5CRSUOoWgSAqAJAwDnJQXYjpwy0HIAnNR1tWweCcOgI0TjTboFXKgcicgmy2yQAcuJjtCl6HDPkFwBSyQeFoOKPotBCnBKcTotpKDOloJ6Rg_p5IUTjJaFM6gMyhQUKoUJCM8hoCaFXH8d8TDqEs3BHc9R6sQSoCIUIuUIJ1DkQjKxJhvSXBxPgCRUE-K_RCnDPIfZGgbZxPmJecGJEFBqLpYc-J5A-jyz2egvpcTMBirpCo1AAqOVSvpV8ukHE7HqJNNIMKZiuy7M5dyjwlBlgqA-eo7odiGVYEUD8VizIklUAlVhJhDyPDcQkI6rCdYsIkVsIIOs_BDUirxbAU58wliSvUagUEdzdEgGwGKxYmA1EDxADGzANpQ3pM-TQykdjoGtPJO01B3ThWsgrUAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/attribute_visualization/attribute/src/index.ts",
        "description": "Assign an attribute visualization."
    },
    {
        "href": "examples/attribute_visualization/attribute_explorer/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1dR6poozkuqr8cFxFef2og3DdJuOTPSbpqvNo8gCuBFzZimNR5ADWBlghox785OKDtCFZOTB58pRwEhDUZfx6cJRQ6zANBJTyMqdEJhOK9ODkDQQeQbLZ3DxESjoVawa4ach5ODo4xoTC4AhTECsEwQqEw8ImRIpTgmFhQYQgAA0IAgcAAQmh-BokkgwPwoC4AL7MrHkHEYbA4AlkEBUGh0AgMCBEB4aDbAMEQugwbwaGAwRlgyECWjSeBPaiGkTG_i0ABqEBg-VVBCtPAAkrr9QA5JEGsEAJQAot6lEHgwGAPreACaAAUg27tEo_O7aEQlLb-EnBOgADKs2ioTRJoN2kPeWMJpPus1wC2oACC8ggNYdTpdzdbYIAsrbNBB-Z5UFAJJm7EnpCnfNH40GABLu73eJN92hQ_nSOwYLnocf8TiCrhgDSUIhcDwAATgckUi00xlUjvymg8XVQypdXA1Ind8o0ZziNQ-41v-gEvKgQaoM0aD-r-ZqwOcQbqDQk4wIhBB9qg_DNK-qBHieZ4XiA163jA94aI-z6aDgYAmqsepwDgaDruB1Bvpwn6UGq35go2BAEFCeg_A6cCrPyEAAF62hBUEwcWSaNpWAbumyPhBpGdq1p4jZ5u6ABaSnugA8t6NZblC0H8YJEDCVc-HHqe55XjeCjkWoD5Pk6NF0baDHwDgto2XZMD-E-YkSdJQGoBxMUjrYmTmhBZS1kl1BdoyXBec63EECl7Y5WqXbvrAGwsZobGQdBsEpWB5yydVxYlQlQVCSJrLiaOUUNfJMBlNZbX2h1kUydQcmwc1GytbZPwITA5xYThmhlHNC26EtGiTVw00hatmHrbhGjeJQex0GUWSWc0W2oH6f6sfVwFZnG_AQM4ZQ_jwN2YClXowL6mDvjw6BZrV93Rfu76CgA2gAulwrhcLD76cMYABUqNxKjXDzkGeYJgGXC-J43oAMLeCZ3rSFw_jaN4jYBt4mPGLEqBylk23oOgd0VQ9qD7sdU6pumwwIwAFF9fVcJ6ep_X6ACU8OsLxIhgNxXCi6VIzw1wlQNBAvBcBLODA3YOCwNBJR6wA1FbCsfaIEBgOrRsm_wUMQHDaBZLo5AwJQTuC74aYwBmWZ22CVhsxsrva8W-RS3V4NZqLwCJRhZSCasMBcIKcuA1Yht-oFnP7qLrt5xHogS9zAG8_uz2vUxaw3inheYJlMe5_nVhG6s8gmzAdqaA2oty5XgpghPcU8KrWgawl-sI7rWuMG3MA4I40DoHqqBm3QzSWyMNtjyIPC5jXlX85QgfB0QcDi0Xm9QNvdDuzDFf4cjrPUOzeqIuoF865Zl8E5G-wttaj0VsrGeat55lW1svfWq9q6JwgvXF6zg94WzwNbW20Cq63VQY9OwDdnBvxwEbP-lB1Cl0rp9QhYM0FPQwXAchrtK4fx7gwnmScSEsPIb3fu_Yh7OAgqPSeYIUGMOIfwUhItEYw0hl_NGGNuBYxxnjcMhNiZkwplTGmIYlBMxZiozGUsuAACtVjs2sdnewBgkibEoNteqlxs4lDsQJQa2dwqdSkqNaeqNmbf1QOzcClwIJskMNrRg85vA9j0qgNYBAgywBsDQVg6BKDkFWOkggOBcIpLSQqNkSR3ToFFqcVx_YPAf3CQEqJuBqDkFHPsCBCtXBK3to7dW9ToqNI3rsU66Bw6nyys-F0UokiKG1sGUM4ZwyzgTDgJS3gVJqW8EGaQ3dtpeJmqadC819rYUOsdU63AEblVrtFcaxZi5cyIagRah1KljLPns3ahy1onLwlYThohz6PKvmAkO98tTFl-jgU8lACD_KPOhFw-CeDZUmXCWZhiFlRirEGHA0g6ahnpkoHZVzKq3PXlQgBjznmaFFjtWaXzjkbTOXQf5PAKUwEAbw_gICzwgrvqPfOU9BRfyjolDAvpxCQH6NFCBZhYDnRstBTKNh6xLQVZdDpXSwQ9NFhKx2EBpUQRwIoDQRBWQNnhq4BGAByZoAF5ToGtaMnuTouB6qlQE0WcqDTfi4FSMoKq4BLRznCrgCLs46vdQagJxrNBmvrBBLgABCK1XBrWYA_ORJ1SK3Uwv1Ya6gUKYAAEcs5ZDjHG81Yi5ZSiiKgUWJr40Ws6TmngOrG1VuoJam1drdC0Edc6gun1XVRoLfW71mVU7-q4IG4NXc6E53HnCw8yj0ZmOQgqY8atpC4yDGTSMxlfC-GMdhTmBYsjag0KLMsFZsU4CXJsgMjZdGmVxbu_dh7fCZVFjATV-DRUuAwhumgMTUpAZQgQVgvwjQ_y-OvKAlBmiVJADuvMe7vAHqPbUyGH8UZrrUVwYDGxZ7aHfRh0yJ7cznqLDSm9y470PvDM-8mr7UPoYPWZdWv6oH2wAwyojoG9pEag1_HgoqJAh33DEvlUmAA-XBVgSkgMWIQryrCAaOURihRdXa0VxKLMuf70AjFCduX2_tkxC0k2HME_ydVJok6HOwCs9QEAYqgUTDhYOwDNoh5DbGP3emw2CUxp91GaAjcMDxXAY4lFtFwJIlBViG31OgJNEcgmajoOgUdnqPADX2dnDT5xyIeEygAAwKyFGLIMuAABJgAAClpCvoumgGCYAkii0c_uQKHyfhwDloKcrH951xVpXAJIrN1Z_vtii3K2t-D5BehsG0Q0Oy5RTpXWYQwyixPiXmEmAwhipJDgqTJ2TckKgKbYU7eTSnlOQztwkcskxtvQGUBESQCoug8JPf5LgE1doRktlbDg9T9jrCPe2PBxD7FsIgBdHgACcegACsAAmAALAANgAOzlBx2jvHaOceVHIAAZjx3jyoaO9DI5gGAHHzPygU-ZxT1nWPKhk5x-QZHggYBo7R-QXH_BmdgD0HoOi6AwCcyx_NNHFO2dgGR0zsAGPyB4-R8j2ngQ9cU8wOgcoMA8dY651TvHeu0cCH1IEanRuJf870BTtH2uYBY-R-UdAeOwB441_wQIWP-AY6F6Tyo6vfZ67OGjwI6Byey7x4LnHWPAgU6xxT2n1vY8CDp1j63mPygi7AELmA5Q0eVAx5UKXGPyjO_QBTzXnuuf8Ar1j_wMeY-BDFxj6nCeydY7AIP8PyOcfI85vwKn_ByhgDK5XREmAoAFU8BoKAn2QCEAIPIOAiBjDGDgJgVY5Byg4BgKsfwvsaAASgP4Y_rk7weQ0BvM8s-xlFDX0QJIUOIIv6sAhwQ0higwAM4NAs5_tPM6UhoIouoAkyVY5XUqt2ooD_EblGoYBRZ5s1RcMRBQtRAsYABxS9fkEzZ4EaGVCzaLTlb_MLYJELYwcHE0dxKIEzaRKqXqbaDALgeQU8J8TAEYWEJgjAjYSgPQCxI5bVR5WAhGOOBOFgsldAiZXKLAngXfeg_sTYJgiAmAPaalDQMETQ7Qg6TQOA-OAwn5K9f5fQhlHQ42eABlYySCFUbIbWPkAUaDaeUIfDXAjLDLLgHsJSRcIMTwbwsLXNWgP1RxHsA1OQdCMoAAdWzioBRGM0Ak6igEcTgEKAIEcCcS8xVFKnQnSLkEN3Vm9h3A0BGRwB8PdHULQD2D4K4AQxOmGD0FsHXHYOM2i00OGHGEyHECgCgD9QSNgC5DSMSnkC5H7HQEqJCOqMECsQvWMwkHUOzmW0cWqPyCS2fhi2cQkEyjsmPH1AGJPH1ByKyQcDkGgngASyS2cHQjAGmK8LCwyxoOwLoOqPmI2DoHeFgGM0-BsF2WCgGxyJcGzhgHUG5BKHa12S4GaRgFoOWOPEblhA2IcFWBaOGC5Gzhug2F8UinInGXsC6L0P60gL8W6jGlQJwD7gHgQNoHvihkrkYFrEVWaFpIsBh1EFOiSDXywCtiSEyja2gh_wLjhBWmnCWQXAfVxTWSXDwLe1EFxOgOin6mUlUnUk0m0l0gMiMlfTwODBDEjFiMXE2UjGDCMTGSnh4Hfk8xUOi0ZzonOC4HyDrTTiOXa0ylsTDQkCiC0DXAHE3G3GBnKKkzVj9I3CgGHFHAIH3GJMBIOQwmsPtKOTDMHAGKkNdRTIDN0CDL3GTg5KoAQw0DXwAGIj0j1qg_sRAxt4TnS6BC4cThoupyJMposoB-AkgjCAQZVWQFMXBjNRZrVFMozrUYStBrVSicynVYzvFRIySYDKTqT-w8x2zNBMyoBvBpk0CPAJzdxgt3DbSmDMA-QUQNgiB-xwyPTEUYBvSjC1ytxszdwQzfTzzUzIyxwsxpzCtZzSCepYIqShFaAlBGd-ATy1y1Mq4MyXysyyjcy7BW4CzuISzmcccQhc5bMbS6DazuBFSpJ8SByhyJARy1ZxzAzdwpyRBNDvylTfy7lFzSS8T0A1yNzFBkMdzyi9zc4BVOAmQWR2RORuReR-QhRmRxj9glocALFPhUAZQ5QixFREAQANQQBMBFAJRWZHRCRkAXIyIKIqJvJdCkAPAKccAa8TLZ8SI793JwS9KXxH9fI3NGI-s4zQocLySYpDKQBjLTKMdzLSI3JdLsofJ6JHKSVeYPBEdPKTLj8fKQBhQEQXp3KIrcRJQ6RzLSRoQCRwqlLvY1RwqPBxj0R0ITM8R8BiABj_B_AAQ6BzLhIt48qQACrfYBjaqtjkrcBUrYrDRlKwSgLVKM1yANKsr8quQmr_BhIMBYADKIqAA9Y_coDHHANHcyuEdKmEeq6atHHALHRajwQUQUHi1kDkbCASxAFw4SkAINfQQwJ_VASAZoCSqSmS6gOShgJStAZTCTPMSgAEOMU8WgMKpATOf0dfXcAMdCSgQQewkmC43CcKoGrq7KeqvQU8fIFwAyrq9MeQNsq4Dyxq9CXag6vi46nkU6oSmAYUEAAkOUO6h66gJ6-UegBSpSqgFUaATQYyGECCTSpS-fFEOEjylmxEVASS8y9lEmM8PJTSs64G-AHsJEPmmuAEOGkA4Gz4BiX2PseQcK6WrqzAFpCY6KbWsm3W-aNsgCaKTWo21wjGrkQpeqrZFCpkbcmyc4ZWrOLqpLaM16eq9ILIcy7AE1ZUBUfkICqgc27iTS-GjwEOMceabiW0biHsWwQQD8wGlWrq3m2AMGz4b4Q2jyiWXarq7AFpVYTAcKhkkACWSMTO-Acy32ggDwGGfa5kQ6_ikm6WvawUIAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/attribute_visualization/attribute_explorer/src/index.ts",
        "description": "An attribute explorer with various options for default materials."
    },
    {
        "href": "examples/attribute_visualization/clickable/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1dR6poozkuqr8cFxFef2og3DdJuOTPSbpqvN2erAj6Hn8BAQaEHoArrToW_whWTkwefKUcBIQ1GX8enCUUIcwDQSU8mUArPXTUxPKRxXpwci7eQELjZRR5IiUdD7WBnDTkPJwNHGNCYXAEKYgVgmcGQgjhEyJFKcEwsKDCEAAGhAEDgACE0PwNEkkGB-FAXABfJmY8jYjDYHD4sggKg0OgEBixVAQIjXDTQ4CgwToAAyLNoqE0DNBEIEtGk8Fu1GNIlNWxgADUIDB8mqCDaeABRB2egBy3m8AE0AAqej1cACy9t2fOkdgwnPQShO4ekSj8AElaERk3ZOAKuGANJQiFwPAABOByRSLTTGVTO_KaDxdZWqyjqriakQACUo6g0UdQ_GaRtBGblGn45HE1Fz_HDE9oU5n91QntQzTQMFTMFgM6HI7HIgzFv3BE96ho-cLxdLFarChgtY09cbmhwYDN-w08BwaGXadZ1QFslVlLIuGOOxvGBGAuFcXge28CMdRg1YYE9WAbBoVh0Eoch9mwggcFHC8sPlVkkgzdAAAoPC2HY9neKDThAABKABCVtOBooYklQcguBotj4NYLtQWMYwHF_e0uHsBsXTdE1qAghTXQ7aEEP4fJ-AkaSzUdRs3Ro7srFmIYyjwgiiJI2xMJgIjKOouiZQGIYPBEoYuCQlCAGE3LgeyiPDHgijKDwiCSJ0XWbEBQQFNjWx4ST9Nk-wXDgK0QNtFToQyrL4LknS9Ltc1LTXEzQR4cRyAAa1sRAqtEDwYAATgAFkqcgAGZyF-bqACY9EqX4wECTr2oGwIADZuvQQJAjAAbfnIcb2sCXrfl-AB2Abppgdruva9B9v4GBuv4AbWvIdBtumvQFum8o9vKchpvIdrjvG8p-Fa6awF-PQwEqe6wG2r92rB_hpva6b5ta34EfKTB9ouw7Xr0dB2v4bb-ECPRfnu9BygEcptu6smNum35LunfgwGmnGv3KfqYD0ch2b0Vr0FasmSfa3nhpJvQYHxvQ9HB7b0AG3qYBhsB0C5xbyEqZ7yBgMBedGsaBv8em4b0Ab2vIN7LvKcpZt-AawbZmGnna35nwG9APBCrgEUwKBovyTwNCgcKQEIAh5DgRBJLgTB9nIcocBgfZ_HVmgpygfwY8fGs1A_KgiFdpqwrLEBIotTK11zkQeCgShBGkYowDKHZ9hgeLEqVHhwOhShDnkQ5fUROCEPytccE74PDjgABtDxKhgDXWta_hof6gbrYW9rtvOgW5vJ-aVbAPQPAAXRwVA-645TUAg2UDQIABBDQpySXvMEKkfu4IJ-YBwRxoHQX9UHHyoB9uIiBSiUFk7s-5QEaF5ewNgqwwjkNCeQv4rz4kyHgSghRNwILgryfoz95C6D3AyBBWwADkwx8h4CSFwJsjQihwQkOfCCdB1CV0UB_QqV95R3wfh_L-eAf5_0_DiOi5chLkBEq4MS5Bj78BsPBVwCEPDS0wF-So_A9bi3QP4TqgRyB6yxtNfw3VcaYHKN1GAA0LGtQ8KCTiSUuCsL3N8GA_CGy3HQoVXk_IPigmcewtxfccD7HkFBR0mgsrCUcWpN0ISwn2mia3UIUkMH5BhJQLgpEMkIPASfZ-RB-A0MGFySCMBFAYDQM0Lg1AuBJE7loD2e5mHQkcPsVAtVOEIW4TQXhRT-HfygL_OgIiMBiKsDRSRokHByIUUo5RIAnjbRugNGe_hKjtRFro1qXN_B6H-q1fwgNfg_UVr8Gak07EiAccklKMBUFcCgPqOgmhCwdm0J6HUnpfLeAAPoAHlfRanQLqZ5hoNA0W9H6AMIZPQ4AzP6T0AAlG-PyMyApwNIT53y_mApITRGAUixKmVEO3Lg-T-5CUYKePcMAZyXnlKwQlx8-6OOSqkzBOTslfBwSMbMkETjuyKVwEpNDMAVPSNg2p9SfwQM9k1MlEgHLzkKowNMmZszzlYBSgRQi6AAKPixA1wCrBUOgHBGiLE0KwBEc4AgvlBFDJEla2COBfwInUA6n-lqTjWs_pAO1XqnUmtJblRo0RNBIs5QhRgPlUKwSjfkIKjKrKEXlF_GStBk00BcjsDyIa25huHDYHsEatAxrjX63ye4oDZrJKmmypUMLkRzR4Eo-amrFpgKWwQH40Dgu8NgTSBdfTyKbiANl4be0aETTgBQEqg20S7T2zAGgW7ZTMkWsdDo-SN1VZW2C1aoC1pbfW_CaaaAZoMnW3NeAO3iK7Tut4n9-2aEHVgYdHgn2N1AuIqI07Z3zroOgRdNFH27sJQWgV0FXVAYwKB_9q7E3rqamAd5NFYDQnsGgPlyqThzu2LsA4tA4AiRJZui-0JizpIrcheN6FE11twuextmbm0OXlLmjQ96mqFso-SsdG4dg0NoyhKtNamMNvTU2m9baXbsUnTwLtQmuT_lQAOodhV-CKa4NRud8gF2OqXYJpOSQUPiL46pCDKmROITo-J49kmWPSbY7JkABB5PrqsDwQYz6bNqY0x-wqSqcz4YYkR94E9-BH1843HTem4MgaMzRWLGFTPme89B_gfr9OGe9dRrzogBTNxDSlJtvKAKaCAmuDcW5DRyQwFwZB_YGF8t5bEjSNS9AACs6UEBaSMSc1XqC1e3IVQ06SlxVdXCNzc24UtGQ0hllJqVaC8pcOeNch5RxaF0OgOSIK-UDY231ocO3xsum0LSg8ugjwQsK5VlcwFRuGjnSCqbT2tu3Z2zRE7N3NyaGW39ggZ2Pway_Dd5cEA-QXfSVGKHsZ4zHA0EmE4JkHCvA7AHAAxGAYG1RKghASiGtDWgMO2BGIVSoDQIC8AcHgdpnTgmDOGagHAsBNwlBpwAam52RhVDOOkDKM3_ceEBDX4e7lWMDl2PvDdQPOdHwP64aD3QlQrbdBdM8wLqoZovxfxPCQ6SJFVCvFdQAlJJqBGTMjZByLkPI-SCiZIQuqR4cDdZeNb5AMpqDXwYJqEA4rgN0HIM6AkyAHzVmfJnV8alYqNRAN1HA1iU-5xAJWaPL43wxQ0J-b8v44BqcAjNkCSAPDJ9TwNDwQoIq6TL4nnEEpaTp5JBAKEEfA9ZE5P18vIBCFoj3IN3E-BiBQP8P4VxZfjQgAOD_DwieB_qygXPoZw_m9j5rzPzAqglDlJDwJcPC_A9L73Hs9p6BYDcb7wAPRjs9HAvx0-wngBCdvvfE839-Dgdqj-a8ChtxZHZGHAd0QB8WdxADgD2wMFwFlEgGaA9y92lB6QVEQBAEDzQEgGVFoB1EoG-GDGLFoFLwXwbh3A8CcHQCRRcUEH-VQAdV0FHBINVzIJADUgXw8D0GoxcGvxn2zHkCgHtHYP705GXxr0ALtxAO5DAKdxgCFHc3BGoHgMQOoGQL93lADw8GznkHNQ0H-ShDXE7wikRGRHHUT2zgRFQE93T3dX7BgF8hLCIgj3AJYPgAjGMNgA-2-CYMbhnxeB_HVijHkAX2cO3zpQEKnGAmCJkNCPIHCK2C-yCMd18V4M5FIiEM9GkGmlb0YhnG8JYJHhUGv0T3SCyHT2wEUF2CIj5D3yoAiI7Aj1IJnwcgkBqI7C2A7AjFsEEBODyJnw9hMKoJeDeEiL7wpS3xaiwFiP2EwAX0nhAApV-X6NgAJG331EPgAKZCAPtykOcIFD2KAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/attribute_visualization/clickable/src/index.ts",
        "description": "Click on elements and see the data."
    },
    {
        "href": "examples/attribute_visualization/gather_data/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1Delw8lD8SWVgsFgN8pRwEhDUZfx6cJRQAK60DbBgBGWdXASU8ps1HqmijOS6qvxwXEV5p6jncIcmt_dHJumqr3DkGhDyBNtJRR5IiUdCLWAhOAach5KHkYxoTC4AgPECsExfH5_cImRIpTgmFhQYQgAA0IAgcAAQmh-BokkgwPwoC4AL7kuEIjDYHAosggKg0OgEBicCBEMYaf7AOIODQCWjSeATaik2XfBUwABqEBg-UlBDVIgA4jBKDYCPSlPw7EaeABJU3m2xWm38O1ce3eeUwAByoJgHukSj89toRGtdk4rK4YA05q4HgAAnA5Ip3ppjKpdflNB46rFUAAKC5JVDkLhFgCUXFcrC4MpExmMcs1XHs2b1BvV1CyXE7-soUtr7fy_AkrZt2pzBqLjaszwuZXQlHIixsNBwzVsAFFYBuCFSkvb0EWPIvUTWLlwABLeACyABkAMJnC57mAHj08IplDxEJIdS7IcCA8WVWSrAsmxbDUp3bTJlSmVAe1QPsXDgFVuFcUdx3-WDFUQ6g51lHhxHIABrWxEBI0QPBgABOAAWSpyAAZnIABWViACY9EqDiwECZjGO4wIADZWPQQJAjAbiOPIITGMCdiOI4gB2bixJgRjWMY9AtP4GBWP4bj6PIdA1LEvRpLE8pNPKcgxPIRi9KE8p-HosSwA4vQwEqKywDUsBtMC_gxMYsSpPojjovKTAtOMnSHL0dBGP4NT-ECPQOKs9BygEco1NYwrlLEjiTP4U4wDE9LgvKLiYD0cgmr0ej0Howr8sYjq-PyvQYCyvQ9CCtT0G49iYHCsB0FamTyEqOzyBgMAOoEwTuP8fhqpm7jGPIRyTPKcoJI47jAsa8LZkYjiYDG9APG_LgQUwKAgPyTwNCgP8QEIAh5DgRBmzgTBFnIcocBgRZ_CWmgNGZfxwdTBRbrUTQcCoIgHpo39ExAAClQwpCsZEHgoEoQRpGKMAyktRYYHAyDCx4QU-xtS0ID0ZZlDdZ8FlgchxGmBsaNQAMyi9H1_UwKCrHQN0ymDUNw0jfgZdEbdnUtJIVfFp0LVdOwAG0AF01dZE2RxNqDZWbRoYCgRQtDARZy0F7gdi4bd_mZKBPbNfWki4OW7Cubh7FFzAUL7L29ZdbW3RHIsI5gcXvRgP0A1JP3NYN_hdf9uOVZNms62FknYyHStYH-CAR0qBpa8YLhk5wYP-BwWBUGaEoG4Aal7mt5ysK4wErFu28NiBjdDrJdCWyhR9jrWVcHmiF17f425HRhHQL5e3VYce3Un021_Vvfc5weRFlTIs28Z8ueFZGjn-Q8uwErotq6uOuG94ZuAzozwNAdA8pUAdzoN3PAfcB5nxjhfeOdgk6AMcCAsBJ8s4awDivM21toJ2wdpoWMLsBZIW2JQP2_wSgwGztghOuh0BcHkHSYUUsaEfy0AIRw2gQy-DDJ-FWUd_he34RGBO2FkGYFTpLAMJd6xDx4Bwqutgf7YXrj_JuR87AQK7j3K4_dV6PxHmPQBE8p4zzsOWM0o9FZ8OVm6Qxw9RAs03uI3gtjREq0PqY4-U81ZOJcbQwu8suBL1zhbbCVsz48HgTnRB_BJGBiCfvOwD8nE8DZj8TmtAVa8ygPzN2V8b54DnAAzAWc26YIQSrLgEF_GiFflYV-NElFfxUbXNRf9NEoOAVAUBdAdFQJgVWOBthPFukSUAtBdAT5pNqWrER9ikHoUwjgZOD8hEIQwP6cQkBThu0TmYWAZQsg_C7lnGwGF-DbhOezLuciy5WAgKPIsOznkQH2UhK-mgiCUkwrWVw2EADkzQ4ZCnQECxxw9UB6i4G8vZNokJFiOUk4AXA8RlEuXAa5NC6kvy4PbFwxjXmUF2R8xF1BvkaF-YTagXAACEgKuBAswKgXUEKoVWHheSwp8oACOdMsgAAUfl_KRVWXkURiyOxpf80uCjh7PMrDKsVdLAXAtBboWgHLHnpJ4DC_IcLSXvM-URFFWc0UYqesqHFtS5lOMacPPF5dHWsjVi4bZxqEVuzPCAAAggQdm2SaGCLJFwAABgGoNXMuA6y4AAEmAAAKWkAAeV9DgU5aBmjPKSCWQNWSua5L5jAUh1AqysnDQ_CC1YoJkgpNSWk9JGTMjZOSZhFEcU4AAFbzFQPyQUtB6CIBADKEAmBFDcnLLqVEyBkxI3TKjDQWYcx5iQB4ViOBuLg24h4dk_5xzIXXRSbkuAiRYxAJiX4KIPBzsvXYKUt6PDMOhPbUOSJ8DEF9v4fwuw6AXs5iAp9IAX1LV9oBvp76eTnpAPu8dMBVBKBgJO1l5AZ23rHaB-2_hOYYFgBoYDAA9cGdkcAcQvdkRQV6_hEY4jgRiZG92snrZSGkqA6QMkQEyFkMB2SXoYQYXAgpIDNB7X2gd1Ah0ihHWOtAkA2W0EfJQXYQr4y0DLUexAtNAweCcOgAASvbcm6BU2oGfHILu9MkDabVCAAcwG9DxnyC4AjZIPDhl6FOYDWGoB7pY429jzauOtt4-SFEwmWhieoBJoUw7R3nnNPIaAmhU1_CQrOsdz1wRWeogKc0IJUC9ovfKEE6heZEAPLO7jLhbPwHvKCbL9ohTxnkLemzHh5iLFffeBQt7qs6fg-QPocM3Z9ZC7ZzAQ26QUtQD11rLaeO2YfV7YDO5pBiQvVmgWbWNB01s5QZYKhXO5e6KBNzIBsCO3FMKZkSGqAjaHLO9rF3fkEDu0OG0Q57y2EEG6Hbe3_wNdgIZ-YSxRvHuTnu2rWAhuLEjkgQ2Hhk4AH0suwFRBNykZ3jbMfJKxptnH-usmJ0AA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/attribute_visualization/gather_data/src/index.ts",
        "description": "Gather all attribute data."
    },
    {
        "href": "examples/attribute_visualization/layer/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1Delw8lD8SWVgsFgN8pRwEhDUZfx6cJRQAK60DbBgBGWdXASU8ps1HqmijOS6qvxwXEV5p6jncIcmt_dHJumqr3DkGhDyBNtJRR5IiUdCLWAhOAach5KHkYxoTC4AgPECsExfH5_cImRIpTgmFhQYQgAA0IAgcAAQmh-BokkgwPwoC4AL7kuEIjDYHAosggKg0OgEBgQIhjDT_YBxBwaAS0aTwCbUUky77ymAANQgMHyEoIqpEACUAKIAOSUJtNRoA-t4AJoABRNnFZXDAGkoRC4HgAAnA5Ip3ppjKodflNB46pwxfquMAuABBAgEH56ZZaymLZkQABe_HE1BNqGaaBgXDdHq9PpA_sDMGDGlD4c0ODA8sWcrgOALqYg6do_jDcGzUDzBamqCjsVQAAoLklUOQuLOAJRcVyseMy2D_MO6uOuLj8fL8CSyjXag-USWz6UiHjPC5lRgACW8AFkADIAYTOFxNWAbBoVh0EochFmAggcGaWxAJgKCqSSABJdBZw8J9UVXQ0rCKMoPCIJIrz1G8CA8GVWVXaMRF3TIlUnDdj1Pc91QLGBFTgZU53vKxxHIABrWxEBlKwPEqPQYHICSAE5pP4fgABZyEqWYAHZVMqcpAnQAA2aSAFZyAUgAmPQ9GksByDAcpVLAVSYH0mAdNU8h0GM9TyGMhSmUCQIdMCdsYECfT0GkqowH0yp21MmAVLAABmPRBHQPQFPi8o9Hi-LMBS_SFMCGBjOM-SJNUtLKjK_hjP06SAvinSYD0DSwDcwJVJ08hVPcyTHKM_S9NUwIJP0vKdMqQIMqC3SFLS9B-HKXSdPQcpjL0tzjPqmB6uK8gnNsmA5P4FSFNUwRynKfT0r0IrjOksb_AUnTroESp9Ms9BVPi_gwCZFb-Ea3z0Ci6rZnKDwcNEEFMCgYjPA0KB8JAQgCHkOBEGMYw4EwRZyHKHAYEWfxdpoDRmX8PGAwUBs1FbKgiHBkSrnQRHCI4riGYfLgoEoQRpGKMAylTRYYAoqiZX3EjJV5QFyyPU0LStK07SdE0cETbxvCNZCqR8E1pGotVqCyY8UzTDNtRHHN80LVBi1LVBZa4B38iTU3-3NrMrYnIsSzLdDOYl_UZTFqcRF7M3aAt0dxxtu2yxwPokk0OAAG0PHkNB-KSDwAF0cF2fhyAkJJGMqHB9Oonhw_dyPPbHa3Jzjh2E_6ZO05APRSbQXOcCobmtCPDwAGIfuqappzDt2B0zS36-923febxZ5Dm2gv1b5x_asavp6jr3Y8XmAW6T5xg-oyi12oskKWpWl6UZZk2XJeRC_4_hYJwAAreZUH5QVaHoIgEA0oQCYEUNyJcOpUTID9JTIMNMmwS0jEgDw8UcDGTxsZBmtY4HU3UIglsGg2wdi7D2KeGYhx1xjpODwwkQBoIwegjw7ICJninCgik3JcBEmwZiX4KJaEgKyHSMiHCX7QhgFAK4XD8DECkf4fwuw6DYPTNAdAtD050l2lI1RUB0DSKRLIkgzDVSgJgKoJQMBwGYEgfAQRmiJFQH8OmDAsANAaJAAAPTxitcu2DsiKD4X8Dxnj9I4AUn4kArJWTX0pDSVAdIGSICZCyGA7IQBwF0ClQwvdqCQGaF_H-f9qAAJFEAkBaBICoAkDAL8lBdiOk9LQcgNtaFCxgKYpw6AjSSJ5ugAA8qgH8cgSwiyQO00xEsPGd0oPkFw7iyQeFoOKPotAPHiO0cw2Jt8En32SY_NJ5IUSCnyYU6gxShSAOARhL0Gc3H9L-JOaBICobgjGXQumIJUDf2wXKEE6gfxeigtAlJLhTHwA_KCN5yEhSenkG0jQwtTHzE7LtD8ChaGgo6R4TA5A-ik1aQ_VJpjcX4vnui-FRKwVLLpLBURdC9Y6V4X2FpCKkUeEoMsFQCy6HdFEeCrAigfhQWZJYqgBKbzQImR4BCEgxU3gLDeD8thBAFn4Gy7FIBXmwB6fMJYhK6GoFBGMlhIBsB4sWJgWh7cjWYBtNquxizQGUlETnGJ5I4l3ySVi6JrIgA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/attribute_visualization/layer/src/index.ts",
        "description": "Assign a layer visualization."
    },
    {
        "href": "examples/attribute_visualization/simple/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1Delw8lD8SWVgsFgN8pRwEhDUZfx6cJRQAK60DbBgBGWdXASU8ps1HqmijOS6qvxwXEV5p6jncIcmt_dHJumqr3DkGhDyBNtJRR5IiUdCLWAhOAach5KHkYxoTC4AgPECsExfH5_cImRIpTgmFhQYQgAA0IAgcAAQmh-BokkgwPwoC4AL7kuEIjDYHAosggKg0OgEBgQIhjDT_YBxBwaAS0aTwCbUUky77ymAANQgMHyEoIqpEACUAKIAOSUJtNRoA-t4AJoABRNnFZXDAGkoRC4HgAAnA5Ip3ppjKodflNB46pwxfquMAuABBAgEH56ZZaymLZkQABe_HE1BNqGaaBgXDdHq9PpA_sDMGDGlD4c0ODA8sWcrgOALqYg6do_jDcGzUDzBamqCjsVQAAoLklUOQuLOAJRcVyseMy2D_MO6uOuLj8fL8CSyjXag-USWz6UiHjPC5lRgACW8AFkADIAYTOFxNWAbBoVh0EochFmAggcGaWxAJgKCqSSABJdBZw8J9UVXQ0rCKMoPCIJIrz1G8CA8GVWVXaMRF3TIlUnDdj1Pc91QLGBFTgZU53vKxxHIABrWxEBlKwPEqPQYHICSAE5pP4fgABZyEqWYAHZVMqcpAnQAA2aSAFZyAUgAmPQ9GksByDAcpVLAVSYH0mAdNU8h0GM9TyGMhSmUCQIdMCdsYECfT0GkqowH0yp21MmAVLAABmPRBHQPQFPi8o9Hi-LMBS_SFMCGBjOM-SJNUtLKjK_hjP06SAvinSYD0DSwDcwJVJ08hVPcyTHKM_S9NUwIJP0vKdMqQIMqC3SFLS9B-HKXSdPQcpjL0tzjPqmB6uK8gnNsmA5P4FSFNUwRynKfT0r0IrjOksb_AUnTroESp9Ms9BVPi_gwCZFb-Ea3z0Ci6rZnKDwcNEEFMCgYjPA0KB8JAQgCHkOBEGMYw4EwRZyHKHAYEWfxdpoDRmX8PGAwUBs1FbKgiHBkSrnQRHCI4riGYfLgoEoQRpGKMAylTRYYAoqiZX3EjJV5QFyyPU0LStK07SdE0cETbxvCNZCqR8E1pGotVqCyY8UzTDNtRHHN80LVBi1LVBZa4B38iTU3-3NrMrYnIsSzLdDOYl_UZTF1BKLXaiyQpalaXpRlmTZcl5H4AT-FgnAACt5lQflBVoehEBAaUQEwRRuSXHVUWQP1KaDGmmwlyMkA8eKcGMvHjIZ2sa-p9R65bDQ2w7LsezdgcYCHT2x2tycPGEkAW7b1uPHZAizynJuKW5XAiU7zFfhRWei6yOkyI3pPoRgKAri3_BiCv_x_F2OhO_TaB0Fnjxz92q_X6gdBr6RLfEgy9VTFxgKoJQMBS6YHLvAQ-n86Tf38OmDAsANAfxAAAPTxitHA-lO7ZEUHvP4GDMH6RwApPBy9WSR0pDSVAdIGSICZCyGA7IQBwF0ClQwOBBSQGaBnLOOdqB5xFAXIuaBICoAkDAL8lBdiOk9LQcgNtZ5CxgKApw6AjSXx5ugAA8qgH8cgSwiyQOo0BEsMF6E9PkFw6CyQeFoOKPotAMFf0vsvWh0cGGx2YfHNh5IUR8JaII6gwihT50LhhL08hoCaH0X8Sclci5Q3BGYuedMQSoEzp3OUIJ1A_i9FBSuLCXCgPgB-UE6TkJCk9PINRGhhagPmJ2XaH4FCzzKRojwmByB9FJqouOrDQF9IGd7VAHSGnDPKU4uksFT5zz1jpXefYVGNOaR4SgywVAOLnt0U-FSsCKB-FBZkkCqCDJvJXCxHgEISAuTeAsN4Py2EEAWfgGyekgDSbAHR8wlhDLnqgUEZiV4gGwP0xYmBZ4AG0PAgswDaX5cDHHF0pKfAAujQ8kdCY5MO6ayIlQA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/attribute_visualization/simple/src/index.ts",
        "description": "A simple example on how to start the attribute visualization."
    },
    {
        "href": "examples/drawing_tools/create_line/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlqKMUGgA1pxWPBowUO4gcAQAnrBweDC2HnHxeIlgKYQE8nCIxsYArqjy0QDmOFRExmBQlADuehIwAAIAjDgALDgA7MboEGntnT19OERoLXBw-SI8YQUmOYLCOwbo6eE8jNOqXGmZMCldEOgEeIhcgwAMbwCkANxcORCNQgvd5fX7TODyKD8dIvDrYX7yShwCQQagvfh6OCUKA1Wi_WBgAgvUFcAiUeTEz4eU4Rci6VT8OBcB4pOmoBnrECsExsjk0kwXflwcgaCDyAik9KKFJESjoGqwEJwDTkFLK8jGNCYXAETnc4zC0XioUisUS9WlAjlSrVOoNZqtObdXq0IajCZTGYEJ0LWg4ABWepMhrN4RMRxOnF2xCgwhAABoQDMAEJofgadJIMD8KAuAC-ifVmow2BwurIICoNDoBAYECIiI0EoAVFxGdolAA1LhgDSUIhcADk_WyChgF00xlUEBgXU0g--nHrjYlwAKPBFAloSg0_HuqEa3ko2Lg8fXXAAkju92hD8fcwBRdQ0M-bS_X_d3k8AQXkEFfVgAAqUGgupKPwdgAaIABKD7SN40EXgAwt4F4APIAHIAPreAAmoBD5QTw0i2OIB7rKgeY9n2A7DqOigThoU4znOGg4GAW41IkcA4Ogu6fv4ZInguS4NpQTZcMADiJBBMCeBAXBUb2_ZDiOcgMWok7TrOmg4KOiToLxMCyv4ORQIoGgiagAAUjC6Cc-7oN0ACUODSF2XCuB2naLqgnDWYy6SoOQXDWc5nmsJJ57VNJW4wG2XDaV0K7nlWaSJSxK6eW2XT8BI3ktDJtCdpl4kENZa5vlYvKMi8TnkDUNg0DgjS2A-sBNQQybpBe6DWYONVwIO4XtgAEt4ACyAAySH0oy7XGTWRHxA8LyDkQ6QlbOK6DueebOb5VgxZuskJS4ayon5b5pea8DItQ2V7nlEruZ2hVxSRF3UBV55WOI5DRLYiC_fEPCDoMABsADMEODOMUPkHSbwAJwAEzI1DgRvCMYB6B8gQjHoegjOMqMQ9jbx6OMIyo-ggz8HDuODIE6B01jgwwGA4xvPwqPkOgCPjBD_AjAArOQqMizT5AQ-gMtvKjIzI-LIwI1DyNgJLousxzkOBPwgRgIbovjhxeh0uMgiDFDegQ3oUMcfztuU28MCDOgyODCMBu86LDN6JDej8LD_DkBrmv8H7BMwKj4zkHoHEC4M5B-yMdMwKLxOQzA4z63o6CBMLhtC_wyPIwHMB6OL_jqzAaf528Xui2nlu4x7qNvKLseo6jbvUw7g7LVYsqYFAW1dJ4GhQGtZQVFUBp8eMMA1OQwzL_45A1ruUD-MM9HjppbGtIPIM8KtQ4bZ992oCfVWiGgKI5oB6b8DYtAaJ2OY1PALyVaDoODkRKBIaa01wgCATQTkiAADaABdPMu0748DzHtA6nBUrUHSg1NI_YIAAC8IKXUAn2Cy4gf7aFIreJkXk_7_1aqgTQOZf6n3iDFC8YBSQ5C4HxG8B5ST3mZEyGo8h0CyXQG2XE_ZCF0igFAdIXAug5G4E8eKPDPyCIcHIA844cAsKsPwSRngRGyReAQDQ38h7_xit4LhdR8pPAggo6AUAuB6FUTMSE0JxzMmUVw8EdhgrxV0OIiBEooRuNzDgLgejRDgk8ekTwqAJBrSIIg_-ilLE8Fav2WwGZmFINYcYS8HCVFcCiAwjRBiyREGkTmORDhOguEMjEngVTKBIUaTAWEOYXCZMKVwGx8VlhJKII1Nsso6gSkoBw0JFF0nDzQMBYBLwRh9KOkUwZXAalYHrGM1AjU3FaGmVwWZLStn8CwEsyBwJUZ9ILCw7iZiIDkHEJg_J8zRCeIYe8j58RGiinQNIVAChoLwCeS8y6Pzfl0IBYk5Jrw3hnKsPcgp6TxIAjQC8aBYs3jxi4DivFbxYFrP_hkRQLxYLwUQihdC2E8IERwIBKa34MKETOSggpHLkW-Wis2Zsv1WyzVkUHAGPY6gQoemAcSnDVH8VvPw7EAquDYBgA1Wg4jFF0BldwuVfChIuJmD2B-2RxxKqVf0eQL8BzZLfhmcCdholVWbMYDBqB0rUCMaI2gj04BBRCtZWZ9r-AvCuWBCC_BwquEirQ0GaVsQwBwJ0Ro_UPzyv1UI4x6rB4nJApAoNaCrrpJujm4Bz9dxv00Nlc618Wq2DLa_WwmhuoYQbf1WZw1oFEsOv_WZ9aK1sQZDieKXkABS0hMJ6SeQeCAYB0gVSHO2l4gbw2KQLekp6-Vq2XRaDUHByw8EwDCjyt8eZj1HT5UqoVUARXRDFcFV53ApVaFKWotN94lUqrVd4zVvjZW8MaAqg1TI2Sb1kaap1LrrqYKmagWagSXFeTChFKKBS42wETZQZNg5U16vvMB3QoHYDoGGmeqxRTEiynUFwGoEAWHFqajUFQlwvL1UajWWtBAFqdW6r1fqDGSMsJnaFBjTHwoxvmSJtQOAKOUHUEelhXLRCnvQVBt1t0MAYUoOISAdIH3ZWsmYWALw0iigPHimwax-CtWM1Oxokbo2CY4dZTT2nnmEOoDgCyywvrcFcH5oc_zdBZrE2chhXQuAuZnW5h9BmJCwDxVJCMLwLNwCs_Ffa3bQZUSSC4ZkTnIs6fc6gTzmhvPXy4AAQn84OTASTxzDRQ9Cgr0Xt2JAAI7fzSIBUrMxr5hTLEogNPWfPIfE9CoTQ2NBlcup5argXqzEZC6i35YWItaai7py6sXzAJdcXKGEWy7ppdXZl6Fil2Vrv_op5BpHiJdhwIIdAU0vR0E0NZV6OAHydgfBhbw9KHxYSUNBb8AB1C8GEADiOE0JoSmtIHAE1wcXgmp4CaWFAJoXB94aQeLrIwGfESAqF4nw1ns41_-LgNPrcKzFwcE0H6jIHLMrgMlHD1dx_jmsbYmRXl1V-R8BPXIpbSxVy7yCC3ng-4957aRXsaHe_dr7P2_v4QB0D0H4OofeBh3DhH34AAayPUfo8x79nHoVOc0BeB94ngvRssMp-gZrm3vp04ubspnubdQs4EGz4jHOCfc_fHzo8J4Sc0CF0d1qovTsZZU1YKXrMZe0AYfLj7Svfv_cB8DsHkPoew_h54DCSEppoWkA-JQWFS9oUAgHms1v7u29J_bgpjvndFf6s9ipnRyRcFQFphpSJ2cW8D-2Xn_7Q8C9J0sKPMAY-oNuw4aDOqJ94d_BAF44_PyT7gOvrgAAfajJZIAMPEV5E624Q94esklFcu2PWZpgHi6gcHQMZIcLu6p-CivEPJJoMhcAYuoUjk3QQe9krkr6B4O-e-LGV-P4f4p2Vg0URSF-8UpSlq5ajaWgNGXAD0pSoogI5oDwMArq6UGBDa788kTG2UrGnU70skXGNY1kHgFwHgQB5B_aVBUm1w6GiIyIemXkg4GIWIOItAVkVgHBWBXBqgk6NwZYveghosOAosFG4hnyVqUhEATGsh6GBBhA2U4Mqhp2khlBWh3BGQ6GeCF4JYWABhIIahPAtB7GEYD28gigGASEeA0AfUJhmg0hQBqB8k1kW61AeKvhGg_hi-xgF6Tqjq8Qgq34E0D4wO2gYO3gSEo0ZqEG8eogxa9YjQs0Ngu40g9wBAjgNBlADUdBqBjBNA_U-RAmb4-RhRjCJREgjgekKoBhs8NozEOkbE-8jELQ_YU4UMxggW8gXh5AcAxgdIRRjIpRHRcAqgjQDhzIRABRDaxRixeAOA9wjweA2Uosbwp2zRWx_AbRZRux_whBRxJx54Zx8xlxSxFhCafBKID0ghwh2IuIMAaxjxrROxOhCaZI8gdhRhDxGxLR2x7RuxPBCaehEoghgwEJTRUJ5xzxux1A5AUQoqXkgUwUoUZOY298Tmt-ZULQ5xAA_GWFKMOv5h9khIkckd-DhKroyskdIARDSt9kttCuSU2A9hdI0LBucf1KCY0ektlrmPFCSaDAKQQEKciCKdCfwG2poBCKquIOoJKVdntKdk4c1C4QoO4egJ4d4dZACTCVcQWvtPJqgAmEmHAKmMChmFmD0jAAWOAqHNEGlgGFiA6cgJWNQCnrWIgCAGApgKaXQOQDOFAmAmpGOIxH0axB4MDCAFDDgKjMMKjB4GeCAImRpOoExElLpBxBBFxPALxHzoJHhmmR4JmdmVmXmR4IWQfMWSmbpPpDopgCZGZBZPWRmVmTmR4PciADUmgIOVqKWCwFAC2akKaOKPGR4GkOmAQIORgW_tObgLOVwP4P4H_n5AmB4HoDRlAOgBuemG_qed4T4tqPgDGKOfmZgKoEoDANGcFHGWmWApuUkP4KeRgLABoIOQAHrDCDCozKHzlkrwCLnrlIAeAgVKFjCiyjl5iOkphphumIDZgylempb6CGDDGoCQDNCBjUAVhVihkMBgJoAn59BTTHjyC_60ASpHmIBmIWIeBODoCgqdCCBoSwZaKtRpmcVP4eBJSDl6B9hdAuDAXHkgC0ANhQi0CXkqhJCjkYXOlYWZg4Uelem6hVikX-kUVBlUU1g0UeCtB_hAVoTiiXTLnjlygKgkEIXBlECyioCBjzkybqBIT9idRQK4W9IeDwATTOWwDWHvzkiiXmLiWpCUBcSbwTQKBpnBXxWYA4kvwPppUenPmqpQi7gPopXyC5Uyn5l2AaCtTwXplwQQzzkmbPI1ViX5mJUEAqDyXpn-LznYAWT1g1g5hvlUBFXiRQItWhXLDtWqriQQTiQTS2CCDhqxVcVOXyiwCgoiG4iXSDn96YBPmhVYA4k1B7VIDQIeC7UwBYQjwuWcjPlegeDwJaUunpi6XpV5jvVAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/drawing_tools/create_line/src/index.ts",
        "description": "Create a line as an input for GH."
    },
    {
        "href": "examples/drawing_tools/edit_line/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlqKMUGgA1pxWPBowUO4gcAQAnrBweDC2HnHxeIlgKYQE8nCIxsYArqjy0QDmOFRExmBQlADuehIwAAIAjDgALDgA7MboEGntnT19OERoLXBw-SI8YQUmOYLCOwbo6eE8jNOqXGmZMCldEOgEeIhcgwAMbwCkANxcORCNQgvd5fX7TODyKD8dIvDrYX7yShwCQQagvfh6OCUKA1Wi_WBgAgvUFcAiUeTEz4eU4Rci6VT8OBcB4pOmoBnrECsExsjk0kwXflwcgaCDyAik9KKFJESjoGqwEJwDTkFLK8jGNCYXAETnc4zC0XioUisUS9WlAjlSrVOoNZqtObdXq0IajCZTGYEJ0LWg4ABWepMhrN4RMRxOnF2xCgwhAABoQDMAEJofgadJIMD8KAuAC-ifVmow2BwurIICoNDoBAYECIiI0EoAVFxGdolAA1LhgDSUIhcADk_WyChgF00xlUEBgXU0g--nHrjYlwAKPBFAloSg0_HuqEa3ko2Lg8fXXAAkju92hD8fcwBRdQ0M-bS_X_d3k8AQXkEFfVgAAqUGgupKPwdgAaIABKD7SN40EXgAwt4F4APIAHIAPreAAmoBD5QTw0i2OIB7rKgeY9n2A7DqOigThoU4znOGg4GAW41IkcA4Ogu6fv4ZInguS4NpQTZcMADiJBBMCeBAXBUb2_ZDiOcgMWok7TrOmg4KOiToLxMCyv4ORQIoGgiagAAUjC6Cc-7oN0ACUODSF2XCuB2naLqgnDWYy6SoOQXDWc5nmsJJ57VNJW4wG2XDaV0K7nlWaSJSxK6eW2XT8BI3ktDJtCdpl4kENZa5vlYvKMi8TnkDUNg0DgjS2A-sBNQQybpBe6DWYONVwIO4XtgAEt4ACyAAySH0oy7XGTWRHxA8LyDkQ6QlbOK6DueebOb5VgxZuskJS4ayon5b5pea8DItQ2V7nlEruZ2hVxSRF3UBV55WOI5DRLYiC_fEPCDoMABsADMEODOMUPkHSbwAJwAEzI1DgRvCMYB6B8gQjHoegjOMqMQ9jbx6OMIyo-ggz8HDuODIE6B01jgwwGA4xvPwqPkOgCPjBD_AjAArOQqMizT5AQ-gMtvKjIzI-LIwI1DyNgJLousxzkOBPwgRgIbovjhxeh0uMgiDFDegQ3oUMcfztuU28MCDOgyODCMBu86LDN6JDej8LD_DkBrmv8H7BMwKj4zkHoHEC4M5B-yMdMwKLxOQzA4z63o6CBMLhtC_wyPIwHMB6OL_jqzAaf528Xui2nlu4x7qNvKLseo6jbvUw7g7LVYsqYFAW1dJ4GhQGtZQVFUBp8eMMA1OQwzL_45A1ruUD-MM9HjppbGtIPIM8KtQ4bZ992oLtb77b5qXUOliKgXAgHpvwNi0FoXnndfLW2HfruL-mhuoYU_jAfqL8aBDWcgAbTeAAXQftdJ-EoGppH7BAAAXhBS6gE-wWXEPAF4JErS3iZF5SqoMeCtVQJoHMLxqE0KOsYS8YBSQ5C4HxG8B5ST3mZEyGo8h0CyXQG2XE_Y8F0igFAdIXAug5G4E8eKPDPyCIcHIA844cCn3iPwSRngRGyReAQDQNQYBDxoTFbwXC6j5SeBBBR0AoBcD0KomYkJoTjmZMorh4I7DBXirocR0CJRQncbmHAXA9FWHBF49InhUASDWkQW-LCCx6Nav2WwGYmGxNEDFAhlBpyYE4fFNAKIcxcDCRRFhVhakvAAFLSEwjgeQ6YXDWVqUAiB38jJgAZFAAAhK5WpVjQY2K4csZJRBGptllHUCUlAOG1IKTwGZwFX4vBGBM-IUz4pEH4Fges8zUCNXcVoFZNSQIwPWVwI5WAtkwOBKjPZmSqqiG4mYiA5BxBP3yZ80GXj6GAvqTQxoop0DSFQAoaC8Afl_MumC8F9TIUPCSSk14bx7lWA-ai-I4kARoBeHAsWbx4xcHJZSpBeyWEZEUC8WC8FEIoXQthPCBEcCASmt-DChF7l5j0UKu-KCjrNmbL9Vss1ZFBwBj2OoSKHpgHEuU7h_Fbz8OxFKrg2AYANVoOIxRdA1VqM1UJVxMweyVOyOOHVOr-gdOAVwbJX8MzgTsDEqqzZjCP1QOlagRjRG0EenAIKIVum3LAhBfgLxnnRrsOFVwkVmGgzStiGAOBOiNH6h-c194hHGMNYPG5r8PX8AOpwPRPSP4gLYkMix2UWltLSKKA8EAwDpAqkOWpg4Xi1PLYpStQKcrPSuHdS6LQaiYOWNgyBw69pisKRKnVMqoByuiAq4K_zuAqq0Co9VvDGhaqgDqvVBqfHGr8aojVfCLUaLZJvWRdrvW-tQf65ZqBZpBNcV5MKEUoojvTbALNlAc2DjzXegtDhdBPtgOgYaS7JlsMSLKdQXAagQD0TdB5dAagqEuF5eqjUawAIIAtTq3Ver9SajURDeiO2hVowR8Kqb6nMbUDgVDJT52HRoSKvFSGHBoPHRgDClBxCQDpDu7K1kzCwBeK228lKbBrH4K1RTPyDxJpTQxjh1lxOSd-Xg6g7TNDLC-twVw1mhyQt0MW1j9z6FdC4IZjtxmd1yYkLASlUkIwvFU3AdT8V77Ct1bmCp-m3NSZM6gMzGgLPXy4MMmzg5MDJPHMNQDBLosecnYkAAjhYtIgFzMzGvmFMsSjullcswBtjBLGM1YS-Vy6nlUt2erAhxzI6CXOdcxJ9z0nLpefML5txcoYS4bU61IdfGCU8AE6i0LI6luLaE69HAgh0BTS9HQTQ1lNsPk7A-DC3hOUPiwkoaC34ADqF4MIAHEcJoTQlNaQOAJoPYvBNTwE0sKATQg97w0hKXWRgM-IkBULxPhrDp7LNCXBicGzFzzg4JqVLmQOWpXAZKOEy2DiHNY2xMivLer8j5IeuUC8F0Z825tVrfJt7bu20j7Y0IdrsOBjunfO_hS7127sPee94V773PvfgABo_b-wDoHZ3QehSJzQUhXOYdU_q3opH6BcvDe-uj45pzsdRqZHjnICHCeQ5J--cnR4Tyw5oNTu6tPh14oXUzrnLO9v0I50dk7Z2LtXZu_dp7L23sfc8BhJCU00LSAfEoLCMe0KAUtzWVXb11dw81yO7XuvYv9V2_QrgnRyRcFQBJhwnQXAW6V1b9sZOj128p3DpYzvWp072u7v16UzUHib3AX8EAXgN8_P3wfXAAA-GGSyQHoeIryJ1ty24LdZJKK5xuBqLZYrg1Bv1PsUpSjBZJZ2xeKUQmccBXeiGso5bo1v7KuV7xTgff5spP7H3-enVhopsMX_FA9TqfSmgGGCkD0B6oogI5oDwMA3eEogBda8kBGb-lADUnU70skFGNY1kHgFwHgV-PA8BtgmgiBnG1wIGiIyIMmXkg4GIWIOItAVkDStaRBGgJBqgekGQIGZI8g2Ug4osOAosqGjBoghB38bBHBNwXGAIhAvBgwQh9OohxBEABGEhIG2CF4JYWAshHwwhPAxGaBEYW28gigGASEeA0AfUihrByhag-BsUsk8k1kf8l0lKVhbB7u4qkq3qXq8Q0q34E0D4N22g923gSEo09qr6jO1UIm9YjQs0Ngu40g9wBAjgyBqBpGf-mBNA_UsR9Gb4sR8RDCSREgjgekKovBs8NozEOkbE-8jELQ_YU4UMxgdm8g5h5AcAxgdICRjIyRpRcAqgjQuhzIRAcRECiRfReAOA9wjweA2Uosbw9OBR4x_AxRKRUx_wkB8xix54yxPRax_RnBmaFBKID01BtB2IuIMAwxexRRkxqhma3Bsh8huxoxhRExJRUxZBmaEBMh1BchxkNxbxKxBxUx1A5AUQ8qXkgUwUoU8ODWogTWa-ZULQKxAA_GWFKPFNZl5JtkhP4YEd-DhPztyoEdIARGyidj1gSsiU2FthdI0F-isf1NwXkRkuFi4AjuCrSQQPSciIye8fwFApoBCPquIOoGyfxouuePoaRoYQoCYegGYRYdZLcR8escOvtGFL5AmEmHAKmLChmFmDmPmImB0gDMFgGFiKgBWFWLQPQIgCAGuCAJgIqXQOQBfh4MgB4GpGOIxNUaxF6R4FDDgKjMMKjB4GeCAL6RpOoExElLpBxBBFxPALxOToJAWkGSACGWGaGZGT6XUYfAGbpPpDopgCZGZBZFmTmeGR4JkiAEcmgFmVqKWCwKegmB4CGOKJyN6akHYE2FmU6vvi2bgG2VwP4P4OSHQPmSAHoJhlAOgIOemPvnORYb4tqPgDGHWVGZgKoEoDAG6cFJ6WQB4EOUkP4HORgLABoFmQAHrDCDCowCEzkMrwCmjih3n8FjCix1l5i6kphphGmIDZgRYFipAhIGC4BViQDNCBjUC2nUD2m1iOnOloCz59BTTHjyDFK0BKp-RIBmIWJRlODoDwqdCCBoRfpaKtRemEWWIeBJRZl6B9hdAuA3kdkgC0ANhQi0BLkqhJB1n_n6mAWZjAUmkwBgW6jQUAhWnwXICViIU1gMDOmtB_jXloTiiXQ9nOkjwKgwFIAeCtCyioCBgzncbqBIT9idQ9kgUuBRnwATRyh6UaHfzki0XmL0WpCUBcSbwTQKBem2WeWYAQkfw7oBXiU7n6pQi7g7p-XyDhURZRn9mtQEBZlwQQwzlKZ_LuVEUeDeUEAqDsXAwulegznYAWT1g1g5j7lUAxXiQ9l0X2XLAFX6riQQTiQTS2CCAxo5WeW6WwDwp0G4iXRZnl6YDbkeDYAQk1DjVIBwIeBjUwBYT9XwAzkBIeCIJ_mJgAWGmiWBV5gHVAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/drawing_tools/edit_line/src/index.ts",
        "description": "Edit an existing line."
    },
    {
        "href": "examples/drawing_tools/geometry_restriction/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlqKMUGgA1pxWPBowUO4gcAQAnrBweDC2HnHxeIlgKYQE8nCIxsYArqjy0QDmOFRExmBQlADuehIwAAIAjDgALDgA7MboEGntnT19OERoLXBw-SI8YQUmOYLCOwbo6eE8jNOqXGmZMCldEOgEeIhcgwAMbwCkANxcORCNQgvd5fX7TODyKD8dIvDrYX7yShwCQQagvfh6OCUKA1Wi_WBgAgvUFcAiUeTEz4eU4Rci6VT8OBcB4pOmoBnrECsExsjk0kwXflwcgaCDyAik9KKFJESjoGqwEJwDTkFLK8jGNCYXAETnc4zC0XioUisUS9WlAjlSrVOoNZqtObdXq0IajCZTGYEJ0LWg4ABWepMhrN4RMRxOnF2xCgwhAABoQDMAEJofgadJIMD8KAuAC-ifVmow2BwurIICoNDoBAYECIiI0EoAVFxGdolAA1LhgDSUIhcADk_WyChgF00xlUEBgXU0g--nHrjYlwC4AEkVIlyOJqDmADIAwgAQXkEHjXH364A4gAJbwAfW8AE0AAoAUS4eZ7fYHw9HigThoU4znOGgLkuDaUE2XDAAUPAigItBKBo_D3KgjTeJQ2JwPG8FcNeMD9rYGYAErwAQoo7qiqCnue-Gbqh6GYdhubvuoNB4ZsG4oWhaAsThdFcVYr6UGgupKPwdjCaIpHvtI3ikeuADC3jrgA8gAck-b7vjJPDSLY4gYesqDfr2_ZDiOciAWok7TrOmg4GASE1IkcA4OgTH8f4ZI4RBqDLtBq4OIkUkwJ455fj-ln_jZ452cBDlgTgo6JOgnkwLK_g5FAijgYuqAABSMLoJzoeg3QAJQ4NIXZcK4HadoVnBFYy6SoOQXBFVVDWsLB-HVKFSEwG2XDJSu-FVmk42gSuDVtl0_ASE1LRhbQnZzcFRVwdxVi8oyLyVeQNQ2DQOCNLY76wGdBDJuk67oEVg4HXAg69e294ALL7sp9KMtdWU1vp8QPC8g5EOkm2ziug74XmVWFVYQ2IeFY0uGsNFTdQM0Y8i1ALWhy0SnVnZrSNhmY9QO34VY4jkNEtiILT8Q8IOADMIyDAAnOM7MAEzs3oMCDAArJz5CBIEABs7Ps28gQK-g_ODOggR6KLYCBOQ5DjNz6D8Ozoui9zgxgHoMsmyM3NgNz0uDLL6BgG8IyBIM7PkIMgzkHoTvkKL4yiyMHv8_z3P8NL_O2-Q8u21rbz8G84xm-gnui9LgQwHoIxvNmMDc_z2ei1H5se_w_sjHo4foOg4t887mBgALgyBOzgSCIn0up9LIyR-Q3NvAbotexbDuqwb_PkJH1v928ej8zATf8Pwgz8_w4zK3o5Ai4E4xgObQSV2Axf8znIy63o4zq4L0sCDAotV4v-cwPz4yDiDViypgUDQ10ngaFAcGZQKhVANF5cYMAaiexwJA_w28aCoSgP4YYAEErqA0C0fs78WY8DBkOSGlN8aoGwXtUQaAUQ5lfOmfgNhaAaE7DmGo8AXi7VZqzQciJxJvXBnBEAnCaCckQAAbQALp5jhqQngeZ4aI3wtjVAM0oiAgINIeBo1GoTWCjgJRhBVF0BgAAQiRqIIac4rgCBVHgHs0FSQ5C4Do3UtipJtkSFwaY25dyoBzG2DAfx-DqCuHISqXRTL7RxhKBxcAADqEg8CyEEN0SoPEIAeJogeI8BA6KiIWowTcKSYDUT3FAQ8yiskiNYEVFm6k9D-gKQQHADIcTwCKg4vRqAYDaIyXAGqkAoB0MqZI7qUBequBpKzKAZYpTqNcI1K8d5Hwvg_DgJQ645KqQ0ppY8-4uAADIdk4NECVPJqSiklJPGeVgwyWiMhUUE7oDUZmkg0EwlmVV8KyJEPhMANiWm2GZAtN4vwIC8HsV0mJTx4nBI8rADCTwgUAGp4W9VYfEFGcgML8VsaNUcwSuBEAUFwdy2JcQ0WZJ1MKGMsVcAAI41BzOIdIF49C4nsd0TQTInijXyt8jQ-LOowBZkNOQHLKBcGFlwREYEuCUDAKSLooqiqN34AqIkrw3inzeaQyJ4K4l3JCUIiAIjUp6q-gociWIcSeIWu8U-xjkbGCpTi-5-L5BiogO2GYhL4CIgURAPQsBrFaE5dK_eLgJQysdXqvFChBUOogLKp4nr5UKnQGK0abwLzBsoDUupXBk1QFTXSGa9gnVdGldwCQLgoBgBZtq2JkLEkGqNaW018hUztkav4N4OAPhvFFnar8nB5EzROmkfsEAABeUkaKvj7PlcQzDtBGX4kyRqKLWaXXaYglhBz7UbgTXYryfEMKklYsyJkNR5AG1oKm5VZJ8X0xzFAdIeacjcGDUe5i56HDosuhlXdog72UE8Fe8KLxKJMI_mwoa3g7F1BWk8Zx9woBQDTW4mYkJoTjjJVS8Edh-U-NTfwiJGIkgeS4ABng4JMPpE8IFVVEMJFsK_FBngl1iKURhANQZe71wHtGlEdp36gMPogHSFDL7yCdBcP-njgHcSUGUtJmAsIcwuFY6ih1sHRrLECkQU6bZZR1HDbK4joTmOiF06JLhLwRgab3dp6NWB6wGdQKdYWWgI1mco056zAiXj81FhpgsBz3KUTE54pJ66LNDWPDXMa7HaEZi9WkKinifODkSyRdIg4d1ydZhkRQLw5IKSUusrSOklnXnfOpL675FLPns9BrTdjUBylGmSFL4WdzfrDWm-YPmrBtcwEk0RTXWb3GKKhGwylsTQXBgAYn3stsAJCLOiGkYMzbVg8wtW4sYZszZaatj-ihvQ5dog9jqIU7gPLcPeRPX5KAx2uDYAKbibDXQ333ePY0U92Jv2XuveOF7L3-jyGoQOLLnHJJ2Ao3tZsxhh3htQCB4HhM4AdS6kVMzsP-AvD8xJKS_ARn9Wi2EhR2IOmdEaM9XiX6nsXtAze9-EqxICLxx8g500JRmaodN2wmgFp4xohdWw_OaGC40PdTSkvnpmfekIt4IiB1WD55DqXDTGHqK4AAKWkFpVK4WMVgHSDtIcCuXi4-J1-D5zGiYrRF9QFoNQx3LAnTAHqe2dve5MYdl7p2oDnYZldzqVq7sfoe39p7L23snRva-ugP2Gdns9WybeKGQcI6R9xHn5a_r8tQ41HqfVuPMemlT7RlBaeDnp5ixnDhdAZ9gOgd6vvWZDUSLKAJNQIDc_CXiugNQVCXEasdU6NYxcEEBrde6j1npnRqG3g58buqL5H8inz6-1A4C75QdQXuDnbY2-3hwA-XAYE0pQcQkA6RWuL2YWALxUv8QvDYNY_BLrP-N40UnZe2Gr5FRX435ibTrO75TLBUzcAzKNSZaoTVit6b75ZcDtJlrAHxqgGeJFSP4wAXhrgRgvDv5wCf6jQIyq4bava5ijSAHoG35gGoA4AQEzBEJcAGKPKDiYCBTjjvT_7ra0GYGi6JC0oUSviaCQFEI9Rlhvo45iHMGkqjK8HrZkKyoyG8pyEEwwFDiNDwEs5IFKEWaoFcD8F340TYESCwB4FipyhcZEEkG27kHrbH6OF25sJOFfin6kw4CCDoCHhpD6IaBFSeHvidjviaTeCLLvgPhKCkTHhRLriaTXhPjqTqT7jSA4BfTxHrhfSeBfQPivjqTxHeDSAXhFQwAcSqqeHrjsQ1h_7k6iAX7oDGH0HPRfTkL6YDhmZerlw5Ct4lFlE1hthMiMS_ZYQ4TVE0A1S2GXQGIuFSJc7cSeHeG-G0BbqBFdg4DBGhHhG6RRExFxEJFJEpFpFfTHgAAaWROReRBRYRxR3U_RNALwlR4xBAtRByDRTRWBg4pqzm7RbOXCXRjg3BfR5RgxPEUeoxbE5Rkx8AxB0xsx9hQ6Cx6xSxXo_haxZMmxYRERuxsR8RiR3gyRqROAngmkyk-46k0g74SgD45J6kr4wJNYjx6xVRUJpedRPA7x1-GBJh1Mg4h4QmnQ5IKB1-DgymvRdxIJ7YwxzEEJcAzx0JH-cJA6ZBiJyObi4JrEcAdELw0p_EspdEXAAAPlwHUI3GgNho1KjMhBqThEVJok2JYdQGjuFBeNQAXhnixg4K7vepOvQbOuSJoAut0gOkVBVPcu2GVDVJ-nqZqQaWPjabmHRKfnntDmRBRGljRHGeqSMbGWeLvumRFjRHAEIplkREljliIqCYRBxmmS_jdkmYicjP7gjkuhKMGsNh1qKmFmlsdjnhTjNHQqhGgOpLiPICyo1E7gwZdAQCOeULiDLnLoON4JoEOcQlVErirmqT7AtEVKgVfpgAAPxMlkzrjeCJAwD7kwCvGoAr4qEGJ7nta9ReoEBuSoAOEoGzhcD-mQGe5FREpQDqB_5hreD1hES4h_nwDYjqAXhvBVQ1ScrFQl4KGpnpDmrdaeJ0Q4BA7hSXlwBFRCIPmYAiJwXKkDqDnLSoCzljn1LYW0CB7B6XaWl6ADo-zYErkUVUW4g4AdnwlWCDQOpWkdZ2IQ4C50ImnAoEzBqijKJXAPACq54D4iWS50KRQj4LTj63TkzhQz41iVIgAXAeDwlKW0KaCqU77XCwCMFIgogaFDgYgWofYBRq4a4qUQAj5G43BlhCmwGiw4Cixd5OWiDGVS5mWqAeWWXSWEALSDiDABUDrBWuXuUWUdITrrglhYDRUgiBVUaUAnSaURheHyCKAYDKR4DQBPQJWmVuVqDwmCWRRFSTkXiVUaChXzFNlHYtkB7Hh1YxHaBxHeDKS3ig7Z6NmiB571iNB_Q2CoTSD3AECODqW5UT7nSCU6U0DPQTXL7cQTVTWaD8CzUSCOCpQqjRXAI2ggSOQYKoJASYJtCqDszGDaEKBlXkBwDGB0jTWMhzVHVwCqCNDZXMhECTWS4zXfV4A4D3CPBWKNSiyAr4Q7Ug37Vg34AwAZILSw0DoI2fUHXzXg3JVWXIj352WYjEq0AA1Y17U40_UZCWVkiuqwGxVZTk1A27Wg2HV4000dKRUSgM1xXw0s2I1U3g3UBSZiaMWDFY7dTXnMaAH2n1IfV7UHmTKKAPKNSeHKTdXvgxGVbvg4AfikTSAfjrIhF6FKFy1eGYyNCoCs38DPR01bXMbfhkajTsnxDm2MjIhW023y7sqKDUTqAO2uHwwDoaWT4FUKDFXoClXlVFQU1s240fIIyH6oAJhJhwCpheIZhZhqYwAFh8IXYkEBhYgp3ICVjUArG1iIAgC8KYCR10DkAziCK8LWRjhAQXVgQeDMwgDsw4Aqy90eB4QgAt22ToLt1OQuRSRuTwCeRR6-Samd0eA91938wD0eDD1oL2SgRORpTjiZTZS5T5QL3d293DAr0gAhYgD4poBH1ailgsDPYJgeAhjihN1P12BNhH0iUem324D31cD-D-ABk3mP0gDMrlWf3pgelgMFpkraj4AxgeAX2YCqBKAwB12dSN2d28Jf1JD-DMoYCwAaBH0AB6wwq8flq9IAhW8Apo4oJDvlYwosiDeYqdKYaYWdiA2YVBedxB-ghgmCqAkAzQgY1AFYVYFdDAvCaAkA9GMA-42E8g_ptAN2ndEGuBHgTg6A5EnQgg6k1tv6AqSAajg9yUR9egfYISmglDtADYUItAEDKoSQiDrD6d7DmYnDOdeduoVYQjRdojpd4jNYkjHgrQZ4hD6k4oRZWDHgX8CohjXdrQsoqAgYlDe-6gs2RAt0giXD6mHg8AX0cocTaVdC5Iqjzy6jqQlAbk28randOTFTmAUm1C6W2dVBg9jTUIqEnitTrTuTVD6Y05R98k0slDdZBAZTkGHgVTBAW4R9eGlD2A-UoFNAOYqDVAXT0EgixjeTywMzBS0EUk0EX0tgHcdgEzFTsTsA5qpNWMSAHgHZiDg92AUmNQmAndQi9z7WD4lz8AlD8zIAYiLjGd6Y7j9TeY4LQAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/drawing_tools/geometry_restriction/src/index.ts",
        "description": "Restrict the drawing to a mesh."
    },
    {
        "href": "examples/general/closing/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1Delw8lD8SWVgsFgN8pRwEhDUZfx6cJRQAK60DbBgBGWdXASU8ps1HqmijOS6qvxwXEV5p6jncIcmt_dHJumqr3DkGhDyBNtJRR5IiUdCLWAhOAach5KHkYxoTC4AgPECsExfH5_cImRIpTgmFhQYQgAA0IAgcAAQmh-BokkgwPwoC4AL7kuEIjDYHAosggKg0OgEBgQIhjDT_ABUXAu2iUADUuGANJQiFwPAABOByRTvTTGVQQGD5TQeOqxVAACkYuhShQwlHyAEocNJFVxXPKFRbUJwrRckqhyFwrc7PawuMA4lxYP8jSaJQRyp7Zfl-BJvThvgJaArjfkk1boyIeEUyh4iEl84nKJLyh5STGeM8LmVGAAJbwAWQAMgBhM4XACisBsNFY6Eo5EW44IOGatlHMDnVKSAEl0FaPK3Uc6Y6znb6eHHMvAJtQU17-OnM-6FdmNLmYNJz1NrSWrOWNSAq6-4BeqANmSzbbBA5AANa2IgoE8B4ADs6AAGyVEh5T8OQYAAEzwQALPBOH8GAYD4VUWEAMyVAArAAnFRxE0TAVGBGAejoJU5Q0fw5QwOU8HkeQ5DoPRFG4VhMCCUhNHwWA6AUdJsyVIEpzoOQlHlLheg4ShYCBMx6DlIEei4fwggwJUpmYORNGyfx_BUeQ5TGbhYAwCRwn8LhVHwfxNGOa5WGBBJSHOW5tHkZ55RgEh5CVIJgnwSxejkdFWGiUplToHo5RIYhKHkBRgSBCF5FYeQ8G0ahynoMRSFEVR_BBeRQRUeR6C4UhtFIbhNWBJUTFZQRswwDRnUOTAmAwI2oEgpgUA1vkngaFAFYgIQBDyHAiDGMYcCYIsjk4DAiz-OQwoaMy_jlDgOoKBNaiaNmaoeAeR6WjwN4Zv8qAmlwAAKqpEJSMBWlaT7zFA6jhq4kYuAQ3hijAlDLGD8ALOopJcFR1SVM6b1-iIn2Zi4AHvtd5BQOMIP4y21AQzAOCU8024CpTLjoGepPUBUHg02mX1cAmhZ1sm2Zs9Tx4OHTCwM0zLMU1THNC0mPMgPjMansrItYamRP_Pej7PgtRafqI36VtWBZJlh02lg4Q5bbwXZ9oOdwjmOwqTtOs7CguS4ezQa6bvLDu869kuniTgE69et764qhv8LQ_6AcWoHm7-SQp--NsgXb4iQdBsE_hNWFMvBvFISFVHoKN8GVGlMBSTA8E2dFNG4eUWFUTFnEhRNYD8TATflRJMBYVllTRfRBWtUR_DkShdHRAJgQ0exMC4bxNV6NU6Bryx5A2a1PdpZxuEschE-4eRej8Eh2ET5h8FLw_0lcRNhkCJUMnYcV6D8HrjRLC98UKBCioPTCUkt7UUqMAsAnEuKxVOPxfqWk2pYRotZci5Ea5cWykhTA_B_CaWAbMXKNFgFsVIfXIK5A6rWXQBXfC0lbZWFmjAeaBYlorR_OtTa21dr7UOsdU651LrXVunqB6GgnpEBeiIQ8voYx6y4D9fI_1AbA1BuDdGMBoaw1sAjGwyMCCowhhjLGOM8bKMJnHTm0cxZUzDJLQU9NGaUGZjucWHMo7vi4LnPmqitaSiwk4lwLiYxuJlh4rxrNFaCytiLAJvNbEnlsIk2skpyK63sQbHMScYDGxFmnO2GcqzFOyWw0Qu52zOwHA7Zcc4vYzjnH7AgTThRBy3DuUOatw4awyX46gOTY4C3yU-Qp2dqClK_OgVaf43wjOqTwAuUENjFw8D1Aa4kKpgHoqVVCUUbIxVinA8iLlBBb1wlAlygQOrwX4A3fiF81LSV3kVfgNF7kAKwmhB-fVhIkT0HoPC5BcJcQwtJQeJFN5TwMhFUqwlW7iWit1QyVFO4N24rJGyxlUIgospRW-ElsroHIixL5mCBJIQEt_XigVAg-UMpUTSyUMLIXKORHKgC5LeSElUclnFyVYLSlpfgWEu4CH8EyQI7Evl4UashViege5RQmuxPQo06pUWMisrgHCuEmh4atfhW0dp7WOiIk6Z0aAXSgFdG6up7rqFkVQeRIABkEw-vY9Rmi1TaPMXogxZ54aI1MUGyGMBMbY2qDY96_NiZLNQORcJEsonS1gLE-WPiHH-PIqklR9iQkEFTQrCJfNolZrlt4hJJauAFrVr6Q8kTUBkgpNSWk9JGTMjZOSeQGEIL8EXDgAAVvMNtyABTUFoPQRAIBowgEwIobkwZjSomQFqKRLqDRCzNEgDwqbJU4FzuySsGY_QHopNyXARJpogExL8FEHhN0PrsJKF9HgB3Qk4VcG9-BiBQC4P4fwuw6D3r0IsaA6BP0gG_WdIDkHoN_qRABkgHgz1LpgKoJQMAV2YDXfAF9i74OcP8JBjAsANCwYAHrXS7jgKi97siKEfX8WjVEcC4UYxh1k7bKQ0lQHSBkiAmQshgOyB9ugsqGCeqgSAzQx0Tv5IKWdIp52LrQJAVAEgYC9koLsAGlBaDkHENQF9BANCLGjR4Jw6AABKnDKCCAAPKoH7HIVAi4LNWZsyAIWsG9CqnyC4ajIEQC0HFH0WgsHSNQAw_xztQnu2id7RJ8kKJBQKaU9QFTM7hQMEXe6-Q0BNAub-O-Ddi7Zrgimle91IJUDjvvU-EE6h-xqjnBusTLgmwgHgN2UEtX1xClVPIHz1m-vzEWD-7sCgX09b85gCmdIk7vgW2lvry2-gXTM6gOb42e3ib6--xcBBYPDmkEhe9WQfimYm350xKgwswSXZSc74XsCKB-HOZkuGqC7brBuyzk2PArgkP9usSc6zdlsIIJO_AHt9Zq7ARzENljravagUEdXMPYAposTAL6ADaHhseYAAPoo6I-F7oH2AC6fHyQCa7SJxbrIOdAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/general/closing/src/index.ts",
        "description": "Closing of viewports and sessions."
    },
    {
        "href": "examples/general/console_branding/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1Delw8lD8SWVgsFgN8pRwEhDUZfx6cJRQAK60DbBgBGWdXASU8ps1HqmijOS6qvxwXEV5p6jncIcmt_dHJumqr3DkGhDyBNtJRR5IiUdCLWAhOAach5KHkYxoTC4AgPECsExfH5_cImRIpTgmFhQYQgAA0IAgcAAQmh-BokkgwPwoC4AL7kuEIjDYHAosggKg0OgEBgQIhjDT_YBxBwaAS0ABqEBg-QlBFJMu-8pg0ngE2oGpEzTommZAHk_lNUA9UKyuGANJQiFwPAABOByRTvTTGVTK_KaDx1WKoAAUFySqHIXFDAEouK5WFxpUaTRpzZbqHAcIL5rAqemMGhmgn7cyXMHUDLjMZZdquPY_Sq1Zqs_8m6rKJLS_x8vwJHX-Ir_WrQymrM8LmV0JRyIsbDQcMaCABRWALghUpIASXQoY8k9R8YuXAAEt4ALIAGQAwmcLmuYBvDVYimUPEQkkrm12CB4ZaysaVtWtZakOMANpkepWq21r_C4cD6twrgNn2A5gbQuqIVaY4yjw4jkAA1rYiB4aIHgAKyVDAegAEz8LRABs6DoPw_AACwAMy0ac5SBLRgSBHogT8OUtHUWA5QAJzsUynEUXownlJxMCyVx_AwIEUnoIxFEAOxSVJ5T8IEulgNpAgMZUonkIE7HUexenkOgYDMXo5CVNJznlIxGnlBR_BSfwjF6Jx_B6egRl6bRtHsRRFG0YZOl6OgiV6OUYBMaFYBgJxeh6YIbHkOULmcegVG5XoHHoJ51kUYxnmBJULlgIEYB6XF5Aycxgh6Ox5Q-QVnFceUMAxWVjFSaFtEdZxkmMXp_gKd1FHmfRlTkOZ5C0fJwkCJx_lsXoG3lR4L6iCCmBQN--SeBoUDviAhAEPIcCIDWcDoBoekwIsxU4L9_jkMK6ZQP45Q4B6CgwN6Gg5k6Z1kW-LogJ-WFIf-IiAZWgFxpWZIUtStL0oy5YwOyIDyPwRH8MaOAAFbzKg_KCrQ9CICA0ogJgijclGyqosgbpQ16ag-h2gZIB4nE4LREO0R47Ifv2VZSxS3K4ESiMgJivwoh4Qs63YkoGx4VPQjAUBXBr-DEFb_j-LsdDa3oizQOgpuU3SwNW677vW0itskIrGrczAqhKDAvOYPz8AG1z5s-_4rsYLAGiewAehDYk4BR2vZIout_JnFE4OxueK6yBOUjSqB0gyiBMiy5Mcro6AGLggqQM0DNMyz1BsyKHNc2gkCoBIMBXpQuwAAqOrQ5DiNQBsEBoiwwKHTjoAASpblCCGaqA3nIqDGiva8bx4Hae3ojr5C46dkh4tDin0tCe4nluK9XRN1yTjdkwpiiLuLRe7UH7kKdmnMDxOnkNATQFol7Wnjh-UE4IYCeyoEQEEqBGbazlCCdQN4nQbkFk3Fwod4AXjQbAbcQpHTyHPuvUO8xFgWwvAoA25DL5h3IH0dMSCuFk1DpgPhdIhxWg4Yw0mzdQ7G2XJ7Fc0hGLayyD8ReTCeGUGWCoR-pFuaUj_E_EA2BFA_A3MySOVABFdkFqvZhHgnwSCsV2IcXYLy2EKnYTRodLroN3nmZYME1aoFBBgkASsTFYD4YsTABsADaHhQmYAAPp-NgKiERhiPAAF0q7khrsTBu3DWSlKAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/general/console_branding/src/index.ts",
        "description": "short explanation on the example"
    },
    {
        "href": "examples/general/div_structure/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIPKUcBIQ1IhcGjBQ_OLqANxcAO4Q6AR4ZQCMAAydAKT1URAA5oQd3X0eqaKM6aqZ2bkeBUXipVz8enCUUACutPVNLW1cAKy9_TBDIydnE3FWU-S6qvxwXM15j6jPcBMmn9-TeLGGaTEwgu7xODkDQQeQELjZRR5IiUdDbWAhOAach5LHkYxoTC4Ag_ECsExQmFw8ImRIpTgmFhQYQgAA0IAgcAAQmh-BokkgwPwoC4AL7svEEjDYHAksggKg0OgEBixVAQIgFDTw4AOCrVGAANQgMAaWoIrL1Alo0ngRWolt8ABkAIIAcQA-t4AJoABQAolxRVwwBpKEQuB4AAJwOSKGaaYyqE0NTQeWpqgAULySqHIXEzAEouK5WFxgHdjMYrQa1lxk6bzXdFVl6ynzSW1g1-BIa7RjY3KNrMxWRDx_i8yuhKORtjYaDhBrZ_bB5wQuUkAJLoTMeCek4svLgACW8AFknQBhJ4vFcwNesiFvdBlDxEJIDs1DggeO6iwsZqglbVtC1owHWLhwPaQEiC28KQdBnb8N2vagQatpQSUqAjk-4jkAA1rYiBPjwHinDAegAEz8JRABs6DoPw_AACwAMyUY87SBJRgSBHogT8O0lGdDAYDtAAnMxQqsccej8e0rEwFJbH8DAgTiegtHHAA7OJ4ntPwgRaWAGkCDRnSCeQgTMSJzHaeQ6BgPRejkJ0EkOe0tGqe0xz8OJ_C0XorH8Np6D6dplGUcxxzHJRemaXo6BxXo7RgHRQVgGArF6NpghMeQ7SOax6CnFlegsegbkWcctFuYEnSOWAgRgNp0XkJJ9GCHozHtJ5uWsWx7QwJFxW0eJQWUa1rFibR2n-LJHXHCZ1GdOQJnkJRMn8QIrE-UxeirSVHiPmOXAopgUCfp4GhQK-ICEAQ8hwIgVZwOgGjaTA2wFTgX3-OQyoaMK_jtDgsYKDACYaDgVBEMdT7NHd74YdBv4iP-gHAWsUDdkkryxpQDQIlEXB6NscBJGdqIwHcDZftqOCCOgvhVIMmbOu6Xp-v6OBcp40jeh6Z4APJKP6AGcP-RaAWyHLcry_KCsKYrsvI_AEfwS44AAVpsqDyoqtD0IgIAViAmCKNKeYmqSyDRuD8ZqImdNpkgHisTglGg5RHjim-PZAW7HLSrgTLwyAlKwiSHh2xHdjajHix8gDUBvCH-DEKn_j-JQlvh2T0DoIn-TJ5UpPbIXadEhnJC-4-5swKoSgwJbmDW_AMdm2r2KVP4ZMYLAGjFwAeqDQk4Mc4eIvA0JRyPxw4MxE--6KsucjyqB8gKiBCiKMDihHujoAYuCKpAgw63rBvUEbKom2baCQOqtBOpQue-mGtDkCsgeIAQGjbBgPXJw6AABKlRKCCGFqgS8chUBLhjv_QB9c6bFz0GGBoLgh5sg8LQTUVRaDF27inX2a95ab0VjvZW-92QkjPkMS-1Br5KmNqbPc4Z5DQE0MLOEWFbZm3OuiGmQdYYolQLrcOFQUTqEvOGNcttd4uHrvAM8qIhGbiVGGeQiCAFAI8JsbYPczwKBjoovRDdyBVCBj_Ux1D66YEsXyaoWFjHaKVnveu8clw_iDv6aQtFw5ZBhN_HRyCPCUF2CobBxFzach8corAigYRrmFM3Kg1ihy2yQeY-8Eg0lDmqEOM8tg8p2FCeYwRsBwGbB2DYoOqBqZ1w8NgSx2xMAxwANoeAaZgD0lSO44NiVkDwABdVe7J14K23mY0UsygA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/general/div_structure/src/index.ts",
        "description": "A proper structure so that the viewer elements are displayed correctly."
    },
    {
        "href": "examples/general/error_handling/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1Delw8lD8SWVgsFgN8pRwEhDUZfx6cJRQAK60DbBgBGWdXASU8ps1HqmijOS6qvxwXEV5p6jncIcmt_dHJumqr3DkGhDyBNtJRR5IiUdCLWAhOAach5KHkYxoTC4AgPECsExfH5_cImRIpTgmFhQYQgAA0IAgcAAQmh-BokkgwPwoC4AL7kuEIjDYHAosggKg0OgEBgQIhjDT_ABUXAu2iUADUuGANJQiFwPAABOByRTvTTGVQQGD5TQeOqxVAACkYuhShQwlHyAEocNJFVxXPKFRbUJxBVlMnR0AA5SjiSCncTUT1cK1mWBlLI_VDNUlcGxwOD8ZowJMEFPNZ2e1hcYBxK5gONhiMQKNTVA4RQaIiUiYx1ydrgAcmaGl0tHQ3eL5ZEPFQJq4NYgkf40etCZg6eAXDxZUz2dzXFZzt9PFZXBgLJgler4ZndbnDabmlbWYbXAAhF3u5hUMahyOKzxp7P5zgNBgABHRZ4AIAAFW82wbK1XRKOgrWbO9224VxS1HKweBnOMkOgjsXz7AcYE_Mtv0wid8inc8_xgxdl1XUEBgzeBNxPHc90w1kyPYisuNQVlfU4K0LiSVByDjYs0NIkRYH-I0TQlf4vX4fJ-Akb0cG-ARaAVY18kUq0MNEIoyg8Igkl0hTKElDxSTI54LjKRgAAlvAAWQAGQAYTOC4AFFYBsGhWHQShyEWIKCBwXMCACmBIqpJIAEl0CtDwHNRZ1eN3S0eALJJpKsWSg3vDtZVU9T3QVTTALnGBpBYmCjKsEyNRAcyGtKv0yTIvK6wAa1sUyClVVNtgG2xbN6jNQSPSz8k8DQoGGwgCHkOBEGMYw4EwRZyHKHAYEWfxyGFfsoH8A6dQUYi1E0TS1Q8bicpEA8o0cOMYC_MdTzSn6eBPNAsl0U7KCrKq3V1ZQ7o0ABxGA1VsekqX4chBowAAleAxlQFw_I0VUtAAMiJ6aYGihGbHylG0eDfHCe8QET07dx_tECHZBulR1DhymkaSGn0fQLGemoPGCesxnFBwbwkq8gBpPzvAAfQVABBDykqUNXZYAeRDZW_IxjHdYxsjvsw0JjAcOcPvsHoYHIC9xM0Qn0zQbY8EpG2XHTexxFpuTmSKK8Y1d6zppcDBf0vec0pAemI7JLgAAMAHUTzkdRZW4cONDKAASYAAClpH1nBkzQZoZySK0vtZFOXqsPj904HdYN9MkKWpWl6UZZk2XJeRUf6nNyYAK3mVB-UFWh6EQEByxATBFG5MTjVRZAtWuvUYcNPSzSQDwAGYcAAJgOs-PHZMy1O6xAPERHkiSmkBMV-FEPC3t-7Bso-QGHtCI8VxuS4CJFwfw_hdh0FfnoRY0B0Bfw8IA06UBVzwKgOgEBSJ8DECgNfOyy8YCqCUDAVeb4nbwC_kvFBR5_BwIwLADQSCQAAD0DrlDPjgAArK_bIih35_BYaw7hOAAAsPDr6si7pSGkqA6QMkQEyY87I366HQAYXAgpIDNBwJPagM9qBzxFAvJeaBIDvloB5SguxwKqloOQecX8CygUIU4YWR5KCCF1qgLychUwwGcRoVxHh5L5BYXoVU-QXDMJ6iAWg4o-i0BYbQ_BIBpHklkb3RRyjB7xK-NQHReip6GKFPPRe6U1TyGgJoXWfwGybyXiCMEEJ_5UCICCVAk9X6ARBOoLyapIqb1yUuDw8A3KgnBDAJKQpVTyCCSEt-lBFhALcgoL-IzCGYHIH0fsTj-7Hi2Y7XZodUBrPmQc32Hhf4xRYX5aQAA2V-ldHELNGSAZZBAVCxIfsvSkBBX7YGbGKYUzJSFUD2dZTeLj3nxQkOC6yc5rJuVsIIOc_A3mEOaVMkWCxlgNhYagWaBCxlYB2YsTAX8ADaHgiWYGVti2AqItn_I8AAXQyd3ORCjLkwFZPyoAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/general/error_handling/src/index.ts",
        "description": "How errors can be caught and converted."
    },
    {
        "href": "examples/general/event_listener/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1Delw8lD8SWVgsFgN8pRwEhDUZfx6cJRQAK60DbBgBGWdXASU8ps1HqmijOS6qvxwXEV5p6jncIcmt_dHJumqr3DkGhDyBNtJRR5IiUdCLWAhOAach5KHkYxoTC4AgPECsExfH5_cImRIpTgmFhQYQgAA0IAgcAAQmh-BokkgwPwoC4AL7kuEIjDYHAosggKg0OgEBixVAQIhjDT_YBxLiCdAAGUptFQmlJcu-Alo0ngE2oGpEWv4tAAahAYPkpQRDTwAKKmu0AOW83gAmgAFO22rgaGAg9TKrJ0TScVlcMAaShELgeAACcDkinemmMqgt-VDIDqYsFWUydHQTso4kgp3E1C4ri4AAozLAylkfqhmqSuDY4HB-M0YI2CM3mgBKKusLiykQQMC14uliDlqaoHCKDRESn67iuTdcADkzQ0ulo6G3w_HVjV-S4M8nc5NC7rElgbeAXDxZQ7XZ7XFZg5zInDMBZGArinGsrzLW9qCXTRV07BcuAAQi3bdMHFGAjxPOUeDAm8K0XP0AEdFngAgPWgtc70HXkolQGtlxg9cRzHTDREnWs6PIytN2rXd9yFdCmJEKweHPS8S2vedqHvcwnxfUEBnbPVuyA79fyEr9mJUuVWTDX9OBrC4klQcha2HVxR1PUJjAcP0TSA-x00ta1NWofMHKtShpSreV8n4CRrO1GBzUcjyCBrCyeGeC4ynQShyEWGwaBwHsCDtWAEoIKkkgASXQGsPEi1FhwuLgAAlvAAWUVABhM4LlS_1hR9HgijKDwiCSIL3OlDwtJ_OVjCs41aHlAtYOoZzUHzFwxo3bzfP-IaYF1GawuY8RyAAa1sRBmJ4DwAGZygATjAcoABYwEqQJyHKGAADYAHZ-ECB6LvQQIzv2_hyBgcgwHQfaACYqjOo6HoewHMD0SpyHQPQAFZ-EqOG9H2o79sCeH4aOwH-HKeG7pgQJ9oe_bKhgM74fIeGYCesAadmeHAZgfG9Fu_a7vQM6zqRnGwAe8pBDx_bDpZ9H4ehsBAfh9Aju5wJ-DAfazvQSoFUqPR0ERvQwECI6PqBiWwZgGAjvuqo7r0aXgbu7nOfx57LbZwI9DOypynO9BdaO9BAfpo7KiO6HAiJ8gXbNmA9H8B74fKS2YBJ8grdlu6FY1_bqcpvRFa-mBY5gDwmvbUEAM6zwNCgVqQEIAh5DgRABrgTBFhunAYEWfwfpofcoH8cocETBQ0LUTQcCoIhC-YlrYxAdrlvXHq_z61B-sGmzhvsKAVRDLQShNK5LlOKBYHQLh8momB1F3qJRoYuRLj0E3uDirJowgAAvNCJvzHYttmhUgyqk0DWB0zpXSejtDgaQdppDSCygAeSdFAmBcDEEAH0qqeGkN4eB5UsoAC07RKDbDWGAplzLMRcBgbCEkaIeHnnBF-OxVyf3QIXLgAADBhlYmFv1YWUAAJMAAAUtIRBA9-xoGaJOJIpDBysg4cvHgmkV4iGmuuJKtgPR0n4DYWgGhMpOl0TAPKIBFR0GaCUDwg4ADalQAC6OBzhLCAtWKoqk5p-XUQuMeixX4sJMcvVeXBqA_S4EkSgix5R-i4DFNUXAt7BnFC2NsfoAxARKEBRJQCNDBLSZQQM281QaDrJQP-g4wyDhrMvMkFJqS0npIyZkbJyTyG-htJSOAABW8xUD8kFKqEUiAQCyhAJgRQ3IjIWlRMgeMg9kwjw0GmDMWYdogH2jgYGmyPDsjar5FeSAPCIh5ESSeIBMS_BRB4WZ5y7DdUOSANp0IAJXG5LgIkXB_D-F2HQM5ehFjQDYQ8p5P0oAvgBVAU-xz3nECgDsjUYzL5KBgBMlC5BpnXNGSCgC_h_kYFgLkh5AA9fu5RAY4Hhmc7IigLl_GuR4Il8McBnQpTs1ktTKQ0lQHSBkiAmSAXZOc3QcNDBj2oJAZo3Ten9OoIMhgoy0CQHFLQRUlBdgeijLQcguFrn9iIgipw6AABKAFKCCHgagKqcgWwFyQHqmACK3L0pAHoKM-QXCEoRbQSUfRaDOuxXCkA7LyScoaby_lLSQAokFBKqV1AZVCnoMM0Z495DQE0PAv4C4ZmjJBGCCEDzx4glQD0s5-T1BVWjOlGZEaHUeHgOVUE4IYBZSFFGeQuqND6o8PMRYzzyoKGubWhFmByB9H3DqppgER2_XHRBVAA6O1TpcF6ukyVnUwLumcpsc4CCdu7SASJBAVCErWd0PdZJ61YGXBKYUzJkVUAnR5GZ9qEX-gkA-jyJoPLlVsELOw-662zybbAE18wliTrWagEu8Kr1jsWJga5NiPDQcwGgvNzbUQjpVB4exwa6lcp5cumArJSNAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/general/event_listener/src/index.ts",
        "description": "Event Listener system example."
    },
    {
        "href": "examples/general/progress_events/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1Delw8lD8SWVgsFgN8pRwEhDUZfx6cJRQAK60DbBgBGWdXASU8ps1HqmijOS6qvxwXEV5p6jncIcmt_dHJumqr3DkGhDyBNtJRR5IiUdCLWAhOAach5KHkYxoTC4AgPECsExfH5_cImRIpTgmFhQYQgAA0IAgcAAQmh-BokkgwPwoC4AL7kuEIjDYHAosggKg0OgEBgQIhjDT_ABUXAu2iUADUuGANJQiFwPAABOByRTvTTGVQQGD5TQeOqxVAACkYuhShQwlHyAEocNJFVxXPKFRbUJwrRckqhyFwrc7PawuMA4g5qFkuPJVeR4C44GVoyIeABtADWMAGmQIP1QzQAumUABLeACyABkAAqq5oaFMAUVgNhovp4rM9UdZvpjgvj7z76Eo5EWnYIOG-Alo7Zg06tHneHmd3a448n05weJwCkUGAAwnhoOgre8NzH3jgsjkYDgxhNxNQ-x5ZvMlrRzTe1HfslgHBul6fp3xAZsil_ERb3vICdnkcDamgmN3QVA90HQWtKVoVBNCtNCcFbBVWwAOW8bwAE161bHBvAAQWkABpOjGKYgB9aQGIAJW8UlQxgcNXEjDMrGHf47DgHNW3UGg-xgWVLkIgBJbwLmk2SCE3HhhwWR8oEoZorUkjThRwIpr0zWNUBHNRlNQPCtC9bcpzMud-AXDthRXEA1xASyrFvQ86HQU9z0vOyHM0SyYx0uN_kTQyWzgS5nInVyaFnFsPJgRdlw8RLmxTddtITJtkrgHBziWBSvUqUrCoqnAiH4LA-3KUr3nsxyD3kI9QrPKAL0alMAtERLkxS-AsxMmSzKKUs-xGlLBys8SuD6PQYCgMd0t3dzPKXbyPE27aStijbZm28yoo0bxsH-L1Zs03lARgTrIp64KT0Gi9TqgGKrOWyrqsWWrtnUubMuB1arAgMBQ2eszskUT1XC9QiGOY9iqJonBq3o7xW245T6NrdjjwAeXIsjvHY2tKfopRlNIgBxZ0Lrimy9JwAyjI8LI6QIDx-JgfiJpTaakcyhaxtZQGeEIwQsJwuh8MI4jadx2isZY3X2PrbjKePVtpGkfirUEiMowu9bpcergFLlFS1KkqGtMtOGEeMyGXpR2r0e9Vjse1_HCeJ0nyapmnyPpxnmbZjmrK5r99MMnzgZFx3xaTSW4Bm335vQUsxp4eHQwlqb8_t8zi6TqweEr1MC7dl6Fqq5kwb7GuYZjeXYaD5XsKyNWNAIxUiJI8jQ914OOLIpQLat4SbbW-KIdb4V5MUoPVMLrsLvLn3N8y_20Yxif9dDgmiZJsmKeponY4ZpmWfZznrNT3n048EKs7FsqE484t1MjLOupUj5NylvvGcssP5QOrjA2upYO41W7kg3uIh-6ew2rYLgRoTQSgdvwfI_AJBBwOjABUxp8hEKtKJUQRQygeCIEkahhDKCShFrbM4FwyiMCrHWY8vC4B5WFKwFyu5mi2DETQKkSRlIXg8M8C464-5jVgP8VMEw3xehIWQ_4hFKHSBTFMa0DCy7oGYSAVhJiUpmO4VZcQ5A8wbA_h4AAnAANmqJgMAgR0DlD0AAVgAOzkECJULxMBAgABZQlBPKF48gABmco_AYAACYvF6H4ME9AHjvGxL0OUApmTglgGCXElJHj0DBMqDAKpHi9CVL0OgcggSvFVAyeUGAKTAjNNqTAdAgQMmBHqZkyoKTQleNiVEzC_BMkpKWXUvQsSwBgCqEE4pHiZkpJSfwZp5BQmBDAKEjJoTMmBF6egZJ6AwCxMyXUzJDzlkpKiTk4JMBQknLmWsyoxyUkwHIMErxdTKj1MqIEfZgRAheP4HktJ5ByDlGKV4wIVzZgPMCDADxKL_DJL0JUPQ1ywnLMyR4sAKS9DhPKOUDxoz0DLPaRsjx_BHFWBBJgKA7D8ieA0FAaxhACDyDTMYYwcBMCLBRTgGAix_DJhoBoZk_hyh3l1MMtQmhZxqg8Oo308swy-jJBSaktJ6SMmZGyck8h-AuP4NInAAAreYqB-SClwiKRAIBoy-RgP1Og5BjSomQFqHUChNXqA0IaGhZokAeBSTgTJarMkeHZCwshfp40Um5LgIk3CQCYl-CiDwobC12C4dm210JtpXFzfgYgO1_D-F2HQAtehFjnlLQVOkyYdodvPHWpEDaSBptJKuGAqglD-pCoG4NpbfXVr7f4DtGBYAaG7SAAAemq8omScDBILf7ItfxN1buCTgWJB602shNZSGkqA6QMkQEyFkMB2SFt0OgAwuBBSQGaM6117rqCeoYL6tAkBUASBgLWSguxGyUFoOQV8WbEBFjBuOkATh0DcW2pQQQlNUCnl0NI0t6GxYeAIfkTdehVT5BcBuskHhaDij6D-KtvazogFveSe95rn2vutSAFEf6WiAeoMBoU9BvW-qoOKaAmhKZ_DMSG31XLwQwE3XJkEqAXUFpbCCdQx41TThDYJijIB4DVlBBp-ytBVTyDIxoDDAtKCLBrdWBQpbzOYcwOQPoyqUPeatRZvzAWPJmM845y1b7MMVukcLbNpsvEFqyD8ZDTmXMgDcwQFQjHECrhwgW7AigfjTmZNOqggXOEhvI5hpcEhKucI8pw6sthBAeXZUgOrLCbOwFw1-ZYDjs2oFBJp7j9WsD-cWJgUtWYPCjcwOxdTsBUS-aKyAUsPHTUPqfTFtkrJWRAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/general/progress_events/src/index.ts",
        "description": "Display the progress of loading a model with the events provided."
    },
    {
        "href": "examples/gumball_transform/selection/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1Delw8lD8SWVgsFgN8pRwEhDUZfx6cJRQAK60DbBgBGWdXASU8ps1HqmijOS6qvxwXEV5p6jncIcmt_dHJumqr3DkGhDyBNtJRR5IiUdCLWAhOAach5KHkYxoTC4AgPECsExfH5_cImRIpTgmFhQYQgAA0IAgcAAQmh-BokkgwPwoC4AL7kuEIjDYHAosggKg0OgEBgQIhjDT_ABUXAu2iUADUuGANJQiFwAOQAATgckU700xlUEBg-U0GrqnDFEv-wFl6HQABlKbRUJpSVwAKIKz0AOW83gAmgAFT0AfW8ACUAIK-6S-ADykYAstHvABJBO-iMJhOO6RcVnK1Xq7W6hQwA0aI0ms0aC1W8WUSVcO0AcUWRD0zKg3g0ujgYGbRA9nvUNEj8DGqBcyYU8jQzULxbVmp1esrakNxtNmhwYAEBEWGngvP7M6HGiI_HE1H8OwWcAbqGtzdtXHTQv75FvqCUN_4D1P1ob9f09VBmjQGAPWTcFxGkGBYB_OdUH4Zp3Q_L9-B_KZUDHYVJx6ahZ3nRcPQACUodQNBQtCMPTWCoHgxCYB_fCaGXFVVzLDcqxrXcNH3Q9j1PNAQOw39n04AAKRhdBSQoMEofIAEocGkRUuFceUFUtVBOEFLJMjodBfUocRIFOX8tK4aSzFgMosh-CCPRsOA4DoxyCGc5oVK01hWziUQIDAWyzIsiArNwnBFCvSkJmoLTXG0jVmnPWh0A1PzgCCqweDdfIuHCkLIpvXC7IkWAPTtPEyjcjz0MLFS9KsItEJcK5Quk4rLLK6gYs0Ih4twrgAEJks1TAX0rLLApEPKivMkqov6k8AEdFngAhg0G4bqGktSSjoaTYqG9yRtcAKcvmhbgq6069u4ZKUrS3QMtm67bq-rgCsWiKVtQCrzGqrhaq4eq6Kalrvp4Vlcry1lmvhuHUFZPSZIuJJUHIWy_MuuarGMYwHBPG8YG2KIuB3fIbXhwz_mpm0bP4fJ-AkHScG-Q8YAVWsbWkz7bqKMoNSIJJedNG0NVJeGrGeC4ykYcjvGTR0AGEzguT1YBsGhWHQShyE7YUcHQghtZgXWCCpJJ03QaSNXlp8VORpH9JuomSe5inyZcc7qDp4j_j9hKntlVn2Y0hVOdJ2gEP9wHBYW4XNTF-PQ-l2XRHEcgAGtbBF8oAFZyEqIui_KGAAHYAE4AGZyCLmu9DrvRy8CAA2cua_KBvKjAOu65gMByBgQIBAAJmHkei8CPQO7ADua8qKv-EqDuh8CcgO70PQq6rovKgnxfq4n9A9EqAAWSpAkCcvsMqbD5_Hy-9Brie18v5fyDAQJL6LvQYAq6BDPnXIuVcJ6X1Xh3dAADL4dyvmASo5Rb6VD0D_GuJdL51zAMXbepdgE134PwKec9h5N3QDAgeE9yjEPIBA9-5A66BB7jAGu_8YCXyqOUMAehWIL1npfYelQG7lCrpfS-E9_BVyqBIuu_BaEV0vn_GhlQa6BDrhPD-HcZHoBQS3KumcbpWBBJgKAEt8ieA0FAEWhACDyDgIgImcAHQwFUHXHAMBFj-FHjQfsUB_DlBwOWfUW5BJUCIBqV26Mbr01BoYeACZljyGWDZEO0UzZJPscsG2vp-A2AdlSBJzsADalQAC60MeCe0EOgK4WEcKJXQABbYlBZRQCgPErA8B4YGG6XALJKSCA4FQKCGAo1Ta2DMpgakSQ8k2AAOoSDwJOdCWBpK_VWZ6LA8hpLGAAHp9LDMYFSalLyemwngaSfT_IE1un0nAtT_x2A2aaTC4lGl_gAgLRoVFNBlG8ptD0LgkIbG2BoTaTU3ZfQeYseQzTaAKk0KHA6VSoaxA9sTLmZMfb1I-dZOgkE3SBxnP8MSmgJK4XAkS8m2lfrAQpZ86lUFpKMzfG7eGntsW0FxUQOCEBjKgvBroOiGgSVGT5UxCACFQW0XQloOlbzGLMVlSK-VqL4aSpVaxAgcq9zTx1XOECEBmQ2V-lHHARrNAmqgNIOwGA6ToGefwH5VAoDNhFieTK6KbrktAlSiCUFHkOgZf66geqNDSS1dKliyE1WaA5Zir2OKjq_OosK1C8rxX_DwH8mi8aFU_TeZRaiEaNU3VzaWgtniwAHjjca01irCoWqtT8ZkdrdDNI0E675do3Ues1HoJYMANQ-qsH6yl1BmVumDegUNk7UBlsrZoCNibCZYtjuTXQXA3HCi4FAF0dBNDKmbLi5onZuwdOzTu8cBBnRZCPRobwlB85h1qfe10mhpLej9AGEM4YoyxnjEmVMGYsw5jzNIS1aZIzpgABphjVuRWMbZPRKA9NJGAeMrpZx4HE89XYezsX-NpLdlxiOEWnCReQC4IIlJ_f6IMoYIwxjjImFMaZMzZm8LmfM0GozwcQ8h30qGlCVIxV9T2uplK4tGf9Pq7svouAwD1Uqv5pK4byhqDshGOmNDlI4XQ6FMoy2MbdAABv4KmfM3x2zKAAEmAARy9UBiM4DZZKO2KMYY8Cs6MmZDmnMXqI7ekZYy4DeZ81Z7yA5LzXl_I4rgjnnMhZNjFi8w4FMRfM5p6FohEYxKsLAf4KWOllB0y5vssXhxcAAD5cEWNySAbp0CFdEFyzdsouClc6YlaNgqdXXt3TQD9j6NYdO7HnGymGygMX5TKnVxHsN3IWly91HVU09c6lcMllxdh0E0yFWyPXsqaasD1zm62YDlq-ijTTHXvabeC3po7R0Tyyne_5-AA2fyVkO11GAYWZk4FgBBEoXAAqVFO2ZhaW2m1cAqz2KrGWrysps5KD0gOvtwDywtSLsM2vVOJrUm9e6D0PrdM4E9Wh-sgsGzdd9h7KfSQtQxv9zH0z-k9DGNWYHfSWs8I6DMYZpCekdJ6XnYYswYaw7cpOeU4nRoW2xW9NkyPvMZWBW9lHiIwDnDRxcJTWc-kY_-sMnPvDc-jLzrjAuhfphF2LiX3gpe-nEzD0nI2meaHG1ASbuco3zdjebW9uOfWcuJw6T3_xyefqp5ecG_KfsEHhozinX7je_qY-GC3VubdZjt8L0X4vJcJl8L4GXy35dyyDonqVyuQ97tI7KS486mXa6nLr_XtHmhG8VDgNn2fzdc553zwvDvi_O6l-X93X1ht3u9xoX3_vA_1-D0ttFBXOCI3LWSCk1JaT0kZMyNk5J5DYVznRHAAAreYqB-SCldCKRAIAcogEwIobk2MTSomQB4dcFYfE1MmgHgiAHgHiNCOAE8HgMsIAABoS1E_EdYQkN4IkcAOAE6nyoB4BUBQS0BZI_-ISm4iBwBgkB4qBJ46B6Wg4mWv494lAj42BIAEBeBHg7IHg14aATBiIPIRIMBHgmIvwKIoBb-WQdIKeSAHg5-0IiE9SSI-AxAnS_g_g-2-kBBIAegiw0A6ATB0ho8nSmh2hchvBihbBsBmAqgSgMAn-U05AP-IhUhdI-h_gmhGAsAYqkhIA-yQS5QE8OARc_BIA2QigghfwTB-yRcOAl8_hbBrIe-lINIqER-iATILIMA7IIAHk-ghgnM1AkAzQN-d-D-1AT-DAb-aAzWEgMAjoDB8gwYqotAWBSAgK0EHgTg6Ak47qggCYqAascgEEMAoBLRsB1MTBegqo-QLgHhsBtA4ofQtAuhThiEbB8RB-SRDIKRJ-6R5IKIgo-RhR1AxRQo9AL-b-ESC47hCYfwuEv-b-pi4IgxnhESIIqAt-gRJ4II6gasaoVsv-qRLgsB8AyYoIDxoauwQxEKrRmRlAx4o8-uoB_xUJmA5AfQ_Yv4CJWx5hrEqJCm8Jx-aRMxdIZsTBno0gHcgRTkkUEhiAwxHgMJBAKgHhYB7-LogR2AsUYowozIVhVAaJzYv-tJIAlsEgPJzYN4zYyYtgggAEEJQKHBIJsAhECwywuETBX2ZhHg2AKJiwmAoBJSHgX2YY9xsAqI5hrJIA5ScR5ICRh-GxiJrIDpQAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/gumball_transform/selection/src/index.ts",
        "description": "Select objects and create a GumballTransform for these objects."
    },
    {
        "href": "examples/gumball_transform/simple/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1Delw8lD8SWVgsFgN8pRwEhDUZfx6cJRQAK60DbBgBGWdXASU8ps1HqmijOS6qvxwXEV5p6jncIcmt_dHJumqr3DkGhDyBNtJRR5IiUdCLWAhOAach5KHkYxoTC4AgPECsExfH5_cImRIpTgmFhQYQgAA0IAgcAAQmh-BokkgwPwoC4AL7kuEIjDYHAosggKg0OgEBgQIhjDT_ABUXAu2iUADUuGANJQiFwAOQAATgckU700xlUEBg-U0GrqnDFEv-wFl6HQABlKbRUJpSVwAKIKz0AOW83gAmgAFT0AfW8ACUAIK-6S-ADykYAstHvABJBO-iMJhOO6RcVnK1Xq7W6hQwA0aI0ms0aC1W8WUSVcO0AcUWRD0zKg3g0ujgYGbRA9nvUNEj8DGqBcyYU8jQzULxbVmp1esrakNxtNmhwYAEBEWGngvP7M6HGiI_HE1H8OwWcAbqE4AApGLoUoUMJR8gBKHBpEVLhXHlBVLRfVBBSyTI6HQX1KHESBTlvbhQNfMxYDKLIflQZoPRsOA4H4ZoYGwghcOaP8QNYVs4lECAwC4V8EKQiAUKmVAcEUK9KQmagQNcUCNWac9aHQDVqOAeirB4N18i4VjGPYm9OIwiRYA9O08TKQjiNIws_wgqwixgFkYCuJiWMQ5SOOobjNCIPjOK4ABCITNUwVATQkqSZNkpTkNU-yTwAR0WeACGDRznOoV8AJKOhXx4pyiJc1xaOkkRZNkxjmJS2K0I8kSxMrSS6OynKqvkxSbKC1D1PMLSuB0rg9JIizWSM_yqsLHrRC64yBs4VkILfC4kig5jqIyiqrGMYwHBPG8LMSrgd3yG1_Og_4NptEDZXyfgJDAnBvkPGAFVrG1Xyy3qijKDUiCSK7TRtDVSX6nhnguMpGAACW8ZNHQAYTOC5PVgGwaFYdBKHITthRwUiCEhmBoYIKkknTdBXw1H6nz_fzBtiSqFqWi7tiiWC0uobbqBglxabQw7jv-ICFTO5baGkeB-NQW6vqudBHue3nmY-oXxHIABrWxHoAVkqGA9AAJn4VWADYHX4fgABYAGZVdOcpAlVwJAj0QJ-HKVXlbAcoAE49aZA2Fb0K3ygNmAXcN_gYECR30E1hWAHZHcd8p-ECEOwCDgQNcqG3yECPXlb10PyHQMBtb0chKidrPyk1_3ygV_hHf4TW9AN_hQ_QSPQ9V1W9YVhXVYj4O9HQDu9HKMAtZrsAwANvRQ8EXXyHKbODfQJWR-7PX0ALpOFc1gvAkqbOwECMBQ9b8hne1wQ9D18pi_Hg3DfKGBm9nzXHZr1X94Nh3NdD_x3aPhW4_VypyDjuQVWbsrYCANmXXWeh_5z0lpVKwIJMBQFevkTwGgoCPUIAQeQcBEALTgOgDQocYCLCnjgYh_hyDCn7FAfw5QcDln1FuDQZ01QamJt1SC81FrnRWlTCyzROzdigFAemM5_gCK7D2A6NUOySOEX2Acl4iCvj2s2AgHoADaTN-Y4FQKCGAABdDh_lyY8NoLKbgMBxz_CgC6OgmhlTNj4VwCRQiRGVR2lwKxwpnRZHsRobwlA5Ys0EE6OxboNCvm9H6AMIZwxRljPGJMqYMxZhzHmaQOAUmRnTAADTDCDf6sY2yeiUB6V8MAZqZSFp41xPYxzCgOhZOUDSJxTgZjAOc8gFx4Q0dE_0QZQwRhjHGRMKY0yZmzN4XM-YslphyfkwpxTSkGLGnA0Q5NdS_mcXotidlOFVRcBgQKKkGpCysBqWRbjGhykcLoUiElPrrJygAA38Ota6aicZlAACTADqcI1pBAcCqMlDjVk5zRDvL0ZgHBXA_kAqgEC3R-i4AQuebJd5FFFHDmCjOX5_zBH1OsWeHFV48VopeULDhJkOFdXihBMkFJqS0npIyZkbJyTyH4LLDqOAABW8xUD8kFK6EUiAQDSRAJgRQ3IoImlRMgDw64KxVhrLuDQHhEAeANjgVWdDVYeE-iAFVjD1DVg2nuA8N5jynmxReXFqF7yUEfFqnVeqDUeHZB4a8aA3UUm5LgIkRqPCYl-CiLVUqsh0gIP67l0IzJXEDfgYgUAuD-H8LsOgIaQB6EWNAdAca6SULTXmgtSakQppIF641mBVBKBgLKry5AFWRo8PGkt_g80YFgJqpAHgAB6dDbY4AVjm7Iigw1_H9QOhWOA9ajq9ayJllIaSoDpAyRATJzLshAMRfQhgWGoEgM0AVQqRXUDFQwKVaBIDeVoI6F18hgyqloOQVCWqKIRWNU4dAk4oCUEEAmVAIM5B4RgJ-jQ36PAbX9XoVU-QXB9uNbQcUfRaBFoTSIkAy7ySrtZZu7dnKQAokFCes91AL1CnoBKqVVBxTQE0AmP4nFFVSoQeCCD_aBRqhBKgQVOaTwgnUCDXjwpFVEZgMa-AyZQScfTEKVU8hIPQb3ZQY8lCulask7WmA5A-j9g_ey8yun9N0jxVp4zLgUN0hRv6z00hNY5pwuxWNSAv1SY8OpggKg-3aulS6HN2AeJimFMyBtVBDPNkVR56TTkfN6ebDeZsyZbATzsCpzzIAOOwEnPMJYRn_Mwq496kA2B9OLEwFqjRHhithhy_AHN3Q3MGNw8ytdG6rMwFZD1oAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/gumball_transform/simple/src/index.ts",
        "description": "Create a single GumballTransform for the session."
    },
    {
        "href": "examples/html_anchors/UI_with_anchor/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=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",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/tree/development/examples/html_anchors/UI_with_anchor/src",
        "description": "Use an HTML Anchor to display the UI of a model."
    },
    {
        "href": "examples/html_anchors/all_types/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1Delw8lD8SWVgsFgN8pRwEhDUZfx6cJRQAK60DbBgBGWdXASU8ps1HqmijOS6qvxwXEV5p6jncIcmt_dHJumqr3DkGhDyBNtJRR5IiUdCLWAhOAach5KHkYxoTC4AgPECsExfH5_cImRIpTgmFhQYQgAA0IAgcAAQmh-BokkgwPwoC4AL7kiBEfjNeAIqioABMOHkqGaZBA_No9EQIEIBHkcEQxmMGn4-RwzQkeEWekWLmh1ClBBwVCIxjgckU700xgAahAYPlNABRLD8Ii9XmYdRQXY2GjGbDuz1wSLEKAAfV0jkozmMzMj2UUoc53N5EH5QpFYo51Np9KQBA0ixg7JAcIRGGwOBR4sldAIDE5Yw0_2AcS4AAlvABZAAyztg_oIAEFUDGNEp-HZSR3u_3BzBh2OJwBhPU7IhTmcdgCSK7wse3_G82AIs5E84HQ4bB9jp6wBGPF54V8Xy_Hh40u65POfe7vSdp34H80xfBwNAEWhpHgCZqHA74oJge1HRbc8Oy-OgYG8SCYHA3c3xvGhAM8eR0GnGAAAUNF2TRxHgThWS4MAaKILgPAAAQtBQYGtDRjFUB0nQ0Dw6k4ZtYzbLh1HIAUuCYljKDYjxmigfwuSLCAsFE2Jx2oLJMjodAADlKHESBTnEaguFcLgAAozFgMosh-UVSS4Gw4DgNNnM00UAEobNYLh2xECAwHs0zzIzacplQYVNCISk4O4Vw0q4AByZpVRoXiMsC0KrFQR0uCi8KYqs1AHIkWB3OALg8TKTzvJ5eT_LEkQmJgFkYCuCK7LKizYuoBKNCSry4q4ABCdKMswVAHXQfKQo7HhBoquKcEggBHEsskoxLkriuz_JrKIqsUMajus1xgsKqw-vsy7xpSmzZuy3RaCWgrVoe4r8lKszyss47HLwkKGtBAYPNgtM2o6h75N-1l2o7VlGI6zhlWYxZx0q7ZKAgpCuHsQilwbEn_jQSZmQgAAvYbUE4fkDMQiibKemjLvoxUVpEaMvzKMmPwnY8Ea4eQ6QbIXez7FRVHfBsOpRoK-Z4Fn_kPFExgIKkCFSrh0EochFmHE1IIoxWaDsjxdQIHYmZAVGRC1nozL1-LaEfVdDQp2z5C5uiHTgHABdjHByLsHA9H1h8CExl2zLd3X9ZwLIchgYVKDQWgNGddQaEuWyPH4ZZKB0xPtfd1P09gE1FmcWMOY8MYc80CuOwD2jW2D4UpZoUP5EUDBVzwaB0Ds12dY952eCn6v4uocgoAzABrDmTtVlwMHWkHqDsjKqWWB2HBX8hV7y9yu-53uw40CPgJNM_V57OBmmd1kE-xkpesWMj2bALjcg-MSjTiuJcU4UBYDoC4NZGA6h6RcEglWLQkCoBY2MFwJIlBFgOF0IbQmugkglDQM0RomgYDM30v8P-kdeq2TstfIO8AygEVllbUcn5YykTodRbuPNAq3TVg4ahXAsAcyYT3eAJpDT8DQJoAA2pUAAulwfwEtA5SJDkSDhOBKBgDAC4AgAB1IoJRQhcAFOLDWWCJGaJ5jImgcjioaAUeUVR6jJEOJ0URY0-jDG2E7DAFohALFWN0jwLxvcfHkwHrXTOax_i2XEQAanYiAeQ2kQDiyidImJZt4k1l2BzJIXA0ktyycrBOdkLhJHHPZQRd0OywH-IJVCkkOZqjkf8NmtAUL5DQnZe66szgXDKIwK8q5RlwA4awI2JszY8gIBwqkSRdwTw8M8C4Hh_LgR4EUMoHgiBJH6WhDwaNZ5cBaYZCaN0Sb5G6UTCiMFblVWGdsNethEC_R4B4AArOgPQeg_nlHKAAdj0AANgAMyVDAHoQI0L-CBEqH8yFYBKiQpgDAMF5QACcYA_lgsqPwPFlQAAsegYCQrxfwcg5KQV_IFIEAUApyDQoFGCsA0LoXoAFOUcliLkXkRgHimA0Lyisv4DAcF5A8V4oFAISFehoUwAFFCv5_AMW0rlYEXF6B0BCoFDCmAYBBWBBgH8wIeg2WsshSSyoYLAjyvJeUQIfzBV6HQOS4V5AwDlD9dy04PK8UerlTAcl5A4XUsqKCwIYAwWwvQJUaF5A0V6DBZavFFrZhkutdC8lMrlXIshQKAF_hgV0rxZCwINLIUCvxeUQ1gh-CQrBWW2YyL4Wto8HsjyoJur9M8BoKAhzZT2wVEqc0mBFjkHKDgGAix_DkAbKqNS87uJWjUJoGRRBe2_QOek45LyUrnM6s7DsNi77HnXFkJSHN_pdnYb4wCt7NzHiGb9X0e9UBlAUX8yo7lANcBUX2yO_AyjvPVs_V-zQx1BKgZQKaZ6rDsl-r0vCv1aEUQueLTCxUcLYq2pQMyD8o7yD1HgGpXCgJ2DfUpC9Igr00ePHHB9JVha3ho3HD97zv2Mz_f4ADQGgPKLA8BcZ-4WPATjqwKDIjfQaDHQAYgMdUao-6RBWC9hsdJbHjwodEOjc9eGV0EdwsR0j4HhSUeo6LGTZ5GPq1Ede4CoFWq2UfZx4iNH3PKGAp-rTVzjYCa4Eo9ywmQNid-uByTgFjx-bkz8kmUBdMl24KmHkmnEZwjHTgBEv50yZmFKKbLD1CjFFKFwK15QuAACoQM4HKO5bGXxaailgT8TUqBmRcAqyUZLTRWi6eZZUerjXautcgaQzrLRaRQHISEggyNcMYTM9hCzNErOPwoxaOzX4EuFac5kdbhHM5beNNhvpmgUonXFm0gZkkcBXZgHdxi_k3uoDJBSPMPWCyICZD1Msktz5phwAAK3mF95AEpfbShAO2EAmBh7zXIMHDwyBOKbt4tu_iD325IA8NCnA_KSceDQyALkaAMceERNWIk-7yzfF-CiDHiOsh0mW4TjJdIV0Lbp7gIkaj_C0UdrOEAupx40559CbqDVFjjyuFWQX4Zyfi-9EoGAKO6Bo4YmQFuvPuoVtxugWAIlucAD152SpwH8xnSZ4DM7-NLi3fycDktt-T1k33KQ0j-wyAHzI2Tkm8voQwjjIDNAh1DuscPGwykR2gSAC1aB9hI_IPhtBgFxQx0WEs4unDoAAErdUoIIAA8qgUeugsuFmLJhkAD3pd6BovkfU9uly9Bw9zyWsv0EgG97mP3dIA-A-DyAFE_JI_R-oLH3K8PEemnkNATQ5e_hxVRJjynoJwSUO56aEEqBIeM8giCdQPsiDDk32Phv8Aew79gLuXKXNc_1_F_MBuK6ewKAxzf9XMBl46RGZf8g8G9MBADVRKpv95AQCepxc7ANAllpdnRpBIVGcXIMwudEA88G8cEnwIBzdvkkdKQudxdsBLpOQGxmRNcqBIDYxN8cCyCkonwADYxpxYwexbAW07BX988jkH8YAS95glhKppdUAB01cPBsBl5FhMAMcFEPBxDMAIwQQwRYBUR1cSCPBlFB8fth9_sb9WQjCgA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/html_anchors/all_types/src/index.ts",
        "description": "All types of html anchors (text, image and custom) in one model."
    },
    {
        "href": "examples/html_anchors/attributes_with_anchor/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1Delw8lD8SWVgsFgN8pRwEhDUZfx6cJRQAK60DbBgBGWdXASU8ps1HqmijOS6qvxwXEV5p6jncIcmt_dHJumqr3DkGhDyBNtJRR5IiUdCLWAhOAach5KHkYxoTC4AgPECsExfH5_cImRIpTgmFhQYQgAA0IAgcAAQmh-BokkgwPwoC4AL7kuEIjDYHAosggKg0OgEBgQIhjDT_YBxLgACW8AFkADIAUVgNhoAEFUI5KBolPw7KSZfLlWqYBqCNrdRoAMKLLKUIgGo0y74CWjSeATajGkTuw0wABqEBg-QlBD9PC-dBg3g0MBgUa4AEl44mAHKgpMy9MwLOYZPSJR-FO0Z2G_jJlOm1Xq4XWvB6zzydCBgAKGl2mnE8E4rK4YC7RC4HgAAnA5Ip3ppjKpQ_lNB46pwxRGuMAuOpyAAmUlbmDkADMXAHQ6do5AzSg_iIhp-WGXsVQxmMg8WOvE1G2lAcCcDXD2LW5qWoB_xoJMzIQAAXoaUyoJwgpZH-HowFwrhcAAFPIXaKJKoZwGU0oiLoNplMB9ZajqTb6pWK4iPIdLCuRipKioqggcK9GsgAlOhrAbjKr6Aeg6CAVw7xXNw-R4BAjhcIuEmUr0_TbFE2zYAQbrUMhkkYeglDkIslo4AGtCcTQmEeO8Hg8fRPDvDgWQ5DAOBjBMX7cBhHizPMSy0E-IiOc5sA4Ho_DkAA1s0XYfugtoLHq6GXnAfS0DFMBJIFDlqE52ShVQUBJd5BSyQFID2Upqh5S5YV6pgGgAEqCBADrJR4gTyI-FUysF-WuWA1AENIMFoSV5QACxddlVU1aFg00L4_BENASTtSAmo_My-5wLocD-C4PxgDNOHdvh8BuUxNA4AoigYLaslQOgmHvHZz48MJghifY8hcDAlH_DsSk9H0a0lGhtBYFp_o6f8v36YZxnCqZ_7mQDVkgPItmVfIc2uXeGjNGg62VCdeOXaJaDNOtACs009QxOBoKgmi1slp14b2cA3dReo4G2di8pplWObddDxY9z3yG9qCsvRnDCeDXCLK2AFgB-5CeWphpXJcpxQLAYnfjA6j0lwCbclo-tQArb5JJQiwOLoEm_roSQlFTjSaDAiGw8rqu0Ml2G4T2BFlDWrEWVavMaC2AswJ2Z1c3xrgCcRPAc6HF1ElH5PdCpa0lTNwmyZgaloTnANXGA5eATHuuNEUmAISIEA18HScEfgTd0HxmfndzlcWsjIWufnoPrag1A-wzQlvvrRlpRD6nuZM36UDXStD5aMqwP8WDsyHA-mUN_BoJoADalQALpcP4XD91z-DEFAucb2ALgEAA6kUJShFwO5Kp7y4IXB-R8n6CjsOfDQF9yi33vo_Lu29kbv0_rKGALRCD_0Ae9UIb53hFDQnoMG6kvhQVQNTJkms9QygPhhA-b5EEXTIbAK-19KqgLWow8BXcWEwFgew3BwlP611HoOJKW8X5_QBg8BiPDs4v1zqPHAax_j0K4AAakvPTHG8jB6KIBuTHY8MQGaO0d1bi8tUCYQuEkHUWEU5p20qgZC84wzrgwvwfIZ9_hmWDAuCMmF06iGeBcMojBay2jOBcKOrADJGRMs0WwUcqRJBTM9DwoTUQ8WTDwIoZQPBECSCGdxeotIgBlLxSqSF_guDgD6LygFvESBQoGL09T4JBJlDwcQUVbCIG6aIDwABOAA7BFcgoz0DlECDTI8MAjzkHKOgRZghKjkBphFYZ5QYDlEmhs_ggR0A7h3JUHchzRk0zAKJMAYBRnlFOeQFZ5Rhk0zbGAI8lQablBpgANnKKM8gegwAwAmrciaOydyBGGRNPQgR-AwB3MMyocKjyBF-aimmwLzl6DOb8pFE11nDMCEeUZlzhlgD0ImdA1yYCjLAGCyoozoVgGGfwUZMBNmHP4DTQIO4OXkEqMMtFE1RnnPhVS0SczDk03IL8jFpKTlfImsMmFbLjwLNEhNfFsz-BHn4DuGm_Kab-CPKSj5E1CX8AhZUPlQK9AcrADuco5Bhk7j0D8pFbYPC5K4CCTAUASn5E8BoKABSQCEAIPIQir44CiRNkeHAMBFj-HIMKDQzJ_DlCclOGAM4NAnyID6wZ-TLxFPaQ0jwlSZZz1aYHSRJAo55gLD7GGLj_jIJoM27MyUWb5C4N2zAGNO0omxjKGMLM8w4C7JQAgN1RIPWgM9Edg6YAy2jGmydCZXIzrnSreOQZNANMwjWttyF92BiiQbcKUUg59pbQAfnDquxxgkRB5PbgAQnvdmPiCYCCLA0KgKxVhhIJhBOoQCBta5GQ0Bbf4At7DEwba_AGq7BkyWgGhTCK7t0tv5pWFRdBmh_wEpUPiuHMzZgI4LMY8gT0gdED-zAvIM2mxcJhTCU9MCvuCVYQaWhMI1IkpWLgG8uDcbHpWPifGrDVywohqSWRSIwHE8WUs5YXT8Bk4MuTDg_Zxo0xaLTyVFMXG0CWXwZZjN0V03JtuWE7N6cM1ZzThHDQEB-HoZY8AL4eCVCbf6coMGtHKbfAAZOFpzcmXPWYrILDzXmfNwD8yAXwRUkqbQEB4a-0WeA6ffXp0QwkkmA3UgYOKnsDAH3E0rSTdcxJK03bQLQtXysOwwFVwweWQl-z0HoXt1GKudYoVSQwlUiu9fbQ4YUmhkr9bqpVih0h5BRATKZWbGhGOTY-vPVGy80KkRomBWuPxQtic3u1pb1Nqs9Z4MJ1BthkodAmzt4TZ22gHmPMlbcibzxECDMyRY8ArKFZ21wBbd4sBsLMY9yMd2QmbYEb68HzXL47ly2Dorp7we7fNh1xr6lzhLD7FjvTwnYDqCgOgzBBBGoE7zehBHPAFSGjwNOgnmFYtuYSwQTzEBvO0BS_5wLUBgu05yzgYnwOuAACoKjVD4sYZnCvKivcm8JoYlA9RZf4PTuKjP3Bk6K6zkoHO4pc_QEZ-L_Abp86S0L1L6XtdaF15L6XaF5cdCVyrl7uDwfCT8bXI7NDjdWGE0ZR0RBvCaUbMVCTYY5SRwBnHu0Dodg266WHuTRVTieTKB9-H2erCIaIirnpmkygAAMAtU_F6FsoAASYAlP_o09C_r7k6BWQJA0KwZ3mX_xN-AFrnX_5O-YG71XlX7IVd-JRzti9AVi-nnXbjyj-ZqOIbcg6PAQn09Ohj1DVPOPcfCSXwdg8zh4IXdrpJhHG_8MX8Pdf6gDGeusmi5_rH3-rBVMqYxp9B0s0NwErBfk7NehFJFOOt6PBDgBflelADepFMlAgcyEgVAZVJ9BgBAWLi0tQGmlJLXFSkTKgKgFTDKGgZAVFFzrAdQDgJJjLLxO_qgGSBSNSLSPSIyMyGyOSIxFFPwEkjgAAFbzCsHIAChDTCgMDSggCYB3TNzkAEQeDIDjiTgKB5pqCzhuKLgaAqEeCJrOo4A7geCz4gB3hoD6EUjci4BEjFogCYi_CjpkAeDKaShWGMTQhBaIg8hEh3z-DdgIRkgeDeZLoeF0hppi6hFPRSRIjPwkCmHGhyEmxKAwAKF0BKF9guGYwRH_T-DeYYCwB6FIAeAAB62aDyOANM9h2QigjhfwVhpRNMOAE0VRphrIbBlINIqAdIDIiATILIMA7IDhug6A1WJ8qAkAzQIhYh_IkC0hiAIAshaAkA5BtASo2u8gictAms8EKhnmwOSRTg6AjU_0lAggAA8qgA9LoEkvsRoIcR4DoVYXoF2PkIdDURaCpOVAMjkV4TbCAB0eSF0ZwX0QMbwSACiIKFMTMdQHMVIfQIsbIVQOKFhhoBcX8PBKiKoeYaCOCDPL8SiSCKgKIfYeBpQOoAlEQJaNieCTmCAPAAqHibACmEKLhPcY8Q4Q7F4azljNwYMUkZgOQH0Bmp5CoXSYKYeCKXBNQLyeKTwfSXYITLYFYSqNIL8vYVkD8JrByfSQ7AQCoMUb8d0OUkkdgHhGKMKMyKkVQKKXqNiQcfSRaBIDaXqIaHqAqLYIIJWLqUkf6viacX5MsHsSUSAPfoCWaVgMKYsJgCoalpJgAPr-mwCoiCmUhhZAnsHdG9H8lsisishAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/html_anchors/attributes_with_anchor/src/index.ts",
        "description": "Using anchors to display attribute data."
    },
    {
        "href": "examples/html_anchors/size_change_with_anchors/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1Delw8lD8SWVgsFgN8pRwEhDUZfx6cJRQAK60DbBgBGWdXASU8ps1HqmijOS6qvxwXEV5p6jncIcmt_dHJumqr3DkGhDyBNtJRR5IiUdCLWAhOAach5KHkYxoTC4AgPECsExfH5_cImRIpTgmFhQYQgAA0IAgcAAQmh-BokkgwPwoC4AL7kiBEfjNeDGcgQaGwfyCdA4OCqZpkEBUGh0AgMRji5pcLAkVBwPKEAh7YzGfL6nD5ADMOEoGmaxgATNVKsYlSFVBAYPkqYY8pUuB7LQAWLg-x7yfglLjoPIAWXKAHZSeUjQAJSMANXK5TjUYjAE5SfGAKwAYRNgSzRq4RuzOCLpdJOeTGYAgpbSZbPZ7SR6c03U-V643mx7Km2_eUYxnE_nLcPCxm_ZUcJOKsWAFohMIYiWsMkU6m0-mM5lsjlcnlwPkC8hCjQwEHqMUSqUy2j0RBMJUqtUajxanV6g3G03mq0bTtCUHSdF03Q8fs_V9f00UYQNg1DDwI2jWM0yNZNIzTcpk3jJMU2wxMsNjZMu0jTNszjfMp2zKspyrGtuwbJsWwHdtOzTHsWP7QcJxHMc8z4-jrTnWju2zZcQFCdFgOaDcOW3VA6QZRAmRZGB2RAOEEQwbAcBRe9qEfeVn05MYNH-YA4i4ONvDDAAZABRWAbBoOtUEcM0lCDfhSWs2yHOcq85XczyNDzRYskoIhvLsPyRG-ARaGkeAJmoeKeESoMYETMDzIIDLMnIOgYG8S8YEKgBJMqYBgAA5UEKusmr6saqqAqclyQo8vAzU8eR0GygAFDRdk0cR4E4VkuDAUaiC4DwAAE4DkRR3k0YxHWdTQPDqTgzLNSyuHUchG2OmByBLabZuihaQGaKB_C5AgfiwXbYlQXUZsWDzxGobZKAcS9sq4ewOqC1z_iDK5UEmZkIAALyDKZUE4GUsiBpKYC4VwuAACnkUbFAsp04DKKyRF0MKynBrq3J6ryfL2kRA0vGgabs-yVFUCG5WZ1kAEocdYLgKZ4L6RW2KIriPbGYDp_4bvmkpscJyhHUwdAQx86z0f-TluWx3G1eJia4BwKneo0HBBrsHADZ5ZmeBN8bSZwVm5Qt-RFAwPM8GgdACaJ134Athnrdt_h7dlgXmesiAwHxl2SdDy2zRtnyLfIcR1CFsXRC-hOpblhWrkufhs7UCrMlsYuuGoc8IHIABrb7fpRgG67VjWYC1sAfsr6hrJ4B2YFNDyoCb1vjeDlPzbTiPM4byeW6d0RR7FbJYFNQN-WyHG7vKd6RBH2XN5yMexjQWgNEc9QaEuXGPH4ZZKGPqwN6yC-cHIRZnDNA-Hgr6yg0O_Lg015YuFFsPUIxgriJxVlweWwUaBly4KgSgUNK7qFJDXf4iDdgVwkEkTus4cygwwCGSksxYBd0oNfTQSD74ohgRvZeU8D4_UwJAVAvc16n0NufbehC94kKfiAMhYCBE8iEZfehIC75ykfndDBvCpEy0EV_bev9_5aHERgggwooBQEoPkXuYDWRTTjp9OBiDFgDRBv3du_0SjQ0pA4ZksAtb_RgOoekXA2aYC0KcYxnAvpJEoIsDx3B0CA10EkEoaBlRREvGjagGN7G2yNknWeZsyiVVpigggoUrb9SySNMac8hauBFvnZOZt8DECgLzGgsibaUl6P0QBIAwFfX9pgOuRIWn6wQdLBeaD-mYFRiIIuQdKkNMmXQIW9S3ZDIVm07onSxEqOoDAY-1kvohN_n0WgdCJh_W4JQUZ2M1lFOsrAf4WAD4rNDg-fgaBNAAG1KgAF0uD-C4C882tzIamjAGAFwBAADqRRgxwMtGvB5XBtlAp_kZd5vCNCfPKH8gFqKQWeyuRC2wcYYAtEIKEP01jxZwPeEUbGegSGIK-PDVAyomTZzNNZJ5uMnlwNRSy2A3yflr22SQ_luS3aCpgNikVH0aV4Lrlo7GYAAGIKJEghWDwWaStDgS1pyqcBrH-LyrgABqO68g3ogDXvippwy2k7HkAfEhFqgHWv5tYvGFwkgeXxtU2put0n_C2vkfKB9-D5Hef8LKtBcrOnynjfOmUzgXDKIwDqeZU1wGGawWJv9QU8gIMMqkSRKqBw8M8C4HgBaFRHugMoHgiBJHjWGw6HhrKCzXnrGucA0rcFxpG6NmNsopT7SjJNMDxAt1sIgGBPAPA5kqDAPQlp-CWgAGzoEGvwb0RpLSnHKIES0gRAh6ECPwco1oYBgG7N6JkRocx6HPbGGA96938BgEWdAG6cyRgzBmco_BAi_rABmTA_B12VEveQQI3pl3ekjOQdAYAt16HIJUbsyHygbs_eUHM_AMz8A3XoI0_BIzoEA5GS0Pocw5ktABn9eh0AMb0OUMAm7SPgqNHoSMghIPkHKCho06Al1gB47u9AmHoM5g3ZhwIlQUNgECGASM3oczkAzN6Ldgg9DehTBuvjRo93lBgDRkTG6MykctGpo0t7DP-CfVp0DGY12VHIGB06j7z0CCNPhyDeh3OiY8HWrgIJMBQFbZ4DQUBG0gC_GTXUcB0AaEjDARYgmcDpf8MVGgGhmT-HKGKVavcq7WyoEQELrCG13WbWO_tHaRBdusqG_KP9YB0jzAsAB4iADEfmBtHxtfK2BXAi111gGy4MrN-A2BvkG9U_xJvNBKENOks3bCMNxi4cd1AcBFrW_lubmhS11Q23jDw9k6ArbwDW4V1LRvjeZVEKAidInamWAtjGK15ZgAAPLLHkMsA-O3-37dsADj7BBTvnY8LIX7d3fkPcOcDU56r7UKxag1TAX3_j6oIFjxqB9eH5C4ITzAF34sY6KaiWO1kvglRajgUamCLbbr9gHPG-PycwDpyIBnvCmcs4IDgTJ2VEyaH7XjPnBy4Gxuxog41GieS464MayqssD75sWKC-XwzKecmaDWxFN6CAa80dCbpOAESyxPPyQUMAAD6IpbxG-GyIdXZ9DVEAgFgKkk30BhiJ-I9I4LNB0GKmAz3mit5j0gFAG-3S0B-IIHjcoQtmj5aSNIEJMA0_VBqALKPpvzcyMKMUPAB9H0m_WKXseTRWgmtLDmGvZuz7sJbgfaXwtoEnzV9d1b63jvW3OEsbJeNluD6O5tkfzJFjYwuOgnXehNBCwteUfho2zGKsQfUkhVy7pRokL4M0rb8plOyiEHY2wNDz8aOHzuT3pZHPBNlLWBguFJK4AYJ5B_EEYJxz71BxRh_kih2B9wRjzy4RvQ-XQFwWgJ4V7lwRennz5x4FZGRzl1RwV2lh-Eb2Vz2QSmDQCXJTb0Ni10oALU9j1wVgNyIDdzQJIMbzrzFEt3EWt1HjtzPFgEd0vGvDHntHdx4DwMIBYO91939zoED2DzulDzAHDw8j2SEKYNEK91jxwHj0T3EWT3GjTwzyzxz2ZDzw6ELzARELILL1hUr1xmr2snMJYIbwpRsJbzsNIJYI72nn9R72TX7ymzwEOw2xvhwFHzv1xgnwH38KHxn2CLnwX0uFQGX1X3-QqE3y-m30hS7lyX30Tg8CPwIBPw0DP0Ogv1oCv0BhQJuQf2vyf2xhfxOV7m_0iQwC_x_3rmuXQUahgWAL21_iiggKgN0kQLgK4AQNgOQNv15zXgwJGx7TF1oCzWMT0Ark8LxhJ2xxgAAH58kecA1e8P5E48YABCNYxqIWS8AgP-VAB7BVGoxoz_NlRo3_dogAhfShRBXLRPP_aWD_Zoh4n_GBHtZ9YnZ0dYjYnAH49INlV0EYAE4gj4rbb_PQcEpoyE5oaQeQFJMeeEjQa40bPg9WBfYxOuHRNmf4SOGGQZanSGHnGBfIf2WhLnKkuUHnDOO2SfSvEWSoIWbncqdY1kqOMYeQaXXEntIlDI3GFwvvQ5ZkY5EGRXU3MLcYKGN43A0gxUjGYBf4L4hlFElowwBwOURhFxJoLQCYQAqwHtY1MoE6EsXGG0jQuaRMWIuAC7PvHgZ9HAH3VAYVZIsU2wULTKQ0rFHFAMg0kBT5S0H5GBRgzKYg8w60i6W086S6B06KJ0sfF0-dREz0_gLAH0i1P0gqLM7E2VUMksyM6M3ElHLGCbBU8ZOkpuSvNALKHbWsvw2ExbfvdYEpHrdBZ0GyTmYZHs8KMA6KWKfgSdN0tXSg5GaYLsosqcyOcmLM6RGAMoaPHkUMngDwsobvGpPYqwQ89kgI4fGIsfLvY8qIoIkIuIpfIgFfDQNfFIlcguOBdI2uXfLItow_aNAoooiyEopQzuCo-_S8R_D85_GU1_Wgd_XUv4_U7Ujo80w8qwbo1AUAvoxGAY7hMYkYwY3CiomMw89kF8iuHONc_GS86fa82I0GeIxIx83gXwm7E86IrkLAQ4rMkiqc-XUMuYwgqwZrPvHk2qPkyOd2SKPAcI7s8OGXKUrAmsxBcwihMKLgBsxwEMC6YGVs-U9svvHtcw4c4E0nQpSGYciKPo8cyclCkxU4C5Mocw0Mpcg8lC0eBytw2WLc-uCeKeXc3YnwmyiI1imi88sIqiwIzQM8u_RfBI-8pIgFDfF8hVd8_BaWPfb83I380_PKYohxUoqSa_ECzE8C1K2oqC-o2C-45UVoxCl4pK3tMHXo8ArCvGUY3hYYtqpAm_VAzfQSrysiquXc8K08m8uiu8h8oWEWYatitATiqc7ilC3irM_imBISqwES1qTAfkiSlaPGQy2SqsuBfiuuPxftb8__To4SpkmgFk_iiXZwCdRg6Y6ZBVC4CYZobgOxPKsqxY5Y-nF7f7QHZYUXb6hYqAJYzvXGfisGiG5uNeCWShEJKAK4LUxQikxBFfZoNAWGNlayaGzxWGvGH7V7SHIHEXF4vnQWYUzgTcSkGkJSXcVSfcDSckXeZuQRAAK3mFQEMllCfBACshAEwB9imX5EmjICWhWgUFKz8U2jAh2iQA8BNAnBwEtA8BIpAC5DQA8DnQpF0lwCJCqy0m-F-BYQlq0jsAsh1qATpGKmRsRD0g1X8H8DGlRjJA8D0EWADmtpAFZjtu_y9qgC1gdoNqaXVr8iFt8SUBgBFoj1Jh1sFr9vln8E9owFgFAUVpAAAD0isr0cAcwjbshFBMRTafas6cwcBvR871bWRabFJlI9x1JNI4BdB0Af80VUBIBmgcAubqBebjIGBBa0AeEJAYB7JKBdgKlaBB43bEAKiI6nB0AAAleWSgQQP7VAP2XQFXJAeejwUNH2vQUafIFwDOiO2gIgTpfK3WpOqAdWuu-mhupmpu8kFEGULunu7m_uuUQeytaKeQaATQP7P4FGVEZAJtUEcEJQ3WirEEVALmo2_E9QLrIgSGMBtSFwCO-AIPMEWASqEBXYHWverSSJaEGAMMBQHWjBpqSO88dbC5Kh5miOzAOh_LC5Ch-QRh9Sc-ukItH2xyaQDdI2rIH4bOIhiYiO97FQDO3W7oAgI27AYmTkOUZkaOqgNhs0MB4hq8CQNRs0IMM0MMWwfjOwcR-fCO8LKBle-YJYBhzOuqkADW7Ac8RYHHJAT5DwF4x3Sx2AVEZhykeRkAH5WuhSR-xm6h1kSJoAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/html_anchors/size_change_with_anchors/src/index.ts",
        "description": "Use two anchors to change a specific parameter of the model."
    },
    {
        "href": "examples/interactions/advanced/group/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1Delw8lD8SWVgsFgN8pRwEhDUZfx6cJRQAK60DbBgBGWdXASU8ps1HqmijOS6qvxwXEV5p6jncIcmt_dHJumqr3DkGhDyBNtJRR5IiUdCLWAhOAach5KHkYxoTC4AgPECsExfH5_cImRIpTgmFhQYQgAA0IAgcAAQmh-BokkgwPwoC4AL7kuEIjDYHAosggKg0OgEBixVAQIhjDT_YBxLiCdAAGUptFQmlJcu-Alo0ngE2oGpEWv4tAAahAYPkpQRDTwAKKmu0AOW83gAmgAFO22rgAWRNmggzOkdgwdPQShN_E4rK4YA0lCIXA8AAE4HJFO9NMZVBb8poPHVOBLrVxZSIAML8GwafgevpqivULK1tA2uVKWvNf2ofjNdVygASlHUGh7fYHIgAkkLa-RxNRI3YfTPaHOF6g7ahmmgYD7lY3mwRWzQfb7weJdbB5-P-xoffXdDAm6gW_w2w_KG2X2-P3KrzAN66BO97_jA14EAA8qgnjyLeBaoLG8aJsmIBphmMBZhoOZ5poOBgNqiwaPAOBtpo_DzlMqCFsWkqUNKZZcOo5AAMxcEhCZJh4zRQP4RAmj8WA0eKdEMQAVPKly5pamhxpxqHoQomFqNm0n5howkABSMLoKSFBglD5AAlDg0hKKaXCuExuEaEW1GoJpFxJKg5BcJpRmWawZZysYxgOMRAbytZlrWpqR7BVa9H_FZ_D5O-_zGmaebWpp5ZWM8FxlOglDkIsNg0Dg_YEHasD5QQVJJFO6CaR4GWoh5FxcIO3i-oqVZ3BcJUwGVPo8EUZQeEQSTmiFUUeHKrJGXZPC-f52owEFLhwPq9k8IKWSZHqVGWfKcUSHNAa6stVGpXKPDiOQADWtiIGdogeCx5QAJxgOUAAsYCVIE5DlDAABsADs_CBADH3oIEb0sRRgFgOgLEAExVG9T0AwD8OYHolTkOgegAKz8JUON6CxT0sYEuO4098P8OUuN_TAgQsQDLGVDAb24-QuMwEDYBc7MuPwzAtN6L9LF_egb1vQTVNgAD5SCDTLGPULpO45jYDw7j6BPZLgT8GALFveglQKpUejoPjehgIET0QwjasozAMBPf9VR_XomuI39kvi7TwPuyLgR6G9lTlO96DW096Dw7zT2VE9mOBAz5BBy7MB6P4AO4-U7swEz5Ae9rf162bLGc-zej61DMDZzAHi9VwIKYFAI35J4GhQANICEAQ8hwIgvlwJgiw_TgMCLP45DCrWvHlDg6ZKVhOBUEQ9d3f1qFDUdK3jSIk12T5fmJQtJQLWR65UVuO5qvKGBcPICa5pgVz_KfEWlpQegAFaAQQYWvv8c-FENxX13DtNU-QuCrnIpRagoC1SaTUtaKaYoZpHwCrQbYUQuDoC7PBLQuh0DynQEQiQ_8Nq4L7Pg8BlouCdiocBO87lpo4LwYwvCMAwAESAmuIMUAaGQP9Lw4MoZ0DhiXPwVKDgFj0S7gAYmqFw6oIR96HyuLOYBl9ty7hwAqaBF9qD4M0pQ7s7CNAoNWqEdB80sELRcBBahhDiGkL_kacK9jf7UKshA7Q4FPFmOYXKDxQFex3jHlw_xwj-HeNoUIwMIjCHiKjFIqgUBZGoTkUo6olQVEWL6ho2Bm5tFql0SQ_RmjDEBOCQQfBFi1HH1sY0EcmhHF3wVC_ch_w8DNLHGYgRTUelGLyU00c-DwncJqQGH4zJ-lxOmVAEMiSNARmScAaRaSNDyOyZULhuSWFAMKfAmApT0DlMKUY7poyzF1LcQAhw1ZyKPhvjEyBVYax1gbM-I8J4CCBNuRtHY11uBWRMWMhU9Dmg_mPO-GgmlTjvKeTAG5a1wqUGWPIZYToHlwHKDtAA2h4aQRQYAACUWiEHrqhIlmBFScL_mSVCvgnYEFpesSlHgmW2DJa0elABdFhaLe6YuxXPMA9E7QUTwJpTSqAPKuC8mlUQ61_iCoxdFTax1qB3R4IVWwkF0XLAqlimwMqjLaq4PhRE0rKByq8gAQkoPhei_ECCkRcksTAcAaogBdfEqAHgjLDJRXcsRdh-lnI3BImqIgrBrJMWUY8iw9ybQggmjQSbSQjM0GmpN7EG48EGkkAA4gmRY8hyi7ysEGnBUYcAmMgj8a--LKiZpbVwSo_K7qquWHanAqBQQwF7aG_gOAMXpmMVGat3aCC9v7ZgXtZbQ0wFNJoFafyeCqMscqrg07jXwHhvijwVIKKXXZSAYcPwABe1A7BQG8LsM9F6IDXpoMyKklACA7FXiATtIhd3Yvhk6jQErHDStlZ5byMbpF3OnTtJaO8oM6qKvqoV5Ukh7tNeay1GBrW2q4A6oDLq3XkA9fAb1vr5kBurdu4d4aCmRuSeauNXYc3JuqaxzNlzs3bHTQtdk5rC0lrRfIeGlbRDVuHXWrsDaWhoGba21tv6rDTtnQOodtax1SuHVOg1M6-1qZwIugMK7nAnWGZuzpO7dNwa2lqqDuqoK6aNQ871ShKD0QDXdbD1VNI2ogwRsVGgiNoBI4sT15Gpl8KoywmjUY6NrgqagKNzG-wcZTb_NLXHNk8dzZungkn62Nrk1ZPFbaytKas6h1T8660acWOO7TArdPVcHYZ-QS6TNruRc45UWQ6CaE0g6Z0rpPR2hwFOF0doSUAEEKzeCnJBJ0OAlAzaLQAfWdEoTNmkkUQcVcG-YsAcBpOaDt8z3Xt1jG_N8mFBBcUvK4B6L8NAoU_M0qVzN_hNaKczVUYZ27AV0Hu6whhoS8Lgq7K927mkrsvZu22coF3wqw4IFDtsB6HtPeuwAt7eLvtcC-7jH7FQ237flFgSkZRmIsXwpxU0zIk1erK79oyDddA8RgGUfwQi8A4A9FOUIXBRN73--FQHqAMcg9MWDjQJyIVo9hSjhXBB4ZI7uUr-HNA2KY-e6jzXvy8WE8-_jjtv3Sd3X4BT_uTFAI0-QkQenSwyPM4qKzi325YBlB53zgXflhcbtF3c8X2updgpIfL_XMPdfK5YhYyafyyQUmpLSekjJmRsnJPIE9E4cBf3mKgfkgpVQikQCAWUIBMCKG5C5C0qJkCpgXpmFS2E1IFiQA9HAiNO9rzQo35So4cIyVlwRE0RESIHI3B4W6IAadd9EyAfjPqYVT48IiHkRIe-Yl-CiKf5esh0npdPrP0JwLqKRPgYg_D_D-F2HQHvehFjQHQCvkAx-p78If0_s_6_L8eEX5gVQJQGAKvTAGveAXfDwN_cCfwB_DAWADSdvEAAAPTnnKEA1xh72yEUC3z-BfyQNxhwDehwAwIX1ZET0pBpF7FT0QCZBZBgHZBADgEIQMFwEFEgGaFz3z0LxvWFAYHLzQEgHFFoEVHc3kA9ATFoEKSn0TT3A8CcHQBJXAkoEEGggrDkG3DriQBkI1BADUhfz0ATHyBcAQJ0NoElD6FoBfygP9QX3IOTyoIZBoPT3oPJBRDYJaE4OoG4KFHoFL3LxXnkGgE0Egj-Cojr3LybnBE0OnxXhBFQDzx72IhBHUCbCIDKjr1oJcB0PgF9FBCiP0QfS0N4x0PmCIinn9HkCn0yNkIr0Aj6FrEnzTzoJ0MwBIzpBNCogqKqOcNMLpCKhfztGkD-k32PAgHnGkOKI8EFRUAQOn26HpWyKwEUB-DKmZCAKoAaPojr20I8G6gkHWPohNHol9FsAVjsAmIzUGjyNgEUMO2WCohfznU0MX2wFC0wCnwJRACeLW0iNgFRBaJVA8F5TIPJAoJT0cOqNZChKAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/interactions/advanced/group/src/index.ts",
        "description": "Group several objects together for an interaction."
    },
    {
        "href": "examples/interactions/advanced/hover_and_drag/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1Delw8lD8SWVgsFgN8pRwEhDUZfx6cJRQAK60DbBgBGWdXASU8ps1HqmijOS6qvxwXEV5p6jncIcmt_dHJumqr3DkGhDyBNtJRR5IiUdCLWAhOAach5KHkYxoTC4AgPECsExfH5_cImRIpTgmFhQYQgAA0IAgcAAQmh-BokkgwPwoC4AL7kuEIjDYHAosggKg0OgEBgQIhjDT_YBxBwaAS0aTwCbUUky77ymAANQgMHyEoIqpEAFl-LQfszpHYMHT0EpTfxOKyuGANJQiFwPAABOByRTvTTGVQ6_KaDx1Thi_VcaUiJQafjNE2oBOaQ08ACSQvj5HE1DtdjTXEzZv4OamqAAoqhmmgYIWABKUdQaJMpjSFgAKlDQBAAwtQsvGe47na73V6fQoYP6NIHg5ocGB5Ys5XAcD3NKXc6gw7Ed_uABQXJKochcA8ASi4rlY0ZlxmMso1XHsQd1-rVA_-b71lEl15ffJ-AkJ9TS1YN9QPGMrGeC4ynQShyEWGwaBwZpbArWAUIIKkknTdADw8WDUSvC4uHrbwjQAGV7M4LkwmBsMLHgijKDwiCSbV3z_AgPBlVkL3DEQH1A2gX0yJVy0_VAsgkuBlW4VxAOA_51TAxV5PLKCZR4cRyAAa1sRAdNEDwAGZygATjAcoABYwEqQJyHKGAADYAHZ-ECdz7PQQJbLM0sYHIMB0DMgAmKpbMs9z3PCzA9Eqch0D0ABWfhKhSvQzMsszAlS1LLPC_hylS1yYECMz3LMyoYFs1LyFSmBPLAJrZlS8KYFKvQXLM1z0Fs2yMqKsB3PKQQSrMiyuty1LErAcLUvQSzBsCfgwDM2z0EqQRtr0dB0r0MBAks_yIrmmKYBgSy3KqVy9EWyLXMG_rSq8-6esCPRbMqco7PQY7LPQcLWssypLMSwIKvIL6bpgPR_Hc1LynumAqvIB7ltctbKmyxr6r0dbApgZGYA8ZiuBBTAoC4_JPA0KA2JAQgCHkOBEAfOBMEWZycBgRZ_HIYV4ygfxyhwSc_TUBcqCIcmTNYj0QA4jSFL4kQBKE-9HxcAhFnkLh0HjZpKd0NsuEKEouDGHsHC_IcaGk2SbZofsZIIB3_iU1BdS4LsezdwdgJoA8AG1KlJLh_EWyPKgAXUjxbBKd_4jYTVt0K0b3fbjdOzczy8teEnXbH1q4sy3ctTeTTOXwwF9NOabg05Noh89DERBVkjds23Ksax9gCffyIsK7Lah-9rA8f31ZORB7yuJ-rWscF24tN3H1AM80A8W-3jQ554Pf240Vf0FtY3A494OCAPF2-3tm-55Txom00feh99xtm33wuZQXzek8fZn3QOvXu5Zf54Dfi2E-h9X4_xPnzMAS4cwmjNBAZkn8R5oM0BgqAlpdDoBtPmfgf99w8BEmpMSADtyG3tM6P82w6ToX-KgUEMA67oBfOfQ2xs66OD_C_Gh5YSFYNHiWTeJCoK8ITGUD2iw6zwM0HIjQCiuCa3_mPbcJCcAtwAIKnigc4HA8hFg-m0iIHgYwJjbjKOHWOsc478Wfp3L8htKB_gAPLLFMV7OSatLFcDQrYbxrNli4QAHL8BsIREASgPEaA8BeEyi5EQHgPJQK8N4uCUBwG3dBmCACErglKLG5JAH26ALyFKEkfBJoTfE4DYZgQpuj7QmLMXgA8wi8z2jgQhLxPjlhNPYa0_WRDaCak0ApMhAkyFkgpNSWk9JGTMjZOSeQpZ9IphwAAK3mKgfkgpaD0EQCAaUIBMCKG5KeHUqJkATl9NOaWs4fyhiQOZHAkUvnyxAN6J5M45y6gXEuU0K54Dri0VJD5IAzJfPFuFDw7J2LBw8MZCk3JcBEl-ZiX4KI0UXKyHSXiMLNnQhgFAcuSJ8DEEpf4fwuw6C_L0IsaA6A0UeDJULSlLK2VUp5NikAyLLkwFUEoGA1zMC3PgASzldJuX-BZRgWAiSYUAD1xblHCjgVKvzsiKFxX8DlIA1WpRwLZHVSLWQLMpDSZMKzEBMhZDAdkIA4CEIMLgQUkBmh7IOUc6gJyRRnIuWgCpEgYBUQ8fIDsrpaCbzRfIusHgnDoAAEoUsoIITxqBexyGrGTJASbVQgB_MavQrp8guFVSW2g4o-i0GNVyilSKbVLPtQyR1ayXXkhRN6lofrqABqFKc85RE3TyGgJoTxfxyz3IuVTcEhb0WyxBKgfZvy5QgnUP2Ig2F7lOpcCW-ARpQRLrAbsRNqjk1usoCuIWJp5BosPTezA5A-jxm3M-7tJa30ftNBAhQ37nW1uYbYY1FZpCuRxR7CAOYr0KJLXeggKhVXou6CS49WBFA_GwsycVVBP1_nucWjwjEJAEb_KaP8RpbATTsAhm9i7YAZvmEsL9MLmmFuFdgd9ixMBotDh4LjAB9ZjMqyQeAwx4OO1ryS2uWZ2l9rIVNAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/interactions/advanced/hover_and_drag/src/index.ts",
        "description": "Hover and drag objects."
    },
    {
        "href": "examples/interactions/advanced/hover_and_select/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1Delw8lD8SWVgsFgN8pRwEhDUZfx6cJRQAK60DbBgBGWdXASU8ps1HqmijOS6qvxwXEV5p6jncIcmt_dHJumqr3DkGhDyBNtJRR5IiUdCLWAhOAach5KHkYxoTC4AgPECsExfH5_cImRIpTgmFhQYQgAA0IAgcAAQmh-BokkgwPwoC4AL7kuEIjDYHAosggKg0OgEBixVAQIhjDT_YBxLiCdAAGUptFQmlJcu-Alo0ngE2oGpEWv4tAAahAYPkpQRDTwAKKmu0AOW83gAmgAFO22rgASW8GhgMCdoJgPoAsibNBBmdI7Bg6eglCb-JxWVwwBpKEQuB4AAJwOSKd6aYyqC35TQeOqcCXWriykS-oUafjkcTUZN2H3N2it9tTVB21DNNBhuW62DtyOofjNdVy32TmDtu3qGg9gASlHUGjXwp9293M7nVdQ6cz2dzIALRZgJY0ZYrmhwYG1i0DcBwaD7bY7qGrMUAAoLiSVByC4ICAEouFcVgGzlYxjAcQMo3lLhy0ta1NWoLIMIretXHlfJ-AkFDtRgc0sMoaUgMbKxnguMp0EochFhsGgcHnAg7VgDiCCpJJfXQICPEY1EYIuLhN28cNFQAYTOC5eJgfifR4Ioyg8Igkioq0aIIDw5VZKCaxEJDyLQ-wXDgfUAKNXD_hsuzYOI0j_mNHU9UHOi5R4cRyAAa1sRA_NEDwAGZygATjAcoABYwEqQJyHKGAADYAHZ-ECTLEvQQJ4oitsVzAdAIoAJiqeLosyzKKswPRKnIdA9AAVn4SpWr0CLooiwI2ra6KKv4co2vSmBAgizKIsqGB4ra8g2pgbKwGW2Y2oqmAxr0NKIvS9B4vizrhrATLykEUaIqi7a-rapqwAqtr0Gio7An4MAIvi9BKgVSo9HQDq9DAQJosKyr7tqoNooyqp0r0J6qvSo6DrGnL4d2wI9HiypygS9AQei9AKrW6LKmiprAkm8gsZhmA9H8TK2vKeGYGm8gEZe9L3v-iKloWvQPuKmBmZgDx1K4EFMCgPTPA0KAtJAQgCHkOBECQuBMEWVKcBgRZ_HIYVWygfxyhwQsFHvNQXyoIhxbCzTrx03VbMHIyRBMszEOQmB13-KAVToTQMxo7Q7UVO15O8AB9AB5J05QVZUsiDjQgIdZ1XU9O0cF9F07QAJQAQSj3145waRw8jmP49JSCYBguCEJEHhBXmWAcCgShmlEkBK4jqO44TkBTLCtv_lQUNXKAxglxgKceL91gG5wSfMDMhjcIWGBO-7oC14bjfRHHrhKGWeRllc5zBxwM-VeWOAAG0D9X_gbAAXSP1ut47rue7vi-BBR4e2Ad7LgvthRcADinNUWgwCh03LHR0Bch6J3QEqQOsD06OhdO6L0ud87F1LuXRByCh51yAg3WC8F6LHx_jvP-vdSGF1QSPL-DhHJcAPtPWeR5ND7hoMvKCq9QxP0qJ_Me9Dd49wPsAzeqA8IAMvkRa-1Bb7nwfs_UMr8P7sLbtvaRQElFAKPp7MUPALKeRgNsKIVwWx_kHMOUcap5QYC4PILM5ZMBXH-CUaxmF9LSlPnoAAViuQyDkFH_B_JoBx1AnFjlcmqfIfp7EDniSOMcQEAnWlAeZZCVibHWJcAvQcJ55xaF0OgeU6CfE4SiZkee4SZwVKSZabQTTpy6FPGnORdjfzpKHJktUOAFS9liYM8pmggIlOaboCpfTZldJHC-GAYA3xdL7DGKAbSUmRi2bGeM6BExdn4HRDhXcNCKwAMTrOqNUEIZj7IWIKahWgRTGg7k0FMypbiFR1MiXhPAXyNA_N2dJEFPzoJHxif2f8CSRljLSf-KFwLjzdIWUfNF3yMWrPWXMg5OyiLJK4Ps6MhyqknJTOcqglybnVDuZUR5eSXnylds0bg4y4WDlOdsSg8ooA7OMXAOuVSuCBn8BcCYHLT7gWsX4pIXBuJcEWPIY5tB0ByngVoICsB_j8rQI012ajhUwVod_Bpxir7eRNRolEj9KASOeaICyfiVVqqjIpQVgsgpXEuKcQV94uD5CiGqXcHyrWUndeq-8YVjE4FVTGr1UAfWBWnskkMmAAD8ZR_SBmDKGOuCx0CZpgDmv0AYgylsbjQsKGkwCQQAIQZtDDBQMBAPyoHYTwFtmAcDqv4DgC-hZ97tK5XE1ApzzlLI2NsDQiwwyfN3GUAg87rEmT6VYXtO9E1RlNJoOy0Kwqsi9i3UIyFKwOGZDssiRBdCLGvYq6ghs7EfL0DAZx4oRx8vlPIXoiq3WOHmfAONdqE0etoMm1NRiwOyNMWmKCR7UBkgpNSWk9JGTMjZOSeQbZAqnhwCE-YyHkACmoKqEUiAQCyhAJgRQ3JwIWlRMgfMFtizW0fAEqsSBIo4Cqnx-2N42NW13E-S0L43wmg_PAb8yK3Y8ZABFPjZsKoeHZNpUiAEFOIh5ESQTmJfgog8CxkAWQ6SGQU7h6E887FInwMQHZ_h_C7DoIJvQixoCass3SQ2Oz3Oeds7phzamNS0d9koGA9HMCMZA2QDwVnfP-HcxgWAGhjMeAAHpm3KBVHAbVBPZEUAZv46WQAZbajgeKeW1OshQ5SGks4MOICZCyGA7JTNVIMLgQUkBmiEeI_yQUFGGA0bQJAcUtBFSUF2B6LMtBBnGdXQu0LTh0AF3npQQQsdUDyTkCsxba7QsBNK3oLM-QXBpbJB4Wgko-i0FKwl-eam6tocawyZrWG2vkhRD1lo_XqCDfI8KEbYlszyGgJoWOfxBzMZo1LcEYsFO2xBKgIjgnAwgnUPJbM_FmMtZcKF-A4ZQQI65bsA7y2PDzA_IbSM8hjP4_HGF8gfRWz_gZ590LmAWd0hNGUhQHPWuhbsBobipW7TSHSvp1dEB2wU6Z3fFQl3Qq0ZVIJ7Aigfj8WZBFqgbOaLMaW0z1SEhdc0RNDRcMthLp2Hl6F-HsB1vt2WPJlXB8QseGwCzxYmBjOPw8AfaODvYtc7VyAd-tXyT1fQ-9xnrJ49AA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/interactions/advanced/hover_and_select/src/index.ts",
        "description": "Hover and select objects."
    },
    {
        "href": "examples/interactions/advanced/selection_by_naming/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPAIQAiA8gMIAqAmgAoBRAASESAPgA6qRmKjDyUAIZw4AXkkh0SgE4BrTVNTDhsmEvRGTJxgQgFY4gMp4lABxisIANxg7GAPR2DjBW1oxQaAbG1iY6MFAaIHAEAJ6wcHgwMASa0rEmePFgSYQEbnCIAQEArqhuegDmOFREAWBQlADuAEb2MAACAIw4ACw4AOwB6BAp7Z29_ThEaC2qeTEmAWGBWRZG-aY9lOipYTYz3oexKekwSdcFXRDoBHiIwkMADF8ApADcj1iWQgjUIH2-f0BmwKMzgbmUqQ-HWw0IK1jclDg9gg1A-Sh6cEoUBqtDR6OEsDABA-UKB1gIlDctIB9I2sXO4XISlQ3hUwheSW5vJUhkCwr5cE5gUu0rg5B0EDcBGEaQ8SSIJxqsE0wjgOnISRwAX15ACaEwuAIcDFJoVSoIcvtyr1BtKBHKlWqdQazVa826fVowzGk2mswIAcWtBwACsbSBxIF5YrlTsAsdTkZdsQoEYQAAaECzABCaF0qSQYCUUDgMAAvkXTeaMNgcNayCAqDQ6AQGBAiJidCrgIcFeZaAA1CAwLpDggFsfxJS0JzwbHURcxACS3HiMAAcicYFuTABZFd-CA1gCqqEiBFYK6Up-E3hnc8ow7gr_ldBge7ZK-27TrO84AIJuBAwFrqouKoJB0GHAAYgAMuBADiAD6fBCNI9bCGAOiUEQwiaAMmTuDAlx-AE76zn4mjQgO87CKOMQABKUL4OgXqgSiNH4wE9joSjkHY1BPgQL6HNuIliRJqCCKgjRoCehxrrA4l8QJjGoARREkWRIAUa4Hg0TodEfn4OBgBONTxHAOBoLQonifBTHSCxX4jgoy60DeEDCAZxGkeRlHmT4tH0V0NmUfE6A4JgmoALRZFAHg6J5qDSHQNSkWe4HbgeWFOIIqGCDw27sCV7D8Nw1UHk4bEoah7DsAASsIajGR0lBfpor4AOrgahqHdcZXQ1lAg2yQerAgdurA3qNE2aBaPgvDUNYbPW0jSLAKoxfOHwgR-EFQdCh16uu8GnbBG4IZdB05AK8nudQymqagMCne9ilfWpV2vXWWkEDpgk6B8mkwNpPK6TowMqng3F-BDfgfFxPHo4j-2oAEABUBP5ATwgdfAORwMI01va5CnwcIPSpMI8Sau-KmqlktN-PT1DCNo0mEaF1NQPIqDHlTaCczAerkP-1MYPzFNg2gjTCJQPSxrD1o4CTATSN2KQsxTBByXTH3GD1AAUACU3XiC1MSg9rONJcr2u2-Sf4_YBMA4MRlAEO2ok8XWVtW6gdtqA77GxKgSXPrZX6CGJeDh-gUcx_SEBgMIVvoG9KQ8nLlC52bPMW1JSh27HFLx6zqNV_nNvkui8c1G4AswJOfiPZ79J7TC9Yt4cw_QvW0LSITxPGKTnD-TLbwy87FvCDe26cyuApU3CCJKKk1Hq8YS-UjA1J6i8Mul9Lsv7vHJMk8Icmc7Ma8byfNR1joCg8jdYPCF0PAEByB4AARaboVNGR_21m9VUXRKB6loBURAj8UrCGQhAHQKQCw30_n4aB4lJa5xPivRSeoUbagLmZDwxhMqEU6F-HBdCpqi3Vt_Da750DbVFqkXWs9hBoLXN2dAODMA0JmBzPmJ8mRkNIYfKWJ9IBYJVCkGAbgcEwHsFkb-NM-pfipgEAB00qa6BlsuU4qoEE9BliArEdAcFflgSfbkdZjIcK2jtEARiqa2LrKgHBNMNZa0IQAvwMsazmOZkQCwy8EjawJLAPhwgZ7JOEKwNRdAJFqz5oAreH8v4EOtE4rIrignax_DfcWmAqbPDeDfKgOhHKYgwKrYQ_EVgc3lFkIg4T4g3V0CAw-YBHFVPgAA7Ri8ubtOXtJb8YC6maCGuAroWFdSAOAaA0x0tjDRMwIUhJfsH78IGG4XQShSI1AgF4K4xzTmiVIqMm0s99aoENiqccl4YYW0ChNK2hxLnXMxtwM8qFrmCFgD0mgr5HkfGAPQ_qUMn6-yPJgAA2gAXX-EY0Wp1kXHgxVi54GBui4v3CimAGLgrSEzo7Ew6zYB5wBT4WymCUicCAVADOwgmXeH9jANmMB2XQHQFbHlLLlFCs5SPHKMQxWKBUHAVCEYcB8hJDLDQMJNBUEwClNw8QYos0oHUTA6AUpYHkD0RoKVGiiRmL2FKjIUrf0tSldZtBGZfkwM6z1fhrWiVSClAAnD8fmug9CIGODoL1fr94pQmCGtwKUABMeoiCIETQANlDfoCNVqbWxoAKw_Gyocae1xSaFWKsIMqFUqo1XLS8sc1AjbRLQF8ggqECQJAmugSg5B8q9haAvcF_Lex_JAMoaxM0QDSpMK21A7bO1TucqgH6OhuDYBVBq2ImgRjVrieJAUudUhGqMTQSxCgUZ2LAcSroVM6F6J0Dglh8hHHuK4dNJE2U51KDbQejtXaoAtGUKoJVKQVU1hqOqx4mgeidHIHoYQRACDJtVJulKcBSLDJoClHpMx8poawCh_NAbg1fGzeG2gRGY0BoAMzFpAOSMV7hxGSpFfOxdgHpWlsMR891J952FIZugYindugypMG8pDv6F3_p7X2gdNAh0ThgCOyFBBx2kM0LO6Tf6wbAYVWBoOqqoPdRgyALoKUwDankEQHoqHkOocVGCFDBbCPEf9Slej5GXUkbjSGlGPFc00ZSgADhDcM_tlRFQqRSqMQiCnKhGocGpFK4sfoJai4gGLebPPeYSzhvDEACPEWNdRFKUA1ZUZQ5h4QbgsApSGHVgNXwcBueqylOWIk3qRB-lZ2AWABS0CIHATrvZ8HaBzb5zzGaQ2TfDYFjG03Y3xvI_NxAkXP7ZdViF8LXxv3cqucyljmS2NWw4_-7jMRqjU3QAXX-_LlTMxkQzPJXMi7DibagFtMn2DKngoIQcaR5P9vU8py8amx2aBe9QbT5J51_YBkD3hcIDkFx6gQHQUH4e_f-59ZHOA5Ho9VFjmAOO0CI4BwT24iTd6IjWiAdLMADsI7x0pAn8rQPKpM9BzVIA4N9sQ_VuLzXUOLahstgNkIKOIHF8Fvzs21thtl6jKGHW_PeZZzJ9tOATsYDO6zpHT2rtbEMUvYwkBWH2HmaAk-eUCpFRKjWyqDUapYTqq7pqhxhnfyttdIKPUvhYqCowYQ7BNbawg2quAVtK1O_Ki7xq7v6qNScDbHAsAVJvGDwAahzzXR4UmYeW35gpsHfHVMQqhyAYvcPHjF6j6ZnqQUc_GQOyYBvaA10cWBeNHq4fgnGcg_AWPjvSoJ7rbVFPNU0-oogJi-vbODNc_AzzszMITCwfg0Lhr8W3ABpTXLyXjW5vK6P7l2NiuZdy_V3lhjrddOyf03r9AZ3i86cHocC7-nqAgJ5IJX5GlWuU3Y2OsFUGmFyCuRSR4RyHIcuNyRSfuCTawKTb_bWSnPmfvCPcSRvEfOPcfWtT3ZPT3WfekHPNAnAnnR4BfZAkwHOPOCgggDAy2NQHqfA53SfYg1PHAYqBaScJaFaVCAvDfBLX3f3CaIPAUUwNpCWHAIlXtLoDPOgRobPAUPPYQikGQ6pOQ5ZOfdFXXO7JuekOOWcJ-f6eCJuOFUhD4THKDHBOXEnUzYeYw4QHTNuWQ-Q7oPQnADuLuHuLBeCJA9EQeWIAiBIVxeg87bXf9Zg7qVg4QdgifIgj3bgtCdqDqDQgoH3POcQwPYPaQx5WyBhHQJQrPPAXPfPWlOuWQx9bwiwdAIwkQkwroMw82RSSwwpGw0new1XLopwm2FwtwgoQo2o-fHwzuS8fwvuIYkwEI6wMI2sGWSIxg2I1gtgsfDg5I6fJqHAEaMaTI2IG7eEWGa8eQFxX6UJUQJQXwC9G1I1NwSpCWamSBd7LrRefcUQGcUSA0PAZmXteAVAAAchVEgBVCNW_jwR_lcQmXpBuxPiAR5h-OZlfh6EuSgBVFqVt1eO6RlmQmKKwgAA1djposJeBdjlksIAAtWEwxdZEBABI1TlUA7UFUBRLmF9YQOJdTKmaxVpOsO5S8AuJmG-R9IhS4yEk-PVGAd8I1ExNwPVSgVOGkvUBBKBVoPoDLGmR5dWXOJQbFKAZ9GWVwG4qBO4juEWMWJ4zEm-OAc5GWaZPGdEG7WKRBL8cJVhbUt4LeLZKRd7O0_U2BX-XQf1eka6F9DCUrZBNiYQVFPQGAJERBHLdFUlbIclSlAiHqYACeekQol9JOHQFOEBcOLoTOFw8MyMuAVFRQ6ZdFFwkwAAfn1IjPuMrOrLtP0LcE_jThLLrOEA-CtnLJbKrJwBrImirPRQGJEJNwKDhKyAt0cXMHpLNIeKtjZNfnOI0VTn1JtkNOpnlKgGZhPkgIQOE2fBtxvk0GXO3HQF1F5I5hPkHI7mVK1KtK0RtP9MvMjOvN1C2VcAwFgHuypmoCWOPi5mPN5m-3pGyL91ekfIeKljgrgAOKyMcRgtZIkPyND0QqrOmmbI7n0MzxUPKLUMqOAIpGwrgvRTqMMOfD-SaOGNMPgIgo6OsMcJPFEF6LYuCmfVwsjMnM0JMBmKeF4qHMou8N8MmN7kCKEtmIHkeDmOzP0knlQCthUFSFeTziAMOGOh8gmiUCmmtwr1Ak_GHCtjIpeA-E0CIFSGMvnFmhhAlBUA-EYB7xBU4B5ElEhxoHEF7VB0HUEgIC8oIBLFSGvPHUcoTH4uCh0zrDgkwOpgMveQXgekCPMvQEspAGspSth0LEeDsAQxyBQREM0EDR6ALVowLUDSGFGC-BgFo1ox6CUAzQmDAFo2qtCwmG-BgEDSTUDXIB6G5FC0wB6B6D6omFGCTQmAmFoyTSGALXQFCzllGAzSTVGHQAmCUHMCUB6tCyUDAALXCyGAzRmqTXmo2p6AmBgGOvIAzVGCUCGCTRWvQC-BmomALVGCGB6C-CTTAFCyGGyDmrWvIE6tGALQLSTT-oLSmsWshq-qGGqp-G-FC0DQzTAHQCLXMCTRmratC1m0DTACmqGDAEDRgGmrEjAC-D6tJtGFhlGCqoOsDRJrKvBuWrurskDQmB-pgCJpWqTTlhSgLXuvmo-tCzACTSUFo26o5usVo3IChozSGAmHIF2sDTEnIHstiE1EwCgGMpvB0CgAyrKGQWqDgBE0upqHIBGBgBqDGxoFEigEa0JzMmoiihKNaHZGiuUpAO7DsFQBqFlIPONlbG_igWmm6FEMZhyFcn5kwRgXAotieRMB0uHAMPQDxIEitjQkwhwgEEEBwE4BqgagPBvHYBvCcCwg6kEHmkEA6mKgwmnJuwrxvnjrIWULUgVgLlIQZmiX4khkOBboBxUnbp6h-haKYotkBh-itmToIBiv_RxgmlHv3TBhxiCMKVdmqRiPZyewmmrEWK9nnvhkhhwDPjsjhlclOMXtMIvAvtvHvHsA6KoE6ERU0ASl1DHn7vMM-iHp-lTvHsUlXtIRxh03FwXpHtMKxjRiPr8DXtAegZKNPpdkvEVBrCvpaJvqvDvofEfuJC_AyptWyByi8Q_piAHu_u-j9nqP_vglXrgd7r8Abt4wXhvgFJ6WjsuSPhvmc0IAvkwC-yNlYZyD8ECmuRB0UyDgryCvHUuDrxiEEdchEeZRpz9kxGxDIR6k0AJCJBJFoAO3keEaO15WUZ0NeFAQ0ZACTS-FZj0bOTYYMeuUJzSESW4a3WMj-AO18vEZwEzF4RfzO30Z0EUe8B0wr0CitliseiYVsaEcCcMcYb8hUxtP_QZg4d9LMVBB4exD4ZiCky7uoCCbEfL2HSrxoGkZ8FkZMDydQCCccbuBwFUZxHis0cJGJFJGZ0Y0OCqZqeMeeFMYZ0sesY6admSfycMdqcSSpFcc0HcaGZME8bBx8d13lNOw5RFS6bia9uEEbumkaoQ1uNel0WKJ4tYR5ALk8JaO1OtMlOIk4UPniEEiwB422WNgrxeNiRVj5nXk4ZPkmd4eZxyebXeR6F-VHvJXrJTMPGPC0phEiOYFBaheNgIAclQE2ck0BfhUcXAa6HJRwACvJTgBCoPDtKWTeHJgeYjlMLJcECwDcCtgCAAD08SEVVlJB0Ac8AgbYhipMOSsWcW8WJZCXiWtEyXsAKWWiqWaW6X6WhoSTJBWX2XOWH9uXlk0G-Wch8XBWekSW8ARWsAxWyYYBGhqXaWGWllb0WW2WOXpy0XvtiQ_ZOhGgzKMWn19Tn0VWSHYgK9214Iwn1nrkcE4VH1jmDSb0FDPbR5NmbsFVQRQL1ydmxJEMoFrESdQRIZD5AF_weIbo4rjAJLaAqZqE6BOnbpqBxiu53LRZdnEMep-ryQo3FZuQrcwTXlwkVQSFZlcgcmehwmS345RlpVh4kDCxiwCXywdBKwNsaw6xGwQBTkENdI4wiRUBOwfbewGBRwtAMlWxXkZwExkBwpnaLIrIGIsokBNBaMcBZrL3ZoTIIoXaeJj3YoSi7IVwHJ4AV02iPIz2QAL2r2k0b3TIqIj2Yo4pXAEo3ZUp0pMpNAUEf3L2Rh_2QBGwrKZMYP1pWxcA5Ab2UwHQ92N2Ptchv27k5Z5ALQ2w5ABEUomQi3cr-c0SbyiOBlu1UThU3pLR8BcxNBkPN3vB0lxE6ByBd2YON3iOEgUpUT_zGJv36WRgHq2sb21R4BnRCPYP6WC1QwC0uP6xh3Swx2J297p2mxTnjhcBuxIBmh4xqAV3qBaB6BEAQAN20BIBUB-hUJ-o3B-BiJaALYYPbD1IQAwP0ByZOgLB2BUB2V_92nEA_PFwQAYo0P-diI70pPYvhs95dHGODQEguOdPR3-Jx2qwp2GwixrQzPQRF2rPkAuwbO137ON3WgoJYAdBmC8OrKtQdRv3WhNRUB4wb2G5fBOASJuSYODP_P4Azx2uYB4CmRfPujNAiQHI5YLw3ARuivYvMB5VRJoDCvFj1vYZlAtuaH3BVvdvNBZkAqEvBAnAM1sPMdgEVOYvodSQvBT3YO4RCPYvsBMoBxewax0kGkVx9FZu7DNB-UH7YYvxAfeIcgLBnxgf_OtbtQYByZtHSQv3YPRkuPPusBFAag-GkBUVNBRksJEeMgb33vNB0VtOixdP8v9Oiv6xGegA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/interactions/advanced/selection_by_naming/src/index.ts",
        "description": "Separate interactions in multiple viewports and sessions."
    },
    {
        "href": "examples/interactions/advanced/selection_by_naming_advanced/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=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",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/interactions/advanced/selection_by_naming_advanced/src/index.ts",
        "description": "Separate interactions in multiple viewports and sessions."
    },
    {
        "href": "examples/interactions/advanced/sphere_dragging/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPAIQAiA8gMIAqAmgAoBRAASESAPgA6qRmKjDyUAIZw4AXkkh0SgE4BrTVNTDhsmEvRGTJxgQgFY4gMp4lABxisIANxg7GAPR2DjBW1oxQaAbG1iY6MFAaIHAEAJ6wcHgwMASa0rEmePFgSYQEbnCIAQEArqhuegDmOFREAWBQlADuAEb2MAACAIw4ACw4AOwB6BAp7Z29_ThEaC2qeTEmAWGBWRZG-aY9lOipYTYz3oexKekwSdcFXRDoBHiIwkMADF8ApADcj1iWQgjUIH2-f0BmwKMzgbmUqQ-HWw0IK1jclDg9gg1A-Sh6cEoUBqtDR6OEsDABA-UKB1gIlDctIB9I2sXO4XISlQ3hUwheSW5vJUhkCwr5cE5gUu0rg5B0EDcBGEaQ8SSIJxqsE0wjgOnISRwAX15ACaEwuAIcDFJoVSoIcvtyr1BtKBHKlWqdQazVa826fVowzGk2mswIAcWtBwACsbSBxIF5YrlTsAsdTkZdsQoEYQAAaECzABCaF0qSQYCUUDgMAAvkXTeaMNgcNayCAqDQ6AQGBAiJidCrgIcLOgADIRuh-AuHBXmWgANQgMC6Q4Ic5iC6UtCc8Gx1C3JgAsru_BAawBVVCRAisXdKY_CACS3HiMAAcicYM_BEvBE_bg-CEaR62EMAdEoIhhE0AZMncGBLj8AJvFXLo_E0aEBw3YRRxiVgdCURoz1QYjZ0OAAJShfB0UjyJ0Z8Xx7IjyDsagHwIJ9DmY2hWPY1BBFQRo0F_Q5-GUVAYE4agUiItBclQcDIOg2CQHg1wPGQnRUPQvwcDARcaniOAcAUvwlDY3FUCw6QcMoYc8IUeJzyvCBhGUqCYLghCtJ8FC0LXfSEPidAcEwTUAFosigDwdFs1B7Mc4BhF8cgAGYPIgry1MaKBIqIXdFSwBLpGqYRGhyYQa3kVAfzgVVXBVSAdEamBhHiSqsAFYw3nazB5ToTAaAaygwDa4Q3CgtDMHQYQ6swaRuxSCqcm_AaS1ST8lCIGAAHV7DwAAlGAuuENRhAACgWmAPjfD91t_DrTuwD4TsaQQsDcABKc7xDww5YBVG7Klfd9skegBtABdc7hBh8kbvbIjaLrS7rt-tR_vw2IIHGy7OrbWgUmunAyN277fpBnA3BqTIMfJetvvJeICGM4wQehetoWkS6VFSVByCuzHscOcqd1oCbAvXBzFJMZaVWl3CLqULolHsZzFxgFc1w3S6cesF4Pk0IhUh1mXh00Z95Z5SUPkYSjuBPCdOFtlRBFgXaaHEdBKHIGovYIHBKoID2YEDzaX3QS7NAlUUQG-w4mfJcWXMlvq9QPaz51klU61Uay4dV9WVQlmB9wL6h9ceI21NNivDxswtHjscg9ByRA2S7AA2MB0AADi-fuwAygBWbRRlGdLRgATgAJm70fp9GHpu_Sr4eiGGeZ_SmAhh6cgJhgbuhiUMAJiGcgwH76evm3jej6UUevm70ZX6UCZx_SsA59GYelFGFfbu3cJhfAXnPfull56jxgP3buPQAGryUEhGBQxQHpSGKfL4e90o9HQNfSBEwJjdw3t3Oe5Bu7kFHkoShMAeg9DnhfSeaDe5DBvsA0B_d0A9Dvog7I6VcFLy3qPHoYB6HEPIJfbu_dyCMKvn3bhc8YBfFHsQ0eo8Z7937jPIYYBIqiPSsQr4hkF40J_hMBe_cJhiNAUQpQujRiWS-FbR4mpMBQHNleHQUBjYgDKBUKoJp0A6CPjUSROAYA1EiuQXsRF8ojF8khfyOgWjQXZB5Zm0gxYBE1ueCa5l-KFzoCJKSBZhDBOIsIQqZFKqtR5HNPANE_BVJ5AxHOqAVoFMsgJISJT2oXSkl0V8LFunWV6aJS6StZaZJsjEVOWsJoVMaC0mpzT6nVXQHNJQk1lAxIULneSNB2krSWfRWpcNBnCEIsRM5fhLozJMKc1ptSIlgEMmxM8fFLzyAGWuYQnyLzXlvPYTiSh9b7M6DoXxoVdTJ0OF0qy1BxlSRwOOXiFlEWoFuToS6TzVk6AeeUoiJFnn6XHNcxoMkOkEEOQQa6fyJI8mkgc9WNBJkwAygZLyS4aw1HgJdL4ZTBWfEpjM7JGytmiCaa1apbTty5ylbRbFFy_nUSVaSnFhLGnqvxa895BAAWKhrCqoZhrvk3jvKC8FVBIW-MaB-JuGTyQIp6cJUSqLNnosKdQbFl1tV-GxWKuZOSMKiBeO1DOmIFINTcLoHaOQ1kNVDb7RqsxUqXh6nxUZslDj50bsHHI_A427T4ptbau0Y4gH4JQaNmhvqQy-NDfALxhpwxpXynmwbcnpyyJNYtCbWo1HctQCaiowR53DcclUsaiIlr8G5Lw3g4a-39oHFoacYBh0DpWy4dbyQzvjXxBdPgcC3FgDTLEOIR0XU0ASIkJJaAJRMAeudOhj3eFPWkc9zxXh4DhpoOeXx4hECfX22dA732fruDgMdhB_0gD-KBldAdew4EzKkVFbgPAYE4HgaA0cX0QYgIuwlZc3KXTzdZMphGj3EZ8EGrYOTWaKhgL4Ca8IsjxGEJQUktM5b7OpXqNwnGYDsF46SOGlHqAFoIGJ8opIy3xsrU4YTfh4B1obdDTtJggZCZE49UG90IY_hhnDBG4ruRQCgAgtuqpKDVQLo0YwLrC7aC4lOhQPQ4b0q6I9AA_HdcGX4fwiwBjCPGV1mCDMer9Vm7NtPWHKsx1cbGap6bU_NeqjVdwQQ1hncmaBlnyiyLtR4HG1MGbhiHAzindoHTeO9bAPnHplICAAPXK_EAA-pISQ6AADUARCWMb1LLNqRAymxjpiqRkwgejtTgMZGAZXVPxAM6e2WMcYQmD5mUnooX-tKDJvGmDMAESWRgJWzrMAeuFjUnW4QkVhD9Z6Md3ap3zsxKu6tm7Vt7sJ0eMN4Q5UVDYic_kkZmLymPhW_p-qBkHKCEsngdGqBQsG1iOLLItmIsZxcyOtz2y1YNRrC5U4DmwdSXQPScqbw03ClEO4bDApxoZ39ikaCEAABeu5XMvFQAAchVDUNwbmI29vhByvGEAhY3XpBFy6UXwqPgMhadG6BQtzTQCkHkMSxrDKzZi0FlMwsUnmh69AVrLleuzagK1KV_VQtVDoPlZSlkfHbe1JmQPYioBwCLsXS4_CN3ueSWI9Z6R-4D-eIPOgQ9A7hTEbmWSu2g9BL1PDDVLPWcsnoOzc2I1jtqUhYQXQshSVotx8TwvRfngappbDuaftyb4_72vtBXZWZs3ni65Aegpxyes7PAoVTUD2TljOOvLbbh6BR5v1eyYhYS-VMvM5K8ZyWSUorjIKjdvF-1NAfGIIOQmjR5pdQ5rs8ZCsLn-_M6V1mSYccU4Ugzhxf-QCwEBCCBwC-ICggjoABBHgF8dgT8HAVgIAgAcS60AlYDKX5kFmFj-lN2sCkz9xDiLXA1LS2iU00GrVrQTk0xwD5BJH6WEAACknAwDP1FQ3UwBUhq5ttJoa0RoPhrt1tCo3BUdQtIZ6QTA_djgL9CsSxKBcAhCMBCsVMRMWhew_BNNrYChBCeNJDhJRDxCVCZhhJpC1NZCWJIYhhoZFDfc0NNCRCxDTDhDtCfs9C-JIY55oZ6RoZE4YRE9Yhi4NZ0CWhptOdb9Q8k4ZkmZ_DUBCxiw4AywyIdBKxEBqxawGwixY025yI4wiQQjkAuxqBaB6BEAQBRwtAzsho6ByBVwExkAfJNIklaJdIgp4okBNB0ocA54Rg54XF1JEltJqiMIUlDJdwltTJ8cm5O4QAGimjGjWiNJEIOjpZgpXBQpwpw5KBooEg4pNAhiRjmjNBGwTZWVVjNALQ2w5BWiUwHRSi8ip9cg6iQAZ0Yl5B9jcA5BHtIomQ6BWiegh0oBqdLjriEg5t3itdWx7jcxNi5x8jvBWACjWxBYSjVi8jvj8o3iMBYBaihi2sRghg54cBR5Wi1R4BnQLiUTR5QwsSQB6x6xQjSxywoiqwaw6xGxkh6ljhcBuxIBmh4xqBOxuwsi-wci8i0BIBEpaAJxKAmR-AoJaBMVVjPcQTZj0ATpOgLB2BUBcMeRKpJSXcxIQBpZdiQAegoIug6xaiQTaBBxlBH0vjdAbjNjyTwjKTojYjaSixrRmTQQUj2T0jOTewGA8jWg3BoA_B2BlRrJTiTYtQdRLjWhNRUB4xWjgMmkZIiBA5Sj7SNT4ATxQyYAvUmQ1TXdNAiRjIYkzw3BVjkyQTMBFA40BJiyaSNSyzlAiIBJCyqy4ijTdAQ5tTBAnBu4jiaUZd8SpTNAeN7wIBkTNA4QLiQTsA4oBxewaxwSqB6yHJSj-yQBw4QUOUHJdwHITwcgLAYckBly3FtQYATp71SRs5Li5cSSJysBFAahFokA-CQAboutDyMhWixzNBoYySiwKTIi7TqzST6wgA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/interactions/advanced/sphere_dragging/src/index.ts",
        "description": "Drag spheres that affect the shape of the model."
    },
    {
        "href": "examples/interactions/dragging/drag_information/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1Delw8lD8SWVgsFgN8pRwEhDUZfx6cJRQAK60DbBgBGWdXASU8ps1HqmijOS6qvxwXEV5p6jncIcmt_dHJumqr3DkGhDyBNtJRR5IiUdCLWAhOAach5KHkYxoTC4AgPECsExfH5_cImRIpTgmFhQYQgAA0IAgcAAQmh-BokkgwPwoC4AL7kuEIjDYHAosggKg0OgEBixVAQIhjDT_YBxLiCdAAGUptFQmlJcu-Alo0ngE2oGpEWv4tAAahAYPkpQRDTwAKKmu0AOW83gAmgAFO22rgAWRNmggzOkdgwdPQShN_E4rK4YA0lCIXA8AAE4HJFO9NMZVBb8poPHVOBLrVxZSIAML8GwafgevpqivULK1tA2uVKWvNf2ofjNdVygASlHUGh7fYHIgAkp2-3b1DQfVOhbXyOJqJG7EuV_w11NUHbUM00DAfcrG82CK3F3L67oYE3UC3-G2fR7KG3H8_X3LdbA1-O_YaDGcYJkmqbpgoMBZhoOZ5poOBgNqiwaPAOBtpou7rqghZioKWSZHQ6BOpQ4iQKc2FcK4XAABRmLAZQtmgzSklwNhwHAE6MVezEAJRUawZZyhAYC0SRZEQBR-44IoGhEJS-rcK4ylcAA5M0tZCugqn8eWVhqvkXDiSJkkmvudESLArHAFweJlOxnH9lwrK8UWIixjALIwFcok0cZ5FmdQMmaPJHH7lwACEKmqZg4rQTpQkiDw_mmdhOCoQAjos8AEB6IUKeZvG8lEqA0bJoWKQJiVWDwIm0eVBXUFR0UabotDabpco1VwBlGaRJlSdQFnmNZtmggMbF6hOzmuV1oisnNLluTwC2oKybmcDRFxJKg5C0fxriCXpoTGA4qEBvKXC5pa1qapeV15qW1H8PkL7_MaZqPZQ0o0cdPDPBcZToJQ5CLDYNA4P2BB2rA4MEFSSRTugNEeADqL8RcXCDt4vqKlWdwXDDMBwz6tXoGUHhEEk5o3d9BAeHKS1ysYp0fd59guGF1B3U-_yc5Vz2vRIZ3ajAupc6Vf3bJJADWtiIHNPAeAAzOUACcYDlAALGAlSBOQ5QwAAbAA7PwgQmzr6CBFryu7jA5BgOgysAExVFrasmybLuYHolTkOgegAKz8JUgd6MravK4EQdB2rLv8OUQdGzAgTKybyuVDAWtB-QQcwGbYD57MQcuzASd6IbytG-gWta6H8dgCb5SCInyuq-XUdB37YAu0H6Bq3XgT8GAyta-glQKpUejoCHehgIEas2673eezAMBq8bVRG3ofdu0bdc10n5s75XgR6FrlTlNr6AL2r6Au0XauVGrfuBKn5Dn5vMB6P4JtB-UHeMB07kF3gPI2w9p7KzzjnPQI87YwAATADwpM2Kgk8jTfIngNBQApiAQgBB5BwEQCzOAmBFgGxwDARY_hyDClrFAfw5QcCQUzGoBCVAiAoLmkUPBVNxaKQZu5WaOERAsxFhdEo3kMKrmwoeY8ap5QYC4PIBMuZMBXH-FIh6tNpRcEoHoAAVg7emRp7oyKwvueRJ4qI9UtFwZctBZFWKPCeGi10rR0xEczVm51aDbCiFwdAXZAKaCUegeU6AIkSB5gRYJfZQlaGor1Wc3ZdATg0DRERPB4lpN7EBKhYAkIAQDD8Zktjer-icUGKAIZdDoHDJufgv0HALG-nggAxNUIp1QQhMxEBYvc1BrFqhwAqRxmEhmoESTRXJiTvFiNOgqAJ0idxTKCVGbYlAVmEQlrE_4gzsJNIqfYiZziNxRhabksoV5sozWWidSJET7BIUMrkpRjhvqXDAN9bYOVmLCTWUcqMOBckAEFdp4C-bYgA2nNGyYwJjYTKDCpOrE0VcEqAAXWcqghF4xJjTC4DCphQdWKktYti5ycosUPP5tJVA6DQUgvkIsdMNFDn7iadk3ZikcCMswDgRY8gGlmk0IpLJG1FlPMuqcGs9hej3labza8pickhPSQUhUqSvxXhfDQGivV3yfkvKqmiMKXaVFYpaylWLrW8R5XMzVCFtVdl1Wao1H4aDuv1QQc1_gbVcEDdi-1jqNX5JdVEnVprfUoySnYwy54HwxrbOawNwa7XEsDQGq1mLM1VF4nKMNCTnUaDGVGt1KaDVzV6kmn1qaSXptzSG4lObyUZvRZUQtIgFk8AVMqLIdBNA0QdM6V0no7Q4CnC6O0AAlMFFZvBTgAPJOhwEoedABxAA-s6JQrEaIwAOkdOa-EDlAqsQuf41F2aXBnF2ecwoHk8BcBgFKg1SoeFSVwIiKDaIAAMN1gp3XuimnBwWQvaVwAAJMAAAUtIVdLCeKuLAEkDlF7hlXtBV2CFnyNC8QWuBytKrfVlFgwhpDTFUPoc5Vh4UOG-z1poIR_9DqHn9JcpKzgZIKTUlpPSRkzI2TknkLuGWE4cCGPmKgfkgpVQikQCAWUIBMCKG5LtC0qJkAQQzNBdhsEPEFiQCrHAbszPcJAGmPTME4KWgQkhE0KE0J0ZwiZkAyszPMJdh4dklN9UeAVhSbkuAiSWcxL8FEgWVNZDpPTdzYnoSeSuCF_AxAoBcH8P4XYdBLN6EWNAdAgWPCJboRl_LhWUtIjSyQXzGpVMwFUEoGA6nYrkC09FkrdIyv-HyxgWAwF3MAD1mHlBdjgIOlnsiKAi38YrIAhtBxwFrCbvnWS8cpDSXsgnEBMi8uyEAnF9CGBwIKSAzQpMybk9QBTDAVNoEgOKWgipKC7A9AmWgUzAu3NPB4Jw6BZ2eUoIIZdqAKxyCPMgpAP36sePm3oBM-QXCDfq7QSUfRaDzdK55XzG3-PbYZLt4TMADsojOy0S71BrtCnoEplTnD5DQE0Muv4-5tMqZBGCCE7nOEglQNJyzqEQTqCbEQOG2m9suHq_AX0oJwQwDObsb7Ghsr1fmChOh_p5CBcl79hr5A-i1mwjr4n9XMAG7pIFaZCgTdeVR3SKG827TSCNuFnia5leq48JQZYKhBtBe6PF6XWBZISmFMyZrVAjdfM93r4mEhI_fRNN9X0thW52Fj_Vzn8vAfzCWMb9zAqod-ZANgA3ixMCBbhSAIv27s-wFRGblUHgsXrfJJtgThPdesh70AA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/interactions/dragging/drag_information/src/index.ts",
        "description": "Event description when dragging."
    },
    {
        "href": "examples/interactions/dragging/drag_line_constraint/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1Delw8lD8SWVgsFgN8pRwEhDUZfx6cJRQAK60DbBgBGWdXASU8ps1HqmijOS6qvxwXEV5p6jncIcmt_dHJumqr3DkGhDyBNtJRR5IiUdCLWAhOAach5KHkYxoTC4AgPECsExfH5_cImRIpTgmFhQYQgAA0IAgcAAQmh-BokkgwPwoC4AL7kuEIjDYHAosggKg0OgEBixVAQIhjDT_YBxBwaAS0aTwCbUUly76KmAANQgMHyUoI6pEAFl-LQfszpHYMHT0EpzfxOKyuGANJQiFwPAABOByRTvTTGVR6_KaDx1TgSw1cWUiADC_BsGn4AAU-qgYPHqFkU2gjXKlCnmmbUPxmppjTwABKUdQaUvlytygCSQpT5HE1AddirXDbFv4namqAAoqhmmgYH2ADJT7OoXP8fN99O6LM5gh5miryj5hdLldy5WwTuNisaZ2u92en1-hQwQMaYOhzQ4MCKxYKuA4fOaIddqgEZigAFBcSSoOQXAgQAlFwrisLGcrGMY8palw9ghvqhoapuXBYQalDSvBGH5Mu_yauaOqhoaIFxlYzwXGU6CUOQiw2DQOAVgQo6wBxBBUkkLboCBHiMaicEXFw1beCaM6JncFy8TA_F9jwRRlB4RBJLq2FEQQHhyqyMGRiIKFoVRGGZCqI64Yu_wuHAqrcK4pHkRZSo2dQdFyjw4jkAA1rYiC-aIHgAMzlAAnGA5QACxgJUgTkOUMAAGwAOz8IEGUJeggRxeFQ4wOQYDoOFABMVRxVFGUZRVmB6JU5DoHoACs_CVK1ejhVF4WBG1bVRRV_DlG1aUwIE4UZeFlQwHFbXkG1MBZWAy2zG1FUwGNeipeFaXoHFcWdcNYAZeUgijeFkXbX1bVNWAFVtegUVHYE_BgOFcXoJUgg_Xo6AdXoYCBFFBWVfdtUwDAUXpVUaV6E9VVpUdB1jdlCO7YEehxZU5TxegINRegFVrVFlRRU1gSTeQ2OwzAej-BlbXlAjMDTeQiMvWl72VD1S0LXoH1FTALMwB4alcCCmBQLp-SeBoUCaSAhAEPIcCIChcCYIsKU4DAiz-OQwoplA_jlDg94Bmob5UEQEuhRpXogNpypObZIBGSZYo8OZlG0NsURXO2AEjuOk6ZhhGBcPI7ohpgVz_CUMD4TR-lcJQegAFYlQZIiClkweDsO1Dh1OJGZvk_YhyXY4TlOIEEYa3tAWZqH-ynydcOgxbnpoUfoBh6CDxIdmFz35Z91ormV1wRaT7oTYaLBpk8BPJaLxe-tgB-Z5UZaUAV_qXBmhaEBWja6B2j2_B0Q4CxEcrADE1Q79UITGavRf_rXZeZjgf0Bw_0AlPEC68p4t2QqhP6gcU5_g7IBbujptiUFgdZd21A5SOWcjgVAoIYA4CvnYHA8hFh-hArPIBCCRw3zvuvMoW5Fgp2Mi3Hg2CRy4PwTgRY8giE6k0M5FePtQjQOHlZMY-Z772W3HnHgBd_hQHnJuGRR8q5zkzAeLcy4aAgQANptUqKSLg_gnpGMqAAXSMbo_wBijEmLamYyxXAnqsJEVwMhncg47CCtwHYXAFQgnUGg-RKjyzaOggEusyhiyaJkTBMeSdKA-JIuAzeb4_rz2aLE7RBAQKKI0conJLdjJCNQGSCk1JaT0kZMyNk5J5BDgCk2HAWd5hlOQAKagtB6CIBALKEAmBFDckgnqVEyA7z-kfDbZ8BFwxIAijgKqiyHYgF9JMp8L59Rvg_OaL88Bfw10Ah4EKIBwqLIthVDw7ItLaOOR4REPIiQrMxL8FExz-lZDpAZeZIAGnQhgIfB5uAiTGP8LsOgKy9CLGgOgO5vy6TG0PlCmFwckT4GIFAK56oBkwFUEoGAQzMAjPgO8jwfzEX-ChRgWAl4fkAD0LblAqjgNqKzsiKBeX8OFdK2o4Diiyq5rJymUhpGWapiAmQshgOyEAcBdCtUMDgQUkBmgtLafyQU3SRS9P6WgSA4paAzkoLsVM7paC12OYw6cHgnDoAAEoAsoIIAA8qgeMcgJziyQFa7FBE4V6HdPkFwtLsW0ElH0WgcLyUAqucKypYqGQStqdK8kKJlUtDVdQDVXThQMH6XbeQ0BNDOr-COMZ_Tpbgi9Scu2IJUCtJWZE9Q2YiD8TGZKlw2L4AmlBFWqhuxLUaCYdi-YX5jZmnkMcjt1qcXkD6CmI5NSpXYswHOuk5oRwTqncm0NdJuJwtHNINKzytwQE7IO4dHhKDLBULSk53RvldqwIoH4_FmT4qoAuoiYyfUeBUhID9RFzRERNLYS6dgL0zsrbAB18wliLpOXgzAWK_1YDnYsZDSBdEeCQzAAA-tBklZIPAPo8OYoV5IRVVMTdO1kdGgA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/interactions/dragging/drag_line_constraint/src/index.ts",
        "description": "Use a line constraint for dragging."
    },
    {
        "href": "examples/interactions/dragging/drag_point_anchor/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1Delw8lD8SWVgsFgN8pRwEhDUZfx6cJRQAK60DbBgBGWdXASU8ps1HqmijOS6qvxwXEV5p6jncIcmt_dHJumqr3DkGhDyBNtJRR5IiUdCLWAhOAach5KHkYxoTC4AgPECsExfH5_cImRIpTgmFhQYQgAA0IAgcAAQmh-BokkgwPwoC4AL7kuEIjDYHAosggKg0OgEBixVAQIhjDT_YBxBwaAS0aTwCbUUly76KmAANQgMHyUoI6pEAFl-LQfszpHYMHT0EpzfxOKyuGANJQiFwPAABOByRTvTTGVR6_KaDx1TgSw1cWUiADC_BsGn4AAU-qgYPHqFkU2gjXKlCnmmbUPxmppjTwABKUdQaUvlytygCSQpT5HE1AddirXDbFv4namqAAoqhmmgYH2ADJT7OoXP8fN99O6LM5gh5miryj5hdLldy5WwTuNisaZ2u92en1-hQwQMaYOhzQ4MCKxYKuA4fOaIddqgEZigAFBcSSoOQXAgQAlFwrisLGcrGMY8palw9ghvqhoapuXBYQalDSvBGH5Mu_yauaOqhoaIFxlYzwXGU6CUOQiw2DQOAVgQo6wBxBBUkkLboCBHiMaicEXFw1beCaM6JncFy8TA_F9jwRRlB4RBJLq2FEQQHhyqyMGRiIKFoVRGGZCqI64Yu_wuHAqrcK4pHkRZSo2dQdFyjw4jkAA1rYiC-aIHgAMzlAAnGA5QACxgJUgTkOUMAAGwAOz8IEGUJeggRxeFQ4wOQYDoOFABMVRxVFGUZRVmB6JU5DoHoACs_CVK1ejhVF4WBG1bVRRV_DlG1aUwIE4UZeFlQwHFbXkG1MBZWAy2zG1FUwGNeipeFaXoHFcWdcNYAZeUgijeFkXbX1bVNWAFVtegUVHYE_BgOFcXoJUgg_Xo6AdXoYCBFFBWVfdtUwDAUXpVUaV6E9VVpUdB1jdlCO7YEehxZU5TxegINRegFVrVFlRRU1gSTeQ2OwzAej-BlbXlAjMDTeQiMvWl72VD1S0LXoH1FTALMwB4alcCCmBQLp-SeBoUCaSAhAEPIcCIChcCYIsKU4DAiz-OQwoplA_jlDg94Bmob5UEQEuhRpXogNpypObZIBGSZYo8OZlG0NsURXO2AEjuOk6ZhhGBcPI7ohpgVz_CUMD4TR-lcJQegAFYlQZIiClkweDsO1Dh1OJGZvk_YhyXY4TlOIEEYa3tAWZqH-ynydcOgxbnpoUfoBh6CDxIdmFz35Z91ormV1wRaT7oTYaLBpk8BPJaLxe-tgB-Z5UZaUAV_qXBmhaEBWja6B2j2_B0Q4CxEcrADE1Q79UITGavRf_rXZeZjgf0Bw_0AlPEC68p4t2QqhP6gcU5_g7IBbujox7_CvnYI-VcgEIJHDfO-68yhbkWCnT-co0H8BwOvAAgpBPAREfzyEWH6HyIgeBjAmIBMoABtSopIuA8L4QAXS9l_RyzkcCoFBDAChjocAMKYWQluPBREjnEZInAix5BoJ1JoZyK8fb33sjHPcNADxbmXDQDBXBUzGIIKY7cBAQLcN4f4J6vDKgCN4U9RRBjC47CCi5buvdN5vj-vPZodjzEOLGPuTc9iW7GT0agMkFJqS0npIyZkbJyTyCHAFJsOAs7zCScgAU1BaD0EQCAWUIBMCKG5JBPUqJkB3n9I-G2z4CLhiQBFHAVVekOxAL6VpT4Xz6jfB-c0X54C_hroBDwIUQDhV6RbCqHh2RaXMfMjwiIeREgGZiX4KJ5nVKyHSAy3SQA5OhDAQ-OzcBEi4P4fwuw6ADL0IsaA6AtmXLpMbQ-7zPnByRPgYgUA1nqhqTAVQSgYB1MwA0-AxyPBXL-f4d5GBYCXguQAPQtuUCqOA2oDOyIoA5fxvnYrajgOKhK1msmSZSGkZZ0mICZCyGA7IQBwF0K1QwOBBSQGaAUop_JBTlJFJU6paBIDiloDOSguxUzuloLXeZhDpweCcOgAASjcygggADyqB4xyAnOLJA6qIUEW-Xod0-QXBYohbQSUfRaDfJRTctZDLUnMoZKyzJHLyQogFS0YV1BRVlOFAwapdt5DQE0Aav4I4mnVOluCc1Cy7YglQIUgZCoQTqGzEQfiTS2UuAhfAE0oJ01YN2GqjQRCIXzC_MbM08h5llo1ZC8gfQUxzIyeyiFmAe10nNCONtHaA1OrpNxb5o5pBpX2VuCAnZ62No8JQZYKgsULO6OcitWBFA_H4syGFVA-10LXV2lSEgz1EXNERE0thLp2CvRCtNsBdXzCWP2hZEjMDgo8NgHtiwANIE4R4f9MAAD6H7EVkg8HujwAj6XkkZWkv1nbWTYaAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/interactions/dragging/drag_point_anchor/src/index.ts",
        "description": "Use a point anchor for dragging."
    },
    {
        "href": "examples/interactions/dragging/drag_point_anchor_multiple/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1Delw8lD8SWVgsFgN8pRwEhDUZfx6cJRQAK60DbBgBGWdXASU8ps1HqmijOS6qvxwXEV5p6jncIcmt_dHJumqr3DkGhDyBNtJRR5IiUdCLWAhOAach5KHkYxoTC4AgPECsExfH5_cImRIpTgmFhQYQgAA0IAgcAAQmh-BokkgwPwoC4AL7kuEIjDYHAosggKg0OgEBixVAQIhjDT_YBxBwaAS0aTwCbUUly76KmAANQgMHyUoI6pEAFl-LQfszpHYMHT0EpzfxOKyuGANJQiFwPAABOByRTvTTGVR6_KaDx1TgSw1cWUiADC_BsGn4AAU-qgYPHqFkU2gjXKlCnmmbUPxmppjTwABKUdQaUvlytygCSQpT5HE1AddirXDbFv4namqAAoqhmmgYH2ADJT7OoXP8fN99O6LM5gh5miryj5hdLldy5WwTuNisaZ2u92en1-hQwQMaYOhzQ4MCKxYKuA4fOaIddqgEZigAFBcSSoOQXAgQAlFwrisLGcrGMY8palw9ghvqhoapuXBYQalDSvBGH5Mu_yauaOqhoaIFxlYzwXGU6CUOQiw2DQOAVgQo6wBxBBUkkLboCBHiMaicEXFw1beCaM6JncFy8TA_F9jwRRlB4RBJLq2FEQQHhyqyMGRiIKFoVRGGZCqI64Yu_wuHAqrcK4pHkRZSo2dQdFyjw4jkAA1rYiC-aIHgAMzlAAnGA5QACxgJUgTkOUMAAGwAOz8IEGUJeggRxeFQ4wOQYDoOFABMVRxVFGUZRVmB6JU5DoHoACs_CVK1ejhVF4WBG1bVRRV_DlG1aUwIE4UZeFlQwHFbXkG1MBZWAy2zG1FUwGNeipeFaXoHFcWdcNYAZeUgijeFkXbX1bVNWAFVtegUVHYE_BgOFcXoJUgg_Xo6AdXoYCBFFBWVfdtUwDAUXpVUaV6E9VVpUdB1jdlCO7YEehxZU5TxegINRegFVrVFlRRU1gSTeQ2OwzAej-BlbXlAjMDTeQiMvWl72VD1S0LXoH1FTALMwB4alcCCmBQLp-SeBoUCaSAhAEPIcCIChcCYIsKU4DAiz-OQwoplA_jlDg94Bmob5UEQEuhRpXogNpypObZIBGSZYo8OZlG0NsURXO2AEjuOk6ZhhGBcPI7ohpgVz_CUMD4TR-lcJQegAFYlQZIiClkweDsO1Dh1OJGZvk_YhyXY4TlOIEEYa3tAWZqH-ynydcOgxbnpoUfoBh6CDxIdmFz35Z91ormV1wRaT7oTYaLBpk8BPJaLxe-tgB-Z5UZaUAV_qXBmhaEBWja6B2j2_B0Q4CxEcrADE1Q79UITGavRf_rXZeZjgf0Bw_0AlPEC68p4t2QqhP6gcU5_g7IBbujox7_CvnYI-VcgEIJHDfO-68yhbkWCnT-co0H8BwOvAAgpBPAREfzyEWH6USIgeD0SsDHcYkxphcAANqVFJFwfhgiAC6oV2ShTYVYMYExAJlB4WNARQjKiiJYVwcRqjJGiGkVw1AcjzZtUUYolRVhWRyhbjwRyzkcCoFBDAChjocAMKYWQ8x1l3bUGsbYnAix5BoJ1JoZyK8fb33shw_cm5tz_BnsfVMe4aAHi3MuGgIE-ECP8E9IxAi2qVFcQXJOlAgouW7r3Teb4_rz2aAkyJIExjhPspEluxkgmoDJBSaktJ6SMmZGyck8ghwBSbDgLO8wWnIAFNQWg9BEAgFlCATAihuSQT1KiZAd5_SPhts-Ai4YkARRwFVfZDsQC-nWU-F8-o3wfnNF-eAv4a6AQ8CFEA4V9kWwqh4cRLskmPI8IiHkRIjmYl-CiR5sysh0gMrskAfToQwEPn83ARIuD-H8LsOgRy9CLGgOgH50K6TG0Ppi7FwckT4GIFAD56o5kwFUEoGACzMBLPgKCjwMKCX-ExRgWAl4oUAD0LblAqjgNqRzsiKCBX8XFvK2o4DisKj5rJWmUhpGWTpiAmQshgOyEAcBdCtUMDgQUkBmhDJGfyQUkyRTTNmWgSA4paAzkoLsVM7paC10eYQ6cHgnDoAAEpwsoIIAA8qgeMcgJziyQJ6qlBFcV6HdPkFwPKqW0ElH0WguK2Vwo-Uq9pqqGTqu6Vq8kKIjUtFNdQc1EzhQMFmXbeQ0BNBBr-COFZszpbgkjU8u2IJUDDKOQqEE6hsxEH4isjVLgqXwBNKCTtWDdgeo0EQql8wvzGzNPIR5E6vXUvIH0FMDyumaqpZgPddJzQjg3VuotKa6TcVxaOaQaVAVbggJ2Rdy6PCUGWCoHlTzuiQqnVgRQPx-LMjpVQA9dCP07pUhICDRFzRERNLYS6dgYNUo7bAf18wliHqeTYzAlKPDYD3YsIjSAeEeEIzAAA-lh5lZIPAAY8MIxV5JlUdILdu1kvGgA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/interactions/dragging/drag_point_anchor_multiple/src/index.ts",
        "description": "Use point anchors for dragging."
    },
    {
        "href": "examples/interactions/dragging/drag_point_anchor_orientation/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1Delw8lD8SWVgsFgN8pRwEhDUZfx6cJRQAK60DbBgBGWdXASU8ps1HqmijOS6qvxwXEV5p6jncIcmt_dHJumqr3DkGhDyBNtJRR5IiUdCLWAhOAach5KHkYxoTC4AgPECsExfH5_cImRIpTgmFhQYQgAA0IAgcAAQmh-BokkgwPwoC4AL7kuEIjDYHAosggKg0OgEBixVAQIhjDT_YBxBwaAS0aTwCbUUly76KmAANQgMHyUoI6pEAFl-LQfszpHYMHT0EpzfxOKyuGANJQiFwPAABOByRTvTTGVR6_KaDx1TgSw1cWUiADC_BsGn4AAU-qgYPHqFkU2gjXKlCnmmbUPxmppjTwABKUdQaUvlytygCSQpT5HE1AddirXDbFv4namqAAoqhmmgYH2ADJT7OoXP8fN99O6LM5gh5miryj5hdLldy5WwTuNisaZ2u92en1-hQwQMaYOhzQ4MCKxYKuA4fOaIddqgEZigAFBcSSoOQXAgQAlFwrisLGcrGMY8palw9ghvqhoapuXBYQalDSvBGH5Mu_yauaOqhoaIFxlYzwXGU6CUOQiw2DQOAVgQo6wBxBBUkkLboCBHiMaicEXFw1beCaM6JncFy8TA_F9jwRRlB4RBJLq-rhiAcqsjBkYiChaFURhmQqiOuGLv8LhwKq3CuKR5HmUq1nUHRco8OI5AANa2IgPmiB4ADM5QAJxgOUAAsYCVIE5DlDAABsADs_CBOl8XoIEsVhUOMDkGA6BhQATFUsWRel6XlZgeiVOQ6B6AArPwlQtXoYWRWFgSta1kXlfw5StalMCBGF6VhZUMCxa15CtTAmVgEtsyteVMCjXoKVhal6CxbFHVDWA6XlIII1hRFW29a1jVgOVrXoJFh2BPwYBhbF6CVII316Og7V6GAgSRflFV3TVMAwJFaVVKleiPZVqWHfto1ZfDO2BHosWVOUcXoMDkXoOVq2RZUkWNYEE3kFjMMwHo_jpa15TwzAU3kAjz2pW9lTdYt816O9hUwMzMAeGpXAgpgUC6fkngaFAmkgIQBDyHAiAoXAmCLMlOAwIs_jkMKKZQP45Q4PeAZqG-VBEOLIUaV6IDacqjk2QZIhGSZyGoZRtDbFEVztgBI7jpOmYYRgXDyO6IaYFc_wlDA-E0UR_yUHoABWxUELZWRB4Ow7UGHU4kZm-T9sHRdjhOU4gQRhrGWKPBmX7ydJ1w6DFuemiR-gGHoP3Eh5_8Xflj3WgueXXBFuPuhNhosEmTwY8lvPF562AH5nlRlpQGX-pcGaFoQFaNroHaPb8HRDgLERSsAMTVFv1QhF7cp_h2gEl5mOC_QO_5q4TxAqvCeTcgKmVQr9AOydP4h2oJ3R0I9EF2APhXABX8RxXxvqvMoW5FjJ3fiIC-dgcCrwAIKQTwERH88hFh-m8iIHgYwJiATKAAbUqKSLgXCeEAF0JbujsGwpCTDRD8CwJSDhvDeHlAESFHguhmiwDKP4Y-eAcCphbKELg5UQqskMuAngDknI4FQKCGAZDHQ4DoQwkh_AjFWTdtQMxFicCLHkCQnUmgnJL2brfOy0c9w0APFuZcNA0FcFTMEggoTtwEBApw7h_hHrcMqAI3RrVHGCnzjsQKzlO7d3Xm-X6s9mhxPCQksY-5NzxPAUZPxqAyQUmpLSekjJmRsnJPIIc_kmw4EzvMJpyABTUFoPQRAIBZQgEwIobkkE9SomQHef0j5rbPgIvpYKIAwo4Eqns-2IBfSrKfC-PSGh3yfm_L-KugEPDbN2fsvRIB2RaXCfcjwiIeREkOZiX4KJ7nTKyHSXOSAPA9OhDAfeXzcBEi4P4fwuw6CHL0IsaA6APkgAhUbfeqL0VByRPgYgUAPCvJmTAVQSgYBzMwAs-AgLwV0hxf4VFGBYCXjBSAAAeubco5UcCtUOdkRQfy_iYq5a1HAsUBWktZM0ykNIyztMQEyFkMB2QgDgLoFqhgcCCkgM0AZQz-SCnGSKSZ0y0CQHFLQGclBdipiETnd2iB8HTg8E4dAAAlKFlBBAAHlUDxjkBOMWSA3XqhAARTFeh3T5BcByyNtBJR9FoJi7FULSXytaUqhkKrOnqvJCifVLQjXUBNWM4UDBpm23kNATQ_q_gjiWdMqW4Iw3bNtiCVAgzDkKhBOobMRB-JLNVS4SN8ATSgnbRg3Y9yI0eHmF-I2Zp5D3LHe68l5A-gpjuR0tVkbMDbrpOaEcq710FqTXSbimLRzSFSr8rcEBOzzo0AQyNlBlgqA5ds7ooKJ1YEUD8fizIqVUF3TQ1976PAqQkGBoi5oiImlsBdOwUHN1ttgD6-YSw93bPMZgUlAHt2LEI0gdhHgCMwAAPqYfpWSDwf6PB8LleSBVbS80btZNxoAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/interactions/dragging/drag_point_anchor_orientation/src/index.ts",
        "description": "Use a point anchor with an orientation for dragging."
    },
    {
        "href": "examples/interactions/dragging/drag_point_constraint/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1Delw8lD8SWVgsFgN8pRwEhDUZfx6cJRQAK60DbBgBGWdXASU8ps1HqmijOS6qvxwXEV5p6jncIcmt_dHJumqr3DkGhDyBNtJRR5IiUdCLWAhOAach5KHkYxoTC4AgPECsExfH5_cImRIpTgmFhQYQgAA0IAgcAAQmh-BokkgwPwoC4AL7kuEIjDYHAosggKg0OgEBixVAQIhjDT_YBxBwaAS0aTwCbUUly76KmAANQgMHyUoI6pEAFl-LQfszpHYMHT0EpzfxOKyuGANJQiFwPAABOByRTvTTGVR6_KaDx1TgSw1cWUiADC_BsGn4AAU-qgYPHqFkU2gjXKlCnmmbUPxmppjTwABKUdQaUvlytygCSQpT5HE1AddirXDbFv4namqAAoqhmmgYH307oszmCHmaDPKPns6hc_x833lbBO42Kxpna73Z6fX6FDBAxpg6HNDgwIrFgq4Dh85oh13UBGxQAKC5JKg5BcL-ACUXCuKwsZysYxjylqXD2CG-qGhqC5cMhBqUNKEGIfkW7_Jq5o6qGhq_nGVjPBcZToJQ5CLDYNA4BWBCjrAjEEFSSQtugv4eFRqLgRcXDVt4JoADKJncFxsTAHF9jwRRlB4RBJLq-rhiAcqsqBkYiLB8HEYhmQqiOaEbv8LhwKq3CuHhBGGUqpnUORco8OI5AANa2IgbmiB4ADM5QAJxgOUAAsYCVIE5DlDAABsADs_CBIlkXoIE4UBUOMDkGA6ABQATFU4XBYliWFZgeiVOQ6B6AArPwlR1XoAXBQFgT1fVwWFfw5T1fFMCBAFiUBZUMDhfV5D1TAyVgDNsz1YVMD9XocUBfF6DheFTU9WAiXlIIfUBUFK3tfV1VgIV9XoMF22BPwYABeF6CVIIr16OgjV6GAgTBZlRUXWVMAwMFCVVPFejXcV8XbZt_UpZDa2BHo4WVOUEXoL9wXoIV83BZUwXVYEQ3kCjYMwHo_iJfV5SQzAI3kFDt3xQ9lStdNk16I92UwLTMAeApXAgpgUDqfkngaFAykgIQBDyHAiCwXAmCLLFOAwIs_jkMKKZQP45Q4BeAZqPeVBEILflKV6ICqcq1lmVpIg6XpMFwURtDbFEVztp-I7jpOmaIRgXDyO6IaYFc_wlDAGGkdh_yUHoABWuUEOZWQ-4Ow7UAHU64Zm-T9r7OdjhOU6_phhq6WKPAGR7scx1w6DFgemjB-giHoJ3EgZ_8Lflm3Wh2YXXBFoPuhNhoYF6TwA8lpPh4a2Aj77sRlpQAX-pcGaFoQFaNroHaPb8ORDgLNhMsAMTVCv1QhC7crvh2X555mODvQOH6l0Pv7z0PNdvz6Tgu9L2sdn5-2oM3R02xKBgJMg7agcorI2RwKgUEMAcBHzsDgeQiw_S_lHl_F-I4T5n3nmURcixY46UATwFBI40EYJwIseQ2CdSaBsjPWuoQQHd2MmMfM58LJLnTiIQUmdBE0HXJuIRI9t6plXNIhcojfwAG1Kiki4P4a6WjKgAF0tHXTobwrg-DG7ex2N5bgOwuAKhBOoeBEjFxbhoIhZoriQL2LrMoYsMiXH5lAn3WB1jcL_0Xved649mj-NUVIggsTXEEEATpbhqAyQUmpLSekjJmRsnJPIIcnkmw4GTvMdJyABTUFoPQRAIBZQgEwIobkQE9SomQOef0V5TY3kwppXyIAAo4GKsMy2IBfRdOvLeDSGgHxPhfG-EuX4PADKGSMwqHh2QqVcSsjwiIeREjGZiX4KIVkNKyHSdOSAPCFOhDATe-zcBEm0f4XYdAxl6EWNAdAuyQC3J1pvT53yfZInwMQKAmz1SNJgKoJQMBmmYFafAM5Ny6QAv8J8jAsAjzXJAAAPUNuUQqOB6pjOyIoY5fxfl4vqjgcKJLNmsgyZSGkZYcmICZCyGA7IQBwF0HVQwOBBSQGaKU8p_JBQ1JFHUhpaBIDiloOJSguxUzuloKXFZVDpweCcOgAASvcygggADyqB4xyAnALJAWqoWYV-Xod0-QXA4qhbQSUfRaC_P-fczZzKslsoZByvJ3LyQomFS0MV1AJXVOFAwBp5t5DQE0Mav4I52kNJFuCK1AzzYglQGUsZ3j1DZiIBxdpnKXBQvgCaUEWbiG7E1RoahUL5jPh1maeQKyK3auheQPoKZlm5K5VCzAfa6TmhHB2rtwbXV0hYr80c0h4pHMXBATsjbm0eEoMsFQOKBndCuVWrAigfgcWZHCqgA7sLtJtR4OSEgL3YXNNhE0tgjp2A3T2zNsADXzCWIOgZ6DMCQrvVgPtixgNIDUR4IDMAAD637kVkg8Aejw-imXkhZdkwN3bWR4aAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/interactions/dragging/drag_point_constraint/src/index.ts",
        "description": "Use a point constraint for dragging."
    },
    {
        "href": "examples/interactions/dragging/dragging_plane/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1Delw8lD8SWVgsFgN8pRwEhDUZfx6cJRQAK60DbBgBGWdXASU8ps1HqmijOS6qvxwXEV5p6jncIcmt_dHJumqr3DkGhDyBNtJRR5IiUdCLWAhOAach5KHkYxoTC4AgPECsExfH5_cImRIpTgmFhQYQgAA0IAgcAAQmh-BokkgwPwoC4AL7kuEIjDYHAosggKg0OgEBixVAQIhjDT_YBxBwaAS0aTwCbUUly76KmAANQgMHyUoI6pEAFl-LQfszpHYMHT0EpzfxOKyuGANJQiFwPAABOByRTvTTGVR6_KaDx1TgSw1cWUiADC_BsGn4AAU-qgYPHqFkU2gjXKlCnmmbUPxmppjTwABKUdQaUvlytygCSQpT5HE1AddirXDbFv4namqAAoqhmmgYH307oszmCHmaH3lbBO42Kxpna73Z6fX6FDBAxpg6HNDgwIrFgq4Dh85oh13UBGxQAKC5JVDkLivgCUXFcVhYzlYxjHlLUuHsEN9UNDUFy4aCDUoaUAMg_J-AkcDzR1UNDVfOMrGeC4ynQShyEWGwaBwCsCFHWBKIIKkkhbdBXw8IjUX_C4uGrbwTQAGUTO4LjomAGL7HgijKDwiCSXUYOQggPDlVlf0jERQKw2hIMyFURzg1Asl0uBVW4Vw0Iw_5NWw5UTJHfC5R4cRyAAa1sRBHNEDwAGZygATjAcoABYwEqQJyHKGAADYAHZ-ECGKQvQQIgu8ocYHIMB0G8gAmKogr8mKYpyzA9Eqch0D0ABWfhKkqvRvL87zAiqqq_Jy_hyiqqKYECbyYu8yoYCCqryCqmA4rAcbZiqnKYC6vRIu8qL0CCoLavasAYvKQROu83z5qaqqyrAHKqvQPy1sCfgwG8oL0EqQQHr0dAar0MBAj8lLcuOwqYBgPzoqqKK9DOvKorWlauvikHFsCPQgsqcpgvQD6_PQHKpr8yo_LKwJevIeHAZgPR_BiqryhBmB-vIUGLqi67KgasaRr0G60pgCmYA8CSuBBTAoHk_JPA0KBpJAQgCHkOBEFAuBMEWCKcBgRZ_HIYUUygfxyhwA8AzUc8qCIHnPKkr0QFk2zTOUkRVPUkCwOs7SShgK520fEdx0nTNIIwLh5HdENMCuf4XYQ3DFK4Sg9AAKwypSREFIz7w7J8vanVDM3yft3eHah08zV9EMNNSxR4TSnddsP0GLDdNF99BIPQRuJAMoya_LOutHMrOuCLTvdCbDQ_3UngO5LQfN2VsBL3XbDLSgTP9S4M0LQgK0bXQO0e34fCHAWZDxYAYmqGfqhCO25RTj384nKccCegcHzz1Au9fceu9L58NLAp7tiiN2g4X5cC3nYbYlB_6uxcHZagcpoGmRwKgUEMAcCgP4DgeQiw_Svl7k_VOI4d573HmURcixXaqS_jweBI5EHIJwIseQoCdSaFMiPMuoRf7Nx0r0Oc-9DKLgwjQNu_weGZmzPwpc_we7L1nGIhckjXwAG1Kiki4CoioABdVRyjVHqMqBoyhHCuBYKrgAnYbluA7C4AqEE6hIF8NzII_45ZBE_hsXWZQxZxGOPzL-YR4CLGoQ_pPc8T1-7NG8QI_Mr5RHzgkU4r-qk2GoDJBSaktJ6SMmZGyck8ghwuSbDgGO8wUnIAFNQWg9BEAgFlCATAihuRfj1KiZA-5_RHgNieRC4YkA-RwHlfpJsQC-naceU8-pzyXnNNeeAd5c5Pg8B5EA3l-k6xyh4dkMlBGLI8IiHkRIhmYl-CiRZtSsh0iUr0kAeToQwEXns3ARIuD-H8LsOgQy9CLGgOgHZ1y6Tq0Xp875bskT4GIFADZ6o6kwFUEoGADTMBNPgKcjwNyAX-E-RgWAW4rkAD0dblByjgKqQzsiKCOX8X5uKqo4CCsSjZrJUmUhpGWTJiAmQshgOyEAcBdCVUMDgQUkBmhFJKfyQUlSRTVNqWgSA4paD8UoLsVM7paAv0WaQ6cHgnDoAAEp3MoIIAA8qgeMcgJzcyQJqqFiFfl6HdPkFwOKoW0ElH0Wgvy0V3I2Uy9JrKGTsuyVy8kKIhUtFFdQcVFThQMFqUbeQ0BNBGr-COFptT-bgktUso2IJUDFKGe49Q2YiAMRaRylwUL4AmlBJmvBuwNUaDIVC-Y151ZmnkIs8tWroXkD6CmBZWTOVQswL2uk5oRzts7UGl1dIaK_NHNIKKhzFwQE7A2ptHhKDLBUDipZ3RLmVqwIoH4DFmRwqoP25CLTrUeDEhIc9yFzTIRNLYXadh13dozbAfV8wlgDqWUgzAkLb1YF7YsIDSBFEeEAzAAA-l-5FZIPD7o8Boxl5JmUZIDV21kuGgA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/interactions/dragging/dragging_plane/src/index.ts",
        "description": "Use a plane for dragging."
    },
    {
        "href": "examples/interactions/dragging/external_gltf_dragging/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1Delw8lD8SWVgsFgN8pRwEhDUZfx6cJRQAK60DbBgBGWdXASU8ps1HqmijOS6qvxwXEV5p6jncIcmt_dHJumqr3DkGhDyBNtJRR5IiUdCLWAhOAach5KHkYxoTC4AgPECsExfH5_cImRIpTgmFhQYQgAA0IAgcAAQmh-BokkgwPwoC4AL7kuEIjDYHAosggKg0OgEBgQIhjDT_YBxBwaAS0aTwCbUUky77ymAANQgMHyEoIqpESn4dgAoqhmmgYIaeABZE2aCDM6R2DB09DGuw2zLkOgwbxymCcVlcMAaShELgeAACcDkinemmMqh1-U0HjqnDF-q40pEAGF-DYNPwAAp9VAwfPULIltAGmUASSFJfI4monv43ubtFb7dQ5stle9ShLzXtqH4zU03oAEpR1BoJ1P06gQ2GI1GQLH4zBExpk6nNDgwPLFnK4Dh65p-G2pqgM1nxZRJbmuEQTQAWUlcdTkADMXDruGkYeM0UD-B-BA_Fgj4PqggpZFw6Amvwg5WmUnboZWXCuFwWEWlaV6oFkui-pm8EABQXEkCFcJRACUuGsLmMrGMYsoalw9gprq-pqjW_y8XqL7_Hh_D5PwEicQ62p8aJlF5lYzwXGU6CUOQiw2DQODTgQpqwNpBBUkkjboJRHgqaiTEXFws7eLaAAyhZ3BcBkwEZ3o8EUZQeEQSRySJkoeDKrIMRRMqwP8LhwMq3DiZJ0nqg6iqxfeikyjw4jkAA1rYiCZaIHgAKzoHoejFeU5QAOx6AAbP-lRgHogT_vwgSVMVdVgJUdUwDA1XlAAnGAxXVZU_BDZUn56DAdVDben6VcVABMgQrStAErdVYD_v-6AreUn6te1KEwENMD_uUG38DANXkENQ0rQIdV6P-MArfVxX8D1C0PYEg3oOgJ0rQ1MBgMdgQwMVgR6JtG11RNlTVYEj2fuUgTFcdejoJ-p3kGA5QE7tpx7UNWMPTAn7kE1c2VFVgRgNVjXoJU_7kF1ejVdDQ1Q7MU2w_-n53a97V1StpX-BVt5DXVgTzXVR3DeUwOCPwdXVRLsztc16seF576gjAUCBZ4GhQL5ICEAQ8hwIg7FwJgizkOUOAwIs_i-jQJYQa7cYKHuajHlQRD64VPlbv5qVxSFIhhRFIjsTJtDbFEVwtre_bYTA3EYFw8jhimmBXP8JQ58JOaUHoABWMBtgJJH_Nefb3tnuFcJW-RcD2N53tQ2eURXonhbEiccclKdl8hY7LtOWi6Og3FAyXDdIegM-6CuWh4Z3-Eb5Oc-MRRPDr1Os_HuDp5tvavZOlA7e7zfjrOq6KEaB6qGKQ4CwvpbADE1QwA9UqCEeOMpm6Z1boRSsOBBDoB7i3ag58NCUVPuOTec8R7wR4EnCeOcp54AXJoZBudF5wJXiIRC_xCGLhITvXUdkiFLgwZoI-MoaHEJYRoN2QC64ECfj8ZkD8GECLvi6Be7pOxfyoFAX-W4AHVCamAUBWDvIZz7gOaBMBYFAwQZApBXDKIcOYQfTQWDV7_FQEbduEkpL_BQmaLROBZGCGrEKGgGURA8DAC-KCltwIEGUWSUIHEfFaACWALgK0uBpi4IsFwXAAAGETEk_jCVwCJFQYk53iTnZJUA9CJO4pcewYSoKFTwHKMABUvFFStgQG2dt2IlnyLpCQeBFh6FydCagtAdIh2MP7BMQcDzgT8P4HQ4pYD-FtEbFkxgPxZCTCtHAlRjDGg_NOdAs5jY2AIMYMZvh1lFhXNs3ZthdJQECbHHgYCRBfD9AGfqOj0AADkjaUSsZgVRHcja8hLCRMpJp7yXnkPEvAnirARw8NBXQcAgX9jDrUqCMEyhQU_DgIg4ILK1J4OinAeDGIGzxV-E8IEAxwr6P2Si-LCUMR_H-f8ZKIyamZIseAlFKg_mKj-a6DF6WFRJQQDFG4iDSFOFANAzQaWkrpQyuuTLRWsqWBynlXA1XFX5YVBioVzFjyXovKeECNHIVQtsSgqcc4xTilwSgywwUogsenXs-jUCdmEV3PRGipHAGnlOMo0F2U_mMQGjQ7KgI_ONf2TsOA0EAHkfhDnboy5lRBlXsrgJyn8XKuCVB-V87RDj-A4DBXGSiUb7ydj1Tgji5D7CnGLPYXougc5ULrDQJ1DabzlhbW42sUkaAeq4IWRtPbKx9thfWNh-rcmWvNXlbgOwuByhBOoOdbaB3_CnAO-iK6iGjinBO9tBAdWUMEvOug7c0HIJeQe5oR7N2US7SWMdVZBLHurT6R5gYcDhkoAQHAix5AOK1JoOK06eBD0lIB4DDpp1hWnWSCk1JaT0kZMyNk5J5C3hyiuHA1d5ioH5IKPpIpEAgGlCATAihuQIR1KiZAMYhmB0XIeXU6YkAeCZYdHAK0w7bmY_uNjaZuGnhNOeeAxEXUaI8AVEA3HXZ8ZAOyPyA7ZMeERDyIk_HMS_EdWQDwpFgqcZANh6Ext05InwMQe-_h_C7DoPxrp0B0DqdM3SX099nNQEXpp3A2nlOqiozAVQSgYA0cwHR-AsnKNmc81LRYGBYAaDcwAPVdtdHAxV-PZEULpv4aXio4Axdl5TrIkOUhpJONDiAmQshgOyEAcAF4GFwIKSAzR8OEeI704UDBKNoEgKgCQMBHKUF2KWcMtAZNIEDdaDwTh0AACVjaUEEHG1A-Y5AWiDLNsN82QDCTc3ocM-QXApbJDCjyzbaBubi8bDw5XySVdQwyWrGGGvkhRO1loXXqA9fcWRijlkIzyGgJoONfwQUxb8qCcEu25MhxBKgAj_G93qGrEQIyDG6suCC_AWZYJYAIN2LJubQX5jnl9PaeQsnccHcwOQPoJZEXofq0FxnzPgUGNp2zvHMK6R6Tc6aaQdUdPQQgPXPbQaPB2oICoC7cnugEH49gRQPwjLMjC1QFnL4GPk48B5CQ2uXwmhfLaWwas7Bk_20FkEROYArfmEsVncmC2Pfx1gJnixMCyYANoeALQAfXt_D1EHPKQq5AAAXSe8hqrdI3v09ZCnoAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/interactions/dragging/external_gltf_dragging/src/index.ts",
        "description": "Dragging of an external glTF."
    },
    {
        "href": "examples/interactions/dragging/restrict_position/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPAIQAiA8gMIAqAmgAoBRAASESAPgA6qRmKjDyUAIZw4AXkkh0SgE4BrTVNTDhsmEvRGTJxgQgFY4gMp4lABxisIANxg7GAPR2DjBW1oxQaAbG1iY6MFAaIHAEAJ6wcHgwMASa0rEmePFgSYQEbnCIAQEArqhuegDmOFREAWBQlADuAEb2MAACAIw4ACw4AOwB6BAp7Z29_ThEaC2qeTEmAWGBWRZG-aY9lOipYTYz3oexKekwSdcFXRDoBHiIwkMADF8ApADcj1iWQgjUIH2-f0BmwKMzgbmUqQ-HWw0IK1jclDg9gg1A-Sh6cEoUBqtDR6OEsDABA-UKB1gIlDctIB9I2sXO4XISlQ3hUwheSW5vJUhkCwr5cE5gUu0rg5B0EDcBGEaQ8SSIJxqsE0wjgOnISRwAX15ACaEwuAIcDFJoVSoIcvtyr1BtKBHKlWqdQazVa826fVowzGk2mswIAcWtBwACsbSBxIF5YrlTsAsdTkZdsQoEYQAAaECzABCaF0qSQYCUUDgMAAvkXTeaMNgcNayCAqDQ6AQGBAiJidCrgI8LOgADIRuh-AuPBXmWgANQgMC6Q4Ic5hC6UtCc8Gx1C3sQAsru_BAawBVVCRAisXdKY_WACS3HiMAAcicYM-TIIl0ET9uD4IRDnrYQwB0SgiGETQBkydwYEuPwAm8Vcuj8TRyQHDdhFHGFWB0JRGjPVASNnR4AAlKF8HQyIonQ_2EF8e2I8g7GoB8CCfR5WNodjONQQRUEaNBf0efhlFQGBOGoFJiLQXIYggqCYLgkAENcDwUJ0NCML8HAwEXGp4jgHAlL8JQONxVBsMOXDKGHfCFHic8rwgYRVOg2D4MQnSfFQ9C10MxD4nQHBME1ABaLIoA8HR7JiRznOAYRfHIABmLzIJ8jTGigaKiF3RUsCSkxDgAChUVJUHIYRKoASmENRxHwx5qlcxcYFVLJ0owjd53klVgvXJyVTUYQlC6JR7C688VzXDdKoI9EXg-TQiFSRaxuHTRmJMCUVA-RgqO4E8J04HlJUEWAiF7cR0EocganumgcEaHJbpgN6CBLVIX3QSrNCOhNGseetGvJLYAnm2hep6utVFsobUBSPUD1slqppmuadz3THqBW-l1o0rb92R6h9vpOxyD0HJEHpCqQCGAA2IYJi-ABWL4JnIdAAE5Mq-AAmLmJlGUZyA5zKuZ6JQhgADnQCYea5gWRfIHpFZ6dBRgsHoYC-YXMrAM2wEV9Whi5mABaGGB9fVuX0At7mwEykXZcVmB5YFr5slZxXyB-JRWcy0Yhj9qWJcViX0DF7Ihky4XyHMMARfQIZRk5zmlfIEXrLAHpU6UDWviGCuvh6d2JgFpQg-0LnWYF1muaGMB0FFiYlY1kWflGD2g65sAB9Z1mvmsjOufFiulFLr4BeyLnFdL0YVYL2P0EyiYemF1WlBF0Yucy-WO_H6sYHIasuei-Od7AcWm7AJPp85gXU56NfjP9xXWc5_PqYwhMJqTAUAdpXh0FADaIAygVCqCaTANRpY4BgDUaKqcaDEUKiMfyyFAo6BaDBdk1hIbkg6rDfGPU3g9UsoJLGdAxIyQLMIdAxFGjCGKuRT6OgpoYFELRPwHCeSMVRujWh1khIiUYT1SaMkugsTYhI2yUjxKVVGhuKGhxyFwyoX1VhJEhFcMETydAU10CmKUMIBE1kerdgUrNGgoiVT6NIsI7h2M5HCCIiRBi3CmrQxYWw3xhkYBm0vgQM8AlLzyFkWuYQkSLzXlvPYbiSgVoKGJE5aB4VdSkMeC44JBDxzeMaHJNGBBFI0Eqp4qSPJZLDUqQQNRl9MpGR8kuGsNR4CVS-MwoYzCviNSGQE8RNlqAqJkjgcc_ErJjNQIUyqBS3F-E0TEbR44pr8LooYkR25hpbL8IUjxcSaJ0QWas4EAj6LLIIaE4yHEEmKhrMc-Rjzok3jvKk9JVBOg6GgY0D8dkQBeQudYUZkjRLiSmeYmZdDqALLwFcwpoLtGUIRlY3QSh7oCWEDUTy1B0WKjBCqbEmAnEYuItivwHkvDeGxk9F6v0WhuVoN9X6wMtA-E0KCkwbhMVUp0DSnwOBbiwBwJibEQlsaaAJESEktByoYn5TkalEBaUirSGK54rw8DSpAH3eIRBFW8uVQJIV3gNV3BwFcjo3Q9UpmJFAY1FKsUqsFWq4VoqYD4BgKCQgerIS_GdQy16vYcCZlSFMtwHgMCcDwNAIGfLKVuvNTynRHlKpI0PKgZhSbXVmo9d4FFMJOqdUwqIF4uieqYiUnAF1Aqpp1vLU9Xqsx-qWPBbZG0JbYZZtsh9HI_BTV-H-p-V1HL-CUFrdygA2l8AAuvgF4mBjCTQqV0shPbhDxAqauXw6L4RZHiMISgpI3CknJYevwMB2BntJNjPtVMgHCAHQQW95RSSjvHZoMpFTiT8BoGDekRkLSVUqpQZqrVhDMEoEZJyxUCAWTqiSTAcAOUIcSU6kAQzmCbtiLAElbgj1fh_JUFi75sjfkwDO-d2MaMBM6tyKAUB5Z01VJQRt2JGjGE7QS7QPFyVa2xtUtcVGYAAH4Phvg_GJyDbVVoFAgGASqzA5Gye3TkUyqA8MFE6juxUMB901nkFe49qBSMCmMG8Nt8arIGjwKkDGBAahuHpKZkjqGXliZaPGqArC6A6diJ1FQXGrN9V48YfjSg3NEevWJ8yYAnKCGsngMDqA5PtWfTDBQWQ2NKfRRFlhj5hAzTrTWNypxOOghkugJmwhOrWbrcKUQ7gY0CjAOil6KQYIQAAF67ixjMdAqAADkKoXP8arXqDw5AlMQHquZslWX2sNVU5FR8IGMBgfQBl0xaAUg8lTpQDrsKlFcUfEMzLFJrCoGhegL5njTtzK-WlRFdEPjrt_IEkiH2dBdJBWm9Et2JsLT8Nm_xdX6x1eB24SbS4we2Qh8-vJMJ6yBfq7DEL1XW1NeM6xvQ7HhCG1VES7hyEStZBkts09H7xuw_PHW7SMbHjuffeexDIPaBXWY_j7GWsGOY74Ux-Qc1qCpymiqaheoeJ7W3D0TNsX4hs9JDgRbMBi1Bdhl0SnhnBFS5cYw9h3WKg6IK_Ue9iWeFS7zQ2uopiuuMhWL1qbj67IwnHFOFIM4dCVQAkBECAhBA4BfMBQQAAlAAgjwF87BPw4FYJHgA4gAfSAqwZhNU6oNQywpm4hNbufQIEO5NAkv33Q5TxHosBOA6G8AAKScLH2dC6cB8hJDI4QDfY8asVJCsAqRibLZrYBj47n4vLHcGlnPdW4iaZ0MYXP13hBYA-Ld44du0CNBLJQXA6-MCb6cIr71GCBJzvnQdCkSJhBr9Pfv0S2_d-35mKJQ_xGWi9j8DOoY5-Z_WF66v8NJ_TfB_QAjfF_I_d_NiGdEWedX_NHSHcGZHQHHGWaElfPFoGobrJ3GAJHWIFHEwSGXA4QQsYsOAMsciHQSsRAasWsBsIsPlOmCiOMIkVATsbsWgegRAEAUcLQGAGNFdWbeATQZAPybSPBOifSEKRKJATQVpEWEYEWamTSXBXSSQzCAhYyXcUyeAJDASM7IFRmEAOQhQpQrSJCVQ0aUKVwcKSKH6SgWKBIBKYQ2QnAeQ1wzQRsTaBxZw4sVsXAOQJQlMB0BMEQ5IGXXIGQkAJNVOEXPw_AXMYQaKaKJkOgJQnoPFPzHw6IhIInDIvbOIgIkATw3g7wVgPgugAQ1cEIng7IwqdIjAWAaQwwgAPRGCGBFhwC5iULVHgGdAiJaK5lDC6KKPrBINLHLEoKrBrDrEbGSBMWOFwG7EgGaHjGoDYOoA4L7C4J4LQEgFQH6AnEoCZH4GgloDmWEM-znBgV0HQDDwSEoAsHYFQDjR5E-guL-wkhAFGh8J6Ggi6DrGkKuNoEHGUAVUiNqI8LGLIImKoJoJmKLGtCWNBGYLWOQC7A2N7AYB4NaDcGgD8HYGVC7WEJ4JAW1BgB8NaE1FQHjCUMNQETkiIF-hCLhM-PgBPC1FgFhSZHeK6SuKJFMlTjPFcymNoKuMwEUExSEmEJZLFMvmUGIiEiFOlOmM-Jl0Lx8MECcFZkCN3Q4h5M-Jpy8CaM0DhAiKuOwASgHF7BrDKKoAVKchCMuM0B-hSUvicl3CchPByAsEfH1KuNJNgDuLlVJBRkiLVw8PNKwEUBqDJSQBnU0DV2TwDKEMLBNIjE0HnVGKLHGIoNhJVPrALKAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/interactions/dragging/restrict_position/src/index.ts",
        "description": "Interaction example where the dragged points define the shape of the model."
    },
    {
        "href": "examples/interactions/dragging/restricted_plane/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1Delw8lD8SWVgsFgN8pRwEhDUZfx6cJRQAK60DbBgBGWdXASU8ps1HqmijOS6qvxwXEV5p6jncIcmt_dHJumqr3DkGhDyBNtJRR5IiUdCLWAhOAach5KHkYxoTC4AgPECsExfH5_cImRIpTgmFhQYQgAA0IAgcAAQmh-BokkgwPwoC4AL7kuEIjDYHAosggKg0OgEBixVAQIhjDT_YBxLiCdAAGUptFQmlJcqphg1Im-Alo0ngE2oOp4ev4tAAahAYPkpQRTVwAKKWp0AOW83gAmgAFJ2OgCyFs0EGZ0jsGDp6CUFv4nFZXDAGkoRC4AHIAAJwOSKd6aYyqG35TRpuqcCX2riykQAYX4Ng0_B9fTVNeoWUbaAdcqUjeaQdQ_Ga6rlAAlKOoNAOhyORABJXtDp3qGiOudCxvkcTUGN2Ncb_hbqaoJ2oZpoGCO5Wt9sETuruXN3QwNuoDv8LuOn2ULuv9-fuVDVgLdp2HDR40TZNU0zbMFBgPMNALItNBwMB9UWDR4BwLtNEPbdUFLctJUoaUqy4dRyAAZlJLgiAtAAWLgEyTFN02aKB_Dou8ICwQjUE4AAKC4klQcguAEgBKLhXFYKs5WMYwHEw4N5XIot7TlQUsjU21K1ceV8g_f5zStdSSIIATqysM0zguMp0EochFhsGgcGHAgnVgFyCCpJI53QAS02eC40yki4uFHbwA0VOs7guTyYG8x0rCKMo0yIJJrVtEs5VZCSyxEBSlP1GBVJcOBjX43Vb0yI1j2kgyjOK4NDQq49LLlKxxHIABrWxEE66yeDTTA9AAdnKcpyD0AA2WYAE4qJmyj6MCMByhmsb-BgSiZpgeiwHWmb5sqcgwHQGb6PogAmdByECa7AnmtD0EqeiZvKMBAn4SjKnKfhHvQea9AAVnekH-DGvQDvKEHyHIEHZq-67qno_hyjGsaLso-b6L0QIxpgcgYBgebKJgQIccCIn-H4L76PQMb5pB67rvKMmwGqSowHutadtZvQwDB67KKx8o8bhzn2b0a7ThBtDAhByp-Hl37yHm67LqouGAfm0m9HIBmUfoqbKO-j6mYp-b-H8a6YBmoGwaZSiwEokGYEqQJqcqUX-AOvQ3b1hn-DTZLRBBTAoCy_JPA0KA0sIAh5DgRAFLgdANEJxZyHKHAYEWfxiZoRsONz2DczUFCqCIUPBp4VL0wy1rKrTXL8rFHgipM0qSlKnDN3w09zzVeUMC4eRk0LTArn-XudLtcyuEoPQACsiYITSav7vDjyHi8GrVfIuHXWgB93s8LwEwtdPM9uqs7xTu-2KJGgnTRQM0Uf0HldBv4kTe3z_DwG_KcugZxaH0ofCKICP4aEkgVeuB4jzUD3mqHACoT64WQagWBAlgGTlgXfOU-D35gLAnnQ668gyn1DFAA-touDUJDGGCM6Aoy7n4JZBwCwSJpQAMRc25mANMTEiGFUfspWgz9SoZyHLAr-P8_4b2qoArgsj-xkM_pAhhi4NGDjAvAuU6jYEULQiBYMPxmT0KPkwyxUBwy6DYRoaMsYuFUCgLw9MAihHVBEXlBBVwkGDwvmgjBQTjy4OMZojQYiH6KOkYE0-O9qBqNjAA7S28jzqAAPLLHkMsBq5VKpuVsLkpOyxfJunrDAQKWpeISQANqVAALo4FQKCGAABCAJWl_iZPEDkvJywOHWOPuEncrjgBqL7GUO8ixLyv0nLMjQ8zREBP6ZXMp-SCAcJwOo7JPxh4NSaTRSopzmkFXksYdyo9HAkSXkM_4bC7DpP-LoO5Gg2wkXQHAbJq8ACCGgIG1TatQEpBAtkVKSFUmwgVpBun-T6Lg_y3Q1lHNkgASqFJprTBSqgIJ0nFezYw9Jqu84BnzKDfLgICjQZRUDOT0JoBpzSWUNXJSRL5zjfkAqBTgOi8gBJCVEhSv5K8ygdjQM0KSMk5IiCsJhAgGFuAAClpDZLdDgeQdIXDCo-WKnAmFeiHhqcYYAAkcAACoJKsmMDRNMDSAAk5RmmhTvjwfxHduGqKIGgBqFFKKoSgpaZk8y4ACXXJAcU2QaKRrQBIJIsbUBRoTe6712k6JYH9UTQNLEiAhqWPAAS_g43RsTVwEtyb40xoraW1NASFIKluRS1JdhtiUESVggZpU6L6M0HKDllLqW0tQiRJ0h48BCqoNSmVskrLWSiX2jQ6Df66L_HeD8NABJQO_L-W894LIBqDSmAtYaBLTu5TimiF6fkNJddeqll7rrNIkjREGEk01WCPb61AAkf00X_eRHNx782hqLTeuAV7uHUrvc0h9MHn0foCV-4Dma_38CwABjDNEj15tPeBx9t6Wnwcvfe6DT6X1ps9ffUIxgm3MjoRs9Qrb7A7AeeU5RiCklZJgJCggxK7BasWNmASTHeOPI4WmsTfGcCLHkM8mAlpNCVUMTRoq9Hx4tlKr0g9rzNPPnXQe0ZT4byAIPQJE5XAzkVDg1wSz1mWlpqKsJnuL8dh9W4GxzCIJmNzx05ut5zRN3iW82_Nd-6AsSSMX2ExCpwtmYCwJY1pn_w0Cc8YJ-Ywuzpo3dl5ea8tyJnuSRFoaAvW9PHj-GghmAvGaqwQGrXYLMOfOTRa6-VaN9G0tqxsqZKQJMbOkYTNE9AFMcLoYezRn79bkJcewP6JRWJgJQwrKT1GTei3I6JK7ox9ka1urL1WItdliTlrgmFJVbm_BMfCDUBIwDKAuPsy5hSzrlUNCr634Jug6Q1GAbSOnIdEJ9vs3hGxvjACRLi9V9JffQD9zA4Kwe6DgJDjQ0PqBwqUAAfXUdjriPx6ndLrmdjdb4-i3f0ke7uqmhpcXokj8HcAKftTJ8zi0x4aLqORxDqHHOwUE54p-0Q360ACTZyzk02wmeS9QFhrAwueDfow-LmX_O5fS5R7LgDaBFe0QYiBnn7P8ICW50ztHGPUD8otITmiEv1d6-vgvaUsn5PBgRzAI3Fv1em77MOeHHSqOXJUdpYxb9lRZDoJobwlAPPst_hH1UmgBIundJ6X0TocBzg9E6DF_yazeDnBqnASg88AHFscBmya6Gi923vzoVfAbiV3xiTEx6VcKT2lwrgIFR07IOlwYET1HjQMe4_6QVMPtUcDU8em9H6LPOe88F6L5q0v_yK_uiULXmA9eScXebwQa7bff0d8uF35oL20sBOo3lVTZIKTUlpPSRkzI2Tkm1b1GcOAV7zFQPyPFYUBgWUEATARQbkUSG0VEZADwLMHMeCSuRCJ3ftJADwQNNmHAa6DwDUEAOAuCBCJCbKZdNCC0DCLCDZagDwAaEAdA3OLAkAdkDwOiMrVAikbkXAIkbAjwTEX4FEKgkArIOkDeVgnrYmRjdg_AYgOhfwfwXYOgLgkAUbaAdAKgjwUQmAOhJQqAP-CQzghgnAzAVQJQGAcAzASA-AfgtQukMQ_wUbDAWAcCVggAPVznKGuhwBBgUOyEUB4L-FUJACcJBhwAZ08IYNZAf0pBpEHBf0QCZBZBgHZBADgEcQMFwEFEgGaB_z_wAOoHxWAI8DQBTVoEVCpXkB9GTFoGwSoLmUvA8CcHQAxQ0MoEEGyVQBrDkDPBgGqJWVqJACd38L0GTHyBcEcJwNoElApy6JEOsI0I8HCPJEiOfwZFiLfwSPJBRHSJaCyOoByKFHoEQBABAOrnkGgE0GyT-GPGgJAIjnBCmOoOrhBFQF_wUNC3UDbCIG8mgLiJcBwPgADFBFuMwWTHkG6PmRwPmAwmJiDBBNf3iIMKJj6EbHwioO-N6MwHIERPV2hJRNWLGLpHcn8KdGkBmgUMu2EMQBqJwMoGGQgEcOoO6GEN-KwEUB-G8mZGMKoCRJImgMpI8ESgkA5JIgtBIgDFsEEDSSQF5JABuNgEaPmCWGRNYPaUwDmKZIxMWBVKQAaQ8GVJgHxwBNgFRAMJVA8GaXmMfyiLpGWNRNZFtKAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/interactions/dragging/restricted_plane/src/index.ts",
        "description": "Restrict a plane on which to drag to a specified length and width."
    },
    {
        "href": "examples/interactions/dragging/rotation_around_a_point/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1Delw8lD8SWVgsFgN8pRwEhDUZfx6cJRQAK60DbBgBGWdXASU8ps1HqmijOS6qvxwXEV5p6jncIcmt_dHJumqr3DkGhDyBNtJRR5IiUdCLWAhOAach5KHkYxoTC4AgPECsExfH5_cImRIpTgmFhQYQgAA0IAgcAAQmh-BokkgwPwoC4AL7kuEIjDYHAosggKg0OgEBixVAQIhjDT_YBxUSCdAAGUptFQmlJcp43wEtGk8Am1A1Ii1Gh1MAAahAYPkpQQjVYAKLmh0AOW83gAmgAFB320QASQd6hofp4AFl-LQfszpHYMHT0EpI_w5ayuGANJQiFwPAABOByRTvTTGVRW_KaDx1OUS21cWXGrhKDT8ZoR1Ct9WargACUo6g07c7GlDXH9zdbQeFo_9Qpb5HE1CTdhnc_4C6mqAdqGaaBgo69fTVAGFqFkW2gCKn05ns3mCwoYMWNKXy5ocGAdYtTXAcJfNOui6oFWNaSpQ0r1lw6jkAAzKSXBEJGAAsXBphmWY5iAzRQP4iEED8WAgSIcoABQXEkqDkFwJEAJRcK4rD1t2xjGA4pqRjAXD2GW1q2t2gpZFB5Z1q4XH5PwEhsWalq8eBBAkQ2VhamcFxlOglDkIsNg0DgzS2A6sDaQQVJJP66AkR4zwXB4dEXL23hhoqx4qXABkwEZo48EUZQeEQSQyRWGgeN2rI0dWjYsVJHFcZk-qbvxZ7_C4cAGtwon8OJknahxeopZuCndjw4jkAA1rYiCFaIHgAKyVDAegAEz8A1ABs6DoPw_BITBDWnOUgQNYEgR6IE_DlA1dVgOUACcSFMjB1V6CN5QwTAc3dfwMCBNN6AtdVADs03TeU_CBHtYA7QIzWVGN5CBEhdVIft5DoGAbV6OQlQzS95QtZt5TVfw038C1egwfw-3oMd-0NQ1SHVdVDVHbtejoEjejlGArVg2AYAwXo-2CJ15DlK9MHoLVeN6F16BfTd1UtV9gSVK9YCBGA-3w-Qs1tYIehIeUv2EzB3XlDAsPky101gw1nMwVNLX7f4i089VF1NZU5AXeQDULSNAgwQDnV6JrFMeJ5CGgjAUABZ4GhQD5ICEAQ8hwIgLFwOgGj7TAiwkzgvv-OQwotjh5Q4A-RZqO-VBEOblXeZhfm5alwWNqF4U8N2YDgdRAn_P8aBCbJ0o4GMWRepmwd5Tuun6bjMALt4lBlagcC0TRlU8Tacll-MBCVxpcW16aILqA6DcLiRBBhXKzGsdltDbFEVxrhu1DbruapcRgXDyJmZaYFcBcr93daUHoABWjdXo2-er1GgGbpve70Vwar5GOa9AS_aokWfclZ7EQigvdiS8SicTwP2TQQ49JaF0OgLi7Vj4JTbv8KBA5YGaDfh_Xs0DBy6GHLRTOoh_zzh_juPcOAFSzkfuvVAWCNAkQwTAwhcCgFWBYQQjscCA6TwIBGKMEBmQ4OtFwQRmhhFQFjAghMy5-AKQcAscCjsADE1Rqi4xCBnOeICorgJXl7VsjCd6IIVCgu-iUuBGLbGw7BolcETlsTwzQxDuw2MYXwz8C4JHRigKIz-vipEyPjBoRMyZFFUCgCozC6jKi42qNojhpDv7P0oWqah7VaEAXoYwkiHi7EaGSfPJBiCIEPxyUBaxyZUGCTIU_dQAB5ZY8hljyICV_OhQF5EFUbDwGxZR8KLH3JVLhgyNDDJCskryqSmktLacmHANjGk_C3m_AA2pUeCWyuCVAALokPnuY5k_j6kbnUNUuw2xKBcEoPM2-Vh753JdssN-yVUp1wIM0l5xkkgun4DYCyIBZDWzADZTZBzuzPNaQQHAqArYAEIlmLNaQWEiZzxBzJ-fI6Ztz7lwsRTgRY8gOq0HNJoVKbjgFWEiscveR5OL5wvDQWp_xei6BgKeNBzL_gOLEYeDlXLzwSRoCRTZ2z4LlD2fBcVuztl7NxZFRYLhl6cR2K3a5XBR7QNVUo7lIr_ithFdRbV6gnFCvwgazujYCkuI0JkxMLZmgWp5SRdlJ5Eo8uKZYtBDg9Bv3yU6qcNAyjjiDcGGe9FGKKSUvfGxel0Auitm_GxwbYXwswCQx5VibHeBbG3HOGg8KbhTU6hNSbMCfLzboOAhbi3UCBdIJQAB9Gxza8IERsgiw5fTQisT0ifNV-a4B9CqZQMAuqL7XwXJVe-lq26jpLaJaCME4UwGaBxCyvaeArpwIvGAtELY8DwkhKtw7F0Nt3fuw91jw3ChwB2iAWBrVKS4N619kVBQDkLgXG59hMx2CArOqxaBVBvxPbyYd5cD2VWPchPdYCD00SPQheD6EiDmmZMM9u5QJVyvwzsnZuGCPwX8MRwjeGKMVBfUpXF_SnXVoLeBetqAH2RgIuB-DRBwRbtfXBggp7r3Idg6hgTvI6QDubrxvj_HBOIcPSJndjdV1CZQ0Vc9kZNxqagspj8t5MNLHgCRKj5QaOvuE9u1eqhKrvqUvGp8FaYBEpJRxclzh8q4tZD2qwCplRZDoK4p0rp3TegdDgf0boHQACUACCx5vD-kaS6HAShYsAHFm1hkac6eC5B_V2RIjAUNaa6IMSgpQIouLfMqgC0woLbpPQ-nC5F2L8XEvJdSzFjLrolC5fy5cQrxWI2lcYqoCr6BkmhSpTwMkFJqS0npIyZkbJyTyHXCVTsOBL7zFQPyQUqoRSIBALKEAmBFDckolaVEyB7yFifNHF83dKxIA8Kuhq4cGrxxAPmO7z5XzWnfJ-SM354B_lSdQDwFUQBvY-x4dkvkRWQ48IiHkRIvuYl-CiSHJ2sh0ivC9kAa3oTW1XkifAxB_H-H8LsOgX29CLGgOgJHhO6TB38fTxnpPUcU7hxqU7MBVBKBgOdzAl34DY48ETtn_h6cYFgEFAnAA9cO40cDVS-9kRQGO_jM8V9VHAp71cgFZKyWblIaQdkW4gJkLIYDshAHABBBhcCCkgM0LbO29vUAOwwE7aBIDiloIqSguxB60HoZDoZIynYJii9bSgghGmoGPHIHcMBI8TOj93ZnehMz5BcArvntBJSjvTwTqX1s4dm_m5bhk1vlt2_JCiV3LQPfUC90KegR2Tux3kNATQjS_ibmuydkEYIIQE9jiCVA22vums5VmIy12bcuD5_AMMoJwQwGyZmeQGfhl8_mN-YOEY99Ldt3zzA5A-gtiA-f1fHgr83809QU_kOV_R7sBoAdzOHTSBaujvhBADOkgFHnzs8ioArlDt0PjmvlgIoD8EZMyELlQLfuBNdmAR4O5BICgeBJGOBGGLYETHYPvtHmPlvnHvMEsHflDhmmXvDiANgNfosJgJDush4HQe2pvrAKiJfiqB4HsqbuSObgtnXh_ibqyEAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/interactions/dragging/rotation_around_a_point/src/index.ts",
        "description": "Rotate an object around a point."
    },
    {
        "href": "examples/interactions/dragging/simple_dragging/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1Delw8lD8SWVgsFgN8pRwEhDUZfx6cJRQAK60DbBgBGWdXASU8ps1HqmijOS6qvxwXEV5p6jncIcmt_dHJumqr3DkGhDyBNtJRR5IiUdCLWAhOAach5KHkYxoTC4AgPECsExfH5_cImRIpTgmFhQYQgAA0IAgcAAQmh-BokkgwPwoC4AL7kuEIjDYHAosggKg0OgEBixVAQIhjDT_YBxBwaAS0aTwCbUUly76KmAANQgMHyUoI6pEAFl-LQfszpHYMHT0EpzfxOKyuGANJQiFwPAABOByRTvTTGVR6_KaDx1TgSw1cWUiADC_BsGn4AAU-qgYPHqFkU2gjXKlCnmmbUPxmppjTwABKUdQaUvlytygCSQpT5HE1AddirXDbFv4namqAAoqhmmgYH3lbBO42Kxpna73Z6fX6FDBAxpg6HNDgwIrFgq4Dh85oh13UBGxQAKC5JVDkLi3gCUXFcrFjcuMxnlWq4ewQ31Q0NRzf5gINShpQ_QD8n4CR_3NHVQ0NW84ysZ4LjKdBKHIRYbBoHAKwIUdYEIggqSSFt0FvDwsNRd8Li4atvBNAAZRM7guMiYAovseCKMoPCIJJdRA6CCA8OVWVfSMRF_JDaEAzIVRHMDUCyVS4FVbhXDghD_k1ZDlR0kd0LlHhxHIABrWxEEs0QPAAZnKABOMBygAFjASpAnIcoYAANgAdn4QIQp89BAi85yhxgcgwHQZyACYqi8tyQpClLMD0SpyHQPQAFZ-EqQq9GctznMCIqirclL-HKIqgpgQJnJC5zKhgLyivIIqYDCsB-tmIqUpgJq9EC5ygvQLyvNK-qwBC8pBEa5zXPGqqirysAUqK9A3LmwJ-DAZyvPQSpBAuvR0BKvQwECNyYtS7bMpgGA3OCqogr0Pa0qCuaZqa8KfsmwI9C8ypym89AHrc9AUqGtzKjcvLAla8hwc-mA9H8EKivKH6YHa8hfoOoLjsqCq-p6vQTrimACZgDwBK4EFMCgcT8k8DQoGEkBCAIeQ4EQX84EwRYApwGBFn8chhRTKB_HKHANwDNR9yoIgWccoSvRAUTTN06SRFk-Sfz_YzlJKGArnbS8R3HSdM0AjAuHkd0Q0wK5_htrhIJjSg9AAKwSqSREFLTzw7K8nanWDM3yft7eHag48zW8A8kuSxR4RSrdtv30GLBdNFd9BAPQCuJA0rTi_LUutH0xOuCLBvdCbDQ33knh65LDvF2lsBD3nZDLSgBP9S4M0LQgK0bXQO0e34dCHAWaD-YAYmqYfqhCM25Wjh204nKccCugcL1T1BG9vPvG5z68FL_K7tiiO3B2vrhF7sbZKDf22LgzLUC4JQZY8hlgPBEGAaCL5YD_AgLBSoDREGMG0rpHAqBQQwBwI4aAxc6A4FgBOEoKCADUZD3wYVEEAjBWDMC4LwPghUqAADaEAAC6OAf78BwBAv0t4W6XxjiOZeq8-5lAIBoRYttZKPysLQkcmDsGMOYXQdhXDFjyB_jqTQulu4yVzqEF-VcVKnGTPYXouhbaRykQhGgtcjJJgvOmax2ZNJ2PzJPJOiYLGuMzO43M9iCAGOflwRYLgAF_zstwHYXAFQgnUFE2xeYaCAWaPYl8CS6zKGLIEzxNBXyOOiXQWC98B77ium3Zo-TUkhPMS4jMWZwJ1MfrJUJZIKTUlpPSRkzI2TknkEOGyTYcDB3mKgfkgpaD0EQCAWUIBMCKG5E-PUqJkDrn9FuDWO5ILhiQC5HAaUjk6xAL6LZ25dz6n3Iec0x54BnhTleDwDkQDOSOSrFKHh2QiXsS8jwiIeRElOZiX4KIXkLKyHSKSByQBDOhDACegLcBEi4P4fwuw6CnL0IsfB_y4V0nlhPHF-C7ZInwMQKA3z1SLJgKoJQMBlmYFWfACFHh4VEv8DijAsAlywoAHoq3KClHARVTnZEUKCv4-L-VFRwF5UV3zWSdMpDSMsvTEBMhZDAdkIA4C6EKoYXB1BIDNDGRMqZ1AZkijmQstAkBxS0HYpQXYqZ3S0Gvi8qRMiaVOHQAAJURZQQQAB5VA8Y5ATmZkgb104PCQXxXod0-QXB8ppbQSUfRaD4o5Yi75KrunqoZJq_pOryQokFKa811BLVClmfM-iHp5DQE0CGv4I51kLPZuCaNrytYglQOM052T1DZiIBRdZWqXA0vgCaUEPbhG7C9dIuNeqwEIrNPIF5U7V2YHIH0FMzy-nappXug95oRybu3aW9NdISL4tHNIIKIKpEQE7Mun1HgwEEBUHy153QYUzqwIoH4FFmQMqoIe6C6zY0zqIBICD0FzTQRNLYVadgP2ru7bAQN8wlhHtefQ6NPyQDYH3YsTALzWEeCIwAfWw6yskHgAMeA4cq8kqqenFp3ayXjQA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/interactions/dragging/simple_dragging/src/index.ts",
        "description": "Simple dragging of an object."
    },
    {
        "href": "examples/interactions/hovering/simple_hovering/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1Delw8lD8SWVgsFgN8pRwEhDUZfx6cJRQAK60DbBgBGWdXASU8ps1HqmijOS6qvxwXEV5p6jncIcmt_dHJumqr3DkGhDyBNtJRR5IiUdCLWAhOAach5KHkYxoTC4AgPECsExfH5_cImRIpTgmFhQYQgAA0IAgcAAQmh-BokkgwPwoC4AL7kuEIjDYHAosggKg0OgEBixVAQIhjDT_YBxBwaAS0aTwCbUUly76KmAANQgMHyUoI6pEAFl-LQfszpHYMHT0EpzfxOKyuGANJQiFwPAABOByRTvTTGVR6_KaDx1TgSw1cWUiAASlHUGjNqH4zU0xp4AEkhRp-ORxNQHXYs1xcxaC0XUABRVDNNAwMvK2CF1Pp8OoF1uj1ekC-_0wQMaYOhzQ4MCKxYKuA4NCVwtTVARsUACguSVQ5C4q4AlFxXKxY3LjMZ5VquPYQ_rDRrqFkuNeDZRpQfL_l-BJz-adaHDau4ysZ4LjKdBKHIRYbBoHAMwIGtYCgggqSSbN0FXDxgNRfcLi4eNvBNAAZABhM4LngmBELLHgijKDwiCSXV9XDEA5VZXdIxEU9v1oS9MhVJc71QB8XDgVVuFcd9P3-TUf2VUSlwAuUeHEcgAGtbEQJTRA8ABmcoAE4wHKAAWMBKkCchyhgAA2AB2fhAls0z0ECYydILGByDAdAdIAJiqYz9Ns2zfMwPRKnIdA9AAVn4Soor0HT9J0wJoui_TfP4cpousmBAh02ydMqGBjOi8hopgeywAq2Zot8mBsr0KydOs9BjOMuKMrAWzykELKdL0hrkui8KwF86L0H09rAn4MAdOM9BKkERa9HQWK9DAQJ9NcvyRqCmAYH0myqmsvRxv86z2ta7KHNOprAj0YzKnKEz0E2_T0F86r9MqfTwsCPLyAeo6YD0fxbOi8pTpgAryDOybrJmypEvK0q9Fm9yYEhmAPCorgQUwKBGPyTwNCgWiQEIAh5DgRBTzgTBFksnAYEWfxyGFfMoH8cocD9BQhzUccqCIXGtJovt6LksSPFY9ixR4LiZJ4koYCuPMqyXOsG1QNXdHQLh5HdENMCuf5VcfP8X3-Sg9AAK08ghBIfedNE16htcbN9dfycsNcXD360bVcn0NeXl04s9lbVi28CTTR2wzLR9cvdADYkZ3_jj5NE80b39Vw-OU10DsND3DjqP96tPd1nBlorN2A9QXOy-zhOS6T8O5Tb4u0yTlmwEnNsf0tKB899s0LQgK0bXQO0S34ACHAWF8KYAYmqapB5CNiOLlMAXx3WB_ggN9KgaU_GD4-TqBwVBQRgHBHGgdAFVQHBYHrEoL4Aah__dAKiBEmJO-D8n54Bfm_AA2hAAAujgOedgcDyEWH6VcPs_YLmrAvJePcygEA0IsNWbFw5WGAUuUBmBwGQLoDA-Bix5CIJ1JoMS5dWLOl3Gw1AZIKTUlpPSRkzI2TknkAWVSHYcB23mNw5AApqC0HoIgEAsoQCYEUNyLcepUTIB9PzAMQsRxPmYppEAOkcD-XMWLfsejBbJlHExDQE4pwzjnFXASSBdLmN5r5Dw7I6KfmXB4ik3JcBEisZiX4KIPA6JAFkOkTsgmiOhDAMeiIeREi4P4fwuw6BWL0IsF-0SPBJI5mPfJL91ZInwMQKAvj1SqJgKoJQMB1GYE0fAaJKiSkpP8PkjAsANBFJAAAPV5uUXyOBopWOyIoCJfwhnDOijgYykzfGsh4ZSGkaYBGICZCyGA7JYn6wMLgQUkBmiSOkfyQUCiRRKJUWgSA4paAEUoLsAACu6WgTdokEKIfUpw6AABKKTKCCAAPKoCInIesOMkB_KbB4J8Qy9DunyC4QZZIPC0ElH0WgQzum1JAOs8kmz-EMl2UIg55IURnJaJc6g1z5HCgYCokW8hoCaHBX8Jc2iVEE3BHCkxIsQSoCkVYhUIJ1BEQ9IhbReyXD1PgCaUEgqG7unkL8whiLYmUGnBzM0mrBH7PqZgcgfR8zVmiQqnVZqLXmiXIa61VL6l2A0LBIZNZpDWXCQQiAhYtX_I8HqggKhMUmO6AkpVWBFA_EQsyZpVBLUvm0QipVRAJCJpfOaF8JpbB9TsIGnVArYAgvmEsK1QT76YDqR4bA5rFg1qQFAjw1aYAAH0S0dKxaoykCTYEkt4VsukFKbWsnHUAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/interactions/hovering/simple_hovering/src/index.ts",
        "description": "Simple hovering of an object."
    },
    {
        "href": "examples/interactions/selecting/do_not_deselect_on_empty/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1Delw8lD8SWVgsFgN8pRwEhDUZfx6cJRQAK60DbBgBGWdXASU8ps1HqmijOS6qvxwXEV5p6jncIcmt_dHJumqr3DkGhDyBNtJRR5IiUdCLWAhOAach5KHkYxoTC4AgPECsExfH5_cImRIpTgmFhQYQgAA0IAgcAAQmh-BokkgwPwoC4AL7kuEIjDYHAosggKg0OgEBixVAQIhjDT_YBxLiCdAAGUptFQmlJcu-Alo0ngE2oGpEWv4tAAahAYPkpQRDTwAKKmu0AOW83gAmgAFO22rgAWRNmggzOkdgwdPQShN_E4rK4YA0lCIXA8AAE4HJFO9NMZVBb8poPHVOBLrVxZSIAJJCjT8cjiaiRuw-qu0Gt1qaoO2oZpoGA-3WwOv-1D8ZoF1Cx-OJ5MgNMZmBZjQ5vOaHBgbWLDTwHBoVu1-uoQtigAUFySqHIXGPAEouK5WGW5cZjA4twH5Vxc5brZrqFlP3mpauPK-T8BIr7ajA5rfpQ0rHuWVjPBcZToJQ5CLDYNA4GOBB2rAmEEFSSQVugx4eEhqK3hcXAABLeL6ioAMJnBceEwARPo8EUZQeEQSTQVasEEB4cqsteRYiM-EHvvYLhwPqh5Gn-_xyQpd4gWB_zGjqeodvBco8OI5AANa2IgBmiB4ADM5QAJxgOUAAsYCVIE5DlDAABsADs_CBN5znoIEjlWbWMDkGA6BWQATFUjm2d53nRZgeiVOQ6B6AArPwlQZXoVm2VZgSZZltnRfw5SZZ5MCBFZ3lWZUMCOZl5CZTAvlgG1syZdFMCVXoHlWZ56COY5OVlWA3nlIIFVWTZfWFZlqVgNFmXoLZo2BPwYBWY56CVAqlR6Og2V6GAgS2cFMVLQlMAwLZXlVJ5eirbFnmjcNlV-c9A2BHojmVOUTnoOdtnoNFnW2ZUtmpYENXkH9D0wHo_jeZl5TPTAdXkC962eVtR1Wa1zV6NtoUwOjMAeJxXAgpgUACZ4GhQDxICEAQ8hwIgz5wJgizuTgMCLP45DCjWUD-OUODpgoC5qKuVBENTFncTOfG6vJHYiSIYkSU-L7aTA2xRFc1b7h2XY9mq8oYFw8gJrmmBXP8JRG1-gnSlwlB6AAVuFwlKag_67po5vUJbvbqWq-RcC2oftuH3a9se7vWuJYo8FJhvG0bLiDgew6jpoNvoPK6ClxIv5BypMD54XY5aMB0faLX_v15oN4STwedt7oRcaILYDrkOAY_MyUeWn6o9BlAIa6Og4aNvwndyj3I8jg3OCYGvBAAPKdpK2TqUyLIwF3pt7gnnZJ2qOAKnHbYF33DfHjv7caOnind7p1A4KgoIwC3lGHA8hFjpmPM3B-YdUBL3gpkVudYygEA0IsI2YlP7f01r_f-mAcCLHkAvM0mgFIry_mXJUKo6AdwdM6V0no7Q4ArC6O0AAlAAgoxbwFZd5OhwNIO0io7ScIAPq718L4UkV5bz3gsoKeYsAcBQEoM0MiIAd5eyHh4a8coMHkOVFkKhGhjw0JdO6L0jDmHsM4dw3h_DBEiJ4ZIm8d4HxyIWIApRKiPDqOoFoz-YlSFkgpNSWk9JGTMjZOSeQtZjJFxwD7eYqB-SClVCKRAIBZQgEwIobkF4LSomQKmGWmZ5ZLndgWJA1kcCxWqcrWcxS5bqDKSuAe64TSbm3CHR-WtKkgCstUqW0UPDsl4mBQ8vTEQ8iJHUzEvwUQeEKWouw0oFkeGidCWupskT4GIFALg_h_C7DoHUvQixoDoFWSAdZos9mnPOVsqZuzhkaiyTAVQSgYA5MwHk-ACzMnXNrv4U5GBYAaEuQAPSluUaKOBMp1OyIoWZfwIWZRwI5WFwzWRBMpDSEcYTEAn0iWo-eBhcCCkgM0eJiTknUFSQwTJaBIDiloIqSguwPQJloFfBZyDUEvKcOgFhtdKCCH3oxOQ3YqZIF5X2Dw7tLl6ATPkFwYKyQeFoJKPotBLkAqgMM7FIS8UMgJREmA7IQAonJS0Kl1AaVCnoOkzJit5DQE0LvP4HYCmZLpuCKV5kBSJhBKgBJdStwgnUIxQNwoCmEtlSAeAvpQS-ofrsHlKC43zE3KLf08gFmxpeZgcgfQawHjzaagt4Vi0mg7Dmstp8XnLJwpcu00hPIzOQRAOsaa-UeEoMsFQqr_XdGEmq-NWBFA_AIsyD5VAS2wQKTKl57EJAztgiaWCvpbAzTsN2uNPrYBCvkcsHp_qcFSpGWOotixMALIANoeDPcI_dvzR3Do8AAXSxeSHFoTjWxtZABoAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/interactions/selecting/do_not_deselect_on_empty/src/index.ts",
        "description": "When clicking on an empty part of the scene, the objects will not get deselected."
    },
    {
        "href": "examples/interactions/selecting/multi_selection/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1Delw8lD8SWVgsFgN8pRwEhDUZfx6cJRQAK60DbBgBGWdXASU8ps1HqmijOS6qvxwXEV5p6jncIcmt_dHJumqr3DkGhDyBNtJRR5IiUdCLWAhOAach5KHkYxoTC4AgPECsExfH5_cImRIpTgmFhQYQgAA0IAgcAAQmh-BokkgwPwoC4AL7kuEIjDYHAosggKg0OgEBixVAQIhjDT_YBxLiCdAAGUptFQmlJcu-Alo0ngE2oGpEWv4tAAahAYPkpQRDTwAKKmu0AOW83gAmgAFO22rgAWRNmggzOkdgwdPQShN_E4rK4YA0lCIXA8AAE4HJFO9NMZVBb8poPHVOBLrVxZSIAJJCjT8cjiaiRuw-qu0Gt1qaoO2oZpoGDN3WwOt29Q0H2-8HiAcwOv-1D8ZoF1Cx-OJ5MgNMZmBZjQ5vOaHBgbWLDTwHBoVu1-uoQtigAUFySqHIXFvAEouK5WGW5cZjA4TwG8pcLmlrWpq1BZMBealq48r5PwEj_tqMDmqBlDSre5ZWM8FxlOglDkIsNg0DgC4EHasDEQQVJJBW6C3h4OGou-FxcAAEt4vqKgAwmcFwUTAVE-jwRRlB4RBJKhVroQQHhyqyr5FiIv5IYB9guHA-rXkaEH_BpWkfnBCH_MaOp6h2mFyjw4jkAA1rYiBWaIHgAMzlAAnGA5QACxgJUgTkOUMAAGwAOz8IEoW-eggTeS5tbTmA6AuQATFU3nuaFoUpZgeiVOQ6B6AArPwlSFXoLnuS5gRFUV7kpfw5RFcFMCBC5oUuZUMDeUV5BFTA4VgP1sxFSlMBNXoQUucF6Ded5pX1WAoXlIIjUuW541VUVeVgClRXoO5c2BPwYAud56CVAqlR6OgJV6GAgTubFqXbZlMAwO5IVVMFeh7WlwVzTNTURT9k2BHo3mVOUPnoA97noClQ3uZU7l5YErXkODn0wHo_ihUV5Q_TA7XkL9B3Bcd10uX1PV6Cd8UwATMAeMJXAgpgUBSZ4GhQGJICEAQ8hwIgv5wJgiyBTgMCLP45DCjWUD-OUODpgoW5qPuVBECzTmiWuEm6ppHZySIClKT-f4wCO_xQCqdCaHG6HaHaip2tx3gAPoAPJOnKCrKlk9saLeDrOq6np2jgFYunaABKACC7sVj7ODSC7buez7pIvjA76ft-Ig8IKkGoKCMCGbejAVlOQ7W6wuc4KXmBKdhEELDAOBQJQzS3rnLeiMX7ed93t5N33TnF_8lDLPIyyGfpHY4NPgvLHAADaY-N_wNgALr90XbewMPPfL7PBCKfJF_aTwKmmeXJTl-emiXh2XY9mq8oYFw8gJrmmBXP8B-UE0LSi4JQPQAAracskdKoEgk_NsV4369kMmqfIXAWzP3bNQZBapbwgWktKK-FtVK0G2FETIMBBxXlnPOB2uh0DynQIwiQ4E4F6SodA2cC4tCwTQX6CcEAa4EFoTwt8_cEEvxwd2XsOAFSYMQR2URmhbwuGodwzQxCRBqK4boHhUswCHhnAGH4zJUGWj9CYoMUAQwMPDI2fgmEHALHQnzAAxIY6o1QQhmzFDwMATtbywH-BAQylQGihMYJQo21BG5lxwI4aA6ATyoE7nQZoJQIkAGosnviwqIBesTN6JKgMkuga8IA7xwOgKMOBZ7plHhYhRUjUAOKcTousZQCAaEWOXBSV8rCFNScUvASSUkVKqYseQNSzSaC0uI-SMZXwLNQGSCk1JaT0kZMyNk5J5C1lsnQnAED5irOQAKagqoRSIBALKEAmBFDcifBaVEyBUyq0zBrHcBCCxIFcjgNKAKdbrg-erdQ3y9waAPEeE8cAzzVhaR4RyIAXIAuVilDw7JxIIWvH8ik3JcBEmBZiX4KIkV3KyHSWSeL9nQioVcAl-BiBQC4P4fwuw6DAr0IsJJSKPC0rliy7lSSGVIiZSQTFGp7lWyUDAR5mBnnwHJfyukgr_DcowLADQfKQAAD1lblBSjgIqwLsiKBJX8HVuqio4G8sazFrI1mUhpHOLZiAmQshgOyEAcAGEGFwIKSAzRjmnP5IKK5DA7loEgOKWgipKC7A9AmWg2DcWIG6b0qVTh0CxyoZQQQXtUDcTkN2ZmSAM19g8AQnVegEz5BcNqskHhaCSj6LQHVAqqGYqdRs11DJ3U7K9eSFEgaWghuoGGy5wpI2MUTPIaAmgvZ_A7K8u57NwRluRVrEEqATnApPCCdQ3FExUVeR6lwUr4C-lBBuhRuwkUVqlfMY8ct_TyCReeyt0ryB9BrFeD9g6pWYB_XSE0SiFAAc9VKuwGgyI6rtNIYKxLukQDrA-npX7l4qEbci7o1LL1YEUD8KizJZVUD_ehV5j6PCCQkGR9CJp0K-lsKtOw6HM3iRvbAXN8wlj_rxWPSVNGsA_sWJgJFa8PBjw9uu2AqIgMqg8DvR15JnWbP7Z-1kWmgA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/interactions/selecting/multi_selection/src/index.ts",
        "description": "Select multiple objects at once."
    },
    {
        "href": "examples/interactions/selecting/multi_selection_and_automatic_deselection/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1Delw8lD8SWVgsFgN8pRwEhDUZfx6cJRQAK60DbBgBGWdXASU8ps1HqmijOS6qvxwXEV5p6jncIcmt_dHJumqr3DkGhDyBNtJRR5IiUdCLWAhOAach5KHkYxoTC4AgPECsExfH5_cImRIpTgmFhQYQgAA0IAgcAAQmh-BokkgwPwoC4AL7kuEIjDYHAosggKg0OgEBixVAQIhjDT_YBxLiCdAAGUptFQmlJcu-Alo0ngE2oGpEWv4tAAahAYPkpQRDTwAKKmu0AOW83gAmgAFO22rgAcRglBsBHpShN_B9AFkTZoIMzpHYMHT0KG7D6PT8iJN1Cn-JxWVwwBpA1wPAABOByRTvTTGVQW_KaDx1TgS61cWUiACSEfB4l1sHIBDt6hoPs7Qo0_EHU1QObHE6n4modtQzTQMEjvYg_Zgg6jqH4zUbqHzheLZYrChg1Y0tfrmhwYG1iw08BwaFok-n1CbLcllGldsuHUcgAGYuFPIsiBLEBmigfwiBNH4sF_VBOAACguJJUHILh0IASi4VxWHbOVjGMBxX2jeVgPra1NWoLJaMtNtXHlfJ-AkSjtRgc0WIAgh0I7KxnguMp0EochFhsGgcCPIdYBkggqSSTt0HQjxRNRQiLi4AAJbwI0VABhM4LjtRThR9HgijKDwiCSPirQEjw5VZfDmxEcjuOo-wXDgfU0KNRj_n8wKiPYzj_mNHU9RnIS5R4cRyAAa1sRBEtEDxQPKABOMBygAFjASpAnIcoYAANgAdn4QJquK9BAkK0Cp13MB0FAgAmKpCty6rqq6zA9Eqch0D0ABWfhKnGvRQNy0DAgmibcq6_hygmyqYECUDqtAyoYEKibyAmmBarAU7ZgmrqYA2vQKtAyr0EKwrptWsBqvKQR1tAnLboWiaRrALqJvQXKXsCfgwFAwr0EqBVKj0dApr0MBAly5rusB_qYBgXKqqqSq9BBnrKpep6Nrqon7sCPRCsqcoivQNHcvQLqLtyypcpGwJtvIWn8ZgPR_GqibyiJmBdvIYmwcqyHEdAk6jr0KHWpgMWYA8ayuBBTAoCczwNCgOyQEIAh5DgRByLgTBFnKnAYEWfxyGFSd4PKHBLyrNQHyoIgtcy2yYIc3UApnVyRHczyyIomKYG2KIrgXb9UBXNc1XlDAuHkIs60wK5_hKeO634wDKD0AArXcCAY1AmI_TRFxnNP1witV8i4cdPyb5dV3XdCS-c6UPLFHhvLjhP45cAcl1QfdD00TP0HldBl4kWumOn6v9yPLQ2PbrgeygPsYBn-fd4IzybOT2eW7VHAFS7xuU_PzR0K3vddF3kegp4D-CB3g-GAYAnyf0_LGKAbdLSH2jD8OMCZ0BJhzEJBwCwAImwAMQgOqNUEIUdR4FgAnhWA_wIARUqA0MhjBMhxWoDgVAoIYA4EcNAdAr5UA4FgKuEolCADUvDCLCVEGFGc9DGHMLwKw9hABtCAABdHAiC7A4HkIsCs6ED5Py_LPZBwAaEzzKMGRY8d3I_ysCIuhDDMASKkXQWRCjFjyCUbxTQgVL5uQId5GAI5_hQBVHQReYAiHSDtIqO0xlvAAH0ADyTo5QKmVFkAJGh0IOmdK6T0docCdhdHaAASgAQQiZ2WJOAQlhIiTEp0pI8IwEIsRUiIgeCCiYlY-ObF0KMG7FuHcg5hzClYHUsRmAr6iBaQsJhUBKDNA0YwsxogIBgDwgAQjaYRV8BAXyoFGc0kKXBKDLFUf8NiFiOEHPNssOA0i2n0P4DYOROzUF1wmZw6Z6FzlHJ_plbyiFUCLGZFwTA_8ZzynWIvCaNDBToAeE0mhBBvASgDMsdCBEiIkSEeY0-28v4PiBViwcszMDzJ4OyLgE0cHzPwb_UIFFfn_KgFAJI-jq40TaTHeUlwGw610PSxlzLByssYZPbOlAPz7KWQ3Zw1cQW6GXt0BMLsHC6C4HoKeihyCLItMvXSSQDlcA4qOdlXFCgMpVfHIJGgOIaEwGvGglBhXeOFFwPxSS1RaD8WlTOTLKBFy0JKnu1L_6AI0J7fFgkMVcDaWUU5clbDRMOcsFSTo7kwA0iAJQlAAIeHwtIyoCi2nLLcj_dy7jUBkgpNSWk9JGTMjZOSeQU4UoLxwBXeYZbkACmoKqEUiAQCyhAJgRQ3IcIWlRMgC8lZrw-1vIPRsSBso4B6ougOIByyTpvHeS0D4nwmhfG-f1KcPAZRAKBRdHsuoeHZPZTiaF50Um5LgIkK7MS_BREe_tWQ6Q1zvQ26Ep8k5InwMQSB_h_C7DoCuvQixWFHo8L-l2kCoOsIAzyJ9IAr0Du8UoGAQ7MAjvgO-uDdIEP-CgxgWAGhYMgAAHoe3KF1HAE0V3ZEUC-v4VHqMTRwIVRjl7WTlspDSA81bEBMhZDAdkIA4CyoMLgQUkBmgtrbfyQU3aGD9rQJAcUtBFSZvkOmH10qfxICMRuDwTh0B5NPpQQQ0TUDGTkKuTWJmNDGI1CAQeVG9BFnyC4SjZIPC0ElH0WgVH4On0vQJytwmGSidrRJ8kKJ5MtCU9QFTXbhTqc0oGeQ0BNDRL-DOMd_bdbgmc8ev2IJUCtpXa-EE6hjKBiUmOsTLh3PwAjKCMrWjdhHtM-5-YL4XZRnkEe1rZnMPkD6JOWeY34vucwFNukJoZwjbm-J9zdgNDySo3aaQlVn3BggIOPrrmJvnJUP5498qV3YEUBmYUzJsNUBmwBMd_WPAwEzAQZ7AETQAQjLYb6dhTtufsl12AVn5hLFm3etl6H2tYCm4sTAR7pEeDaZE0rsBUQLZVB4OR_HySCarbF8brIKdAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/interactions/selecting/multi_selection_and_automatic_deselection/src/index.ts",
        "description": "Select multi objects, some of them automatically and deselect them after an interval."
    },
    {
        "href": "examples/interactions/selecting/select_outputs/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1Delw8lD8SWVgsFgN8pRwEhDUZfx6cJRQAK60DbBgBGWdXASU8ps1HqmijOS6qvxwXEV5p6jncIcmt_dHJumqr3DkGhDyBNtJRR5IiUdCLWAhOAach5KHkYxoTC4AgPECsExfH5_cImRIpTgmFhQYQgAA0IAgcAAQmh-BokkgwPwoC4AL7kuEIjDYHAosggKg0OgEBixVAQIhjDT_YBxBwaAS0aTwCbUUly76KmAANQgMHyUoI6pEAFl-LQfszpHYMHT0EpzfxOKyuGANJQiFwPAABOByRTvTTGVR6_KaDx1TgSw1cWUiACSQo0_HI4moDrsxp4iYtKbTqAAoqhmmgYFntDBYKmzah-M1w6gXW6PV6QL7_TBAxpg6HNDgwIrFgq4Dg0LnU1NUBGxQAKC5JVDkLgzgCUXFcrFjcuMxnlWq49hD-sNGuoWS4R4NlGl64P-X4Ej35p1ocNM7jVmeFzK6Eo5EWNg0Dg9YEAWsCAQQVJJPG6Azh4X6omuFxcAAEt4JoADIAMJnBcYEwBB5Y8EUZQeEQSS6se14EB4cqsiukYiDuT60AemQqpOp6oOeLhwKq3CuHeD7_Jqz7Knxk7vnKPDiOQADWtiINJogeAAzOUACcYDlAALGAlSBOQ5QwAAbAA7PwgRmXp6CBDpqkpjA5BgOgqkAExVDpGlmWZbmYHolTkOgegAKz8JUwV6KpGmqYEIUhRpbn8OUIUmTAgSqWZqmVDAOkheQIUwBZYCFbMIVuTAKV6MZqkmegOk6eFiVgGZ5SCMlqnqZVMUhQFYBuSF6AaQ1gT8GAqk6eglSCFNejoGFehgIEGl2e5vXeTAMAaaZVQmXoA0eSZDV1Slll7dVgR6DplTlLp6BLRp6BuSVGmVBpAWBOl5CXdtMB6P4ZkheUe0wJl5D7UNJmjZUUUFXlehjQ5MBAzAHhEVwIKYFAlH5J4GhQKRICEAQ8hwIgO5wJgixGTgMCLP45DCsmUD-OUOB-gonZqH2VBEGjykka25HifxtEiPRjHbruomsSUMBXEmeaTkWJaoPLujoFw8juiGmBXP8csXq-1FcJQegAFZOTRIiCueY6aEr1Aq6Wt5q_kXA5g7E5O8WpYzpehoMWKPDMTL8uGy4Vb5jWdaaAeGAHugmsSFxPGVlbNb1logluxWUcx1nq6McRive4WvtqzgM2e8mZcF5oM6RxnuhZ0HU4iE31Yt32MBgAOXcWhAzKu_qXBmoPVo2ugdoZvw74OAs16EwAxH31TVCEEvB6617LrA_wQLelQNIfjDsRJ1A4KgoIwDgjjQOgCqoDgsDFiUJ8ANQfyuH6iLx_FXxvnfPAD8n4AG0IAAF0cDTzsDgeQiw_QzlzjXR2qBZ7z07hsbYGhFjy3om3Kw_9JyAMwMA0BdAIHQMWPIWBOpND8SLnRZ0K4mGoDJBSaktJ6SMmZGyck8gUxyVjjgc28x2HIAFNQWg9BEAgFlCATAihuSLj1KiZAPoOYBm5t2S84YkBqRwB5Ix_M2xaK5uoXRvYND9kHMOUcpd8weCUiAVSRi2ZuQ8OyMiD4pwGIpNyXARJTGYl-CiZxCish0hov4wR0JKwKyRPgYgUAuD-H8LsOgpi9CLAfs4jwcTGapJyQ_RJPJgkgG8YomAqglAwGUZgVR8AIkFLpEU_wOSMCwA0PkkAAA9Nm5Q3I4BCqY7IihQl_F6X0kKOAdIjK8ayDhlIaS1h4YgJkLIYDshAHADWBhcCCkgM0UR4j-SChkSKORCi0CQHFLQDClBdgAAV3S0DLs4gguCyweCcOgAASpWSgggADyqAsJyGLKjJAXy8HqhAJeXpeh3T5BcD0skHhaCSj6LQXphTKxeOWVwtZDINl8O2eSFERyWinOoOc6RwoGAKN5vIaAmgQV_EnOohRmNwTQpcbzEEqAxGmIVCCdQWEPQQXUZslw8L4AmlBHymuuxPnfPhfMIcjMzTyGcbKn51TyB9GTE43hWz4WYCNXSc0k4dV6vJfCuwGgQK9ILNIEyISvkQFTGquFHhKDLBUOilx3QYnyqwIoH4EFmR1KoCa686jYUGoIhIWN15zTXhNLYdqdhfUGt5bAQF8wlimpcdfTAXjw1GsWBWpAYCPDlpgAAfQLc0jFijKQxMgUs8kKzuGkv1ayIdQA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/interactions/selecting/select_outputs/src/index.ts",
        "description": "Select outputs."
    },
    {
        "href": "examples/interactions/selecting/select_outputs_without_effect/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1Delw8lD8SWVgsFgN8pRwEhDUZfx6cJRQAK60DbBgBGWdXASU8ps1HqmijOS6qvxwXEV5p6jncIcmt_dHJumqr3DkGhDyBNtJRR5IiUdCLWAhOAach5KHkYxoTC4AgPECsExfH5_cImRIpTgmFhQYQgAA0IAgcAAQmh-BokkgwPwoC4AL7kuEIjDYHAosggKg0OgEBixVAQIhjDT_YBxLiCdAAGUptFQmlJcu-Alo0ngE2oGpEWv4tAAahAYPkpQRDTwAKKmu0AOW83gAmgAFO22rgAWRNmggzOkdgwdPQShN_B9_toP2ZnlQUAkkbsnFZXDAGkoRC4HgAAnA5Ip3ppjKoLflNB46pwJdauLKRABJIUafjkcTUVPRuWtuMdruoO2oZpoGA-5u62Cdu3qGg-6cwTv-1D8ZrV1AZrM5vMgQvFmCljTlyuaHBgbWLDTwHBoAedqaoGtiwVZTJ0dBOyjiSCnIdcK4XAABRmLAZRZD8o6klwNhwHA64wBBBBQc0ACUgGsI2coQGAIHfr-ED_k-OCKBoRCUvq3CuDRXAAOTNO2QroHRGFNlYar5FwBG4URJpPqBEiwDBwBcHiZRwQhG5cKyaG1iIGYwCyMBXHhwE8X-_HUKRmgUfBT5cAAhLRdGYOKR6sdhIg8BpfFDjgN4AI6LPABAerplECWhvJRKgwFkXpVGYVZVg8LhIEBZ51CASZjG6LQLFsXKoVcJx3E_rxxHUIJ5giWJoIDLBeqITJcnJaIrLlbJ8k8JVW7yZwwEXEkqDkCBGGuFh7GhMYDg3gG8pcBWlrWpq1DvsNVqUNKgHyvk_ASH12owOaI3TQQwHdTwzwXGU6CUOQiw2DQOAbgQdqwMdBBUkkzboMBHg7aiGEXFwAAS3i-oqADCZwXBdMBXT6YXoGUHhEEkq1TdKHhytVcrGL1xq0INLj6dQY2oO-aNBUB_DzYtyMwLq6N-Vt2xEQA1rYiDlTwHgAMzlAAnGA5QACxgJUgTkOUMAAGwAOz8IEguc-ggTswzHbLmA6AMwATFU7PM4LgsK5geiVOQ6B6AArPwlS63oDPMwzgR63rzMK_w5R6_zMCBAzgsM5UMDs3r5B6zAwtgN7sx6wrMB23ofMM_z6Ds-zhvW2AgvlIItsM0zwdm3rWtgArevoMzUeBPwYAM-z6CVAqlR6OgBt6GAgTM5Livp6rMAwMzAtVPzehZ0r_NRxHdsix3oeBHo7OVOUHPoDXzPoArfvM5UzNa4EjvkMPrcwHo_iC3r5QdzAzvkJ3Of8_n5cM17Ht6AX0swDvMAeMDsGgkpUOeBoUBgyAhAEPIcCIIjcBMCLF5jgGAix_DkGFO2KA_hyg4CLAoI8ahzxUCIA_cqRRP4QxJlRWGCkyrPhEIjLgMB5z_GTFkOgmhMzTW0HaRUdpvreAAPoAHknRygVMqShaoNDAQdM6V0no7Q4GbC6O0AAlAAgkw5s7CcDSHoYwlh7CYLARgB1Lq5U3z_FQM_WawFGBTiUsuc6ZDWAaJwHozANVRBvgWDAHAUBKDNGAtYjRtjtrjX-JQZY8hlizRxiRXxP9lhwAANruKsfwGwABdTxDhxoOKcS44CIT_EEAIVYFwGBbJZT8h4VhfiAkuBnAlB-XAAAGRTQkbC4AAEmAOk5Y0SbCskqVk0qDUiFI36ijEoKl7yaEHE-EcY41TygwFweQ2YKyYCuP8AZQ1KwNkoHoAAVqYzG74hntkfNQMZ45ZppX7MM_Zw5RzjmApNa0BCEa9OWtsKIH4ylPlXIhLQuh0DynQN8iQ2z_ilNMauDcWggJpSXCuXQHzgKdN2SMg5ly1Q4AVKcvZQ53mguAkCqFo5NB3JEGAWhwFYD_AgLNSoDRyWMA_KTKxz8cCOGgOgG8qAnF0GaCUKlABqblSVrK0qovSzAjK8DMtZeEiAsScDoCjKRRYRY3GWi4GihFqAeybReaYsoKEXKlU6TwIJ2kolMqgCyugkrpWLHkLKs0mgqKwtsXVWSjrOBkgpNSWk9JGTMjZOSeQHZKaIRwOs-YqB-SClVCKRAIBZQgEwIobkrULSomQAWBBJZkEnkmtWJAjMcBKwLeg_cGakHqGzWeDQF4rw3jgHeNsaqPC0xAAzAtcCFYeHZODBaz480Um5LgIkxbMS_BRE2uNWQ6QECbR4AN0IlJXAHfgYgUAuD-H8LsOgxa9CLGZTOkAc7IGrp3cyxdSJl0kE7RqeNpClAwETWZcgKbx2zrpEe_wO6MCwA0PugAenA8oCscB62LdkRQI6_h_r1jgdmwHO2sndZSGka5vWICZMpdkIAEL6EMIy6gkBmghrDRG6gUaGBxrQJAcUtBFSUF2B6bMtBzlNt1RODwTh0ASKUpQQQrDUDfTkHiljGgXLXsmvuvQ2Z8guB_WSDwtBJR9FoPuw9SlO2Ic9ShhkaHfUwEwyiQUBGiPUBI0KegMa42oPkNATQrC_hPlTXGkEYIIR9tQSCVAobi03hBOob6OYrqpvQy4a98BfSgnBDANFuxhOiY8PMa8kD_TyCbcFtjN7yB9HbEOVLunr2YEy3SLSqBku5eUteuwGgzr7rtNIfmw6UJEWnUgVj16QkqFk827ozXQtYDIhKYUzI71UGy9NVNrWPCAxTMuaaJppq-lsInNMLWRPpec5Frj8wlg5b7e4q9k2sCZcWJgJt4SPDuOYet2AqJ8sqg8LEhD5IkNeu02l1k72gA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/interactions/selecting/select_outputs_without_effect/src/index.ts",
        "description": "Select outputs without displaying any indication of doing so."
    },
    {
        "href": "examples/interactions/selecting/selection_and_automatic_deselection/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1Delw8lD8SWVgsFgN8pRwEhDUZfx6cJRQAK60DbBgBGWdXASU8ps1HqmijOS6qvxwXEV5p6jncIcmt_dHJumqr3DkGhDyBNtJRR5IiUdCLWAhOAach5KHkYxoTC4AgPECsExfH5_cImRIpTgmFhQYQgAA0IAgcAAQmh-BokkgwPwoC4AL7kuEIjDYHAosggKg0OgEBixVAQIhjDT_YBxLiCdAAGUptFQmlJcu-Alo0ngE2oGpEWv4tAAahAYPkpQRDTwAKKmu0AOW83gAmgAFO22rgAWRNmggzOkdgwdPQShN_E4rK4YA0lCIXA8AAE4HJFO9NMZVBb8poPHVOBLrVxZSIAJJCjT8cjiaiRuw-qu0Gt1qaoO2oZpoGDN3WwOt29Q0H0DmB1_2ofjNAuoWPxxPJkBpjMwLMaHN5zQ4MDaxYaeA4NCt2v11CFsUACguSVQ5C4V4AlFxXKwy3LjMYHIeA_KuLmlrWpq1BZABealq48r5PwEg_tqMDmkBlDSle5ZWM8FxlOglDkIsNg0Dgs4EHasAEQQVJJBW6BXh4mGoi-FxcAAEt4vqKgAwmcFykTA5E-jwRRlB4RBJEhVooQQHhyqyT5FiIX7wX-9guHA-oXkaoH_Kp6mvtBsH_MaOp6h2aFyjw4jkAA1rYiDmaIHgAMzlAAnGA5QACxgJUgTkOUMAAGwAOz8IEQVeeggQeY5tYTmA6COQATFUHkuUFQWJZgeiVOQ6B6AArPwlR5XojkuY5gT5flLmJfw5T5QFMCBI5QWOZUMAefl5D5TAIVgD1sz5YlMD1Xo_mOQF6AeR5RU1WAQXlIIdWOc5I3lfl2VgIl-XoC502BPwYCOR56CVAqlR6OghV6GAgQuVFSUbWlMAwC5gVVAFejbclAXTZN9WhZ9Y2BHoHmVOUnnoLdLnoIl_UuZULnZYETXkCDb0wHo_hBfl5SfTALXkF9u0BQdF2Od1nV6IdMUwLjMAeAJXAgpgUDiZ4GhQMJICEAQ8hwIgX5wJgix-TgMCLP45DCjWUD-OUODpgo65qDuVBEIz9lCcuom6mpHbSSIsnyZ-35GTA2xRFc1Znh2XY9mq8oYFw8gJrmmBXP8JQW4BEnSlwlB6AAVhOUmaagYEnpotvUPbvZ6Wq-RcC20ftrH3a9levvWnJYo8Ip5uWxbLiDueU4zpoTvoPK6DVxIIER9pMCl1Os5aFBifaM3ofl23z7yYJNtp52GdqjgCop22Ze6BXGhXiXPe6G3ucaTwC-TkvO4wGAe4b62QZQAnlp-gGPzBqG6Dho2_BoQ4CwodzADEO_VNUITG3ncYoY-sD_BAemVAaP_RgmQTLUBwKgUEMAcCOGgOgQ8qAcCwG7CUIBABqNBL50KiB0h2CBUCYF4DgQggA2hAAAujgS-dgcDyEWOmK8ndJ4x1QNfW-68NjbA0IsC2skV5WFweAyBmBCHELoGQyhix5DUMQpodS_cZKf0UjAEc_woAqjoJXMA39pB2kVHaDi3gAD6AB5J0coFTKiyJoueDpnSuk9HaHAFYXR2gAEoAEFDEVjMTgXR-jDGmKdKSR8MAXxvg_CIHggowLCItlBK8jAKzjiHKo1gYT8GYAHqIGJCxoFQEoM0RhUD-E5K0gHZYdD_hQUEYgyglTlhwBIXEiB_AbDkOydE0CeSkGFKvPUvmywV72UUkQXQixmRcEwBwjs8p1iV3yqAwU6AHhRNAQQbwEoYADKvM-V875sECO7hvbsO5pnHIIAotZ7IuD5VfqUj-84nxXLJBSaktJ6SMmZGyck8haxWQrjgIO8xUD8kFKqEUiAQCyhAJgRQ3J7wWlRMgVMStMyq03L7AsSAnI4GSnizWK40Uq3UJi7cGhdz7kPHAY8Q9zweDsiARyeKFaJQ8OyESsELw4opNyXARJCWYl-CiBlMKsh0ikjyv50Jm7WyRPgYgh9_D-F2HQQlehFhwIZR4aV0tD4argXKnkAqQActhSopQMB4WYERfAUVOq6R6v8BqjAsANDapAAAPQVuURKOB8qEuyIoIVfwPWevyjgDy_r2WsleZSGk05PmICZCyGA7IQBwF0HlQwMDqCQGaECkFYLqAQoYDCtAkBxS0EVJQXYHoEy0GHgygg3C-weCcOgNxzdKCCBMagDichTnNtbRqEAvsPV6ATPkFw7qyQeFoJKPotAPW6ubuyuN7zE0MmTd8tN5IUSCnzYW6gxahT0ChTC9W8hoCaBMX8DsyKYUs3BAzHl6sQSoGBYSw8IJ1AcUTORZFKaXCjvgL6UEL7J67GHTw0d8wDzS39PIBlwG23mvIH0Gs9KvmptHZgDDdITQdiQyh3do67AaGIh6u00gAqCpbRAOsMG0MDJULOxl3RJWgawIoH45FmSWqoFhlCyKW2wY8HxCQgmUImhQr6WwS07DMdHc-2AXb5hLGw4yuJ7LuMYcWJgBlJCPBxKMapu1c7YUqg8OQ2N5J40fO3ah1kLmgA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/interactions/selecting/selection_and_automatic_deselection/src/index.ts",
        "description": "Select outputs and automatically deselect them after an interval."
    },
    {
        "href": "examples/interactions/selecting/selection_on_up/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1Delw8lD8SWVgsFgN8pRwEhDUZfx6cJRQAK60DbBgBGWdXASU8ps1HqmijOS6qvxwXEV5p6jncIcmt_dHJumqr3DkGhDyBNtJRR5IiUdCLWAhOAach5KHkYxoTC4AgPECsExfH5_cImRIpTgmFhQYQgAA0IAgcAAQmh-BokkgwPwoC4AL7kuEIjDYHAosggKg0OgEBixVAQIhjDT_YBxBwaAS0aTwCbUUly76KmAANQgMHyUoI6pEAFl-LQfszpHYMHT0EpzfxOKyuGANJQiFwPAABOByRTvTTGVR6_KaDx1TgSw1cWUiACSQo0_HI4moDrsxp4iYtKbTqAAoqhmmgYFntDBYKmAPKoTzyM2ofjNcOoF1uj1ekC-_0wQMaYOhzQ4MCKxYKuA4NC51NTVARsUACguSVQ5C4i4AlFxXKxY3LjMZ5VquPYQ_rDRrqFkuOeDZRpTvT_l-BJj-adaHDYu41ZnhcynQShyEWGwaBwFsCALWAwIIKkknjdBFw8f9UW3C4uAACW8E0ABkAGEzguaCYFg8seCKMoPCIJJdQvB8CA8OVWU3SMREPd9aFPTIVTnK9UBvFw4FVbhXGfV9_k1D9lWEucfzlHhxHIABrWxEAU0QPAAZnKABOMBygAFjASpAnIcoYAANgAdn4QJrOM9BAkMrSUxgcgwHQLSACYqkM3TrOs7zMD0SpyHQPQAFZ-EqCK9C03StMCSLIt07z-HKSLLJgQItOsrTKhgQzIvISKYFssAytmSLvJgTK9AsrTLPQQzDJitKwGs8pBAyrSdLqxLItCsBvMi9BdNawJ-DALTDPQSpBHmvR0GivQwECXTnJ8oaApgGBdKsqpLL0UbfMs1rmsyuzjoawI9EMypyiM9B1t09BvMq3TKl00LAhy8g7oOmA9H8azIvKY6YDy8gTvGyypsqeLSuKvRptcmBwZgDxyK4EFMCgOj8k8DQoCokBCAIeQ4EQQ84EwRZzJwGBFn8chhWTKB_HKHA_QUPs1GHKgiGxjTKK7GiZJEpiRBYtiDyPKSuJKGAriTPM5yLEtUBV3R0C4eR3RDTArn-ZXby_BiuEoPQACt3MYkRBRvadNHV6hNdLJ9tfyLgc1d2d3eLUtFzvQ1WLFHgOMVlWzZcKt80bZtNFPDBT3QPWJH4wTK3txsWy0MTvYrePa3rRP863NieDj3PdHzpmwFHVMzQtCBmS9_UuBbzQ26ga1dbtDN-B_BwFgfMmAGJG8b6oQlluUXeTAPCyD7WcEWv2l4T3Qk40Rca-buvNHD-cRCEkScFQUEYBwdBHRweRFj9Rci83t3UCHkeD42bYNEWFWWIn2rrxagl9r44EWPIO-tBtSaBEpXZ0m4EGoDJBSaktJ6SMmZGyck8gUzKSTjgG28wUHIAFNQWg9BEAgFlCATAihuRrj1KiZAPpeYBgFgOO84YkDaRwL5fhItuzsP5uoLhQ4NAjjHBOKcatl4eHUiALS_DubeQ8Oyair55y8IpNyXARIhGYl-CiBRtCsh0kYjovB0JKyqyRPgYgUAuD-H8LsOgQi9CLGgOgBRHhrFsycZ47xdieQGJABouhMBVBKBgAwzATD4CmL8XSAJ_hPEYFgBoXxIAAB63NyjeRwJFIR2RFBGL-NknJkUcCGSKeo1kqDKQ0ibJgxATIWQwHZCAOAusDC4EFJAZoRCSH8kFJQkU1DaFoEgOKWguFKC7AAAruloPIpABA_5lg8E4dAAAlSslBBC1nwnIYsWN1mbPVCAO82S9DunyC4LJZIPC0ElH0Wg2T_GVnUY09BLSGRtOwZ08kKIBktGGdQUZFDhQMFoULeQ0BNDVj-HOFhtC8bgnOYooWIJUDEKEQqEE6h8Ielgiw9pLgrnwBNKCTFm9dgKI2f_K58xxxszNPIBRFKtmRPIH0ZM-YuVAquZgPldJzRzg5UKjpVy7AaEgtkgs0hLKGI2RAVMjLLkeEoMsFQTzFHdEsVSrAigfiwWZDEqgAqHwsKZTy0iEhLUPnNA-E0tgep2E1cy6itLYD7PmEsQVOir6YHUcavlixQ1IAANoeBDTAAA-hi2AqIRWUksQAXQaeSJpGCAXctZIWoAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/interactions/selecting/selection_on_up/src/index.ts",
        "description": "Selection on pointer up events."
    },
    {
        "href": "examples/interactions/selecting/simple_selection/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1Delw8lD8SWVgsFgN8pRwEhDUZfx6cJRQAK60DbBgBGWdXASU8ps1HqmijOS6qvxwXEV5p6jncIcmt_dHJumqr3DkGhDyBNtJRR5IiUdCLWAhOAach5KHkYxoTC4AgPECsExfH5_cImRIpTgmFhQYQgAA0IAgcAAQmh-BokkgwPwoC4AL7kuEIjDYHAosggKg0OgEBixVAQIhjDT_YBxBwaAS0aTwCbUUly76KmAANQgMHyUoI6pEAFl-LQfszpHYMHT0EpzfxOKyuGANJQiFwPAABOByRTvTTGVR6_KaDx1TgSw1cWUiACSQo0_HI4moDrsxp4iYtKbTqAAoqhmmgYFntDBYKmzah-M1w6gXW6PV6QL7_TBAxpg6HNDgwIrFgq4Dg0LnU1NUBGxQAKC5JVDkLgzgCUXFcrFjcuMxnlWq49hD-sNGuoWS4R4NlGl64P-X4Ej35p1ocNM7jVmeFzK6Eo5EWNg0Dg9YEAWsCAQQVJJPG6Azh4X6omuFxcAAEt4JoADIAMJnBcYEwBB5Y8EUZQeEQSS6se14EB4cqsiukYiDuT60AemQqpOp6oOeLhwKq3CuHeD7_Jqz7Knxk7vnKPDiOQADWtiINJogeAAzOUACcYDlAALGAlSBOQ5QwAAbAA7PwgRmXp6CBDpqkpjA5BgOgqkAExVDpGlmWZbmYHolTkOgegAKz8JUwV6KpGmqYEIUhRpbn8OUIUmTAgSqWZqmVDAOkheQIUwBZYCFbMIVuTAKV6MZqkmegOk6eFiVgGZ5SCMlqnqZVMUhQFYBuSF6AaQ1gT8GAqk6eglSCFNejoGFehgIEGl2e5vXeTAMAaaZVQmXoA0eSZDV1Slll7dVgR6DplTlLp6BLRp6BuSVGmVBpAWBOl5CXdtMB6P4ZkheUe0wJl5D7UNJmjZUUUFXlehjQ5MBAzAHhEVwIKYFAlH5J4GhQKRICEAQ8hwIgO5wJgixGTgMCLP45DCsmUD-OUOB-gonZqH2VBEGjykka25HifxtEiPRjHbruomsSUMBXEmeaTkWJaoPLujoFw8juiGmBXP8csXq-1FcJQegAFZOTRIiCueY6aEr1Aq6Wt5q_kXA5g7E5O8WpYzpehoMWKPDMTL8uGy4Vb5jWdaaAeGAHugmsSFxPGVlbNb1logluxWUcx1nq6MTwkcZ7oWe02AA7Vs-lpQK7-pcGaFoQFaNroHaGb8O-DgLNehMAMRV1X1QhBLcr28m3uFr7as4DNntT9HuixxoM6lzXxaaEHU4iLx_E4KgoIwDgHd2Dg8iLH6M654vjuoF3Pcbxs2waIs8v0TvJccdQh_Hzgix5Bnx1JofiRdnQrnAagMkFJqS0npIyZkbJyTyBTHJWOOBzbzGgcgAU1BaD0EQCAWUIBMCKG5IuPUqJkA-g5gGbm3ZLzhiQGpHAHk2H8zbHQrm6hGG9g0P2Qcw5RyK2nh4JSIBVJsLZm5Dw7IyIPinCwik3JcBEk4ZiX4KJxEkKyHSGiyjUHQkrArJE-BiD138P4XYdBOF6EWNAdA4iPBGMZvXexjjTE8nUSAeRpCYCqCUDAchmBKHwB0S4ukbj_D2IwLADQziQAAD02blDcjgEKnDsiKE0X8RJSSQo4B0hkuRrIYGUhpLWBBiAmQshgOyEAcANYGFwIKSAzRMHYP5IKAhIoiEkLQJAcUtAMKUF2AABXdLQMRSACBvzLB4Jw6AABKlZKCCAAPKoCwnILe4i5nv3VCAS8iS9DunyC4BJZIPC0ElH0WgiTXGVjkeUuBVSGQ1KQfU8kKI2ktE6dQbp-DhQMBIbzeQ0BNAbL-JOahJDMbglRso3mIJUBYM4QqEE6gsIeggtQ2pLgjnwBNKCRFi9dj7PmUc-YQ5GZmnkOIglCz_HkD6MmfMjKvlHMwKyuk5pJz0s5XUo5dgNAgUSQWaQJkNFzIgKmSlhyPCUGWCoK5EjugGKJVgRQPwILMiCVQdl15qEHOZQRCQBrrzmmvCaWw7U7AKuZQi2Aqz5hLA5coo-mA5FatZYsb1SAADaHgvUwAAPrOvCdc0hlIDEAF0ynkgqfAj5TLWTpqAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/interactions/selecting/simple_selection/src/index.ts",
        "description": "Simple selection of an object."
    },
    {
        "href": "examples/interactions/selecting/using_intersection_points/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1Delw8lD8SWVgsFgN8pRwEhDUZfx6cJRQAK60DbBgBGWdXASU8ps1HqmijOS6qvxwXEV5p6jncIcmt_dHJumqr3DkGhDyBNtJRR5IiUdCLWAhOAach5KHkYxoTC4AgPECsExfH5_cImRIpTgmFhQYQgAA0IAgcAAQmh-BokkgwPwoC4AL7kuEIjDYHAosggKg0OgEBixVAQIhjDT_YBxLiCdAAGUptFQmlJcu-Alo0ngE2oGpEWv4tAAahAYPkpQRDTwAKKmu0AOW83gAmgAFO22rgAWRNmggzOkdgwdPQShN_B93jwGhgMAAVnBI3ZOKyuGANJQiFwPAABOByRTvTTGVQW_KaDx1TgS61cWUiACSQo0_HI4moqejctbtHbnamqDtqGaaBgPubutgnbt6hoPpnME7_tQ_Ga1dQGazObzIELxZgpY05crmhwYG1i3jcBwaAHHa7qBrdcllGlXAAVPLLt4ABIAEp2nambZrmHglPGMCvi-qAABQXEkqDkFw8EAJRcK4rCNnKxjGA48YBvKXAVpa1qatQWSkZWDauPK-T8BIhHajA5rkR-BDwU2VjPBcZToJQ5CLDYNA4JuBB2rAokEFSSTNug8EeHxqKYRcXD_t4vqKgAwmcFxSTAMk-jwRRlB4RBJOxVqcR4cqsuhtYiPhLHEfYLhwPqcE8IK1EeV5WEMUx_zGjqerDtxco8OI5AANa2IgUWiB4ADM5QAJxgOUAAsYCVIE5DlDAABsADs_CBKVuXoIE2UpR2K5gOgKUAExVNl6WlaVLWYHolTkOgegAKz8JUg16Cl6UpYEQ1DelLX8OUQ3FTAgQpaVKWVDA2VDeQQ0wOVYD7bMQ0tTAS16EVKXFeg2XZaN81gKV5SCItKVpedU1DX1YAtUN6DpXdgT8GAKXZeglQKpUejoCNehgIE6W1a132dQm6UlVUxV6H9bXFXdN1LRV2OXYEejZZU5Q5egCPpegLVHellTpX1gSreQZMYzAej-KVQ3lNjMDreQOMA8VwPQyle07XoIP1TA_MwWSSUgpgUDWZ4GhQOZICEAQ8hwIg-FwJgiyFTgMCLP45DCu2UD-OUOBFgox5qBeVBEB4JlXOgOuWbqnnDnZIgOU5eEETAC7_FAKp0JomYftodqKnaOneAA-gA8k6coKsqWRxxo8EOs6rqenaODNi6dqAQAgmnzbZzg0jJ6nGfZ6SaEwJh2G4SIPlUf8LizpJUeBTAv5cNOMAj_Owph_3VxgGhw8rqPwr3m2LhDtQHqUA-WGuPRizcpAaroJh8YEDeqAL7xg9cJuOa2PSgVqvkXAAcBFfSPIUTxgAcRgM_Ag9J4KVBwENTurVoEtUcklXy_wiABh-MyN-lpP5ARAjgX08A8BUguBAcg_oBxBigNxBwCwPybCwGAOheVKhcFDggh-PR_4T3ou_TB38cF4Pgk_GwoCkid2QaQ5k8DF5sM0DAHAYwJjPidrYJSi8eCrznFHTeA5t7Pj3g-AA2pUAAut7VRM815zzEg-TQ2jhy6JoHo8oxikqmNnhoqxzg162P3vYlqhikoSJYagaiqBQQcMyGY9RG8QmYCclYaJMiFQ9nglw2M0FkxJKkfGdCEi4mhJwIseQ6AAymmsRFHJTCAnOQIqFCeJQJ7uKfMOUc441TygwFweQ2YKyYCuP8OpNEOKfkoHoRMa9KJBP-A0neI4xwTnQR_fsmhGnUGaROeCZEbLSkqTwFyNTthRHCSPYca4Nzx10OgeU6ALkSHGX5CJBA1ybi0JwjBy5Vy6FOUXcpUznyrLVDgBUizBzPhOU8-CaiHm6Cedsw5a9HkXhgHQuFKCyHzL9Ci4MoYikaAjFGChVAoDUP3AAYjodUaoIRmHeQTloeCsBJmBUqA0CAvBwmB2oDgeJOBHDQHQPGVAOBYBjhKMygA1KKzCPFRD-WHJyvJPKoB8roHoiAhicBFLsLIxYRZkkYKBcs1ASTgCws7GUUBiwJ4OXKaY9lAquUKqVagFVaqCkarYqU6gGFYlMPTOhL1nAyQUmpLSekjJmRsnJPIDssVTk4GTNQfkgpVQikQCAWUIBMCKG5ChC0qJkAFmdiWN2p4NnViQKlHAbVK1ewLUeE8Z5LQXivCaG88BNFLOmR4RKIAUqVsdi1GtIAoIJi7R4CB5Rao4EqB4dkFkmIvnLRSbkuAiSDsxL8FEXb01ZDpAQUdIAo3QhnlcZd-BiBQC4P4fwuw6CDr0IsXl-7D02wvfe3lJ6kRnpIDOjUGbI5KBgFmzAOb4Bbo8M-me_h70YFgBofdAA9R25QWqQMHdkRQ66_gIaGjgbKqGQCslZIGykNJ1yhsQEyFkMB2QgDgOcgwuBBSQGaHG-YqBE3UGTQwdNaAz4SBgIqSguwPTZloJ2pA5rJweCcOgQCM9KCCEzqgHScgxxK0QJJ39Gz916GzPkFwcHlZDqMr0AMT66QvpncR4NZGGQUfDdR8kKImMtFYwm5AApOPCm48pHM8hoCaEzn8Yceb02q3BOp3zRAQSoGTIO-MIJ1A6RzDJPNlGXC_vgL6UEEWgW7C7Zpjw8wbw239PILt6WpN_vIH0dsz4KsOd_ZgGrdITTHIUA1qjv67AaAkvuu00hiprtAUQvdEmNAWt_ZQZYKhDPdu6GNzLWBFA_BksyADVA6sfjzYVkARkJAbY_CaD8uC7Aav4AVibVXwuwDk_MJY9XF3xJ_R4bANXFiYC7Xojw8T043dA0ZhbHhDFEfJCRkNdnKuEdZEAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/interactions/selecting/using_intersection_points/src/index.ts",
        "description": "Use the intersection of a selection event to place objects."
    },
    {
        "href": "examples/materials/all_material_properties/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlqKMcOQaEPIEnFY8BACeiu4gtFgExgBW_Kr8UTFxHgmJcBrk6YQE8nCIxsbk6Kg4OXCYUGoaOKi2xqjyRMYAjgCuEOQA1i4E4qgA5nAAAlD8tHDZ45MztvNLOERobXClIjysJkWxBOEmeAJCnGWMBujJ4TyM6Gpcm8mwdIAdwg6AIeEQXAAjAAGGEAUgA3FwHhAFoRIbCEYiPJ8IuRdAU4FxQekCagibiTOSiXiTD9VHTrnEuCk0h4iJR0GNYCEKlUPPzjGhMLgCKcQJdjMzbi9jG8Ppx7sQoMIQAAaEAQOAAITQ_A0ySQYH4UBcAF9NUKRdgcOKyCAqDQ6AQGM9UBAiPJKBoCFxgGVogJaNJ4HAINR1YGNMGYAA1CAwIHe31RkQAWXWmggpukdgwBvQSnW_DTPHTAEFvABRABKAEkKwAZAD6zYACgAJCtlriVmsN5st6TdpT1gByAHFe_2643W9J60pq724_XFzr603694AJot9MAeWXnHNXDAGkoRC4HmWcDkigZmmMqkTQM0HhxHq9Pr9wAcMZZpmdTqlwCy2KGcDhtQk4wFetiGlwZ4XleN4gDgxhjOIZqfu6AAUhTJKg5BcHhACUXCuKw_plI0AGxlw9ivkmKbxCITqbFwzHJr-lGMUC_ASPRWYJixv54QG5wOIShSQownbeOmTYAMIyXA1awDYNCsOglDkGMWkEDg4EEBpMCGTqyT1ugeEeDShQeGRvY8KCkIcskonvhoHjOVx2oQHo0ASMkkJrhuW47vuR7Ljglbjp4zZlOaZFfjwdFBlmjF_GGEaoIG1CcS4UG5Xx_ACUJGUhjl1ASWUSQ7LYiB1aIHgwAAnDCgRtTAUJQjAMAAOxdTAgToAArAATG1UJje15B6AAbGNC1QvwUILc0MIDegE1gAN01tW143kBNsK7ftbX8ANC2YL1816AALDAMIPbtl3kIEUKnXogQAMy_eQC0LTAU0CHo7Uwr96B6PwejzQ9838GNvXbQt_ATQND0LWAY0DRNW0g-jC0PX1138DCY2_W14PoG1UOBPwMALTC1MwiNcN6G1s3NOgv1gL9_CBBNcN4-t60PfwC2BJjMA_TAD1jdDV0g79-242AD0PTC_BtQt_gDQNUK_TA42_Wzei_VCD3dSNDO_X9k16ML6CBCbPnNZynSeZ4GhQG5IA1HUDTSpgYzkFCOAwGM_jkC6Gimv4Ef3goJtqJoOBUEQ7tSa5aFEMkkHQXlIBJSl7ppcYYG2FX8EEIa-WoJx4G1zE8B8SZhe5bBLfJHhRVF2XeUiOlgG0IxGCMcVCzcEQWYxKaDecbPtDz1AfF9ECfZzzmUB5ro6CFsWdjkalNc2HXiZwDgYA-tW_COHheELBRVGkQshzb6afHL9mppkYPtFK6VRgFwMY8gD5jwJFAKAMNpiLz9GAiBMBVLQNgVMPi5FKLUUklYZu59W5XxvhoO-D8n4v2ok_HAiCRKaCLuRf-p8eA_1XlQ8BNDnC5RPs1fuuVehchgKwpBcZaGcMHlYbirFBFZi4SIc0X5AHCTHqaNes86jwJolJKgUAfTAV8qgH0s8oC6OagseOBcoEwGMVJUx_BzGmhgPWCktDLEKF8jYuxsAKxQHkHIKxVhtELEoMBJKpVyp-mAcBOAMiFH3koJvKIdAYBlAkb-HAsTN6uFZBoMYMB5HDwAFT5LqkU84-SuDeDwNqLg2B-BelgJCZRXB5CXkUL6S-xTinGHLqEIBo8QGzH2MSTw9Z1HMJ3u2XQMA16ZLwowXQHwQQYDiWRHAABFCY0xQxzDQAcYBeEYSgQOWhTMK8d6OVPhxP0ZhYA6gNJ2GAaJCAYPkopJsKhVBmUMqwWyUldL6UMsZWwnyXS6mSMpNYUFxy1JgLZEAIw4AtmuTAFsMNvIgDIgAbRhAAXTKP_DOXQXT3MeQQU-syFJKXecC7SPyrB_IMi6QFplNIgssuCwocAoU2FhfClsTpaA0Ecli3FIh8X_FgB_LAxL0R-kyYs3SQIcBoD6BoaVTz_CsgkDcu5DyZVcAANRoXkFgXCQ8mGfygDgU0Pj-DAT4mMDAMBIB9HQKfMZpoJl9EtYIdAOpKCUFgLoWF1rfEKB8ueU0LhQJ4QKFAHJkIDABoEKgchGirDuu9d40N8g-KxpyVwAA_GBMx0gLF2shA6zAzqTaMNAWw2gKCYH3ymDIngyU8nmtOaaK1Wb-DKSwpQMAYA-IwjdRaz1UyrXoHQOOAy4MNDBt7f2ggg6wDhqOVCQ5hycAwk3aRPNMBISoDnZoVNODRAZp7Ta5dq7c2mhybW6hDblFoNbUhABIhL0httfwvis5Bytg7N2HAh52wVlWZ4asY6u1QAnd66dSgWlKDiagWlLUQDfvTPw7OVgMX_vnG2JsXYKwgbAxBlcfYqxziHEBkjOomzVnHEoUC-GaNEeA5WaQABpbFvkY33sPZRgcBHaNnuap23-mabVYcwHeuNuTxN1qQY219YjRDmjxR2rgX6gkKHtY66trqygZrg1O31_rA2oY8PwXT8hw0mjNDAaNB6E0WeTWJqSOm7WZIPYW4ttjS32PLaAgzaAa3NSfcgl9za33tu6V5hQjiBXhhSHxKE0HJOmZ9bOog87g22aS3QFLyR12gT3XumEO6938fk0ek9GgPPpotVagrzpG7BTkw-iL9aouoJi2puLZrtPNfWAKsY6xcrKQDT6PiHgADEQ7FtrpABl1eWXp3eGwAQYNcw6DjfENQKb2i0WgXm0tod4aavxr-BfRYjWL0jd28eibh3ptaB8wJx9PWVP9dPoN4zj2xsvdQCoTYuhY4jtW-MyZ8GZ31bQzwazT39u5VB_mWOOHRAHOapu5q2OpKVd3XxlzXBj25dPVgtNiQv3I-B2j8HICPvydrTwSLP3phvrbZp-LzW9AGXkN5kLVawtGc_eOmHZm_VJqDR4PnXpgkagjY55zAnXPS5TZT89EmWFy4F3ppn-ai3uMC7AYLlanUi6-8p6LHOBsfu1zvHAuuTeM64KOgHMH1tw_Jwu2X_OXelehFut3VWVe1dJ_V-7Dvu3O4sZ1hTUk2c25bXbrTl7yCBsqJQdYkOPeZYl9l-HdlM9UHWIHir26if7tVxHn3UfhswYJQILPOeDcJ6sEnvrtu_v24b5JpvBpS8EEF-bwzUOPUF-nVLyzsKM_N6Hwr0CDmo3V_D4myz9f08l-z8P_XXEBN-a0TovTFbQsuqt1mdnKee9p-a3PwfO_xwGNNCPs_4Wxee8n-Z9Xs_t_rCfxoIYovkrivldoJuvu5prh7Hfn_gQAAUAXvr5kWvooAS_ifkLhbuft1tbl3tfqXLfo3vfi3gQLWJQGMOiH0FBLnh_vnl6mZjlnls1MXvPjvqQeQXgJQRKL5PjlYLjgTtwaHs1GAXVnXlAVJNHpakQUPmwRQWGPHizkppfsnpzkhNzkNlviwesDIRwWGK_sLlgTQWtl_tPsmr_poSQWQbIVBMAcvk5qvtdhAboJvjAeYdoZwYLkgf5h4g4k4s4C4jmqfvoe_h3t9soanjzoQW9rNiAHNkDHEQtKahIV7ptlkLPm9uGvNvEUDJdiTpsDEHdmIU1pEcdvIdgUobgbFr3peuZNqOGOoHoZgcEX3kYXQT6iYTLiADUcVPUWGorrYWHg4W5k4YUQ9o3l0XUf4fHn5gErZlwIEY0aLiETgU2t3vgREf3uMWnJwdEXNnCHsTCIkc0dDq0RtltrCpseoJwRkTEfsXCDkTXnkTss4WMUcN0YklQW3hfs-hUeEeoc1hGO9tCDgGNOPrBl_gwZoLCgCYHg9GVsCZXtViTmTvOs8f3gCaUYnqET8TfusSwqovpkEYsUcRPicd_jPhyL0UvpGnYcIVwI4Rrq_FrsSZaviW3ofm9mbm_kSazliSsXgbIlUc1ufKaNsZkulnni0ZOoXj7rCsKVAFcYrhumVgiQMYJsiRToydAY3nKaKfvszmUd8XyZUQQf3jqboXvqPpbhKccVKVPkMVZiAGadYZSSATSSTvSaiXibYCKeaTmmyUbiWmWugZaQYUseUUab8dad2k6XAG4b6QSQsaCV7u0Q6TGXGc6XZn0dSaqWrhviMRIYcN6fKWGOmXAB4QfgGQFkGQERgWPgab1hGTiX8Y3igQgX6bWVaYYTabDimbCq2WgZmVScrvYeAfaZ6Y7v2UYogRWaTs_lOTWSGU0Tycsapk2VGZapOS7mljukmeCUXiAJuRYuXsqSHlXrSeqQ1vmcyXwqgbvHHp8fWVfsabiY7pQPIPfB1mKTueuV7hCb7iAG-R-SkMeUHqeYiTXheeOd2oBeQJ-XqV1piSub9msc2f3peOwbqRHO7l2SSbad7owSAOhVYVwW7ieRVqHiOSISiVeZekRToR8fBe3qIJ3o2SheuTgHRe4RaVybuaSb2R4Jxb6fZtmZRXSWOTRc1oJRmVMZWd4Y4uoH4ZyYSV8Q2auWxThZasnD8IsH-lRgBsOKOBOJODgNIEeIeN4J2LxXhYhm-chkCFZlJIKHINpQsJjjwHhnpQRiOBWGOFOCZWZRZSxp5UON5b5cZb4E2FWLxkISTqxguIZVOPXgWVpTshiYkIoYaWpVJBpqKiaSwveP1NwJkthUkXuTKU5YVSBUcoTuBeHpBRJY3gVXQGlcxbyVlW2oKY1Q8HQEdjNpkmdudocSZl_ikdthVT1ekYrgNUtvceHo8QUZqZ5s1k1agL1YCQeipU-ZGRpWkt1atRydxcpT-cYfabCitWtTYSJbSR6Q1f3udQde2Z4UfhoEpYmY-WEWuTtStaWWllZbDn-WdXtaWSBeRWeUiZHrdflUDZYfRcSA-YheGe1e-nlY7t9TDVxe2YuUScNXxadeNagKWZdcOddeJYtUUXddDRhfGf6V4S7l4tJsGTxe9diepclaCK7nFcOEuNWDgEoIeJ4PRlBsdaSTZfIHZQ5VYIKOzW5VwB5cJiFdzbzfzYLUFfLQuIrb4LWIeOON4KrdRurTFDqBWMpDxsTjXpzYuMuEldeeGLJvDelSxUjVzrlS-d2nAIoPpGsBoGtTsedstn9WZqNWdR7TyAaGtdcQtoNYrrSfNc_JDajSHV7T7fba1UhasQKSjW7YnWHQ9QmXWRpcmXjSAO7TAJ7TncdkTaAe6aTdglqXddnd7bnTTc9a9fnWGZlchRna7ZpQ3YVu1qlmKQHdKYwY5cXb3W1sVjLTwaIHwbwQIUTjFRBRDWTdTstePclnBRtYpo7Z3VYDlTwJ1fXaXaHRoH3cVg0W3cyYXT_oKOvUVsFJXW6TXjdSvclXff3ckOWfJn5sbhYvTdmnMR2aGanYjbvcjd3XaJUtMLqSVVfWVSPZLRkFA1MAqdwb5I4s6sFGg3joIVJOecvbXeIdeeCDsLqVvUQzvenXvWoexSQ9A9TUA00TjXhfxUg6Q0JVmcTdXerlBZanQygww54b_UFozUdQjR3VQ-A6hSwnXLoHAK8UXNQaVaSQDR4LI43Ao7lFVSqaJfVa_cQ_HBo7USVCncuaA5I_9jteo_I8Y9QBfZ2coyw0XdY5o3Yy6f0aJS_YQ-TTI4YzY8VG449TOcI6bqI29eI6pWA5Y2YxI_yclDIhqFqLqPqIaMaNSZaMXZUJhNhFfPaMgI6NQAKq6IgFqD-L6FTjwN3PgskEfKWM1OuNVKgBWPIBAOg94DGDAE_pgL5MBLUz0xatWIsGFr5O0_1F00krIueJeNeLeMnI-GnBoC-G-B-CtmUKMgM0M30JCCcpJoMwsGFn-hs_s30Eqo3OjkxeoltvHOQAQFUwhJfBgs1PopgJCDuB0-M24nBPgpfJCHc3XDUyWBitinxEC3ir818whAC3YEC1eUQqRLAH6BAJDiSLwLOZgDgBAvwDgLAIsOCMiBAPqvqhREyS5MOnhM8wIpixihAMC2gGDsRHBMOn84aLU8S4pjwHgvc_ADgPIGMPeLMsy1C_wKwBSxi4CzS2ptQ9lc1HC3hAiyi8Vfi6i6K44NAOgDGK0DiwsHiySIS2y0Q1c_fLcxCxfPAOS_whnJUlAOq3QNS7xmfFy3AJK6oSIM1DGAQGMBoNwJy6a3AH9qfGUNgKxA4AVH6B3I04KxgjwtQK853NQM0xAGROCz3LUzC_o_Kz6wQsm9U6m8C5kkC7WrK_K5QCSNwNG60GQbUFhE6xU6IBAGS-WzgJW7y-KBipQNih_DBlwAAISuCZJY36vpUcsmsELtwjuXwZzUAEhjVENWCGs3PMuXx9yNNNtYQttwBtsdsUvdtkTstcDOvO1StWDuuevevjvwD-trMiBBu8SXKKL-Fw2TxEQkTkSQjtjTPagwCMBMkt0KDbMKC1O1ohP-H_ti0lhAeBn2LyXOLASgeAcmKQeeK9qwdbxgd2C1qTkoe9PgfNQzFYcAc4eyLUT6N3uqLvtXifuPtlSCR-jkevECLKJ4QYqKYZp7NhbYvZ7oDAQI6JAeCBz1CNDcTpxzOpwKWTvDCqC_TCizzgRwDGDSBKB8pvY8uLBnDpVOQsdHPsfaKCDcd7t8dzBByCfLM9AidPg9CZwvhSeej8CyfyeKfuJRD2IqeuUlxEMadEOsebMCI6dccKA8eIP8fBxCemcPiifpyWeSfSe2fwD2ctiOcWIthoAKUuAudqeJAefpVefHM-ecd6eztoRBfGdJjCdhfmfidWfRd2cKctjfppdufqe-QSFscnO-f5dDuFeGcCdLMlehcpzleRfWcyexc1eTn1eKaZer0wYte5e6f-f6cBxdfBcme7X9cLMVdRc2fVdhfvKaAtgzEthAiVK0DjfufNTYpqZuu2Cnu1s8C_vyCQhkcftFTCrdtNe03VmPcKB0eUcYpQjYpveKbAfQeKV_vDbyA_cvcTQA_vfAf_22pg9PcUcve_Qw-KaYeI_ffPfwAYoPRo9EN4eY8Q_Y8btjQA_NRyJJSnyJPah6ioAGhGiIC2EZPvnTAxcnDUAOj8ougMABggCYCKCOrETtJkCzNlcLM9deQeBNQgC_Q4CnTy8eCWgUloDS8eA2i4AsBQDuzF3RA3ASjICCh2C-hq8gDvmVBTKluij4AqhcD-D-Bvl0A6985qum_m-xxrwu_WtW-2ha9K9Rj88wCqBKAwCC-YDC_wDS98_u9TL-B84YCwBooy8AB6EcX0wJOvbI8AevJQSAHgyfY0OAD0GfIA5o5oNPyT9PqTTP6TVo-8BguATokA787QnP-T3P9AJTfPaAmDtATY_qxPlAtANzWjSAdcOSAfTg6AtYUynHh4q1cgiwSSY_2STmHg3Epvegl4QILgJ2aj5k8gawtAbvg-UySvFfdPDPaTjmGT4oTfaIHPqAXPhTPPXfdkV4LTifh4cQuUBvfPnsPIZfjL0zichUA7QHXjGE5DqApsRAQyAb36KtQyyXIQAYVhaTS9x-a_YumQQt4K4a-yuDwJgAzwGhgc0vBAYHyIHxwDsqAXAWQON4mRTe1YaQAkQ1BG8YgNzdAavwD6VsVASfAgdqHiAsDOiWAVpJ6BdCmgQ-VASgT6AN4YCA-NRAgBIJ9DrAdE3pTFhwIn4chkBsAGfnAADRYRR-MvClv71ahYAM8YwTANL2Y4Hl-ELYAAbAC4J8DNgHgbFOX01C08UmjPZnmXyAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/tree/development/examples/materials/all_material_properties/src",
        "description": "All material properties exposed in a simple UI."
    },
    {
        "href": "examples/materials/gem_material/custom_environment_map/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1dR6poozkuqr8cFxFef2og3DdJuOTPSbpqvNw5BoQ8gRc2Yp5RJToAK6wIXAa5Hmn5MZomLgEUyCsJitrG-EmiSmcJixQwiAAGhAEDgACE0PwNEkkGB-FAXABfIGXa4YbA4e5kEBUGh0AgMCBEeSUDSbABUXCG2iUADUuGANJQiFwPAABOByRSLTTGVQQGD5TQeLqoTgACkYuhShQwlHyAEocNJaVxXNSaSLOLBNi44HAINQysqaTgAJLSeD66gAQXkEBF2q4fIFxNJRtpZpp_PyroItvtsVQxjJZLiFO8eBBjRgUEUWjAB1Q5HE1EpepaqGG9iI_FoazhW0oXAEji4ObzEALVCJ1DxXEoYC2US4qH2MBwYbDXFZ8kh_GZrcwYeMnBxWTT-uaqAA4jAiABZXOaStQVVppJJrhiwcwd0m03eDQwGAAOTb8tVrC4wDiLbbGI0_HUzhgYu3F9cV5vIh4YBJW8dCA10qBogMYFscHQXN-BwWBUGaEpQIAaiQi9vysHgIEbbdIOggBtCAAF0RkzOwkxgBt1RwWcmVsKElGgtDbwwrdGGNaiKJsAh6Og1hUFwuwCMIxVy2XAs1VQAUqMXCs4VnIgGLsMV0JY0QjwZfhkwNVBTTRLAygAJhwAAWAFmNUwl5AONZskXeQykTTBIEk9AzJ_CyiWsiQkmkfpYDKSo3NU0QqCgElD10OAwE0UEYGaNAyg8ABiMBUrSjwguChxKDCjQIszaKNAAUQwRKQBStLUoy8yWOafsc3aTLgpxbihgIQymtUvQ1laAhJL1ALOpY9I4DjK1UACnAAGYhow1ryDQZolBgDZSi4QJZqsebFoAeV7BbskmjaaowuhVDsvccCKk8aVNAAlHaT3na7vAAfXna0AAUcFBa0ABk_oenb5xOngEXlEVgv4qDBKInADnkGGYBpTRxrFCGToRcysZEcHIbvTB4cRpcUecbT0ZFBFNVQMUhg3cgtw_L9b2dH0SU2NV-HyfgJCo1YBFoL0XXZ5TzKKMqiCSIW2dJar3NmIYykYAAJbx5z-gBhAYhiK2AbBoVh0EocgDn1ggcGaWxdbnPFQSSU10DFDwFYeeVbzx29dXGtcuZ5zZ2P5pcLXTahRfc8WWRASXg_GuWtogcgAGtbEQE6PAEAA2DP0HISpygAVgM8opvKQIpuMmBqj0ABOfgwCg8gYAM8h87AYz8_zvR85gGupsqfgM-rsAAHZynIKb-EqPQDPzqDAnIaupoMjOYGHyowAM_hAi7rfh5gcph-H8hh8wdBAkCSopqm4f8_IQIqnKPQS6mmBjOrrv0HQPR-GH4yOhryo1dh5b3ztXMuHct6VArlA_Oxlf57ynsZdAU0n5TWrpUYe28T4Z34AZauC8wDkGMoEV-egm56D0MPMBV9x5VGzuQWEeh0Ct3QNXHuehAiEPKMw8uJCf7-EruUOBgQDIUO3oEdAR9c7lBgKw4yGcq4GXLgZGAGc46iD2JgKA0tPAaCgGVQgBB5BwEQMYYwcBMAHHIOUHAMADj-EbjQR8UB_A2I5AoWRahNA4GrB4d2GNRQiFZr6Hx_ZND8AAIQ4AAF6UCZN4SgFNAw8DMVwXwEBnAEABFwQU9IbhNhgPWA4Rjik4C4BGKM4wuBkK4EbSSTpKwtjCdkoo9Z4wknLB2EQY5Nh6BaCofs1B0A7WKVZDmmRLTaXMhbWwIySkEDtieMJTsQDgiWpWPYGAPBu3cjgZyjsxSUCZlwCJlA9kdNzDgNA5AoAHEwHAFZol8xQG2fKCJ1MUnGC4AAdUKUMSc3BdBcARkjBwcIoDfyTmUipwwozYBgCbWg6AclREks-ApBNClRjQHmVA4KkiUighsWRXSeB9PWYMjAcyxlEyRlrKAELNKJzXE7dykl8hnkwAAfkugeI8p42ydRyugTlMAeVUT5ceUVt5jkqUwthdloqmLuU-Tkv56YpwYqeSuQsGKdwnX-RmeSMkxJQG3AKJV-MrCpN0MikFS5dUuEKSUQpjhdCWymCqlsFr7z2sFqjcmASWLBPZrSpcST3I4zBh80IXzcl-VXCUKMfrXXgshcy6gjdskECLE6opWgFDyCgPyZFbr4LwFvOSgZmzhmjNKSm-ljKk5iirRsoZ1LSk7gCeDCNgJgRgghFCGEcJERAn2onfglscAACs4DUCxC1PEDAbwgEwIoNESZ-QPGQGydxXIvEaF5N6IUSAPBTRwEXC9HgkQeBzGgDwqdgR6XwMQF5gIPAvHWPcB9K6siQgIA-jwvYzgxhIrcF9JAuD-H8JQdd1UQB6AONAdAgGQDAcbquRDyGwPol-Nesyq6YCqGWuuzAm6K1kCA5CDD_hEMYFgBoVDAA9Gx5QjL53g9seAqwv3MfziZHAHGQAIgRH2kE4I8VDsQLCeEMAkQgDgLagwuAcSQGaDOudqAF3UFoPQRAIAV1oGchIGAf04nyE-oyWgWlqAPu4gcGABGnDoDujGSgggdqoA1nIctdmNAOYI6zVD3U5QuEY--kAtAiRQCXKh9DMZr1iYHZJ6E0mR1yaBPcVTLQNPzuQNiHTS79MrurHaBje0UyZh_be_YRwYCoerJs2d8Gjx7HUBrJkZtt0yZcAR-A85auwF0nmWDfmAsfsoNZRudkH09ccx4TANy-yVdm-lgji2YuPkqzN4dsmCN2A0JbADp6QBFWkGoiLWQ1jJjG_NkAk2CAqHC4-kax2-tYDjISPEcJlpUC2ySbd9m7tzgkL9kkuYSTzlsIIaCt2COaLq65udtyVsnf1cJ97Ny7n1aQHhDwO5XoI9gA8dbIJjuEVE0CcTg7UtzZEwiIAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/materials/gem_material/custom_environment_map/src/index.ts",
        "description": "Gem stone rendering with a custom environment map."
    },
    {
        "href": "examples/materials/gem_material/simple/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1dR6poozkuqr8cFxFef2og3DdJuOTPSbpqvNw5BoQ8gRc2Yp5RJToAK6wIXAa5Hmn5MZomLgEUyCsJitrG-EmiSmcJixQwiAAGhAEDgACE0PwNEkkGB-FAXABfIGXa4YbA4e5kEBUGh0AgMCBEeSUDSbABUXCG2iUADUuGANJQiFwPAABOByRSLTTGVQQGD5TQeLqoTgACkYuhShQwlHyAEocNJaVxXNSaSLOLBNi44HAINQysqaTgAJLSeD66gAQXkEBF2q4fIFxNJRtpZpp_PyroItvtsVQYqGSVQ5C4YvlqtYXGAcSd3t9qsp-X4EnVOFWAloXpdJIIYrjIh4RTKHiISVzPvzHgB8Z4syGZUYAAlvABZAAyAGEBkMAKKwGw0VjoSjkA7Dgg4Zq2QcwKegpKm9BijyNh7y-MI-Uini6q3cNX8VPp42ZjTZmAWvUGoNFqyllkgCs3w-1-tbCDkADWtkQn48B4AgAGwgeg5CVOUACsABM5QAMzlIECEACwwNUegAJz8GA6D8OQMCweQ0FgKh0HQXo0EwNhCGVPwIFYWAADs5TkAh_CVHosHQfhgTkFhCGwSBMDMZUYCwfwgRUVJzEwOUzHMeQzGYOggSBJUCEIcx0HkIEVTlHoSEITAqFYVR6DoHo_DMahHTYZUWHMVJ0FYShFFSZU6FedBqG2XJXGoegCFGQhWGVMx0kqSB_CwVhAlgOQqGBKZehEXoejMW5WnsVU4HkLCejoKR6BYTReiBIl5TFWhKU2f4GHlH5gSwRl0mBOgSmQeUMClahIGYbBaGwTAIEfsWXB7JgUBVp4GhQGWICEAQ8hwIgxjGHAmAHOQ5Q4DABz-IRNAaHC_h7RyCi9WomiZkyHjbrugY8BtXCCg4l78LQlLcAc8j4d9_RQFA1m_lscibCClK3s0qC9VslDgzAXCUAcK1o8MaVQHK8Y4lkXB_QDMC9sDoM_smYpw_kABy-wwAA_O6Jqmt4l4wLTmBRq4MYPqIEBgBGACEVMczAUaXgQBwaKge6iK971DPqsNI5NX2aBAcKq7Qaxwp-It0xip3qM4yhffwYpiugXM84BIwC5bIyoFkuiEZQAvngA4jATK2FCShm1GvNWDwEqe97NgEH7ZujoqRBqzrUDJlTGbtvHGtQF7RD-3Yha21YdCqKn8hlM61akvtEwQIyqBTkXdYTcHXCXgyBHiNQppolgZSwTgqH143j5ElLEhJEXZQHGikBw-g_cDyWQ9rNk0hAzAZSVLPc9UNjGis7ocBgJooIwM0aCLQAxGAl9X-Nc8NpQ2-707B8aP2GDn1f1-AnnojNPwRBx-0DeA8cSRyGAQbuQDG56DWK0AgcM9Rr0gcHdIcBFDODvGvHACEkFWFAeQNAzQlAwA2KULgfdv48DwQQgA8vIAiI9MHBAbqIHcstG7oBwITNWNJNCHkjGwlhn5WHPTlsYH66ACb_TVgjTIMBkYlGRo4XQs4pgTX1pgThUicy8LvPwz8pdfSaKJnokQCJNQiDxpsVG6MCDUz_vAZMABtDw0g47A2kEUZQGs9gYAeACZ84JmgeMwCoP-1B0B-ICS0UJPj0AeAALrmJ4GAEkEZHQQGTJUBoGTGAozRvINGdibBwBwLAVAzQSjZIANRVMDp-SxeSbHJgPHeW2M5bDUPyWjJcRSYBimsQU2x9i4COIgPErczCcBT1XP062XBBaUCmSSOO040DkCgAcTAcA1wvjTrrEA8p5SCySaIrgAB1ZGisWjcF0JIomDg4QgwIj-HAXBvB4ChlDbAMAJy0AkfkKIcNjYq1QHTEYww0Da1QI8pIlJ8IbF6jgT8Ay0ZGLViTJ5YM1RcNoBismAj5aKMeeDKGOKiWk2eSjMMMB_EEERi4ZGqMtAKHkFAfkEilHlPgJ-MleLnn9K6dOUFnNZYIk4DuExgJgRgghFCGEcJERAjob-fgs4cAACs4DUCxCAvEDA4wgEwIoNEYZ-QPGQGyS6XIboaF5N6IUSAPAIRwPBF1HgkTljTKKR1wJO74GIFAD8IAXjrHuB4C1wa7CknDR4OhZwYCJxuOiX4XB_D-EoMaoNegDjQDiT6uNhFE7ZtzY7W4_qSDurrIamAqgiHGswKa7lZBY2QkLf4bNGBYAaBjSAAAentcoPdoJBu2PAVYoae29ugr3HAw6QAIgRFKkE4JoVysQLCeEMAkTBt0FZQwd1UCQGaBqrVqAdXUFoPQRAIADVoCnhIGAnZKAZoAAqMloOQNu3rECRwODSjwTh0AACUE2UEENQ1A3Y5BcvDb-_9IBS49ugXKFw3av4gFoESKAase0FoTe6pdMrV3QnXQqrdQJ7g4iPSe7VyBsQXr1deg1VAiTQE0LQr95qDVTSODAHtLGfGaqDZePY6huxMinOajdLgq3wHbPsXjHdtYZtgxoP9VatVS0IkXcN0n4OYHWZCL6rT5WbqrQZ7Dp0v06dMzJjwUbZwEB7f2aQY10NZDWJ-1T6mPDWJUGhgChqQROfQ9gNBhI8RwiIVQKzJJzVwdk0QCQ0WSRfRJO2Wwggzbefgzx2AIGtUbK_T24VfH52yawOszZZXEDOJAKVgA-nlpt5ngsJMXUCZdsqSN6YXQiIAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/materials/gem_material/simple/src/index.ts",
        "description": "Example of the gem stone rendering."
    },
    {
        "href": "examples/materials/gem_material/ui/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=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",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/tree/development/examples/materials/gem_material/ui/src",
        "description": "Advanced example of the gem stone rendering with UI."
    },
    {
        "href": "examples/materials/material_change_gltf_2.0_display/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlqKMcOQaEPIEnFY8BACeiu4gtFgExgBW_Kr8UTFxHgmJcBrk6YQE8nCIxsbk6Kg4OXCYUGoaOKi2xqjyRMYAjgCuEOQA1i4E4qgA5nAAAlD8tHDZ45MztvNLOERobXClIjysJkWxBOEmeAJCnGWMBujJ4TyM6Gpcm8mwdIAdwg6AIeEQXAAjAAGGEAUgA3FwHhAFoRIbCEYiPJ8IuRdAU4FxQekCagibiTOSiXiTD9VHTrnEuCk0h4iJR0GNYCEKlUPPzjGhMLgCKcQJdjMzbi9jG8Ppx7sQoMIQAAaEAQOAAITQ_A0ySQYH4UBcAF9NUKRdgcOKyCAqDQ6AQGM9UBAiPJKBoCFxgA4NAJaABZdaaCCmkN0MZcc1cMAaShELgeHDGGyoMaecRmjw4j1en1-gOUdQaGKYMO0GKmuMJpMptMZ8O1qA56ASgue72-_1laLBmAANQgMCBvYI6oHQfD0ngcAg1GnImrEdN0jsGAN6CU634nHjieTqZAyzgckUDM0xlUY6Bmnz7oAFIVkqhyFxnwBKLiuVj9iIjSBkOXD2He46TgO1CbFwEETsWf5gUC_ASCB4ajpBxbPsAZQ8DShSQowAAS3ghgAMgAwoShQAKKwJmtzoJQ5BjIxOALLY9EwIxOrJAAkugz4eARErfiuVigpCHLJJhCG-mcPDmt-BY8MBg7hmBfwLkuqDQagsEuHAi7UEh_AoWhGm0POxm6TheGsjstiIA5PAeAAzAArAAnN5nkAGzkOQnn8AA7GA_lQno7n-d5MLoD56BgAATO5ejJTA_npeFyWhVCyVQpgyX8J5nkwmVAAs6BQlCpVgBVegwDCoWhTAZUwvw7kwlV5DuaF7mBLVMCBKFCX-egyV6N5_AVRVtWDRV5BgN5MB9Z5k38DA00wFCoWeXoJX8GA7neXoIVQvwyUwsFgTuZNgTHRdS3LYE016DCMDPWAvUwmAgSCLFi2BAFehVTCyUVZtO0VRD5D-bFgToCtoPkIjejjYVJWQ1C_nAzAFX-FCt3vZ5UUrRVgQFeQehE3ot3_eDwXoKF_nuegHgSaInKdHJngaFA0kgDUdQNNKmBjOQUI4DAYz-OQLoaKahM4BeCgwNePRUEQHMOVJp5EMkNkmXpIBlMpBZlOps60FpfRAlwRCtpGUBcOg-76bBjs1s7SF21wa5tpuuhuxou77j-FtAcYXBlpolYwKyDwO07pqnCIscVqCMAB87z5Gcb6qngACjEjuGhzxelwayQ56aFde-uUAqWUGfx7XUB5zpy6nvOToh8kFceL31D9-39cp03kdqdHVkJ-CCcN22DsxmU5moX6s_t9GWbPovzvN6gykR5wGparq-qGsaqcwJaIBCnvpodmadoIMgjrULQ9CIFqRZ9rh5xcH4t4IMMAAByXIYCcx4O3IO25Q57jsFArgABxGAyZbCGgQfwJB8FJxwCQfxI2ukACC8gIBmwbCeDw55LzqzUDeeCj4QCqVTEBAAVGwvCbCuAACUYDyDWPLMCUAXYsVYkGD88AY5gETgvCeXAQTglkX8RQ5AICQHVlwVA_AbBcJJNweeDgxgVhdFoiBYEMAkgIAAcmJI4aA6AJEKIkHgZRD8XbyCTHeTA7NzicL8VwZY8gDQ6LMZgPRQSQkpncaAnRMAInBMVtEieXDjAez9EGAR_B5btyQsJABqAIGQiASA8BmAkExLiZCTYMRFgVInpCGBW4Q5hzsGUX8_5AJWDAD6L8sA_QQCQjCZEgzGBhJgDgN2dgcCwEWOCEZABqBZv5_6JFCNHdxdjdBcEalwGALjNCuwgEGcgkhkj6OUVM-wlAZH2EKeEgBPB1FfnuRMq5ABtCAABdfRmxdDyxuf7CesCWlYJWa5UQTpYLiIkQQXJrheBNODjuLBrBXmTP3J8r5LC1nPOfDCl07dehxL_K4BFlSbC_nRR875SF3E4tEOaMoELgK9PJDshOhRFwLD6OgVklAtKcXQQQcujySQyOfNSzFtK0B_MkYC1BwrMH7nBWK_CME_RCpsCK85CLGCKu1cquwaKIEYrsFihlkkJVaowckQ48iABkDquA2p1fa72ppiU2FJeSiesTKUQqsK6w07rG50onpauMDkmUiAcj0rQz5-kkiGSM3g4ycD2KgI4ugMy6ALHmSSJZ34IWZMEdnCekrTWZuzagLFhcKWQOTh6yeZsWGWw4XogA8uWeObj5GKNcYYuAqj1Fjj5Q2i5hjKBjFqDOvRA7lHDs-qOzR07Z0EH9QnBdhj3FcE8WWLO6AcB6OIQ4U0UADrTGcSIjlXAgwLG1DWTRBABWtyzondYTaw0wHLOc8QuiAlTpnfIGdJJiRjHkFM9Wx6_EJKidpWy1A4NJJjsBmdm7kOhIbZh5JzbUllGwJOBwGqY49qzvCr8Dl866WKUQ6gpCIBILXSBjdVS_girQAsepzbN3VI43Uhy7jGnAuaSi92IgOkAVWaIYCvgRTKOY6B4Od6xjcHsGAccDgHjTDTlYKFfpFPij4pupC1HqAcVsJ2tDBBjNxOfIZzdB8rVfkM7qZIm7c1zNcQBKEqq1lQsoLAGZlAFjCRAN4B4QYwJRaIDycQAiE6uecUo8En7tE2GPSAJziQgwEGMagBl8YYBmgTni1ztmMuzPza4slCKYR-cSAFoLUAQthfAah9dyXB1yD9OlrdhQEzTowJl7LVhcv5cKw5fTe6q6Gis51hFZnWicQIPNljFWYD2es4595MIvkAEI20AKtqBewBIRGXqmB-v0EGoPEh3Sk470dt1JyXWojRfK-tdb7c2mbB6fFTZI7d8M1ELvZKuwiyV44ykwAAPzFOATAMBEDC6BfQDD-HgDEfI8wJJrpOX-FlvblDoEMP9v1r9XEinzbRuiDtmTnAwPaDDk0MbY-YrcHFjgO8mSckoIgC-YzyD4Z2dWHNAy4CXK0QGKTudi94P-UKesw5Txnpq5rZnULqDoP5dXoRUzmAOvLsS5nue5RcvLskiIDYH44YoDnPjeb4xsLxkOQN0b8Hz5Vdl2SBrggvQIH7ey-Lsop9tR6m0ZfRAJoSu33vjGJ-cAX4OidJ_V038eyIWk-3Wiiw0CQLKEiuBrTsGF4UFgzmnPfT4LKFEOgMBsecwNbarBh5KFNjPKrK89CNC3nvEwyO033G54fX0YTzaR_56QjnvPfQcCyq3PLSOxgO3cG4ZRa2c8k6ZljI7h7zbC5S55ZcmAJo4twVNGMeACR_FcG4ZElD7ib9pL6FgIj03N4T23rGBFb4PxfiEyBWbRBTEzsDx2kxO00m2QNzPTByvT3230e3VQMhu2F1DHkUh3AIcmAgQO1D2SwB0QS0LgfC4BgLN2DTHGJDQEXXlj6GwOjjQiBGnSzVvU5Ci1P0gDUVMRfRjlQHt1ILQK3wTgoKkVSxuxcDcS5BXXHSQNEDrz6GxxwCTEoH9xFXyFZ2UHDmfCuSwLFTxSuV-UXzQRkWbx1TBVdn3C1wwlZzslp3NkEwnisOZxsOoFFzkNoIbxASUMoBUKcJHBcNQDcJ4Cr3FB5xAANj52LA8EFwNzcJDz0ijm0j9EwDPygD9AKCgCv10y_TbAzUC16QRQ8AAGIwBSiyinwRB3F7V5A_wHJXwLI_Rh9Z8JkWtBAwx5B8k1kPBhZ6hGhGEegu86Fyw8jhhVB3JhRHZOI4BjBpAlAAB9KgFrHoeQRYRSUQb8X8AAH02NIIwFP3z3QBYQN2JwPkthnk3ySP2GJE8H4nSRyOdiLl0GKzyUYF0A-BBAwEoCBG_BwAAEUJhph5w5hOMk9Z5nwYRC4ITTwx4ssWFpszBYAdQDRiJ9l0Q_RIcSIyJyIVBVBuJGJWBOjRBmJWJ2IVs8SXQ3NKI1hjJN0wsRg4A5iESYA5iDoNAPBvxdsvl2kfjyAugXQUS0RCAWFnxMSKIcTySaACSHJiS2IXQLMCAJSjNkgqSuVaSPB6SFiP4XR2TOTuSVYUggtHYsABS0SkIPjmIgR59UA-gNATTCAuB_BHJzAkTbTUT7SFlTx5AsAKizjiMlj9EWMyh3FHi-goAcBBB0BvBsACAwtFifRB4QASiyjSiK5nwMir8-NakFhdCrAqi4ytAEV0yYAGVjiK1g9TiRAk1WifhFg-YBZ2MsyWFgJd00BAzKiJ4Qzitwz0BIzozCS3JwiFAdYAFui5gRY-j-8BjaENYRjbxxi1cpiZj5j8ycAViFhhyrA_9Pw0zL8YBMzOMczEgk1HZ5BhN5AsEuAdjVMUiDjI0dV8c1lqzOM6ykIizI0eATy8k140ImjR8WjKA2iFAdzMiYANjLyry9jIBeVI14wCQCBHAvxQKHzGsYJAt_zQsPBiFuA45ekxFndNEgQ8BoAE4nzFg-1TyK5QKYKEx9QRFzlpM1lgIIsE5HBPorsXsSKAKayFhPAeFyIwMtEkcfFFc6A4BjF4k1V1lrsFFOUotsk8tz1zkFABFkhONlFqT0jdzpKUJiQXAaBA0pL-IN5mC-VdkxCFEiLYAuBSKuNlExgXAtAXRNBNFdAVDItSD-YDLgJ-IZFzLLxFADJiCE5mJUBrE_QUIaBFdlL-CHsajzKdLrKuLNE0BGoCAHw6ADK8UbKXzasL8QKGs1kPzHDPzfV5B3zRBSzm0gjEgY01larGV2kCx4iw9z5I8jRo9r5b5glph-BOIThqAU8tSv4QBcIQBMAArMAPxKCPBkBqFBiNY-9xwmEXIQB3IcACp1qPBLQORUITYVqbRcAWAoAdY75ogbgJRZq747AFIkAPBEl5YXYDr8AVQHT_BKAAqTq9AJgs0Zq7qDQHqdlvq-Unqjqtrpwxqf0lB-E6BJquCLrRr7rit_AvqMBYA2TbqQAAA9KWfKHATyE6tkeAM6koDGzGzyHACqPGra80FqiPauK-WPK0YOAwXAJ0SABYfq1AQa50Ya0atAKCiQGAciHw-QEuFQz6cQJDJAEVK_cGpwdAPhasztVASiOQRYeJaWjQWWjweCX6kAPQJMIEBygmniLJWgPWxG46kAGmzUcPC-dqmPC0TUcUNmtETm7mtPBgUarWMhNGztOIXSeGjkLkHkDWlarWTkVAdoE6oMTkdQSiZMRiC6x2gvEAeAEMEO2AfiZ0JMeQGamW1OuAadSoctPOhmlwcGzAXkkJSWvalOyuz6NYRWWu9oma-ujwa6lbPW2iaQfyE6mpSYeITW7WkANdFQdGlan4TYE6wjCMRiU0KGqgZun0C6gu8GniCQRen0dYH0aMOwK5fOrW1O7mUOvhIuzI2uvW15MGjwbAXksYcJJAMI15OYk-2ACUSux9aIm2s-OmqPFO80QBoAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/tree/development/examples/materials/material_change_gltf_2.0_display/src",
        "description": "Exchange the material on a glTF 2.0 Display component output."
    },
    {
        "href": "examples/materials/material_change_shapediver_display/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlqKMcOQaEPIEnFY8BACeiu4gtFgExgBW_Kr8UTFxHgmJcBrk6YQE8nCIxsbk6Kg4OXCYUGoaOKi2xqjyRMYAjgCuEOQA1i4E4qgA5nAAAlD8tHDZ45MztvNLOERobXClIjysJkWxBOEmeAJCnGWMBujJ4TyM6Gpcm8mwdIAdwg6AIeEQXAAjAAGGEAUgA3FwHhAFoRIbCEYiPJ8IuRdAU4FxQekCagibiTOSiXiTD9VHTrnEuCk0h4iJR0GNYCEKlUPPzjGhMLgCKcQJdjMzbi9jG8Ppx7sQoMIQAAaEAQOAAITQ_A0ySQYH4UBcAF9NUKRdgcOKyCAqDQ6AQGM9UBAiPJKBoCFxgA4NAJaABZdaaCCmkN0MZcc1cMAaShELgeHDGGyoMaecRmjw4j1en1-gOUdQaGKYADyY1qtbDtBiprjCaTKbTGfDTagOegEoLnu9vv9ZWiwZg0ngcAg1HVo6D4YAahAYEChwQ5yIGxHTdI7BgDeglOt-JueIuAJLSC86i8AGQv3gAmgB9ENVpQAUU48cTydTIDLHAciKAymjGKoK5Apo-bugAFIUySoOQXBwQAlFwrisCOIiNIG45cPYkGruuo7UJsXDEWuxaYYRQL8BI-FLlB65wcAZQ8DShSQowAAS3ghneADChKFJ-sCZrc6CUOQYySTgCy2OJMCSTqyQXugcEeFxEpoWeoigpCHLJMuJHFh4-k8JB056NAEjJJCl7XreD7Pm-H6fjgIYAIIAHKeN5d5lOaaEFjweFjuGhF_FOM6oGRqAUS4cDTtQtH8PRjGRbQk4pXFbEcayOy2IghU8B4AAs_CBOQMCYFCACcUIVRVgRgAArDAADMFVQgAbH1DVdVCADs7Umq1I16DCgSDX1YAwuQI1DTAMJgOQFVgAATF1I0VXo7UHe1fVdTAW3teQw0NfwcJbZgXXtZ1zRdXo6DNSNYBdVtFXtQ1YAjYtG2BG9DXfYEegPd16ANe1_B6JtS3oOQW0NeQjUwnofV6CN0NgH1GNgIEI0ElCwPtYEMLQ196DtTCFWo79_WBPwYAwIEDUHaNgRbTCDV7d1_DI311U8wtegNb1fXkDDhPtV1XVgKNYD-DC7XoD1SPC1j_C_VVQN031O2g_9l3TRZhWcp0plAp4GhQEZIA1HUDTSpgYxozgMBjP4tU0Bopr-FCODAQodVqJoOBUEQ5vnCS6AO0QyS5al8UgMFoXuuFxhMbQ0V9ECXBEF2kZQFw6AnglFFF42Je0fnXDbt2e66OXGhHie6EFmUeFlpolYwKyDyF8XpqnCIGUMX6vcVqCMA1nWBCNyXcHJSn6oAQACjEReGhZw816aGfj5lU_lv38_yPWI9QCvsWzgBk5Oq3yR79XO5QEf3fZ9lA_ggPb_dkLjGMoE8soLlDNfaMWY4IAJLp_XC2dgKUALn_SiLEaLUFqlwGA5ZkjgjQAsEkxIoCUEEHVMoVF1zBzwMg2iBANBjBgAWEKndOAai1LqfUhpjSjxgJaEAQpYGml7GaO0CBkCOmoLQegiAtRFmHOxEQF4L61m8vICA-krx31QGojRZRHxBhgL5LkMB9JL13PuVu7c7A_lbP-DwQEQJh3LBBKCMEQBdz6FgdcDhyKnz7rPFRi9r7pTgEhFCWkRCrzipCLReVqC6P0pQWsl8CC-X4DYSEmwYiLH0kI-2Ddr7NwPG3Y8dguAAB9CkHygMUqxZT-AAG0AC6nAMJYRwlnLgvgRSDwHskhehEMBcAYdwewrMC6OBgNMMenE_FcAGak3UyR0k2FotE6gClbBBLUqsmAcFFm1j2UfHgEAwCoUOeKXZGSYA4FgIscEmFXCuC4DCDCiirBOjgJQWAdzKALC0iAYxCyUm1i4CCR54J1hcFQDc8FhQEzJIwDgDwJzRBBgIGMDQqAwpxkrn6eQ28DTJHMVAIJtFLnLL2TgSAGBIlWAObEoJuj2nYUoIcEJzyXljAwDAWl5CRDwNOecuCABCQlnpiWkqCe8wqXyfm3JIQCjwQlklQHQDCygfpaUavsPkkFgyIV4D6VwQlZZZ4athTYFFIA0U8AxVinFwVM6hGzomGAMAABeA9GJwXwcSGwuhiRQu1Viv-WgxjyHLhsQe0Ko4Dz_CmZJWgXAaHLMSEEUBS56B9QsVAPo6rr2oFAZI4K5B-mSMk01YK0C-J5eKNCZQJU7xJdfIJNLDHeroQwphLq8KFGnHmk1-SGnrwJC4GK8gDTrDimXGAigMAEIWdwM5JqzWQUwBq_V2ohmEQrPwF-CDNWYD-PQ92mKgyQkucYk9_hsL0KDWAH01c4o3oHne_e7831lFXXBby-7kg4G1P-_2yQYHXzQrK2Ov78l3LoAsR5ornmmqJYaaVoKCC9BMaKyOeBoDoCDK0e5CG8BQcSL4xKCq_nKpAKq50NAuDEcefmv0MBxjNgIJQT9gCmN4BtXa9FthHW4p4OaF1XSB1om4Kg_JwauOoKoBWeA3pF2LGPfAQqzapVtow1hzAOHHD4cIzSn0n5BZ4HpYkOC5BYneEMW-9eNosCQizEQHNGhWWoXILhozdBGkwmaTgaNTSAu0XyY0pzzTG2xzRfGGAZoB4fNEP2vKQ6ZMhM4yaxTQY4AqZ-Gp_NmBZmiC02hnTC89MwAM3h9Vxmn0aDM44SzDKbNcAMR6t9nnrM-dq35gLQWTz-eaWFiDhVYt9uzpG6Nv8h6UpASfGK8TWhTfDEEuArDUDmgLOw7UepYXcMQCaBL_DBExhEXAMRDonTSNdLIwcNEksAHEYDJlsIaUdZQwzyA-1ua-n5FhoFMZ9opljDw_Z4FEOgMA7Mev0pQ4sY9fxtgAo40OYENCuNXO4zxXy_T5P-wsQHkJSUE8B7REnAO-hAcSvuWqnjjAACoGcJAZ1wIS4CZv_xjIirQ6Wanr0k2loemATQ8j9AUKAjDZnM-4Kz5YU7_YpnySz4wnBsA-NxznGApKoGxheYhZCqF8nE5By3MHJ5PNJYihz3dK3c4EizXoQWUwefDuvvirgdvtectQpbwqeF6uDx3dgDJ8hYDr2gp7qNUVTSl0Uq9-hK5iS1tQZDvo_vs6MSBGqjVObC4FuwWASA5AVwMcy8W0tXuTXx5sIn-Asa_RjAnTJrkZyVxbvd7HNP0PDE4CTFqu0_t03KA7nBYLfvY7CtQsFkkNPdC1UoOc57Cf3sW7LieHAXvFyaBThtqwIURPcZLpv6PtBt_OHygJ7vMPbn98w1vnfl_D_w99HARpxlrakRAIFr3e-4yeK6VmDnVFygHF1NClzKFgyoBIS0BeQ8AAGIi8kCwBYIRBYMi55BMJCoEIFt8dKdFVSF0AvtmtRAPAnZ6hGgqII4Q5QJw4ego4IIuphQi5FI4BjBpAlAXxoCfQcB5BFgzgrBINKkqkeURdAd0BcUvdSUNsv4tcYo5gCFiRPALwPd8kN5dB4taI4JGBdAPgQQMBkE0IcAABFCYaYScBQxYC7H-OCGEdeOwgCUlVFXFTXMwWAHUA0XiGANEQgLQviASO8FQVQZSSSVgEg6SWSeSRSAgEIl0ZZISNYFKPZQFEYOAF8NwmAF8J3DQVFIbMoSDSOLoF0LwnwggXFbQ_iQSII2ImgMIwqCIuSF0LZGIiSOItSBIgdZIjwVIrgqRF0XIgLfIow_4X5IuLAEo9EP0F5fQ6SIEanPoDQCY3w_wIqcwDwxY7wyYrgAAagAnkCwFQNkO4K0DQFSUgOvnUL6CgBwEEHQG8GwAIEBWOL3gQOQKLz3jggl0YSyUT0WAnysCgJ-R9Foi-N7VjikOvj_wPxdVgD9BIUEAIVtgKWyQIVxTwm3UGFrHOJqUuPixuPQDuIeJII5AUBjisDILmGdkoLcR6BoOcQjgYNUCYMlVYPYM4OON4P4I1EKgNwiVBJ-JyQWH-MSFhOHnkBN2-xPEqU915X5QkLKlZENE6XI0Y0IMRLthBPALBJVLFK0NATxz-3wL-UEGINBKEIqRENlPEMP1EwcHWEcFQhgDIxVPlV-SVUBW8m4D7mBJklkiUw1SBBqwHnhPy0IXS3FL3idJtJbFpVj1LSS3Izwm8CHimWmHBQkGNVQRDMRIACU7wiEYUPVN1WQuM6A4AsUYAFSukQ1wUB4DQ6zyBMU4zCJ5Aw9kgl0szCgwDJcZtoV6JiQXAaAqzXU2s_QqAeRc9ey_RAzoBgy1TckTUm9NBsFnQgxdUWMHgI07Zhy8ILxzkayQIF04AI8B5pJUAAByac3QP0TLBQNst3TAms_s1UshDVNAHNAgaCOgYc39bMxYJEp5F5M05UnU9AhQEbeQaMqwCEmpP_cjMTSfPFWOBCngI-LbNhTUXbLhI0Q7XhfhKdaYfgRSE4agK7PomREAdiEATABdTAZCJPDwZABxOk9HTHaCHIpADwLqHALaIOLaDwS0EktARijwJzfAFUc2ARaIG4CUJigROwX0ESkABXWqUuMSlgUufwfwSgBdSSvQCYdVJSlSzQ_S_DWfUUcSkgASucainBJQedOgOikvDTMgDwYyqAfwfSjAWADi0qEAAAPSDihC2hwHakkrZHgGkpKE4oCvahwAqlCoEvNB204X2xwqOwtCtBbgMFwCdEgAWBItQDIvo1u0otEtQFpQkBgDvEoB0q3i1WmXEGoEYrPSB0dkPBzPi0IKrFQCEjkEWErKQFapsqoiUr0CTCBFTXCpUjD3DCMoNFUoEpSr22JR4WO01HFDyrREKuKpuwYCoqjnUR8qrDiDilkqosth5EGr8qjk5FQHaEkqDE5HUFVSIEklkoyravgBDC5CuovFXJ0pap7Rsu-SxVqi-0Ys-psswHIDWH9iatTlwoS2humThpnWoAhrWpcBsoUuiKUs_GkD6kkpRMbKBsYRsoGRUF8o8B-E2EkvVwjEklNHssU3WB9FkuGo8BUgkBZp9DZo0GjDsGCzJrasutgE6u-UlwRqUsK0GsEpAGwFhrGEwEYvfxAFlpfDFpcuhu1HiG_2SswtStWqRotHNHNCAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/tree/development/examples/materials/material_change_shapediver_display/src",
        "description": "Exchange the material on a ShapeDiver Display component output."
    },
    {
        "href": "examples/materials/material_library/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=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",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/tree/development/examples/materials/material_library/src",
        "description": "Library with materials."
    },
    {
        "href": "examples/materials/properties/alpha/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlqKMcOQaEPIEnFY8BACeiu4gtFgExgBW_Kr8UTFxHgmJcBrk6YQE8nCIxsbk6Kg4OXCYUGoaOKi2xqjyRMYAjgCuEOQA1i4E4qgA5nAAAlD8tHDZ45MztvNLOERobXClIjysJkWxBOEmeAJCnGWMBujJ4TyM6Gpcm8mwdIAdwg6AIeEQXAAjAAGGEAUgA3FwHhAFoRIbCEYiPJ8IuRdAU4FxQekCagibiTOSiXiTD9VHTrnEuCk0h4iJR0GNYCEKlUPPzjGhMLgCKcQJdjMzbi9jG8Ppx7sQoMIQAAaEAQOAAITQ_A0ySQYH4UBcAF9NUKRdgcOKyCAqDQ6AQGM9UBAiPJKBoCFxgA4NAJaABZdaaCCmkN0MZcc1cMAaShELgeHDGGyoMaecRmjw4j1en1-gOUdQaGKYMO0GKmuMJpMptMZ8O1qA56ASgue72-_1laLBmAANQgMCBvYI6oHQfD0ngcAg1GnImrEdN0jsGAN6CU634nHjieTqZAyzgckUDM0xlUY6Bmnz7oAFIVkqhyFxnwBKLiuVj9iIjSBkOXD2He46TgO1CbFwEETsWf5gUC_ASCB4ajpBxbPsAZQ8DShSQowAAS3ghgAMgAwoShQAKKwJmtzoJQ5BjIxOALLY9EwIxOrJAAkugz4eARErfiuVigpCHLJJhCG-mcPDmt-BY8MBg7hmBfwLkuqDQagsEuHAi7UEh_AoWhGm0POxm6TheGsjstiIA5PAeAAzAArAAnN5nkAGzkOQnn8AA7GA_lQno7n-d5MLoD56BgAATO5ejJTA_npeFyWhVCyVQpgyX8J5nkwmVAAs6BQlCpVgBVegwDCoWhTAZUwvw7kwlV5DuaF7mBLVMCBKFCX-egyV6N5_AVRVtWDRV5BgN5MB9Z5k38DA00wFCoWeXoJX8GA7neXoIVQvwyUwsFgTuZNgTHRdS3LYE016DCMDPWAvUwmAgSCLFi2BAFehVTCyUVZtO0VRD5D-bFgToCtoPkIjejjYVJWQ1C_nAzAFX-FCt3vZ5UUrRVgQFeQehE3ot3_eDwXoKF_nuegHgSaInKdHJngaFA0kgDUdQNNKmBjOQUI4DAYz-OQLoaKahM4BeCgwNePRUEQHMOVJp5EMkNkmXpIBlMpBZlOps60FpfRAlwRCtpGUBcOg-76bBjs1s7SF21wa5tpuuhuxou77j-FtAcYXBlpolYwKyDwO07pqnCIscVqCMAB87z5Gcb6qngACjEjuGhzxelwayQ56aFde-uUAqWUGfx7XUB5zpy6nvOToh8kFceL31D9-39cp03kdqdHVkJ-CCcN22DsxmU5moX6s_t9GWbPovzvN6gykR5wGparq-qGsaqcwJaIBCnvpodmadoIMgjrULQ9CIFqRZ9rh5xcH4t4IMMAAByXIYCcx4O3IO25Q57jsFArgABxGAyZbCGgQfwJB8FJxwCQfxI2ukACC8gIBmwbCeDw55LzqzUDeeCj4QCqVTEBAAVGwvCbCuAACUYDyDWPLMCUAXYsVYkGD88AY5gETgvCeXAQTglkX8RQ5AICQHVlwVA_AbBcJJNweeDgxgVhdFoiBYEMAkgIAAcmJI4aA6AJEKIkHgZRD8XbyCTHeTA7NzicL8VwZY8gDQ6LMZgPRQSQkpncaAnRMAInBMVtEieXDjAez9EGAR_B5btyQsJABqAIGQiASA8BmAkExLiZCTYMRFgVInpCGBW4Q5hzsGUX8_5AJWDAD6L8sA_QQCQjCZEgzGBhJgDgN2dgcCwEWOCEZABqBZv5_6JFCNHdxdjdBcEalwGALjNCuwgEGcgkhkj6OUVM-wlAZH2EKeEgBPB1FfnuRMq5ABtCAABdfRmxdDyxuf7CesCWlYJWa5UQTpYLiIkQQXJrheBNODjuLBrBXmTP3J8r5LC1nPOfDCl07dehxL_K4BFlSbC_nRR875SF3E4tEOaMoELgK9PJDshOhRFwLD6OgVklAtKcXQQQcujySQyOfNSzFtK0B_MkYC1BwrMH7nBWK_CME_RCpsCK85CLGCKu1cquwaKIEYrsFihlkkJUQqsFqjB5yABkDqbWiDtTqw48inUup4G6w0HrvammJTYUl5KJ6xN0Wqrg35vVcF9ckf1jc6UT0tXGByTKRAOR6VoZ8_SSRDJGbwcZOB7FQEcXQGZdAFjzJJEs6NYrMmCOzhPSVpqS1ltQFiwuFLIHJwDZPM2LDLYcL0QAeXLPHNx8jFGuMMXAVR6ixx8u7RcwxlAxi1HXXo6dyi52fQXZotdG6CDhoTtuwx7iuCeLLFndAOA9HEIcKaKAB1pjOJERyrgQYFjahrJoggArW5Z0TusXtiaYDlnOeICNohuGrvXfIddJJiRjHkFM9Wd6_EJKidpWy1AsNJJjvB9dJ78OhO7aR5JfbUllGwJOBwGqY7jqzvCr8Dl866WKUQ6gpCIBIMPQh49VS_girQAsepfaT3VJE3Uhy7jGnAuaSi92IgOkAVWaIYCvgRTKP44h4On6xjcHsGAccDgHjTDTlYKFfpdPij4iepC7HqAcVsCOojBB7NxOfLZk9B8rVfls7qZIJ6K1zNcQBKEqq1lQsoLAGZlAFjCRAN4B4QYwJpaIDycQAiE6BecUo8EIHtE2DvSAPziQgwEGMagBl8YYBmgTniwLnmSuzKra4slCKYRRcSDFuLUAEtJfAYRo9-WZ1yD9MV09hQExrowKV8rVhKvVdqw5azl6q6Gjc6NhFTnWicQINtgTLWYDefc7595MIvkAEJB0AKtqBewBIREvqmMBv0KG0PEnPSk-70cz1J13WojRfKptjcnX2jb16fFrYY598M1EXvZLewiyV44ykwAAPzFOATAMBEDC6xfQBj7HgDcf48wKprpFX-GNvbmjoEGPrtdrDXElnfbFuiDtkznA8PaDDk0MbY-YrcHFjgO8mSckoIgC-bz1D4ZhdWHNAy4CXK0QGKTs959yP-U6fcw5Txnpq5HfXXLtDiPtevoRXzmAFvXsq5nk-5RWvXskiIDYH44YoDnKzc74xsLxkORt3b5Hz5Ddl2SCbggvQIHXfK8rsop9tR6m0ZfRAJoGu33vjGJ-cAX4OidJ_V038eyIXU-3Wiiw0CQLKEiuBrTsG14UFgzmovfT4LKFEOgMByecwNfarBh5KFNjPKrK89CNC3nvEwyO633GV-_X0eTfaF_V6QhXqvfQcCyq3PLSOxhh3cG4ZRa2c8k6ZljL7n7fbC5q55ZcmAJostwVNGMeACR_FcG4ZEgj7iP9pL6CwDo3W03gnm3ljARTfA_C_DkyBT7RBSUzsCp3Uwe00m2Rt0fSR1fSv3P1-3VQMg-3l1DHkVR2QIcmAhwO1D2SwB0Ry0LgfC4AwKd19THGJDQB3Xlj6HIOjjQiBDXVLQ_U5DS0f0gDUVMX_RjlQG90YKILPwThYKkUKw-xcDcS5H3SXTwNEC7z6HJxwCTEoGjxFXyEF2UHDmfCuTILFTxSuV-V3zQRkX7x1TBVdn3DNwwkFzsk53NlkwnjcP5w8OoEVy0M4J7xAT0MoAML8JHACNQCCJ4Db3FAlxAANil2LA8FlxtyCITz0ijm0j9EwCfygD9AKCgDf0s1AzbGLVi16QRQ8AAGJ4Z_InwRB3EcBTR5A5BKJ10bkZEusWFWjKBgk1EUgkIoR-jfD2i5Awx5A_wHJXwLI_R59N8JkBtBBpj8k1kPBhZ6hGhGEegx86FywqjhhVB3JhRHZOI4BjBpAlAAB9BYRWZIKIU0CZeQRYRSUQb8X8AAH2-MYIwEf2r3QBYRt3pwPkthnlPzyP2GJE8H4nSQqOdiLl0HqzyUYF0A-BBAwEoCBG_BwAAEUJhph5w5hRM89Z5nwYRC4qTTwx4ysWF1szBYAdQDRiJ9l0Q_RUcSIyJyIVBVBuJGJWANjRBmJWJ2IDsBSXQgtKI1hjIT0ksRg4BbimSYBbiDoNAPBvxLsvl2k8TyAugXQ2S0RCAWFnxuSKI-TJSaAhSHJRS2IXQXMCArS7NkgZSuV5SPBFTbjC8XRNTtTdSVYUg4tHYsAjSOSkIsTmIgRt9UA-gNAwzCAuB_BHJzAWT4z2TEyFlTx5AsBmiyh3FkS-goA2j0Bic2JGoNAktBjskJAB4NQuAaSoRC4myGycAYQWznwSi39IQswiAKzLCrABihjaykIuyYAGVQTm149wSWiJ5Cz6sSyyy-zNAktJj-Auj_0wAwAK5GzqTqS2yOyxyezyzNAByuYJioAOj1zuitzRzX9xyg9ZCwSWFvCcieBc1VifhFg-YBZhNakFgWFgIL00ABN8y5yUTizBB0BvBsACBhS3IQA1zpidYAEti5gRZdjp99jaENZjjbwzijdLjri7iHj-AnjntXj3iNQHIoDPxOz7ypN_yzyrBc0kKFB5N5AsEuA_jDMCigSU0dVqc1lPzRMfy7zSiHzI02KZjUc140IljF8VjKA1iFB6KJKvjuKeKATIBeUU14wCQCBHAvwYAetosYJYslLEsPBiFuA45ekxF_dNEgQ8BoAE4RLFhlFpKXJ6yTK9KEx9QRFzl1M1lgIUsE5HBPo3sAc3LlKvyFhPAeFyIkMtE8cfFdc6A4BjF4lI1gIlCFFOU0tskqsn1zkFABFkhRNlFZTij7z3sFEZsXAaAXVgJ-IN5-C-Vdk8rnLXKuB3KxNlExgXAtAXRNBNFdADDUtGD-Zmro5-IZE8rLxFADJ6CE5mJUBrE_QUIaBdcyrpCfsZiuqZtPzNE0BGoCAHw6AXU8U-qxLOsX91KhK1lETA1pKzJLypiFAU0rBJy-04jEh001kAbGV2kCxsik9z5U8jR09r5b4hiph-BOIThqAC8P4XQGBcIQBMAlrMAPxWCPBkBqEDiNYp9xwmFvL3IcACpKaPBLQORUITZvKbRcAWAoAdY75ogbgJQCa747AFIkAPBEl5YXYmb8AVQkz_BBjLrqKQA9AJhS18aBaDQhadk5a-URaWaabpxMbwMlB-E6AcaxCuaMbBb6t_BZaMBYANT-aQAAA9KWfKHATyNmtkeADmkoa2m2zyHACqR2mm80cGlPauK-TPK0YOAwXAJ0SABYJG1AFG50L-EADGtAHSiQGAciCI-QEuAwz6cQPDJAEVN_LWpwdAPhT8kdVASiOQRYeJfOjQQujweCBWmWpMIEIa52niLJWgJuk21mkAf2zUZPC-KGjPC0TUcUSOtEGOuOovdGkSZMMhS2kdOIXSI2jkLkHkGu7yrWTkVAdoNmoMTkdQSiZMRiLmkemvEAeAEMde2AfiZ0JMeQfGgui-uANdSoJtR-4OlwLWzAfUkJXOhm8-n-z6NYRWAB5Cr-i-3mg7Ju2iaQJo6WmpSYeIWu-ukAQ9FQK27yn4TYNm2jCMRiU0XWqgMBn0Lm5-rWniCQYhn0dYH0aMOwK5J-uui-7mDevhV-0ogBpu15TWjwbAfUsYcJJAJI15W4th2ACUH-n9dI_us-QOtPc-80ZRoAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/tree/development/examples/materials/properties/alpha/src",
        "description": "Example of the alpha material properties."
    },
    {
        "href": "examples/materials/properties/bump_normal/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlqKMcOQaEPIEnFY8BACeiu4gtFgExgBW_Kr8UTFxHgmJcBrk6YQE8nCIxsbk6Kg4OXCYUGoaOKi2xqjyRMYAjgCuEOQA1i4E4qgA5nAAAlD8tHDZ45MztvNLOERobXClIjysJkWxBOEmeAJCnGWMBujJ4TyM6Gpcm8mwdIAdwg6AIeEQXAAjAAGGEAUgA3FwHhAFoRIbCEYiPJ8IuRdAU4FxQekCagibiTOSiXiTD9VHTrnEuCk0h4iJR0GNYCEKlUPPzjGhMLgCKcQJdjMzbi9jG8Ppx7sQoMIQAAaEAQOAAITQ_A0ySQYH4UBcAF9NUKRdgcOKyCAqDQ6AQGM9UBAiPJKBoCFxgA4NAJaABZdaaCCmkN0MZcc1cMAaShELgeHDGGyoMaecRmjw4j1en1-gOUdQaGKYMO0GKmuMJpMptMZ8O1qA56ASgue72-_1laLBmAANQgMCBvYI6oHQfD0ngcAg1GnImrEdN0jsGAN6CU634nHjieTqZAyzgckUDM0xlUY6Bmnz7oAFIVkqhyFxnwBKLiuVj9iIjSBkOXD2He46TgO1CbFwEETsWf5gUC_ASCB4ajpBxbPsAZQ8DShSQowAAS3ghgAMgAwoShQAKKwJmtzoJQ5BjIxOALLY9EwIxOrJAAkugz4eARErfiuVigpCHLJJhCG-mcPDmt-BY8MBg7hmBfwLkuqDQagsEuHAi7UEh_AoWhGm0POxm6TheGsjstiIA5PAeAAzAArAAnN5nkAGzkOQnn8AA7GA_lQno7n-d5MLoD56BgAATO5ejJTA_npeFyWhVCyVQpgyX8J5nkwmVAAs6BQlCpVgBVegwDCoWhTAZUwvw7kwlV5DuaF7mBLVMCBKFCX-egyV6N5_AVRVtWDRV5BgN5MB9Z5k38DA00wFCoWeXoJX8GA7neXoIVQvwyUwsFgTuZNgTHRdS3LYE016DCMDPWAvUwmAgSCLFi2BAFehVTCyUVZtO0VRD5D-bFgToCtoPkIjejjYVJWQ1C_nAzAFX-FCt3vZ5UUrRVgQFeQehE3ot3_eDwXoKF_nuegHgSaInKdHJngaFA0kgDUdQNNKmBjOQUI4DAYz-OQLoaKahM4BeCgwNePRUEQHMOVJp5EMkNkmXpIBlMpBZlOps60FpfRAlwRCtpGUBcOg-76bBjs1s7SF21wa5tpuuhuxou77j-FtAcYXBlpolYwKyDwO07pqnCIscVqCMAB87z5Gcb6qngACjEjuGhzxelwayQ56aFde-uUAqWUGfx7XUB5zpy6nvOToh8kFceL31D9-39cp03kdqdHVkJ-CCcN22DsxmU5moX6s_t9GWbPovzvN6gykR5wGparq-qGsaqcwJaIBCnvpodmadoIMgjrULQ9CIFqRZ9rh5xcH4t4IMMAAByXIYCcx4O3IO25Q57jsFArgABxGAyZbCGgQfwJB8FJxwCQfxI2ukACC8gIBmwbCeDw55LzqzUDeeCj4QCqVTEBAAVGwvCbCuAACUYDyDWPLMCUAXYsVYkGD88AY5gETgvCeXAQTglkX8RQ5AICQHVlwVA_AbBcJJNweeDgxgVhdFoiBYEMAkgIAAcmJI4aA6AJEKIkHgZRD8XbyCTHeTA7NzicL8VwZY8gDQ6LMZgPRQSQkpncaAnRMAInBMVtEieXDjAez9EGAR_B5btyQsJABqAIGQiASA8BmAkExLiZCTYMRFgVInpCGBW4Q5hzsGUX8_5AJWDAD6L8sA_QQCQjCZEgzGBhJgDgN2dgcCwEWOCEZABqBZv5_6JFCNHdxdjdBcEalwGALjNCuwgEGcgkhkj6OUVM-wlAZH2EKeEgBPB1FfnuRMq5ABtCAABdfRmxdDyxuf7CesCWlYJWa5UQTpYLiIkQQXJrheBNODjuLBrBXmTP3J8r5LC1nPOfDCl07dehxL_K4BFlSbC_nRR875SF3E4tEOaMoELgK9PJDshOhRFwLD6OgVklAtKcXQQQcujySQyOfNSzFtK0B_MkYC1BwrMH7nBWK_CME_RCpsCK85CLGCKu1cquwaKIEYrsFihlkkJUQqsFqjB5yABkDqbWiDtTqw48inUup4G6w0HrvammJTYUl5KJ6xN0Wqrg35vVcF9ckf1jc6UT0tXGByTKRAOR6VoZ8_SSRDJGbwcZOB7FQEcXQGZdAFjzJJEs6NYrMmCOzhPSVpqS1ltQFiwuFLIHJwDZPM2LDLYcL0QAeXLPHNx8jFGuMMXAVR6ixx8u7RcwxlAxi1HXXo6dyi52fQXZotdG6CDhoTtuwx7iuCeLLFndAOA9HEIcKaKAB1pjOJERyrgQYFjahrJoggArW5Z0TusXtiaYDlnOeICNohuGrvXfIddJJiRjHkFM9Wd6_EJKidpWy1AsNJJjvB9dJ78OhO7aR5JfbUllGwJOBwGqY7jqzvCr8Dl866WKUQ6gpCIBIMPQh49VS_girQAsepfaT3VJE3Uhy7jGnAuaSi92IgOkAVWaIYCvgRTKP44h4On6xjcHsGAccDgHjTDTlYKFfpdPij4iepC7HqAcVsCOojBB7NxOfLZk9B8rVfls7qZIJ6K1zNcQBKEqq1lQsoLAGZlAFjCRAN4B4QYwJpaIDycQAiE6BecUo8EIHtE2DvSAPziQgwEGMagBl8YYBmgTniwLnmSuzKra4slCKYRRcSDFuLUAEtJfAYRo9-WZ1yD9MV09hQExrowKV8rVhKvVdqw5azl6q6Gjc6NhFTnWicQINtgTLWYDefc7595MIvkAEJB0AKtqBewBIREvqmMBv0KG0PEnPSk-70cz1J13WojRfKptjcnX2jb16fFrYY598M1EXvZLewiyV44ykwAAPzFOATAMBEDC6xfQBj7HgDcf48wKprpFX-GNvbmjoEGPrtdrDXElnfbFuiDtkznA8PaDDk0MbY-YrcHFjgO8mSckoIgC-bz1D4ZhdWHNAy4CXK0QGKTs959yP-U6fcw5Txnpq5HfXXLtDiPtevoRXzmAFvXsq5nk-5RWvXskiIDYH44YoDnKzc74xsLxkORt3b5Hz5Ddl2SCbggvQIHXfK8rsop9tR6m0ZfRAJoGu33vjGJ-cAX4OidJ_V038eyIXU-3Wiiw0CQLKEiuBrTsG14UFgzmovfT4LKFEOgMByecwNfarBh5KFNjPKrK89CNC3nvEwyO633GV-_X0eTfaF_V6QhXqvfQcCyq3PLSOxhh3cG4ZRa2c8k6ZljL7n7fbC5q55ZcmAJostwVNGMeACR_FcG4ZEgj7iP9pL6CwDo3W03gnm3ljARTfA_C_DkyBT7RBSUzsCp3Uwe00m2Rt0fSR1fSv3P1-3VQMg-3l1DHkVR2QIcmAhwO1D2SwB0Ry0LgfC4AwKd19THGJDQB3Xlj6HIOjjQiBDXVLQ_U5DS0f0gDUVMX_RjlQG90YKILPwThYKkUKw-xcDcS5H3SXTwNEC7z6HJxwCTEoGjxFXyEF2UHDmfCuTILFTxSuV-V3zQRkX7x1TBVdn3DNwwkFzsk53NlkwnjcP5w8OoEVy0M4J7xAT0MoAML8JHACNQCCJ4Db3FAlxAANil2LA8FlxtyCITz0ijm0j9EwCfygD9AKCgDf0s1AzbGLVi16QRQ8AAGJ4Z_InwRB3EY8NBHYoAwx5A_wHJXwLI_R59N8JkBtBAuj8k1kPBhZ6hGhGEegx86FywqjhhVB3JhRHZOI4BjBpAlAAB9QpdowNeQRYRSUQb8X8AAH3OMYIwEf2r3QBYRt3pwPkthnlPzyP2GJE8H4nSQqOdiLl0HqzyUYF0A-BBAwEoCBG_BwAAEUJhph5w5hRM89Z5nwYRC40TTwx4ysWF1szBYAdQDRiJ9l0Q_RUcSIyJyIVBVBuJGJWBxjRBmJWJ2IDsaSXQgtKI1hjIT0ksRg4Adi8SYAdiDoNAPBvxLsvl2koTyAugXQiS0RCAWFnxySKIqTWSaA6SHJGS2IXQXMCA1S7NkgOSuVuSPBeSdjC8XRRTxTJSVYUg4tHYsA5SSSkIwTmIgRt9UA-gNAnTCAuB_BHJzACTvTiTfSFlTx5AsBmiyhc0RifhFg-YoBwEDiBZhNakFgWFgIL00ABMyh3F_i-goAcBBB0BvBsACB6S3IQB9iOiuidYAFJi5gRYZjp85jaENYljbxVijcNitjdjqzDjjiNQHIoDPxnwSi38pM0zLC1lc1-zOiFB5N5AsEuArjDMCi7iU0dVqcZzKBBBRMEykyOikJxyYAU0eA5yui8k140JBjF9hjdz0AxiTyziVzVybjIBeUU14wCQCBHAvwYAetosYJYt7zEsPBiFuA45ekxF_dNEgQ8BoAE5YzRNlELyFyK4AKvyEx9QRFzl1M1lgIUsE5HBPo3sAckKHz9yeFyIkMtE8cfFdc6A4BjF4lI1gIlCFFOU0tskqsn1zkFABFkgULDFOTijX8z8QMUJiQXAaAXVgJ-IN5-C-VdkOL4LEKuBkK6llExgXAtAXRNBNFdADDUtGD-Y5Lo5-IZEOLLxFADJ6CE5mJUBrE_QUIaBdcBLpCftujVKZtYzNE0BGoCAHw6AXU8VNKFgDyfQjzOsX9SiALty1lfjA00LuiEUUqzzRBHjm1OclcIV01cqVMp4krCy5zpBnsE4EUpZhlcyJ58z6siz0Bic2JGoNAktSryqK4MSoRC5uquAYQcAYReqxzxLIQswiAWrpyuZfD2rTQKrYq38GUsq-0sjniRAYzKL4z-YdQ2J5BJzRMMyNl5FszN0WjaqATCzizSysgks9AdrayNRTwK4RyvwTy9rFhJqeBc1bqvQujFzly3z1zPyHItz8LRBwqEztqvRjzxKU1vr5BLzUdryBiJ5V8t9YynzxKXzLjrjAb1ZatH1fzXFnx4rQb8C4AQL4swKQAIK9kKxoKgpYK-U1LYANKNqFhlE4bfqMKvDsLtFcKErp4uAiKzNSLwcRK2bPBqLaK-h1Y_0BUmKWKWVo5VKuLOVTkxg-KwJ5BBLhKk5RL5qJKXKZsZL4gxV5LFKeRlLDaFEEKWbwrC5DEdLDl9Kgw-UjL54tBjEoAlbAErKJsUQBKmL7LXZqBnKFFdA_QJCPLINcDvL_apLWbBB_LUBArgqcjcUJVwatqdqQ0DbALEhWjOaFAkIi75AMqlrG44jGU00zZVqeBC6dqyrZr80aq-06qLrGrQFmrNAbrG6OqHqur0T0SBqhrXqtFu6NAPriqcA4am6WaEUTzFrZCniWFvDD4Cwk9z5U8jR09r5b5glph-BOIThqAC8P4XQGBcIQBMBbLMAPxWCPBkBqF5iNYp9xwmEXIQB3IcACof6PBLQORUITZP6bRcAWBvahy75ogbgJQn6747AFIkAPBEl5YXZQH8AVQ_T_BKBbKdYQBbqHFH7kGDRUGdkJgBD0HwH_7pxr7wMlB-E6A76xDYGr6UH6t_BbqMBYARSkGQAAA9KWfKHATyPBtkeAaBkoXhvhzyHACqYR_-80TelPauK-TPK0YOAwXAJ0SABYE-1AM-50L-EAK-tAD8iQGAciCI-QEuAwz6cQPDJAEVN_GhpwdAPhWMkdVASiOQRYeJRxjQZxjweCIh_BpMIEXS0RniLJWgEJthiBxRzUZPC-HejPC0TUcUbRtEPRgxovS-kSZMMhbhkdOIXSFhjkLkHkPxz-rWTkVAdoPBoMTkdQSiZMRiWB1JmvEAeAEMCp2AfiZ0JMeQR-pxzp8m4xHJBQR-jpmhzAaUkJex4B6ZjwWZtYRWBZ-63ehrGhhBg7EJ2iaQJoyBmpSYeIfxwJkAQ9FQHhz-n4TYPB2jCMRiU0ehqgNZn0WBkZmhniCQF5n0dYH0aMOwK5YZgJzp7mSpvhcm0ohZkJ15ahjwbAaUsYcJJAJI15HY8F2ACUGZn9dIhJs-ZRtPDp80EloAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/tree/development/examples/materials/properties/bump_normal/src",
        "description": "Example of the bump / normal material properties."
    },
    {
        "href": "examples/materials/properties/clearcoat/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlqKMcOQaEPIEnFY8BACeiu4gtFgExgBW_Kr8UTFxHgmJcBrk6YQE8nCIxsbk6Kg4OXCYUGoaOKi2xqjyRMYAjgCuEOQA1i4E4qgA5nAAAlD8tHDZ45MztvNLOERobXClIjysJkWxBOEmeAJCnGWMBujJ4TyM6Gpcm8mwdIAdwg6AIeEQXAAjAAGGEAUgA3FwHhAFoRIbCEYiPJ8IuRdAU4FxQekCagibiTOSiXiTD9VHTrnEuCk0h4iJR0GNYCEKlUPPzjGhMLgCKcQJdjMzbi9jG8Ppx7sQoMIQAAaEAQOAAITQ_A0ySQYH4UBcAF9NUKRdgcOKyCAqDQ6AQGM9UBAiPJKBoCFxgA4NAJaABZdaaCCmkN0MZcc1cMAaShELgeHDGGyoMaecRmjw4j1en1-gOUdQaGKYMO0GKmuMJpMptMZ8O1qA56ASgue72-_1laLBmAANQgMCBvYI6oHQfD0ngcAg1GnImrEdN0jsGAN6CU634nHjieTqZAyzgckUDM0xlUY6Bmnz7oAFIVkqhyFxnwBKLiuVj9iIjSBkOXD2He46TgO1CbFwEETsWf5gUC_ASCB4ajpBxbPsAZQ8DShSQowAAS3ghgAMgAwoShQAKKwJmtzoJQ5BjIxOALLY9EwIxOrJAAkugz4eARErfiuVigpCHLJJhCG-mcPDmt-BY8MBg7hmBfwLkuqDQagsEuHAi7UEh_AoWhGm0POxm6TheGsjstiIA5PAeAAzAArAAnN5nkAGzkOQnn8AA7GA_lQno7n-d5MLoD56BgAATO5ejJTA_npeFyWhVCyVQpgyX8J5nkwmVAAs6BQlCpVgBVegwDCoWhTAZUwvw7kwlV5DuaF7mBLVMCBKFCX-egyV6N5_AVRVtWDRV5BgN5MB9Z5k38DA00wFCoWeXoJX8GA7neXoIVQvwyUwsFgTuZNgTHRdS3LYE016DCMDPWAvUwmAgSCLFi2BAFehVTCyUVZtO0VRD5D-bFgToCtoPkIjejjYVJWQ1C_nAzAFX-FCt3vZ5UUrRVgQFeQehE3ot3_eDwXoKF_nuegHgSaInKdHJngaFA0kgDUdQNNKmBjOQUI4DAYz-OQLoaKahM4BeCgwNePRUEQHMOVJp5EMkNkmXpIBlMpBZlOps60FpfRAlwRCtpGUBcOg-76bBjs1s7SF21wa5tpuuhuxou77j-FtAcYXBlpolYwKyDwO07pqnCIscVqCMAB87z5Gcb6qngACjEjuGhzxelwayQ56aFde-uUAqWUGfx7XUB5zpy6nvOToh8kFceL31D9-39cp03kdqdHVkJ-CCcN22DsxmU5moX6s_t9GWbPovzvN6gykR5wGparq-qGsaqcwJaIBCnvpodmadoIMgjrULQ9CIFqRZ9rh5xcH4t4IMMAAByXIYCcx4O3IO25Q57jsFArgABxGAyZbCGgQfwJB8FJxwCQfxI2ukACC8gIBmwbCeDw55LzqzUDeeCj4QCqVTEBAAVGwvCbCuAACUYDyDWPLMCUAXYsVYkGD88AY5gETgvCeXAQTglkX8RQ5AICQHVlwVA_AbBcJJNweeDgxgVhdFoiBYEMAkgIAAcmJI4aA6AJEKIkHgZRD8XbyCTHeTA7NzicL8VwZY8gDQ6LMZgPRQSQkpncaAnRMAInBMVtEieXDjAez9EGAR_B5btyQsJABqAIGQiASA8BmAkExLiZCTYMRFgVInpCGBW4Q5hzsGUX8_5AJWDAD6L8sA_QQCQjCZEgzGBhJgDgN2dgcCwEWOCEZABqBZv5_6JFCNHdxdjdBcEalwGALjNCuwgEGcgkhkj6OUVM-wlAZH2EKeEgBPB1FfnuRMq5ABtCAABdfRmxdDyxuf7CesCWlYJWa5UQTpYLiIkQQXJrheBNODjuLBrBXmTP3J8r5LC1nPOfDCl07dehxL_K4BFlSbC_nRR875SF3E4tEOaMoELgK9PJDshOhRFwLD6OgVklAtKcXQQQcujySQyOfNSzFtK0B_MkYC1BwrMH7nBWK_CME_RCpsCK85CLGCKu1cquwaKIEYrsFihlkkJUQqsFqjB5yABkDqbWiDtTqw48inUup4G6w0HrvammJTYUl5KJ6xN0Wqrg35vVcF9ckf1jc6UT0tXGByTKRAOR6VoZ8_SSRDJGbwcZOB7FQEcXQGZdAFjzJJEs6NYrMmCOzhPSVpqS1ltQFiwuFLIHJwDZPM2LDLYcL0QAeXLPHNx8jFGuMMXAVR6ixx8u7RcwxlAxi1HXXo6dyi52fQXZotdG6CDhoTtuwx7iuCeLLFndAOA9HEIcKaKAB1pjOJERyrgQYFjahrJoggArW5Z0TusXtiaYDlnOeICNohuGrvXfIddJJiRjHkFM9Wd6_EJKidpWy1AsNJJjvB9dJ78OhO7aR5JfbUllGwJOBwGqY7jqzvCr8Dl866WKUQ6gpCIBIMPQh49VS_girQAsepfaT3VJE3Uhy7jGnAuaSi92IgOkAVWaIYCvgRTKP44h4On6xjcHsGAccDgHjTDTlYKFfpdPij4iepC7HqAcVsCOojBB7NxOfLZk9B8rVfls7qZIJ6K1zNcQBKEqq1lQsoLAGZlAFjCRAN4B4QYwJpaIDycQAiE6BecUo8EIHtE2DvSAPziQgwEGMagBl8YYBmgTniwLnmSuzKra4slCKYRRcSDFuLUAEtJfAYRo9-WZ1yD9MV09hQExrowKV8rVhKvVdqw5azl6q6Gjc6NhFTnWicQINtgTLWYDefc7595MIvkAEJB0AKtqBewBIREvqmMBv0KG0PEnPSk-70cz1J13WojRfKptjcnX2jb16fFrYY598M1EXvZLewiyV44ykwAAPzFOATAMBEDC6xfQBj7HgDcf48wKprpFX-GNvbmjoEGPrtdrDXElnfbFuiDtkznA8PaDDk0MbY-YrcHFjgO8mSckoIgC-bz1D4ZhdWHNAy4CXK0QGKTs959yP-U6fcw5Txnpq5HfXXLtDiPtevoRXzmAFvXsq5nk-5RWvXskiIDYH44YoDnKzc74xsLxkORt3b5Hz5Ddl2SCbggvQIHXfK8rsop9tR6m0ZfRAJoGu33vjGJ-cAX4OidJ_V038eyIXU2GeQWDOZIrga07BZR260UWGgSBZRRe-nwWUKIdAYDk85ga-1WDDyUKbGeVWV56EaFvPeJhkd1vuKb9-vo8m-2L5b0hRvze-g4FlVueWkdjDDu4Nwyi1s55J0zLGX3P2-2FzVzyy5MATRZbgqaMY8AEj-K4NwyJBH3Gf7ST6CwDo3W03gnm3ljARTfA_C_DkyBT7RBSUzsCp3Uwe00m2Rt0fSR1fWvwv1-3VQMg-3l1DHkVRxQIcmAlwO1D2SwB0Ry0LgfC4EwKd19THGJDQB3Xlj6AoOjjQiBDXVLQ_U5DSyf0gDUVMX_RjlQG9yYOIPPwTlYKkUKw-xcDcS5H3SXXwNEG7z6HJxwCTEoGjxFXyEF2UHDmfCuXILFTxSuV-T3zQRkQHx1TBVdn3DNwwkFzsk53NlkwnncP508OoEV20K4N7xAX0MoEMP8JHECNQGCJ4Hb3FAlxAANil2LA8Flxt2CITz0ijm0j9EwGfygD9AKCgHf0s1AzbGLVi16QRQ8AAGJ4Z_InwRB3Fi1YADQqAQMEUoQWE2jyAOjKhKB1hwENBHYoAK8_wHJXwLI_QF8t8JkBtBAK98k1kPBhZ6hGhGEehx86FyxqjhhVB3JhRHZOI4BjBpAlAAB9QpMYwNeQRYRSUQb8X8AAH1eKYIwCfxb3QD6L8IGIECGPWB4TXXRD6GMiQl6LKH6MGK6IIBBLGDBIXEmPcAARmPXkqOdjX23yWPQBWIhXWLmBFi2Jnx2NoQ1gONvGOKNzOIuOuIWEVmSCiFNBgCuLQHLBcBwAeIWCeJ4BeK4HeM-MKJ-KnkxMDW1VNHBOJB6L-L7QiMRLwClPzTKBt3pwPkthnjP3yP2GJE8H4nSTFKgCLl0HqzyUYF0A-BBAwEoCBG_BwAAEUJhph5w5hRM89Z5nwYRC4vTTwx4ysWF1szBYAdQDRiJ9l0Q_RUcSIyJyIVBVBuJGJWBVjRBmJWJ2IDsEyXQgtKI1hjIT0ksRg4ArigzWSDoNAPBvxLsvl2k7SBixwaAwy0RCAWFnxoyKI4zMyaAkyHJUy2IXQXMCBOy7NkgcyuV8yPBCyrjC8XQKyqyayVYUg4tHYsBGyIykIrTmIgQd9UA-gNBVzCAuB_BHJzAQy9zwyDyFlTx5AsAWjoSJ5jS-goAcBBBic2JGoNAksJSoApSK4fSoRC5_yuAYQcAYRALnxSj39IQswiB3yrCrA2ivylSEUIKYAGVVTm1491TWj7yTSnyXzQE3zNAkskwFSfyNQgKALvTvSQKwKUKoLCKNA4KuY_CSKkSITkK39UKg85C1SWEfDcieB3EHz6tnz0BXyYKiKRJYThj4hyK_zKKgKaLC5wLOL6KJLGK_w1NfC5SATOiZKkIUK0KeKMK-KsKeBc1cTRM-YBZhNakFgWFgIL00ABM7y-1hK8KxLvBsACAktdKgS4UFBB5TZyLoDPwVKyiYApM7KmLzLbAHBpL1gK95NK99wBShTvjeUGUdVqcrBLLFhrKDLOKU0_K4SUSvw140J5il9Fjhi8SFBwr39-TBTDNhTMq01H0CBHAvwYAesrMYJYsarEsPBiFuA45ekxF_dNEgQ8BoAE48qFhncEqAr5AXJyKerasEx9QRFzl1MrBgIUsE5HBPo3sAc5raqrKeFyIkMtE8cfFdc6A4BjF4kxVgJlCFFOU0tskqsn1zkFABFkhRNlFcySjOL3sFEZsXAaAWVo5-IN4BC-Vdk3rprZquB5rC5DExgXAtAXRNBNFdBDDUsmD-ZobAEZE3rLxFADIGCE5mJUBrE_QUIaBdc_qZCft5AwaUJiRcTNE0BGoCAHw6AIU8V5qCrOtX8IrerEgYTATSqFAkISqZKK8U0eB0K-14jGU00zYzLUa4qRb-YQworRMHKNl5FnLN1sK3LcLRL0AvKshky3JHQlrRjxiK8dYAFCTahNjp9xxNAVZyTJ9KSjiTj-BaTLibifRxiuTHiNQHJQqvw6LbLRMYrRBc0FaRiI6owFBkqsE0qWqMr1YU1srdrEg9aJjCqIrlb4qZaZLnbM72bUcKq5iJ5sSarlj6qUKmqPi87IA2qxV4wCROrXFnweqcret-r-tBsY1hrRqKxxqgpJq-VkbYBUbzrFhFrq7067iJis63a1krBnq96o0U0jwtqZDi69ro4DqzNjrwdDERbLrrq-h1Y_0BUHqnqXVXqJt3r0tOVTkxgfqwJ5B_rAa77CgQaIqOaIaZzI1gJYb6MeQEbz8QMl6zrBBRN0ak5MbDkcagw-V8b54tBjEoAP6Yayav6KaHrqbXZqB6bwambJCWbIM8D2akaZtua-VebbABaBK97hbV6FhrKQwQ1xbGrR61lpa9LN6Xa5aEU07j0M7t75BK6VbjK1bOclcIV00NGVNRShKrb8KGL7bTw5GES2KJQkEvSHJ_yrGLGlLpiE7oLYLNKxHDT2iN74TQTFSFxy738U1VbG51atGj73RYq_RS6eFDbFhjbDT9EXKLbG53LrbbafKHIpL3HTGvHjJXaY73ahYiSvbti_a1YKStYqTg7Q76TGTmTYA2SKRTCo6eScmrA46GrIrE7Fhk7Qmq7JGPHSLkSs6gUUq7Bc6vie6C6IUi6XVwmfGuLI0THPGpSUSY10TKrm6Fj4s275BWnO70qxnfjNGOqurh7Ja-qDIBr4shrI0HaRq9lZ6tAJqTFF6Zrl75r16emMnFmd6mnD69kXV1H6we6AHz6NNL7NdzMTqXEgb-HPAH7qCn67rJC36gwSGOaPrf7vrtrAHgG17QHYIULIHiRIb4gYGYa4aEGP0kbnnUGfg6llEsHsbnRcGLECbDkiGUX-IyGQMKGqbv7abaHGa_QGGgHWbmGCWV7BAebUA-buGXU-G0H8r-YeFhGO6XH4L_ilqPn-n67un_LNWsmFBlHZC0NeKXUgntHzXgnD4Cwk9z5U8jR09r5b5glpgQ6Jl2hqAC8P4XQGBcIQBMBKbMAPw2CPBkBqFdiNZvaHxyykAPIcACo42PBLQORUITZVqbRcAWBiGY675ogbgJRQ2747AFIY2QBEl5YXZ038AVRDz_BKBKadYQA9AJhS0Q2PAy3TSm2HF9FRQq2SBE3pw_XwMlB-E6BA3xD83fX22oB_Am2MBYBo3VqAA9KWfKHATyBttkeAXNkoEtxdzyHACqNdxN80G1lPauK-TPK0YOAwXAJ0SABYE4D1t-acr-EAX1tAHuiQGAciSI-QEuQwz6cQPDJAEVd_AdpwdAPhXEkdVASiOQRYeJEDjQMDjweCVtxtpMIELGjdniLJWgdDqdxN09i-e1jPC0TUcUO9tER91AT150V931rWMhedkdOIXSCdjkLkHkRD1arWTkVAdoBtoMTkdQSiZMRifNsj1vEAeAEMLj2AfiRlutkN0D6TuANdSoJteQENqTgdzAAYkJID1N3TjwfTtYRWIz7Jh1hrAdotg7dD2iaQZo7NmpSYWSxAVTgdw9FQBd0zn9Bt2jCMRiU0YdqgCzn0fNzzjwHiCQULn0dYH0aMOwK5FT5D6T7mbjvhdTsooz9D15ft6LrAAYsYcJJAZI15K4jL2AcxvzzYDIk9zUZPEji9i0c0c0IAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/tree/development/examples/materials/properties/clearcoat/src",
        "description": "Example of the clearcoat material properties."
    },
    {
        "href": "examples/materials/properties/color_map/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlqKMcOQaEPIEnFY8BACeiu4gtFgExgBW_Kr8UTFxHgmJcBrk6YQE8nCIxsbk6Kg4OXCYUGoaOKi2xqjyRMYAjgCuEOQA1i4E4qgA5nAAAlD8tHDZ45MztvNLOERobXClIjysJkWxBOEmeAJCnGWMBujJ4TyM6Gpcm8mwdIAdwg6AIeEQXAAjAAGGEAUgA3FwHhAFoRIbCEYiPJ8IuRdAU4FxQekCagibiTOSiXiTD9VHTrnEuCk0h4iJR0GNYCEKlUPPzjGhMLgCKcQJdjMzbi9jG8Ppx7sQoMIQAAaEAQOAAITQ_A0ySQYH4UBcAF9NUKRdgcOKyCAqDQ6AQGM9UBAiPJKBoCFxgA4NAJaABZdaaCCmkN0MZcc1cMAaShELgeHDGGyoMaecRmjw4j1en1-gOUdQaGKYMO0GKmuMJpMptMZ8O1qA56ASgue72-_1laLBmAANQgMCBvYI6oHQfD0ngcAg1GnImrEdN0jsGAN6CU634nHjieTqZAyzgckUDM0xlUY6Bmnz7oAFIVkqhyFxnwBKLiuVj9iIjSBkOXD2He46TgO1CbFwEETsWf5gUC_ASCB4ajpBxbPsAZQ8DShSQowAAS3ghgAMgAwoShQAKKwJmtzoJQ5BjIxOALLY9EwIxOrJAAkugz4eARErfiuVigpCHLJJhCG-mcPDmt-BY8MBg7hmBfwLkuqDQagsEuHAi7UEh_AoWhGm0POxm6TheGsjstiIA5PAeAAzAArAAnN5nkAGzkOQnn8AA7GA_lQno7n-d5MLoD56BgAATO5ejJTA_npeFyWhVCyVQpgyX8J5nkwmVAAs6BQlCpVgBVegwDCoWhTAZUwvw7kwlV5DuaF7mBLVMCBKFCX-egyV6N5_AVRVtWDRV5BgN5MB9Z5k38DA00wFCoWeXoJX8GA7neXoIVQvwyUwsFgTuZNgTHRdS3LYE016DCMDPWAvUwmAgSCLFi2BAFehVTCyUVZtO0VRD5D-bFgToCtoPkIjejjYVJWQ1C_nAzAFX-FCt3vZ5UUrRVgQFeQehE3ot3_eDwXoKF_nuegHgSaInKdHJngaFA0kgDUdQNNKmBjOQUI4DAYz-OQLoaKahM4BeCgwNePRUEQHMOVJp5EMkNkmXpIBlMpBZlOps60FpfRAlwRCtpGUBcOg-76bBjs1s7SF21wa5tpuuhuxou77j-FtAcYXBlpolYwKyDwO07pqnCIscVqCMAB87z5Gcb6qngACjEjuGhzxelwayQ56aFde-uUAqWUGfx7XUB5zpy6nvOToh8kFceL31D9-39cp03kdqdHVkJ-CCcN22DsxmU5moX6s_t9GWbPovzvN6gykR5wGparq-qGsaqcwJaIBCnvpodmadoIMgjrULQ9CIFqRZ9rh5xcH4t4IMMAAByXIYCcx4O3IO25Q57jsFArgABxGAyZbCGgQfwJB8FJxwCQfxI2ukACC8gIBmwbCeDw55LzqzUDeeCj4QCqVTEBAAVGwvCbCuAACUYDyDWPLMCUAXYsVYkGD88AY5gETgvCeXAQTglkX8RQ5AICQHVlwVA_AbBcJJNweeDgxgVhdFoiBYEMAkgIAAcmJI4aA6AJEKIkHgZRD8XbyCTHeTA7NzicL8VwZY8gDQ6LMZgPRQSQkpncaAnRMAInBMVtEieXDjAez9EGAR_B5btyQsJABqAIGQiASA8BmAkExLiZCTYMRFgVInpCGBW4Q5hzsGUX8_5AJWDAD6L8sA_QQCQjCZEgzGBhJgDgN2dgcCwEWOCEZABqBZv5_6JFCNHdxdjdBcEalwGALjNCuwgEGcgkhkj6OUVM-wlAZH2EKeEgBPB1FfnuRMq5ABtCAABdfRmxdDyxuf7CesCWlYJWa5UQTpYLiIkQQXJrheBNODjuLBrBXmTP3J8r5LC1nPOfDCl07dehxL_K4BFlSbC_nRR875SF3E4tEOaMoELgK9PJDshOhRFwLD6OgVklAtKcXQQQcujySQyOfNSzFtK0B_MkYC1BwrMH7nBWK_CME_RCpsCK85CLGCKu1cquwaKIEYrsFihlkkJUQqsFqjB5yABkDqbWiDtTqw48inUup4G6w0HrvammJTYUl5KJ6xN0Wqrg35vVcF9ckf1jc6UT0tXGByTKRAOR6VoZ8_SSRDJGbwcZOB7FQEcXQGZdAFjzJJEs6NYrMmCOzhPSVpqS1ltQFiwuFLIHJwDZPM2LDLYcL0QAeXLPHNx8jFGuMMXAVR6ixx8u7RcwxlAxi1HXXo6dyi52fQXZotdG6CDhoTtuwx7iuCeLLFndAOA9HEIcKaKAB1pjOJERyrgQYFjahrJoggArW5Z0TusXtiaYDlnOeICNohuGrvXfIddJJiRjHkFM9Wd6_EJKidpWy1AsNJJjvB9dJ78OhO7aR5JfbUllGwJOBwGqY7jqzvCr8Dl866WKUQ6gpCIBIMPQh49VS_girQAsepfaT3VJE3Uhy7jGnAuaSi92IgOkAVWaIYCvgRTKP44h4On6xjcHsGAccDgHjTDTlYKFfpdPij4iepC7HqAcVsCOojBB7NxOfLZk9B8rVfls7qZIJ6K1zNcQBKEqq1lQsoLAGZlAFjCRAN4B4QYwJpaIDycQAiE6BecUo8EIHtE2DvSAPziQgwEGMagBl8YYBmgTniwLnmSuzKra4slCKYRRcSDFuLUAEtJfAYRo9-WZ1yD9MV09hQExrowKV8rVhKvVdqw5azl6q6Gjc6NhFTnWicQINtgTLWYDefc7595MIvkAEJB0AKtqBewBIREvqmMBv0KG0PEnPSk-70cz1J13WojRfKptjcnX2jb16fFrYY598M1EXvZLewiyV44ykwAAPzFOATAMBEDC6xfQBj7HgDcf48wKprpFX-GNvbmjoEGPrtdrDXElnfbFuiDtkznA8PaDDk0MbY-YrcHFjgO8mSckoIgC-bz1D4ZhdWHNAy4CXK0QGKTs959yP-U6fcw5Txnpq5HfXXLtDiPtevoRXzmAFvXsq5nk-5RWvXskiIDYH44YoDnKzc74xsLxkORt3b5Hz5Ddl2SCbggvQIHXfK8rsop9tR6m0ZfRAJoGu33vjGJ-cAX4OidJ_V038eyIXU-3Wiiw0CQLKEiuBrTsG14UFgzmovfT4LKFEOgMByecwNfarBh5KFNjPKrK89CNC3nvEwyO633GV-_X0eTfaF_V6QhXqvfQcCyq3PLSOxhh3cG4ZRa2c8k6ZljL7n7fbC5q55ZcmAJostwVNGMeACR_FcG4ZEgj7iP9pL6CwDo3W03gnm3ljARTfA_C_DkyBT7RBSUzsCp3Uwe00m2Rt0fSR1fSv3P1-3VQMg-3l1DHkVR2QIcmAhwO1D2SwB0Ry0LgfC4AwKd19THGJDQB3Xlj6HIOjjQiBDXVLQ_U5DS0f0gDUVMX_RjlQG90YKILPwThYKkUKw-xcDcS5H3SXTwNEC7z6HJxwCTEoGjxFXyEF2UHDmfCuTILFTxSuV-V3zQRkX7x1TBVdn3DNwwkFzsk53NlkwnjcP5w8OoEVy0M4J7xAT0MoAML8JHACNQCCJ4Db3FAlxAANil2LA8FlxtyCITz0ijm0j9EwCfygD9AKCgDf0s1AzbGLVi16QRQ8AAGIwBGiminwRB3EPV5A_wHJXwLI_R59N8JkBtBAwx5B8k1kPBhZ6hGhGEegx86FywqjhhVB3JhRHZOI4BjBpAlAAB9KgAbHoeQRYRSUQb8X8AAH1OMYIwEf2r3QBYRt3pwPkthnlPzyP2GJE8H4nSQqOdiLl0HqzyUYF0A-BBAwEoCBG_BwAAEUJhph5w5hRM89Z5nwYRC4UTTwx4ysWF1szBYAdQDRiJ9l0Q_RUcSIyJyIVBVBuJGJWBRjRBmJWJ2IDsqSXQgtKI1hjIT0ksRg4AticSYAtiDoNAPBvxLsvl2kITyAugXQCS0RCAWFnxSSKIKTmSaAaSHJ6S2IXQXMCAVS7Nkg2SuVOSPBuSdiP4XRhTRTxSVYUg4tHYsAZSiSkIQTmIgRt9UA-gNAHTCAuB_BHJzA8TPTCTvSFlTx5AsAWinj6M9j9EBMyh3Ffi-goAcBBB0BvBsACAktdifRB4QAGimjGiK5nwSi38pNakFhLCrA2isytAEViyYAGV7jm149HiRBc1BifhFg-YBZhMyyWFgIL00BYzWiJ4Ez6tkz0BUz0zaS3JkiFAdYAFxi5gRYpjp8ZjaENYFjbxlijc1iNjtjqycADiFh5yrAoDPwizX8YBSzRMKzEhc1HZ5B5N5AsEuALjDMCibiU0dVqc1l2zRMuykI6yU0eAHy8k140I-jF8BjKAhiFALzSiYATjXy3yrjIBeUU14wCQCBHAvxEKfzesYJYtoLEsPBiFuA45ekxF_dNEgQ8BoAE4_zFhJ1HyK5EKMKEx9QRFzl1M1lgIUsE5HBPo3sAcGKYKOyFhPAeFyIkMtE8cfFdc6A4BjF4lI1gIlCFFOU0tskqsn1zkFABFkhRNlF2TijLz3sFEZsXAaAXVgJ-IN5-C-Vdl1LaL6KuBGKxNlExgXAtAXRNBNFdADDUtGD-YbLo5-IZF1LLxFADJ6CE5mJUBrE_QUIaBdd9LpCfsOjnKZt2zNE0BGoCAHw6AXU8V3KALOsX8EKes1kQLfDQLQ15BgLRBGy-04jEh001l2rGV2kCxsik9z5U8jR09r5b5glph-BOIThqAC8zSv4QBcIQBMBorMAPxWCPBkBqFZiNYp9xwmEXIQB3IcACpDqPBLQORUITY9qbRcAWAoAdY75ogbgJR1q747AFIkAPBEl5YXYrr8AVQfT_BKBoq7q9AJhS01qPqDQvqdlQa-UfqbqTrpwFrwMlB-E6BlqxCnr5rPr6t_AQaMBYAhT3qQAAA9KWfKHATyO6tkeAB6koIm4mzyHACqCmk680PqlPauK-TPK0YOAwXAJ0SABYSa1Aaa50Wa-atANCiQGAciCI-QEuAwz6cQPDJAEVN_RGpwdAPhdskdVASiOQRYeJVWjQdWjweCcGkAPQJMIEbyqmniLJWgC27G26kANmzUZPC-QajPC0TUcUAWtEYW0WovBgearWMhAmkdOIXSTGjkLkHkI2varWTkVAdoO6oMTkdQSiZMRiJ672mvEAeAEMOO2AfiZ0JMeQNatW_OuANdSoJtCurmlwRGzASUkJZWi6vO5uz6NYRWdu4YtazujwV6g7C22iaQfyO6mpSYeIY202kAQ9FQQmvan4TYO62jCMRiU0FGqgXun0J6quxGniCQben0dYH0aMOwK5Suk2_O7meOvhGu0o9ui215BGjwbASUsYcJJAJI15LYu-2ACUZun9dIt2s-DmtPPO80aBoAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/tree/development/examples/materials/properties/color_map/src",
        "description": "Example of the color / map material properties."
    },
    {
        "href": "examples/materials/properties/displacement/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlqKMcOQaEPIEnFY8BACeiu4gtFgExgBW_Kr8UTFxHgmJcBrk6YQE8nCIxsbk6Kg4OXCYUGoaOKi2xqjyRMYAjgCuEOQA1i4E4qgA5nAAAlD8tHDZ45MztvNLOERobXClIjysJkWxBOEmeAJCnGWMBujJ4TyM6Gpcm8mwdIAdwg6AIeEQXAAjAAGGEAUgA3FwHhAFoRIbCEYiPJ8IuRdAU4FxQekCagibiTOSiXiTD9VHTrnEuCk0h4iJR0GNYCEKlUPPzjGhMLgCKcQJdjMzbi9jG8Ppx7sQoMIQAAaEAQOAAITQ_A0ySQYH4UBcAF9NUKRdgcOKyCAqDQ6AQGM9UBAiPJKBoCFxgA4NAJaABZdaaCCmkN0MZcc1cMAaShELgeHDGGyoMaecRmjw4j1en1-gOUdQaGKYMO0GKmuMJpMptMZ8O1qA56ASgue72-_1laLBmAANQgMCBvYI6oHQfD0ngcAg1GnImrEdN0jsGAN6CU634nHjieTqZAyzgckUDM0xlUY6Bmnz7oAFIVkqhyFxnwBKLiuVj9iIjSBkOXD2He46TgO1CbFwEETsWf5gUC_ASCB4ajpBxbPsAZQ8DShSQowAAS3ghgAMgAwoShQAKKwJmtzoJQ5BjIxOALLY9EwIxOrJAAkugz4eARErfiuVigpCHLJJhCG-mcPDmt-BY8MBg7hmBfwLkuqDQagsEuHAi7UEh_AoWhGm0POxm6TheGsjstiIA5PAeAAzAArAAnN5nkAGzkOQnn8AA7GA_lQno7n-d5MLoD56BgAATO5ejJTA_npeFyWhVCyVQpgyX8J5nkwmVAAs6BQlCpVgBVegwDCoWhTAZUwvw7kwlV5DuaF7mBLVMCBKFCX-egyV6N5_AVRVtWDRV5BgN5MB9Z5k38DA00wFCoWeXoJX8GA7neXoIVQvwyUwsFgTuZNgTHRdS3LYE016DCMDPWAvUwmAgSCLFi2BAFehVTCyUVZtO0VRD5D-bFgToCtoPkIjejjYVJWQ1C_nAzAFX-FCt3vZ5UUrRVgQFeQehE3ot3_eDwXoKF_nuegHgSaInKdHJngaFA0kgDUdQNNKmBjOQUI4DAYz-OQLoaKahM4BeCgwNePRUEQHMOVJp5EMkNkmXpIBlMpBZlOps60FpfRAlwRCtpGUBcOg-76bBjs1s7SF21wa5tpuuhuxou77j-FtAcYXBlpolYwKyDwO07pqnCIscVqCMAB87z5Gcb6qngACjEjuGhzxelwayQ56aFde-uUAqWUGfx7XUB5zpy6nvOToh8kFceL31D9-39cp03kdqdHVkJ-CCcN22DsxmU5moX6s_t9GWbPovzvN6gykR5wGparq-qGsaqcwJaIBCnvpodmadoIMgjrULQ9CIFqRZ9rh5xcH4t4IMMAAByXIYCcx4O3IO25Q57jsFArgABxGAyZbCGgQfwJB8FJxwCQfxI2ukACC8gIBmwbCeDw55LzqzUDeeCj4QCqVTEBAAVGwvCbCuAACUYDyDWPLMCUAXYsVYkGD88AY5gETgvCeXAQTglkX8RQ5AICQHVlwVA_AbBcJJNweeDgxgVhdFoiBYEMAkgIAAcmJI4aA6AJEKIkHgZRD8XbyCTHeTA7NzicL8VwZY8gDQ6LMZgPRQSQkpncaAnRMAInBMVtEieXDjAez9EGAR_B5btyQsJABqAIGQiASA8BmAkExLiZCTYMRFgVInpCGBW4Q5hzsGUX8_5AJWDAD6L8sA_QQCQjCZEgzGBhJgDgN2dgcCwEWOCEZABqBZv5_6JFCNHdxdjdBcEalwGALjNCuwgEGcgkhkj6OUVM-wlAZH2EKeEgBPB1FfnuRMq5ABtCAABdfRmxdDyxuf7CesCWlYJWa5UQTpYLiIkQQXJrheBNODjuLBrBXmTP3J8r5LC1nPOfDCl07dehxL_K4BFlSbC_nRR875SF3E4tEOaMoELgK9PJDshOhRFwLD6OgVklAtKcXQQQcujySQyOfNSzFtK0B_MkYC1BwrMH7nBWK_CME_RCpsCK85CLGCKu1cquwaKIEYrsFihlkkJUQqsFqjB5yABkDqbWiDtTqw48inUup4G6w0HrvammJTYUl5KJ6xN0Wqrg35vVcF9ckf1jc6UT0tXGByTKRAOR6VoZ8_SSRDJGbwcZOB7FQEcXQGZdAFjzJJEs6NYrMmCOzhPSVpqS1ltQFiwuFLIHJwDZPM2LDLYcL0QAeXLPHNx8jFGuMMXAVR6ixx8u7RcwxlAxi1HXXo6dyi52fQXZotdG6CDhoTtuwx7iuCeLLFndAOA9HEIcKaKAB1pjOJERyrgQYFjahrJoggArW5Z0TusXtiaYDlnOeICNohuGrvXfIddJJiRjHkFM9Wd6_EJKidpWy1AsNJJjvB9dJ78OhO7aR5JfbUllGwJOBwGqY7jqzvCr8Dl866WKUQ6gpCIBIMPQh49VS_girQAsepfaT3VJE3Uhy7jGnAuaSi92IgOkAVWaIYCvgRTKP44h4On6xjcHsGAccDgHjTDTlYKFfpdPij4iepC7HqAcVsCOojBB7NxOfLZk9B8rVfls7qZIJ6K1zNcQBKEqq1lQsoLAGZlAFjCRAN4B4QYwJpaIDycQAiE6BecUo8EIHtE2DvSAPziQgwEGMagBl8YYBmgTniwLnmSuzKra4slCKYRRcSDFuLUAEtJfAYRo9-WZ1yD9MV09hQExrowKV8rVhKvVdqw5azl6q6Gjc6NhFTnWicQINtgTLWYDefc7595MIvkAEJB0AKtqBewBIREvqmMBv0KG0PEnPSk-70cz1J13WojRfKptjcnX2jb16fFrYY598M1EXvZLewiyV44ykwAAPzFOATAMBEDC6xfQBj7HgDcf48wKprpFX-GNvbmjoEGPrtdrDXElnfbFuiDtkznA8PaDDk0MbY-YrcHFjgO8mSckoIgC-bz1D4ZhdWHNAy4CXK0QGKTs959yP-U6fcw5Txnpq5HfXXLtDiPtevoRXzmAFvXsq5nk-5RWvXskiIDYH44YoDnKzc74xsLxkORt3b5Hz5Ddl2SCbggvQIHXfK8rsop9tR6m0ZfRAJoGu33vjGJ-cAX4OidJ_V038eyIXUwa-1WDOZhnkFXso7daKLDQJA-vCnkXwP3JzKIdAYDk85qL30acjyNlPDQtWGtbz3iYZHdb7jG_fr6PJvt8_m9IQb03voOBZVbnlpHYww7uDcMotbOeSdMyxl9z9vthc1c8suTAE0WW4KmjGPABI_iuDcMiQR9x7-0l9CwDo3W03gnm3ljARTfA_C_DkyBT7RBSUzsCp3Uwe00m2Rt0fSR1fUvzP1-3VQMg-3l1DHkVRyQIcmAmwO1D2SwB0Ry0LgfC4HQKd19THGJDQB3Xlj6DIOjjQiBDXVLQ_U5DSwf0gDUVMX_RjlQG9wYMINPwTmYKkUKw-xcDcS5H3SXVwNEG7z6HJxwCTEoGjxFXyEF2UHDmfCuVILFTxSuV-R3zQRkQrx1TBVdn3DNwwkFzsk53NlkwnlcP53cOoEV00I4N7xAV0MoH0N8JHH8NQECJ4AH3FAlxAANil2LA8Flxt0CITz0ijm0j9EwEfygD9AKCgFf0s1AzbGLVi16QRQ8AAGJ4Z_InwRB3EY8NBHYoAa8_wHJXwLI_Q58N8JkBtBAa98k1kPBhZ6hGhGEehVYrx6FNZkxbx3JhRHZOI4BjBpAlAAB9QpNowNeQRYRSUQb8X8AAH1OIYIwAf2b3QBYRaJ-DnUbUYk6PcAAR6PXnKOdhX03yGPQBGIhXGLmBFimKnxmNoQ1kqOGFUGWKNzWI2O2IWEVmSCiFNAmQOIWCOJ4BOK4HOMuPyJuJYRt3pwPkthnhP1yP2GJE8H4nSU-NNCLl0HqzyUYF0A-BBAwEoCBG_BwAAEUJhph5w5hRM89Z5nwYRC5xTTwx4ysWF1szBYAdQDRiJ9l0Q_RUcSIyJyIVBVBuJGJWBRjRBmJWJ2IDtdSXQgtKI1hjIT0ksRg4Atj5SYAtiDoNAPBvxLsvl2luTyAugXRlS0RCAWFnwNSKJtSzSaB9SHIjS2IXQXMCBwy7NkhLSuUbSPA7StjC8XQ3SPSvSVYUg4tHYsB_TVSkJ2TmIgQt9UA-gNBizCAuB_BHJzBFSayVS6yFlTx5AsAmiyh3EGS-goAcBBBic2JGoNADS3IQAHisl5ZGJpBnt4kNQHJxSHIoQkFVylycAYR1y3jijX9IQswiBRyLC1l7jtRpyeIXQ5zUSkJdyYAU0iTm1PD2kp46SoA-z6tBz0BhzDzNBxzTwpyniXQ9RCgdYAFlyAFtyrBwKoLNzILRBnxbz9yRzNBjzEhTzHjskLyaBgLiQEVbz7yZDiTVsVMXzc1fjRM-YBZhNakFgWFgIL00ABMeyJ53yByhzvBsACA_yPAALMLniFBQKrBATahJjJ9xxNAVZwT5jISliVj-A4TNitjET-BDZ5ycB0TBLRBIDPwEKX8YApMaLUKrBc1eKZzCUFB5Na99wcS8TrjeUU0dVqc1lyLFhKKby9KU0eBTKsK4UFA8k140J-iF9BjKBhiFBdKSiYBsTcTDN8T7KIV4wCQCBHAvwoqnLesYJYsQrEsPBiFuA45ekxF_dNEgQ8BoAE4XKFhLkzzAKaAa8XINQ9lOclIEx9QRFzl1M1lgIUsE5HBPo3sAcKrQqfhXKeFyIkMtE8cfFdc6A4BjF4lI1gJFCFFOU0tskqsn1zkFABFkhRNlErSii9L3sFEZsXAaAXVgJ-IN4-C-VdllrSryquBKrC5DExgXAtAXRNBNFdB9DUsGD-YLro5-IZFlrLxFADI6CE5mJUBrE_QUIaBddtqpCft5BjqUJiRfjNE0BGoCAHw6AXU8VKq3LOtn9Iqes1keB0Lzz-LUaEVvKabPLRAHy-1YjEh001l2bGVnz3RKaWLGS2KvzQFkKxyPBdj2irzeRGrJTVzoQJTYLC4Iq9ytFhajLXzWjxb5z3LIqGVmbG5MiSSRAyLhqKL-ZiEDLRM6KNl5FGLN1mi-b-zPz0AOKshuKQAxaowBLFyAFhLgSxKHwwTx9pKtZZLYT4B4SdifR2j1LDivarBtKvxELqLRNVaeBc13aOiLKgUrK7AbLYq7L1YHLDR0rjLjbXLTatbX9Gb06XivwAq-iJ5viQqwr5BFaoqziLi87IB4qxVEr1gUrnw0rOqMqDIsr4scqQA8q9kKxCqgpiq-UHrYAnrS6qrDFq6LKK4oqU0jw2qpCh6rBurNdzMBqXF9rl7PAxqJq-h1Y_0BVZr5rAa0bVrOVTkxhNqwJ5Adq9rDEDrSbX80bTqszFqgbrqeRbrT8QMF6hrBBRMXqk43rDlPqgw-Ufr54tBjEoAH7gbjqwbZrIbXZqBYaTqEbxCkbIMcDUb7qZtMa-VsbbA8bsiKbxU-kz7y6SbbzyaKaWi17aazE9iM75BGaeBda2xWalcEq01ubD4Cwk9z5U8jR09r5b5glph5KJl2hqAC8P4XQGBcJJz-E6BMAPwWCPBkBqFZi6Fyw_amEGr3IcACo7GPBLQORUITYGqbRcAWAMHFy75ogbgJRTG747AFIkAPBEl5YXZ3H8AVR6z_BKBwadYQA9AJhS0THQmDRwmdlkmaGriPGVRHHpw9HVAlB9GrijG38yA0nKh6t_AkmMBYBXSQmQAAA9KWfKHATyBJtkeAXxkoRpppzyHACqdpxx80GRlPauK-TPK0YOAwXAJ0SABYE4DRt-TMr-EAXRtALuiQGAcicI-QEufQz6cQPDJAEVV_AppwdAPhX4kdVASiOQRYBcxAM5lvEAeCVJxJpMIEd6zpniLJWgD5sJ-rRxsZi-eRjPC0TUcUeZtEJZ1ATR50NZ3RrWMhepkdOIXSfx3R7mHkJ5kSZMTkVAdoBJoMTkdQSiAl80kxiF15-AEMLkXF_iZ0JMeQExl5gpuANdKpmval6-ApzAH0kJY51xml_lz6NYRWYVnlyZlwApoJg7D52iaQRo7xmpSYeIU5jQc5jwQ9FQBphqh4jVgp2jCMRiU0YpqgSVn0fx9ljwHiCQC1n0dYH0aMOwK5NlrV15nF2APhTlko4Vj515fJu1rAH0sYcJJARI15LY718p_ln9NI0ZzUZPMFmVm-c0c0IAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/tree/development/examples/materials/properties/displacement/src",
        "description": "Example of the displacement material properties."
    },
    {
        "href": "examples/materials/properties/emissive/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlqKMcOQaEPIEnFY8BACeiu4gtFgExgBW_Kr8UTFxHgmJcBrk6YQE8nCIxsbk6Kg4OXCYUGoaOKi2xqjyRMYAjgCuEOQA1i4E4qgA5nAAAlD8tHDZ45MztvNLOERobXClIjysJkWxBOEmeAJCnGWMBujJ4TyM6Gpcm8mwdIAdwg6AIeEQXAAjAAGGEAUgA3FwHhAFoRIbCEYiPJ8IuRdAU4FxQekCagibiTOSiXiTD9VHTrnEuCk0h4iJR0GNYCEKlUPPzjGhMLgCKcQJdjMzbi9jG8Ppx7sQoMIQAAaEAQOAAITQ_A0ySQYH4UBcAF9NUKRdgcOKyCAqDQ6AQGM9UBAiPJKBoCFxgA4NAJaABZdaaCCmkN0MZcc1cMAaShELgeHDGGyoMaecRmjw4j1en1-gOUdQaGKYMO0GKmuMJpMptMZ8O1qA56ASgue72-_1laLBmAANQgMCBvYI6oHQfD0ngcAg1GnImrEdN0jsGAN6CU634nHjieTqZAyzgckUDM0xlUY6Bmnz7oAFIVkqhyFxnwBKLiuVj9iIjSBkOXD2He46TgO1CbFwEETsWf5gUC_ASCB4ajpBxbPsAZQ8DShSQowAAS3ghgAMgAwoShQAKKwJmtzoJQ5BjIxOALLY9EwIxOrJAAkugz4eARErfiuVigpCHLJJhCG-mcPDmt-BY8MBg7hmBfwLkuqDQagsEuHAi7UEh_AoWhGm0POxm6TheGsjstiIA5PAeAAzAArAAnN5nkAGzkOQnn8AA7GA_lQno7n-d5MLoD56BgAATO5ejJTA_npeFyWhVCyVQpgyX8J5nkwmVAAs6BQlCpVgBVegwDCoWhTAZUwvw7kwlV5DuaF7mBLVMCBKFCX-egyV6N5_AVRVtWDRV5BgN5MB9Z5k38DA00wFCoWeXoJX8GA7neXoIVQvwyUwsFgTuZNgTHRdS3LYE016DCMDPWAvUwmAgSCLFi2BAFehVTCyUVZtO0VRD5D-bFgToCtoPkIjejjYVJWQ1C_nAzAFX-FCt3vZ5UUrRVgQFeQehE3ot3_eDwXoKF_nuegHgSaInKdHJngaFA0kgDUdQNNKmBjOQUI4DAYz-OQLoaKahM4BeCgwNePRUEQHMOVJp5EMkNkmXpIBlMpBZlOps60FpfRAlwRCtpGUBcOg-76bBjs1s7SF21wa5tpuuhuxou77j-FtAcYXBlpolYwKyDwO07pqnCIscVqCMAB87z5Gcb6qngACjEjuGhzxelwayQ56aFde-uUAqWUGfx7XUB5zpy6nvOToh8kFceL31D9-39cp03kdqdHVkJ-CCcN22DsxmU5moX6s_t9GWbPovzvN6gykR5wGparq-qGsaqcwJaIBCnvpodmadoIMgjrULQ9CIFqRZ9rh5xcH4t4IMMAAByXIYCcx4O3IO25Q57jsFArgABxGAyZbCGgQfwJB8FJxwCQfxI2ukACC8gIBmwbCeDw55LzqzUDeeCj4QCqVTEBAAVGwvCbCuAACUYDyDWPLMCUAXYsVYkGD88AY5gETgvCeXAQTglkX8RQ5AICQHVlwVA_AbBcJJNweeDgxgVhdFoiBYEMAkgIAAcmJI4aA6AJEKIkHgZRD8XbyCTHeTA7NzicL8VwZY8gDQ6LMZgPRQSQkpncaAnRMAInBMVtEieXDjAez9EGAR_B5btyQsJABqAIGQiASA8BmAkExLiZCTYMRFgVInpCGBW4Q5hzsGUX8_5AJWDAD6L8sA_QQCQjCZEgzGBhJgDgN2dgcCwEWOCEZABqBZv5_6JFCNHdxdjdBcEalwGALjNCuwgEGcgkhkj6OUVM-wlAZH2EKeEgBPB1FfnuRMq5ABtCAABdfRmxdDyxuf7CesCWlYJWa5UQTpYLiIkQQXJrheBNODjuLBrBXmTP3J8r5LC1nPOfDCl07dehxL_K4BFlSbC_nRR875SF3E4tEOaMoELgK9PJDshOhRFwLD6OgVklAtKcXQQQcujySQyOfNSzFtK0B_MkYC1BwrMH7nBWK_CME_RCpsCK85CLGCKu1cquwaKIEYrsFihlkkJUQqsFqjB5yABkDqbWiDtTqw48inUup4G6w0HrvammJTYUl5KJ6xN0Wqrg35vVcF9ckf1jc6UT0tXGByTKRAOR6VoZ8_SSRDJGbwcZOB7FQEcXQGZdAFjzJJEs6NYrMmCOzhPSVpqS1ltQFiwuFLIHJwDZPM2LDLYcL0QAeXLPHNx8jFGuMMXAVR6ixx8u7RcwxlAxi1HXXo6dyi52fQXZotdG6CDhoTtuwx7iuCeLLFndAOA9HEIcKaKAB1pjOJERyrgQYFjahrJoggArW5Z0TusXtiaYDlnOeICNohuGrvXfIddJJiRjHkFM9Wd6_EJKidpWy1AsNJJjvB9dJ78OhO7aR5JfbUllGwJOBwGqY7jqzvCr8Dl866WKUQ6gpCIBIMPQh49VS_girQAsepfaT3VJE3Uhy7jGnAuaSi92IgOkAVWaIYCvgRTKP44h4On6xjcHsGAccDgHjTDTlYKFfpdPij4iepC7HqAcVsCOojBB7NxOfLZk9B8rVfls7qZIJ6K1zNcQBKEqq1lQsoLAGZlAFjCRAN4B4QYwJpaIDycQAiE6BecUo8EIHtE2DvSAPziQgwEGMagBl8YYBmgTniwLnmSuzKra4slCKYRRcSDFuLUAEtJfAYRo9-WZ1yD9MV09hQExrowKV8rVhKvVdqw5azl6q6Gjc6NhFTnWicQINtgTLWYDefc7595MIvkAEJB0AKtqBewBIREvqmMBv0KG0PEnPSk-70cz1J13WojRfKptjcnX2jb16fFrYY598M1EXvZLewiyV44ykwAAPzFOATAMBEDC6xfQBj7HgDcf48wKprpFX-GNvbmjoEGPrtdrDXElnfbFuiDtkznA8PaDDk0MbY-YrcHFjgO8mSckoIgC-bz1D4ZhdWHNAy4CXK0QGKTs959yP-U6fcw5Txnpq5HfXXLtDiPtevoRXzmAFvXsq5nk-5RWvXskiIDYH44YoDnKzc74xsLxkORt3b5Hz5Ddl2SCbggvQIHXfK8rsop9tR6m0ZfRAJoGu33vjGJ-cAX4OidJ_V038eyIXU-3Wiiw0CQLKEiuBrTsG14UFgzmovfT4LKFEOgMByecwNfarBh5KFNjPKrK89CNC3nvEwyO633GV-_X0eTfaF_V6QhXqvfQcCyq3PLSOxhh3cG4ZRa2c8k6ZljL7n7fbC5q55ZcmAJostwVNGMeACR_FcG4ZEgj7iP9pL6CwDo3W03gnm3ljARTfA_C_DkyBT7RBSUzsCp3Uwe00m2Rt0fSR1fSv3P1-3VQMg-3l1DHkVR2QIcmAhwO1D2SwB0Ry0LgfC4AwKd19THGJDQB3Xlj6HIOjjQiBDXVLQ_U5DS0f0gDUVMX_RjlQG90YKILPwThYKkUKw-xcDcS5H3SXTwNEC7z6HJxwCTEoGjxFXyEF2UHDmfCuTILFTxSuV-V3zQRkX7x1TBVdn3DNwwkFzsk53NlkwnjcP5w8OoEVy0M4J7xAT0MoAML8JHACNQCCJ4Db3FAlxAANil2LA8FlxtyCITz0ijm0j9EwCfygD9AKCgDf0s1AzbGLVi16QRQ8AAGJ4Z_InwRB3FpYjhbJ1A-hjIkJ6iwA-j-jmieBWieJtRFx1Awx5A_wHJXwLI_R59N8JkBtBAJj8k1kPBhZ6hGhGEegx86FywqjhhVB3JhRHZOI4BjBpAlAAB9KgAbHoeQRYRSUQb8X8AAH1eMYIwEf2r3QBYRt3pwPkthnlPzyP2GJE8H4nSQqOdiLl0HqzyUYF0A-BBAwEoCBG_BwAAEUJhph5w5hRM89Z5nwYRC4STTwx4ysWF1szBYAdQDRiJ9l0Q_RUcSIyJyIVBVBuJGJWBVjRBmJWJ2IDsuSXQgtKI1hjIT0ksRg4AriaSYAriDoNAPBvxLsvl2kMTyAugXQGS0RCAWFnxWSKIOThSaAeSHJ-S2IXQXMCATS7NkgxSuVJSPBpSbiP4XRlTVT1SVYUg4tHYsAdSmSkIUTmIgRt9UA-gNAAzCAuB_BHJzA6TIzGToyFlTx5AsBmiyh3FYS-goAcBBB0BvBsACAksRiOju9jJB4QA6j-iBiNQvwSi38pNakFhLCrBhj2ixjyziQEUGyYAGV_jm149ASRBc0lifhFg-YBZhNmyWFgIL00ABNMyJ5sz6s8z0ACyizeS3IQBSzOyJidYAF1i5gRYtjp8djaENYDjbxjijcziLjrjbifQcAHiFgDyrAoDPxnxeymzRNWzEhc1dz6EJj5N5AsEuAPjDMCifiU0dVqc1kxzRNJykJeyU0eBALxiFA8k140J5jF9FjKBliFAvzX8YAXjwKIKvjIBeUU14wCQCBHAvxSK4LesYJYt8LEsPBiFuA45ekxF_dNEgQ8BoAE4ELFhlF0Km15AXI6zSKaKEx9QRFzl1M1lgIUsE5HBPo3sAcRKCLxyFhPAeFyIkMtE8cfFdc6A4BjF4lI1gIlCFFOU0tskqsn1zkFABFkhRNlFxTiiSL3sFEZsXAaAXVgJ-IN5-C-Vdk7LBLhKuBRKxNlExgXAtAXRNBNFdADDUtGD-Zgro5-IZE7LLxFADJ6CE5mJUBrE_QUIaBdc3LpCftJioqZsxzNE0BGoCAHw6AXU8U4qkLOsX9SimLlK1loTA0JKJikIxqFBULRABy-04jEh001lFrGV2kCxsik9z5U8jR09r5b5glph-BOIThqAC83Sv4QBcIQBMAirMAPxWCPBkBqFdiNYp9xwmFpL3IcACovqPBLQORUITZpKbRcAWAoAdY75ogbgJRHq747AFIkAPBEl5YXZgb8AVQYz_BKAirwa9AJhS0HrEaDRkadk8a-VUbQbfrpwrrwMlB-E6BbqxDobLqkb6t_BcaMBYAlSEaQAAA9KWfKHATycGtkeASGkobmnmzyHACqQW3680DalPauK-TPK0YOAwXAJ0SABYY61AU650c6y6tAKiiQGAciCI-QEuAwz6cQPDJAEVN_KmpwdAPhMckdVASiOQRYeJO2jQB2jweCAmkAPQJMIEJK4WniLJWgQOlmsGkAeWzUZPC-bajPC0TUcUTWtEHWvWovBgS6rWMhTmkdOIXSJmjkLkHkb26SrWTkVAdocGoMTkdQSiZMRiaGlOmvHcuAEMcu2AfiZ0JMeQB6-2juuANdSoSSh69uqmzATUkJG2wGqejwGetYRWee_c5WlwKmuGg7QO2iaQJojUQUETU5Ie32juw9FQLm6Sn4TYcG2jCMRiU0WmqgVen0aG4eqmkYggZ-n0dYH0aMOwK5U-v25InumAPhUe0o-ewO15SmjwbATUsYcJJAJI15K47mCuiUaen9dI-Os-RWtPdu80YhoAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/tree/development/examples/materials/properties/emissive/src",
        "description": "Example of the emissive material properties."
    },
    {
        "href": "examples/materials/properties/metalness_roughness/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlqKMcOQaEPIEnFY8BACeiu4gtFgExgBW_Kr8UTFxHgmJcBrk6YQE8nCIxsbk6Kg4OXCYUGoaOKi2xqjyRMYAjgCuEOQA1i4E4qgA5nAAAlD8tHDZ45MztvNLOERobXClIjysJkWxBOEmeAJCnGWMBujJ4TyM6Gpcm8mwdIAdwg6AIeEQXAAjAAGGEAUgA3FwHhAFoRIbCEYiPJ8IuRdAU4FxQekCagibiTOSiXiTD9VHTrnEuCk0h4iJR0GNYCEKlUPPzjGhMLgCKcQJdjMzbi9jG8Ppx7sQoMIQAAaEAQOAAITQ_A0ySQYH4UBcAF9NUKRdgcOKyCAqDQ6AQGM9UBAiPJKBoCFxgA4NAJaABZdaaCCmkN0MZcc1cMAaShELgeHDGGyoMaecRmjw4j1en1-gOUdQaGKYMO0GKmuMJpMptMZ8O1qA56ASgue72-_1laLBmAANQgMCBvYI6oHQfD0ngcAg1GnImrEdN0jsGAN6CU634nHjieTqZAyzgckUDM0xlUY6Bmnz7oAFIVkqhyFxnwBKLiuVj9iIjSBkOXD2He46TgO1CbFwEETsWf5gUC_ASCB4ajpBxbPsAZQ8DShSQowAAS3ghgAMgAwoShQAKKwJmtzoJQ5BjIxOALLY9EwIxOrJAAkugz4eARErfiuVigpCHLJJhCG-mcPDmt-BY8MBg7hmBfwLkuqDQagsEuHAi7UEh_AoWhGm0POxm6TheGsjstiIA5PAeAAzAArAAnN5nkAGzkOQnn8AA7GA_lQno7n-d5MLoD56BgAATO5ejJTA_npeFyWhVCyVQpgyX8J5nkwmVAAs6BQlCpVgBVegwDCoWhTAZUwvw7kwlV5DuaF7mBLVMCBKFCX-egyV6N5_AVRVtWDRV5BgN5MB9Z5k38DA00wFCoWeXoJX8GA7neXoIVQvwyUwsFgTuZNgTHRdS3LYE016DCMDPWAvUwmAgSCLFi2BAFehVTCyUVZtO0VRD5D-bFgToCtoPkIjejjYVJWQ1C_nAzAFX-FCt3vZ5UUrRVgQFeQehE3ot3_eDwXoKF_nuegHgSaInKdHJngaFA0kgDUdQNNKmBjOQUI4DAYz-OQLoaKahM4BeCgwNePRUEQHMOVJp5EMkNkmXpIBlMpBZlOps60FpfRAlwRCtpGUBcOg-76bBjs1s7SF21wa5tpuuhuxou77j-FtAcYXBlpolYwKyDwO07pqnCIscVqCMAB87z5Gcb6qngACjEjuGhzxelwayQ56aFde-uUAqWUGfx7XUB5zpy6nvOToh8kFceL31D9-39cp03kdqdHVkJ-CCcN22DsxmU5moX6s_t9GWbPovzvN6gykR5wGparq-qGsaqcwJaIBCnvpodmadoIMgjrULQ9CIFqRZ9rh5xcH4t4IMMAAByXIYCcx4O3IO25Q57jsFArgABxGAyZbCGgQfwJB8FJxwCQfxI2ukACC8gIBmwbCeDw55LzqzUDeeCj4QCqVTEBAAVGwvCbCuAACUYDyDWPLMCUAXYsVYkGD88AY5gETgvCeXAQTglkX8RQ5AICQHVlwVA_AbBcJJNweeDgxgVhdFoiBYEMAkgIAAcmJI4aA6AJEKIkHgZRD8XbyCTHeTA7NzicL8VwZY8gDQ6LMZgPRQSQkpncaAnRMAInBMVtEieXDjAez9EGAR_B5btyQsJABqAIGQiASA8BmAkExLiZCTYMRFgVInpCGBW4Q5hzsGUX8_5AJWDAD6L8sA_QQCQjCZEgzGBhJgDgN2dgcCwEWOCEZABqBZv5_6JFCNHdxdjdBcEalwGALjNCuwgEGcgkhkj6OUVM-wlAZH2EKeEgBPB1FfnuRMq5ABtCAABdfRmxdDyxuf7CesCWlYJWa5UQTpYLiIkQQXJrheBNODjuLBrBXmTP3J8r5LC1nPOfDCl07dehxL_K4BFlSbC_nRR875SF3E4tEOaMoELgK9PJDshOhRFwLD6OgVklAtKcXQQQcujySQyOfNSzFtK0B_MkYC1BwrMH7nBWK_CME_RCpsCK85CLGCKu1cquwaKIEYrsFihlkkJUQqsFqjB5yABkDqbWiDtTqw48inUup4G6w0HrvammJTYUl5KJ6xN0Wqrg35vVcF9ckf1jc6UT0tXGByTKRAOR6VoZ8_SSRDJGbwcZOB7FQEcXQGZdAFjzJJEs6NYrMmCOzhPSVpqS1ltQFiwuFLIHJwDZPM2LDLYcL0QAeXLPHNx8jFGuMMXAVR6ixx8u7RcwxlAxi1HXXo6dyi52fQXZotdG6CDhoTtuwx7iuCeLLFndAOA9HEIcKaKAB1pjOJERyrgQYFjahrJoggArW5Z0TusXtiaYDlnOeICNohuGrvXfIddJJiRjHkFM9Wd6_EJKidpWy1AsNJJjvB9dJ78OhO7aR5JfbUllGwJOBwGqY7jqzvCr8Dl866WKUQ6gpCIBIMPQh49VS_girQAsepfaT3VJE3Uhy7jGnAuaSi92IgOkAVWaIYCvgRTKP44h4On6xjcHsGAccDgHjTDTlYKFfpdPij4iepC7HqAcVsCOojBB7NxOfLZk9B8rVfls7qZIJ6K1zNcQBKEqq1lQsoLAGZlAFjCRAN4B4QYwJpaIDycQAiE6BecUo8EIHtE2DvSAPziQgwEGMagBl8YYBmgTniwLnmSuzKra4slCKYRRcSDFuLUAEtJfAYRo9-WZ1yD9MV09hQExrowKV8rVhKvVdqw5azl6q6Gjc6NhFTnWicQINtgTLWYDefc7595MIvkAEJB0AKtqBewBIREvqmMBv0KG0PEnPSk-70cz1J13WojRfKptjcnX2jb16fFrYY598M1EXvZLewiyV44ykwAAPzFOATAMBEDC6xfQBj7HgDcf48wKprpFX-GNvbmjoEGPrtdrDXElnfbFuiDtkznA8PaDDk0MbY-YrcHFjgO8mSckoIgC-bz1D4ZhdWHNAy4CXK0QGKTs959yP-U6fcw5Txnpq5HfXXLtDiPtevoRXzmAFvXsq5nk-5RWvXskiIDYH44YoDnKzc74xsLxkORt3b5Hz5Ddl2SCbggvQIHXfK8rsop9tR6m0ZfRAJoGu33vjGJ-cAX4OidJ_V038eyIXU-3Wiiw0CQLKEiuBrTsG14UFgzmovfT4LKFEOgMByecwNfarBh5KFNjPKrK89CNC3nvEwyO633GV-_X0eTfaF_V6QhXqvfQcCyq3PLSOxhh3cG4ZRa2c8k6ZljL7n7fbC5q55ZcmAJostwVNGMeACR_FcG4ZEgj7iP9pL6CwDo3W03gnm3ljARTfA_C_DkyBT7RBSUzsCp3Uwe00m2Rt0fSR1fSv3P1-3VQMg-3l1DHkVR2QIcmAhwO1D2SwB0Ry0LgfC4AwKd19THGJDQB3Xlj6HIOjjQiBDXVLQ_U5DS0f0gDUVMX_RjlQG90YKILPwThYKkUKw-xcDcS5H3SXTwNEC7z6HJxwCTEoGjxFXyEF2UHDmfCuTILFTxSuV-V3zQRkX7x1TBVdn3DNwwkFzsk53NlkwnjcP5w8OoEVy0M4J7xAT0MoAML8JHACNQCCJ4Db3FAlxAANil2LA8FlxtyCITz0ijm0j9EwCfygD9AKCgDf0s1AzbGLVi16QRQ8AAGJ4Z_InwRB3FDhbBTQ-hjIkIoQWFWikwxh0ROjiQEUpZhkyhWjtUOiFwwx5A_wHJXwLI_R59N8JkBtBAZj8k1kPBhZ6hGhGEegx86FywqjhhVB3JhRHZOI4BjBpAlAAB9BYRWZIKIU0CZeQRYRSUQb8X8AAHx-MYIwEf2r3QCngqOdnCIGLwCGJmLmIAQWPXjBNNFXy3zWPQA2IhW2LmBFj2OnwONoQ1hONvHOKNyuJuPuMeP4GeOexgDuLQHLBcBwHeIWE-J4G-K4D-IBIKOBJYRt3pwPkthnlPzyP2GJE8H4nSURKgCLl0HqzyUYF0A-BBAwEoCBG_BwAAEUJhph5w5hRM89Z5nwYRC4jTTwx4ysWF1szBYAdQDRiJ9l0Q_RUcSIyJyIVBVBuJGJWBNjRBmJWJ2IDsPSXQgtKI1hjIT0ksRg4A7irSaSDoNAPBvxLsvl2k1TyAugXQ7S0RCAWFnxnSKI3TAyaAvSHJfS2IXQXMCBCy7NkgQyuVwyPBIy7jC8XQEykyUyVYUg4tHYsBMyHSkIlTmIgRt9UA-gNBezCAuB_BHJzAbSxz7SJyFlTx5AsBmjxiJ5pS-goAcBBBic2JGoNAktJioAhiK4TSoRC5zyuAYQcAYRLznwSi39IQswiB9zLCrAJj2jjyFwkIHyYAGVeTm149-SWj1yZStydzQE9zNAkt-jBiFxTyLzEKryby7zfynyoKNA3yuZfDYKoTvyEVfz_zZC-SWFvCcieBc1UTRM-YoAQwpNakFgWFgIL00ABM1y-0Nz6ttz0B0BvBsACBvS3JkjPzoSFAdYAFMTahdip9xxNAVZ8SJ9CSziLj-BSTbiHiniXi4smTxKrAoDPx7zX8YB6LRMsKrBc0jzRL5B5N5AsF2TOSgTeUU0dVqc1kqLFgaKQwfyjKU0eBLLpiFA8k140JljF9VjKB1iFBDLSiYA2SOTDMuSnKIV4wCQCBHAvxYrXLesYJYtwrEsPBiFuA45ekxF_dNEgQ8BoAE53KFg3ERKArrKK5YqU0jx9QRFzl1M1lgIUsE5HBPo3sAdqqIqfgPKeFyIkMtE8cfFdc6A4BjF4lI1gIlCFFOU0tskqsn1zkFABFkhRNlFQziijL3sFEZsXAaAXVgJ-IN5-C-VdllqKqqquAarC5DExgXAtAXRNBNFdADDUtGD-YLro5-IZFlrLxFADJ6CE5mJUBrE_QUIaBddtrpCftZj7qZtUTNE0BGoCAHw6AXU8UarPKQ0X8Yqes1k_LfD_LjIYTyV6rqaFBfLRAAK-04jEh001l2bGV2lQTKLhrqL-YeETLFgmKNl5FWLN0QKOKwLuLeL-LBLTxcKrLdLRBJLsSZKHw8S1YCStYiSVK1LyTNLqTaSKQTDGSPiNQHJ9Kvw0LhMGKzLRBc1FaGqbK7L_iErHL1ZnLDQsrzK-aPKBbvKYrGanb6bZjUdgqliJ5kTwrIr5Boq384q3bATIAkqxUUr1h0rnxMrOrsqDJcr4t8qQBCq9kKwSqgoyq-UHrYAnq_barDEQ64AZiXINQ9lOclIEw2rpCc6rBurNdzMBqXF9ra7PAxqJq-h1Y_0BVZr5rAbjqGCDROVTkxhNqwJ5Adq9rDEDqSa3857TqWzFqgbrqeRbqz8QMq6hrBBRMXqk43rDlPqgw-Ufr54tBjEoBZ7gbjqwbZrIbXZqBYaTqEaJCkbINcDUaJsTriQMa-UsbbBcbyLyaCbh6A7Ott7s6Y0-i104LQ6kIG6ZjGaeBmbG5Waldkq01ubDwCwk9z5U8jR09r5b5glphVKJl2hqAC8P4XQGBcIQBMBwbMAPxWCPBkBqFDiNZ1amFm73IcACppGPBLQORUITZm6bRcAWA36La75ogbgJRhG747AFIkAPBEl5YXYVH8AVRJz_BKBwadYQA9AJhS0hGjGDQTGdkHHoHATVGVQ5HpweHwMlB-E6B-GxCdHuHjH6t_B7GMBYB4zDGQAAA9KWfKHATyWxtkeALRkoOJ-JzyHACqFJuR80KhlPauK-TPK0YOAwXAJ0SABYE4Nht-Zsr-EAbhtAFOiQGAciCI-QEuAwz6cQPDJAEVN_XxpwdAPhVEkdVASiOQRYeJIZjQEZjweCJxuxpMIEd6tJniLJWgVZ8J9RopzUZPC-WhjPC0TUcUGptEep1Adh50Zp7hrWMhGJkdOIXSUJjkLkHkeZ5urWTkVAdoWxoMTkdQSiZMRiHRs5mvEAeAEML52AfiZ0JMeQIR4Z6FuANdSoJtFFsplwXxzANMkJAZpRqF_Fz6NYRWYlmYoR0ljwfRg7VZ2iaQJojRmpSYeIBZpZkAQ9FQWJ5un4TYWx2jCMRiU0AJqgSln0HRtF3xniCQcVn0dYH0aMOwK5VFxZ6F7mb5vhDF0o4l1Z15HxjwbANMsYcJJAJI15O4rV2ACUfFn9dIw5s-EptPKF80d1oAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/tree/development/examples/materials/properties/metalness_roughness/src",
        "description": "Example of the metalness / roughness material properties."
    },
    {
        "href": "examples/materials/properties/sheen/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlqKMcOQaEPIEnFY8BACeiu4gtFgExgBW_Kr8UTFxHgmJcBrk6YQE8nCIxsbk6Kg4OXCYUGoaOKi2xqjyRMYAjgCuEOQA1i4E4qgA5nAAAlD8tHDZ45MztvNLOERobXClIjysJkWxBOEmeAJCnGWMBujJ4TyM6Gpcm8mwdIAdwg6AIeEQXAAjAAGGEAUgA3FwHhAFoRIbCEYiPJ8IuRdAU4FxQekCagibiTOSiXiTD9VHTrnEuCk0h4iJR0GNYCEKlUPPzjGhMLgCKcQJdjMzbi9jG8Ppx7sQoMIQAAaEAQOAAITQ_A0ySQYH4UBcAF9NUKRdgcOKyCAqDQ6AQGM9UBAiPJKBoCFxgA4NAJaABZdaaCCmkN0MZcc1cMAaShELgeHDGGyoMaecRmjw4j1en1-gOUdQaGKYMO0GKmuMJpMptMZ8O1qA56ASgue72-_1laLBmAANQgMCBvYI6oHQfD0ngcAg1GnImrEdN0jsGAN6CU634nHjieTqZAyzgckUDM0xlUY6Bmnz7oAFIVkqhyFxnwBKLiuVj9iIjSBkOXD2He46TgO1CbFwEETsWf5gUC_ASCB4ajpBxbPsAZQ8DShSQowAAS3ghgAMgAwoShQAKKwJmtzoJQ5BjIxOALLY9EwIxOrJAAkugz4eARErfiuVigpCHLJJhCG-mcPDmt-BY8MBg7hmBfwLkuqDQagsEuHAi7UEh_AoWhGm0POxm6TheGsjstiIA5PAeAAzAArAAnN5nkAGzkOQnn8AA7GA_lQno7n-d5MLoD56BgAATO5ejJTA_npeFyWhVCyVQpgyX8J5nkwmVAAs6BQlCpVgBVegwDCoWhTAZUwvw7kwlV5DuaF7mBLVMCBKFCX-egyV6N5_AVRVtWDRV5BgN5MB9Z5k38DA00wFCoWeXoJX8GA7neXoIVQvwyUwsFgTuZNgTHRdS3LYE016DCMDPWAvUwmAgSCLFi2BAFehVTCyUVZtO0VRD5D-bFgToCtoPkIjejjYVJWQ1C_nAzAFX-FCt3vZ5UUrRVgQFeQehE3ot3_eDwXoKF_nuegHgSaInKdHJngaFA0kgDUdQNNKmBjOQUI4DAYz-OQLoaKahM4BeCgwNePRUEQHMOVJp5EMkNkmXpIBlMpBZlOps60FpfRAlwRCtpGUBcOg-76bBjs1s7SF21wa5tpuuhuxou77j-FtAcYXBlpolYwKyDwO07pqnCIscVqCMAB87z5Gcb6qngACjEjuGhzxelwayQ56aFde-uUAqWUGfx7XUB5zpy6nvOToh8kFceL31D9-39cp03kdqdHVkJ-CCcN22DsxmU5moX6s_t9GWbPovzvN6gykR5wGparq-qGsaqcwJaIBCnvpodmadoIMgjrULQ9CIFqRZ9rh5xcH4t4IMMAAByXIYCcx4O3IO25Q57jsFArgABxGAyZbCGgQfwJB8FJxwCQfxI2ukACC8gIBmwbCeDw55LzqzUDeeCj4QCqVTEBAAVGwvCbCuAACUYDyDWPLMCUAXYsVYkGD88AY5gETgvCeXAQTglkX8RQ5AICQHVlwVA_AbBcJJNweeDgxgVhdFoiBYEMAkgIAAcmJI4aA6AJEKIkHgZRD8XbyCTHeTA7NzicL8VwZY8gDQ6LMZgPRQSQkpncaAnRMAInBMVtEieXDjAez9EGAR_B5btyQsJABqAIGQiASA8BmAkExLiZCTYMRFgVInpCGBW4Q5hzsGUX8_5AJWDAD6L8sA_QQCQjCZEgzGBhJgDgN2dgcCwEWOCEZABqBZv5_6JFCNHdxdjdBcEalwGALjNCuwgEGcgkhkj6OUVM-wlAZH2EKeEgBPB1FfnuRMq5ABtCAABdfRmxdDyxuf7CesCWlYJWa5UQTpYLiIkQQXJrheBNODjuLBrBXmTP3J8r5LC1nPOfDCl07dehxL_K4BFlSbC_nRR875SF3E4tEOaMoELgK9PJDshOhRFwLD6OgVklAtKcXQQQcujySQyOfNSzFtK0B_MkYC1BwrMH7nBWK_CME_RCpsCK85CLGCKu1cquwaKIEYrsFihlkkJUQqsFqjB5yABkDqbWiDtTqw48inUup4G6w0HrvammJTYUl5KJ6xN0Wqrg35vVcF9ckf1jc6UT0tXGByTKRAOR6VoZ8_SSRDJGbwcZOB7FQEcXQGZdAFjzJJEs6NYrMmCOzhPSVpqS1ltQFiwuFLIHJwDZPM2LDLYcL0QAeXLPHNx8jFGuMMXAVR6ixx8u7RcwxlAxi1HXXo6dyi52fQXZotdG6CDhoTtuwx7iuCeLLFndAOA9HEIcKaKAB1pjOJERyrgQYFjahrJoggArW5Z0TusXtiaYDlnOeICNohuGrvXfIddJJiRjHkFM9Wd6_EJKidpWy1AsNJJjvB9dJ78OhO7aR5JfbUllGwJOBwGqY7jqzvCr8Dl866WKUQ6gpCIBIMPQh49VS_girQAsepfaT3VJE3Uhy7jGnAuaSi92IgOkAVWaIYCvgRTKP44h4On6xjcHsGAccDgHjTDTlYKFfpdPij4iepC7HqAcVsCOojBB7NxOfLZk9B8rVfls7qZIJ6K1zNcQBKEqq1lQsoLAGZlAFjCRAN4B4QYwJpaIDycQAiE6BecUo8EIHtE2DvSAPziQgwEGMagBl8YYBmgTniwLnmSuzKra4slCKYRRcSDFuLUAEtJfAYRo9-WZ1yD9MV09hQExrowKV8rVhKvVdqw5azl6q6Gjc6NhFTnWicQINtgTLWYDefc7595MIvkAEJB0AKtqBewBIREvqmMBv0KG0PEnPSk-70cz1J13WojRfKptjcnX2jb16fFrYY598M1EXvZLewiyV44ykwAAPzFOATAMBEDC6xfQBj7HgDcf48wKprpFX-GNvbmjoEGPrtdrDXElnfbFuiDtkznA8PaDDk0MbY-YrcHFjgO8mSckoIgC-bz1D4ZhdWHNAy4CXK0QGKTs959yP-U6fcw5Txnpq5HfXXLtDiPtevoRXzmAFvXsq5nk-5RWvXskiIDYH44YoDnKzc74xsLxkORt3b5Hz5Ddl2SCbggvQIHXfK8rsop9tR6m0ZfRAJoGu33vjGJ-cAX4OidJ_V038eyIXU-3Wiiw0CQLKEiuBrTsG14UFgzmovfT4LKFEOgMByecwNfarBh5KFNjPKrK89CNC3nvEwyO633GV-_X0eTfaF_V6QhXqvfQcCyq3PLSOxhh3cG4ZRa2c8k6ZljL7n7fbC5q55ZcmAJostwVNGMeACR_FcG4ZEgj7iP9pL6CwDo3W03gnm3ljARTfA_C_DkyBT7RBSUzsCp3Uwe00m2Rt0fSR1fSv3P1-3VQMg-3l1DHkVR2QIcmAhwO1D2SwB0Ry0LgfC4AwKd19THGJDQB3Xlj6HIOjjQiBDXVLQ_U5DS0f0gDUVMX_RjlQG90YKILPwThYKkUKw-xcDcS5H3SXTwNEC7z6HJxwCTEoGjxFXyEF2UHDmfCuTILFTxSuV-V3zQRkX7x1TBVdn3DNwwkFzsk53NlkwnjcP5w8OoEVy0M4J7xAT0MoAML8JHACNQCCJ4Db3FAlxAANil2LA8FlxtyCITz0ijm0j9EwCfygD9AKCgDf0s1AzbGLVi16QRQ8AAGJ4Z_InwRB3EVYHg6AkIoQWFWiLw8dUBKJqitBaiQA6i4QwBxiwBmieAej2j-jBiwx5AkJDMCjq90BujfDei6AeE110Q-hjJOj1i-02i-jtixhdiFwFiliMBH9Vip4ZC0N6cD5LYZ5T88j9hiRPB-J0kKjnYi5dB6s8lGBdAPgQQMBKAgRvwcAABFCYaYecOYUTPPWeZ8GEQuVE08MeMrFhdbMwWAHUA0YifZdEP0VHEiMiciFQVQbiRiVgfJKwZiVidiA7akl0ILSiNYYyE9JLEYOAAAfVxJgF5IOg0A8G_Euy-XaUhPIC6BdEJLREIBYWfDJIokpJZJoFpIcgZLYhdBcwIDVLs2SHZK5S5I8B5N5MLxdFFPFMlJVhSDi0diwDlOJKQlBOYiBG31QD6A0CdMIC4H8EcnMHxO9KJN9IWVPHkCwGaLKHcT-L6CgBwEEGJzYkag0CS02JNjRMLihCzLRJwBhGzK_BKLf0hCzCIBTMsKsBmL6KQiLJgAZRt0eJYW8JyOmInljPqwTPQHQG8GwAIDTNmIGIGxFI1FPFGN-gmIrmfFrKk1qQWArK5g2IHMGJrNfzrKD1kMbLNieJEFzQG0EFEz5gFmE1nJYWAgvTQAE2jLbP-PjMTJ7KyH7L6MHJ9AWMHlNhHKgM_CnNXJnNE3nJ4FzXTOfI0AWPk3kCwS4AAB9GDrjIBeUGUdVqcrA9yfhFhDyVzSi1yxUgL5iFA8k140J59N8JkUKFjvzMLvxfxILoLlibj4K01H0CBHAvwYAesrMYJYsSLBsPBiFuA45ekxF_dNEgQ8BoAE4ULRMd0lyhzQKK5WLasEx9QRFzl1MrBgIUsE5HBPo3sAdxLKB9y0KeFyIkMtE8cfFdc6A4BjF4kxVgIlCFFOU0tskqsn1zkFABFkhJLDEOTijVz3sFEZsXAaAWVo5-IN5-C-Vdl7KRKxKuAJK6llExgXAtAXRNBNFdADDUtGD-YQrAEZF7LLxFADJ6CE5mJUBrE_QUIaBdd3LpCftFjoqZsULNE0BGoCAHw6AIU8V4qFh0LOsX8KKkLEgqy6BgLLjdtpKXyFAU0eAGzm1OclI00ty7iYybzOykyyzNBHytidi8A9iJRMzoQcyuAYQ8yCzyLiytFkzNB_yfjA10zTjzj9iEVaz6yNz5qmztyALbA4r9LULer-YQxfzFhTyNl5ELzN0Wjry4z1r7y-zBRZjHq9qLiFA3yK5PzCyfzjy_y_w1MHJALEbdr9rQKgVwL9woKYKVj6KAFELVLRAerDyQwMK38U0HqiaUbFjUcCK_QiLF8uLBAyLazKKoKaLYLbiGKCQmLXFnxWKhr8C4BOL4tEseK-KKwBKgohK-UYrYBfqDKFgpKTj2bjJZKRz5KGK4LXK5b1kuANKzNtLwdvK_qDyjKTK-h1Y_0BVLLrLcrorHLOVTkxhLbarPLFhlEfKBq39_KUJiQgr4hbLQrwqeRIqz8QNta9K9bC5DEkrDlUqgw-UMr54tBjEoBcr-J8qJsUR3LLKSrXZqAKqArqqJDg7J0GqK7o7dbzLWrbAOqWzEhuqna0LAaQ0I7Za6bKzFzDazjkbja8KJrJ6nq4AFiZr7jwxNyxV00ldlrDwCwk9z5U8jR09r5b5glph-BOIThqAC8P4XQGBcIQBMAirMAPxWCPBkBqEx86Fywp9xwmEXIQB3IcACpAGPBLQORUITY_6bRcAWAS6NRBRogbgJQ36747AFIkAPBEl5YXYoH8AVQ_T_BKAiqdYQA9AJhS1X6MGDQsGdkyG-UcGYGQHpx77wMlB-E6An6xCkG77MH6t_BSGMBYBhy_6AA9KWfKHATyYhtkeABBkodBkAYRzyHACqCRkB80XelPauK-TPK0YOAwXAJ0SABYC-1AK-50L-EAO-tAOCiQGAciCI-QEuAwz6cQPDJAEVN_JhpwdAPhFCkdfouQRYeJdxjQTxjweCChkhpMIEZKqRniLJWgSJnh2B9RzUZPC-A-jPC0TUcUQxtEExsxovW-kSZMMhQRkdOIXSLhjkLkHkYJv-rWTkVAdoYhoMTkdQAY93Vk1-rJmvEAeAEMWp2AfiZ0JMeQV-jxvphW4xHJVG7RlwJhzAaUkJVxiB3pxZz6NYRWVZ18-Zvp1Bg7SJ2iaQJouBlBmIU5CZ0Jvpw9FQIRjwH4TYYh2jCMRiU0VhqgbZn0JByZphniCQD5n0dYF82wQQd2EJsJ5IoZmAPhBW0o1ZyJ15RhjwbAaUsYcJJAJI15Xk7mOpg6h5n9dI1Js-TRtPXp80CloAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/tree/development/examples/materials/properties/sheen/src",
        "description": "Example of the sheen material properties."
    },
    {
        "href": "examples/materials/properties/specular/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlqKMcOQaEPIEnFY8BACeiu4gtFgExgBW_Kr8UTFxHgmJcBrk6YQE8nCIxsbk6Kg4OXCYUGoaOKi2xqjyRMYAjgCuEOQA1i4E4qgA5nAAAlD8tHDZ45MztvNLOERobXClIjysJkWxBOEmeAJCnGWMBujJ4TyM6Gpcm8mwdIAdwg6AIeEQXAAjAAGGEAUgA3FwHhAFoRIbCEYiPJ8IuRdAU4FxQekCagibiTOSiXiTD9VHTrnEuCk0h4iJR0GNYCEKlUPPzjGhMLgCKcQJdjMzbi9jG8Ppx7sQoMIQAAaEAQOAAITQ_A0ySQYH4UBcAF9NUKRdgcOKyCAqDQ6AQGM9UBAiPJKBoCFxgA4NAJaABZdaaCCmkN0MZcc1cMAaShELgeHDGGyoMaecRmjw4j1en1-gOUdQaGKYMO0GKmuMJpMptMZ8O1qA56ASgue72-_1laLBmAANQgMCBvYI6oHQfD0ngcAg1GnImrEdN0jsGAN6CU634nHjieTqZAyzgckUDM0xlUY6Bmnz7oAFIVkqhyFxnwBKLiuVj9iIjSBkOXD2He46TgO1CbFwEETsWf5gUC_ASCB4ajpBxbPsAZQ8DShSQowAAS3ghgAMgAwoShQAKKwJmtzoJQ5BjIxOALLY9EwIxOrJAAkugz4eARErfiuVigpCHLJJhCG-mcPDmt-BY8MBg7hmBfwLkuqDQagsEuHAi7UEh_AoWhGm0POxm6TheGsjstiIA5PAeAAzAArAAnN5nkAGzkOQnn8AA7GA_lQno7n-d5MLoD56BgAATO5ejJTA_npeFyWhVCyVQpgyX8J5nkwmVAAs6BQlCpVgBVegwDCoWhTAZUwvw7kwlV5DuaF7mBLVMCBKFCX-egyV6N5_AVRVtWDRV5BgN5MB9Z5k38DA00wFCoWeXoJX8GA7neXoIVQvwyUwsFgTuZNgTHRdS3LYE016DCMDPWAvUwmAgSCLFi2BAFehVTCyUVZtO0VRD5D-bFgToCtoPkIjejjYVJWQ1C_nAzAFX-FCt3vZ5UUrRVgQFeQehE3ot3_eDwXoKF_nuegHgSaInKdHJngaFA0kgDUdQNNKmBjOQUI4DAYz-OQLoaKahM4BeCgwNePRUEQHMOVJp5EMkNkmXpIBlMpBZlOps60FpfRAlwRCtpGUBcOg-76bBjs1s7SF21wa5tpuuhuxou77j-FtAcYXBlpolYwKyDwO07pqnCIscVqCMAB87z5Gcb6qngACjEjuGhzxelwayQ56aFde-uUAqWUGfx7XUB5zpy6nvOToh8kFceL31D9-39cp03kdqdHVkJ-CCcN22DsxmU5moX6s_t9GWbPovzvN6gykR5wGparq-qGsaqcwJaIBCnvpodmadoIMgjrULQ9CIFqRZ9rh5xcH4t4IMMAAByXIYCcx4O3IO25Q57jsFArgABxGAyZbCGgQfwJB8FJxwCQfxI2ukACC8gIBmwbCeDw55LzqzUDeeCj4QCqVTEBAAVGwvCbCuAACUYDyDWPLMCUAXYsVYkGD88AY5gETgvCeXAQTglkX8RQ5AICQHVlwVA_AbBcJJNweeDgxgVhdFoiBYEMAkgIAAcmJI4aA6AJEKIkHgZRD8XbyCTHeTA7NzicL8VwZY8gDQ6LMZgPRQSQkpncaAnRMAInBMVtEieXDjAez9EGAR_B5btyQsJABqAIGQiASA8BmAkExLiZCTYMRFgVInpCGBW4Q5hzsGUX8_5AJWDAD6L8sA_QQCQjCZEgzGBhJgDgN2dgcCwEWOCEZABqBZv5_6JFCNHdxdjdBcEalwGALjNCuwgEGcgkhkj6OUVM-wlAZH2EKeEgBPB1FfnuRMq5ABtCAABdfRmxdDyxuf7CesCWlYJWa5UQTpYLiIkQQXJrheBNODjuLBrBXmTP3J8r5LC1nPOfDCl07dehxL_K4BFlSbC_nRR875SF3E4tEOaMoELgK9PJDshOhRFwLD6OgVklAtKcXQQQcujySQyOfNSzFtK0B_MkYC1BwrMH7nBWK_CME_RCpsCK85CLGCKu1cquwaKIEYrsFihlkkJUQqsFqjB5yABkDqbWiDtTqw48inUup4G6w0HrvammJTYUl5KJ6xN0Wqrg35vVcF9ckf1jc6UT0tXGByTKRAOR6VoZ8_SSRDJGbwcZOB7FQEcXQGZdAFjzJJEs6NYrMmCOzhPSVpqS1ltQFiwuFLIHJwDZPM2LDLYcL0QAeXLPHNx8jFGuMMXAVR6ixx8u7RcwxlAxi1HXXo6dyi52fQXZotdG6CDhoTtuwx7iuCeLLFndAOA9HEIcKaKAB1pjOJERyrgQYFjahrJoggArW5Z0TusXtiaYDlnOeICNohuGrvXfIddJJiRjHkFM9Wd6_EJKidpWy1AsNJJjvB9dJ78OhO7aR5JfbUllGwJOBwGqY7jqzvCr8Dl866WKUQ6gpCIBIMPQh49VS_girQAsepfaT3VJE3Uhy7jGnAuaSi92IgOkAVWaIYCvgRTKP44h4On6xjcHsGAccDgHjTDTlYKFfpdPij4iepC7HqAcVsCOojBB7NxOfLZk9B8rVfls7qZIJ6K1zNcQBKEqq1lQsoLAGZlAFjCRAN4B4QYwJpaIDycQAiE6BecUo8EIHtE2DvSAPziQgwEGMagBl8YYBmgTniwLnmSuzKra4slCKYRRcSDFuLUAEtJfAYRo9-WZ1yD9MV09hQExrowKV8rVhKvVdqw5azl6q6Gjc6NhFTnWicQINtgTLWYDefc7595MIvkAEJB0AKtqBewBIREvqmMBv0KG0PEnPSk-70cz1J13WojRfKptjcnX2jb16fFrYY598M1EXvZLewiyV44ykwAAPzFOATAMBEDC6xfQBj7HgDcf48wKprpFX-GNvbmjoEGPrtdrDXElnfbFuiDtkznA8PaDDk0MbY-YrcHFjgO8mSckoIgC-bz1D4ZhdWHNAy4CXK0QGKTs959yP-U6fcw5Txnpq5HfXXLtDiPtevoRXzmAFvXsq5nk-5RWvXskiIDYH44YoDnKzc74xsLxkORt3b5Hz5Ddl2SCbggvQIHXfK8rsop9tR6m0ZfRAJoGu33vjGJ-cAX4OidJ_V038eyIXU-3Wiiw0CQLKEiuBrTsG14UFgzmovfT4LKFEOgMByecwNfarBh5KFNjPKrK89CNC3nvEwyO633GV-_X0eTfaF_V6QhXqvfQcCyq3PLSOxhh3cG4ZRa2c8k6ZljL7n7fbC5q55ZcmAJostwVNGMeACR_FcG4ZEgj7iP9pL6CwDo3W03gnm3ljARTfA_C_DkyBT7RBSUzsCp3Uwe00m2Rt0fSR1fSv3P1-3VQMg-3l1DHkVR2QIcmAhwO1D2SwB0Ry0LgfC4AwKd19THGJDQB3Xlj6HIOjjQiBDXVLQ_U5DS0f0gDUVMX_RjlQG90YKILPwThYKkUKw-xcDcS5H3SXTwNEC7z6HJxwCTEoGjxFXyEF2UHDmfCuTILFTxSuV-V3zQRkX7x1TBVdn3DNwwkFzsk53NlkwnjcP5w8OoEVy0M4J7xAT0MoAML8JHACNQCCJ4Db3FAlxAANil2LA8FlxtyCITz0ijm0j9EwCfygD9AKCgDf0s1AzbGLVi16QRQ8AAGJ4Z_InwRB3Fwixh0Q-hjJ80yhWjtVTROjiQusp4KjnYVZVEeQDRKJqitBaiQA6iwAwA4Q4RmieBWigcJiNApiBsNAwx5AkJDMCjq90AWE1jxi1gNB-JnQDIJBdVoQTjfD1jzjLjP5FwUhdj9iMBH8jjhibd6cD5LYZ5T88j9hiRPB-J0kRjTQi5dB6s8lGBdAPgQQMBKAgRvwcAABFCYaYecOYUTPPWeZ8GEQuIk08MeMrFhdbMwWAHUA0YifZdEP0VHEiMiciFQVQbiRiVgfJKwZiVidiA7Dkl0ILSiNYYyE9JLEYOAAAfSpJgClIOg0A8G_Euy-XaTRPIC6BdDpLREIBYWfGZIojZMFJoC5Icl5LYhdBcwIGNLs2SBFK5XFI8ElKlMLxdCVJVLVJVhSDi0diwG1IZKQiROYiBG31QD6A0H9MIC4H8EcnMBpIjPpKjIWVPHkCwGaJ6InmhL6CgBwEEHQG8GwAICS0eMmOmMHjmIWKWJhArmfBKLfyk1qQWEsKsFOM-g2K2JqJf1KJgAZV-ObXj3-JEFzQG0EFEz5gFmE0bJYWAgvTQAEwzL7SzPq1zPQHzMLOLLONLO2N2PLIrigM_FrNfxgAbNE2bNEFzRLM2OmN2Pk3kCwS4AAB9GDPjIBeUGUdVqcrARyfhFhxykI6yeyIVLyOydiFA8k140J59N8JlvzdjDzuzvxfwHynyDivi3y01H0CBHAvwYAesrMYJYsYLBsPBiFuA45ekxF_dNEgQ8BoAE5vzRMd1NyrztyFAXINQ9kvCEx9QRFzl1MrBgIUsE5HBPo3sAd6LKBRzfyeFyIkMtE8cfFdc6A4BjF4kxVgIlCFFOU0tskqsn1zkFABFkhGLDFRTiijz3sFEZsXAaAWVo5-IN5-C-VdlNKaK6KuAGK6llExgXAtAXRNBNFdADDUtGD-Y7LAEZFNLLxFADJ6CE5mJUBrE_QUIaBddDLpCfs9jXKZtvzNE0BGoCAHw6AIU8VPKFg_zOsuy388LEhWzWJziQL3jdtmLGqFAU0eA-y-04jGU00zZBzVjMyYScy8zQE2JGoNBuTRBBRmLnjlKbidYAEiSHJLjXybikEoQkEYQcAYQNqHJ4L6ytExrNAzyWyHiZqrjXjbiAKU1OrG5ur00eB-qPLbAPLJKfzyr-YQwTzFhpyNl5E5zN0WjBrsyVy1ysgNy2yniLqbidyOLSgOL9yvwALvqmy_w1MHILzzqXiYa2KgU7z9xHznzDj0KAEPz-Lzy3qxzPr_yjyU1LzZrri3iwLUcIK_QoLF8iLBA4KALELHyUKXzviMKCQsLXFnxcLPzIUCL-tiLI0SKyKKwKKgoqK-U3LYBXqpKFgmLIaDQGbLqbyFq1keA1K1kuLXz9KJbp4uAhKzNRLwdTLKbpLZKqC-h1Y_0BVlLVLwrXLtLOVTkxhzb0rjLFhlEzKqqz8QMUJiQbL4h1L7LHKeRnLw7kraK1ayrC5DEfLDl_Kgw-Ugr54tBjEoBwr-JIqJsURDLlK4rXZqAkqrLUqJDA7J0sqy7I71bFL8rbAiqcjcUJUyrxyQwQ0w6arTq-0xjtaLjoama9jmrx7dacb5B2qZC0M_iU0HqeqRBvDD4Cwk9z5U8jR09r5b5glph-BOIThqAC8P4XQGBcIQBMAYrMAPxWCPBkBqEx86Fywp9xwmF2L3IcACp_6PBLQORUITZ2KbRcAWAi6NRBRogbgJRX6747AFIkAPBEl5YXYIH8AVRoz_BKAYqdYQA9AJhS0X60GDQMGdkSG-UsGoGgHpw77wMlB-E6BH6xCEHb70H6t_BiGMBYBFTUGQAAA9KWfKHATyQhtkeAOBkoQRoRzyHACqcRoB80HelPauK-TPK0YOAwXAJ0SABYc-1AS-q44vEAW-tAVa2gciCI-QEuAwz6cQPDJAEVN_BhpwdAPhb8kdVASiOQRYeJFxjQNxjweCMhohpMIEXyyRniLJWgcJrh6B1RzUZPC-fejPC0TUcUfRtEIxkxovG-kSZMMhfhkdOIXSDhjkLkHkQJ9irWTkVAdoQhoMTkdQKY93IUl-jJmvEAeAEMap2AWapMeQF-1xnpuANdSoJtEZzRlwBhzADUkJJxsB7p-Zz6c49YXSWGg-hrBh5Bg7cJ2iaQJomBpBmIU5UZ4Jnpw9FQAR9in4TYQh2jCMRiU0ZhqgRWf9ZwS5kJ3po4Agd5n0dYH0aMOwK5H5np7mGpvhCZ0o5Z8J15ehjwbADUsYcJJAJI15KUqF2ACUeZn9dI5Js-dRtPbp80cloAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/tree/development/examples/materials/properties/specular/src",
        "description": "Example of the specular material properties."
    },
    {
        "href": "examples/materials/properties/transmission_volume_ior/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlqKMcOQaEPIEnFY8BACeiu4gtFgExgBW_Kr8UTFxHgmJcBrk6YQE8nCIxsbk6Kg4OXCYUGoaOKi2xqjyRMYAjgCuEOQA1i4E4qgA5nAAAlD8tHDZ45MztvNLOERobXClIjysJkWxBOEmeAJCnGWMBujJ4TyM6Gpcm8mwdIAdwg6AIeEQXAAjAAGGEAUgA3FwHhAFoRIbCEYiPJ8IuRdAU4FxQekCagibiTOSiXiTD9VHTrnEuCk0h4iJR0GNYCEKlUPPzjGhMLgCKcQJdjMzbi9jG8Ppx7sQoMIQAAaEAQOAAITQ_A0ySQYH4UBcAF9NUKRdgcOKyCAqDQ6AQGM9UBAiPJKBoCFxgA4NAJaABZdaaCCmkN0MZcc1cMAaShELgeHDGGyoMaecRmjw4j1en1-gOUdQaGKYMO0GKmuMJpMptMZ8O1qA56ASgue72-_1laLBmAANQgMCBvYI6oHQfD0ngcAg1GnImrEdN0jsGAN6CU634nHjieTqZAyzgckUDM0xlUY6Bmnz7oAFIVkqhyFxnwBKLiuVj9iIjSBkOXD2He46TgO1CbFwEETsWf5gUC_ASCB4ajpBxbPsAZQ8DShSQowAAS3ghgAMgAwoShQAKKwJmtzoJQ5BjIxOALLY9EwIxOrJAAkugz4eARErfiuVigpCHLJJhCG-mcPDmt-BY8MBg7hmBfwLkuqDQagsEuHAi7UEh_AoWhGm0POxm6TheGsjstiIA5PAeAAzAArAAnN5nkAGzkOQnn8AA7GA_lQno7n-d5MLoD56BgAATO5ejJTA_npeFyWhVCyVQpgyX8J5nkwmVAAs6BQlCpVgBVegwDCoWhTAZUwvw7kwlV5DuaF7mBLVMCBKFCX-egyV6N5_AVRVtWDRV5BgN5MB9Z5k38DA00wFCoWeXoJX8GA7neXoIVQvwyUwsFgTuZNgTHRdS3LYE016DCMDPWAvUwmAgSCLFi2BAFehVTCyUVZtO0VRD5D-bFgToCtoPkIjejjYVJWQ1C_nAzAFX-FCt3vZ5UUrRVgQFeQehE3ot3_eDwXoKF_nuegHgSaInKdHJngaFA0kgDUdQNNKmBjOQUI4DAYz-OQLoaKahM4BeCgwNePRUEQHMOVJp5EMkNkmXpIBlMpqlwfek7SxSEBJqgjFhvIACCur8NMCxJmMGBIQQGhjDABZlOps60FpfRAlwRCtpGUBcOg-76bB0c1rHSER1wa5tpuugJxou77j-QdAcYXBlpolYwKyDxRzHpqnCI5cVqCMBZ7Hz5Gcb6qngACjE0eGhzvf9wayRt6aQ8p-uUAqWUTeV-PUAdzpy6nvOTp58kQ8eOv1Cb4vk91zPxdqaXVlV-CVdT22UcxmU5moX65-L9GWbPtfsez6gylF5wGparqfUhpjT1xgJaEAQoP6mg7GaO0CBkCOmoLQegiAtRFj7Lhc4XB-LeCDDAAAclyGAnMeCLxztufOe47AkK4AAcRgMmWwhoqH8BofBSccAaH8SNrpZ28gIBmwbCeDw55LzqzUDeeCj4QAW2DgAKjkXhORXAABKMB5BrHlmBKAccWKsSDB-eAZcwDVyvkfLgIJwSmL-IocgEBIDqy4KgfgNglEkm4JfBwYwKwuicUQsCPsJAAHJiSOGgOgAxFiJB4GsVAuO8gkx3kwOzc4ijUlcGWPIA0Li_GYDcZk7JKY4n4JcTAfJWTFZFKPko4wSc_RBg0e7Vu5jXBfgcqgIhkIcF4MIZgGhxTSmQk2DERY_Sj6QjIVuPOBc7BlF_P-QCVgwA-i_LAP0EAkIwmRBsxguSYA4ATnYHAsBFjgm2QAanOb-TBiRQilziaE3QXBGpcBgNEzQ8c7afUkMkdx1jDn2EoCY-wHS8lYJ4PYr8oL9kAoANoQAALruM2LoeWQLM5H3IdMlh1zXKiCdLBfRBiCCLyQowSZucdwsNYNCg5-54UIotrcyFz4iUukXr0Upf5XCtIGTYX8tK4WIqQnEplohzRlDxcBFZ5JnlV0KIuBYfR0CskoFpTijC_Zb3BSSExz5BX0uFWgFFhj0X0M1cw_cuKdX4Rgn6DVNgtVkvNY6y1dgaVELpXYBlYrJJ6rxVYB1TDfkADIQ0BtEEGrVhxzFhojTwKNhoY2p1NJymw3LeVHxKa4m1XBvzxq4Im5Iybp4iqPr6uMDkJUiAcssrQz41kkk2ds3geycBhKgBEugxy6ALDOSSS5-adUNM0c0lNS9aUdq7agBl3c-XENruOr-SlZFAQUW4gA8uWSusTzGWJiZ4uAtj7FjhVfOv5njKBjFqNetx-7rFHs-iexxV6b0EGzVXe9ni4lcASWWFu6AcBuOdg4U0UADrTCiTouVXAgwLG1DWRxBA1XzxbtXdYi7S0wHLL88QObRDKMvde-Q16STEjGPIQ56sgOpPKYU7StlqB0cqWXYj16P3MZyfOzjVTx01LKNgScDg7Vl23S3UlrThJYM7rpLpPDqB8IgDQ19JH32DL-H7NACwxnjo_UMzToyHJxImZiqZVLE4iHmQBG5ohgK-BFNYlTpHc6we9lpMA44HAPGmA3KwBK_ROfFHxD9SEZPUA4rYDdbGCDBdKc-QLH7l2iBZYF3UyQP09tOTEgCUJrW3IJZQWAxzKALGEiAbwDwgxgSq0QHk4gNFV1S1Eqx4IMPOJsEBkASWrBBgIN41AYr4wwDNFXFL0W0sZZOX2mJPLWkwjy4kArRWoAlbK4Q1jb7msHrkH6drn7CgJivRgTr3XRC9f64Nhy_nf0j0NFFzbrSwutE4gQe7qnYs2Hi9FxLsKYQIoAISrqsCHUC9gCQ6Ig1MdDfoKNUeJN-6pWDgJfpro-uxDiVV7a27u8dN3_3JKuyJ2H4ZqIQ_dlDyTEdekwAAPxdNwTAAhRDu6FfQNTun2CGdM8wFZxZiQR1NMXvq8c1P_tzqzaU8XS6K1U6If9nAxPaDDk0MbX-Or2HFjgLCmSckoIgARQryj4Y1dWHNGK4CCq0QeJruD8D5PVWOeiw5BJnpR5vevYbqjpO7eQdaYrmA3vIfm7PmB6xtvIckiIDYH44YoC_LrWH7xxK9kOX94H8nz4XcD2SO7ggvQ5dJbN2Uf-2o9TOOAYgE0I3wGQJjDAuAcCHROmQa6VBPZEI2adiwzmFKKEzNYWURetFFhoGIWUDXvpOFlCiHQGAXPOYuuDSww8QimxnlVleCRGhbz3mkcXa7cTh_wb6CZ8dR_R9ISHyPvoOBjVbnlsXYw67uDKMoqHC-NdMyxgTwj8d3dLdKr_IwAmh1ZwSmgBy-ZpJcDKIFIsZxIJByK1J9BYBCbXbPxHyvyxitJvgfhfjGYYrjpYrmZ2C842Yg6aRPL-6gZk6QY_6f6I62oGQw5G6hgtJfikEOTAR0HaivJYAuINbdwPhcBUGh6JpjjEhoAPryx9CcGlxoRAhXqdowachVbAGQB2K-LIZlyoBx7CEsEf5VxiFGKtYw4uCxJcjPpnoMGiAz59Bc44BJiUB55-z5Aq7KCFzPgAocE6osoArIr34MImKL5ao4rxz7ie4YQq52SnbmxGZHwRFK5RHUAm42HSFz54IOGUBOEJEjhJGoApE8AT7ija4gAGy67FgeAG7-4pFF56QlzaR-iYAgFQB-gFBQAQFlBxLtqFYrKtIeAADE8M_kT4IgXR6wyCYw6wukKgJqWirSsIFsXRS4Wg8xOAnkix8R4IOwfQxkSECxnRmxisBkRwjG3A8xGx46mRYw6IOxxIc2Fx08hwtgpotxza7oPAXRWx0wtxTsf4Dkr4Fkfoh-1--yK2ggTsUmtyHgws9QjQUiPQG-4i5Y3Rwwqg7kwo0cnEcAxg0gSgAA-p7PwMkFEKaPsvIIsIpKIN-L-AAD40nCEYDAGj7oAWz-5C5fzBxnzv4NH7DEieD8R1KYZtg9y6DDZITPiMC6AfAggYCUBAjfg4AACKEw0w84cwWmDe58z4MI3cOpp4B8XWFs12ZgsAOoBoxEby6IfokmJEZE5EKgqg3EjErAkJogzErE7EL2TpLoaWlEawxkH6ZWIwcAeJJpMAeJB0GgHg34v2CKcyCp5AXQLoFpaIhAFsEppEFEDp3pNALpDk7pbELoEWBAOZQWyQfpCqgZHgwZeJzeLo0ZsZ8ZKsKQRW0cWAKZVpSEMpzEQIt-qAfQGgHZhAXA_gjk5gZpg5lpw55yp48gWAIxBxlx4xMYUx1AlEPRKxp4_RYAO5u5IxHxR8IpfQUAOAgg6A3g2ABAZWy5WYq5qA65K2UZGoW5u5e5z5z4bRAc-mIyCw3hVgYxcwK54ga5G5SEn5gcqe-h7JFssRdRB546R5w2p56AbObEjUGgrpbkIAN5kxwFqAMxAROsWCOpDk_EqAkAHoKQNCsINCMIOAMIUINCH54BMAkIWYRA6Ff5iQAFExd5BFqKVcrS4FFabJR8BRlalmJ8QpsciFJ5Z5-CaFmgZWyxQ8epFU3cUsnkup9FjFX44FbFilGgXF8FjxyxYFLFYqol46NRHJoxh5opclKFClHFSlDkHgXxUwtxRFVgJFWCZFFFEgyQ1FvlPlOlTF-lTihlxlXMmxeA2xC45l7REFOqVl084l1aPAtlPAjaYJPwiwfMUAuCugcAJxxs35WmFswEP6aAqmi508slyF55l5ZWLhxx2oxsTs28psz5OBn4zFSV5Viw0VjarVJV7VukTsJm8gLCXA9J3sTRzJYqTqNmVguVWmBVRVbVpxiVAcFao1pVE1Cg4pD8aEwJx-oJlA4JCg_VAc1Js1c1jJFF6sg2oGBAjgX4MAC2fmMEhWF1pWHgzs3AFcKyeiSejiQIcVsAXAa1iw1i-1411Ak1Q8n1L1FFYGvyK1tmpcFWVcjgn0UOKOVcMNCwngKi5EZGTijOySDudAcA3iZSOqwEJhFi8qVW7sfW6NYE8gGiyQWm1i_prRLF0OFiB2LgNAUqpc_ET8ihKqLyzNEN0ARNl1eV2m1iYwLgWgLomgjiugThlWwh_MEt2CJizNl4igBkghVczEqAQSfoKENADuCgPNu68gwtKExIuVjiaAjUBAD4dAeKLKxNG1RxY121s2YBSVX13FhxxVB1iNR1rS8NpxTsFaPAqVbY4lSkVaZsWV0lpoDV8lhlLVIdcdJsupGlFdXAdFDF3cN1rFkVLlRlf41mcRlxSdxsO1yVVg6d7cheudOVyt61_MFW8Vxkg1CwlV9y5iNVt6dlCFDljVF5WQmFp4HlPxCg3log0JcwIscJu-CJYiGsKJt46JruWJOJ-JhJxJ4OZJFJGoDkvVelLF490V2Vtg1co9cAk1GK01-4s1DJC1yqe1hofOtyQdw9cV3xCVQlFlEaa9C4vxkmJ1QJR85-N-uVEJ4Fd1dJADTJQDeK8YBIb1MSz4n1oDi2P1y2q2ANQNFYINQUYNKqCtUNxNcNkDnlCDCgLkz5KNBDCY-oOiGNEawEONXm-N2OniQdZNFNfQ6sSGaqtN9Nwjpc8trN8q5AHNgjXNPNfNkjhQgtSVbtot9ZuawEUtwmPIstH-GGzDStggWm3cni6tHyWtQYKqutl8Wg3iUAyjxtwtZttNlt8c1AttItDtWhTtuhCOrt8tB2ntKq3ttgftcFtyuqqyg9-VEDn9GaEdt15Dtynx7D69rtidRTnD8gqdogPdpomd4qBD2dklh4BYJegC5eRoleoC4CWS0w_AnEJw1ATeSCLoDAuEIAmA5tmAH44hHgyAIiiJGsO-440i3D7kOABUazHgloHIqEJs3DNouALAPj99EC0QNwEoszECdgCkSAHgFS8scc-z-AKoI5_glA5tOsIAegEwnaMztzBo9zzy3zCTjJBzKomz04Yz2GSg6idAkzGh5zozdzw2_gXzGAsAT53DAAelLPlGsR82yPAKcyUDcyAJi55DgBVHiyAOaOaC02XqPCAtXlaLnAYLgE6JAAsP06gIM86CgiAKM2gAFbQORFkfIH3E4d8rpDM37AHBC04OgGorlRuveXIIsGUkgDK2PiAPBL8580mECBrfizxI0rQLq0i0c7S5qKXkAu01XhaJqOKOy2iFyzyy3iMyJMmPwuixunELpAixyFyDyOq9w1rJyKgO0B80GJyOoOuVHj6TM3a1q_ACGIG7AGRTWG89K_7Fq3AFepUM0vIAm6AhC5gImdknhUWyNiW59GsIrHhZ1Yyy4BC1cy9rq7RNIMMcc8MpMPEBq9mxC6-ioBix4D8JsB84JhGIxKaNC1QHWz6Oc5qxCzxBIDOz6OsD6NGHYAClm7KwG9yLAGorm-0RWyS9CuCx4NgImWMHkkgCUdCnidzEGxKCWwhpUZawAvSxXomzS-aEAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/tree/development/examples/materials/properties/transmission_volume_ior/src",
        "description": "Example of the transmission / volume / ior material properties."
    },
    {
        "href": "examples/materials/unlit_material/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlqKMcOQaEPIEnFY8BACeiu4gtFgExgBW_Kr8UTFxHgmJcBrk6YQE8nCIxsbk6Kg4OXCYUGoaOKi2xqjyRMYAjgCuEOQA1i4E4qgA5nAAAlD8tHDZ45MztvNLOERobXClIjysJkWxBOEmeAJCnGWMBujJ4TyM6Gpcm8mwdIAdwg6AIeEQXAAjAAGGEAUgA3FwHhAFoRIbCEYiPJ8IuRdAU4FxQekCagibiTOSiXiTD9VHTrnEuCk0h4iJR0GNYCEKlUPPzjGhMLgCKcQJdjMzbi9jG8Ppx7sQoMIQAAaEAQOAAITQ_A0ySQYH4UBcAF9NUKRdgcOKyCAqDQ6AQGM9UBAiPJKBoCFxgGVogJaAA1CAwIHe33qwMaYMwaTwOAQagxkQAcRglBsBENSnW_DTPAAkt44zAAHJcmBFrgAWXWmggps8qC6BHzdk45q4YA02a4HmWcDkigZmmMqnDQM0HhxqE4AApCslUOQuIuAJRcVysf1lRoOOONrj2KcRqPxEROzZcc-Rn1-1ynoH8CRH-Nhi-PxcB84OQlCkhRgAAlvDrAAZABhQC4AAUVgGwaFYdBKHIMYkIIHAFlsBCYEwnVkmLdBFw8GlCg8Tdax4UFIQ5ZIvwfX0zh4c1N3nA9jA_E97BcOBk2oQNqFvPiBO4Z9-Ffd8g0bRN-JTVBfzKJIdlsRBlNEDxAgAVgANkCPQwBgMAABYYAAJihKFyG0gB2QIYShczAnQWy9F0pztJhGzzIAZgAThMwIYHQMByF82ybLAXTfJ08yYW0kywHQEyoVs_yYT0Cz0H87TyHMjz-F0_gwD0WynN02ztLABKzLM_z_JgXywHs3yTNsozAmswIwts3yoV89A9ECxLGpM8gYDs7T-C6_z0HIGETMEcyxvc4K7KS3STJM9BKpgIL8t8mAMt08h3N88zophKq3N0zB-BhfhzOc7bfJhSyVvQJ6TJhSbfPcnLbJM7T_BhHrzK-i6ipgSLyCM_gmuq4a4cegRLP8jxqK4TlOkYzwNCgOiQBqOoGmlTAxnIKEcBgMZ_AmmgNFNfxqZHBQQrUTQcCoIhMY02jBxAIhkjksSWK4NiOJEQ8ZNoU8uD6IFscbGJTS4L6u2vYS_SIFXmygHcFYjes9ZbNsJE7fglP_KgoB9ImAGIwBquEYT5_86FUBt5CJ1BqBgcXJfdHgbz9eQYl1w0AHkxlqWPDdEhTsNsGO44IQiK34GxSJAAAFCODWSSiAG0YQAXQAQilngZePOX7AJKAoD0fhplZOQ_TGeQNfgduYGV2hVYNoEHj6dQtHBfvKFj-R48cXQcNOLXUFvLue5gpuW7b59F0VqtMAAfkhUty33msuEoKB0DPo-uBPmBK2rbdd33f8IDADcK73p-uDjAgxg0KgecVhv6YDtEzceLhFyLnIM_Pcf5Ei9h9BuWAfoICGxhMidBjAHA4A1vwHAsBFjgiwQAalIduBBiCSQfxgXggsxcIBlxJCvOwa4swf0zNmWweYCyUI0oguh-DGHMMKFwLhOZeF2E3IcU2Btny60HvrYB1CeBCIYUw08xIJE8OSJbGRa9Gwhk0GJLcKjVHkBwIY0MJiFJmIEaIc0DinH_iDiIc0KjDyFGTAsbgk8AKb1blMVklA-4XxnrHMo4dPSF1TrPLC1iYAb2bkEw2iTklbymJ4rijcDb-NyZkkkRAbA_EbFAZISCJ4PAcAAuMNAFbVjKOk00KTpiLmiZHZIcTY69GrBXdi3ZNz2NQBqLUup9SGmNKaC0mp5BBP4DhE41AHROloPQRAIAAwgEwIoDAdByDhglMgIcbMxycw0JOacs4kAeF8jgSy9yPCWg5G-BcNytR7NwCwKAfMQAyiOVszYBp4jvLmZUGABsbRfJVFwfw_hKC7N-XoCYV8PDqRAGCiaBtkXQHQCw0U-AVRPJjNsmAqglAwF2ZgNchy0VbMxRC_wyKMCwA0GijwAA9amTkcDaV-WyeA0QbjspABy7SOATK8qeeaUZ2o9SoELlMs0MBLR_N0ENQw3NqCQAWEskZyBHTUDWa6DZWy0CQA9LQCClAEX50oLQcg4hBJIFzGMGsHgnDoAAEoQsoIIKOqAoJyEWAHF1Gg3UkvvCKvQ_YgQuDZRqDwtAvRrFoCKhlPyQAys1HKiZRpEAmmVaq8UTodV6pWUal0DAtk83kNATQUc4gKQBRyLkPJQ3op5pyVA7Rflxk5OoKC2ZMJHMLS4El8A6xttgMWZ0_Z5Botde6v509wXezRWO5dmByBrCZk6t5BbplbpgDug06wFLrqVeOpNBocIgvRXBaQulfmbBiI6xd4bl3Tw7BABN6KfibF-dgRQEcXSmgpVQPdPojlLonUcDsJ6fTrB9HWWwggCwfoja27ksAfVwEvrHBSIq_aYGJR4bAO6xikaQMXDwJGYAAH0cbtolCSgDIKy7ZrGfKxVh6i3mnNEAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/materials/unlit_material/src/index.ts",
        "description": "Example with an unlit material."
    },
    {
        "href": "examples/rectangle_transform/selection/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1Delw8lD8SWVgsFgN8pRwEhDUZfx6cJRQAK60DbBgBGWdXASU8ps1HqmijOS6qvxwXEV5p6jncIcmt_dHJumqr3DkGhDyBNtJRR5IiUdCLWAhOAach5KHkYxoTC4AgPECsExfH5_cImRIpTgmFhQYQgAA0IAgcAAQmh-BokkgwPwoC4AL7kuEIjDYHAosggKg0OgEBgQIhjDT_ABUXAu2iUADUuGANJQiFwPAABOByRTvTTGVQQGD5TQeOqcMUS_7AOKiQToAAylNoqE0pLtPAAogqvQA5bzeACaAAUvQB9bwAJQAgn7pL4APJRgCyMe8AElE37I4nE47pB7UKzlar1VqdQoYPqNIbjaaNObLeLKJKuLaRDwABKUdQaFO6fjNd2ergZoUafjkcTUJT8OxFqzj2iT6dTVBe1DNNAwReiZeaKczjfqGhR-BjVAuAfyeRoZp7nhRr3SaMZgDCmezkdDXsf2hgWBpwHVAhxHYtSzVDUQG1XVqzUA0jRNTQcDAAQCEWDR4BwNAVyPdcm1QK1WxtUcvVPAhzx6ahrwUO8t3_c9p10ZpYG8ScrzAVsiCLEsVSgis4JrOtkI0VD0Mw7CCA4uAuI0Ih53XfwdgWVELVQTgAApGF0FJCgwSh8gAShwaRFS4Vx5QVdTOEFLJMjodA_UocRIFOY8LK4TSzFgMosh-BiuBsOA4DAvzpPvIyLNYdtRwgMAvOc1yIHc9ccEUeTKQmagLNcSyPGaDjaHQDwoo7KwrDdfIuCS-KUsU6hvIkWBSXbLg8TKYLQuHLhWSM9SrBLQCXCuBLNNqtyGtQdLNCILL1y4ABCPLoMwIjq1K2LOwqib6uPHAsIAR0WeACBDWb5sakySjoTTNIyuaQvXKLXBi8qKo--KvIey7uDy_KQEK3Ris296PvBrgqpqly6tSxqfN3NqOqC-BupgXr-tHCHWSx0Q-oGvHOFZGzUE0i4klQcgvJet7R2MYwHCw-d0ZurgkPya1Rzs_52etTz-HyfgJCsnBvnQmAFXra1NLBiqijKDwiCSSWTU5slcZ4Z4LjKRgu28FNHXfM4Li9WAbBoVh0EochFnNggcGHAhTZgO2qSSDN0E0jwtdRIz_3x2Jtvpxnxe2KIHKe6guZo_4XEjv7ZUF4WzIVUWmdoaRUfXGWNaudAFZAJXM_jjx_yscRyAAa1sRBc6sDxygAVnISpG8b8oYAAdgATgAZnIRvu70Xu9DbwIADY2-78p-8qMBe97mAwHIGBAgEAAmJfl8bwI9HHsBx-7ypO_4Spx8XwJyHHvQ9E7zvG8qdeD679f0D0SoABZKkCQI26nSopx7zXh_PQ3d16nw_kfcgYBAgf0bnoMAndAiv17o3Tu68P4n3HugeBH9x6fzAJUcoP9Kh6Ggd3ZuH9e5gCblfFuSDu78H4JvXeS9B7oGwfPde5QmHkHQWA8gvdAjTxgN3OBMAP5VHKGAPQMAr5gB3h_JelR-7lE7h_D-69_CdyqBo3u_AeHtw_rA7hlRu6BF7uvcB48dHoGIcPTupdc4gkwFAFW-RPAaCgAXQgBB5BwEQPTOA6BMCqF7jgGAix_ArxoJOKA_hyg4ErHqBCYkqBECcdtAOGltrc3aoYeAiZljyGWJ5OO2VpqOyKX45Ybs_T8BsF7EAVICm-wANqVAALoEx4MHB0VwJz4Ryugec9gdiyigFAfJWB4CjgMDMuA1SSkEFzjgVAoIYCLQdrYZymBqRJHqTYAA6hIPA55hxYE0lDc5XosDyE0sYAAevM8MxgjJGVWXJL0U48B3XmTTLaEMrDzJwA6OcdgrkmjHIMtcs5Rky0aL2TQZRpInVai4ICGxtgaBOhjTG20IYgsWPIEZtAFSaAqZpfF2N8V0wZmLZmYd0a4UPLC7gdBtxumjlef4LLVzHk3Jy9GlkoYHn5euQVO5NK8xIrSoO9L04s3DhiuR_wFKgWHI2XJMcHKYpAmBLQIqoWZz1YOTVVKem6tVfqzVESwBoWAszH4zJPJQxTjgAcK4IDMmkHYDAdJ0Dgv4AiqgUBWwFywiVEAGNLV5JVY6jVmhvCUGrn9XOfKhkbi3DuUFISxWZptZoTS8aCCFo0HKqwwcGW0CZYivsQUzVmm1Tyutmgy2uqhT2PsZaLWjjwEi_sjaxJb2tU671UyjXVXdZ6zQ47fW6BGRoQN8LgAOAWOG6CeglgwBCNkqweT-3dqHcm1NFl00woFdmt0ub0D5rZT2w9bah0VtEFWxVsp2UUS4FAF0dBNDKlbLWpifrWIwHYroWS3FuX2RgBRZ0WQ_0aBPXQfmIT4OuiLbnH0_pAy_kjLGeMSZUzpizDmbweYCwevTFGDMAANcM74uxxgAOJeiUGXUQmkYAAtlhDPJsHhRnoJUCng6M5TkWFFRS8tFbz3jadhgMwYwz4bjAmZMaYvxkYo9IKjb56OMZY2x7pgcRO9IZjqQytb1nJThjk0zDkMC7Vs17YTImPDAZYmxGScl1RyEuI4FiG11auaBQAA38GzKWJEPZlAACTAAEzQHAMrJQexxiFqwEX1l7LiwliiayNlwHS_ZiL0kIM-amgErg8XEv2zK5xbilXWShY4x9al4N2SjhfWZ2UISuC1e_b-t0zgANaBLaOB06HEOaXdQp3DymMwBi9LGT8pHTJekdF6T84ZsytS4zx3OcbAKqokzQIT9mxOXDvQKiiUmaIwBvPRZobTZu-kU3hxb3hlsxlW9mdbm3tvZmM3Z8Gb7Q6sw81uLz5XuKjSZVhWUCPsvwCtdODaIWvrFuO9OU79tkdlTrqIPJWFmJQ7A952Hk6uCQ9A-Bhr8kXP2asClggrWgVtJLbjgrmBOls4hrxpnPBei6BgGUAXgurCthaGgMoHTWqVHl7zwngv1DTlbOGRYsvyjy8V3ziXqudgaHDKoWXCuKi6-V0z7IigyjPlfDR37ZHfw4BDI6OMf5LfYz1x9TrGXRDdaBRmtlkrr1YRBOoa764e0lrLch1A7WRNB8vUKg6LskWR-oA-gdseU10ATxVYreN8V9V7agMkFJqS0npIyZkbJyTyCnJXMCOAABW8wy_IAFNQV0IpEAgFtCATAihuSU2NKiZAgkqzCXZmaJAHhwncJwOvJxMFknwT7CJBs4l5ySTgDhC9BE58gAX4k5f6tV9CVSZvlCaEd9YT3_VyD8kprKUoKpDwtdj9L9Px4TrhchYaRH6Ig8hEgr6Yi_Aogf4D5ZB0grJH4N7QiAQDJIj4DEBTL-D-C7B0Ar56CLDQBRqf4IErxTK4H4HIEgFoG_4eiD6wZKAwDD5rTkBj5QEeBEGAT-C4EYCwCNhH6PKJLlDrw4CNwr7W7wDfAQEf4eCPKNw4AfxCG_6sjl6Ug0igTV6IBMgsgwDsggChT6CGCizUCQDNCt7t78iCg94MAD5oCQBES0COhv7yAhiqi0Bsof6oq7geBODoDnhhqCCJioDvhyBbg7pIDuHUHsySEgB6Cqj5AuA8HUG0Dih9C0CRFsFQC_5KGV6qEMjqG15aHkgoiChGEmHUBmHd7CiWHexqh3jcGJh_Drjj4D4uLgghGf7pIgioBt4r5h5Irvhqh2zj4aEuDUHwApiggtFiq7BuE4oeE6GUCYQrw3gf5DGzGYDkB9CTjHjLF5HUFrEbFTRLE16aEJF0iOyREvjjxgERTTjTFooeDzEEAqA8Gf7dBwEjF3Kzp2zMh0FUCbGtjj5hEeAuwSA_Gtjzitgpi2CCCjK3GzHNGwBUQLDLCH6f7I5UFAlYDrGLCYAf5tIeDI7hjwmzLn6vEeCdKKHkjKFV45ErGsh0lAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/rectangle_transform/selection/src/index.ts",
        "description": "Select objects and create a RectangleTransform for these objects."
    },
    {
        "href": "examples/rectangle_transform/simple/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1Delw8lD8SWVgsFgN8pRwEhDUZfx6cJRQAK60DbBgBGWdXASU8ps1HqmijOS6qvxwXEV5p6jncIcmt_dHJumqr3DkGhDyBNtJRR5IiUdCLWAhOAach5KHkYxoTC4AgPECsExfH5_cImRIpTgmFhQYQgAA0IAgcAAQmh-BokkgwPwoC4AL7kuEIjDYHAosggKg0OgEBgQIhjDT_ABUXAu2iUADUuGANJQiFwAOQAATgckU700xlUEBg-U0GrqnDFEv-wFl6HQABlKbRUJpSVwAKIKz0AOW83gAmgAFT0AfW8ACUAIK-6S-ADykYAstHvABJBO-iMJhOO6RcVnK1Xq7W6hQwA0aI0ms0aC1W8WUSVcO2Rz3SKPpgDCGazEZDnsLxbVmp1esrakNxtNmhwYAEBEWGngODQtA0_HI4moDdQ1ubtq4kZg290zVg3k3qDgYGbRA9nvUNBPPWoLmTCnkaGaw5Vo7LCcqxrWcNHnRdl1XAhr1ve9-B3VB_B2BY4D3TgAApGF0FJCgwSh8gAShwaRFS4Vx5QVS1UE4QUskyOh0F9ShxEgU4ELIrh0LMWAyiyH5UGaD0bDgOB-GaGBeOgn8CLI1hWziUQIDATimJYiA2KmVAcEUDQiEpCZqDI1xyI1Zpr1odANRk4AFKsHg3XyLhVKU9T4M0riJFgD07TxMphNE8TCwIqirCLGAWRgK5lPQ5zWLc6htM0PSRM0rgAEJjM1TB90rKz5JEOynOYlyNISlcAEdFngAhgyS_T3KIko6HQnTkoM7hXDkmyCsKxTota-rDOMkyzN0Cy8u63qpq4ByirU0rUA88xvK4XyuH8sTItZYLbOm1ldtCnaev21BWSojCLiSVByE4mTOvyqxjGMBwV3gyKmq4Gd8htXbaP-L6bQ4_h8n4CQKJwb5FxgBVaxtdDJt6ooyg1Igkhh00bQ1UkDtEZ4LjKRgAAlvGTR1uzOC5PVgGwaFYdBKHIRYaYIHBxIIKmYGZqkknTdB0I1PHUII3btvOnqnpeqHtiieiUuoX733-Fw5Y62UQbBkiFQh17aGkeB2vhnGeCRzVUb1lWsaN7Z1IAa1sZGAFZKhgPQACZ-FdgA2B1-H4AAWABmV3TnKQJXcCQI9ECfhyld52wHKABOP2mQDh29Cj8oA5gFPA_4GBAkT9BPYdgB2RPE_KfhAhLsAi4ED3Khj8hAj952_dL8h0DAb29HISok678pPfz8oHf4RP-E9vQA_4Uv0Er0vXddv2HYd12K-LvR0A3vRyjAL2Z7AMAA70UvBF98hym7gP0Cdk-9H99AB6bh3PYHwJKm7sBAjAUvV_IMnb2gg9B-3KMPc-AdA7lBgMvW-ntE4z1dv_AOCdPal38OnIBDs67u0qOQOu5BXZpyjgIAOY9fZ6HwXfS2PUrAgkwFAdG-RPAaCgMjQgBB5BwEQE9OA6ANClxgIsK-OBhH-HIMKTcUB_DlBwOWfUU4wJUCIBqEWR0FY3n-GKTaCZljyGWBxZW7VWa2D0Vw5Y3NfT8BsOhDw6YiCbS4MGPoboPAEQANqVAALpi0es9SGb1paRRPGeASl4YJ3l0lwQoJRZSfVhoeD0qBQTwA9LodA8Tei6EipgSA-4EK7Qlh9bJbouB5LQPAYJmRlxMkkVwQy-Q8DqTwNUlcYTmjgjpI0DJsAriXAEcDaiPU_pcHaXYcJMAry6FgtE8is1QkTIvFMyJ950IAySVwDxOjxLmIMSzFJmA0reO8lbUpEkHrTR4M2FoaAyheI9JUR5JyrZWHUNuZsYZFj3PKI8552M6G9XeTsDQYZVD3KeRUf5rzRDZEUGUdsnZIw9j7NmIMoYcDBkdLGT0Vt2TqL8aICWgTaCym4DAZ8_woAujoJoZUzZqmLPPBEmZUSiCaLohS4Uzosi0o0N4SgdtVaCCdDSt0Gh0Lej9AGQcEYYxxkTCmNMmY0W5nzDgVMXYAAaYZuyE1jAAcU9EoD06EYB3S6lbUZXKaAcUinKJ8wpXxjBvDAT88hvwCQ8VK_06LwxRljPGJMmqVU5jzNIDVaZkU6r1Ya41vjYiAp4BLSAUANz0q0CUSkmRFDkBKlcLRuhJFWyUpxG1LMijpUyuM5lKzWX3jXOgGSK4lwaFQISwqEtdT4WqSk-a8VhlTRcBgWKrkEJ2KTXZDUTLJnTJvGynplxHDnlygCq5PAAAG_gEkY0PLzMoAASYA5acAbMlLzE666uDbsOfAQ9x7KU4FvXAS967t3QXrbpAdPCuBHpPR--dcEEIvo3VbI6h0qLbXQkdMkFJqS0npIyZkbJyTyC3DbTaOAABW8xUD8kFK6EUiAQA2RAJgRQ3JromlRMgDw44KzAS-poDwiAPABxwK7ORrsPDYxAPRxR6hqxMbAgueCkE4BriFJubcmkWNsY41xnjdGFGTkEyBOs4ExMrgkwB2ZjiEJIUoChOTIB2OcY4x4fFIBHFoBM4iHkRIlMgExL8FELHSNZDpAQEzaHoThQLUifAxAoDXv8LsOgTm9CLGgOgHzdJJEhaizFgLDnguWd45gVQSgYAUeynm-A7mPC-YS_4KLGBYAaBMwAPTkbHHADsnNwvgN8Vz1WHY4D9vVyzrJYOUhpKgOkDJEBMgiuyZzGSDC4EFJAZo2HcP4eoIRhgpG0D5IkDAR0Rn5DBlVLQGT8skDQSqrxpw6ATxQEoIIBMqBuxyAEjAFjR2YC8a-iZvQqp8guEq2SDwtBxR9FoHFvzUBLO9fgwNxDw3kMwDGyiabLQ5vUAW0KegxHSMqO_BVhMfxNI0dIww8ED2kAeBUSCVAOGnMrhBOobsapmY0ZGy4Xj8BkygkJ-mKTuxHsaGOx4eYy5JHupY4z57HhMDkD6JuQpSGIoZdPJLgdQuZdM9-3SNmJmOyeyc3xdS3nDs89FyASgywVDfdY2Rl0TnsA6TFMKZk2WqBS-bDRp7zO9IEAd82eCzZky2AvnYbnvPrNs9gK-BYyxZPE5ALe9LHhsAS8WJgFjHiPC3rDAT2AqIMuW5AN4nr5I-sIaGyL1kpegA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/rectangle_transform/simple/src/index.ts",
        "description": "Create a single RectangleTransform for the session."
    },
    {
        "href": "examples/scene_tree_manipulation/cloning/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1dR6poozkuqr8cFxFef2og3DdJuOTPSbpqvNw5BoQ8gRc2Yp5RJToAK6wIXAa5Hmn5MZomLgEUyCsJitrG-EmiSmcJixQwiAAGhAEDgACE0PwNEkkGB-FAXABfIGXa4YbA4e5kEBUGh0AgMWKoCBEeSUDSbYAODQCWgANQgMHypPJAKpNJg0ngcAg1FZKzoMG81JgXARXDAGkoRC4HgAAnA5IpFppjKoGflNB4ukSSWSKVwiPwCAAWVnqcgAZlF4sl0o8zSg_kNBDWWC1hIAFEMkqhyFwPQBKLiuVhcYBxULGNlGkX2NWM5kECM4rJceNMvXBrj8fL8CTRunqxMe8MiHizIZldCUcgHGw0HDNWwAUVg9YIoKSAEl0B6PBWHkGhlwABLeACyABkAMIDIatmDtgERnhFMoeIhJekJvUeCMIgPaiPGKOrdnZzJcnmoZPUVMuODc6hZnN5zZnmOcx_XksrrYQcgAGtbEQP8eA8C1ygATjAcpjTASpAnIcoYAANgAdn4QJ0Pg9BAmNC1-HIGByDAdALQAJiqY0oPQ9CKMwPRKnIdA9AAVn4SpWL0C0oItQI2LYqCKP4co2NQmBAgtdCLUqGBjTY8g2JgTCwGU_h2IomAxL0FCLVQ9BjWNTjhLAdDykEUSLUg7S-LYpiwAotj0CgozAn4MALWNdBKkEHy9HQDi9DAQIoPwyj7NomAYCgtCqlQvQnKo1CjIMsSsIS3TAj0Y1KnKOD0BCqD0AotSoMqKCmMCSTyGy2KYD0fx0LY8oEpgaTyESlzUPcyoeKUhS9A8wiYBamAPGXMsDX2GAoG3fJPA0KB1xAQgCHkOBEBPOBMAOZCcBgA5_GImgNDhfxyhwBUFBgZUNBwKgiAmv81xlEBNy_J8bxAfdD0JHgTwcKBqBFEoRVQGbb1QVNyGB1BboAORmrMHy-nAIcwB64ZgQMjxEQG_IvF1dDgMAyWda8tkoEYkxEWGQfQJHMeJ6GyY0Cm7xweQDgVX8ptejwWdJ8mjWvZ6pudV0ymdY0cAlKUhRJqBReoD0ZYe6kY0DM0SItOXbVpOEDngD1KlZJzWUqAMA1-vGAajA55HQGMtiiNNNC-rhKDAV3wchunscZmacEd526Q9n8_pvfGo0JsGuAx0Hqfj_l4ZdaKI1TwVhRwSVKAIHA_OnPBoF7en4aDzAo54LOhWi3PKHzkOnZjWkI9VqPjwdlvaC4GB1ChEo0GaCN00TZuw5xzuY64TX0C9g5Nnj-RIX4GxaC0QoSl9zJFHICBID9VA1_Gum702WBUGaEoAAVV_XzQUavahG1sO-zofjROwRk--xASc6DXzwB4AMABtSoABdO2kYuChxdvHQYUBjYRkvkA9-J8N44EQcbLMqFoEEwwA4HmBApQQAAF6gzdlnCMr58yo2vA9YhpCKG404AeVhqBATAjBBCKEMI4SIiBCvIC_Amw4AAFZwGoFiHEtB6CIBAOGEAmBFBol9AyB4yA5TXSVGoFU6ZNRIAgjgKiJiPBIg3Hmb6oFgRolwL8Z6IAXjrHuB4LRTi7DkjcR4FeZxZojDsfgYgUAuD-H8JQVRji9AHFLt4kAvjiIhOiaXAJtwgkkHMcuZR_clAwFUZgdR8A3FKISbNfw0SMCwA0HEgAepdcoFEcBsUcdseAqwXG1LYjgWWzSQAIgRFwkE4Jj58MQLCeEMAkRON0KxQwD1qCQGaBIqRnDkDYmoHI_ECilFoEgESWgk5G7yBvpKWg5BxDUDcS6Y2WSnDoAAEqzUoIIAA8qgYuugmxXI0Dcjw6Y4l6ElPkFw1TASC0XPIZWtA4mlKgOYwZPCRnQjGQIyZQJ7g4kWcs6RazZF4gYEox68hoCaBeRsa8milF7EOMcIx6yiB7FQJIxx1I9jqGnFKdsmjxkuCyfAcc-wjgwC7LiSU8hvm_KcZQA4fjxwKDcTymAWTMCw1Xhc6xirlUkWVmddVcrxX8ImVkzxTYkx0ubNIVCjishrHORKpVHhpUEBUKCmx6QsiOOwIoNY7Y4S5KoLqskmjrkOpAIuCQ_qyRGjJOOWwlk7D2qydSoVjypFIPVXExOmSPDYFhgcTAbjQEeETgAfWTbAB4yqQRmogQMoEQzeHIsVf0hEQA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/scene_tree_manipulation/cloning/src/index.ts",
        "description": "Clone and translate the results of a computation."
    },
    {
        "href": "examples/scene_tree_manipulation/find_by_name/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1dR6poozkuqr8cFxFef2og3DdJuOTPSbpqvNw5BoQ8gRc2Yp5RJToAK6wIXAa5Hmn5MZomLgEUyCsJitrG-EmiSmcJixQwiAAGhAEDgACE0PwNEkkGB-FAXABfIGXa4YbA4e5kEBUGh0AgMWKoCBEeSUDSbYAODQCWgANQgMHypPJAKpNJg0ngcAg1FZAElvNSYAA5fYwLgIrhgDSUIhcDwAATgckUi00xlUDPymg8XVQnAAFEMkqhyFwDQBKLiuVhcYBxULGNn8WhceyaxnMggOnFZLgeplkzauN35fgSZ10rVeg32kQ8WZDMroSjkA42Gg4Zq2ACisAzBFBST56ANHkTDytQy4AAlvABZAAyAGEBkM8zACwCHTwimUPEQkvTPUGPA6ERa9Q7jE7Vuy3ZkuTz9SJfZsXHBudRraHw5s5y6OUvqLGe1sIOQANa2RBnngeACslRgegATPxXwA2dDofj8AAsADMr79OUgSvoEgR6IE_DlK-z5gOUACc_6woBD56NB5SATAqFAfwMCBEh6Cfg-ADsSFIeU_CBKRYDEQIH6VLB5CBP-z7_mR5DoGA356OQlTIdx5SfgR5QPvwSH8J-eiAfwZHoFRZGvq-_4Pg-r6USRejoJpejlGAX6yWAYCAXoZGCH-5DlDxgHoE-pl6AB6CCcxD6foJgSVDxYCBGAZFqeQKHfoIej_uUIkWYBQHlDAKl2Z-SGya-AWAYhn5kf4GHBQ-9HvpU5D0eQr7odBAiAeJf56AV9keN28ZcHsmBQMO-SeBoUD9iAhAEPIcCIDOcDoBoZEwAc1k4GN_jkHiGhwv45Q4MqCgwGqGg4FQRB1WefbyiAg6cpuy5jiIE5Tqu1B-pQBy9TdO4bluqBZrYADyN3yDdRbCvwNhliAsgwFAYAeBaADalQALrnTwM6RuK9j9FAUBOVeWxyJsIJcNgMBprQ6BcPkUSoDA6haCU4qoGKjTVnoMB0FwBzyL-eM-pd-5wsj_CoyGBrE_koqYAA_GUApCgLMBWjado7WA5oAIR8-LVrUgQBwaKgepWGuXCU5gwwhorYrPQQ4tgkk32_R4FvigQlCLpCjgg5rErQ46Dgc2j4qI5zqPUDNXDpNS5CSEkboYG6R3NNwEg-hzKOXga123QQOC6xLztJx9KeM8zMCtkj8c7t78d6hOlp6oCwJghCUIwnCiJAvIXOXvw2Y4AAVnA1BYjitD0IgID2iAmCKGipoMg8yCKstqpqOqAY6kgHiATgr6La-HhIgO4b6kvwJorgvzbSALzrPcHhTyfdjkhfHhN2cgMjAf-DEFAXD-P4lCj8fegHNA6C3xAPfGab9f7_yfrcF-JBN7dmHiTJQMBR6YHHvAC-Q9gGA38L_DAsANCAIAHqLTgjgB8x9tjwFWGfAhD4cD_hIZvBElcQTglQJCaEiBYTwhgEiE-uh0AGFwDiSAzQO5d1QD3agfd8QDyHmgSARJaCNkoF_AACjKWgwdjpIAIBoA4MBYFOHQAAJUBpQQQL1UDNjkKgbMF8dF6NgQGQBegZT5BcHgwEHhaAkigIeQBGCoCbyYdXVhtcOH124UCe4QiWiiO7sgbEki8QMCHpteQ0BNAvQ2MuSeQ8mpHBgIAzaexUCd2PtSPY6hmyygLJPThLhYHwHrPsApfJcQynkHY3R-iPBdzVjNesCgL71J6XA8gvi5riGoMMiJsDMDjMhC6ZcgzOl1y4bA6-2ZvR7xzNIT8x8shrGDl0hxHgk4qA8beYeIJtmNKwIoNYBY4QIKoJMskk97GjM7BIF5ZIXRknrLYSydgTmjPybAExXcoA3S0VctOMCPDYHGQcTAF9QYeDTgAfXBagzx1ysgeAhowoEzCa7sJGQiSlQA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/scene_tree_manipulation/find_by_name/src/index.ts",
        "description": "Find the nodes that correspond to the name provided."
    },
    {
        "href": "examples/scene_tree_manipulation/material_manipulation/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1dR6poozkuqr8cFxFef2og3DdJuOTPSbpqvNw5BoQ8gRc2Yp5RJToAK6wIXAa5Hmn5MZomLgEUyCsJitrG-EmiSmcJixQwiAAGhAEDgACE0PwNEkkGB-FAXABfIGXa4YbA4e5kEBUGh0AgMTgQIjySgaTbAOIODQCWgANQgMHyJLJAMpqxpMGk8DgEGorJEAFl-LQ1nDpHYMJD0Ephfx-TwAJLeakwABy-xg8q4AHEYJQbAQoTK7FqVnQYMqYDBOAiuGANPquB4AAJwOSKRaaYyqBn5TQeLqoTjGABUIbiIe0AjOUWGYFJWyiXCIws0EDhXFQGq4hRKiZgmUU5AgkBg6Ez_BsOAjEa4zvkkMrmY1tfrjaIydToqgqsr1u4IeMnBxWS4zVsQpF6agXFcXAAFJSs5gykqVerMFqU1O4b2bGUsmtUM1OABKMoUkTLmCry1qjWBnjbtNwsqTl9QcW6dBS438QMIgA2gAurOrBcJePAjpsz7dhu8AXpSPDXre64PkhnY7lAb5dtOX6Sho0qyo-XBAaBc4gYGS4ahiGj8OozgwPO86oKeYEQRh8ZaPOsCbBAs5cJUDT8YwmY4D-dg4LAx4lMJADUclsZBVgjGAC6oOJsqARAoFoFkujkHqanvt2-E_oRf5KRhVjQZhH4CYwJl4RK5lEXYrAaRJ_DacBJEqapC6wdOOCoH2s6uHOQW7n2VkiP5T64buGpwDg8gHG687AM2K6ZgCdndqRp5-SpCLWaRsRxaIJbqZpdg-SMqD6aghmUGpur6rYRqyrF8UONQo7jh1hpJA57UGl17meVpOnFVY1XzoN41JDgUUzgAZGtY56ktK2JVAIVhRFkV7XuBYbVtQ1QrtWENU1LXGXtZm_t1HGVf5q3wSlaUZVlKG5fl05lItnXLathWzaIpVveVlVQzwCJFRVPDUgQBwaNwH3JQBVGoPOQxJM1C5sa44HKcYxhUhyXD2D6jLMgQbL9ZstNMqSmxzvw-T8BIlOpvSdNs5lGGzEMZSMAAEt4AoADIAMIDEMACisA2DQrDoJQ5AHKrBA4OOBDKzAOugkkCroIu2IKw8p5ajwRRlB4RBJPzrNkh4lIIyR5O87Q1OZNyvJBiItkuHAPLUAJnPc5s7KplyYeB0LlXiOQADWtiIGVHj9IIADMgSVAA7Ln_AAEwACyF4EYAwAAnJU_AwOXpdgAAbOQtd6OgACstet4Xtel7nufoK31Td63pd1-Q5TlK3NflOXved6XgSl-UYDoOUMCz4EudVPw_Ct-XreBN3egbxvo8wP0Nc193MC5-v3eVE3peYDfMCt7n5cF3oYDlz0OXR-6BB4D0Lo_QeudC6b2HoEPQQDO78DALXGAgRy78HIK3Vu3c27F3IGASopd-CD1rugfOegYDd3KKXcglQT7d1wVPMAhct6VHKLneh5Qq75zPuQQB5cMF13KP4eeRcp7lxrqvCeZdC78ELvPMe3dR56H4YfPQucPC22TBqKALtPAaGwk6EAhACDyDgIgcmcBMAHBnjgGABx_CGRoHRKA_hyg4DdAoMsahNA4CoEQLRGF7bGKdvHcOQYQAe0RkHKC_VKCwCkpQZoC0Jx7XnGaVAFoVQ4AdJQAgeUPBwHkFEakHhTwxLiY1BJMAkkpP1k5OEGTnHZKtLkyg-TCkgAMFgcpMTGaNRjnoASLFGTwQAPyoStPBYmpNglqXnAAQiyfkGZXAUZo1QDjGyTMAZJUwMMOcDT0krPgl04ppTrQgEqaITGBycBcUVpgvAzE7kwFma9d6J0aKrX8QkhMc4PDUnQAGMqbzrofhwAceQEkYC0k0BE-c_TobguvFCmFfMEWJxufDG5CISKhwiei2F8soBQD0Jg1OAlyB6BIjSjJAdqAhQ1DEhGSLAyAmBGCCEUIYRwkRECBsad-DjhwAAKzgNQLEOJaD0EQCACkIBMCKDRM1BkDxkAui8R6XxGhvS-n9EgDwuccDr1NR4JEjtuaRMzsCNEuBfhBJAC8dY9wPCaudXYN2RqQANjODAGcNx0S_C4P4fwlAVVOr0AcaAIKfV-sMjOaNsaGq3HwMQKAFrWRKpgKoJQMAVWYDVfAd1iqE0Bv8NGjAsANDuo8AAPQ8TQnA3cnXbHgKsV1daQD1u7jgcuLaLUIk5SCcEoVeWIFhPCGASJnXfh6X81AkBmjislagaV1BZX4nlYqtAkBUASBgNLDp8gAAKDpaDkHENQd1hoDiag8E4dAAAlANlBBAAHlUCyzkMeK5iA70PpACzbtegHT5BcLWwEHhaDEigKmbt5bM0gGHUCUdPLoSTv5TOoE9wcTLtXVK5A2JN14gYIqgJ8hoCaA_RsQOGrFV7EOMcH1AS9ioAlU66kex1Cy31DrDVU6XDZvgAKfYRwYAKlxA6eQt6ND3uzZKtGhkhSyb5dO7NmByDwbotem1QmgNaZ08KQOqn3UGezV6_W3bFbSFbk6w8EAr1yYUx4SgBwCAqCg7a9IWQnXYEUGsHWcJ81UF06SDVgGRNEAkKF0kwpSQClsIIWULmgNMYk6-yVUAPOB27deLNHhsDaYOJgd1gEPDXgAPoZdgA8TTIIGYgGAqhrlY7ISYYMwibrQA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/scene_tree_manipulation/material_manipulation/src/index.ts",
        "description": "Find a specific material and change it."
    },
    {
        "href": "examples/scene_tree_manipulation/persistent_updates/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1dR6poozkuqr8cFxFef2og3DdJuOTPSbpqvNw5BoQ8gRc2Yp5RJToAK6wIXAa5Hmn5MZomLgEUyCsJitrG-EmiSmcJixQwiAAGhAEDgACE0PwNEkkGB-FAXABfIGXa4YbA4e5kEBUGh0AgMWKoCBEeSUDSbYBxBwaAS0ABqEBg-VJ5IBVNWtJg0ngcAg1DZIhWdBg3hpMAFPAAkqKYDAAHL7GCcBFcMAaShELgeAACcDkikWmmMqkZ-U0Hi6RJJZIpXCI_AIABYAVx1OQAMxcFVqjVakDNKD-e0ENZYC2EgAUQySqHIXAjAEouK5WFxKSJjMZqZyuPYTUyWQR2dQsq7TYXk7n8vwJNmHTAGQWbRH01ZZkMyuhKOQDjYaDhmrYAKKwPsEUFJSXoCMedsPJNDLgACW8AFkADIAYQGQxHMDHEtERTKHiISUbzJtHipCITlqpmbrtFzmR5fNQxdQpZccF51Er_DVrWHL1tyv7vi2VI8OI5AANa2IgUGiB47rlAAnGA5SOmAlSBOQ5QwAAbAA7PwgTEdh6CBI67r8OQMDkGA6DugATFUjpocRxEsZgeiVOQ6B6AArPwlSCXo7poe6gRCUJaEsfw5RCYRMCBO6xHupUMCOkJ5BCTApFgPp_DCSxMBKXoBHuoR6COo6onyWAxHlIIinuqh5lSUJfFgCxQnoGhdmBPwYDuo66CVIIEV6OgIl6GAgRodRrHeZxspoURVSEXoflsYRdk2UpZHZZZgR6I6lTlFh6AJWh6AsUZaGVGhfGBKp5BlRlMB6P4xFCeU2UwOp5A5QFhHBZUEl6TpeghbRMD9UqgJIXsmBQBengaFAJ4gIQBDyHAiCZnAmAHPhOAwAc_j0TQGhwv45Q4HqCgwIaGg4FQRAeIePDHn6Z5gX-H4gDed6Ejwj6DpsJQwFwXZklwg4arYUJcJQBz7Rj8Yw2jqCwyUDpw5Q8BcKglCbHI6h2vWaxwiM3A42AZLBgmn6lvDGgAPIY_IWOuK-4HUEhA62NzmPjkkcr8DYM4gEolBkh4rMiDwOCQBgEYRpQSYplwACElBq8zDo4Gg5BQAcmBwLLwaaBAcJKwmev3hmWYgc-9j9FAUCzXBWxyJsCjyFAjLDPYIa6HATMaMG75bJQ_uw3AijkBAkCvaTips5sXs-3RsGVhGeP5AqmAAPxlNKYqlzAOupq2R5gPGevFzXSY0gQBwaKglpWI-UUvhHX7R7H_4EAnEhIa3io4FFoqRyPDoQQ3Vh_R4Q9R8b4hC8tKuiMGoZlMGjpq-qRDz1-UBL9QEbHx9NL1omLpuu6p8anScIHPAEaVC6_h-S6SoCZlZWFvL3UQ09MA4AOPIdA9Y6SaCBomcBCIXYQyzC4aGUQuAwLgbQbc3tfawSpBzMWvMCDQNgfWAhec_b81zkQ8B_cMAODhFAEYmxqD0XponLgegYDNDQESVAzR2RsKIRGUhPMMY4DJpgMGqBbzIM4ICYEYIIRQhhHCREQJ5D534IOHAAArOA1AsQ4loPQRAIBKQgEwIoNEsZQ4eGQDqZ6Bo1BGnzGaDQLiUI4DYgEjwSJTw1mBohYEaJcC_G-h4F46x7guNsVkSERYkAeD0WcGA7Cbjol-Fwfw_hKAONiSAPQBxoDoD8SATJ9F2HlMqfTW4-BiBQGCWyOxMBVBKBgA4zATj4BJIyZCOp_hykYFgL49JIAAB6j1ygsRwEJUp2x4CrASdUmZQkcAn2WSABECJVEgnBKgSE0JECwnhDAJEIA4C6EEoYD61BIDNGMaY1A5jqCWPxNY2xaB1YSBgOuBW8gAAK6paDkG3uEkMX8OlOHQAAJWyZQQQnNUCbjkCIpaiBYXig8N46peh1T5BcFMjptASRX1oNU2p2TglHPUaczRFztHXKBPcHELy3lmOQNiL5eIGC2M-vIaAmhOYbHfA8VxIBVpHBxbODUexUAmNKTSPY6hNxKrxNKy5LgOnwFXPseVkpcTqnkC4vFHTTFd3oquBQLi9X4s6ebSE19wlOo6ZgV1d1oX2otVoq5FLIRQ2qUOaQhFSlZDWFCy1Gg4UeHRgQFQUyInpCyKU7Aig1hjjhD0qgvqyTSqtR4fcEh81kgdGSVcthXJ2DjQm2VxrYDItMRbaF1S5FLRCSAbA5tLY4oANoeC7QAfTlbAB4XqQRpIALqHKBMcjR5ynUHIREAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/scene_tree_manipulation/persistent_updates/src/index.ts",
        "description": "Change the a property (in this case the translation) of a node every time it updates."
    },
    {
        "href": "examples/scene_tree_manipulation/traverse/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1dR6poozkuqr8cFxFef2og3DdJuOTPSbpqvNw5BoQ8gRc2Yp5RJToAK6wIXAa5Hmn5MZomLgEUyCsJitrG-EmiSmcJixQwiAAGhAEDgACE0PwNEkkGB-FAXABfIGXa4YbA4e5kEBUGh0AgMWKoCBEeSUDSbYBxBwaAS0ABqEBg-VJ5IBVNWtJg0ngcAg1DZIhWdBg3hpMAFPAAkqKYDAAHL7cVU6VihWYJT8OycBFcMAaShELgeAACcDkikWmmMqkZ-U0Hi6RJJZIpXCImoALACuOpyABmLg6vUGo0gZpQfzughrLAOwk4rKZOjoBXiSD9cTULiuLgACjMsDKWTWqGa3pscDg_GaMCL0bQzQAlNnWFxKSIIGA86nOxAM3zUDhFBoiCDeVnXJOuAByZoaXS0dDT5vtqyoJlcHvpzUD_MSWDe4BcT5lCtVmuBxuOng6mDwmAjLu5rd9nfUIeaUeVgdcACEU-nTAiRgJcVypHgX37d8aQARwOeACAABU_Mdd0bDEolQXNhy_cduFcVtVysR88xw1CJwAucFxA5c23A4j13yTdKDTV9MywgtxTbY99iSU8eWrB8ESveib3o4Tr0DbVHU4XMhiSVByDzZsCLokRjGMalOS4ewbSZFkCHZahEz05kXWzHT8n4CQtM1GAGX0l1cyInhZiGMp0EocgDhsGgcBrAgAFFYF8ghQSSSV0FzDw3IeZshi4AAJbwAFkABkAGEBiGYKYFCiVRCKMoPCIJIHLM8kPCpCTCR4DTbNoHSk2_agjNQRMXBa_DLOszYOTs7kuuc-jxHIABrWxEFE0M_XKABOMByg9MBKkCchyhgAA2AB2fhAm25b0ECD0_X4cgYHIMB0D9AAmKoPTm7btpuzA9Eqch0D0ABWfhKk-vQ_Tmv1Ai-r65pu_hyi-zaYECP1tr9SoYA9L7yC-mBdrAdH-G-m6YChvQNr9Tb0A9D1fvBsBtvKQRIb9Wb8aBr63rAG6vvQOaycCfgwD9D10EqQQBb0dAfr0MBAjm47buZx7ZTmraqk2vQ2buzayZJqG9uVwnAj0D1KnKJb0Alub0BurG5sqOa3sCWHyD1hWYD0fxtq-8plZgeHyBVjnNu5yoAbRlG9B506YHdmAPAKng9kwKBys8DQoGKkBCAIeQ4EQDS4EwA51pwGADn8c6aHnCNyhwM0FBAtRNBwKgiGj-iitDUrBrwqqRBq1AqXq6N-HUZwHzhKAuEwIUMAXYZKC7exUEVHSMB0-R5CgJItiiBxR9D8a2sTAeh5cLKoCgXexos3NUDKFVZTVGAVMI-iE0oWAcCgShmivkSRB4FwMEgm-LCHh75JlgOQRc0cuAAAN75lAACTAEHKgfgNgETQJ_jeSSnU8I4AXpgDE84j4wHzEQzQx8d5nTGj_PumlD7kJHqfcemp7ASDyjPLsJQQRcHwSPZeEhhgT1LugaeS90ArzXhvEoD5-in3PvvTY9Dh4ajsCfM-VDL7oBvjKeUioVH8EfmpKwL834fy_ugTBoh_4phYr2KCwCQD6LARdSBgIYH6IQcAAAUtIAA8nKKu9ZSydiSLmCx6DLEImwTyAceDFSEMHgw_RpDEnKJYWo8-P9hK5h_oCYEYIIRQhhHCREQJ5BUMEjgAAVnAagWIcS0HoIgEAlIQCYEUGiRSjIHjIBNNXC0dcNDWltPaJAHg_Q4DupMjwSISrWV7mM4EaJcC_GbiAF46x7geF6esuwlVFnlLOHeEYyz8DEDHv4fwlAOlrL0AcaA6BtkeEOedMedyHknNuGckgMy2RtJgKoJQMAOlAXIN07ZrSXl3n8HcjAsANBPJAAAPUruUG6OAvprO2PAVYmzEVIq-jgD0GKZkIjySCcEKCimIFhPeJE6zdCfUMA3agkBmjVNqagep1BGn4maa0tAkAiS0DSpQa5iF9S0AgQObZ0Z4J_KcOgAASneSgghfGoAynIUsUckByqVCAUyiK9D6nyC4BFgIPC0BJFAOyiKoVQBmeSgpVLoQ0pKTAel9wcRso5XU5A2IeV4gYK0xu8hoCaF8RsAcPTWlxyOLqqagaiB7FQDUtZNI9jqAygaUKPTaUuD-fAFK-wE2SlxPqeQsqNDyo8LUg4RyUoKG2QWg1mByC2vnOxFtHq_nts7UAptVbin3j-XsgKiLArSE2ms4sfZDJ6prQaygBwCAqAtUm9IWQ1nYGHMSPEcIgVUC7WSHp-qi2jjXRdMkmoyQpVsLTLUi7a0gHjbAFVtSoCrplYs3hvyPDYA7QcTA2yADaHheEAH033wDWVuhdABdMlQIKWFLda2hEmGgA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/scene_tree_manipulation/traverse/src/index.ts",
        "description": "Traverse the children of a node or the data items of it."
    },
    {
        "href": "examples/session/advanced/automatic_update_and_session_settings/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1dR6poozkuqr8cFxFef2og3DdJuOTPSbpqvNw5BoQ8gRc2Yp5RJToAK6wIXAa5Hmn5MZomLgEUyCsJitrG-EmiSmcJixQwiAAGhAEDgACE0PwNEkkGB-FAXABfIGXa4YbA4e5kEBUGh0AgMWKoCBEeSUDSbYAODQCWgANQgMHypPJAKpNJg0ngcAg1FZKzoMG81JgXARXDAGkoRC4HgAAnA5IpFppjKoGflNB4ukSSWSKVwiPwCAAWVnqcgAZlF4sl0o8zSg_kNBDWWC1hIAFEMkqhyFwPQBKLiuVhcYBxULGNlGkX2NWM5kECM4rJceNMvXBrj8fL8CTRunqxMe8MiHizIZldCUcgHGw0HDNWwAUVg9YIoKSAEl0B6PBWHkGhlwABLeACyABkAMIDIatmDtgERnhFMoeIhJekJvUeCMIgPaiPGKOrdnZzJcnmoZPUVMuODc6hZnN5zZnmOcx_XksrrYQcgAGtbEQP8eA8AB2SoAFYACZyjAdBKgANhgMAwHKaD0ECGBYIATn4cgYCQvRoItMALT0C08LASp-AtQJjXQC1jRgGAiIQiDyFg_gINw_hjTw5DAn4ZDjUCQJ8LgvRKi4mBygg2CGPQZDYIEfh-D0Y1jT4yo9EU_hykCKDjXKS0YCEni8ONaCILswJKnKcoLNUsA-LM6DAgtWCbIg9C9ECMA9FhcgUNg6DcPk5DKlhbTkKI9BoONfg8PIMjymS5Cgr8zC9DwuCLWi4joNUi0IONeLKiExCKvQPjYP8Y0ZMqC1eOg8hykKzqILMti8PKPRkLqwJMII8pYI8ZcywNfYYCgbd8k8DQoHXEBCAIeQ4EQE84EwA4OpwGADn8IiaA0OF_HKHAFQUYi1E0HAqCISa_zXGUQE3L8nxvEB90PQkeBPS8CHEVBmmzA4CClI0AK4A55HQGMtkocU4RcVlq3gLhUEoTZ4cR2gtiiTJTpFF02OzVAkj2akIwfb6cH4SHofEchpFJzwEaR1xUfhGAjxEIHHF0JsL3kSF-BsWgtChrhkLpq9qEbWwAAUJalzROwAOUlmA-xASc6GaEoPADABtSoAF0cEGKADhFHnkIFwGoySSgDi4JtNhKEUccwLg9EIwDWT0SGRk2EFsdx7N0EwdBkaJkV-VQMnhWzYYoGocHhyZqHnQAzmCZFSPCPEdRb1QVM_ZgAB1CQ8ENmg8GQl9c3zenr0eg4silCAAC89f-m9BdPOQwdjLhxfOjWZZRiaRA7pWvbV6fbE1pIdZsfXG-NvBTYt63bftrNYOdyMuDdj2vcTqP_cDoCQ7D_NI5xzZBDjhOfZJgUtjT4dM7BunCGecYbkELkjEu5Ay4wArlXWadcSiNxKLBVub5LzfiVrWHuRB-6DzPkDLsXBAI43yFwTA5AihkxRu_AOuM8C3yxoaVABw4RQCSJTeOLpdBwDAGSaU1ARSUDAInZ6C9SZCjYjgSUuNGax2nHgaAvZq4IIbniZuQ8eDJ0FMKKRlAZH4xjLSTQ31Axn2UfXJBeBYIYnOpXXhGh853hwPIbueBfzTTeh4LhlcoAw2oC9aazpXRlGdMaHAEopRCm4b48Q1APShMetSGMgYzTsQtOE20tI4T2zgB6SorJ8lcHCgGAMf1tSaPETo6RBBZHoHkYoj05jEFqNgho7-KcJEwF0formdJjE_jaemRMOADG0FMZwA84zUCAmBGCCEUIYRoxgEiEA4sgL8CbDgAAVnAagWIcS0HoIgEA4YQCYEUGiX0DIHjIDlDdJU90NCqnVJqJAHh0nwRwBNEASINx5h-qBYEaJcC_BeiAF46x7geFueCuw5JoUeCnkRKAIxgX4GICi_w_hKAXLBaHRRCLVmQmRQHA4ijUW3HRSQDwvyzkwFUEoGAFzMBXPgNC05SK5r-FDhgWAGhCUAD0rrjRwNBMF2x4CrEhYK6COAwlip-QiGZIJwSoEhNCRAsI-YrLgLodABhcA4kgM0bZuzpnIGxNQQ5-JjmnLQJAIktBJx6PkCrSUtAoHXmhS6e2y41qQnQAAJTmpQQQAB5VA8iRYwKQD6mAfr0yEr0JKfILh-WAi8YueQMSY2As5VAGlyq5lqoWZqpZKz7hGpaKavZFqDl4gYKcp68hoCaDDRsa8NzTl7EOMcN5lqiB7FQDssF1I9jqGnFKdsNytXow8PAcc-wjgwC7LiSU8hvUaF9R4XZBwzgwHHAoaFs740eHIb486sSAUnr9eeiWV7D0bsWXzP1cKvaEubNIeWGbYVrCgZu7dIB3YEBUOmwF6QshguwIoNY7Y4SMqoJeskNy41-sXBIBDZIjRknHLYQQRp-AAdPR9JdsBg27Ltlewl1caVoawOQO2mBoVmw8NXAA-j25dDxb0giTCAS2SqgQqvmRqk9CJxNAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/session/advanced/automatic_update_and_session_settings/src/index.ts",
        "description": "Do not update the visible scene and only store the results in local values."
    },
    {
        "href": "examples/session/advanced/cancel_customization/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1dR6poozkuqr8cFxFef2og3DdJuOTPSbpqvNw5BoQ8gRc2Yp5RJToAK6wIXAa5Hmn5MZomLgEUyCsJitrG-EmiSmcJixQwiAAGhAEDgACE0PwNEkkGB-FAXABfIGXa4YbA4e5kEBUGh0AgMCBEeSUDSbABUXCG2iUADUuGANJQiFwPAABOByRSLTTGVQQGD5TQeLqoTgACkYuhShQwlHyAEocNJaVxXNSaSLxUMkqhyFwxfLVawuMA4g5qFkuHyBcTSarKfl-BJ1ThVgJaDT-flbQQxaaRDwimUPEQkp6bSSCB4AWaeLMhmVGAAJbwAWQAMgBhAZDACisBsNFY6Eo5AOhYIOGatnzMAroKSAEl0GKPPGHvKzQj5SK4xbNi44HAINR7fxHc7lTTXRp3TBpPBh9Q_bGRuhgyBQwuhyPRYDV-JyABrWyIVc8Dzlfh6ADsN8qgRglQAbDfygAWfj3gBM_AAnJU37voEYB6OU6AvuQACsejkM-L6BAAzDez7oFUUFQZU75_hhMB_oE35YUBlQwOBGHfmAgHkJUiFQegN6Ic-34wIEIFwbegS3tBMACGAUHfje_BQe-iHoPxv78Iheg8XotF4d-5AsbR356PwrHlH-MDPu-6D_rp5Tfgpej8Yh77vmAgRYXolF6Og74oZU_DaYhlR6JZ8F_iJYDmc-iFOXo74URZxHeYFd7Ife-EwNhEH-Pw779GJgXPqhLFQTAUH8GA2Wod5MEwIhBnkIh0arnsmBQOG-SeBoUAboQBDyHAiDGMYcCYAc5DlDgMAHP4ik0BocL-N1HIKDA3IaK6TIeF2PaxCIrUOAcWRMhAABe_DiKOdgnsMUGZDAOLoMMYoQGAIybCCqAAOSbP0jgTZ2IiDkuqBVrYAAKkL8DYtAaA2AByv0wK2IBKDAUD8EkXAANouOQAC6HjyrDlSIzggxQAcMD2lBvaHTu1CuitBBretoPzaKi3GFwgoOLoilQJdlJgP9FSHcdZouAQ3iEjAlAHL6BpGiaq6vburqM5Dmak-TW27gaBNIhU1SVFT3ZK5wgLAmCEJQjCcKIkC8j8Me_DVjgABWcDUFiOK0PQiAgKaICYIoaK6vyDzIGyY1cmoPLWoKGgeGeICITg37dd-HhIiGTp7uHNzor8pUgC86z3GHrtZJCUZIB4ptnJDIxorgvxcP4_iUB76d6Ac0DoGHReQkzXAN03Ze3PgxBQHHMZuzAqgQx7mBe_AOetyXUD-A3GCwKHhcgAAet1Bk4FB6fbPAqxZy3q9QTg76b3HCI6yC4KoJC0KILC8IwEiGe6OgBi4DikDNNbtuoPb1CO_iZ2rs0CQFQBIGA6ZKC10-oyWg5BtpJwIBoHGg8nDoAAEqQ0oIIAA8qgTMchUDVjDkglBHhg4Hz0IyfILgl6D1oESKGtAD7FyZnHC-etr4GzvkbR-QJ7gfxaN_O2yBsT_zxAwV2VAiTQE0DgjYu4fau3KkcGAB9pF7FQDbdOs49jqEzEyCsPt74uEHvAVM-xVGNlxIyeQJDkEwEHrbA4JdUwKDDiYxxHhMDkChkNBBHjeGDx8X4hW1A3F2MNg_ehkJqwF3DrmaQz505ZDWPA-xZCQCCwICoJe4d0hZHTtgRQawKxwghlQfxJIfakK8SAOsEgKkki2iSVMthBBbX4BkupKjYCYNttjAJy9UD7DUSAeO9SsC-IOJgMOsMPAjMwAAfV6ZPfcbsQQF0RufIEl99a308QiI5QA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/session/advanced/cancel_customization/src/index.ts",
        "description": "Cancel a customization."
    },
    {
        "href": "examples/session/advanced/consistency_between_updates_advanced/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1dR6poozkuqr8cFxFef2og3DdJuOTPSbpqvNw5BoQ8gRc2Yp5RJToAK6wIXAa5Hmn5MZomLgEUyCsJitrG-EmiSmcJixQwiAAGhAEDgACE0PwNEkkGB-FAXABfIGXa4YbA4e5kEBUGh0AgMWKoCBEeSUDSbYAODQCWjSeBwCDUAFUmkwABqEBg-VJ5OZAAlvABZAAyAFFYDYaABBVCOMnebAEJT8OzMgCS3mpMAAcvsYFwEVwwBpKEQuB4AAJwOSKRaaYyqTn5TQeLqoTgACiGSVlXA9AEouK5WFxgHFQsYWSr9fZHVyeQRwzislw49yyZtXFx-Pl-BIo7QOfGMx6wyIeLMhmV0JRyAdJQQcM1bOKYA3QUk1egPR5Kw9A0MuAKRQBhAZDVsNgHhnhFMoeIhJIvp8kecMI_1unjGSOrVnZzL0xnukTJzYuOAM6hB7O5_N76N0y_H0szrYQcgAa1siDfPA8ADM5QAJxgOUAAsYCVIE5DlDAABsADs_CBIhkHoIE4EAfw5AwOQYDoABABMVTgcBiGIURmB6JU5DoHoACs_CVPRegAcBAGBAxDHAUR_DlAx8EwIEAGIQBlQwOBDHkAxMDIWAsn8IxREwAJehwQB8HoOB4HMbxYCIeUgj8QBQGqRxDE0WAREMegwE6YE_BgAB4HoJUghuXo6BMXoYCBMBmHEZZ5EwDAwEIVU8F6DZJHwTpWkCShUXqYEejgZU5QQegfnAegREKcBlTATRgTCeQqXhTAej-IhDHlFFMCieQ0V2fBjmVGxMlSXoTnYTAdUwB407llweyYFAy6eBoUDziAhAEPIcCIDucCYAcsE4DABz-LhNAaHC_jlDg1oKDAdoaDgVBEENb5zuaICLk-V7uiA66boSFbUCmNZkgA8gcC0AzeF7PW-Ta2P9gMEB22r8DYPYgEolBkh4_pg5AGAeh6lCBsGXCUDgRDRmscJcAAhK4WYHGiGNnf6ZNukmX2bP0UBQD1X43h6qBcrqmAAPxlBqWp8zAzKUFA6Ci4LXDC6Fou4yGZZWBAYB-mTPP5ArXDUgQBwaKgjMjTujSaPqMDqDQXBQCCtA884DiUEc6BcHo-rUns6gu5GHlnW-muizg6AqvwODyAc1o9iNPCa0OQpihKeIynKGgKlgSoh6-0eiFAtYqseZQANp_lYfo_RokPh42eh6ETWBk4XlQALpcAA1Fw5eVwDOA10QaAN83gaRkROCVMNpel53ANVz3tf94X5Qt_4FTjxPogelPUOz3XDdES37ebzPvfz3vQ9cCPlQlzwTerxPwd2GUytrzwtDp7NtBZDd2dWFQucaLNABiMAUFqiX1et_A0JcNxvneiNAOeocAHHkPfdkmhnoBi3AaI225IxoAkBAUmrMoDMhKPqFwOIXaoD1B3Sg8AuBUM2ETAgtAtBoHxvrLg2A4byGOKeOE7McKfg3sjCu09u5UMwGTZkh9xF6jJrAngMjGwSJgGTRByDoxsjQS-BRqYnQJnUSgjBH0IyuySIeZhaBmhbDwCCBw_COafhsfqWOugU5GjJM4mhnjChs1dvqB8tAXYW00OY8QNgvEqK4EglBUwRBKMMdGMcbNHE3iIY47Bt48ybFjgABRNH3FwWNqRwAluoRWFjvDEhgE7AgHoSllLFhUUB_pdEg2PODAguTIRw1sJoGGvSEbCjoM0EoqNG5NxwIMKABx9RZngpgnM2TDzPmoJdCOBBTQQAAF4wGMagDc-zATAjBBCKEMI4SIiBPIQR_Bmw4AAFalNQFiHEdt8SIBAGGEAmBFBollJyB4yBLQnVtGoe0aYXRIEAjgEisKPBIgXHmF6v5gRolwL8G6IAXjrHuB4YF2K7CrmhSAG5ZwYBQBGOi_AxBKX-H8JQP5WK9AHGgOgfFHgyW4UpSytlVLbg0pIAi6cPyLZKBgH8zAAL4D4u-Vyil_gWUYFgBoDlIAAB6R1ygjwYli7Y8BVi4rVeqhiOBwI4F1SABECJjkgnBKgSE0JECwnhDAJE2LdD0UMJdagkBmiPOea86g7yGDfLQBjCQMBhTI3kPkygtByDiGoPiggGhZkiqcOgAAShSygghfqoBHHIVAzYU1prFh4NMaq9AmnyC4VVgIPC0BJFAaMar5VQARba05DrznOsuW6oE9wcR-oDdQINuJ6CfO-VdeQ0BNC_Q2MeIF3yxpHEGiSq6exUBPKxR7Sg6gRymgbECl1LgRXwEFPsddapcQmnkGW9NHhSn61woKBQ-Kz0VtFeQVt-0k0oq_SKzAv6ekAffQ-i5rqRVEubImEloppDwSxVkNYibH3ftqSoBtqL0if0bSAbAig1gNjhOKqg_6yRAtTU-wjfclR4TJCqMkgpbDGTsBhkVa7YA5tKTMgDaqVHCo8NgX9BxMD4uLiAFRAB9bjMqCN4fg03G1QI7VnKdV-61CIgA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/session/advanced/consistency_between_updates_advanced/src/index.ts",
        "description": "Use the updateCallback to apply custom changes to the model after each update."
    },
    {
        "href": "examples/session/advanced/content_update/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1dR6poozkuqr8cFxFef2og3DdJuOTPSbpqvNw5BoQ8gRc2Yp5RJToAK6wIXAa5Hmn5MZomLgEUyCsJitrG-EmiSmcJixQwiAAGhAEDgACE0PwNEkkGB-FAXABfIGXa4YbA4e5kEBUGh0AgMWKoCBEeSUDSbYAODQCWgANQgMHypPJAKpNJg0ngcAg1C4CK4YA0lCIXA8AAE4HJFItNMZVAz8poPF1UJwABRDJKochcNUASi4rlYXGAcVCxjZ_FoXHs8sZzIIZpxWS4dqZZM2rht-X4EktdIVDrVppEPFmQzK6Eo5AONhoOGatgAorA4wRQUkAJLoNUecMPA1DLgACW8AFkADIAYQGQxTMDTALNPCKZQ8RCS9PtHo8ZoRepVPGMFtW7JtmS5PNVImdmxccG5vK9_B9ftHVo5k-owebWwg5AA1rZELueB4AMzlACcYHKABYwJVAuRyjAAGwAdn4gQ_D_QgTvc9-HIGByDAdBzwAJiqO8rw_D9IMwPRKnIdA9AAVn4So0L0c8r3PQJ0PQq9IP4cp0LfGBAnPD9z0qGA73Q8h0JgL8wBY_gMMgmByL0V9zzfdA7zvLCSLAD9ykEMjz0vHj8PQ5CwEg9D0CvYTAn4MBzzvdBKkEXS9HQTC9DAQIrwAqCFLgmAYCvd8qjfPRlOgt9hME8jv0cvjAj0O9KnKe90FMq90Eg9ir0qK9kMCKjyB8uyYD0fwP3Q8pHJgGjyCc1S3w0ypcOYxi9E0oCYFSmAPCbUMuD2TAoC7fJPA0KA2xAQgCHkOBEGHOBMAOF8cBgA5_BAmgNDhfxyhwSUFBgGUNBwKgiEq3dW1FEAO05Bcp17ER-xVM1h3WxMCAAeQODqLozAA5fgbBCakCAODRUGGXQbQ0caki4QoShtKAoC4SgLvkC7hhKK1Gn4dQtiiLhMG5al0C4VA7oqkQjpKGABRuAUDm1cRqGGFxIUceABTJIGQbBn6ompWHsbAMkiEhygwAZhxqFoGgRmGdsNzWOFdrDInNijMkywFiA4XOy7PQnbbqF3BNbFl0H0ySW6bFzEAlEoMkPD1ZXIAwNU1UoA0jSBnAWdoQXAdcR2uHxzATbmvUAEIDpEFdfTF_WNElu3pagNWLpwA55HQDcw4IKsubxNUAG1dxDKweCZjRbda23NBDlbqp4aO7DKNP05FqAyTKJPlPQ1lIOqevKnroiAF0qvLnhc_t-RqRcAgylS8oO879RnCnVqpsqYX04RXc55EVuB0JIcLQgdmsYFakYAAL2xygNinXmuDoTjYFZTfgbln7oEB1BKE2PRscj4u5ptVAkj2alDotVAYAkOmrppYTg0GPZ2UcNzDEpizVABw4RAz_lMDGFp-5bxsnvLYlABRwhcJgrgT8bR6FgHgl-G4OZX3VjaZovppxFwDkHPOMtqYEBwIKdB2MvQEA0AcGAKp-z6hVICYEYIIRQhhDgmASIQDyGAgefgiYcAACs4DUCxDibm-JEAgFNCATAig0TagZA8ZA4oZrSjULKN0SokAXhwNBOxHgkT8zQB4E8wI0S4F-CtEALx1j3FcTorIkJHQ2OkaTGAgMbjol-Fwfw_gD50G8XoA40B0CuI8DIs4ET8EpKgMjKJnjiBQEcU2XRMBVBKBgPozAhj4ABIyeEqA_hkkYFgBodJIAAB6U1yiQRwOhbx2x4CrD8R0zp6EcB3n6Y4hEQiQTglRmIxAsJ4SSORLoNChhFrUEgM0JRKjUBqITvQLROi0AmwkDACs-t5AAAUhS0HIITVUSAuE8NKU4dAAAlCJlBBCnVQFWOQqBEyuLeTAUpboOl6CFPkFw7TAQeFoCSKAG4OmZJAsUkAsygTzNEdCZZEipH3BxLs_ZqjkDYmOZo7ReZhTyGgJoU6h8ib1I2vsI4FVQlLT2KgZR3jqR7HUPHIgaZjErJcKU-AZYOWwEzLiIU8gwXcIhR4FRz0QKSyVeI1ZpTMDkFReNZ5riJWqrKQayEVopxapNRI0pdgNAnQ6UmaQb5vFZDWE85V7yPBXxUAitx6QsjeOwIoNYaY4SVKoEaskxjwVSqIBIKNZIrQS1sFJOw3qzW1U5T8lRUALo7VCffTAJSPDYANQcUtSAU4gBLTAAA-jm2ADw9UghCa3HFwiFmQgJaahEA6gA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/session/advanced/content_update/src/index.ts",
        "description": "Update the content of an output manually."
    },
    {
        "href": "examples/session/advanced/customize_result/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1dR6poozkuqr8cFxFef2og3DdJuOTPSbpqvNw5BoQ8gRc2Yp5RJToAK6wIXAa5Hmn5MZomLgEUyCsJitrG-EmiSmcJixQwiAAGhAEDgACE0PwNEkkGB-FAXABfIGXa4YbA4e5kEBUGh0AgMCBEeSUDSbABUXCG2iUADUuGANJQiFwPAABOByRSLTTGVQQGD5TQeLqoTgACkYuhShQwlHyAEocNJaVxXNSaSLODispk6OgAHKUcSQfriaiqrhisywMpZNaoZoArg2OBwfjNGC2gj25ry1WsLjAOIjMCWw3GiCmiDUHCKDREEFwaPcVyprgAcmaGl0tHQ6b9QZEPFQAq44YgJv4ZtQVoksCdwC4nzKLrdHq4CPlIp4CK4MHhMBDYaNFcjVeTsc0Cddya4AEI0-nMKh-XmC8GeOXK9WcBoYABHA7wAgABSnieTYsVJToYrj06T5tcAcLVh4Fct94vT8XWZzMDXQMNzfEt8jLEdt0va0YAbJt9iSFt4DbQdO27N8EWA1Dgww1AEU1GshiSVByEtP1nyAkRtU2PkBU0C1-HyfgJHVHBVgEWgaX5fJiVJMVX1EIoyg8Igkk42iNA8AFgNmIYykYAAJbwAFkABkAGEBiGABRWAbBoVh0EocgDj0ggcA9AgdJgUzQSSABJdAxQ8GSHnlbCu2DKjdRnJ9KUY5jlRpVi9yrGBpCQy9-PfdAhJAETwp80VAWA8RyAAa1sRBgJ4DwAHZ0AANkqAryn4cgwAAJlygAWXKqv4MAwFqqoKoAZkqABWABODrGq6mAOsCMA9HQSpyi6_hyhgcpcta8hyHQXq2uqiqYHmgqutysB0Dazb-D0SpAn6dByHa8pqr0KqirAQJBvQcpAj0ar-EEGBKhezBWq67bZv4DryHKJ7qrAGAmsW_hqo63LZq6gGQYqwI1oKoHQe61qIfKMACvISp5vm3Khr0VqsYq5bDsqdA9HKAr8qK8g2sCQJkdairyFy7riqO9BGoKhqOv4RHWqCDrWvQaqCu6grqu5wJKgGym6v2mAuol_6AJgGBJOAvZMCgMT8k8DQoFiwgCHkOBEGMYw4EwA4AZwGADn8cg8WzKB_HKHAOQUAC1E0VimQ8dz8J4FwMC3MdqyckA1IOLImQgAAvQcACV4COAhJK4AADWP44TZOuDTuAM7KAASYAAClpAAeX1L3vTQZoKySMUXES1i44IBPk-LjO-K4FS6GaEpYq6kJO3lBFs483D5SvEVAWBMEIShGE4URIF5DKtL3RgHAACs4GoLEcVoehEBAIMQEwRQ0WI_kHmQNlva5P2NF5LihSQDxWpwCrPYVQ8EiYSTEkpZWBGiXAvwtYgBeOse4Hhn5wLsKSJBHht5nH7CMKB-BiBQC4P4fwlA76wL0AcaA6B0EgEwS7Ah5DKE4NuHgkgwCpI3xgKoJQMA77LnII_JB19aH9n8OQjAsAJI_xAAAPU9uUCqOAOqwO2PAVYCDqHSI6jgaqijgEIiXiCcEqBITQkQLCAcSI4G6EpoYAOqBIDNEPsfVAp9qDn3xJfa-aBIArloCpSgJCTyMloOQasSDvRHnYU4dAacoCUEEDXVAak5AOk1kgCJMEPA0XyNQvQjJ8guEkew2gRIoChWocIqAwCDEr2MWvMxG8YCWPuDiBxTiT7IGxG4vEDBr5UCJNATQNcNjJiftfHWRw0kQP6XsVAR9YF7j2OoNSTJTJP3MS4dh8AlL7EmXZXEjJ5DhI0JEjwx8DhYKUgoJBGzMkcPIGU7MYT14DnYZgB5kJxzUCuUcl5myPCoIstQrS0gCqwLtJGTO6STl3MoAcAgKhJEQPSFkWB2A4yEjxHCbhVAnkkifhkrZCYEVrRJFWEkSlbCCCrPwY5py4q7NgMXSgUB4XJmoagfYaSQEgGwA8g4mAkEAG0PCcswAAfQmbAB4byQRQoALr6KBIY1epjbkIg1UAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/session/advanced/customize_result/src/index.ts",
        "description": "Receive the result of a customization."
    },
    {
        "href": "examples/session/advanced/customize_with_values/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1dR6poozkuqr8cFxFef2og3DdJuOTPSbpqvNw5BoQ8gRc2Yp5RJToAK6wIXAa5Hmn5MZomLgEUyCsJitrG-EmiSmcJixQwiAAGhAEDgACE0PwNEkkGB-FAXABfIGXa4YbA4e5kEBUGh0AgMCBEeSUDSbABUXCG2iUADUuGANJQiFwPAABOByRSLTTGVQQGD5TQeLqoTgACkYuhShQwlHyAEocNJaVxXNSaSLxUMkqhyFwxfLVawuMA4g5qFkuHyBZpVZT8vwJOqcKsBLQafz8sTSWLTSIeEUyh4iEkPTaNB4AWaeLMhmVGAAJbwAWQAMgBhAZDACisBsNFY6Eo5AO-YIOGatlzMDLoKSAEl0GKPLGHvKzQj5SKYxbNi44HAINQ7fwHU7lTSXRo3TBpPBB9RfdGRuggyAQ3OB0PRYDl-JyABrWyIZc8DwAdnQADZKlfyvxyGAAEzngAs55f_DAYHfVSfAGZKgAVgATiA78QJgIDAjAPR0EqcoQP4coYHKc9_3Ich0HAgDXyfGBMKvEDzzAdAAOI_g9EqQJ-nQchAPKV89BfG8wECaD0HKQI9FffhBBgSo-Mwf8QNI9D-CA8hyh418wBgH9sP4V8gPPdCQKkuSn0CAirxk-TQP_JTyjAK9yEqTDMPPGC9H_Eyn1w6jKnQPRyivS8b3IADAkCXT_yfchz1A28aPQb8ry_ID-G0_8giA_90FfK9QKvV9QsCSooOcj9KJgECkskmBMBgSNlz2TAoDDfJPA0KA10IAh5DgRBjGMOBMAOKScBgA5_HIPENDhfxyhwDkFEKtRNBdJkPA7LtYhEHFLVgVBmhKAAFSF-BsWgtDVfsF1QCtbA2gbts0OsADktpgZsQFTOhVrwDx5QAbUqABdbt7UdPt523F0DiyJkIAALxuv0rBe5bHpO66dpwIp3rXICZpETsRU7A0RUBYEwQhKEYThREgXkB8D34SscAAKzgagsRxWh6EQEBTRATBFDRXV-QeZA2VGrkJo0XlPSFJAPH_HAn2Gp8PCRYNHR3E9gTRXBfhKkAXnWe4PF5jW7FJHWPFJs4YCgEYVfwYgzf8fxKA59W9AOaB0ENkBjb6s3Hed83bktkhZajNmYFUJQYA5zAufgHXWfd03_EdjBYAjMWQAAPWG8onxwFHdxAbZ4FWLXXdToCcFfbPZYRHGQXBVBIWhRBYXhGAkQ13RnMMKbUEgZpqdp1B6eoRn8WZ1m0EgVAJBgVNKDttbGVochxGoHWCA0A4YEDpx0AAJVNyhBAAeVQdM5BW4qkDXjfA-tfJXb0Rl8hcZPA9oIkoH4WhXdjqBZervG64E0bkTFuQJ7g4h7n3OmyBsRDzxAwVmVAiTQE0IfDY24easzKkcC-SskF7FQDTdW049jqHTEyMsPMm4uEDvAZM-wcH1lxIyeQq916bw8LTA4JtkwKB1tQjhQdyAfwGsvRWAjA6YGEZtMRvDWGE2bq_SElYCCu2zNIK86sshrCXmw6-HhKAHAICoZOSt0hZHVtgRQawyxwlDlQURJIeZX0ETWCQ9iSSfxJMmWwghP78D0YI7BsA960ygEY7crtUD7AvnLEA2BhEHEwDrF6HhomYAAPrBKjrncxqiQDvSrkCGu-MG4CIRBUoAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/session/advanced/customize_with_values/src/index.ts",
        "description": "Customize and provide values directly."
    },
    {
        "href": "examples/session/advanced/load_cached_outputs/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1dR6poozkuqr8cFxFef2og3DdJuOTPSbpqvNw5BoQ8gRc2Yp5RJToAK6wIXAa5Hmn5MZomLgEUyCsJitrG-EmiSmcJixQwiAAGhAEDgACE0PwNEkkGB-FAXABfIGXa4YbA4e5kEBUGh0AgMCBEeSUDSbABUXCG2iUADUuGANJQiFwPAABOByRSLTTGVQQGD5TQeLqoTgACkYuhShQwlHyAEocNJaVxXNSaSLODispk6OgAHKUcSQfriaiqrhisywMpZNaoZoArg2OBwfjNGC2gj25ry1WsLjAOIjMCWw3GiCmiDUHCKDREEFwaPcVyprgAcmaGl0tHQ6b9QZEPFQAq44YgJv4ZtQVoksCdwC4nzKLrdHq4CPlIp4CK4MHhMBDYaNFcjVeTsc0Cddya4AEI0-nMKh-XmC8GeOXK9WcBoYABHA7wAgABSnieTYsVJToYrj06T5tcAcLVh4Fct94vT8XWZzMDXQMNzfEt8jLEdt0va0YAbJt9iSFt4DbQdO27N8EWA1Dgww1AEU1GshiSVByEtP1nyAkRtU2PkBU0C1-HyfgJHVHBVgEWgaX5fJiVJMVX1EIoyg8Igkk42iNA8AFgNmIYykYAAJbwAFkABkAGEBiGABRWAbBoVh0EocgDj0ggcA9AgdJgUzQSSABJdAxQ8GSHnlbCu2DKjdRnJ9KUY5jlRpVi9yrGBpCQy9-PfdAhJAETwp80VAWA8RyAAa1sRBgJ4DwAHZ0AANkqAryn4cgwAAJlygAWXKqv4MAwFqqoKoAZkqABWABODrGq6mAOsCMA9HQSpyi6_hyhgcpcta8hyHQXq2uqiqYHmgqutysB0Dazb-D0SpAn6dByHa8pqr0KqirAQJBvQcpAj0ar-EEGBKhezBWq67bZv4DryHKJ7qrAGAmsW_hqo63LZq6gGQYqwI1oKoHQe61qIfKMACvISp5vm3Khr0VqsYq5bDsqdA9HKAr8qK8g2sCQJkdairyFy7riqO9BGoKhqOv4RHWqCDrWvQaqCu6grqu5wJKgGym6v2mAuol_6AJgGBJOAvZMCgMT8k8DQoFiwgCHkOBEGMYw4EwA4AZwGADn8cg8WzKB_HKHAOQUAC1E0VimQ8dz8J4bVKFgHAoEoZonKLPymM2FxEsjyhBA0xwAIAeQOM2c7gPjsq4ABtTO9AAKzWszBigI986Tx9UBwSgc_kPP5SLyoAF0cCKTuylLivyCruFa7FeuJ2b3P7nbrvC54HB1GcZMpLjngS_LyuF5H-Ax4imNJ9b6ei_Kbve9itBq6KLhF4bkIra4PcCAODRUGGA40UgEt0HpEktjwEFr6aFvnHTsGIog1j3HAI4mxyJRVEC4DAW4xzViciAFSqdv7pyiN_bOU8HhOgAAboMEFwLBAEuC4MPhbLgAASYAAApaQmd9Re29GgZoFYkhikgdA-UCICEeRAW5EQgjOxXhFICYEYIIRQhhHCREQJ5BlTSu6GAOAy5wGoFiHEtB6CIBAEGEAmBFBomIvyB4yA2Tey5H7DQvIuJCiQB4VqOAKqewqh4JEwkmJJSysCNEuBfhaxAC8dY9wPCWJCXYUkESPBKLOP2EYAT8DECgFwfw_hKAmOCXoA40B0CxJAPEl2aTcn5KSbcFJJBPFSSMTAVQSgYAmOXOQcxETDHFP7P4XJGBYASScSAAAep7coFUcAdWCdseAqwwmFMGR1HA1VxmeIRJIkE4JUCQmhIgWEA4kQhN0JTQwAdUCQGaOozRqBtHUF0fifRhi0CfwkDAdBWSTyMloEPZMETvRHlqU4dAAAlfsGDM6oDUnIB0mskC_Jgh4Gi-RCl6EZPkFw_Tam0CJFAUKhTOlQE8Ws6RmzZE7PkTAfZ9wcRnIuVo5A2Ibl4gYIYqgRJoCaEzhsZMFjDE6yONCvxLK9ioA0cEvcex1BqSZKZCxuyXC1PgEpfYfK7K4kZPIH5Gg_keE0c_F2SkFARNlXCup5BsXZmrIasltTMCmshOOag-r1VyIHBiyEFlClaWkAVYJdpIwEA1VqkAk8VD9L8ekLIwTsBxkJHiOEjSqDmpJBY2F8qEwEHjSSKsJIlK2EEFWfgAbjW8tgMCzRNcLUDNQPsaFXiQDYFNQcTAESi4eCrZgAA-sW-AwTw3-pAJ3VZQJ1kyO2UahE46gA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/session/advanced/load_cached_outputs/src/index.ts",
        "description": "Load outputs that already have been cached."
    },
    {
        "href": "examples/session/advanced/parallel_scene_customization/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1dR6poozkuqr8cFxFef2og3DdJuOTPSbpqvNw5BoQ8gRc2Yp5RJToAK6wIXAa5Hmn5MZomLgEUyCsJitrG-EmiSmcJixQwiAAGhAEDgACE0PwNEkkGB-FAXABfIGXa4YbA4e5kEBUGh0AgMWKoCBEeSUDSbYBxBwaAS0ABqEBg-VJ5IBVNWtJg0ngcAg1DZIgAkt4aTAAHL7GACngrOgwEUwGCcBFcMAaShELgeAACcDkikWmmMqkZ-U0Hi6qE4AAohklUOQuNaAJRcVysLiUkQ4rJcE1MlmbVxcfj5fgSamchkBskEa1eqxFMoeIhJaPM2MeaWiWZDMqMAAS3gAsgAZADCAyGAFFYDYaKx0JRyAd6wQcM1bLWYG3QUlBehrR5cw9nVSEc7LTwfZsXHBedQ3SGwxGOfxaNz53zUPGqTwk1qQKnNwurYC91sIOQANa2RAXngeAAsAGYAGxgADs5XI5XKb5fT8AE5YSffgwAgmA9BgMAAFZ0AAJjASpAhgQJAnKWDyD0H9KhgN88PIOCn0qBD0E_V90D0J89CAp9P1A_hPxfdAWPKF8XyA8oEPAv8wCI2CaL0WDKifchKk_JCgM_T83yowJ-HQt9BH_IDKhfWC9Fo9iX3Yz8YCqIDyBgMCBH_So3wQoC9HUoCXwQ2DykQsin3_BDdP0l9-HIchUKA1igMEQJ0Fgz91M_chpJwj9Ak_RDyn4F9KmMsK30VWD-CM2DYP8MAEKfLDKmExLyifMA30CWC6IsvQKJs6j7Lop8swvPZMCgdNPA0KBkxAQgCHkOBEGMYw4EwA5fxwGADn8YyaA0OF_HKHA9QUGBDQ0HAqCIDxx0nQlp2oX1BHQCVMG8ShpDmmAl2tVAymFUUzpgV13U9C9ZVQeVRRwdVKHbE7yzwaBB1QfaRBla6FRgX7KH-nADnkdB1xgOlNFPF0p1Ef0M3JBGkZRzHxyxudTwvLaDiyDUIAALxgAAFSE4VgKB40PTBZP6TB_GSgR_HonCgmAmAlv4Irv2AqoDI8XqEJCCdyZKOhbXQU7JQuq65XBmUeW3cmWypohaYZpmoBZtmPA5t8uZF3n-H5z9BdioCRYS8XyklvDyhlw8X3lscIa4DEoh3E7no167tcyXXqH1ymCGpunGYWs2YFZ4B2ZgTnBFt4z7YF8ohZd0X3c96WkEPZqQC4BXA-D5Ww_Vy7I5JmOrTrg2E6NpPTfNjPLaz62c55vOHad4WS9qj2uK9n2PFg_3FZDlW1fO5utdbrdY47-PE5NlO-8z7PubtsfC-d12xansvvYrjw30XuuldD1Xw_Xr6o9JvWd8N43k-ZtOFsQBWxtiPPmBci6X1LjPcuvVPyPysPXF-q95TvxepvMmP8u5_17oA_uwDB6gNPhAi-k8JYwNvr1YI1da6IOfivN-msP4YO_ogzue9_6p3TkfIeJ9R4kInm7a-FC54gCAgg0QSCGFNyYegqkX9t5sN3t3feADuED2PrncBjtz6CKvuQqWlDDxVAkTwKRjc16yPBhOImqBATAjBBCKEMI4SIiBPIby15-CdhwAAKzgNQLEOJaD0EQCASkBDFBogdIyB4yAdSrQNGoI0ONzRIA8C-HACFlpyxAEiFM4Yzz3mBGiXAvwWogBeOse4MsIlZEhAQGWHgPFnDTiMUp-BiBQC4P4fwlAokVL0AcEGTSQAtOMt0oZIN2m3E6SQDw-SCGqCUDAKJmAYnwFqc0yEEz_BDIwLADQoyAB6y1uI4AXueEA2x4CrGqSc2COAnwXIWQiexIJwSoEhNCRAsJ4QwCRJU3QVFDBbWoJAZofiAl2OQNiagIT8RhIiWgSARJaCljhvIem6paDkHELHJABANAHClB4Jw6AABKadKCCAAPKoCBroTsMsiUkrZCAHGoy9DqnyC4I5VzaAkigCjUZ4y04LPeY4r5zjfmuIBUCe4OIIVQsCbC4JeIGARO2vIaAmhaUbG3HEiJbUjhKnSXCogexUD-IqTSPY6hywajbHEv5Lh2XwGLPsU1gpcTqnkCy4lpLKmUAOK04sCgZauqDZgcgwqFr4qKVG9lMa43rm3OG_1Lj_nsrsBoTsjTzXVmkA_K5WQ1h4oDWyjwIaCAqH5cU9IWQKnYEUGsNscIVlUHjWSOJrKg09gkJ2sk64yTFlsIIdc_BK1BpNbAKlASoAHATaM1AkoFnuqwLGg4mAZYAG0PCrswAAfVnZsq5jaC0AF03lAg-U4n5UaERPqAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/session/advanced/parallel_scene_customization/src/index.ts",
        "description": "Customize the scene in parallel multiple times."
    },
    {
        "href": "examples/session/consistency_between_updates/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1dR6poozkuqr8cFxFef2og3DdJuOTPSbpqvNw5BoQ8gRc2Yp5RJToAK6wIXAa5Hmn5MZomLgEUyCsJitrG-EmiSmcJixQwiAAGhAEDgACE0PwNEkkGB-FAXABfIGXa4YbA4e5kEBUGh0AgMWKoCBEeSUDSbYAODQCWgANQgMHypPJAKpNJg0ngcAg1FZAElvNSYAA5fYwLgIrhgDSUIhcDwAATgckUi00xlUDPymg8XVQnAAFEMkqhyFwDQBKLiuVhcYBxULGNn8WhceyaxnMggOnFZLgeplkzauN35fgSZ10rVeg32kQ8WZDMroSjkA42Gg4Zq2ACisAzBFBST56ANHkTDytQy4AAlvABZAAyAGEBkM8zACwCHTwimUPEQkvTPUGPA6ERa9TxjE7Vuy3ZkuTz9SJfZsXHBudRraHw5s5y6OUvqLGe1sIOQANa2RBnngeADM5QAnGBygAWMCVQLkcowABsADs_CBIBn7oIE74Pvw5AwOQYDoA-ABMVTvs-gGAUhmB6JU5DoHoACs_CVPhegPs-D6BARBHPkh_DlAR_4wIED6AQ-lQwO-BHkARMDAWAvH8IRSEwAxeh_g-_7oO-77EbRYCAeUgj0Q-T6iRRBE4WASEEegz4yYE_BgA-77oJUghmXo6BEXoYCBM-kHIZp6EwDAz4AVU_56DpKH_jJUkMSBXniYEejvpU5QfugdnPugSECc-lTPjhgTMeQoXuTAej-IBBHlF5MCseQ3l6f-hmVGRPFcXoRnQTAeUwB43bxlweyYFAw75J4GhQP2ICEAQ8hwIgM5wJgBy_jgMAHP4sE0BocL-OUODKgoMBqhoOBUEQTVnn28ogIOnKbsuY4iBOeo-tQfopmSADyByDY9O4bluK5WFmtgPU9hZJMK_A2GWIBKJQZIeBaZ44JAGAGgalBWjaXCUDgRCHmscJcAAhK4IYHGi0PrRamOXSIM6RuK9j9FAUA1VeWxyJsIJcNgcGPetXD5FEqAwOoWglOKlCPfIz2OLo2ZTKu137noO4Gtz-SipgAD8ZQCkKiswKylBQOgGsq1wauuRrCO2nGVgQGA5ry8bdp3lw1tijgmrcnosA7rC8IwFOVj24yGs4Ac8joIetKaG9lrezwCLjiT06znCUAjJs1CwVslBuvI8hQEk9PiqLqDiyMRA2Okh7Zz6egGrdGjfcLBA4KgYqToScdcHoOcuAQ4gF_TTNUzTMGXrnXDV0jQvPYU1NtxT6AAFYHFk7Oc3QPOaMPjeYCMwzUlnMHrQ61e149AdB4erbU7TQ8hsVeoThHnCAsCYIQlCMJwoiQLyIP_DZjgs9wNQLEOJaD0EQCAe0IBMCKDRKaBkDxkCKlWqqNQ6oAw6iQI-HAKEsEeCRAOcM-oMHAjRLgX4u0QAvHWPcDwCCKF2HJDQjwX8zgwETjcdEvwuD-H8JQaB5C9AHGgOgRhIBmGwUTgIoRIwSH4GIFAXB3ZIE8yUDAaBmBYHwBoRAsRrD_ACIwLADQIiAB6y1yhIRwARch2x4CrCoSYgiOB3yWNwQiR-IJwSoEhNCRAHsP4UN0PhQwW1qCQGaH_ABqAgHUBAfiMBEC0DQwkDARsoN5AAAUZS0HIOIagNCCAaAOJrDwTh0AACVWGUEEHdVAzY5AF0akgApRTFEBhEXoGU-QXBGMBB4WgJIoCHhETo-RIA3FAg8S_HxfiYBIhAPcHEYSImAOQNiGJeIGAQO2vIaAmg7obGXPAiBbUjiNNvGs4u1B_7kOpHsdQzZZQFngTMxR8B6z7FOXyXEMp5D5MKcUihgsWH1gUDQl5HhMDkEGQtXJhDfHvwBZC6FLplwgt-W_T2ij6HZm9EQnM0h_zkKyGsHJfyWkeEFgQFQPTznpCyOQ7Aig1gFjhCoqgMKyTwOaQCzsEg2VkhdGSesthlJ2DJQCk5sAKkAKgI9U6RCN6NLwSAbAUKDiYBoQAbQ8IqgA-pKzRvTIEglxQAXXGU_Tx3iMWIgRAiIAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/session/consistency_between_updates/src/index.ts",
        "description": "Use the updateCallback to apply custom changes to the model after each update."
    },
    {
        "href": "examples/session/exports/export_request/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1dR6poozkuqr8cFxFef2og3DdJuOTPSbpqvNw5BoQ8gRc2Yp5RJToAK6wIXAa5Hmn5MZomLgEUyCsJitrG-EmiSmcJixQwiAAGhAEDgACE0PwNEkkGB-FAXABfIGXa4YbA4e5kEBUGh0AgMWKoCBEeSUDSbYAODQCWgANQgMHypPJAKpNJg0ngcAg1C4CK4YA0lCIXA8AAE4HJFItNMZVAz8poPF1UJwcVlMnR0AA5SjiSD9cS81xcAAUZlgZSya1QzVZNjgcH4zRgVoINuaAEouK5WFxgHERmAzbr9RBDTzUDhFBoiCDucbXCaAOTNDS6WjoZPegMiHioRlcUMQA38I2oc0SWCsymfMoOp0uvmelU8fkweEwIMhvUl8NlyPRzRxx2RrgAQiTXGTmCJMCzOcDPGLpfLOGpAEcDvACAAFYfxyOmz0YqIVmMjhPcX3-peiEtmi-HxMptMZ-fZ295qxcAv5Iu9quR4WjANZcHWXANs6XYIi2d5tnesGtnynAIiqnDGAAVJhcSYVwvi2I4WxRAK0BdoKwrEV2BwaFAXC6OgXDoJQ-SoFAlCCCMmyFCUVFcM0ah0KRsCoPwNg4LhXAAJLBvYBCUAA1kJIJcPIQrypg6CshIIzDAcLiMWAZL0QcJRkhAABeA7UBJ3A4XZXBivIkJiVwNFQJJTkuSKkAiWJMCec56YivJSmqnZxhqtQGpgIReC-GRADqEh4N4ilCSaQxJKg5BmoG7luh6AKBr5dD-YVaB2oGoV0BVtpcAAPr-Rx0SaqAtZw3o3rmPDukkX5WMYxgCnFXA8XgfH8KZeDmVZ5ZbOl3APmplAafOd7qps1LDJl-T8DpsUEI4pruTW8FcDgl3motXAAPz-o00SaHAZSUgAgtNs3WagZQ1dw_L8q9sGIXB4WDcNLqbCUXZ6OxegbdFmyw5Qeg-vRe06dtODI3ox7od-Q1MSxbEcYxEgI6gGp7JgUAJbAaOFBgLE4J4ABKAAyOCrOyADyegAFYwOQBBs-zpo46DVibVwUBoApaPMeQBw2DQXPUmWMAAKKwCrBCmh4_AeJLoiy6gCk4FkOQwDg6RwPIUD8P1JoeKg1ABSAyE8Kb5t4NSwYmtTHZ0zAnsy3LNvE-xnEmqVok2KH3tc7L5AKXjd6i-uMCqOlfOC8LoumonvswGAxv8oaRGmjAi7fuqlCwDg7HNFXZeofjppZTlZpdX6PWhMN3Ma_RXDyoyzIEIG0uj0yZKbLt-2bIPdIKuPpp9zwsxDGUivK3iOCQ9rMC66CSRSeg-vYgMQxG_RwwABLeAAsuzADCV9wIfuvFd-RRlB4RBJHpGPWeHhAxIUJDwQmS8uz2BcKOagk9EaangdedGC82Qa05Cgted5xAp1sIgc6HhAjkBgIEAAnJUMAAB2AALLQ6h5BqEAGY9DUP4OQ2hAAmch5R0DMP4AAVgAGxgD0Aw8oJDuG0LAOQrhzCmGVGYbQmAehhG0L0DAQRehMDUPKOUch6jBHoB0WoyoQjKiCLAOUZhgjyDkPsaw8ggRBGuK4dQ8hriNFVGEZULh_ABHCMEYEahYByAMOscI8o5BhHkH0fwgQ_BAiBHKLQ4xKSrHMNioI8odiuHCOYTAfRlRDF6H4LQkpzDqGhPKPwWE5AwnUK4eQfoBjgnoA4eQWxlC9DKJoVw8oehyBcKsZUXx6AlHKPIII_wiTBHMMwPM9AgR0CeMqNQrRlRaHlNiswkJdSYnoA8N_KwgcoBAPyJ4Wif8QCEAIPIF6Q04CYAOHEnAMADj-FITQdMUB_DlAtlKecgkNBc2FMcu8v9RQgAAVgq8oCRDgLBv3Lg6tGKUFMnxbA48xopT4nbIWfZcpxwCiIaW2LZ65yFnPZBV5962E1lgceJ9tT-Qvoy8ezClCP32B2I2ABtSoABdfGkDhqbm3BqaGXAKXkkQZTLa8Ajg0v4BjTYsqCBUuFpnLcO404iAfKabayqwW4hoFwAAZBa1FSqoAEFNbQGggqhU1yltFeu1sm5GttQQY2G8kGx38mjAABgAEmAMau1OBA02ARDgcNkb7U4kdQQZ10ayREDLAiYNodDqOGDslEoaUwrergCa5NeI03FzAKyGNoFaWDn5vkAgxa6BlxlZ2AaogXAYBXP2cs7KmWzwFPtWARzAQ2rLVGogcBmjjlbqgWC-rATAjBBCKEMI4SIiBM5FO0EcD8zgNQLEFb6CIBAAGEAmBFBohygyB4yBxSSgUMC9QGg5QKiVEgDwzCcADL_R4JE_99qqm_cCNEuBfgQpAC8dY9wPCPpg3YOVYGgqkLojcdEvwuD-H8JQG90G9AHGgOOwhIA0MdnAsRqAZMIP4GIB5EAQGr1ZyUDAG9s5yD3oQ5eijfyiMYFgBoBDHgAB6ALyhcJwII6D2x4CrDgyJkAonBE4FodJwDCIV0gnBKJDdiBYSdiRDBhiBhcA4kgM0A9R7UAnuoCmhgl60CQCJLQdmlB8O7iFLQYWkYEPum3MVW5kJ0Csw7KTHmqAX5yFtO7RAAXQIeGnkpvQQp8guGE4CDwtASQO1oEpvjgHtNrr09CAzW6YDGfuBZlo1nj3IGxPZvEjmPBUBJGRDQPMNiRgfZe6mRw4uteFHsVAh7oPUj2OoF-w28QPsMy4IL8AeWHFgFJXEQp5D-Y0IFjwR6aKkMfgoBD83EssfIA7dM5ZjsVaC5gc7LlyyHc25uzsQXkOQyU5raQwjoPWnDBPJACWgsYoICoTLZHbYA8W0yzQxI8RwjY1QS7ZIH1A48EfCQiOyRljJI_WwggyyG0B9t07_XYBhaPVAUyfmwOu0wIB6H52Dj06QPyl2vKAD6ZP4DQchx4IVWmgQ6fXWVk7CJxdAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/session/exports/export_request/src/index.ts",
        "description": "Request an export."
    },
    {
        "href": "examples/session/exports/export_request_download_with_JwtToken/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1dR6poozkuqr8cFxFef2og3DdJuOTPSbpqvNw5BoQ8gRc2Yp5RJToAK6wIXAa5Hmn5MZomLgEUyCsJitrG-EmiSmcJixQwiAAGhAEDgACE0PwNEkkGB-FAXABfIGXa4YbA4e5kEBUGh0AgMWKoCBEeSUDSbYAODQCWgANQgMHypPJAKpNJg0ngcAg1C4CK4YA0lCIXA8AAE4HJFItNMZVAz8poPF1UJxjAAqdVxdVcXy2RxbKIC6AwAVCkUlU0HDRQLi6dBcdCUfKoKCUQQjTaFEqG03NNR0Y2wVD8Gw4bVcACSYDtW0oAGtAyCuPIhfLMOhWRIRsMDi4HWAyXaDiUyRAAF78cTUcPcLV1rhi-SQ0Nca1QCNNlsiyDB0MwTvNjStggJuja4ycHFZAX6vC-E0AdQkeG8Y-4rjtcCSqHIXAAFHE2zaylk1qhmgCj726P3TwRz5ej6PE6h74-uAAfLioI62ze_lAHaoAAlFwrisFwwDPlCUFHjwxjGLOBAGt6eC-sWpZrJW1bcC-SYxqmlDpjA6DwQ41AztSwybvw-T8NmYBzvu7astBIhWDgXH7vh3AAPxQY00SaHAZSUgAgiWeBljhPJvnGr58kpYkIiB5GqSq5GIVwzS2Bhehuno5HTpsBmUHo4F2vR2bUTgZl6PuIGaRxoRIU6Lpuh6EjGZRmx7JgUALrAlmFBgzo4J4ABKAAyOCrOyADyegAFYwOQBBRdF-72U5PmoDOUBoPGllOuQBw2DQcXUlWMAAKKwBVBCHiA_AeLlLmFag8Y4FkOQwDg6RwPIUD8EklkeKg1ADiAKpWJ13V4NSMabv5MCBSas2iPNA3Oq67oOpuN4hjYm08Nt5CFeQ8aOadXCZTg1KqGOSWpelmX7tti0wGA7U8Py_Qoeh-4wGB7FWNOlCwDgbrNMDv18pwCLOfuQw7nujngZBYOuWyNWxvKjLMgQR4mVwBNMmSmy0dZmzxTV9KE5T-7YzwsxDGUpXlXiOC6QQ9UwI1oJJJG6DNWzDxgUMXAABLeAAstFADCAxDPzjVXi5RRlB4RBJAzFPkh4R4aYSCFISUybJvkUTUlwSSUAcjT8OocaZAc8jDWN9vWlwyX5AQa6KXAlCGlWR7adm4xcHoVr5gKRaWpkXJybjuF2hgGHYETXDUgAjgc8DEyI2mEAQ8iiYhURQPIPVSqRAYaHFwrGKVxi6cKthQv4ej8FddDoAAxAA4jAHcPkkoK96-6D-JJWEVlWckk75vv-4HgabkbM2mzjdO0LGLhwNy1DL_lmyH8fG5WQxtPVbQnJH3JzPkeIfcEIg5E8B4gTkDAgQAJyVDAAAdgACygOAeQYBABmPQwD-D_1AQAJn_uUdA0D-AAFYABsYA9AQPKD_ZBoCwD_yQdAqBlRoGgJgHobBoCY6YL0JgYB5Ryj_3oZg9AzC6GVCwZUTBYByjQMweQf-YjYHkECJgmRSDgH_xkQwqo2DKhIP4Bg7BmDAjALAOQCBQjsHlHINg8gbD0ECH4IEQI5RQFcOsYI6BTFMHlFEUg7B0CYBsMqBwnuoDvHQOATo8o_BYTkF0cApB5B-jsK0egBB5ARGAL0NQkBSDyh6HIEgwRlQVHoCodQ8gmD_AWMwdAzApT0CBHQAoyowCYCYMqKA_gJCYDQO0SE4xZFATkVWlAfWngTyihAKXcuiBEJwEwAcUxOAYAHH8L_Ggw4oD-HKLXBQ9d1CNyoEQDwGsrB-wDuuPZogtZDN1g_S-RsRAm1VMXJC1UHQO02InLOlMuBoQwkNNKEBIB7mOgOEQpNXnkhemlKmSdH41l5rVLARMhYADl-zNRhUTaBSg5b7DWm1AA2pUAAus5M2OcYD50LpnWFlNT4zmBQQSK8AjjgrojfLgNLQXpQeiSguWQbo7wjjGS0ttkw4loHhEO7k9qCFZExQGnojw_IPDSulcAGVN1xDQLgAAyDVLKKXkiVSq4VeJcV4tBnlGcR1-yWQAAYABJgCKvpVAAgOALU2ARDgO1DrlVOtVSKggxqXVkiIFWBEVrbrSscEFGAy4Sjr1QMDXVtLHXOsNTQANX0wBSpNP81kBy43w35GtFwcEXIQyhjDBNRN9U-qIHAZoBbEYgR5agQEwIwQQihDCOEiIgTNiuvwXSOBkrBxbcgbE1A_UMGgiATAig0S7gZA8ZA4pJTrJlBoOUColRIA8NAnAaT90eCRDrBiqod3AjRLgX4uyPAvHWPcDwy6QBZEhMTc9Q5f62huOiX4XB_D-EoHOm9IA9AHGgF0j-IAP1rWjmBqADpv1XuIB2EAx6Z0wFUEoGAc7MALvgI-6d0HlmgYwLADQj6PAAD1VnlCQTgTBwHtjwFWPeijIBKOYJwKA-jR6EStpBOCEMnbECwnhDAJEz77QGFwDiSAzQh0jqxKm_EiAQDTrQJAIktBoqUEAwABSFLQdKS8kAPgLleYZkJ0B0s8ugBKqBFZyAvNNRAZmYAWfJmxvQQp8guHI90kAtASQjVoGxojR7-PtqE9CET3bxNAnuLJloCnqBKYnXiKdHhtnyBNBoBKGw5JLunf5I4LmsvCj2KgYdwHqR7HUIrCreIl2iZcBZ-AGLDiwEjLiIU8hH1uYs8Ha0v85YKEfS19zHhMAXRbLhcbcWLPTZGsOXCo2-tdrExZuwGheZsdqtIbBwGzwQHSv1jQ5mPBPJUP5yDg031tdhZoYkeI4RYaoCtskS6BseAFhIN7ZIqxkjlrYQQVZWqmfO5NkAJXYBKshiWEzkHJqYCPQ9i6BwUdIGxRNTFAB9GH-GAt3Y8HivjQIBMdpixNhENOgA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/session/exports/export_request_download_with_JwtToken/src/index.ts",
        "description": "Request an export and download the file with a jwtToken."
    },
    {
        "href": "examples/session/exports/export_screenshot/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1dR6poozkuqr8cFxFef2og3DdJuOTPSbpqvNw5BoQ8gRc2Yp5RJToAK6wIXAa5Hmn5MZomLgEUyCsJitrG-EmiSmcJixQwiAAGhAEDgACE0PwNEkkGB-FAXABfIGXa4YbA4e5kEBUGh0AgMCBEeSUDSbABUXCG2iUADUuGANJQiFwPAABOByRSLTTGVQQGD5TQeLqoTgACkYuhShQwlHyAEocNJaVxXNSaSLODispk6OgAHKUcSQfriaiqrhisywMpZNaoZoArg2OBwfjNGC2gj25ry1WsLjAOIjMCWw3GiCmiDUHCKDREEFwaPcVyprgAcmaGl0tHQ6b9QZEPFQAq44YgJv4ZtQVoksCdwC4nzKLrdHq4CPlIp4CK4MHhMBDYaNFcjVeTsc0Cddya4AEI0-nMKh-XmC8GeOXK9WcBoYABHA7wAgABSnieTYsVJToYrj06T5tcAcLVh4Fct94vT8XWZzMDXQMNzfEt8jLEdt0va0YAbJt9iSFt4DbQdO27N8EWA1Dgww1AEU1VBjDJMk4gpXxbEcLYonpaBBwZJlKMHA4NCgSkMC4dA5VQKBKEEEZNkKEoGK4Zo1DoajYFQfgbBwEiuAASVDewCEoABrMSQS4eRGT5TB0CdCQRmGA4XHQekSUpA4ShJCAAC9xxjEjZNZeRISkrgmKgJyXOzZlIAkqSYC81zmWUtTRW4MljC1agdTAci8F8GiAHUJDwbxVLEtUhiSVByEtYMPK9H0AWDPy6ACoq0EdYNQroSqHS4AAfLhUCOFi1VaqBPNQP1nyAkRvSSfqrGMYx6XirgBLwIT-EsvBrLs6stgy7gPy0ygdIA4DtU2Pdhiy_J-AMuKCEcMUPIbYCeBwG6rRWrgAH5A0aaJNDgMpGwAQTmhb7NQMpau4Xtew-ztMK7WIi1CMaPU2G8m24vRtpizY9ERi1-EOgy9pwNHKD0K98JGsaOPyLieNMiRkdQHU9kwKBEtgC0ZVJnBPAAJQAGRwVYBFoAB5PQACsYHIAgOc5sU8b0CGoZ2rgoDQFSLQ48gDhsGgeb3KsYAAUVgDWCDFDx-A8WWrEV1AVJwLIchgHB0jgeQoH4Ia1Q8VBqECkA0J4S3rbwPdQzVOn-0ZmBfYVpWHc47jeLVMrJJsSP_Z5xXyBUwngIl3cYFUDLBZFsWJbFVPA5gMBzY7BwqwosUYHXOWYsoWAcG45p66rnC8Mh0auAAYWodRSSE9Aq3sCXlspLhQXR_Gi4IaKac2Me7Al5TZ_xi0xVX_gJfq31_WG6HtGdgz4d3rhJ-U4TbCEvQhhgAA2AAWdjx-DeXIS0NVd5zp3FZGw8CVEAVd5YJhsBjDQGgADalQAC6OAiC1zwGKYwiAxQ4DJA9Lsxh5RzhgeUeBaF5Z6DtMzG4cocBVnxmKb-hD4Gy2DLATYKYmx2jbnQZoJQSEo3coEb-FpQJXzQAQQIn1oGuzFD1ImJ9B4TE0HDKiegIRQkyN6KqU8J6iPEZIpIwZ8h4BopaVA_h_B-gOAI6BMDUDwItGQ70PMnCD0wJ9I2MjIY8D7v3bWtBp6bz0FweeotNh0RClRTwOiJHZn0SIPcBAmLcGEQEsUMDLHf3gbBbYnpnSEhQrLHu4U6FwBynlK8R9XwOD4XyAUxIR4HSOpsZUNItZ8xgDSfk-Q6lG0qe-dAZQPBECSB02pJJF6Am2gMIYZRGAAAlvAAFlOb9ymXAfWMBDasFVurPEOBYbrMNqCJIcl0DG2xKss2JURBYREPLFwM4nyUixk02krSdbSCQpeXpIx-kshAEMj5DzRQTKhuIDOthEBXT-QAdjAE_AArPweFABOcoyKYAACZAjIoxeUJ-lQwBgAAMwYqJeQPQ0K9B6HhU_Z-yK9CVBfi_fgL8MXkDJaSolgRAiVCJfCslhKX6EvhZgPQ5R-DlCqDAF-mAcX8ECOKoV5QBDIqZS_IlqqMUP34Bi3V8LyCVH6E_B-mK9DkHQCSsA5ByiwnQBi-FMrSWBFxYESlAi9DIswAIplRLoVEr0DASo5QMUyvILCeFgRWU6rAOUKl6B6XcrldC5F_ByC4pDTyl-ZqYAwCJZUPQ6BoXYvIMa21YAI0Yuhcm1l_hyDmqJf6jF8bc1gFdUSzFBKMWVGRdioltKGV9vKMA4CocoAjPyJ4ZiAyQCEAIPId6o04DoA0NCmABxrU4DXbWvE2YoD-HKDbTkAFRIaB5kyYd1ymEiD7rzHW089CWWUuFHgpDH2PO2YbN5tADl4jOQ-ggT6zZoX_U-nAaASwaHmUsi0Hh2YHiPDqXWWBumTVStoXmdAORGmFMGEDMZbat2JEmJa7sQD8DIS3Sy3tgNvtQDbbIrdlLyBgyASoOGRAft2Z8ah8hFAYH7kYqApy8MeOfSfQQpk854ijlkOgQoRAiZwNQcg6dlZZRKblS0vUXzAT7nYNSmQMM03movJuy9DN7kwyZpQ48LQ1K6WMvZthpBGaw0bKuXixpgHMi7DQHotAvBzdwJMNl4BbH4CpTR9hAtWaNDXbg-nBxwCZIOcQNhgKY0aS1UsJ5GTThgGKMUe0W7qG07qAg3g8mUEskV-AJWYIVEqPKK9xMB5D0UaPWz19KD-LnsLEJ1MdQxdQLII0n0wTo1_uPdelAUnDbczZuwLXRB9w-UowcgwoBHiCaGeGZV3LOwpppYKthNBT3hvNkzg3NiXaNCeE7tAf66iBU508D3NBHP1AFY2UMeAeFu-M4C8o4F2KpM0nAclw73Z8qdjQn15AQEjgD6HAVHs4E29ttUw3RsEHGwEyO8syqeEO4IE5GNnkWaC25lHNg0cHBJ6c5bnmuB7kPMeIS2BunXcp7FggSGUNY8-TGfZyGxmfe-_91zV3QEg9kS-vhe0jibAaQZAH_PHOs4Qz0qFMDkfvdPUnGA8CyhE4Zyc8GkcPy1bgErs9uIaBcAAGSO5Z_AW3OJaA0BB43N8VSaYt3tu3a3SuPOiEJzRQ3FoAAGAASYAiuoAEBwInAKCIcBx4T0nj3eIQfJ5JMgggCIo-Rx4CdRw4cUolHSmFYPie7ee4ILn8uYAnQp5sE6e5j46NC3yBVlaofez9hcMfKwLgMBbjHNWM56uR6whougYBrubd16IHAZoc4B_YRFJ2LOqBATAjBKo6EiBYQDiRCAFyGd3T2yFslvfyBsTUAbwwIMIBMB8eXOQfkDxkBsg5AoY9YeXkTpIUJADwIlHAXFSAjwJEQZI6YFSFYENEXAX4YdEAF4dYe4DwX_dAuwUkbAjwbycgfsEYZA_AYgFiMxSgPjNAh9aABfMAi_SEYgliOgoTUg24cgkgGAkBTAVQJQGAD_OgL_eAbA1_Ig_sfwB9DAWADQAgkAAAPQPWDRwHhTQOyQwI2HkIUPhRwBflUJgIRH3xBHBEkihBhDhERGRF0HQAMFwBxEgGaBwFv2oCxGz3oEQBAFfzQEgBXFoE5koGoNyyNBCWTGwO9CPBAScHQDgzjnQH5lQAE10A9HCI0EiI8Hs3kL0EZHyBcDkImRAFoCJBdloHkIkM8hACMKBBMKPwsLPyBHuAcJaGcLvzcKfzxBfw8CoCJBog0H5g2GTB_1fzpiOG9kQO6L2FQFvzQL3D2HUEHiIENh_1PxcBAXgAWX2FGLklxEZHkFSPSPQOqzOBgAWQUGwJWJgg8EwBU1cmrHOMsMuLf1Fl8z-lOL2LqNWI8DwNhnkN1mkCfjQLtEjHGUQAiMeOqwIBUHyMQMdnGTWOQ00DyRoDhAEKoGzGUmcH2MeI2QkFRJJBoQ0AWVsEEA_iQDBJARGNgDg2Sy2zuMYM9kwB4I8GwBUwOEZKQBgQ9n2BgAAH1KTRCCjYSPB4EqiD9TDIRj8LiERpSgA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/session/exports/export_screenshot/src/index.ts",
        "description": "Trigger a screenshot, provide it as an input to a file parameter and then export it."
    },
    {
        "href": "examples/session/exports/file_upload_before_export/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1dR6poozkuqr8cFxFef2og3DdJuOTPSbpqvNw5BoQ8gRc2Yp5RJToAK6wIXAa5Hmn5MZomLgEUyCsJitrG-EmiSmcJixQwiAAGhAEDgACE0PwNEkkGB-FAXABfIGXa4YbA4e5kEBUGh0AgMWKoCBEeSUDSbYBxBwaAS0ABqEBg-VJ5IBVNWtJg0ngcAg1DZIgAkr5oDAAAqQ_g2WgaACC8ggAp4zTomjhAHkNnzUHAlVwADLqgDiRsFADkjQB9fUAUTpNv1nARXDAGkoRC4HgAAnA5IpFppjKpGflNB4uqhODispk6OgzZRxJB-uJqFxXFwABRmWBlLJrVDNAFcGxwOD8FV5ggF5oASnTrC4lJEEDAWYTSYgKe1OEUGiIIN5adcI64AHJmhpdLR0GP682rKgmVwO62u_xU6hsxJYMXgFxPmVS-WVVwEbWIzxnTB4TARm3M6vkxue32B2XtVwAISjseYIkwLO85UjwT7rpuOA0gAjgc8AEGKmjvkOW61hiURbm-g6fq4jYLlY95ZphH7Dr-k7ToBc5NiB-FLvkK6Jmu3bUNu5h7ge-xJEePIVne56XvhCLUXxVKCagCIRpwxgAFRSXEUlcL4tiOFsUQuqKLpuh6JR3gcGhQFwujoFw6CUPkqBQJQggjJshQlCpd7NGodBqbAqBSjAOByVwgptvYBCUAA1s5IJcPIbrBpg6DFhIIzDAcLhGWAZIGQcJRkhAABeL7UJ53CyXlXBevIkoerpUBeUVJUuXQ7kVcVU5aYFdBycYUbUDGYBKXgIqwAA6hIeDeE13AZkMSSoOQWZUmVVY1nqkCue5s1oEWVL-UFqDLYWXAAD5cKgRz6RmB1QOVqD1jhVEiNWSRXVYxjGC6XVcLZeD2SlaVrFlm5bMNBFhZQEWAdR0abDSwyjfk_AxZ1BCOJmZV7tRPA4Kj2Z_QA_E2jTRJocBlPusqpXg6XfdqZTrc5zrOgT55CRehL3Y9KqbNpB4WXoIPtZsegc-mBlQzF4M4LzlB6JmDORiIPAPcZpnmZZRkSFzOqbHsmBQD1d4ZoUGCmTgngAEr6jgHIbjA6p6AAVjA5AEEb-qZqLeiS1YoNcFAaABfzJnkAcNg0KbNLmzasABwQmYePwHiu6InuoAFOBZDkHnpHA8hQPwt0Zh4qDUDA4bUfHid4DSbYZurN5a_xPDFzgJlmRZVkZgtNU2DXHte6bnvkAFEsdw7kEwKoTWWzbdsO5mdelzAYCx86KbKZmMDAdLDjtZQsA4BZzTL_PToSVuY0TVmF24VSKpLlOUCapucDb5QzSOYW-rDze_OGia5pWra9om0oNpQSeCNIfGWj0za0AMlwYMTIWQEHZNzaBIY4H834ILTYECYAMlgWSCOeEeCzCGGUX2_s8Q4BZqHGA4dQRJEFOgSO2IBhDBjgZYYAAJbwABZfUABhJhcBKHhz1DwIoZQPBECSNg5kuCPAiVjrLTBUCXDESlgQxByjkKoPQdSTk3IVGZnwVsLsQUCCIGRp6bEAA2AAnGASxABmSxAB2AArNUFxMAXH8D0OUfgMAAAs_iPGWPIDAPQgQnG238fwbx6AgnWMqAAJj0Ik_gYBknkCcfwUJkT0B-L0I46x5REn-M8dYxJLj0BgH8eUEJLjqmVHQOQfxlRyj-PIOQexiTAj8Bcf4np6Byj2PQK0-x5RZ5gFhFUWegQXHkHQHElxYz-D2KcfYvxnVrGWMApk_xlj-BBMqIEcg5RKlgECIEdAiT7H2OsZU3p_inHWJidci5_j0n9DAHoPQ3jJnlCqHEyoTjfFOP6Xk4p5AvGJK-Q4vQ0T_CWJqekrZ6AXHWIKUs7x4ywDkASeQEpsJ0BOPQBcjwwiSz7BvFIzwekxEgEIAQeQ-MHpwHQBoSJBwTk4BgAcfwoSaDX38OUJOfpAJOQ0Kbd0ZLqKiIsRIvRyFZEiGEqo0IzNbDvVbiMVA8hUqhRKrYMMIh3at0FDq1KEoGqGq0BmDRPYWaWvcjKGhZp3KRzXh4QURAeLeRJDIkAVJawAG1KgAF1WHeS1o66Umh5QQFAWqj2itMjujvHkuwCDVZcHBkcTYkNoabHdVYNBBanpwzwAwhlTLEAPRgaGCVvoFBivUBKqgRAgz2OMGReQeAuxwGMDvSgvZCwx0DSLDm_dGaJpcKzVSgwoCwS4JQNsbMtVoF1fAkQprzXwQNTKHA87F0ZhzVAAgCbZYHAzsm1d6lvUHThFAJIVJZYlBCvkSgRwjJ537A-26eg03521e9O1OU_ZZHdJlO8_RTqZo6qKTwV7BB0K0aW7dG7o3WpwJepu9DJbPsejO96NJQlOUSvBxD6BkNoHetgFB0FYJZHwzjGkXAkgfocLoAy8JKCxk2ImKIWh6pOs0NAuEDGI2hhgyIF9vbhgPtMsMfy-1ExyygWB_yA4yZpno3BA8s8yR3jZrRmRxrEHg1JDqbWAtS0gdQOQ2wNosBwJdW6z13rTyObgTHENoah4wTggY6iQa0MWr3ZoHARRQ1lFbghnDdC5EJtbFmcz7UPI4loDQLgAAyLL2b4AWZcJK3ENAfOrzdhvLeO9MwnoILHNRWbW5uRsPzAABgAEmAClyzOBGvuQRDgDrXXCvpbxD5nrZJvUEARC1jusNHBa36iUIaG1qv5dS0VjLBAxszzAMWXrNhiy2ZwFbfIBBlt0HnlwG8Lg7qiBcBgMCTEtweE87gl00NYDoDJXl9O62iBwGaF-feYlayTtQICYEYIIRQhhHCREQJiq9x4sduA1AsQjfoIgEAlIQCYEUGiCajIHjIG9I2_04qgwhjDEgDw9icCJOFYkjwSJxHQ0jDT4EaJcC_GlSAF46x7geBJ3zuw5IhceHqqE_SNx0S_C4P4fwlB8e870AcaAX2OeS_fqr9X2rbj4GIOVEALPcfDyUDAfH_5yBE6FzjrXUB_Cq4wLADQ4uQAAD1hXFJwC43n2x4CrAF2793LicD-J98zhEEOQTgjcjDxAsJbxIj54ZAwuAcSQGaCjtHyBsTUE2wwHHaBIBEloPqSgSuxRuloHbbUQvqywTZPSyE6BDY3kVuqVAPC5CFgLkgBvMAm91rd3oN0-QXCu8BB4WgJJM60Dd_b5n0eodx-hAnuHMBk_3Azy0bP4Pc8Y_xFjnHbaFQu9vtqYnOP1ZHD72YvPRA9ioCtg8JvNI9jqB4e6cOxPE8uCb_AJwvsLfmajKErvXhoI3h4KjrpKEpwgoELn_oPh4JgOQJnFOJuIgRvk3qgegdlKgPAfIFgbeE3qLizG7jaNIJYrzvmF2PAv3pAcgSAB-gQCoJPvfmnPQQAU5poMSHiHCOblQBgWSMTgPgAQOKwbbGSBuGSJwrYIIBuNHAwVASADfrAG3qjgupgRznnJgMztwWgQcHoUgEGrnJSpaGofALzpwR4KGlHkCDHtDmvkgQiK4UAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/session/exports/file_upload_before_export/src/index.ts",
        "description": "Upload a file before requesting an export."
    },
    {
        "href": "examples/session/exports/mutliple_export_requests/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1dR6poozkuqr8cFxFef2og3DdJuOTPSbpqvNw5BoQ8gRc2Yp5RJToAK6wIXAa5Hmn5MZomLgEUyCsJitrG-EmiSmcJixQwiAAGhAEDgACE0PwNEkkGB-FAXABfIGXa4YbA4e5kEBUGh0AgMWKoCBEeSUDSbYAODQCWgANQgMHypPJAKpNJg0ngcAg1FZsgUyjUmgASvBSagXABRLDMzYIrhgDSUIhcDwAATgckUi00xlUDPymg8XVQnBxWUydHQADlKOJIP1xNQuK4uAAKMywMpZNaoZqsmxwOD8Zowb0EX3NACULtYXGAcRGYHdtvtEEdPNQOEUGiIIO5ztcRa4AHJmhpdLR0CWYwmRDxUIyuKmIA7-E7UB6JLBWZTPmVA8HQ1wEVGTTx5TB4TAkym7a30-3M9nNHmg5muABCYslzBEmDV2uJngttsdnDUgCOB3gBAACqv85m3VGMVFOzm1wXuK443WrDwrbup-T6Fju5aVgeNbxseAGNvkzbzmez6ejAvZcP2XCDiGM6juOAEIrBeGJoRqAIianDGAAVFRcRUVwvi2I4WxRAq0AzoqyosTOBwaFAXC6OgXDoJQ-SoFAlCCCMmyFCU3FcM0QrcJAsCoPwNg4HRXAAJLJvYBCUAA1nQIzDPISr6pg6CshIplcAcLhCWAZICQcJRkhAABeS7UJp3C0f5XBqvIkLqfZfFacFoUqipdDqTAkUhRWKoGcZpr-cYZrUBaYBMXgvjsQA6hIeDeEZJmukMSSoOQ7qJrxUDhpGAKJrFak2E1aD-omqV0J1fpcAAPlwqBHPxrqjVAUCcDGv4wSIEZJPNVjGMYCp5Vwsl4PJ_BuXgHneR2WzldwQHmZQlkHrB5qbNSwyVfk_C2blBCOG6DW9rBPA4D9HonVwAD88aNNEmhwGUlIAIJ7QdPmoGUvXcPK8oQ6ORFjoSK1raGmwlDOegSXo13ZZsBOUHoLoCY9tl3TgZN6C-FH1qEa0iWJElSRIxMSpseyYFABWwJThQYKJOCeMKAAyOCrOyADyegAFYwOQBAS5Lbr0xjzM3VwUBoIZlMieQBw2DQMvUu2MCSrAZsEG6Hj8B42tWPrqCGTgWQ5DAODpHA8hQPwS2uh4qDUAlID4Twbse3g1LJq6fNToLMBR3rBu-6J4mSUJrptfFacxzL-vkIZjOwerF4wKo5UK8rqvq26RdxzAYAuyODjtsxbowEeOvZZQsA4BJzQ9-3pHkYSbpVTV7qzX-iarWyVsCVw-qMrKia6-vTJkpsD1PZsstW_SG9726_6iLMQxlMbpt4jgOM2zAdugkk2noA72IDEMzsCcMAAJbwABZSWABhH-cBn52xaszIoZQPBECSKfXe5IPAkW1ovNax9aCrxcOuagW8SaWgIT-Kmh9l60E5KQi-sFxCl1sIgL6qoQAAFZKgwD0AAJn4FwgAbOgdA_B-AABYADMXD-jlECFwwIgQ9CBH4OULhHCwDlAAJwiNhGI1hegFHlDETALR4j-AwECOo9AfDWEAHZ1HqPKPwQIViwAWIELwyoSjyCBBERwkR1jyDoDAAIvQ5BKgaICeUPhpjyisP4Oo_gfC9BiP4NY9A9jrFcK4SI1hrCuF2MsXodAeS9DlDAPwpJYAwBiL0NYwQwjyDlECWI9A7Cql6FEegMJHjWF8LCYESogSwCBDANY7J5BNECMEHoER5RIm1LEeI8oMBMnNL4eopJXDRliLUXw6x_hdETNYS4nhlRyAuPIFwnRCiBBiJicIvQpyWkeFgVYJOUAUGeD4ggkAhACDyHBqtOA6ANDWJgAcBpOAwX-HIHiCsUB_DlE9lqA8QoNAy2VM82C8CWFIOod-dBIhiLpR4EvK8N4LR4y4NgWUUwRC6zukcfe5DbL4O_FXa8t5pQ0toczHg1K97gy4AAbWYTwVly4n4yj3m_a08Uv7aSIDhLgXK97OyFZUAAujgIoLyAJiq5BK2wKryQyrlR4OuyqpVoJAFGdVWqijMI1bqqwSV4q0GcBDUVXBJZ0GaCUMoXDmGkQnJgkQzktBul1vy8kH8RjcAZVAAgkKrX3D7lYKNKbRRwEZZTBNSbo33CFQWj-Gr_7aGRSodQGgs3iilCmpmVggI90zfARl6LcQ0C4AAMi7VSlt2bE3ttoDQO1aaALmkHj7EezbZRZsZe3dNxD842EpgAAwACTAALXOwdy6YAIhwJu7drbB04mHQQO1OBw2KoIAiVdaceAvUcCnYqJQyppRnXvHdSaz14kvS3MArI92snFb5RW-QCDvroAujuU4XDLQAi4DAp5Fwdi_sazYsJ2LoGeX22dJ6k1EDgM0TcMHg0jk4KOcuqBATAjBBCKEMI4SIiBCFUuOEcCKzgNQLEv76CIBAAmEAmBFBohqgyB4yB1SagFDqDQeoDRGiQB4MROAuGIsDSAJEiCnqmmU8CNEuBfiYpAC8dY9wPBSdM3Ya1TCQBJRhfxG46JfhcH8P4SgomTN6AONAHD-mHNTgwr5qAQlnNGeINNLTLVhPVyUDAUTe5yAScs0JwL8KfMYFgBoSzHgAB6iLlE4FYSZ7Y8BVjmdyyAPLrCcAiOKx4BECJaMgnBGpRjiBYTTiRKZwSBhcA4kgM0Tj3GaPIGxNQc9DAhNoEgESWgktKCebvEqWgqtMyWYjDeGLTh0Cig5ugOWqAwFyD9BHRAW20IeB3lVvQSp8guBy4CDwtASSB1oFV9LjWWv0fa9CTrzH91AnuINloI2ePjb4_iATQmqAknYhoOWGxMySaE3zI452PBw72KgLjJnqR7HUGA5UdtJNdZcDF-AwD9gY-0riJU8hNsaG2x4bjvEYXAIUJZ8nV3YvkEDhWDs3PAcxcwPz0KHZOeM6Y9OGLNmcZVclNIPhJmfTpgIEzlnIBKBuRUE9uzfsNfPZANSzQxI8Rwni1QQXZJJOXcp3mAgVuyTtjJMA2wdS7Ca95-j2AWbB5uQ2_psOmBGuU6wPzg4oekAipACHmAAB9X38ATOG48Bq5rQJWsMf-zzprCIgA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/session/exports/mutliple_export_requests/src/index.ts",
        "description": "Multiple export requests at once."
    },
    {
        "href": "examples/session/initial_parameters/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1dR6poozkuqr8cFxFef2og3DdJuOTPSbpqvNw5BoQ8gRc2Yp5RJToAK6wIXAa5Hmn5MZomLgEUyCsJitrG-EmiSmcJixQwiAAGhAEDgACE0PwNEkkGB-FAXABfIGXa4YbA4e5kEBUGh0AgMCBEeSUDSbABUXCG2iUADUuGANJQiFwPAABOByRSLTTGVQQGD5TQeLqoTgACkYuhShQwlHyAEocNJaVxXNSaSLODispk6OgAHKUcSQfriaiqrhisywMpZNaoZoArg2OBwfjNGC2gj25ry1WsLjAOIjMCWw3GiCmiDUHCKDREEFwaPcVyprgAcmaGl0tHQ6b9QZEPFQAq44YgJv4ZtQVoksCdwC4nzKLrdHq4CPlIp4CK4MHhMBDYaNFcjVeTsc0Cddya4AEI0-nMKh-XmC8GeOXK9WcBoYABHA7wAgABSnieTYsVJToYrj06T5tcAcLVh4Fct94vT8XWZzMDXQMNzfEt8jLEdt0va0YAbJt9iSFt4DbQdO27N8EWA1Dgww1AEU1GshiSVByEtP1nyAkRYE2PkBWJUkLX4fJ-AkdUcFWARaBpfl8joggxVfUQijKDwiCSLjaJJAgPABYDZiGMpGAACW8ABZAAZABhAYhgAUVgGwaFYdBKHIA4DIIHAPQIPSYHM0EkgASXQMUPDkh55Wwrtgyo3UZyfSkmJY5UaTYvcqxgaQkMvAT33QYSQFEyK_NFQFgPEcgAGtbEQYCeA8AAmfgAE5An4ABWSo9BKsByAAZgAdn4AA2MqmvKfKYHKIr0HQchynIJqmsqfhylq2qyvQcoBBgPRyEqIryqKsrOs68gYDAAAWDbKg6_h6rAfKNtq_KyvIQJtr0PQRqmpqivIMAyrKoqmtqjb6vy_KFvKJqNpgDr-nKDawFqorKg2_r-BgNqNqavR0DAdB-D0Y7Ktq8p-HIdBGsqer6vm7qhsqQJKmW_LyjKsB6qKvRNsxonibW9B8qawJPsqWrAjKvQmvQBaNp6_hWZgamMbK_L6o5iWNr0fn1v6fwNrq_gkZavrAj0GANuagbNsK2ryCq_bXv26TgL2TAoHE_JPA0KB4sIAh5DgRBjGMOBMAOPqcBgA5_DWmhsygfxyhwDkFAAtRNDYplTaLEYV3EOET0hfgbFoDQaThI9nYot8uGXJNsni4IQEwzz8J4FwMC3MdqxckAHITiA4S4ZPszTzQHidAADNvU9sTQuEzqAjzKAASYAXGSyzbD7juNHs_V-_rguJCSDx5QAbUqABdHBBhHmAEW7rzcPlK8RUBYEwQhKEYThREgXkDGMvdGAcAAKzgagsRxWh6EQCAIMIBMCKDRMRfkDxkBsjDlySOGheTcSFEgDwtUcBk3QR4JEIlmIpRysCNEuBfimxAC8dY9wPDQNIXYUklCPDPzOP2eOtx8DECgFwfw_hKBgJIXoA40B0B0JAAwta7C-ECOYeiYhIBsEgJgKoJQMAwHLnIJAyhwCRH9n8HwjAsANBCIAHoh3ajgMqJDtjwFWOQwxZUcAbVMVghEV8QTglQJCaEiBYQDiRKQ3Q6ADC4BxJAZon9v6oF_tQf--JAHALQJABOMA1KUG4SeRktByDVkod6I8MkQBOHQAAJX7JQQQAB5VAGk5AOhgFkjQOSPA0XyEIvQjJ8guH0alEAtAiRQHCkIzRUAsHOJvm4u-niH5HyBPcIJLRQk_2QNiSJeIGDAKoESaAmhSkbGTFA4B5sjg1JQYsogexUBfxIXuPY6gNJMnMlArxLhcnwBUvsA5jd07cNqfU0hlADiMJUgoShDyYIeEwOQXp2ZMn3wHLksFELxzUABfIIFEzck0KskInS0gmokLtJGKSSBskgpAL8ggKgOn4PSFkEh2A4yEjxHCRRVBIUkigUSp5CYyUwGZVWEkKlbCCCrPwL5xL9mwCKd_EeUL8GoH2Ic2R2BwUHEwJQzeHhZWYAAPpivgCQqlBKd5OKBC42-HjgUIgtUAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/session/initial_parameters/src/index.ts",
        "description": "Set parameter values that are already sent with the initial request."
    },
    {
        "href": "examples/session/outputs/data_outputs/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1dR6poozkuqr8cFxFef2og3DdJuOTPSbpqvNw5BoQ8gRc2Yp5RJToAK6wIXAa5Hmn5MZomLgEUyCsJitrG-EmiSmcJixQwiAAGhAEDgACE0PwNEkkGB-FAXABfIGXa4YbA4e5kEBUGh0AgMWKoCBEeSUDSbYAODQCWgANQgMHypPJAKpNJg0ngcAg1C4CK4YA0lCIXA8AAE4HJFItNMZVAz8poPF1UJwcVlMnR0AA5SjiSD9cS81xcAAUZlgZSya1QzVZNjgcH4zRgVoINuaAEouK5WFxgHERmAzbr9RBDTzUDhFBoiCDucbXCaAOTNDS6WjoZPegMiHioRlcUMQA38I2oc0SWCsymfMoOp0uvmelU8fkweEwIMhvUl8NlyPRzRxx2RrgAQiTXGTmCJMCzOcDPGLpfLOGpAEcDvACAAFYfxyOmz0YqIVmMjhPcX3-peiEtmi-HxMptMZ-fZ295qxcAv5Iu9quR4WjANZcHWXANs6XYIi2d5tnesGtnynAIiqnCmkMSSoOQZrejeuY8MYxhsmWXb2PKjLMgQgbqpslFMmSmwmvw-T8BIpF0gq1GmoRoizEMZToJQ5AHDYNA4C6BAAKKwOJBCgkkACS6Cmh4AkPN6QxcAAEt4ACyAAyADCAxDLJMDyQCd5FGUHhEEk9JUUxHiBkhgbEZx5GaqO1C0dQGouL515cKx7GbKs7KcsFvF3uI5AANa2Ig8GiiAADMej8AAbAALOQMCVAArDlMAwHoADsuXZYE5ToCVYCVYEABM6AVXo6DlLl6D1WARXkJUuWVJ16XpeQVT8AAnPwo3jZN3XZc1YDpUVPWDeQYDlDAK3ZZU2XlZU6XoGA6CTfOgRgNl2VVYEk3ZegY3ZfwMDNfwgTpRVhXPUV6V3eg2XTXov3lbluX8Llei5RVFX8BV6C5dt2V6JNFWjV1RWTZNgQwOQ-XkHogR6OQcPPWAh2TfjL2dc17WBNVNPlLdSPNdlRXbZ1YA0wjuWM1l5WBP4MBIzDq1FcNuVFTDlSBPw5DkM1ehgC16D8NLlTlJN5QeNZ357JgUBOfkngaFAdkgIQBDyHAiDEXAmAHONOAwAc_gFTQ6ZQP45Q4JKCjzmomg4FQRDazZ6Bmw50VXq5IjuaqIieR4UkAPIHJbaeKdq_A2CE1IEAcGioMMuihRo6ZJFwhQlKFUBQFwlBp_IafDCUZaNPw6hbFEXCYNy1LoL-2cwP5RebCrdip-nzE-Vekm2JPTcKUkWc2GpIDamJeiaMnYCcmWmkANqVAAushLgYCu_blmvShlvYC_N9rXAAAY6ZQ_5ELoFcuPvpddiUmgYAAH4uAABJgDj34A_AgQdqC0BoOOI-x8cCQIRM_OCqBYLHhVICYEYIIRQhhHCREQJ5CywStBHAAArOA1AsQ4ngfiRAIAAwgEwIoNEOEGQPGQOKX20oA4aDlAqJUSAPDpRwM1b2zUPBInsuxVUYjgRolwL8UOIAXjrHuB4XhGi7Dkh0R4MhZwOwjBUfgYgdd_D-EoBw9RegDjQHQIYkAxiCp1wcU4sxtwLEkFkdZNhMBVBKBgBw2c5BuE6NYW4js_gHEYFgBoFxAA9b25Rmo4CKuo7Y8BVhaJSUVHAuVMmyIRLgkE4JUCQmhIgWEnYkQaN0OgAwuAcSQGaNQ2hqB6FwLxAwVhaBIBEloIZSgtjdxCloOQcsOj3TbgCU4dAAAlDslBBDJ1QMZOQtph5IDmaBDwDEXF6CFPkFwSTAQeFoCSKAZEXExKgLI8p-CqmENqcQmADT7htJaJ0uhyBsS9PoMw1hwd5DQG3hsSMPDWF6yOLslKgKiB7FQDQ9R1I9jqGMsKeSPC6kuACfAfS-x4VKVxEKeQsyNDzI8LQguBV9IKB0fig5gTyC3PTDMohnYAmYHZZCAc1BGWUu5QSq5kIpIuOktIbK6jrThhons6lrKG4EBUBcxF6QsjqOwDGYkeI4QhKoJyskPD9mErjGqnGZIyxkn0rYQQd8qU0pAHC2AKzaFQDTpGFxqB9i7LkSAbA7KDiYB0QfDwfrMAAH03XwHUVqxVx8ylAgqQQmpLKERZqAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/session/outputs/data_outputs/src/index.ts",
        "description": "Retrieve the data from a data output."
    },
    {
        "href": "examples/session/outputs/output_updates/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1dR6poozkuqr8cFxFef2og3DdJuOTPSbpqvNw5BoQ8gRc2Yp5RJToAK6wIXAa5Hmn5MZomLgEUyCsJitrG-EmiSmcJixQwiAAGhAEDgACE0PwNEkkGB-FAXABfIGXa4YbA4e5kEBUGh0AgMCBEeSUDSbABUXCG2iUADUuGANJQiFwPAABOByRSLTTGVQQGD5TQeLqoTgACkYuhShQwlHyAEocNJaVxXNSaSLxUMkqhyFwxfLVawuMA4uqcIJ0AAZEG0VCaMXKmk4ACiNJdADlvN4AJoABRdAH0API-P0-HCh7zh7yBzx-pQAQW8LqUAP1MENrmNppEPBxWS4lAOBHkJZd6hoqq4MEpwydOAAksGS2WCBW8SKrAXNsXSyXE_IINWXHA4BBqDhmrYW_2CKCko30GK-22OzQcKuS0v5QBCLuiCBgfVbgiDiA4VD8Gyq1xqjwACRJEAAXtQ7FBvJR5CEAGS_otW3LSsCEvAUPX2TMTTNKxT3XUD7XyCDMAxDR-HUZxlH4OwxTFdAsxzGCrBGY88JGVAsl0cgYEoY8GwAcRomwCChJRsP4eUiOI_V0Drc1GKZWxWPYxUiGwzQIDhXccCoKASWrDw9CgA4YGFLiuAReUDx4BEzU0zURB7Lg-QFYlSWrfh8n4CRzVWARaBpfl8jMggxVzKwijKDwiCSRzTJJAgPABIjZiGMpGAfbwAFkrQAYQGIYXVgGwaFYdBKHIA4UtA6d22SvEFyXMUPFCh5OJEfSzSM0dx2oCyrJshs7PE6R4Fq1A3KIzyWRAHzWrHCdRUBIjxHIABrWxEHUjwAHZ0AANkqebyn4cgwAAJhmgAWGbNv4MAwB2qp1oAZkqABWABOc6DsumBzsCMA9HQSpyku_hyhgcoZpO8hyHQG7Tq29aYD--bLpmsB0FOiH-D0SpAn6dByDO8otr0TbFrAQIHvQcpAj0Lb-EEGBKmJzATsuqGfv4c7yHKQmtrAGBDoB_gtvOmafsu-nmfWwJQfmxmWauk72fKMB5vISo_r-mbHr0E7JfWoGEcqdA9HKea5sW8hTsCQIhZO9byBmq6lsR9ADvm_bzv4AWTqCc6TvQLb5qu-atqtwJKnujXdrhmBLvdumYEwVThrzLg9kwKA_PyTwNCgLyQEIUs4EQYxjDgTADnpnAYAOfxqJoNCoH8cocA5BQw7UTQZKZIKiIaghfBJWc2wz-k4RcPStNiQzqELdL26AzY1RqwaiKnGcx4XD1rxgYqQCUSgSQ8cqrBwSAMFwygCK4XdKG3kkxNAtByGUzA4GXs-JLhDe9wPEeNA7kscAOeR0HE-KoCgPRVpjQsnAHUeoxSIWQjAAA_GUBsjZvAaBgDASBB93KHlIhAyCho0FWEstZTYiEuB-kZEQEES8xSILgJQKA6gD4uAIN4QkNESwUPgNQ9Q6Z1rVEqPKfuUceCYJQixdCmgXBsRwnhVB6keBHh4uRSiuoaJ0VpDgASzFhJ2E3txUQZEqQMSYkJJI4iOI4DvmsKSDc5JaHvCARB6A1L8I0nwqwukKoik0gaEUgJgRgghFCGEPcYBIhAPIQB_Bpw4AAFZUNQFiHEdp8SIBAKaEAmBFBol1PyB4yA2TVy5HXDQvInJCiQB4E6OB1qV3Wh4JE3lrJDSmsCNEuBfhNxAC8dY9wPA5PaXYUk3SPChLODAKA5Fbj4GIKM_w_hvx0DaXoA40B7GlJCZCaioyFlLLGeiVpIBampJgKoJQMB0mYEyfAbpKShnrP8AsjAsANADJAAAPUruUdaOBzptO2PAVYnSnnPPOjgLanyakIm8SCcEV5_GIFhPCIJyJdAa0MA3VAkBmhRJiXE98eIGApLQDvCQMArRr3kMQygtByDiGoN0liKlgqp0hOgAASiMygghgyoFinIVA05aUaHpR4Ey-Qnl6EZPkFwjzhogFoESKA4knnXJGTUiFvjoXQlhYE4J9wcTosxdQbFuJ6BJJSVQIk0BNDBg2INbJKSY5HAjo0s1exUDRLaYgvY6hYpMmytkuFLgGXwCivsB1jZcSMh_EgOlMAGVUIOMMqKChun-pjR4TAl9ITYSngE-FDL03yrQtS1AibI2atzR4PpuUnkumkPNNpWQ1hUv5YKkAfYVBSsaekLIbTsCKDWNlOExyqCFpJNk6NgbSEECHSSbCJIoq2EEOxZtqbeohtgKyqhyki1PNQJBGpgasCXwOJgbpABtDwu7MCBntbAB4ebbQeAALrgqBJCvxGqU0Ii_UAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/session/outputs/output_updates/src/index.ts",
        "description": "Different ways of updating outputs."
    },
    {
        "href": "examples/session/parameter_values_access/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1dR6poozkuqr8cFxFef2og3DdJuOTPSbpqvNw5BoQ8gRc2Yp5RJToAK6wIXAa5Hmn5MZomLgEUyCsJitrG-EmiSmcJixQwiAAGhAEDgACE0PwNEkkGB-FAXABfIGXa4YbA4e5kEBUGh0AgMCBEeSUDSbABUXCG2iUADUuGANJQiFwPAABOByRSLTTGVQQGD5TQeLqoTgACkYuhShQwlHyAEocNJaVxXNSaSLODispk6OgAHKUcSQfriaiqrhisywMpZNaoZoArg2OBwfjNGC2gj25ry1WsLjAOIjMCWw3GiCmiDUHCKDREEFwaPcVyprgAcmaGl0tHQ6b9QZEPFQAq44YgJv4ZtQVoksCdwC4nzKLrdHq4CPlIp4CK4MHhMBDYaNFcjVeTsc0Cddya4AEI0-nMKh-XmC8GeOXK9WcBoYABHA7wAgABSnieTYsVJToYrj06T5tcAcLVh4Fct94vT8XWZzMDXQMNzfEt8jLEdt0va0YAbJt9iSFt4DbQdO27N8EWA1Dgww1AEU1GshiSVByEtP1nyAkRtU2PkBU0C1-HyfgJHVHBVgEWgaX5fJiVJMVX1EIoyg8Igkk42iNA8AFgNmIYykYAAJbwAFkABkAGEBiGABRWAbBoVh0EocgDj0ggcA9AgdJgUzQSSABJdAxQ8GSHnlbCu2DKjdRnJ9KUY5jlRpVi9yrGBpCQy9-PfdAhJAETwp80VAWA8RyAAa1sRBgJ4DwAHZ0AANkqAryn4cgwAAJlygAWXKqv4MAwFqqoKoAZkqABWABODrGq6mAOsCMA9HQSpyi6_hyhgcpcta8hyHQXq2uqiqYHmgqutysB0Dazb-D0SpAn6dByHa8pqr0KqirAQJBvQcpAj0ar-EEGBKhezBWq67bZv4DryHKJ7qrAGAmsW_hqo63LZq6gGQYqwI1oKoHQe61qIfKMACvISp5vm3Khr0VqsYq5bDsqdA9HKAr8qK8g2sCQJkdairyFy7riqO9BGoKhqOv4RHWqCDrWvQaqCu6grqu5wJKgGym6v2mAuol_6AJgGBJOAvZMCgMT8k8DQoFiwgCHkOBEGMYw4EwA4AZwGADn8cg8WzKB_HKHAOQUAC1E0VimQ8dz8J4FwMC3MdqyckAT0hfgbFoZxJK4AADYDY-zBO6JpOEjwtrgABJgAAKWkAB5fUve9NBmgrJIxRcRLYzjrONBzqA8_lHCrAz-PbDohLH24du87KIvS4rqufTrhuIpjeQW_7jRB-TEf4C79PF8TrglFB_gjk2Nf8_H8vK7tGuZ8bofm8zpfd9hA-j43kQU483D5SvEVAWBMEIShGE4SIiBAvdK7oYA4AAFZwGoFiHEtB6CIBAEGEAmBFBomIvyB4yA2Tey5H7DQvIuJCiQB4VqOAKqewqh4JEwkmJJSysCNEuBfhaxAC8dY9wPDYLYXYUkXCPALzOP2EYTD8DECgFwfw_hKBoNYXoA40B0D8JAIIl2Ej5GKJEbcMRJBqFSRQTAVQu80HLnIJgrhyDVH9n8PIjAsAJIkJAAAPU9uUCqOAOqsO2PAVYHDlFOI6jgaqHjqEIm_iCcEqBITQkQLCAcSI2G6EpoYAOqBIDNEgdA1AsDqDwPxIg5BaBIArloCpSgMiTyMloOQasXDvRHn0U4dAAAlfslBBBl1QGpOQDpNZIHqTBDwNF8jKL0IyfILgHH6NoESKAoVlFWKgNQ8Jv8on_1iYAmACT7g4nSZkmByBsS5LxAwZBVAiTQE0GXDYyYsHIJ1kcPpDDzl7FQFA1he49jqDUkyUyWC4kuH0fAJS-xHl2VxIyeQdSNANI8NAg4QilIKC4QCwZBjyBzOzLUgBA59GYAxXHasSKoU4sBR4XhFllFaWkAVVh58anQthSASgBwCAqAcQw9IWRWHYDjISPEcJd5UCxSSLBAygUJjZWtEkVYSRKVsIIKs_BGVooebAVp0CO7YoYagfYfSaEgGwBig4mAuEAG0PC6swAAfTVfAVhXKCAeAALphKBBEv-MTUUIh9UAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/session/parameter_values_access/src/index.ts",
        "description": "Access to the various parameter values."
    },
    {
        "href": "examples/session/parameters/all_types/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qnzMAhuh1QACIYwIQCsVgGU8vAA4wAIhABuMAE5DpvDACNKWRgHpxkmIJGMiMAryHk5GuLYC87EAFUAKgDEAtAAcHkLGgiZ4fAKc3AboAJ6WouhqQhDo7iDkuqq8cP5UNLxomiFwBPGwmQDu6QR4iEIAjAAMLQCkANxCkRAA5oSNAKxt8ljd8pRwEhDUjRowULzi6h5JVtmouXBpGR6b22smB3lJJimqgpxWF7uZhQQalFBwZRVVHvL8Kah9jQBMLTG3QMGkwGkaTTGQjgz3SQgAxDBkd0iLwNH00P4CJR5JCgVg1tdRMYLmc4OQNBB5AQhBVFJkiJR0ABXWBlDTkTJwTnGNCYXAEV4gVgmClUmnhYxxRIxVARYhQVggAA0IAgcAAQmh0fEkGBeC8YABfNU88h8jDYHBCshZai0eiIdVESYaWnAYmUvi0aTwabUFVehbLGAANQgMGqboIQeEQgAkn64AHUABBeQQOMiAAKaYASmmALIAUW8JfzAH1vABNHMluPGoRgJ5EIQeAACcDkigummMqkj1VKIE6csK5TSqAkQlcQjy8VQ5CEAAoAJSz1hCT3x4zGBwh2jzoSDqMxr3USen6OUd2z-fVYq072hiNn28EFc7kQiE5wRroJQ5AsjYNA4H0tglrAoEEJq8QJugK77DkeQeBueRCAAEt4RYADIAMIoXAUEwDB2Y_ukjQeEQ8Rvje7oeORxprmOu77i-R72C4KazFw8YTrS3GpvevCPjOHEwMmqZfsSIjiOQADWthUSAIwwHo_y8P8ABs6DoLwvAACwAMz_NkTSBP8gSBHogS8E0gIwGATQAJyGQaxlDHotlNMZMDuSZvAwIELnoNpQwAOwuS5TS8IE4VgKFfBaS09nkIEhktP5EXkOgYC6Xo5AtK5uVNNpQVNEMvAubw2l6MZvARegMURf8_yGUMQz_NFYV6Og3V6E0YA6fVYBgMZegRfwBnkE0eXGegIzjXoRnoMVqVDNpxWBC0eVgIEYARR15Bubp_B6IZTRlVNxkmU0MBtQt2kufV_xHcZznaRF_headQyJZpLTkIl5D_J5tl8MZlUGXoQOLYxslCEymBQHRngaFAKmEAQ8j_nucDoBoEUwCys04CTBR0I8hr-E0ODdgoMB9hoOBUEQCPxiIlHtiANFSbxHMiMxrEXqgk4shAKiqPegHATB4GQdBVNwQhSH2jQTwvGh847NheFSyRMGsb-h4wJ4EArkJvEqkIEtSyxnDGiL07Tp-Dt8QJB4-mbED3pb_q8Y0SYB9QGZZkIXwLDQjR67hBtKzQG6uFu37Nreq6e_IU4wiHqA4JHvA2LQzgbqnXNgKuVvUPn6KF7YmhwAA2vIAC6-DpJgqAbg8aAsjAzs_g4l60gXReaAA8noABWMDkLSc5V3no_184zctwPP57l7oZCLcYDp_UMAOCyGhRyPtdjxoiOZxfUsy0BIFU6zpuG1TasXGhG8iFvEnHkseiLCELUeodJIhCFQHXIQlAK6HwjhfFe19h5CH_oAucstH5gQkq_GgasUFQE_ojPBNpsAEHwg6Km95l7F0njPOeOAIE2C_qEdiptjy3HqMsIB0AoBDyKGgUBR88GILFrSW4aCH7yywQnT8HgP4gHdoPUeUscAKEUBgfCeBoCIQuAon8FwVHyDUegDRWiVx4PdojCAFckKcx_FQie09Z4EBtPERQs5XBzjzIWUs5Yqy1nrDgBMAA5bwQgAA-YTEYiHsRoGhTiXFuI8Z4gsxYywVmrHWEsOBfC4XHmmUJESolwI0HXahji6H0iPkkoQXjUm-IyQEksYYSxBPCZE2x0T4FlNoc4yp7jkneLSX4zJOBx5KCUIjUuRSt6wLgFAdIpQOm8MnDEhMqB5AsgINg-eu8JFPykaRN-RSRAeDQBsgggtB5CHQrrHCuE1nnO2cbK5qz1mbO2TgeEc4YlxLoekZ5iiumaAee86RCSqk8xKb8GAHgAV2KBRoEFWywVEH4d8hFvznGouEAAah5rCoprzHkot4FgShGLylYtJUIPFHgCVLKJaCw5YFchQD7uSkpl9MU4FZeyjC5QqS_DheXVcPzKXgv6TUlJPj0n-KycE7wUylmdM5SvJFHzygwCznODwTR6VXKEE2RYLg0jWOOcU0pDiekSuqbUmVwzGnNNaYU5VFquXir6ba6VQyGlZLGRMpZSqDUqstYit5yLmXOM1dqnm_x9VXKNUabc5rGURvltG2c5qRBNFCEIIsyw8D50oNUFcrQbZiutZgcgEA0RQHkEscg8AACEG5aUgHjYPY0hLb5qAMUYkxUBEKpu2RYhlCL1VguoI4XQEERJwEXMudcm5k2uorfE3lELh1go3cKn8oknw5x4tXYC5RKCooAF4wHXLup2iNE0mqsaKil1rPUeKlYM-pcqcCanHuPXCQarkzLATiPofR2RLJvqq4uE7I33zlvsl-0ibHBp5mczZlzB43KwncmDRtu1QeBeGj5Xy3Ur25f8_DobcNP09TzRws8FIGEJKOIpj6VxrroRujcW7I2s0iIpJm95Hh913Uo3tqi6DGM0YO9j46iPSNHQaoDR9shQCgCtRSlHL7UbAlOuQ0K50LtXEnFOKbn3rsNOy9FBGw3Et4_RgT6Bd0iH3TORerMWSnovVe3Rna4X3qPmxjjvTXFVLfXan1X7pDeHzMEgA4gBweympznKKZBqj8nYPiPg5gxDkbkPBtOeGjDP4sOxx0wQUTcm7PyxI8Fz5TmtNqsy_LWjHhaBYAuSxsdNmKs8ss5u8znGBs6xhI8NAfQqucuURJ9R0mh3VaZTBRTgH9ywNU-p3gmmesZZq0_PTM6IULiXMZ5dZcXlDecRujlu2ltPx3ea1zglc4ea8xAS916im3tsQF01T6bPctfQMupsqRn4T_ePfMiXN5rbAVQKA6c0MXIg0gmJZCEe2buzQODGDnEHJggVg1RXUuqiKWVnDLWqZTdDej28fW6uXYa9Ty-tPMdppo6F-8-xni3g7fCmzrO-vXbnCuRgAqJusHq1x81OAFj1q21ejwLRmM2w8AiNCMu4Asj0OL34K4Wg2wir5_nhcZuGMkwOhbAueds5HUw7-sOVOGk29tg1aObd9YOwZucx3F0mZXShqXI3rM0495TllA3nMPgPe5k9OJvOfaWd9ztQhjWBesfVoH76QcOqydF2LQS4v3Oi9Dh3Ajd5PHkIBaofEDXpe0-HnZ6DJF5YJ-ajwLhYBzxKyIcneE_Rd_ZzQZnzW9tgQZwD8VFGln7y0GY2wQgp73haN0JfjBSPdPiY4SgEBG1wCbTgWAvx6ir5xTi0vP5Pa4nENQHHLfvbbLVtfgW8io_P-rsLxfNL8XdZQ-_vOHWpC5C2OIe7q1q2-u-zajcU8685qbGOKsmk-1q12_K42vwScc4U8a4WaUCNIvE9MiwTigmc4wm_cZmvWjefaFu82K4_-xuQsWmZu_aNBPGy29uzC5eG2GmCkTW0GlBXus6Pu86J2S6ycAewaQebKg2FBY-V2kej2Ykz2R6ecceZ672PmN6_mqeSaQWjOWeEWn6IyvgCYuEJYF-yWkAsAKW6GKOIiG-hGshd-CGD-SG7e6oxWpOgao25WjeI-fBshDWN2YB8S0-bui2Q-IWiSPMlhMKv-F2MhWOziW2jaNIQRZG4qs-aIBAB-U8O-qAasQYr-jB4m5uc2pirBVMK2SWjuDgzu3BvBDhiROAAhR2whfuZ25qW8JYWAM4j6qAlAzY0A8AOcg-TMcB1iTaFRYEMRcAG4CwBAJ8qA7BIawRw2UhaR_hTRMxjcLQsBrqT2h6qYr28e6hieBqyeP4Xate_OT8s2Um5RPaqguiVx32qo6oWoOoGgeoiABoRopoIAXwikvAEEOAU8sIqAdoDwVMDAnoIAmARidA1a8AHgyAnYDMvYag_Y14I4iAHgxkOA_wdMcaIApo1ExQXASARWAo-AioCMIA4o1IQoKJsJ5Q6IXWuJAJ6IjaPC_I1oLAPC_g_guIdAdJegEsg6KJnwXJgCYpWiU41J_JHgpJcJMAqgSgWqkmiJkYwoqJnJnIiw_gYpGAsAV8lJIAAAenTA5DgEMHSZUgyTSJKRaUMDgIZDaUqcaG8RqNqBAl8fqIaC4P8XALoOgExqzNQJAH0KCeCZCcAQQDCUVpAK7DALhJQLiDmE8LQHPC_ogKQYUU4OgPmIsJQPwOPKgBoodiiXmR4NeE6XoE8NUC4KaYUbQK6EsLQE6ZHNyUqV6R8b6d8b8YGWqEKIUJGdGdQLGTQNCc6LCWzJmCaePHgZeMydRMyGyLERyWzEyKgGCXSQsEyOoGQkQDBDqYOTAIUfAEWGubAGssXLiFWRoH3IUbCCfI2vmvICiWeYUVWksCUjfhST8QGeebIrPL-csLxO-Z-UBS2eiBBOyR4CWNINpHSeLt3kgNWSAJQJsioKaRySkOUHSdgIoFSDBIaOqVQH-beDqRhaRBIORbeMsLeEWLYNNHYA-U-auayLAEWbCGyv-U6f0ZgEqReVgOQGykJUgI3B4IJTAJWMjOucKN-RqF1i3J6WqN6Z8QOUBcaDpUAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/session/parameters/all_types/src/index.ts",
        "description": "Parsing all common parameter types automatically."
    },
    {
        "href": "examples/session/parameters/change/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1dR6poozkuqr8cFxFef2og3DdJuOTPSbpqvNw5BoQ8gRc2Yp5RJToAK6wIXAa5Hmn5MZomLgEUyCsJitrG-EmiSmcJixQwiAAGhAEDgACE0PwNEkkGB-FAXABfIGXa4YbA4e5kEBUGh0AgMWKoCBEeSUDSbYAODQCWgANQgMHypPJAKpNJg0ngcAg1C4CK4YA0lCIXA8AAE4HJFItNMZVAz8poPF1UJwABRDJKochcNUASi4rlYXGAcVCxjZ_FoXHs8sZzIIZpxWS4dqZZM2rht-X4EktdIVDrVppEPFmQzK6Eo5AONhoOGatgAorA4wRQUkAJLoNUecMPA1DLgACW8AFkADIAYQGQxTMDTALNPCKZQ8RCS9PtHo8ZoRepVPGMFtW7JtmS5PNVImdmxccG5vK9_B9ftHVo5k-owebWwg5AA1rZELueB4AMzlACcYHKABYwJVAuRyjAAGwAdn4gQ_D_QgTvc9-HIGByDAdBzwAJiqO8rw_D9IMwPRKnIdA9AAVn4So0L0c8r3PQJ0PQq9IP4cp0LfGBAnPD9z0qGA73Q8h0JgL8wBY_gMMgmByL0V9zzfdA7zvLCSLAD9ykEMjz0vHj8PQ5CwEg9D0CvYTAn4MBzzvdBKkEXS9HQTC9DAQIrwAqCFLgmAYCvd8qjfPRlOgt9hME8jv0cvjAj0O9KnKe90FMq90Eg9ir0qK9kMCKjyB8uyYD0fwP3Q8pHJgGjyCc1S3w0ypcOYxi9E0oCYFSmAPCbUMuD2TAoC7fJPA0KA2xAQgCHkOBEGHOBMAOF8cBgA5_BAmgNDhfxyhwSUFBgGUNBwKgiEq3dW1FEAO05Bcp17ER-xVM1hy4alBC4SgDk2EoYC4eRIX4GxaC0QoSi2KJMkUcgIEgHVUHuiqZ2oF1YFQZoSgABTuh7NENCdtuoBNbAh8aoY0DMADk_tzEAKzoUG8A8PUAG1KgAXQOkQjoOeR0A3V7rsGKADn-nhgbxpG_senAGaZmG33JocLV0dAHAOLJhQgAAva6rsyUbme9X05y3VBFtFghxal_UVX7LXOEBYEwQhKEYThREgVuw9-ETHAACs4GoLEcVoehEBAU0QEwRQ0W1BkHmQcUZulNRZTdJUkAvHBoMjjwkXbX1VXD4E0VwX4VpAF51nuDx_fTuxyWzjxbrOGAoBGZP8GIUv_H8SgvbTvQDmgdAC5AIuQNLhum7L24K5IGOmw9mBVCUGAvcwH34Gz9225L_wG4wWANBbgA9KbykgnB0LT7Z4FWTOV_QnA703mOEX1kFwV-43EFheEYCRdOhYMXAcUgZpbft1BHeoZ38Vd920CQCJLQCslBa5gyFLQcg4hqDZwIBoJmA8nDoAAEol0oIIAA8qgKscgQYVSQPAxBHg3Qtz0EKfILgl6Ag8LQEkUANwtxnlAGO59DZX2hDfU298gT3Ffi0D-DtkDYh_niBg7slryGgJoTBGwpx-3drVI4BCTwiKIHsVAds07Uj2OoKswo0x-1vi4Ae8Ayz7GUZmXEQp5BwIQTAAe9sDjFzLAobOxiHEeEwOQBh40YEJy4XfAe3jfFWinK42xJsgm0MhImR0ickzSDfGnLIaxoF2OISAc6BAVDUNUekLIadsCKDWGmOEI8qB-LJH7IhniQANgkBUskVoyRllsFJOwGS6lKNgGg-2jN_Et1QPsAhsd6lYB8QcTA2dCYeGGZgAA-j0yeNCPYgniSTM-QIL5G04R4hEBygA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/session/parameters/change/src/index.ts",
        "description": "Change a parameter."
    },
    {
        "href": "examples/session/parameters/change_multiple_parameters/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1dR6poozkuqr8cFxFef2og3DdJuOTPSbpqvNw5BoQ8gRc2Yp5RJToAK6wIXAa5Hmn5MZomLgEUyCsJitrG-EmiSmcJixQwiAAGhAEDgACE0PwNEkkGB-FAXABfIGXa4YbA4e5kEBUGh0AgMWKoCBEeSUDSbYAODQCWgANQgMHypPJAKpNJg0ngcAg1C4CK4YA0lCIXA8AAE4HJFItNMZVAz8poPF1UJwABRDJKochcNUASi4rlYXGAcVCxjZ_FoXHs8sZzIIZpxWS4dqZZM2rht-X4EktdIVDrVppEPFmQzK6Eo5AONhoOGatgAorA4wRQUkAJLoNUecMPA1DLgACW8AFkADIAYQGQxTMDTALNPCKZQ8RCS9PtHo8ZoRepVZuMFtW7JtmS5PNVImdmxccG5vK9_B9ftHVo5k-owebWwg5AA1rZELueB4AMzlACcYHKABYwJVAuRyjAAGwAdn4gQ_D_QgTvc9-HIGByDAdBzwAJiqO8rw_D9IMwPRKnIdA9AAVn4So0L0c8r3PQJ0PQq9IP4cp0LfGBAnPD9z0qGA73Q8h0JgL8wBY_gMMgmByL0V9zzfdA7zvLCSLAD9ykEMjz0vHj8PQ5CwEg9D0CvYTAn4MBzzvdBKkEXS9HQTC9DAQIrwAqCFLgmAYCvd8qjfPRlOgt9hME8jv0cvjAj0O9KnKe90FMq90Eg9ir0qK9kMCKjyB8uyYD0fwP3Q8pHJgGjyCc1S3w0ypcOYxi9E0oCYFSmAPCbUMuD2TAoC7fJPA0KA2xAQgCHkOBEGHOBMAOF8cBgA5_BAmgNDhfxyhwSUFBgGUNBwKgiEq3dW1FEAO05Bcp17ER-0HERhy4alBC4SgDk2EoYC4eRIX4GxaC0QoSi2KJMkUcgIEgHVUHuiqZ2oF1YFQZoSgABTuh7NENCdtuoBNbAh8aoY0DMADk_tzEAKzoUG8A8PUAG1KgAXQOngjoOeR0A3V7rsGKADn-nhgbxpG_senAGaZmHAnJ81juiM6Lrpm7IdsaHnrwUW4A-r79y4X6bCdQHNioKAyXZlGYfnRdUARggtYl1GkgxmwsbLDc1jhLgq0oDWNAJ4mycJCmLSpmnrSu104SZlWHaNznueur0PAAYmqMBH0qZVXYF3R0AcA4smFCAAC9ru9lY6GZ71fTnLd9ZjFOiHTmB9RVfsK84QFgTBCEoRhOFESBW7D34RMcAAKzgagsRxWh6EQEBTRATBFDRbUGQeZBxRm6U1FlN0lSQC8cGg9ePCRdtfVVVfgTRXBfhWkAXnWe4PFn0-7HJS-PFus4YCgEZD_wYhn_8fxKAnk-9AOaB0B3xAA_ECz8_4AJfrcN-JAt5NjHjAVQSgYAT0wFPeAl9R4gKfv4P-GBYCO33gAPSmuUSCOB0In22PAVY58gGEPQjgO85Ct4IlriCcEv1G6IFhPCGASJT4JwMLgHEkBmjd17qgfu1BB74mHqPNAkAiS0ArJQb-YMhS0HIOIagl8CAaCZnApw6AABKT9KCCAAPKoCrHIEGFUkB6IMR4N0QC9BCnyC4AhcDaAkigBuIBWCoBbzYfXTh0JuHNz4UCe4IiWjiL7sgbE0i8QMFHkteQ0BNAWI2FOGeo9apHHsSeJJRA9ioB7ifakex1B21KXiGePCXBwPgGWfYhTMy4iFPIXR-iYBwN7gcR-ltulN14XAzA5A_HjW0XvCJYyPATKmVaKcwzL6NL6R4G-iZHT7yTNIN8J8shrC0T0pxIBzoEBUAQ4p6Qsgn2wIoNYaY4RIKoNMskM9HEbJAA2CQryyRWjJGWWwUk7CnO-QU2Apje6MxmUA1A-x7Hbx-VgSZBxMCX0Jh4BFmAAD6kL0GAgWSCHZJNWFAnYQ3cJ6yES0qAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/session/parameters/change_multiple_parameters/src/index.ts",
        "description": "Change multiple parameters."
    },
    {
        "href": "examples/session/parameters/file_upload/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1dR6poozkuqr8cFxFef2og3DdJuOTPSbpqvNw5BoQ8gRc2Yp5RJToAK6wIXAa5Hmn5MZomLgEUyCsJitrG-EmiSmcJixQwiAAGhAEDgACE0PwNEkkGB-FAXABfIGXa4YbA4e5kEBUGh0AgMWKoCBEeSUDSbYBxBwaAS0ABqEBg-VJ5IBVNWtJg0ngcAg1DZIgAkr5oDAAAqQ_g2WgaACC8ggnARXDAGkoRC4HgAAnA5IpFppjKpGflNB4uqhOAAKIZJVDkLhWgCUXFcrC4lJExmM1M5XHsxqZLII7OoWS4geZZM2rn9-X4El9_HpJuDVs9VlmQzK6Eo5AONhoOGatgAorBCwRQUlBegrR4sw8XUMuAAJbwAWQAMgBhAZDcswSsCqxFMoeIhJBlB6MeKkIp0WnjepO0f2ZHl8y0iHHhlxwXnUV1xhObDnJrmb6jpqk8cTkADWtkQt9EDYAbABOMDvgDM74AdgAVmqICYCA_g9HKfgYAAFlgsD33IGA9ECACYHIWD-Eg9AEM_SoACY9AI_gwCI8gAP4ZD0PQGC9H_T9ygI2DwM_AigPQMBYPKJCgK4yp0Ewypylg8hyF_AjAn4IDYKk9Byl_dBhN_coYDAdT-CqNTAiA8h0FwoCVP4X8AN_GCwBgT93xgQSANg99-AQypAnIcoOLAQJAnQAjf1_T8OOk2CAM_bCfM82CyP6MA9D0SD1PKKpcMqADoLsrzNII8gIII6K_z0LD_HfbiyKs9AgM_ejDMg1SwHIfDyGY2F0AA9BPI8EdRD2TAoGnfJPA0KBxxAQgCHkOBEG9OB0A0dCDlcnAYAOfxkJoDQ4X8cocF1BQbLUTQcCoIh2tfMdNRASduQPLc5xEBcLSpFcS02EoYBVUURlQeQDhDHcw02SBYEFT7volNbpU0Y990PVBi1sUGpVsTRqwAOQR-sRB4DxBSIfgSy4bHgxungnQAbUqABdf1hmFUV4fBuUFXur0fSgShBEydVXtouxQ1QcMaTgI4YxPRN0asfh40TCyCEcethoIUbxu9SN9u2_U9o0A71SNX9jGaNb5DwCByDgYxWeaSgcHkVBmg8J0qSdHA9FZvRnSZ5cfRcZ6ogjOEDleygwC2H2AdetAvp-nhQ6BiO6cRzXBigf3jwFoX3dCH1dHQBwDiydUIAAL1el7MhWmAqQl08Nyu6gDtzgh86Lt2lSdZvUEBYEwQhKEYThREgXkKiH1xmAcAAKzgagsRxWh6EQEBKRATBFDRe1GQeZBtTV3b1A0I0TTNJAPF_HACM2giPCRCcE0tI_gTRXBfmOkAXnWe4PE3l-7HJD-PEHs4YBQA-rcfAxAgH-H8JQFez89AHGgOgX-IB_7ISAbA-BwD0RPxAFfJeMBVBKBgCvTAa94Af0XsgwB_hYEYFgBoRBAA9TaTEcBAWftseAqw34MKAjgWCLDL4Ig7iCcEqBITQkQLCeEMAkQvyzgYXAOJIDNHHpPduyBsTUFnvieei80CQCJLQLslAoFijVLQcg4hqAfwIBof2bJhqQnQAAJUAWzdAAB5VAPY5A23LkgGxdiPCRkQXoNU-QXB0MBB4WgJIoAXkQRQqAl8hFd1ET3CRfdpFAnuIoloKip7qJnniBgi9DoKloe4jYW4N6Ly6kcPxL4NFED2KgCez8aR7HUD2dUlYN6SJcPY-AHZ9j1KBjKKB1jbEwHsZPA4ACOwKA_v06ZHhMDkDiWtSxt8MlSPsWsjZyYtwLPkEszJ9jv5PUQaWaQ75n5ZDWBYyZgSQCUG-ioSJjT0hZGftgRQaxKxwgIVQTZZIN4BJWSAIcEggVkmTGSDsthBDJn4E8iFdTYAuMnknLZiDUD7D8Tg7A6yDiYA_iTDweLMAAH10WkKiUvEEIYQDk0EUCYR3dxHLIRNyoAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/session/parameters/file_upload/src/index.ts",
        "description": "Upload a file."
    },
    {
        "href": "examples/session/parameters/file_upload_advanced/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1dR6poozkuqr8cFxFef2og3DdJuOTPSbpqvNw5BoQ8gRc2Yp5RJToAK6wIXAa5Hmn5MZomLgEUyCsJitrG-EmiSmcJixQwiAAGhAEDgACE0PwNEkkGB-FAXABfIGXa4YbA4e5kEBUGh0AgMWKoCBEeSUDSbYBxBwaAS0ABqEBg-VJ5IBVNWtJg0ngcAg1DZIgAkr5oDAAAqQ_g2WgaACC8ggnARXDAGkoRC4HgAAnA5IpFppjKpGflNB4ukSSWSKVSiAoALLEmDeJKKbyUEWwACiGDQzTgAp42FoGEdNhdigDVOaBx5YedrpgvjVRE9dClMCVKpTmpAOr1MANGiNJs0OAO4nhOCITv820zIAtnAAFEMkqhyFxmwBKLiuVhcSkiYzGamcrj2Y1MlkEdnULJcKfM619if5fgSMf8ekmmfNodWWZDMroSjkA42Gg4Zq2L2wS8EUFJQXoZseI8PXtDLgACW89oAGQAYQGIY7xgB9A1EIoyg8IgkgZadrQ8KkEW7C0eBHLdaAnTIeT5VA51QBcXDgXlqFXfh103Dlty5fDqH3KkeHEcgAGtbEQZjRA8AAWfhyl4vQACZeIAZl48oYBgMBZMqPRKnKETyHKABOGAAHZhMCMBVPIcgwA09AJNU4SxP0gBWAA2KzyjE3TVKU-SxMCKyYECKoYD0VTxJgVT0F46S9HKDSZOE1SLJgUTC2s_h-PKQI9D0QILLEyp-EqGzeN4jScvQfh-CsizhIs8grIikKwAs_yxPQKz-GKyKiuSpLtIsvRpN48hAlUwIAr0ypNOkwI-rAOzzJgcorLAcSxNC-r-HC0KYDc1SxLEizZLAYT-H8wJ1oEypVLASoLP8fhco0hKxKs8hst69yIo0q7An4GBso08hSoE8oPCgng9kwKBEPyTwNCgWCQEIAh5DgRARzgdANFCg4VJwGADn8cg8Q0OF_HKHBdQUQs1DLKgiD-7iYNzeDuTIgiUJENCm2HUcb02EoYBVUURlQeQKyIhdIFgQU-YrCVcelTRV1I8jUGvWwJYzGUnwAOQzN8RB4DxBTtG8uF1mdGZ4bsAG1KgAXQnYZhVFJWpblBUWcw0dOd5_nZxEHEF3kSUHdFj3wIfVdT3PB8FYIIO8SfF9NasDxhZgAOBZAKkv2GP9AOTyP7zxZ3QjZ2wJygKBi6gShTXQbnYC4Oh0lQf1Bc2ROfXr_1VzteR4wjZ0PVFVu_TgOPRGDOvu8TIfE-z-3bDLMAyTtAgAEJuzT_OsJpPZ1C4Q55CgCB-loKYRFgTYDiJABHWM0wHhu4cyAg1gb02rdcLgX4w6uYFv_0cHnjQvT8EcM2ZsMBc40F7P2QcVMwBdiXufCAV8kz919HfHAaByBQAOJgIeYCIJ4m7L2BBSCb6oN_vzXUoDwEEHQqhWhhFWZ4Q5lEFwi44SxmGP_Cc-kYAbC4PINUihyRJCpL7SWs8NDZyjleIB2M-Fv2IdfFBbc4A4AAFaUDQG-QEHh6FUiwm7foJc9BALYqIv2EipHUJwNQRwuh9ZvzbB2LskCBwHmgrA5sS8xHK00FY_BV5E7DAAD7BK4N4ixMp_HhyCebC2vYaQEAOBoVA-cXaZHVFzA4e9KCCELF_YYp4uCoEoJsOQ297D1kyIocgEBICFm4t7ZuPM34-P9mLHOASCB_1FHAOJn8eCny_gAdQkHgceihVyJwGSMTxS9E6jJKBMmAGJEyry1qIBZYzlmrlQEyLgaZmym0ThbAEX8cCoAzGc9xVgWKJjKDGOMToe7JnVGmS5NhmyJwuRmM2ltuI8GZoSKwU8OkzxlDgQYWCuZvy2Us55iYZlUQ3JsWWBEcDniyOqCAAAvGAPZP4IgtGhAlnBATAjBBCKEMI4SIiBL7di_AbzqLgNQLEOIQz4kQCASkIBMCKDRB2RkDxkDaiJvqUmxYlxmiQB4MSOBhIE2Eh4JEcENyEVlcCNEuBfiUxAC8dY9wPCiv1XYckxqPBiOxqXG46JfhcH8P4SgAq9V6AONAdAFqQBWrAVwN1Hrea3HwMQKAKq2R8pgKoJQvC650FqfAY1vKfVQH8G6jAsANBeoAHoE3KMJHAFk9X1gNRsbNFkcC8QLSqhE5KQTgkudSxAsJ4QwCRPq3Q6ADC4BxJAZoLK2XIGxNQTlDBeVoEgESWgAFKDOrFGqWg5BxDUGNY_WM4anDoAAEpgNyegAA8qgICcgG4NkQKumA4alxer0GqfILhM06JALQEkUA6JeuTSq2tlKG3QibbS1tQJ7g9paP21A7Lh14lHe-dUCoM17o2AREVvLAZHFPdBogexUBqIeOGzelB1BAXVA-EVzaXDhvgPafYqHRYymdSujQa6PCsuSdje0ChjWkYvR4TAmDJRLo1X-lt4aeOvtxvxtj8gOP_vDWa9mXqvTSCsnqrIaxF30cYyASgFYVAPq4nykEs5H3YCEU6GgcJo1UDE2SEV57yM1gIBZsk24yT2lsIIbc_B1NcZACh2A27WVYP416kpmAw0eGwJg7Bp7TYeBCzAAA-r5hNj70hZA8BbGtQI61Ut_ZxhE-WgA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/session/parameters/file_upload_advanced/src/index.ts",
        "description": "Allow to upload only specific types of files."
    },
    {
        "href": "examples/session/parameters/file_upload_with_screenshot/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1dR6poozkuqr8cFxFef2og3DdJuOTPSbpqvNw5BoQ8gRc2Yp5RJToAK6wIXAa5Hmn5MZomLgEUyCsJitrG-EmiSmcJixQwiAAGhAEDgACE0PwNEkkGB-FAXABfIGXa4YbA4e5kEBUGh0AgMCBEeSUDSbABUXCG2iUADUuGANJQiFwPAABOByRSLTTGVQQGD5TQeLqoTgACkYuhShQwlHyAEocNJaVxXNSaSLxUMkqhyFwxfLVawuMA4g5qFkuHyBcTSarKfl-BJ1ThVgJaDT-flbQQxaaRDwimUPEQkp6bSSCB4AWaeLMhmVGAAJbwAWQAMgBhAZDACisBsNFY6Eo5AOhYIOGatnzMAroKSAEl0GKPPGHvKzQj5SK4xbNi44HAINR7fxHc7lTTXRp3TBpPBh9Q_bGRuhgyBQwuhyPRYDV-JyABrWyIVc8DwAZj0AFYwHpBOhAnoAEyVGCYAAsAHYAGxgGAYAfapYRffh-CAzByhgS90AAThvao9H_MBAm_chL0qdB-BvX9-DAeDYQwuD-E_S8b3QSpyD0SpAigyo4PIODAhvb8wG_fhfxfPCwJfb8bz0OC4Mqbjv0CaJym_QSbzg39ynKODyk_F9cLA_h-L0fpxNhdC9BgX9P1_VixPkpiaJgKiOMwsBFLASo8MCaDyEQgDf0vaipIwzSYECcg2PQLi73QN8wCU8h0EvPjLzAfwb34cg-OYl9LwM2SaII2DQt_Tzyjsyp1N_aNVz2TAoHDfJPA0KAN0IAh5DgRBjGMOB0A0b8YAOchyhwDr_HIPENDhfxuo5BQPzUTRXSZDwux7WIRCargJ02A4aGgLYonpCBnE2PT-AObIuFnNE1lQZouCPCBj2GNAzXHJ1NlQAUuAABUZIgQRgMUxVnOBKCgdRDVcHopxwR90xBWgno0MVQdzGlcwAOW8bwAE0XtzHAACUkaUXMscbRGAHEcFBXMAEEfFRgB9HHEbxgniep3xCcbaQk1zJQASO-B_sBs05tFBbjC4atNhKGAttgLgDnkKBKEELh5EhfgbFoDQzRxS1IFgTw5YV9AXpVtXNHtQcl1QKtbCNwaTY0BtEdVr6PEbIlI1BIkPHlABtSoAF1NWFrZ-BPSlMjdOgOUoKMRC1gcI9QKOCHJuAlH4OxPCx9N7Wtb1IytghpATpODUDnhFszah1DtCWuGwuwuEz7OCEoMPQXlvQuEoPQACsYHIGO-0TzZ6_4JuW_b7v7TFUem7KLJTuaIHjX9KxFukOXnVr0fG6zrZW7FjbJYfFwDLr9P-FXOPKQ0LQ1VnrOcDgTffSKkBBasa-PpsMdb99v2cBEHTo4MUxhEBihwGSAA_D2Yw8oACE3tygByvv2LgegF72hlCWfIYMW56DFJCDQSC_aC1XLAR69oMEEA0DgWAZ0Si9lENfA4gQiH2ievkRuaACCBHJrffgSQxSoDIQGUIItK4TE0OLTaegIRQkyDQtA50W5h08DwvhAikirnyHgaAkthH-H8IaVhRDvaoD9lQheronCV0wOTX0Iiy6iArrOdOkt7CT07t3PuA96TvSPtwmgmjBraLEbOAgBwNDcE4VwLxYpvamNvn7bmwAthJEUGUb-ktuxMIRM4iuVdpGBJ3k3febcO5d17v3Qe5ph7h1nHQWQ0cU5ePtA_dME8O5iheIBROeAWmpwvk3UR5cRYLhkZLQYUADiS0oGAQJOtJay3lorZWttbCm1UbXXpkcBm1KWXrVZhtjabNodM2ZZsE7NOTmCDuBSRZ63rpLHZi5dx3WWpkN51BXQHCyEyCAAAvL6gtuyl04ICYEYJ5HQkQLCeEMAkQgGVsefg1YcA9z-qgLEOIob4kQCAU0IBMCKDRLqfkDxkBslGlyCaGheReiFEgK8OAXzdRfB4JEIYnR7jPMCNEuBfhvxeOse4HgqUgCyJCKMzLkWQn6lAEYAr8DEEVUYygpK356AONAdA4qPDrIVegnVUB0BKtuCqkgnKYzEpgKoJQMBSWYHJfAcVRLDUwCgP4bVGBYAa1lQAPW6uUF8OAbxv22PAVYor9UgADTeHAn4w2coRJCkE4JUCQlhfCxEyJdDoAMLgHEkBmgYqxTi6geKGBErQJAVAEgYDpkoBqt60canvKQDQ2ZNqnDoCxp6g2AB5VAmY5BnRgOKrtMAbW51jXoRk-QXD-ptbQIkUB3Gxo9VATlaboWZqhDCOEuaQD3GLS0Mt1AK24noASolVAiT6I0IOjYu5KVEpKkcCdsr717FQJit-s49jqErkQCslKc3To8PAVM-xP2NlxIyeQk6NDdo8H9KJ_VUwKHFRBm1mByDrsGuIagOGj2QdtQRlWxHUBYaQ4ehFK7IRi1jbmaQhV9ySqUQPZDqGQCUAOiof1fL0hZDftgRQawKxwgdVQIjJJKVTptXWCQMmSTpxJKmWwggL48fIx-2A_a_ozOo7G1A-wv1cpANgAjBxMDiu9h4MzmBqb6ddRxkTMq_apqBOmmF9HEQIgREAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/session/parameters/file_upload_with_screenshot/src/index.ts",
        "description": "Take a screenshot and upload it as a file parameter."
    },
    {
        "href": "examples/setup/CDN/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1Delw8lD8SWVgsFgN8pRwEhDUZfx6cJRQAK60DbBgBGWdXASU8ps1HqmijOS6qvxwXEV5p6jncIcmt_dHJumqr3DkGhDyBJkach5QgEeRwRDGYyqCAwfKaHBwOSKd7wqhEKEAZmMfVoWWMekWGFgOAAVg8QKwTF8fn9Pt9fv9soo8kRKOhFrAQnBAXlueRjGhMLgCOTKcZqQzwiZEilOCYWFBhCAADQgCBwABCaH4GiSSDA_CgLgAvqq-QKMNgcCKyCAqDQ6AQGPastolAA1LiuLgACkYuhShQwlHyAEocNIPXVYqgfRckqhyL7Q17WFxgHFQsYHBoBLQuPZobCxhoCJmXf8i_kS_9vfx8vwJG73ThvnmYO6YdXKKWfRmRDxnhcyuhKORFjYaDhmrYAKKwScEDVJACS6B9HiH5NDyszPCKZQ8RCSneLPbLIEzxtD0ZEkJz7YLmXgE2o5eorpccFf3DrDabkYtm2_C0NIL5TLG_ZWOI5AANa2Ige6iB4ACslQwHoABM_CYQAbOg6D8PwAAsGKYac5SBJhgSBHogT8OUmHoWA5QAJzEQaGIoXodHlBiMAcaR_AwIErHoLhKEAOysax5T8IEElgGJAg4ZUDHkIExHocRknkOgYD4Xo5CVGxenlLhwnlCh_CsfwuF6Bi_CSegsmSZhmHEShKGYTJ4l6OgPl6OUYB4Q5YBgBieiSYIRHkOU-kYugaERXoJHoCZakobhJmBJU-lgIEYCSZ55Dsfhgh6MR5TmdFGKkeUMDuYluGsQ5mHFRiLG4ZJ_jcWVKFKdhlTkEp5CYVxdECBiVlEXow1JR4u4DlwrKYFAp75J4GhQIeIAgmCELiugGiSTAixxTgZ3-OQjoaIa_jlAiSIwCiGitpQRCLUhB5cEeSRgd-EEeFeN6cNePqg6gKpqpq2q6vqhomqq8j8HB_AzqS8xQ8gdrULQ9CICAGYgJgiiWomMLksgppHo2qAeIhaqWrgCpfSAEp_FTxNZDqF6MyjgIwFAVzM_gxDC_4_i7HQbMEtA6AMx4As3cLctQOgItCmLJAeDTJMwKoSgwGTmAU_ADPE8rQv-ASRKaIrIAAHqPYxOAoWzTLwPSfwO47KE4MRbu68a0PqlqqA6nqiAGkaMCmuzujoAYuD2pAzSY9Qtr2vjTqE8TaCQKgEgwAAMpQuwAAoaJQtDkOIb5IAQGiLDAu57Tq6AAEpC5QggAPKoAAwnIqAzgzTct23VYO3o1f5C4GgezARC9CBMAO1bUC66HsMR_D0eI3HqoiqnLQZ9jFB446DDE2i8jQJofd_BBXNHmyHLr0gm4fayqBkmzuZWTqEHj_R0VMY4uDbvAAAsu_WAK4HTV3kOPZurcPDzEWILaBCgGYQLQfrcgfQ7r13pgjWObdMCEJ1CBCC2DkFkMgR4OwGgZx8w8LOaQuE2ZZB-HXFBk8PCUGWCoReX8SbqgvFArAigfiLkNEbKgxCexUwnvg5eEgFE9hAj2aBtgYp2H4fg1aH9u7zCWCQh2qA2Sfz1tgQhixMAMwANoeCsZgAA-sY2A5IKESI8AAXRDqqMOcMo54ONBEoAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/setup/CDN/src/index.ts",
        "description": "Using the Viewer API via a CDN."
    },
    {
        "href": "examples/setup/NPM/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1Delw8lD8SWVgsFgN8pRwEhDUZfx6cJRQAK60DbBgBGWdXASU8ps1HqmijOS6qvxwXEV5p6jncIcmt_dHJumqr3DkGhDyBNtJRR5IiUdCLWAhOAach5KHkYxoTC4AgPECsExfH5_cImRIpTgmFhQYQgAA0IAgcAAQmh-BokkgwPwoC4AL7kuEIjDYHAosggKg0OgEBgQIhjDT_YAODQCWgANQgMHyEoIpJlcpg0ngE2oXFZXDAGkoRC4HgAAnA5Ip3ppjKolflNB46rFUAAKC5JVDkLjugCUXFcrC4wDiZpExmMGv4tC49gdytV4cFWS4iZVlElQfj-X4EhjCsdqvdYZEPGeFzK6Eo5EWNhoOGatgAorAGwQqUkAJLod0eSuowMXLgACW8AFkADIAYTOFzbMA7pPDPCKZQ8RCSiqTWYIHnDrP9rtQ4ajhZg8cyOqmp5Eqf-Ljguu4rlz-f-3012uft9Lq-2CByAAa1sRAAJ4DwAFZKhgPQACZ-HggA2dB0H4fgABYAGZ4NOcpAngwJAj0QJ-HKeDYLAcoAE5MKZbCoL0UjymwmB6Jw_gYECGj0GQqCAHYaJo8p-ECfiwF4gQkMqcjyECTDYMwgTyHQMBUL0chKlo1TymQrjyig_gaP4ZC9Gw_gBPQESBPg-DMKgqD4OEvi9HQZy9HKMAUPMsAwGwvQBMEDDyHKNTsPQGD_L0LD0G02SoOQ7TAkqNSwECMABIc8g6NQwQ9Ew8o9KC7CcPKGA7Ii5CaPM-Csuw6jkIE_wmNyqDJMQypyEk8h4MY0iBGwwyML0LrIo8Fdyy4EFMCgHd8k8DQoA3EBCAIeQ4EQKM4HQDQBJgRZQpwA7_HIYUNGZfxyhwK0FBgW0NBwKgiAmgD1zNEAtx_F8DxEI8TyPAMTzJClqVpelGWZNlyXkfgQP4ZscAAK3mVB-UFWh6EQEAwxATBFG5H0lVRZALVum01DtDNnSQDxsJweDrvgjx2U3fNT1piluVwIlXpATFfhRDxSf5uxJWFjxYehGAoCubn8GIWX_H8XY6D5vRFmgdAJZAKWztljWtblpEFZIFmVzxmBVCUGACcwIn4GF3G9Zl_wNYwWANB1gA9a6KJwKC-eyRQBb-H2oJwTCA5Z1kQcpGlUDpBlECZFkYHZfndHQAxcEFSBmmR1H0eoTGRWx3G0EgVAJBgKdKF2AAFY1aHIcRqGFggNEWGALacdAACUZcoQQAHlUBnORUGbDuu57jwMx1vRjXyFwvbJDxaHFPpaB1l2oBZuOwcTiGU6h9PyRRPOWkL6hi6FLGcYHE15GgTQR7-W8SdxmbwRgHXnpBKgFGfNZQgnUDOE0HYSapxcBbeAE5QS_27EKY08gZ7dwtvMRY0sJwKGFjAueltyB9Aum3Dmp804W0wMQuksZby4LQZDShG86TNn3JzFs0hkJ8yyD8Vu6DCGUGWCoNe4E8aUnYXArAigfgdmZDbKgpCswk07hgjwS4JAKKzLGLME5bDBTsAIi2P9YCD3mEsMhOtUCgj_iAVmIBsDEMWJgYWABtDw1jMAAH0TGO3XuIrIHgAC6sdyTx3BsnAhrJolAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/setup/NPM/src/index.ts",
        "description": "Using the Viewer API via NPM."
    },
    {
        "href": "examples/setup/first_application/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qnzMAhuh1QACIYwIQCsVgGU8vAA4wAIhABuMAE5DpvDACNKWRgHpxkmIJGMiMAryHk5GuLYC87EAFUAKgDEAtAAcHkLGgiZ4fAKc3AboAJ6WouhqQhDo7iDkuqq8cP5UNLxomiFwBPGwmQDu6QR4iEIAjAAMLQCkANxCkRAA5oSNAKxt8ljd8pRwEhDUjRowULzi6h5JVtmouXBpGR6b22smB3lJJimqgpxWF7uZhQQalFBwZRVVHvL8Kah9jQBMLTG3QMGkwGkaTTGQjgz3SQgAxDBkd0iLwNH00P4CJR5JCgVg1tcRMlUuVKjBMmiMViDAQcURIUMxkThCSrEs9ItWABZSiYKBCADqdQaomMnO5xPZjDQ8gArgQhBVFJkNLo-jAQukaqL_HAoOlSiBQutxRcrmyrHpFTjhDqPOhKNVUFBKPx_HoCFwQKwlM7Xe70EIAPJ6ABWMHIBBMNvp1EtMtuDpAlEVCoIBWodhKGjeFKp6MxqGxuIBBNZ7AIVZrMbwAGZWCH04rEBFGzFq12q4x5AtO7Xaym0wQM1maHRqyAB92u-SPtOuLPBwQ9LxyABrPpPeUYRoIsAtQ-HzozldVr7oH5_ZoE09L89d3oDAjlu9n5c49QaMBu6qNOByCeKAoHvR8a0XR9WBMPsLA_c41DOYwLWJRhAI0CB5CVFVKQ8Ih-XlWAyg0chMjgEjjDQTBcAIV5fRMdDMIIcJjDiRIYlQCJiCgVgQAAGhACA4AAITQdF4iQMBeBeGAAF8BPI8hKIwbAcFosgsmzScGAgIhJg0JVgGJIC-FoaR4Gmag-OMhZlhgAA1CAYGqfSCGstkAElzLgSzUAAQXkCB3JEDzvAWGAADl-RgYLQxbAgAogJRll4dzZKEMAniIIQPAAATgORFAuTRjFUJzqmNMDUEKco0lQCQhFcIQ8niaqhAACgASka1ghCMtljGMBxbNoZVIiEMrnNc5qMAcahUCjJUGpxMaYAcHI8mM6hasmlzKAMxrmuqYolRMuzHKm_aCHa_r2ROOBGidch5RsGgcE1AgAFFYFeghhPiDz0Ha_YNro7q8iEAAJbweQAGQAYVB76YF-2KRHSRo8PiC69oMjxYtkzqqpEQbhtMtb7BcHzZmEWp6iEeI0y0cRN1sGbg3wgUcc8DQoGJUm0DGoT1pcIQKqEeVReoNbKDAIQmaEbBeD02AhE5xZXjZGqlSp3zDt4Y6GrOsyLJpm7pWVCBWdfHKQBGGA9H-Xh_gANivXheAAFnrf5siaQJ_kCQI9ECXgmkBGAwCaABOT2pPrIY9BDpp6xgOPvd4GBAmj9AXaGAB2aPo6aXhAjzsAc74Z2WjD8hAk9lo0_z8h0DAN29HIFoY5bpoXczpohl4aPeBdvR614fP0GL_P_n-T2hiGf4i9zvR0CXvQmjAV2x7AMB6z0fP-A98gmlb-t0BGPe1099Au5roYXa7wIWlbsBAjAfP5_IWO3f4PRPaaL3Q-9ZvZNBgLPc-Lto5j3-J_esUcXb538InH-QwK5OxaOQCu5B_gJxDnwesA8PZ6EwRffGFt1ZQG5rzTGIBCCjgeoNOA6AND5xgPKE-OB2EFEnOqKA_gmg4AKgoGAxUNA4CoEQchVpdi0KIPEbyvlpEiEJsTUIQ1qDkDWvUNausaZpB2LZBIfEhB6ComkbClB5byi0J4DyisfqTk1iIMxGAAAK6Jla2E0HY9qejqBE2JK49An0sCuV8f41AgS2TBObKORUETTYBPvLJKqaAJBdSqtrUxVEPHqhsLQDQdjDp-KSagRoXkymJW6q4Xqt05qoFqgaI0WgmpPRepOd6thka_X-oDYGIBajoHqPqQ04IPDgx2NDOGHlUAZh6ZOe8JMhpgFsI4VaQgvj5O8VoSgEZFqmPiBYgA5DsVAXixrLDFhDTE6h7TCAAOLqh8pDXEig8xa22kqLZXjCmJUOpErpBA8m_M0P9CKXiBmwzoH0eoEyADaLQAC6ajSb8HDJLbC41mngmauQKgYI0B9GVFYnRmzPEFM0EITAkB6riGoMSHFmgcBEEFk1H5lKNCJRZYLAA1LbDwSyYRjOZWiLAh0OU7O5WKoQ_KPCCsZSK8RuQoDyjWuyilUrAo4BVWq2VAqQBCqZeI8oMB5CHQ8E0BVXA2TGpwN8T6dyCCwyErQBaGgBmOA1FqfizU4CtXIB1GpdSLak08PIdAdkNmSsKezBwmLKCsoAF7aOxWUi22SFrVHstJPVGrnAwFmddO1uqYDRPZDGzQ3LS2HSzTm1VMAhUiANidGEZSJEJuTTATJGbtrPBgDgN0fR2oAANw2RtoMGIZ9McSNAACTADrbmuSI7y1CFUZwVJHFsnBNCeE-xTVSnUzmEISpx7_KBWDX1LajSlROhdG6fgwlvSHXab9IFCyaB9KBhbR0AZH3oE9N6ZRQhJlQxhrDYStpqCfoIEK0mvg1l4A2dgaaezIzRkORYs5Fz6hXOOjsW5dA6pCCeXkOArz5DvJvbVVDV1_lNUBR9PdV1wWQo8GGcMQgWN4xAJ1RFKKOIiHvYGJ93p7VXkdZOF1pr3WesNJufGfqA1Bp6temRpNBFCAAEowAAI5qtqmSyRGZlj6N0MGSAqtNTurMwymR2SFhwEIkqJqLaGp0YMtyhYBn4DXWiaGoa_wcBQws6rMlTmXMdTJSJgDQhDSoA3J1Xtt6MrQBgDzQUTVItQAIBIrSNAACEAn8ALDAE2sWVFnQ4FxHQdqVmMu8xMR4AA-noJYiWJlCo3agLdNqd1UTiRmYph7IkVMUTTapan6kIaQxskcGZyXbNjXoI5EgcM2EuUqAjQgiP3NI88ijbzSifNSwtxUDG23nqBUNxUbGbADI8miTUQg3EdbWsJQwCLkWoqGjSkozV1ogTXJuDKu5oz6Lw9t6AgouRA9gFOyIC1vzzfitSlKBiJYRrsugGjSp5TY9oIjYH64NwlKzVFTAAB-CpYVkSU7LdNlLtVzsJUCslOwtbnIM6pzgCdvAcC0p_TIkQ7V0BXuDGgcougtGyzivEtnSUUpo1A36-XGZEoc94BV0mH0NlZoaW66sDmvmG8nIdVnmuUqFftdqh4k5ivIr5ylHXf2hLyCWEc4zBWlQQw98UYQtAsDG7uqb2Cr7KDPXfcxxxX6AY_tTPFccRuJlq-mbDNxCxYMVdgmpbABB4Y-8OgAKWkCGCKQjHhEogGAeI7V7c0BMagQiUATH_DXX1_mbu4D-7W3SiA0kzc0GJATidMBidQBBxudqlvtWoGimu0mLhTrSUn6TjK-0wcEBsWtUfdlnHWIV9yvfRPV9T8Oif8fZ_ScpPvPxQSIkxIaAkogKSMl5IgC-JuXgmocDhlhKgBpA3gQAwEZCAJgIoCpNVE5HRMgHlMIkVGoCVLtMaIgB4PWDgP8IIv8B4PJHhAHh4GgYJCpLgCwHzPxB4IxFhLAWAdLrxkQVslooKFRKpGQUIP4P4LVj6NZCADaNALjkgJ8OiEwaYvKPwXVNRPgNxLgTwZgKoEoGanQJgNAfAIQWAYwYsJ6LuOgLAHmIISAAAHqCLhw4BDDkIgA4RUFThEEGFDA4CeymG4GyT35CSiTnLP6STSQuAf5wAWYGC4CFCQB9B_4AFAE-6gEeBoC0oSAwCwyUC4iZ6UC0AQ4MpICPBqo8FODoC6YAYhioDwxyC_A-qIDpExQeC7SEEeB6BPDVAuB6E8G0Aqx2SVGf7CGLC4EuGP7uEv5v7eECS0SBH9AhHUBhETj0CIAgBgEmbpYaAhhYQ0w0F4QERET6GSL4SoD_7mELD4TqCF5EC_SwG9FlEgDwB8joCESFoThPDyCEGlE8Gwg2JaI8gKCEFHGyFRhLDqj0o-iv5eHHGYDkCfF2aoDPE3GeEyQNFFi2AtGfTSAuzmHlAYTRi3EaAZEeAjgqB6FEEpDlDmGoaaC6STjSQKEErLD7SwF3EeAowSAkn7RkkaA8i2BHx2AolokgCcwXG6awiqrfEtHz6YAyFUlYCAnygClIDwoeD8kwAtYcmwB0SyGuoeBIrOECSuFP49F_GyRalAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/setup/first_application/src/index.ts",
        "description": "Creating a simple application with a slider and an export."
    },
    {
        "href": "examples/setup/multiple/multiple_sessions/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1Delw8lD8SWVgsFgN8pRwEhDUZfx6cJRQAK60DbBgBGWdXASU8ps1HqmijOS6qvxwXEV5p6jncIcmt_dHJumqr3DkGhDyBNtJRR5IiUdCLWAhOAach5KHkYxoTC4AgPECsExfH5_cImRIpTgmFhQYQgAA0IAgcAAQmh-BokkgwPwoC4AL7kuEIjDYHAosggKg0OgEBgQIhjDT_YAODQCWgANQgMHyEoIpJlcpg0ngE2oXFZXDAGkoRC4HgAAnA5Ip3ppjKolflNB46rFUAAKC5JVDkLjugCUXFcrC4wDioWMGv4tC49gdytV4cFWS48ZVlElQdj-X4EijCsdqvdYZEPGeFzK6Eo5EWNhoOGatgAorA6wQqUkAJLod0ecuowMXLgACW8AFkADIAYTOFxbMDbpPDPCKZQ8RCSioTGYIHnDrP9rtQ4eMke-mtjmR1U245ST1BTLjgutQ5Sz_BzefP0a11-oxeXbYIHIABrWxEEAngPAAVkqGA9AAJn4BCADZ0HQfh-AAFgAZgQ05ykCBDAkCPRAn4coELgsBygATiwpkcOgvQyPKHCYAY3D-BgQJaPQFDoIAdlo2jyn4QIBLAPiBGQyoKPIQIsLgrDBPIdAwDQvRyEqOi1PKFDuPKaD-Fo_gUL0HD-EE9BRMEhCEKw6DoIQkT-L0dAXL0cowFQiywDAHC9EEwRMPIcp1Jw9BYICvRsPQHS5OglCdMCSp1LAQIwEExzyHotDBD0LDyn04KcNw8oYHsyKUNoiyEOynCaJQwT_GYvLoKkpDKnIKTyAQpiyIEHCjMwvRuqijwl1LLgQUwKAt3yTwNCgNcQEIAh5DgRBTzgdANEEmBFjCnBDv8chhQ0Zl_HKHArQUGBbQ0HAqCISbANXM0QA3bVnxvO8QH3Q83R4U98xgS8nxfLgEPvVBHz_VAEPfT9_m_WgfpfADpvEUDwMgz7vOshiPL0ejRLQpysMCGAYGGsALNo8gmYQh6gsihDyj0Wn6ci8gnOKvQUMowTOdomiWfIYL8Jw8zJdg8ghZgbz8IYlCEIwwJ0DGgT-IktWGNI6DwoQjSYGEyysNonDUuyg3wuMvimJMsByBwyokMltirMEiSYBEwJYKI5rSL487ylKtLrdU8pLZswTqgQ6C-vO2izasgP-D08iLLO2joMCcgsKitKqcqOy_fOypaMqaDRMClCzeyt7ptmmB5sdJaVs-9bNu24xdsO47TvOmhLqga7butB61E0Z6TWbqwPvXJIMZvGGAZEA8jwPAMjzJClqVpelGWZNlyXkTOQP4RscAAK3mVB-UFWh6EQEAwxATBFG5H0lVRZALR3RtDPDQ9pHTOiQB4HCOAOYwI8OydcuZjyQIpNyXARI3ogExL8FEHgAFYLsJKPBHgL7QjblcNB-BiBQC4P4fwuw6CYL0IsaA6BiEgFIedGhzDWEUKRFQkg8ClyfxgKoJQMBv6YF_vAPBH9OFt38MwjAsANDsIAHo3UojgaCmDsiKGwX8dR0EcBYW0fA1k-9KQ0lQHSBkiAmQshgOyLBugtaGDnqgSAzQ74PyftQF-Io34fzQJAVAEgYATkoLsAACsaWg5BxDUDwQQDQiwYDCKcOgAASm3SgggADyqApxyFQI2ZJqT0keDTOwvQxp8guFUWSDwtBxR9FoOw-RUB4GWMPjY4-9jT5OPJCiQUXifHUD8UKV-78-wmnkNATQ-S_g3n_h_Wa4IYDsJeiCVA99MGyhBOoKcJo2z_wcS4YR8Axygg2Z2IUxp5DlLScI-YiwyFjgUHg85lSRHkD6JdRJyCBmOOEZgP5dJow3g-Y8k-ILml0kbLuFBTZpAoUwVkH4CSnk_MoMsFQjSIKf0pEiy5WBFA_DbMycRVAAUZn_ik55HgFwSGpRmaMGYxy2BCnYbFwj1mwByfMJYgL2GoFBJskACCQDYD-YsTAeCADaHgxWYAAPr8pkU0olWQPAAF0LHkisUfOx3zWRmqAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/setup/multiple/multiple_sessions/src/index.ts",
        "description": "Creating multiple sessions in a single viewport."
    },
    {
        "href": "examples/setup/multiple/multiple_viewports/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZQCstXUeqaKM5Lqq_HBcRXkDqENw5T0mE1O9Jumqi8uZ2bkehcWlFdX1jTAtbVydBwSU8h1dPXFWvPPDo-jjg8MATLPGj3CLxsuLODkDQQeQELjZRR5IiUdAAV1gITgGnIeWR5GMaEwuAIcC-QJBYPCJkSKU4JhYUGEIAANCAIHAAEJofgaJJIMD8KAuAC-dPRmIw2BwuLIICoNDoBAYECI8koGnBwAcGgEtAAahAYPl5YqaSq1TBpPA4BBqPqAJLeVUwABysJg-oA8gAlbwACSdAHEXQBBAAK7otAGEAPrB30AWQAon7Q0oLS7o8HvBanbauDyuGANJQiFwPAABOByRTLTTGVRa_KaDzdVCcAAUwySqHIXEbAEouK5WFxgHdjMYDfxaFx7FXtbqCDMRBKslxJzqFTOe-P8vwJCONdXp42ByIeD8yuhKOQ4TYaDhmrZo7BLwRGUkLehGx4fjMQN2nu7vJGADLBm8cB3jAD40ncPBFGUHhEEkmpTiun53Dynb1oOw7Aoa46LruK6fHO1ALku07vGu_AbluWGjjACHLoq-6QQ4wEnmeF5Stet73lKT4vm-4rAZ8X7jiMv4AUBkzDKB4FMdBBYgHBdGkR4KFobEIhDtuMA4S4cCmtQdzzuCun6dwrjrpu4LUbQxp6WaqCMYeEIQOQADWtiIExPAeJ0MB6O8_DvAAbOg6D8PwAAsADM7wDOUgTvIEgR6IE_DlO8lQwGA5QAJwRZyUXtHoKXlFFMD5dF_AwIEOXoEF7QAOw5Tl5T8IE9VgLVAiBZUaXkIEEWZRFDXkOgYAhXo5CVLlo3lEFVXlO0_A5fwQV6FF_ANegLUNe87wRe07TvM1dV6Ogx16OUYDBetYBgFFegNYI4XkOUY1RegnT3XokXoNNvXtEF02BJUY1gIEYANQd5B5SFgh6BF5RzU9UXReUMB7R9QU5et7xQ1F2VBQ1_hFbD7SdQFlTkJ15DvIVKUCFFi3hXoVOfR4EFOTCmBQHRngaFAMEgIQBDyHAiBDnA6AaA1MBwq9OBy_45BShoXL-OUOAlgoMDlhoOBUEQHOyegQtwbZpkqSIqHoRpmGqjROGoNqXArnglDNGr8h4C5zE2GrhlEVZ_D-_Y5kkfhBsO7QTqKu7nsKD75BAaHXb1keIeaPwODpKq5DiNQa6uh63p-oGIbhlGsa-vGibJqm6Y4L4Lrpt46e4YhirvDgwyms0qAp1njYDKHOBFGpqCoWnnC0vSTIsmyHJcrydLyPwbn8DeOAAFZwNQYoSrQ9CICAA4gJgihCm2Wp4mQRba2WagVkutZIB4UU4O8mtCXysGbg2b96RClwJSY2IACSglxB4ZAHgsisgINAjwa8UQwCgKMYB-BiBoP8P4S4dAwF6DhNAdAiCQDIJVmgwhxD0HYkwSQDwv9z4wFUEoGAl9MDX3gNAs-5DUH-EIRgWAGhSEAD1NbpRwO0MBkJ4DAkgaI9oOAIqSIYTyWeDJmSoFZOyRAnJuQwD5OA3Q6ADC4AlJAZoO896oAPtQI-0oT5nzQJAVAEgYD_koJcf0uZaD53stAggGg4SOg8E4dALpUGUEEE6AechUA3gCUEkJIAlykL0LmfILhhG0g8LQOUUAaKkN4VABh6j55aMXro5eBi6S4nMS0Kx-9kDijsVKBgZ9DbyGgJoJ0YJ7K3xgQpWECIYCkMNjCVAu8wGqhhOoYMeYHwDL0S4CCIB4CRmGbAC0kpczyEScE1Ze84QoMjAoaByzkmYHIAUtWBcAFVP0asq5NzRz2VOXspejzcmshvAgwB0ZpBBTAVkEE-d9nJMoHCAgKhsmeXPgyP5qzsCKBBA-LkrCqC3IVAMwJByPBgQkBihUo4FSRlsM9Ow4LVncxGREveUAoX-MAagB0DCkVYGuXCTA0CADaHgWWYFDDS2At8nkIo8AAXTUXSDRC8dEXJ5IqoAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/setup/multiple/multiple_viewports/src/index.ts",
        "description": "Creating multiple viewports with different cameras in them."
    },
    {
        "href": "examples/setup/multiple/mutliple_sessions_and_multiple_viewports/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZQCstQ3pcPJQ_EllYLBYDfKUcBIQ1GX8enCUUACutA2wYARlXVwElPJbNR6poozkuqr8cFxFeWeoF3DlRyZ3D8cm6arvn5nZuR6FYqlCrVeqNGAtNpcTpgnp9AZDEZjCZTGZcOYLZarLjrTZcba7fbQrpHOJWXivS7XdC3c6XABMz2MlLg72Mn3ecHIGgg8gIOySijyREo6CWsBCcA05DyUvIxjQmFwBDgTK5PL54RMiRSnBMLCgwhAABoQBA4AAhND8DRJJBgfhQFwAX1NcoVGGwOBVZBAVBodAIDAgRHGGn5wDJ3IEtAAahAYPkwwRjVGNDGYNJ4JNqKmRNIAKLSaQASQA8gA5AD6he83hLFYA4tIqwBZMtKAucZ1cMAaShELgeAACcDkik-mmMqgT-U0HjqsVQAApLklUOQuMuAJRcVysLiRkTGYwOdP8WjorgzxPJp4if1Za-zu979H5fgSM8Z-O3yjh5cjysFkynQShyCWGwaBwZpbALWAoIIC0khLdBlw8FknhAXcqQACW8VsABkAGE6TgeCYEQvMrCKMoPCIJJfyTf8CCw6jRBcOAc1QLMCHEVBmjgVC6JABisy46ZUDYskeE47jeP4wTW1FGAykLYty2rWt6ybFt207HBWwAQQrTwjMIslnW3RdUDJE9vwvGArzkySKijagnxc6hyjffgPy_aNHPE7jAJknYIHIABrWxEDCngPE6GA9Hpfh6QANnQdB-H4AAWABmekznKQJ6UCQI9ECfhynpSoYDAcoAE4codPL2j0CryjymBmvy_gYECBr0DS9oAHYGoa8p-ECYawEGgRUsqKryECHLapykbyHQMAMr0chKkazbyjSvrynafgGv4NK9Dy_gRvQCaRvpekcvadp6XGoa9HQd69HKMB0uusAwDyvQRsEbLyHKLa8vQTpgb0XL0H2xb2jS_bAkqLawECMARpe8gmoywQ9By8ojrBvL8vKGAnphtKGuu-k8by-q0pG_w2sJ9pZpSypyFm8h6VaiqBDy07sr0PnYY8dieBFTAoCYzwNCgETCAIeQ4EQE84HQDQRpgJZIZwQ3_HIQMNEdfxyhwMcFBgScNBwKgiBlsLaKHUSkmCyTpJEHhsHIZZMCY5Mta4ABtejGJfFjGRAABdSzrKXHh7MCy97BvZjw0ZB8PP5bPk3pXz_P5DOYFDljQv9hwyNA8DIMDGC4IQwNkNQ9C_TI-OcKufCiNI-5Lgoqj3fQESGKr3O3drryeNsRShInz2xOzST49lzJ1-oBS0CUlS1KLUtKxrAs6wbZs2w7AtDJMsyLJEKybLs08K-cnfuDznhH35eeS9cO-T85dzy0B9tQGuVhxBRRinFT2f07rNW-noJqE0MqvRyoEGAMAxZgGug1cghD6QO1BjDek5Q9A4LwTDcgr0yZ6DStVEaFCGr1WIeQMGhU8pXQ4Z0cgjCYB_UKs1NK9IsqBHQJLYaQ1pqiOauVdoUN6TbRgGNG6OUGp5QxnjeRUMzqDVaudMA5A8qVBShwzqt0RrTRgONQInQSps3KoNc25QKaYy0RtcoGj7ojWqPSdogtzYNVUbdex_BDqVWumbBq7RAjkByrDTGmDKiPVsebSoDVKjtAmiDNKqi8azysPLGAitZzK1Vp7dWmttbGF1obY2ptzY0EtlAa2ttxwOzUJoZ2A4imiA9tHcBqBN5hUDsHSusdwzhyjl7aerEPBJyfinVAVkdw2RNGaS01pbT2kdC6U08gImRX4LBHAAArBYqBfT-loPQRAIBIwgEwIoT0G4EyqjICOO2E5ukaGnLOecSAPB5RwOQsFHhXT0U_LZYFZpPS4ANG7EA6peQqg8MgDwWQbQEAxR4I50pSnXARfgYgUAuD-H8HsOgyK9BLGgOgPFIACXm3JXShlxKlSkpIJC1MzyYCqCUDAV5mB3nwAxU8llpT_B0owLADQTKAB6Ntqo4HaMi7IihUV8iVe0HAOU1WQudJs80VpUA2jtIgB0ToYCuhRboSRhhemoEgM0C5VybnUDuUGB5Ty0CQFQBIGAhFKB7AAAr9loOQcQ1AMUEA0EsGAfKnDoAAEqlMoIIMsqBiJyAEjAONCak0eGzkyvQ_Z8guAVSaDwtBQz9FoEyqVUBIUmu2ea3ZVr9m2tNCqf0rr3XUE9QGe5jyMIDnkNATQZY-SSU-Zi0SopxQFrhS7EUqBLnIvTCKdQxEByIXndalwfL4DKTFLAEsAZ-zyELYmvlCwliEtbAoDFR7i38qDjaC8klX3dr5ZgT9lsY2oGfTevZNq-V2A0LBXFcKixpWRVkHk0bb3vsoCsFQ1bYrPPNLBk9WBFA8kQo6IVVAgP_nnfGu9HhKISFI_-C8_5Wy2HBnYVDfL5bLvTZiFYP64WoBUrymjWAg5LEwBi2ZAnMBVk47AT5_7cOLONaaU1OzLVvudJpoAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/setup/multiple/mutliple_sessions_and_multiple_viewports/src/index.ts",
        "description": "Creating multiple sessions in multiple viewports."
    },
    {
        "href": "examples/showcase/Lamborghini/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=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",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/showcase/Lamborghini/src/index.ts",
        "description": "short explanation on the example"
    },
    {
        "href": "examples/showcase/curve_preview/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1Delw8lD8SWVgsFgN8pRwEhDUZfx6cJRQAK60DbBgBGWdXASU8ps1HqmijOS6qvxwXEV5p6jncIcmt_dHJumqr3DkGhDyBNtJRR5IiUdCLWAhOAach5KHkYxoTC4AgPECsExfH5_cImRIpTgmFhQYQgAA0IAgcAAQmh-BokkgwPwoC4AL7kuEIjDYHAosggKg0OgEBgQIhjDT_YCxOzodAAGUptFQmlJMu-Alo0ngE2oatQ7AIGv4tAAahAYPkJQR9YaAKKmu0AOW83gAmgAFO22ggO52uz12gD6AEkXXaAEoAQQAwt4QwB5J0-kPeDQwGBO0EwH0AWRNmggzOkdgwdPQShN_B9XzoMDTGZ93jw6ZgACs4JW7E3W1nMPrWVwwBpKEQuB4AAJwOSKd6aYyqC35TQeOqcMXWrjSg0EJQafjNfOoA-qmUhoX78jiahd6tni_8K9TVB21DNNA5--0S_Xl_qGgRvAYyoC4-byPIaDND6Hp9CqMbUFk-5oDanCDsOo7jiAU4zjAc4aAuS6aDgYCaos6ZwDgyGaI-v6ruu4qUJKXAAFRcBcXDeAAEhGdp2kOI5jh4JStnRBqoIKWRsXKaa6HAfS_t4lAepQyFcK4XAABQymMyFlAA2qgixEHoqpcIZxmmeZJkaAAuj6RAmj8WBlFZmh6XZnAAJT6a5GikmZRnWf5vk2WprBbuqCH_FgalcPmJQ4COiwYBpGk6TQemVKFADUXAOQQTl6eUABMNmeSxFTVOVxiVZUa47hJ_xJLF8V4IllDJegqXpQQRU5XljkQFgRUAMxlRVHTVbV9WGo1XAAF4tSabVJSlaUqRlpVcLl-WFeUAAs42sZNoTTTK6YEGR3B6Vg_lJP5802fVrIzagGkXEk4maeVrjhduhrGDVxq0GxXCLpa1qRSB_zg1ajH_Op_D5PwEgOOmBbmhD8Maf9BCzWcFxlOglDkEZwo4M0th2rANg0FSSQhl1HjPBcHjlexnHeLm8oxgTcDUzAtMoTuhpFGUHhEEkmNw5KHg-qynkzQQgNo5qMCgy4cC6mJs1RZkOrPrFSMo_8wMwNqWvPjjMqGuI5AANa2OLICVAA7MVMAAKwjZ7YDkOUI0CGAeiCK76CBPtI3kK7YDFdHxVgIEUeuwI_AwAAnK75R6OQ5AjegxWe_w-1gPtJcwAAbGAKf5zAlTkHorvRyNeglWABfu9H6dgJ7rsVxXI0V5UxX7eU6fkBnI3Fa77tJ4EweV67I3p_tQ_oHngSVOU2cV4EI_p3XcflOgS-BDAIcR9Plej-UFfj5Ue8ZoId_8PXlSx0XFf7enej7eQ1Rey9lvcgP8YBlxjpUQOgR06e09hXOO4dG56HQBXfwYBl7FT0HoYqODPYB3KPwTO5B9qPnIP3T2MBAjF2_jAuWNtiDZigNLTwGgoDO0IAQeQcBECAzgJgRY_scAwEWP4CeNB9xQH8OUHA04FC4TUERKgRA6Ei3EOgZ2ksLbaxUYaBWr0AZA3RiDEo6sqI_mfK-d8Ko2IYC4PIEci5MBXH-CYsGS5NyUD0G2GAV4oaSTMTRCxb4PyxRVPkLg55vyBOoJYj8GlYbWkVrEHcKszbbCiFwdA-5Dy6BPFoXQ6ApKFIkH4_4WSDxHjyaEy0XA9wVNyZTDQGkkk7nKTk48jShFgBIleeKhZmTVPCX0n4xZSzoHLLeHGVAoCMWdgAYmqN06oHg9EygCU-GJwSVQ4EEOgSJ1ENmoEqY0jSbTjmaBaTKFWuzQa9F0OrRqSEaClLsbBGA8FoZPIRmZGpMF7kfMQijGgGlMr-UqP5codkuCgq4OC2FZUlYq0WC4dJ6sdiO24DsLg6YQTqFRQ4KKXy2LNCBZpHFlB1B1OaACgqQKCCeReeiugsUzkNKIrsqlNKvlpTeVyullyUk1RjEY9W9hFxwEWMyCA80TSGyiFARQWhUDZi4PkKI6ZVXqyyIxNFGSzE2HSAWBwZF1APAanrZVTj1JhI4r2bMzSlZzWEhmAAUp2KsgyOItgzB2SZNquI8TtDgBMXifEEBGkoZplyCCWpgDsuUkznUwDdbeaNsacCLHkOMs0mhtYOplLWFUDY427L7DADSsbo2FvrK2dqlACAZqzRjXNVsBUGK4CSkx-SoBQC4B1ThyxLglBNGxDVKpcK4SHIxdJlIuDYH4OKCE5roZ2I2iiBMyx5DLFiprbWOB-1bpRHpDwgQCF6F9jnMAFdiEF3fuUIuKc8ER0qPwY-wCPBPReWMKASRFQqg3QO75u7nz7s3YO49IBb5MnPTPPQLcQ7p03jAJeUdyjByZK7SBK8wAfv0eYU2ZF0w0GUshc8SJYpSMdXrHq3DoW-WCoFSyjHbLuViu5PD1zwI_psVwTN2aHnMigCHB22xKBFIiQ-Q5t5tJrrgABw9jb-O8x7cJ-2sUK2WjLQAfjKKmO1mAfp_XoRAMAmkACEYSy3lQuldPDhoaM4FgG-EosU6qhCBrAOk-KaOjv3M1EyYAdVFMgj88JNH6GBa0BpWA_wICuYaHFxgoWy04EcNALJdBHN0GaCUBL2VsrlVxoadtNzXHrN_Jkj1WLXHAeoPQw0lnsypbwOlojekIA2RwNm_gOAt3Tg0-E_Z5ibxVhxm0soBVFgwAVtG4rMbNNNb4825wra7N42VjVTt6rvNrsq3YKdWh5KaF4y4erRo9ZiO_GpM7DWFuYGa61ug7XOsGE6pBKkhgcCvYwJBaQ8h1Vxsu5oNb9nZO9eRXgEFN2CCtXap1DSQONCZVCsdKqp0Og-jm4aWHq0uqI76hNNHNUMfQ5xx1FK-Otqo8qFNEnqjDQIvoayGUL0ZPITk2BhtS3aDKaE4-e2612fyeWDgStHHmLMRlBVBM3A2mZDsJKfyy4BqO3xaTDQRH_jfualAD8lw0DiogHoJdhoWLGBlLsxUWQ6xNL9C6d0XocBhm8JGWM8Ykw4CUNGAA4kGaQ3gowRm8P5DSMBDMRVUXNNpdp_wIzO6Ky4Q3ol_mFIBHoCEYBgQgm-PSduAxelDOGaMcZExOk9z7v3Aeg-fp1utyLmkYtXHi03pLNHhcNtjWZh7UAMuoCy85vAeWCsR6x-dldaWe-xTb5z0X2Yu8T9789pWc2TOaQX5RQprgt-ZOyTH8m6aiiFeh-rzXJGaBkewLFCAy_1uGj0Oje2N_dFM-SXN7Xf6YDt9n5gLvhvjfq3UiZBZBgBv3fw_C_070U2WzzWjVWVr2MAlyl1Yhlx3wPDygpRzE1Q7WWmO1cR8wKVViNXsHVzxSxXFUlV13ml1QeUI2FGxXgHBDxh3DNwtzlCt2VE0A0jzwdyDWd1dxLw9y9yjF91zATEdBDzDzChH3Wyj131j2u3pxBnYiT0OT3wAiAgzyz0glz0dHt0DELxd2L3dzLyEJELELtBr3oTmkEDbGRVoHQBjFoOI120Rmkn3BAnkmfEUjPwIC0kUJoz0hP2FB8IvywA8kUOj1jxwF2iGjYkuF8nckx3pTW0bz-EuHUgcwcnkG6htCuG5CwHDyK3W1Xw0kREvy33UiCOcNI3yKP0UMNBsw0G4H9W4l4hwFNDDUYhGj8NHzmxsLsNwkcI12CLXWRySNH36OtwcKcIIB8L6nGNv1lFsKmKGNP1GNKgWMNFm3W2Z0UMaOaJqQDTaI6KvC6LSl6iyn8j-HmLsV6lKm2LgLm0bxIIANCw4laKDV5mIHBCgAjFHCGPUG6LSP8km0wOZhNCIB-IEjllhRwFdk9m2KdW9RgB8PSONQ0HUAplsFRI0k9hpxvzmkplHFsHpE9SOKDSpEWG6U0G9xgGJIKiSGaRkVsF8AEhxKTVRMRL1nyn6V7WtUOI-JwA_ypAuAgHIGGSLCgCmQWFmVhSwGqAVMqEePWxVmFTVnxUgGPF7U8W8SvFE3E2qwyWrSsIuxNU_1DT1P5PCXJKFLiSJJsAZP8h5JGSgG2KTRTSrH3S8ViheJDV1IIBv3dPdTsCgJzRW2oHzR3EeJSUQOYOQNl2yTnQwCV3Vi22O0Ex21Um6xsUKVJm1SIGlWoMyDETjSQPNx3EtyVBty4N0Pz14KLzd1L3L2EKDGdCUH8g-i-lD0KJNJXUiLoPcEUITwkyiVUNjzT2AlAgUGz2aB0P9B4IMP4OMObN9zbMsMjz1lpQ8NlWoHiichZTkPJhiJGF7MkkmPsNWJGNUlcPQBkm3IUiUjXR6MWICKqNmLXVCPCNHy3Lkh3KOUGhinYgSK_PWzbXW1fJmJCPyNClcOWIvMgrXTW1STsNHELPxWrVVQkDwEzJoD234HoVqz73kDpAXVsFzQgxDmQUwBKn8C_lbn8D_kCECH8GoWYv_n2kbm7hARTldg_RwHOCWAALOwAANpQQBwskAAASYAF1aQD3RCSCEzRkmjTyVkVkYSm_Y2VGQi1LFCgsqgjSTqGATU3CfyIyky9AEEjQKbMC9tdMO5CeNXM0uxdMWGTClzXQOdcUbIPtC0pgubIM28L0tsMkwUv0sNCNSM-hFWacSgcJPAhYX9EJA9bdA8IFehMA_9GfSAv_WAWKUE0AxKj_CAufUMmADo8Mt6bYnS9NbncqltCM2AlpBWSMskCkakWkekRkZkNkckYih2E8HADsagfkQUZUEURAEAMSzARQbkcSC0VEZAScWRWcBRfCWGFcJADwEaHAYqaRYqOhLCFa-RdQdawiDQYiUiciSiSTWiLakAHava3aw6pNDwRADwSoHAcoCOHASoFZNUEAByNAN6jwMo3AIkQ6zEX4FEN6sSrIOkPGe64i6EGAXtMG_AYgXtfwfwXYOgQ6vQRYdLEG8SukCeXtAm9LPIpEDGkgf6jwTAVQJQGAWazAea-AWGjwZGsm_wAmjAWADQYmgAPWkRKhwE9hesBHgG-GhqFs9hwH2jFpWVZDaspBpGPC6sQCAN6pADgAKQMFwEFEgGaCGvmFQFGuoHGoYDErQE1IkBgHlEoF2A9BHFoEOTetBIBqcHQEAhmUEBlxjDkDfBgHduss_BAFhmJvvzipcAFrJCEkFjuVoGJq5tRpWRVo6vVoZE1p6um3JBRENpaBNpGuQAFAtuFCtuZlHAgn5oTD-GfEWrEpBDBAhHuqURBFQA7EOvJXUHgiICFkWq1rDvgFzFBHBBgCG12BDqmwBvmDIgnjAjesHoBswHID6H3DuuzuAOXp8TXr_IXu6q3qEjpEpkRvepADtGkArkhoKjFNPo9o8H7RUFjrPu6ERoBuwEVTFGFGZCZqoHXsYkWvvpAEFgkF_sYhNEYlzFsEECrCnrDqbrHrTwWGWGfGJtjTpuAawFXsWEwDeog1jSDAQdgFRGXqVA_WVvJFVs6qzsHrUtZCAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/showcase/curve_preview/src/index.ts",
        "description": "Preview the curve that is exported by GH with a three.js object."
    },
    {
        "href": "examples/showcase/door_hover_animation/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqcVZccARJsO4gmVlcAO4Q6AR4iFwAjAAMdQCkANxFWVEQAOaE1fVNrSLF6XDyUPxJ1WCwWAPFPPKUcBIQ1NX8enCUUACutLNzsGAE1f1tVgSU8ictZ1webamijOS6qvxwXOUFL6hvcB6sEw_P6PEzpVSguDkDQQeQELi5RQFIiUdDbWAhOAacgFLHkYxoTC4Aj_ECA4xQmFw8ImRIpTgmFhQYQgAA0IAgcAAQmh-BokkgwPwoC4AL7svEEjDYHAksggKg0OgEBgQIgLDTw4BtaECWgANQgMBKGoIrJ1Gj1MGk8CW1HNgy4AFF9U6AHLebwATQACk6APoASQ9ToASgBBADC3kDAHk3Q6rIHvJaYG7UTBE6JA-HUGr-OJqEoC_wszxc_nC6hi3Yy1xBOgADKc2ioTR1m1wO2oWO7eS7Gv8TiirhgDSUIhcADkAAE4HJFODNMZVEaSpopwM1aauNrHQAJSjqDQAWV0_E67bagaVGn45Crg7rN9od4fK1QTtQnTQmevt_vKsnXUGhQ3gBZUBcM95HkNBOmHUdx0nWd5wUGAlw0Fc100HAwD1bZLTgHA0FfQCP03Tht0oTVdy4ABHbYCy4EcxwnadOigfwiALGEsAo1BOGMAAqITOCErhvCSRQuEwSA8yrUdqIRKJ6zzbiFNktBlmoHAxLuVBxO8FTdErD8ZJgOTtO4Tl6y4AApaR4y4Sg9AAKxgB9lKYzS2w-SoYFU0zqA-MAlP8mTKGooi9KMmyXPczybN1At0K4PQkmUgLZDQlRjy4FFMCgVT0E-D55HeFwSouTKuFXY1NHrD57Acpychhb9dIM_TDJUgBrGAMsoMAavijz4Rs8LUH4GxnOG8L0EijROp6gK3h2AKhpGtyxtK1TnO2zyykqGrQqgKBKDKb8uHkcdFE1I04EQPSuH8BEpJgaojICxENrm4y1ILD8cC4SMCMtGgoEG1BIbuEBxzsKsQhsuBthg6jaHQZaeFetbtngapc3rDQ70G4bRofD4jrwE6tnOy7Omu27NHEfHnqsV7-CwTlPuMrmPk28L4cB6hGtsgBmJRarG6isayDnv1gHmAt0DjfpqoWFLQLg73SXRoq6l6ETVfGuEJvkSdmo2bA-LWXEVdB9fEw3YNUShjgklSXbd67KBIy3Bbd4XuHecXJfUB8Zee16cj5d2vuyOwaPEGaBf-oLrO4O3qAd2XXrRO8qyVmSCKD_20_UszbY87PHeMTgftNgHHwsrSFNcXc2gAbX6iYE_azoAF1qj3OY3sUaopw18j9mKXGTeAes-eqTvUG2Ig9HbLhV_Xzft43jQB-aVTVeqPeGtFTvD9uHhk5Ns-NEvmesi992V7X_fWS39_d-_g-n6sGOmpT6_3_qIfOQdgE7w0E_UUAxYGxFQMJUSXV44mQriLHyVl9oJQIFjGKeA4oHXGh8bYlUESUATtRb65dS6YIUpUJiNlypdlStVcKdV1xaHSjVbKihcoNQKjAKAy067Q1sIFdB1YW7yQ_ATJuH4lDSKwe3YA8CBKoAABTvCSKgcgXANEAEouCuFYB3R0xhjAOEtClGqHDTQ6mCvCOx6NjH1hKPwCQVirSGmNKaDRI85jlAnkQJIPiTToynHWKwwJ3jVEYPubwJ5GyRleO8J0sAbA0FYAtcga9lQ4EvAQdJMBMkEC5EkQM6ANFThiXAKcBi2iigMU_CxXibHhRcF2D8DjILwk6d2Vx_B3GeOSrQTs3Z_HX0-OgYJSRxnkSiaIcQ5B-rHCmVYKceh0A1H4PwGAABWAALAATkCAANkOXUQ5ehAgACZAh6AAOy3MObs8gZy9BnNuWcsAZz0BgDADUQIxy8Ji3OYEO55zDnkCuY8455ByC3L0GLQQjzyDoDqLcvCjyzli0OY8mAty9kWUeXocgYB9kwDuZcvFxzDn7OOTsnZ-yagAtuXUQI-zAX8EeaS_ZyKahiz0IIY5YsvnoH2dss5jz6XvLFo8sWMA9AUrFqcx5-zMXPLqEKsW2qvkypqDAQl8Lbl0teTUQ5YsAVnMCOip5_BjmfIRX8_gkrhX7IJS88lZz-C3P8HUMACLPn8HxY8nZdRPm3PIPs-5_A7mPO2cc-F_LyCRKmYIqAYTPAaCgBPQgBB5CPQsXAdAGgCXbHIDUHAMBtj-HIMqO8nEq2oUXGoHCVAiBTkac0hBVhWmjOoQFEimgyIizoD-NsPScifAAu-agX4J0BXbm2EoXAXwjrnZ-b8v4NHOM1D29RfbLEDpqngI8AjzyXi0LoEqDZPjwjYSpYdb4FLjt_FO-EZ7jxnimle1xK6uCHm_ZezQhin7PtHVuxdOAGzrpfR-H9F5QNfs0Ihq9B62itOsSVSguwaoLSUugEszk-x4ZvRFKKJGC27A_RRjQg5ezUfhO3fpQNCmMf7GUpIbppowGqUoRag56mdzqFfR0ipp0EY0BxvDLHbRsdsDJrjPGbD8cWnUgxImxOYZEmccS4Z0C3u4DAEC8IoAtjoA1UKWhwooa0GO0znUsjiT0x7GyJnlRcHMzkSzWgJowk6Fe1KJQojcHCqQhqdn-Z5XsKgDMTmrDiQAOqhZqhFrQUXnIxa3hmT-4U0Gl2szVOLmBdqAIxgl0QLnHRcHEumWgRcGzNh822LQYBti6KrB8S0BACKQVshcfqYW5Dwh-GlAKEWqoUMtCidQNUPM0C8xZ1rlWeBCVEVYJry3QMundJ6X0AZgzeDDFGGM8YcD7ljK6UM_p4yfw0TAIxJizGjwk30oRY0PzAU8-3ZWHw4OQe-6BcCwUYDQVgt-Tuu2PTej9EGEMEZoxxjdBdq7YZbtujE69xx2QPsPnQumUrcnYCbqB7gkr8AtOgJ4G93HJOMaE7TLx1xLh6cE_i1NGw1PPjDV3WuU0MH5HBU7qzsa7PMAqZgAPQXlYl2uHbkKEUj31miD3bggrXWRd44ZxmSX0vysVkkWB7tAwdPIOc1wMCP4fPXu4KjIjtAHDCigMKlZikbMqSkzJYjuGmOrdq_pC3sUSHyAdwFF4Z1Xe9V2gQALQWSohboPhxa3u7BUc47te3KVMaudczOcqd5JwrsZ4HxLXAZw9b6x8PTG2wGCZLEpnAWfaApMj_eaP7cNHF4zAAfmqMmVMjOnumICcUCAvOACE3fMBGMrxoVApuauiFadgWPgEaoa7MnQsyrFJzhV9xnh3Q4l805xwfgcxHl3GkZzgI_uFCQaI0egYfMkZ0x10TATa8zqBKcHAYif3Om-RYSibc-i5-BAg4os3-PYpGEBJYBiOAhEEELgjeiorYBAE-WmKuPAt-xGIchuQciilkVYi-o8rSseXQf64WoeNiEeLu7e7uyelG4BUy4--iUmjezeMAre9BKyDSJ-WQHBsBTeNBLezuUeT-i0jeFOB6VgaiR6CIceDU1BYeTubebuRW80KeR-6eeG1A9a5CM6ywwoEAAAXoOhIrQiAd0o6FJgxsIVwTwRIXYQ3sITIaQcvrpjVuJFbhZrblwFwWobwdHpoZ7uprobgrnt4W5iHqoXQVHjHkoZaAnqllocwbAZnqIehP7tVhbvnnyNNFvNfhmKXlVuXnPv1jXm0EIX7o4eIQwZ3tPjAH3muimEakPsYiPqwZPk0bPrYH1h4cUFhiUuevWGdFwNgC2HBJYRpMRrvsVhmP8AIU0bgXYNgVwPflAK-I_s_p0a_mgO_vWptAQY-PAesbhNRE6PeHgI_oIC_isTNueoOFos_hhgIeQXeMeC4BvkLtwNviLORnevlr8anvYI-gFBTksaPEVhorTj3DOjMQotYdQEYqPqPA4DjkAVIsNO3FiUQa3B-N3ANNpgIQoXJFVCpBTmlBlJzjAOsbTpCf-sUZgAUrYIztyNxrxhoj3G8eicvselEG7mwXFjlqVu4iFLhhgJ_EpGwUQOiOIKMBCYsaUJoAFKFB1ugOsWwRolPsqQAD56minwA4CwDfjHTy7tx1BcAGlGlESmmdDHSmI1ConrHRLBRbAwDVrEzUQaIAAGJeAAJMAD3COHFvCOqRgM5FoHKVsbCLALaYpBqTgL6bIXyVkGgWgHjNznIb2mmQySUcuosVTrmXycMbNsrOMZMTkNMRBpuqCYhGxJNBmOsRTqscfmmVkJsdsU_i_iVAcXYB_ptADpun_q6aIBcRoFcY4I_uUPcfFo8eoM8bObyWma0kCSpHZjOqRHWToeCUaS2fFg2M8QBsOacXYP4lwHZtULHnjMxAYqmXya2VwfqJoBMiuaWcetYo7sCenPWYCYZveoYU2ZgPSZib8YOP3icQopfkUaulBUWCWBomOTwD3IsnyZ3MhVkGiR2aPOVJUGsOBRZLKO9GhThQoYqMeA-ipFPCLHPH5BQgxClPPh-FCWReiXRQRenEQTgHRZhR2TgNxPII_qoC_thWxR2bTnRK4oxbgi4AQOGHzLmKrBojJTgAOoYp_KoDBnzJpYLqrA-eJThRUVwJ3HRFpp_GZTUAPBZZ3LctZfRJ3GLAPFjoZXyU0nxWmbhGMAQBpR5cULfI9IicAWALKMbHAKReJS_JxZItxS_BFWxc-gsN5bItOOZm2HyGmqSWxRTqfEWaJn5cxJhdZZhXiUReVvFcUKVSFeAojFlTwO-eiWuQBT-ZIvWXuRTi2cyZ6UeYhXifAdzqKFMisc-a-R-Mbo6PIfyYoZQcoSpIEfEQwaEQFFJvzBkfod9BQgSSYeYT8b-UftUVIQ4VkU4e3pIdRNIRmAek0uNWyByNyLyPyIKMKGKOyOVCskhjgK5JsKgPKGgcqAwNqCAJgIoNKLog9B4MgB4HOAuOhG2phBwpoBDR4GLDgLclWrch4OaCANDWhBhFhPVEtHhAWARMabWYjEgMjajejR4OKB4NxGgEjRyNKLgEyJjR4JSLCCSBDYDeVozQXvWkVISDKEyC9P4JcHQGzSAHoNsNAJqRTSAPzUImlDLVAH2czfgMQFADTVjZgKoIoiDZgGDfANzR4IrZxNLRgLABoIzQAHpVo1C3I4D7KS0_Qc1wi237I4CHJO002ii3Wcg8hTSPWICK4vUgBwA3oGC4CKiQCdCfXfW_XUDoEA0eBoDEEwCNiRTyA-jwyfbUAQ03l_ggBODoBgTnSCCxioCRhyDfh0lICF1Y0cKM16DjglAuDW1sgeC0DqjeV11PQK18gC003-33VB0Cgh3PUwDiggAkgx1dDx3UCJ1Kj0CIAgCA0dqwRW2xhwgsUm0gAFToh90eAdooioBfWS0LncETilKkgT1K5Y3wAnioiH1waXAF0aB4xY2bAET1rQQQ2h1F2YDkBjAFzdJPX30eBAMgNBx_3gMuBY2JyFKM1OjSBnKS1tQQAPjv2f0eC-4qAd393DAECS3YB3TGw0DCiKJUAFxRTYNF0lISBUPUQFjUQni2CCAlh0NY0H2wBgSbA7Dk390dUgC00gDYDAPbAgVIAYUgAU7-g8PG2d1A0tgeADx-3sgB0PXj0AOii6NAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/showcase/door_hover_animation/src/index.ts",
        "description": "This showcase demonstrates how to create a an animation with data from the ShapeDiver model and how to trigger the animation on hover."
    },
    {
        "href": "examples/showcase/gltf/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=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",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/showcase/gltf/src/index.ts",
        "description": "This showcase demonstrates the loading and displaying of glTFs."
    },
    {
        "href": "examples/showcase/kitchen_interaction/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqcVZccARJsO4gmVlcAO4Q6AR4iFwAjAAMdQCkANxFWVEQAOaE1fVNrSLF6XDyUPxJ1WCwWAPFPPKUcBIQ1NX8enCUUACutLNzsGAE1f1tVgSU8ictZ1webamijOS6qvxwXOUFL6hvcB6sEw_P6PEzpVSgtDyXa3L4eAwEC5Ee6DUToDT8Tqddb5DxgfhQFwo4q5RQFCBETEwYlZHJ5GAFBZLcSrLjrTY7PZcQ7HLgAJgArPIZlwLld-UKZjSrGUKngCn1paIOt0CAqGkqeHANOQCjhjBSqXBjAikbIYFAwDh5KhOpquNQFmhaBp0JQSqgCmUMO6cIJ0AAhSiIyhEc2WgAUAEolWE2owoTDUTw4SAxfb0ZjsXpceACUTCsnRUkyR5DZ1qYXinTc0zlqz2VtdjBmtyYEdeoLha2xdUu1Kq1lZZV1XV7SrCKP7drdR59eX4KZLuGrTa7YOrI7KM7NG6PV60Hu_eh0N5l1FIzGN6FQXByBoIPICMXSyAiJR0NtYCEZwUZwaMGwHACH-EBAWMO8HyfcITESFJOBMFgoGEEAABoQAgOAAzQfgNCSJB8UJGAAF90IXY1TVDFdrVtMgQCoGg6AIBhCAIeQ4EQYxjAxEocE6CQ8G2PRthcHVqFoGgcCoIgILkRRwU0YwADUIBgEpNAAUSwfgiFGRdMHUKBLhsGhjGwHS9ONOA8HdF4XGMABrCRHDoAB9HcMXIFlUANSkKwo4MzQvVdaLIrCcLwpACA0bYSLIvzFzFai1zohiJOYxAQFY9jOO4_heP4yohJEzQ0qYqTQ1khQYAUjRlNU9SNC0izYGNAyLWMpizO03TWtk2z3hgRznKiVB3MYzzvN8o0l3kZLQow8LUFw_DEGi2LSJAf9MEgVB61QYCEGQejxKYhgKQWDRn2ALgAEkAHldmhAgAEF5AgVC7oABVwnTbE0N6IC4YiuDADRQzuEAAAFrOq2rjFUBrNA8AYLsoK6uBuykCAAFk-9RyAAZmB0HwaISHOigfxsYfLAUdiVBsEu59SRgbRgqUds0H2rhXExzIaYgch4GqYA2mi3Q4DAdHsZWVBqmxnH9h4cG7G8hX-Fx5XRQxVA4DGdWuEV_ZiIAbQAXX2Sgnt2AB-aoHpt173v2eRfpsF17e-93_o0QHGByB9bVYfYqG2CbqlQbYiD0TR9jgZb5C-7caA4_nUSdGhqgJwntYxdIRMj6PY40PPg01uXRbZLBMOzmAidbXRKZgIuY80YGTYt-PE4AGTQEX06sTOCBqOuG7aYe-TH3O2nziBC64KO29L2fy8Nm7-BrtOc8b21YFbkuO8yM3Lc4YiBk4Jn0efBici4Siw2C6oV053aeb5sWREF4W09NtpP5JLrKWMsK6skVlJDQAhaDRlQrcVWoD5ZG01jjCBUCYAwNuBLPWBtK5INxqgzW6CoywNRKRTI5sSE8DDhHWolDsiJ2Ts6X-_9bjD2njgMGoYlIElinACM_g-Q4D5J9OoIjiFwMEPPNOdQcACjoVYeB69q61y4DnDhZNuE7HgBGURXBdE1GIWyPeLc9HA3kWYlhRY2GqProTdRXCeHaP8DUHAAA2ERYjzEq0kQvGRci4Fr1wRvLe7DOFEE0bwnRHjaiGKbvvUxZDSHmIAVkaxaiwkRKcS43ROTxFFjnr42RXiuCKKCco7etj7HhMcXwnJn0DGfTiSYuoFikmWOKGkypGSan8JkXjPRniJEF2kUUgJasymbxUekjRPS6kxMacYk4rSrCJKsCkoeKdeTTIcVo2pQjol1DycUApIz_H5MCayYJUyukzN2VEgZ8yjHNyWas0QryeDrNEJ0omVTMl7MCAco5WQTknFGec8ZlzymhNuZEuZDSnnxJae85ZohPnzE2dCnZkSXH9NycUkFeiwXHIuYgq5FSfndLuXC2JiyEnmORWirg3y7GUsiYIuZhz8U-NOfiklVdJnkpZTC7R1KFnPLpW0RJ7TUkYpsRS4VfCBFFK4P4GRhNBn5O5aCs5xKIWkqhXKoVWKRXRPhU06oABZTWeAcBfVuqEfkKKeAMtYbK7Z1S7lKrkSqmRABODVxytWEp1cCvlmMDXur-fc_RNLxVWsqLa-1xhHXIpdVYt1NzjWKsEd65xyrOVDKkdq3ler-UhMNb82ZprY3xPjTau1Dq-ROubYy5llbPU5s-kqmoAbgVBr8SWhBZbrnyqzdG-pNaTF1sTY25taaOkZtHR6yJXqu2CIAOy9oUf2olobS3hoFZi5dJqHlmtpdOhtyam2puSa650R6o2rpVXY9VeigXbuGcWsZQ6D3lsjVW09k7LXWpnVeudt7033oraypxnbn04H9W-rln7g2DqUYe6DCrx2PPNVwC9SaU30ogwuqD_6O3Kv8Cg71BbNUoYHd-9Df7M3HtqdWsVtaQOXsI5KuhFDMgJwUH3RmzDUSts2aPTDY6lXCJVdR99XzNlT0kyxiMgiZP-Dk8hotqGGMTKY0uqNoqEVTs4_am90qNnOgk2RtlFG1VboU86JTNntFwcozgTdSHC2FJDQosNZKH0AZjexkx_h8OzvMyIPjqBz6XywMzBw1A75JSfuzC0YBX7c28rzQeeCHw_2qH_UTmCgHSw0LLMByCCHQPkyrMN4D7xoIwUWLB-sf0NcgYQ5rKzeN0OoS6XodCBNJ02SJtZd6s7KcfWp01sjaslJ3b50QpTIUYZc6xwDIWXlEYs45yb63-EuPcaeubWmfNob0yOo1KmjO4aRTt4rkH9vMcfdk2bAp5sEvo-Cn9AWptBYnVtiVbTHskeewZnpqqcC4vqad7zPLdOrf09dwzbHjPbZ47t9FpGXuzP2Sdj7Z2Ec_cY1d9tsK0d3fA1jpli6Ud44BQTz7i2LtI7JzBjbwX0fA56zTttHOIw4ve8zuju6_P7r-wd27tL7uY9BzKnHEO7nsuF0Tr9JPLuCvJyernVPIt87p9r7NdmcCvpcYT-H6vdW_YjbjqllPz2mYiw98bT2tl25XW5v1sOLe0e09963pOtcC-l3Gp3YHIuu7B-7pXnuKPm59yL_3Yvlv-dt7HnXgPufhYjy71FE2Y_0_I7mwRPbahw79-dxH-q1se8zzhx3CauPXrzx8gvgXi9ro84ntXOmNds-D1h0PHGm8EZb3LqPCvwdF7j7ml9PfLd98D5rjvFPNvZ_D9xkHk_LPT6N_wtzdjEPm6T1X_vNfkf7-HyZ0fzuJ_57d6v2DFGqML8r8T5fA-n-c6z7hnPW_ecoshte5-4xsH9o9rM69jd1NvUT9ilJ5v9VN8cNM39A1Rcls6sJd08Z968z0w9b9I9wCp8R5ECvdTdUDiDnMoCkDc0UFPM4DF8A890bda8M8f8G9xUwtN9x9t8uBotYtUA0JFpsJlpIpEBCIXBNp_xDwgIQJUpTp6BMo0YMYAAqNkD4aQJQJSUmCGDwGGOSGqNQRSRGNSZGEAVGXSa-XLf0PuHIOgTQPrTrWgaQeAJYagRwtBFSNSZmOhDSJSDSAAOW8G8AAE0voNI6FbofoMQPYAZ3pIiXC4A3DUBAZIivCShmZUjMh41NAIACRpA7AMBcJ0AlBNZ-A6FIF3x1BbCJIHDMglJbppBboAxboe5bpQjXILV7olAIiz4dDyY9DYZ5IjC6oTDGp6Y9pLCMYUklAMROgrVloKwNA6EAAJSgdQDQBYqkZYzIW6WYzEDSdQGgSIiafgLyOWUouwE4l0M47yDSW0fuOhITGAAAYSSwlmdDoS-jGEZjeL1g-OOMyEYRoD-MDn4E-L6LCUhn0LhhGIRiRg0A4SgW2EgTgBwA8luLlgmOUOujwX6QAEdthNZ8ZbESYoSPBKZqZNZaZsSpjcSH4VxPoX4uY9pvJPoUt0sySyZIZ9QdosssTzCGYIxGBdAUhvQ9wowcBNDtC-ZpSL4fJk13xWT0ZPgwBRQogjZrYXBPgPhth5AHQtA9xUBOBYBnx3wSolB3RuA-Y6gBg3RyBo5yo4IcBqBzSXAjSctoxeZWBcsABqX0t05QK0gYAQ-0x0ySZ010rUmAPUz0qMb03LfwamaMy0j0EM-U000Ua2RwVM60vRO0ygB0kyAgHASMmgbMvAHIXCZ8PmL01wH0lJf0i4bYHM4Ms-Asosp0j8JIF08sls0adAOMhMlJJM5s1stM9shmTMlwJI3BRo1wuWQGAYTMsY5mB2dIzIl2Kc2wLgTMeY3QbY6ofY_cxYuOE0ncmyDYrYpY6oNYq8g8pYjMnch0nIUMCAAALwQVulQC-nBk6FRLTgMC2AEDzIkJbAZlvmfD3OeNBIBJAj2LTkDjQE6Athyy7k4EgrZHOLeFoG_JuPOKSzPAcjoFFn4zsCumqCQttH2DoHQEouimQpDJyxSSrIoshg8DoVouqHuDQknONNQEwr1PQEIWiL-hdBy3eCSAEq4AjB2mfg5hZP2njPrNyy4kS1-E0BZg1O_ngE-HLPVLZkwCWEgUHLK2xkyEwqov3IYqwBeg0AxAmGyAYttFQr5nQv4p4B2hwB0rRLKw0jOLwAjAjCIGUseCsvjVpjsocutBEkCo8D_hAC4F9KNmAlKxAW8mAkoAKKDk6C9OSo8HNg8CBSjH2C8rdhiN9gAEIcA3gtFeY2hwrqSIBbL7LxgcBYBbRKheZXAbTbhbZIZgBiJ7RqgAADYAHyxAU2AAEmAEapsqiraoACsU5oxiJzZiIRr9h8pwTnwZzkipIRIkQPyiF0yIL3iuAhLCE8LNBMSktPSMSCLUBvASwB4bpTZiLHKrLzZqggLYBdBgZQrctLKLx1APg3KOTLRPoGTgpT4RAysZLMygYbTWwgZGBsgQb4B2q6BOhKgUb_T4zPl4aIxMzFqctbSuBSa0brILRQbTYIBzYKpw4XRWxFr8bcsrBMLUAPw2Y-ZqaoBab6aXSnZqqubMBqqKwCAAjuasIkgAi_oIxbgtQMa4A6aGbrY2JdgRa_okrIZXIQhkrFrikoxTY6hzZKrtYUw1SIxKrRaYB4y0o0BYp5Tig1L1IuA6AcRDK5j-JbRQYVTKhMJF5ubbhMLhK7ActGYSg7pTjHrLj-AIwHrvJnrFA4ASqGYXbk03aXBnx_rdBHAVTNYDL75AoIY9AziHIjZyh0BYAHQ1TKg2YAwAx06shEaNLnAea8T0S26CAFaiweAOsmt5slaab4BVbvKmqf5TZFqGaVtUAjaLbVSZLKq0ANiXB4yV7NBtS-YB6us06PKshMK9A9AI7ubSzrYMBkKgxcByAjJGZow_R5BRgkgIrmqE62616F7MK6xss-YDtFaZKj7x6sATbzYdbAGiA0AQH4yr1ikeBwHN5TYahos5h749BvLIG-RkGsg97bg1FWszL40cZe6UHv65ZYHadmQyH_6-aBaGafKp6Z6SV57m6ObzqmkctCTNY-JbAXpjFiG5hOGSzs6Xot5eHm4IxBHqsiESS2DsN4UaMUHwEJaAAlElfhlByRxrXe8h4e_m0ewW-h6enAWe8h-bHBosMO_gHAPc3h_O5wGK6yCMRldFSh9w_-2e0ivu0QVgnA9ghpf-ngJpch5FZ1cxjOkpGAKotmLYQcyxkO86mJk-zAaxsojhaAF0IK9AQGwctAKsgSmASgNU66yaC4sove4oW24xyJ9Y5QMoiMGJsJrIV2tmf0IuyxoxQcykYiou22vSxGJYHMNmeGrmkoW4Sp_0OO2Ssp7WIakQWZgQzgYwFQlQuINQzmTEnCtmeupy3QYS10PS_C7yf4bgFQ4wDC86zADZq6mOo5oclSlJaC_uWCjEJhBCjhdGfyxwTJ7JuY68zQKpqJ48558EmgWSqMcpiJqJmo-wjQCMK53Cm5uWOAIiugHAViggCFyomp6FxmWF-FmAYp26vWFFg6Wixpy6hFw5pFpx3cuYyYfMGAT6S8zQeloiAG06_ipZlZk5rgF6bCwhIuvJvZnJxFpLVZs5gSth_lylm6x6sGmSwGh5gQaVgl0VvWaMfYCl1VqlpLGlvc6odaRlrgZljQA1mKNmYiRp_FwluVkltF8imstkE8HFzQdRrgPwwI4IsIjSHAW6IIjSZRl6F47wB6AInAJQQNgAcVcmkG8BemUe8HMUkukojDtuHNhCtpfKOs_O8m_N_MoH_NcIJv_r3L-cRKxfUClswA1fcdsBRNQAXtmeKFDrmMOKYhy0YD2NbaOIIFYHAv3qsEed-PeJedTjeb8oCu-e9JLd-YfP-YreUDmOBedDBeYYHdEGaeyAEB1DwD9q0G2YfFVF3MUuy12adcHOG25FAPif-PRpHvldNghrAChpLsfnS1huKEzLkrS0tEy1ZLlgXqJsRrJpRt4Dvb0bRI6pxrwDxt9OLa8YgCtr3LbckkqYlp-kqHvrQBvu2CMojBof0bVuFvRKyfg5Qc8vbBywI5VvpoXsHfbDRYYVG3eaakndTdgGLNCoCbRDmJgpHZBfgqUDROhEce48HdndPMRImaXf45XbE6yEjq4GBIIGXdBfk-KAtEifKmHh0fI80-LOMe5V05Qf0_KhMfU9ECHrmCjEquM64Cs54AhZQa8uG2eN8o-bY9M5oC468fE8xD4_-NHcE-E9irdfI9pcxDLePBKJk8C4E7C_C8XjUi4AC7BLk987044-0_Ezs406y8kknly6yC85LJOSK6sBK-MaYYs8c6K5s7s4c_s7o9ED0E6wcma6bayFmduDUuoGFiLqieLONfeHdsAnQE-jdq1YG6aqwD0qLvKrEvbj5P_eoFuGtbVeRcoGItJYwAkudcwlqNhf_o9aCNCPCN9f9cDeDdDfDajdckCKUHIeTfIBkrTfue46HdeNk7HaE5Y8-cCrBenYy88ok-2IBZqaBe-57qyd06c7mBbYOJ7Y7a7cR6Yj7ea54DUoUCfum5sqzLae9pqk-FoGRAy85uLnbj5mQ57ZwFtvk-4YIAw8CpjGB64DRaEisoS-c-7fKjQ9sCZ_vrGByG_MwCwHujAAVpAD1pAHjOSp7Qs-p959PvQ-tUF-xsqAa4x87qIC_HECfq56yC8vod9KXhLgZtaxwTcdZ6N4ntHpN4p40HN6AUt7nvk_ATCW8Gd4QQN-KB3pqyK6UdsE98lhd597mDUS0f95q4i86BQ5LMFiwDq4a9h61_AR16gD16gCSDD4o6tGN9N80EYb1Ts5t4Ysnvt-XiL4QTs_d7JgAEUiSe6LO_fpHm-qsVG1HNGnDpGY-4_x6bLGvavuO4ffeqt0_M_s_5PS_8s7eC_HfUrJYzLq-p-GP8-HenfF_0qqHWfwFWsmR0EW-YEZKRTUAUg7b-_aZGuR-D7Dq3yc25Y82_yAKctDWtftqJALr5Aw6YBRLYjYWdpGmKDTmtzRyxeV1az0EWtzXFq2Aq28AAMLLXlor8rQ4AzWrT21r5Upe-tGSl5X6ztx_A8yYfiA3NrcdKm_TCAIMxyxgUtelTLVkpE3pywIwYFT6GBWv5WBVy18HAFq1gERhbagAuYAuxdZ4sVWNrI5nazJZv9hBG3GtmT1v4QN7-1AR_gW2f58wqB_9EJk1xYbLZqm1RA7jCzhaSCdWxLLbqi3RZw9Xke9BZj5GWarMuA3gPAIHUDrbNpIlIXbpUELrYB64zYD4Ns2wAuhloUAGPj7TtAnMbBUMBbuTB2jitzmt7f0CuAkpwApKL3WSu2HkrpY_2SldNiIEQ4yUs2d_L8j-Sf5FsImBAetqVWVbiBNmIg6lo0zUqR82Yl7YeB8HhoB0PgfNMABZQuaxc0uP3RCs5RQqgM3KH7Y9laGGzKd3OrHL5uxy07ecgefnToKp2C4OM4qFjUHksWi6Q84u6XFBop2U4LCw-lXHTtx0q5lcjh-XUrtVy8ZmNbObQYqmUJGEgFhMf3TzmcJ85zCFhcAN5iJ2WFDBVh_zaTpiD2H_1FOqXOCvsLOHWgcupw6YSWUK5QiDOJwjLscIuEoMrh5iW4c3TUq7RBy2zXpmUC6rbMhez4coOyXsEfBqAbMQOg6XspMQs-xrKunQA6G3tI6sA0AQxxQEEBIBYtBnrAJlpy0bAbrMAcR2Wg2AdaHgaXjrWSFWhcBWgfAf4xEDG1TaxA_epuw9oUC9yQQvduqUDp08RAodMohHWS5VDqAkzG6Pqx1ixR2WGIzOvUJ3K50BKNkLQIXW2YPx745dSuieBrqFMi6jdTIJY2sZzF7oh7NADlj_qogeBakWAWfXDjpBbQV9IBiAx1rMjT6BgaMZfUMDoNUAUDRtOYiTHJMUxF9WMemMpDAMkGOYiMcmPPoxjOgcYiBpmMwZ0Iah1o89m031FnsumWzDUr0xXqYRyBNdYZu6EyC5iYA6wuppYwhZDjqqZAigSoIZb7B2BV0TgV_13rO1QgTY2gFAACHbNS2c7fdpQBj5aiPgOokHpFx3FosYB3NcMSUFgGVVGx2QUMB2OQofA5A6gfHrHF3LkiHQ3AbZpAGcBmkamc3bZmMWRi6jzqFwbbhan_F8wbCug3Fm6xO5etzufrbwAGyDYht7oYbCNi9GjZdF_CSbBISmze4NkM2S9QMrmS4AAAyciVwEqpjk8AuZMjnMDUrbNAypQEbpAj-rul747YdGGzCYi5FfagEhEjOxPGSdwelbC8awKwoVDrmhgvhNfxBgWhtSzjVcUXSAlaASgI3PiSZU-jtjieqiHsYMyBHliuRU4munzFf5GSrxp9WgfQOoCMCGWzAhlpJPnElkuBF4ocfJLgTaCYAggiMGBLoAQT1AZghsSuN675MBuNTIbnIA-C0UaoE3NmFN2YkzcAJGpcIb7GGH8lVuIE29v5NQD3FByUE_bnYVgnwSzuPrJCShOu7oTbuWE-7gEUe7qFEhr3RVm0AR6x8kefMTtseTj7o82ge5d4eOw86TCsmCZbcaJIXYbDuh0PcFtrGn5CxR6c0n-FjU6q7tZRG_bBAgnqpFha-oYYPhtO8gG9D-VnQPgQD2ltYDpEfbvkf0V6SQE-ZjWaav1t4q1FpmNKDl1TWlVc9UOWHaUQAb6awEuR04pCdNUZ6oJGjfKRtdJ563SZu8mOHmn116Pgs-CXF6c9Mell9Xp6vVabUHWnAJysy_CxmjJn6oy8-T05adBxVTYyF-esJfmyVuC78gE-_YKlVjqGQzUe0MgfmiJXGY9k0rTewIpwT4dNP-3_ebj7BdB9TCZ80kLo40ZT4Mt-lWfBCzM-z1ZmZV0-bBb3awqzB69KOHjgPPouh_SXMhwLII_L5D82hbJIi_3Nbax3-z4LVr_19iSi-BwAzAKyOQFCioB3I6WvAL5HoJbggojWhyLQEiiMB4o5KpKMZoTQKZcoqwAqLNraxSBBksyaDFnFtAaBS42gHQOcAMCmBycoiHDxcmLjv-3A3gYbIEEwTXWuU_KXD3W6yTpBHNY2fINQCKDzZ8rVQXMwsHylhSopVgOKXdCSl_QZ4OaMFHiFNS6yREkQLEOCh-Tzw6WDuUKRP5ilDwfc6LkGBDBvtLQI8lNi1InkngVwEYaGrPI5acA4W-EpIdvKoQNzTZhQi2eZKtmZAXJElDSR_zqEblr4TjVqa8HeDVBGAKxbwBah7gvFP5cADSGcNYBhkDOEtEBdCPgG3R0AkvYEO8CKrmJyg3FN8EkFflXQOKbQKcdAAkCOUGiTRFom0Q6JdEeiOAC1C9ACKeAXoPcOhJa3jgLlqAj8nag4G76JFki781EOIHIDEVeQHgOoOgAFA4x105AdAK4lcQCgBQriPQITF9R1A9AAoGoIEBxiCLCYhMQIK4jqCuIVFdQAUNED0DyLJFhMdAGAHQA4xJF_AQmOujAA1AaogQTAHyH4CuJAggQPQGAEJjkAcYR9fgDUHIA1B0AvqddNYoFCxxhYAoQQK4mFjiLAlgQPkDABxjkByAdQGoDIvXSuIYAfIQIGAD5C-p0ABinGC4rAB1A-QjiuoDAHXRiKEl66QUHUFyV6AcYVixRSksJgNBAgdQdxQKEJgqL10_AHpeunyUChVFegMxbkoFBgBRFniwReQF9T8B3FggEJegBqDrAagriMRYTBqA9KwAAoX1DstVR5K9AEygUOQDiVuKBQfIHGPwH4DbK8l6AYWPIp2XroagfILBaiHfCYAoA6RTwBoCgCoLsoHELiHAHRDroYyfinADGX8DCwaAGIKmC4iGKGENiFUZELxVRAoLIYRAJIOwoFJ0LbxbtRwE3HqH3ir2R7eQODEUBXRVIHwEbi0OyCQqKRHwQkhIDZh6AugjIu-OkEgSPUCQfcI9nzHuh6BFq9cEsrVUiQFyoAXQQgNIFpXVUxVqoVOmkwwButiagNKAMBBerdVZSWhHAG0Uja_zXIZU8NrdGUYaQqpARGhQ2PULaBNVexCAByu8hcrxVzsCAKVRtWCq5Y9q1UGizkB7grU8gZRvACbA_0uAOMWpa4mdW2q3VUAblYQE9WCB3QPq7CCNz5hQ4GguilcU-yFoByqOjCg6BLUegBzvZiAtMDPMtBFUQG-wA-ZaAzXPQs1s5agAzzzXPQC1_I-EK-xXClrTaaa4tauFFmU8t2tanNfzx7UaAm1vs1EB4CfYv0f4LyxzgmJG5REh1_sKyiHEyAVru1FVcSrzWzUM97ZLoEdW6xbVryVwk6-ANOvs6zqPg869dXEQgABw-hy6_ejbKFkiUh108oeYfMyCPq7ZL61dRC2Br3s0KT7F9oephorigOO5JGvmU-BgdqOZM3Gp8DZqfJnZHdajmPXZGciYA0AyWl7IQHNqiwKGwWmhqDlswQ5Y4ZFTHKIHxzT6pkjum3KsBpzv-mcjhTnJYEmx75DUZmIXOXHN0C51kd0JbKdpWjWFaCIuonTlijcfaLTVwdpR3HHMqE51UTdQHuISaDRUdI0XlIeJ30XJELE1mWxU1cA7ymgMtnXONY1NNip49sGAEFU5EHwBIPTdZryJQACiuzYoiaMSxGRTWkMAAMQngfN6AEIPQsyAKb1NEm6LmpqM06adxELMadsT03HkjNUW34YiQs1WbCENmgIXzEU72b8ihRYVq5qoDubUF3m3zX5sSoBasharJTf3FC1qsjN0WpYreLqFshhh_AXXkyh-JswSgUQSBA6H5WCrKV3W9UTVF9GJb1hXQ0EanOS7fFdAX3TYWpyLBS4u0ZeBRlkAW0-pyCXmVEOiJEB1a_hJ4SaeNtRA7D2tgI-bdQSW0OYeAB2J9HiluDKSfGV-NjP_T_zcFikyKLbceJPJg9_h8wqHm6yO3Ta9hq2rnEDrETvajZr5OQVfKUGuFKBKcmLFGGkFCFMIIhFaARAZabQ3YPCqkDgEWqbBBCx0MqIoRABiwQAmARQIBAEoUqPAyAQYgYXhhqTqdHgOxHyBcTPLeK0MOFfToRJIlNYKJTGkFsZ0gBmdrOjwGQjfAgtBdMhXAEhCwVbR7wj4ECNTpJ3otBd5VYWAEKl34BiAAQpMpcAZHs7hI0AErYgA8Bq6LQ98bYEbr0qi8tdJAUXbAlJ0wBVAnMcnZgEp0nqyApu3COrv8DCQMAsADQILoAB6LiJ5bIll2sxIICu4PQKGhzh6QAxEYiEjqWio7xC6O9CHAF2YGBr61ASAJ0Bx1475CjEInSTrQBvxaAPcSgJcHza0BHq1Ow1g7qcDoA_VRkQQPdFQAvE5AtoSsGtHNYO6xigu1ru6FEgR7ImowQhKru90WhRdyelHWITAqbQQIDEPPQXuoBF70oDAEndJHegB77oT4JFkro8BvKvwPejwM4OoC47ZdC7N4kQGLKgQ09REB3fAAgmfhYAxTS4PXr70eBNgKJYWD6up1MCPAmAG-r9G8gAGHJQB-uGMAxDeR_9aOx_eOtwgS1BdGkaQK4ll1IUvIn-2KA7vVoqBA9SAIAwd1l1MxcixZAkJzCoAwH0Y9-hvR4EiYSBKD6MTWOjAtS2BBAZRbA4yyP0fgT9fqjkLsAFIm6QAdPBPU_qwA4dMA1OhKrbVcjH7Wosu4YAQAKpJ6woc-1aAvsT1AA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/tree/development/examples/showcase/kitchen_interaction/src",
        "description": "This showcase demonstrates many of our interaction features."
    },
    {
        "href": "examples/showcase/multiple_sessions/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQATlQCGccAvADoh0nAE4BrQQD5-qVq2YxO6abLnyCEArEkBlPJwAOMACIQAbjBGsdnDACNKWRgHoNWmCrXyiMAp3b6InC-AiAAqgAqAGIAtAAcgqzOKjJejFBoEqpeIjBQoXAEAJ6wcHgwvoKpXqx4uWChhAQGcIjOzgCuqAZiAOY4VETOYFCUAO52mjAAAgCMOAAsOADszugQhcOjE1M4RGgDPFXZSZ7yzuVKKaqMDuhFZ3KM62ashSUwoWMQ6AR4iKxZgAGIEAUgA3LUYBBeoQAcCweCpNU0uRbGZuKwfqE0agMXApC5cfjHucXqTGHByCIIAYCKxikZQkRKOgOrBEnAROQCtznGhMLgCASQJIXFSaXTrmkJbT6VyeYImi02p1un0BpQhiNxpNaHNFis1hsCFtdbsAFYisXOWVS6ouO4PGQuFhQFQgAA0IA2ACE0KIikgwJwoMEAL7ehX8jDYHDCsggKg0OgEBgQIgGSgienAdi5Ti0T2sDoGYS0Vjh1hgERa1iCHCdCCCJGoDNZnOsYDVamKWg6eBwCDUT09gu0ABqEBgYw7BFHqgAEhEALIAGQAorAfDQAIKoch4bMAYQ6hS1xkLnAXcgAkgOeMPULuDBAb6xbxFcjAAHKsmDvjoG46Dot4API_gA-kBEQRLeP4AOI6JBK5gcYG7vsEj7UHA74Tvet6-rea6fgAmihaEbjIVY1nWgjTGUhgwC8ljOGY05jJYLYyO22a5qwRCFgsxYWOQADMlbVrWRD1iAvRQDEgkEDSWDcagMjJoUAn_mGALdqoGjkGIvgAoUNKoL0rZyCymBQFOM5hCIUCmcpaCWdUVKhjAAD8AKoB0RB2JYrbhgA2gAuqwvCsKF1T6V4hnGQQiAomoggAGwAJx2HEsxgAATHY-XoPlBVgHEQJieQmVAuQYCzHY6BxGA5BxPl6WYOQzFgGJCw5eQ4n5eQ6XAgArOlyyzPlMB2Jlo2jZwszpZwSj5WJMBiXY40grVCyzHEyxBfV6ULOgYlxOlcQbTACzLJwQJgAsnBifVYCZWJnBXZwM3LKNdVxHECxxOgQILGtANgEC6UwPVdiHZwkOjbMsxKJlnALe91VTQsQIrctdjkMszEwHESjoAt02jQsBUvQsYmzDdYBNeQxV2H1o2_ZdMDLECsw1TE6DoHd2W9Zw-W3eldhgKNUMrcs5DArdCyXdV6CCO-1k6fZYyOc5snKq07RwOgIhEx0Cs4DAHQxF1NAiKGMTzIxRgsSImpEOrqWebAAJAjgo3VJGcWpYlJmpXIgiVWAs3Ncx2XK0tt3NRV7X5Qzo2k2JyzoBNm2ZegKMwOLH0s-Q6CE2z91gETyzK81QKjZl8s80XDfR0LDMwMtyswONZfCJl7UXSVsxonESPR-P-X5c1fWtSjMt7TAfP5SLc1xArswldzSjLJDJ1Czd6WtcDIIExD2XlzL72negCx_fLA104d6UZ79kPnbjo29-g1fCHYdgYjQ2hsVNE6VobLABiDJGQIYDvU2ujQeYNRpgE9icGyeRta6wBEqAgzRDa2hNmbC2VsbapntgpJ2-gXbmEsO7NBXhvYwF9jgdKgd3zxTUKHZK4dZLLHypwOmDd77XzEmJEE5d2oNybnlTKuUJZ2DEtPE6Sggb5VGgA06YkkYjRBGXaaO1pqFUKg1Tgl0Fr7S6sCMAYBFAPT5ldQmCwcaHXluIw6OVBHU0ytTXKGi2pzRykFA6mUfGrxBtPDefV5ZBREelQqwT0CZRakk8R41x5z3KgVBuHUYBQ1Ji1JRJ0tHvU4HYJQQI4gE2WvdTgywYjcwur9TKZdB4yyBL_ZWQUprc2pugHKYjOAMLUBguyHFsH6zwSqI2RCrYkOtrbZSDsqFMVdvQr0Xs0Q-1YH7BY7Dg4nG4SlE4Eckz8NrgtJQdgoZ_QBm1cq4tsqfXypVFaCw0Yc2qrXX-PUqoLBJkCRR4sOaAoBrjOBlSzoaIJqE1qCwWZiTvn9DqPV_kb2-i9VePi4hiXStLcpMiapiUyrMUamBoW5UBmSnF2KzoXXmssem40fGLQ6tnQFA17p1XKr43aeTf7LF-qPSq71e6NXJvnbOTU-pAjTkFGAXUXrXJiOtRlCNsqvMFaVF661Rq4vOni5xMN3rDM1rZLBTkcEgANqqY2ps5nzFIYsihjscDO2YrQt2gxjhyHDDIcKrYZDOAAFTBtSMG1gx5UyWFYLYdAbwtkwAZOUbStlw0fjAMmpNTCsRwFYKgSg9JMCQFQMxYsfwk2jNYN8KAUB82FtYEFBNXk1ayAjQACj-BsXNWb2DcCTWAbMvauBaSrWMPAEBDxYgPFADomA80VvYJoIorBegwC1L4EQRQACU4b03TAMKITgMkC2YH3Ye-2MlFlcTbawA9R6ZJMP3bkAgHQRCoAJG25wGkcL0mvSIfc6AdCJqiqwdtp7mEfi_BUP8mBiz_oBKJMSxYmG-XzQFIKIht1RUkF2aoEBM3toAIRMOwy-t9qBA2qE0vSJZH7B0iCUk-UDSkli9kLDAdt26rJJGcM22Avaq1xu0hYLEtHKC9v_dUVj8Z7Yfq4LQTtcm4AMaYyOBkynVOFifPB6NWGeMyaYUp2wKnsxqdQOWzTZntPqdCkwlDiaHNeXCtxmQ1QIM4DJl-EzWmNDUHbZwuQPwrX_sA8BrypqBKFhUgCOjpnGM2fUqocMrnUDhioyGsNt6whlg472sIt500ACUYAslE4u7AJo3KsAK7GjAsbBaxvzTOVg1AYB7tvfey9bxBxPnPQ--tZ7OsXuPewPT4bv0Hl_SWXLtAwgQFA-2rCQ5qAAnvL16gL43yDcg5-b8sGAJjZTCIRDCqxLYd4LhzhDGwOwHpAt6KQJIQLcYDtnA5ZOA4FgBZP4z2ADUf3sOBaxIRjzH3QoQEimgQotguqUEzcudcW5Supn3IeE8Z4CAXivED3h7RWC5DK-1k5b2PtuoMBkLq7btuzFSzULEMQYg8d9YHNz1HpvkEx1qebaOjxWGiqWsYrBEebm3Kjg8fPTzniIJePwAXUqjDRH51AAJ_0a1YB9vSPXsKyCDicCdmAynbJDGGACqV2NFlSqWcsxPfV09J1eHABgzx4HbZz6XPOJfZlS-ltnmX027ka_4LZUBylGQZBJxdy2-u3qiBAII9Jrd5cXbV4TFbZD_rq_GnNi7RkddYBGrro3o_UH691qTw2BsdAgGBGxwQCBl-L4mibP6P30jJseUMofODh-iu2jyG2VcfgfCt58r53wIdYEh981fa9gHr6d8SmFE1of8oFG9F2rs9g513sPYhFuC4O2hvbMH_yb7wycAjYGiOH7PwT3wFGqNeCT3NiAS3B_Flv3BqfZ3POC3bUhgMOOJxturpsdsWLPnXr4NuvbnIKFhgOFrAOBjOAdmAbQCIE5rALAc1mMAdjgC_jABOJYKPlxjxr7qoCXqgPgbNjAJ3rWnvqBiHnvjxkwT3mIO_jrjgBBj7lRu2twEUAeGBufpwvjhbkmouuxDOHONUPjhIRsBAJMBkMUD2vXhHlFv5KGChpHimpIbOHxNWtAHWgWvSE2mUOMLIF0BoHWlHkeELgYLWEYDmCut2qoVjhph0Lbrxr2pQT1ngm5Hmhgiob4GoYJBoVAFocmoWNWkmriG8EYOQARiulHoPr4RoBZHmj8Nvm3lPhxHOKBpwGMJwJoPmH2IQbkXxPLpfugFakQEUNrNIRsicMSNwACIwCLp3niNwMjjuAQJIOgJQJzj0TgGugQN0amL6EULeOgP3kmOiNwIIKAalOxEOIocugCPhKBERCRBEORKhOhDgCuLuD-GELuGuOrpQQOH4ekVMVapQZBGJJFhcb4Gkb0HACuP-ACEBCBOBFBDBHBIhMhHsRuAcUcScWuIHKllkVpPYVqBsPAACAAArSRwmMDrY65baSARSgYRRP5eFiHeGD6fpmp5BwA4AMYbg96u7tqjLFgQDCGpQwn7BYRO4u794k5iEj5PiVH05BbVGsAAAGdxAAJMABAOGPyerglJOklACKMvGNKb4JKSMlrOMpaqmnkHsCqQ5E5LwilqlPbilrifjoUcUZYdALGrWtrqPnmqIDEcAa2nIAUUUfSEibCcEJ5rWu2oyXCXAJCaoPjiMQSTrvccWOOpOngOwNQH4NDpJsuquuuj4MpCumnimv-nmvDr2ljpxEEFCfKIPvcaBpQXALFCAHcQ8SAAGmznIAGcEYumma1pmoulmcQbmUduga0D_uJFidFGWcMb4GBB0M0IORMT-MepxoIGmQsaFECOFJqCmDQERtOeFKlO9leEaXxlspzgpuISmusLkOQMro2r4JxHQJJnpnmnANoVEZxH2rIPDvPrWSmgVq2f-qYPuYedFIAQWglhkAAF7jknCAFiFcbq6AFwAdB2AAG_7AWgFtnEGhRiThRoHwUzm7qqB-nVl8ZkySa75sELraHZqEnSY6SknkmUntrUk6S0n0knCiHAF1YNkPlFowBGAYDVbUC9oCjYCtayD-ByZroNmsA4zm7Tb8VJrRQ4zM6RnZGQFMWgZgWJpsn05AXAEgW8Kvnx4KrK5KnU5JBgajKknfa9B_CsAxCAgwEF4E62ACV_amViV6X5T6lSX47YV1m4Xh5uHJE66pQd7uXsFFmhSCn5kilin8lIVwVBAQ7hWyX17FhymkZkEYVeFmFC5yFSF8TVC6Fzhuq2GgbKQeEhTbqkEyBeg-hwD-ioCBjBihgRhRh8jV7xgIDIBJhRmpjpiZj6F5gi5jF7he4iCy7XgfjdVi69Xo4iA5Y26umOEaDwCSS0QyT0TuquxsQcRcQgCti8Sdh5hiHzZzXSSyQMTUIeoWAiArUzh0KMS5DoDvalaUAxDlBQCOFqSbX8SiT5R7V0RyQKRKQqRqRBp8ZgBdAHnMZuH4n-DDUo40Cxr3ZtgaChgQC_mJYyDYB5E0YlF5Z94wnTXTgdmcKw584AgQ09G87ZgDU8YXqpiE2rhrimBmA9UECFU4YX6YXo0ViLrV6tnV602gb9GDGphAGlH00zEvALE8Zc3mBurFCwBO6UBDgfmyRlKXmzq0BqRyDi1mCS0fAy1oDoEbgWA0B5rRSCCcCDmUCq0lgQC02a3S1xaqZgQ0i9BoCgaCBY4GCsCwBgAN7rWtlMJRA95Y7847KsIsHTZxbbkAAaCJlgiynAAl0UMQMsId2RSgFomOzE3m8mHG4doG_JIpYdWdUd3IqYsdSaEavt_t2Y4YoI_JSdWk-dtApEhdMdcdrALytd7e6AqdhQ6dym25pEOdedvdHGjd0dxdAlZdiaftB5ld1dYtltEt7wNtVmjGOd9dMA4d7aIpKdad6AGdcAEdKWGmJmfdm9wA293du9Q9Ddh9RmIp5d09IgKWNdVZeJ9F7NzY1GwB82XpDhlgM1pJ-N2Yq5fgbqH-FttN9uWNf9ONTutpNAnmBgrF6Ax4E6UA0x6tPBfufG7NNB1YQNh5fwUR3aIezEPFrAMAJ1K6uQsYVgIe_1rARQlAHQt5GuEmtgRQXaFkUIuQyNWAqN02BBi2UDOYONa2RN4uY1E1HGU10D8ANFcgwj_9-AxAUA9N1tMA72GwFOnAK6RtIAf1_pG5oYW5yeKaWYctzGGZi6bo9N1Qd2rAWAoGijMDyY0ZpaIgS5plrAzj8AyjJAaj959eAA6j8CZXxvlDxvY7o947_SI74640Ue46FLMJFGZT46STYyNQQDgIE74IuNCLCPSOE-uRruYD8EmnYEkSmt7NViGA_dUI49FI43xuk26omkuTxtEyui07E0o0wsk5WUliza4dU1LQOkOtYyo-Q1k0STE5QNjb45k5Ddk4vRox7fSE06wLZYIAYKpN7aoK00s0Mas_GPM6BiutsyALs2pOQaVX6AGFutVabpGFc2wSXTgFaNQImK421YgCAN2EICxXQJgAeDjYIMgItUdctboWtSlCAGJDgGnIi57CAIdasp6mddmTlbaddZgCyPdXkE9UgIIAi0i45SAEHCAIJGgOC4IFxbgG6Ci3aMKOCwCzDjmLS680XXWvS343WozvM3QCi3YNXmg5yxel1HWiK9APGry4yxS6OIC2YMYEC7GKC_AKyzs6IJKzECKxgLACIJywAHrzBTT-wouMjwDUhyjGujSGgBwUvhh3PlUPNBiIAm61WllxoOC4DJiQD9CfOoDfOtX0B_MAtoAlpTBriUDzOum0DA2l5ID5Vm7WqiDoAlajBKBgSoAoPWXtZJsiAeGKu6Gct2C1hjDBCGsbIgC0CZjbnivat5CCBOvej3OVWPPus1UwAvPCh-swgfOXlBvNU_Ohv_MTlaivgGtgR0hPgigQtUusjsj5twuDAsioBWgouE6UAWDHhag9FzsespvwDvFsiwC3jHbzPgvJuKuXlvpdQriGDguHuKudRcD2zK5PtdsvsKpvuJYPsGCfum6Kt-AiAjGcvARsLVtmSTpe2IDXuCBMMEBvmcvrCFAoso2WAZjF1QAqtUDvvZhzvwcgClaaC4fZiFjZgri-BKBXhXuFsps2RLslZK2Dl9bEsgAQbNuKvYAcBzrLslkQaQSMelAouode3hQttlUVVVWdvPPhjhhAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/tree/development/examples/showcase/multiple_sessions/src",
        "description": "This showcase demonstrates how multiple sessions can be used effectively."
    },
    {
        "href": "examples/showcase/multiple_viewports/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlqKcVoxQaADWkVZcGjBQ7iBwBACesHB4MLYeCVZ4yWBphATycIjGxgCuqPKxAOY4VETGYFCUAO56EjAAAgCMOAAsOADsxugQGZ3dfQM4RGhtcHCFIjxhCSZ5gsJ7BuiZ4TyMs6pFohnZMGk3VpTqGl29iFx4EOiYqADcT1E8kocAkEGon2SUH44nUgO2iR6PwIeE-wwADBiAKQIxKiPIQZqEdFY3FAnh6fjkFoaSgNdD-KjdDRQ5p6AAUAFZJgAaLhcwL8gBsAE4AJR4xJbKznUSXNQUrg_NKqCAwHogjQEFSqYYy_FcO6wR6I_EgsHiSFcfh6OCUKB1WhSw1cZHoVGfcj8KDkbk4rj-LjDeRYSVKniE4kEL0-v1cgNBkNhl3SkBAuVRb2oVT8ODK9BpbO5uD6kCsEzFvOZ3gzNQ1hXXM2iFUeNUarU6tQAJgN-ONDz7hot4OttvtjudEa4sDAMYccf92K4AGpg6Hw82rO7PQvfUvA-uU9OoyS9_HE0fN66hzwaxcq_nWyBH73y5XdCWG3XVA2rkrn3bTVKG1XUAGZb1uLITUgqwRytVBPnHB0nRgVN8QISh5FjfcE2XNdk2vV03RRNFzwPJMN3QxJT3nb1cMvQjqJ4SD714R8CyLT88wg99jEfb8rj_RUt04tt1WA0C1DGWCjWgwd01Enh4IhRCbTtFCpyUrhMOw8i8NXK9mNEWc6MXAyCKo6cdzI-iL2XSjj202icPsw8mKVVilUYDjn0fGS-IEoETCEm4QvrMK4HIDQIHkAgdMyRQ0iISh0DqWAQjgDRyDSLLyGMNBMFwAhNj4qKYrio5EUYcrYvivLygISpqlqBomladoFl6fpaBGcYpjreZ3iWWgcAAK1KitjFqyq9mME4zk4fZiCgYQQF5EA5gAITQfgNEyJAwB9FwAF8NrygqMGwHASrIF9qFoehEE2ohOy4YAbmigRaGkeAwWoXlPuSWEYAANQkztAcRIDO02VATq4MA6SILgPEGXIFBgK5NGMIDNA8BEIFekD4uABxgdoTwIC4BGkcoFG0YxxRsY0XGJM0HAMeSdAcEwFL_DyKBFA0AnOE4Dk80yVByC4DlxS4VxWHez7qAyLh5GRuZ4AVrgAG0AF0ERuWpye-mAdLyLgYZJuGrDAEDZdgeLqdcLgMX-ZVeC4MYPYgFcV3lj7RI1-mtbgHB5DqXIOWnHgvpB8GOxJjkg-Iw0fk-cSk-1EI1w5amCPFKG0_xR9PnQShyDqGwaBwZpbAAUVgGuCC2zIAEl0Bjl9uNKwz88M4ZxXlvMuAACW8ABZAAZABhXum5gFvY5p8UlSIngTrFxETZ6fgJERh2fSgK2IZtnTKC4PRzfj2h0Bufg94PgAFTWXBwY-ORD1YXDgTdjeMKbEGNojR_VUirVAatf7_W4K7R--94q3xgL9DYqkU5KnEDSWwiAV4eAxGBMAehRSBDAFjUUegxjCmGMKMYkwSGBAxN2YU3ZhgwEFPwMCkx0DCkmGBIh6Bhj8BgN2MYYFqTdnIOgcgkwKH8AxGASYMBJiUJIRiLkopJjSIxMItRhD0CTFYTAYU_BKFsOFJI9A_BRRMMCMKdALDvSBC5MMQhTjuzdhIWMPQ5BAiCITGMVhwxrHkLAqKQU5BhjDHsUowQkwwAYhofomAlCfGBHQFibxgQSHkKkQmUUYExi_DGFyaR5AymiJkcKQUkwuTxLAgw_gXI2HoAUZYvQeh_DCiMcIqR_BhRdLoWktRmIYD5L4Y06xYxuy1I8MXQ0KVMBQETj0TwGgoCZxABUKoNRproA0IouoEScAwDqEyOgBANA-n8KMJmWM1Ac3aLMgC6ANlEEyCgmBQ4Tr_0RFQSB8Urg6wrlXFubQKYwEXi3DkAByK40KN5cCuJzeSEdQSjlgVwaFyFJwwGhamJFA4bpYR1tCnEeKbgEpRaZElZL8VqGRfcNodRnAO1dtClK6hyWImBdXc5OAFof3kIoDAs9vhQC7lcBFSCqYcmgapfkkrt5WBNgAKX4LmaQ0U6qHy0EQfgsQ0DNAtubQFHLbQZURE7LglAwBgBcAQAAGjrDE_IbV2tsAATWdfyOYShLnNGaIanWR0oAuCNjvQBvgGjkAQhfOSe0AX-sDagZoNwwDRtjRkBNfr-ABsNRyGAnxn6UDQLQDQDd1A0EDgBMABabp7Xrs7f5uhyAwBtePKe0926NCdJC858tkgEGZQCJV6c4A5rzSmnWFy6hoSVG6-1TrXYwDaDEc5TqgxIsbVtekGBDWzzXTQAASjAGNcscCmWMguz1OsV3kEPQQL1m76Xbt3bMFNB71THtPQQc9ulUxb1QAArgUbpaxswnJYlezc3JtTYidNYHVKQfkBO2DctlaiV9UmoNrsQ1hpuIB4DoGY1IYgxy82qITUiTthmpD0Hmi6gLUWktNBNAVv7Rh10EAwCyywzBw11btI8EpYy6lrs633q_Y6w817HXyzXNC0MXKS6IvpYS3SOsJMPqfda219qPXycxUp4ygGrCEYjVwdjNAZxzEepoW2ogkWCHQFZgg09bN0E0DCkEpbNAVx6KgaF_Is2gWwymhFPLQXOdc-5jInmNDeZY2Wuo8ggvIdQwJ_FldeW12i5WtzHnUBecU0lzQ5G0v0d1D85VgCkEgL2Vhfz3B7ZaAEI4U-2d4oQZcLAGNxqFw2EuWmh2HIrUuzdr7L2PtlT-0E66P5atrbah1ktkquss6SQILnXjg9xSGyVAt-Kq3dRAuy6CxtfaaBt07t3Y7ioQD9wLsGYe4bXQmz-XYNAmgdX9Ya_IJrB3VYArUKdkFfKkGXd_R4f8IAEVWBE7AVFlokOuw8Ni1CotRII5XRp1HIAcSY9dHd1QAB-QVwr0CiugBKtQ1XDTvfBb9uk_3ehAdEod0BvX4qu0i-D8FkPu49Z_R4OHjm1Bk4UBTqn4rZUpB_XT_EJtnP9e9IN0eEHKOIuZwD0SLXHa2AcMqbgq22j8DV3_TjJcOdYVjTzs7fOzYC48Db8BsPjLPDiqpG62ACCzweucnW5B3eiBd9QHAuZHTm1dkHleQuY3k7oJTsVXdQ-oFF5vUdivAF5jBM0bgmu493wG5oewGvLaraVIXnA1BHC6Hrpp-WitLdpxNznokqB55q9l1z8PPpZ3p5pq9-n2fUF5_q9x0hyRrOq5L3GtreAOubcr3L-PEfZ063WyAXSszUYgGFnARQJH1A748HTGgJ-QAxWjB4fWusID7dEq30fHezcl-7z-3vkeEWAe-XLBE61No4AdpUA9oDpEA8MYAzo99qRYhc0V0JpqA7oPtzkGAPoQBMAKc6ByB1RSpkBGY5BmZ7lWY8YRYkAPAwIcAWFKCnkQB0YCC7lXg2YNQOYuYsZeYl5KABYUhhYPAcEQAKCqC3wzoPA9U0BeCPBCproWAoAaCZoSpeC0CQstsyDoDsoUgjcip8AVpAx_AsI6AaC9A6hqdxDVDW0T5DDqcNCpCVoPBhD0CYBVAlAYBMDpYcCFCPB5A9ozD_BDCMBYBSC-CAA9UYYYbsHALkGgrIRQOQkwwIrkfqCIkAE6E6AA7aXafaQ6Y6SA86XQdAAwXAP5SAVoBA1AJA_3J6EANAtASAVAAYaeSgLCV-SgWgEjagXgmdGAQGTZPadAE9boQQAAeQ7zkBTRgHaI0FnS6KAhML0DpB6BcFIK6NoFehhFoBMM8LUJkKSNSKAPSLAIgKgJKkKKJHGntFKOQHulYwqLQPaHkGgE0AGM91VncJAAWXSjGJUPaBSlQAmhoOSHIz9yIBblwIgK6PgEnlSneO7TLSwnGMmI8HtGZVbUngUF4NBOh1PRhEuQQjRKyK6MwHvT2lhFUhRPkFxNDU6I8DsA0EbRMIbmkGFFkIuQgBjThMpJAHpC7ACOh1sxoOwGFiJnOR9CcKoGxJAlwI6LBNWB1FPRAlhBAknlsEEFhH4DZK6LeNgBPQnCdFdz4NQFSg-LsOwHvTqEwF4M331MwAAH0NT4AaDZgMgb8UiNo0iQCMjwCsjkiTogA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/showcase/multiple_viewports/src/index.ts",
        "description": "This showcase demonstrates how multiple viewports can be used effectively."
    },
    {
        "href": "examples/showcase/ribs_table_interaction/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlqKMUGgA1pxWPBowUO4gcAQAnrBweDC2HnHxeIlgKYQE8nCIxsYArqjy0QDmOFRExmBQlADuehIwAAIAjDgALDgA7MboEGntnT19OERoLXBw-SI8YQUmOYLCOwbo6eE8jNOqXGmZMCldEOgEeIgO_FDkABSDAAzfAKRcfxcABM30SRAAlABuLg5CCNQgvH7_GHTODyKD8dIvDrYGHyShwCQQagvfh6OCUKA1Wgw2BgAgvUHgmEESjyF7_DynCLkXSqfhwLgPFJ81AC9YgVgmMUSnkmC7yuDkDQQeQELgZRQpIiUdA1WAhOAacgpY3kYxoTC4AiS6XGZWq9VKlVqjXm0oEcqVap1BrNVpzbq9WhDUYTKYzAhBha0HAAKztJkdbvCJiOJ04u2IUGEIAANCAZgAhND8DTpJBgN4uAC-hfNlow2BwtrIICoNDoBAYECIBI0GuABUE6AAMlG6Jp8wUVQJaNJ4ETqDORHP-LQAGoQGBdAcEVc8ACim6PADlvN4AJoABSPh64J_Pl9vR4A-gBJC9HgBKAEEAGFvA_AB5M8Hw_bxEhgM89RgB8AFkN00CA3k8VAogIJQN34Vday4MANEoIguA8fpsgUGALk0YxVB3LpNA8KFOD7fcuGHEQlA0fhGiQ1AeOnAoAAlKHUDQ-IEjQIK7bjyHEahsLsaTaFk-TUCPVBGjQeCCg_GT-Dkkl1PUGgf3gAlUBcJD5HkNBGgfG9MVQGAAOoNJuLQA9OHwwjiNIkByLkRRqI0Wj6M0HAwHnGpEjgHBPM0Ay1KYlj-0oQd2IcRJkM8CAuB8oiSLIijgrUGi6N3CKKMSdAcEwXV_ByKBFA0FLUE4Ts0i4UcoN0OBMTU7xKBvShPK4VwuA-AoCU8l4AG1UBqIg9GnLhFuW1b1pWjQAF0HyIDdVSwF4ts0Oa9s4CF5tOqS1qW7b8zujbdvG1h2NnNyNSwcauCQp4cCIup0A-D4ZpoObvh2rgAGouAOggjrmwZgR2iEuAAKi4ZE0eMLHfmYtdPq4dIfr-vAAcoIGQbBggkah2H4cRwYAGZUYxvHvhxjmCZ4TqNQAL1JjdycBjBqdG8GUZhuHDogLAkZGNnMex0JuYKRICBi7g5qwR70ke_mdoJ2sCc4D5BXSVByEmtHXDejitlx9daE1HIuAqvd0oID7LI1D22Im_gun4CQsvnGBt13fcPgd0QHheDwiHSSPPcHDwH15_lBReRghO8BCxwArO4CPWAbBoVh0Eocglu7HBGlsUuYHLghi3SD9gY8WVBQ8CEH1raECmqMPkNdmAriXIyfa6lw1iMn6g5DjVnZgRc5-oGOCh4eP_KTtfl3agst81CByGiWwE5AQYADZBnGb4AFZvnGch0AATmZ75gQf8YRhGcg77MwfnofggxAjoHGE_B-b9gTkD0IEPQ6ARiCBWt8T-zMwCYLAIEaBgwH4wDfoMGAyDoHAPQNgx-YBmbAiAYEGAIC37fFyNfQI5Bfj8GvszEYgxGH_1_oEX-6Bv65BZp_cgAgwDAnQIMEY9975gPIMCAyYA9DiP4DA74gwtHfD0FQ8Yb9-CsPQPwB-1837XwfoMMA6Av7jDATA0E3wRjUNYQ_MAzjr7X2-AZKRD8f5aP4Oo74b9cgP0COokYEClECPQMzcYehP6QP4MCEYD9mYgOsV46sMByDVgfv4IR8SwA_1MWAFmfj75v3EXoSJUUmGBGvvfRR6dj66kwFAFOngNBQEvmUCoVQHSYBqAAnAMAaj-HETQbiUB_DDBKlRMqGgWjERaSIAepsRDDxXmPYU-lDLUC4HQLSzlHroG4o0GW_EG5aF0OgWEolNCXMktPDUCVVJGQ0sc8eE1nJdC4HpFSSUPmaW0h8f2XtB7tU2U7bKLsnjjzOTxJ51zuoYG6ugO59gMQGXHnzDyNAXlcERbxXQkkfq_K4FxHiElrkfEhTwYlNKIowEwTkggf0UJvHJbuX6yFVRoQwhIRS_AY4OCpOlS-NUQjrIKG8oF1BPnaRwKOAFiV9moCZRoD4jLSXXPpWK32XBsXOVcr7fFGofk8scroFyn1zUfAho9QYj1IaPUdVwb4LrUY8yJeczVyqMVUsaKa9yIcaCgycras1YaCCQqHrjUc3V7liWRYxQmhq8APPErqx5lq_kiTEpqulPrM2FpzUsllUU5Icv5VAblfya2oSgOhTCwrRVUE6BoS-jRoKH3yvquV6rFXOQDegVV7zqBFtLZoTVcboUjzhW7eQ5Z-A2BUlwGoeUDnwq4KqBE7oHgwEJcu7ia7NC5RUJcCaVca4txaLCmATcW5TRABcXuPqT2rtsOeiAl6cDXFgDgAkRI1I_Q8OSSk1JaBtR4J-s9GgL1qH_RkQD9xHh4DAyAZkzcYNGpXfBxDqhkM3BwFmjo3RMOOipFAXDcHv0Id_UhgDMB8AwHhIQTDyI_i4ZvbXGgOAMzKpsnQdAAE8DQGBnRlShH9Ur1yh8WeB9HpSZ_ZeudjtQi4wYrCQ9OyaZChUzcoU2mq6uxmO7VCuzAXqvWPOxTRl662BvPh-jbczxfpfSNTykoIQQx2vgB4mBuATQRjUGAGyNMa1VDAdQOz0Q5ESFwSm5QaSEvi5oGAIEaTyBpD9ez1Bj6OYIFllLrd0juZsC-01CMqQ3hoD5wrkAxYfEoLbN6ABCSgkV0rw3ilbakmA4AvvhpymjIAIQQnaz6vmRqJa2muvdTai3bo3R2udH650ItcFgO6eQCWYJwUqP8qCuRYKYHWxNTb8bXhQCgCAs-mpKDdTno0bgg7QPGLsISuBP0Pi_LOzAAA_C8SC0EAdtfepsYUYBJrtf-3BNGGstZbci7YaLsW3h1vS4l1Ah3dlmaFOJxKJo8AkxcJreQx9scHcG_WgHLRxNQDOXQFHmnntElezs9789Pv8Cp3tjLAO4pgHSkeAyeAQaoEelabAEPY5WC2TkB7EAYc7u5wc3nXBg5CjeNlY47P4TOXQMfDTTxzNilhAoRQb3VduxrmkYiEB-Ybh5w8VAAByDUNR5CffHju9EOSVenzWnBE30PYeoDqjhSKVoQboAh3ctAaRdDiMoDD8d8rUDCom5D-IohI-jjbRSjP6q23AGTZoF4oX4K-p4lXjQYX-36rz5H73vvNyaAPsWzgYeNONGFo8ndNMiU4QIulbbfKN0uF7warqkz10_IE5TDAdliyGCX0DOy0gBeJBaN2TQrOrAq8mvpnAsBNJPF4Ls60aN5d59m95oDNRsgOpn1YMmFMqbz7OpDdmKtcbIgZz348Af6izAzf4aB0x_6_BcyAFv6iCgHL7gH76QFSzKwwGqxwFQ557eoz74RJAuC57AFs7H5D5zYj52DdRQB64kzYBRhwCPRt6jyhz3CX47oUrAbEgHJp47K46YDwH6ZzQy5YBQyXbwEgHCyf5iwQF-bQGcyYG_BAHAGIFf4oFQHoHyEAGKHiG8r_RgEfAyFoEcywHaHYHxBGx4Fh61hh6t4-7IQd7OBGTd5Q4yprJbbDyCgc7cBm5Ch8i3b3bRCPZcArSah7rXJURa45DOQprJY5Ze52G0CE5W50AFDU4lZxE4BMG0BFz-EGSBETRwI-oeFop-F1qhzUDiLdQaj-52Bpxrh6AKY76ZbZY0g4B8EwDqZs5dBRExaD5uzErHIXIO4VALp-5uxoBxFj5aBD4ubrpAwODP5sjLD8xjHjz5ZQo8CjgThpBThapPgXjXh3g4BfjeC_iATARgQ4BKD_gADib454Sgj0FsVsk0HRr0RBvMRMxKR4JkFqYe48go_yeyakPx3YZk6IbkMA1ktkmkc0-xL4d4n434_4QEoEZ4Vxtx9xZ4SgFhGxogM2CMfUA0Rkf0R0P03xvxSwssWAPqPAO2CxGgiQNAXmNAek1oP0syrOIuWgHw9JeUE03wMIeUjAVwTR6RrR7R7WDOEmTJZ-RyTwQp0M0Mt-YeM2jgEmeWYpLRBAbRcEUp6pTOTJQhuJeex-BhjOtUDw40rg165yoJ_G7R8U8eHx8QNcjJ3YLJBAbJ2AP0EAtJ8Qeg2U0Q_pPA1hLhPeUOM2gg8YixVEAEMUTJBAnpC8GKvUlkxJ1AQ0npU0ZhghbpiZnp3pIhShoRRJLuk61Jz2T02050QBnRsGc2cAc0-ZHpc2RZoh6KMZOxomCZrZnkrO6xRWzmp6rm5WHmHgdgegsAAEGgqgAAUtIGBL3H5jgAKNSN8lwAuZce5HZCrukJvLmY2S8KfgdPINTHLjPkjhoNwHfnnsdEan5iWVYNiA-YMBdGYVYPzMeXNCjE-flCGf2kAa4VYIvKHIOfbksU7jAB8EDCytpOgIwc2E1lRI9NXvqq4QPM4QWEWHAKWPxBWFWDWDAPWCAMumfAJAmJSKgO2J2LQPQIgCAMOK-jANbkFuQDuJKMgMVEFAsmJGFJVK1EgB4MzDgMCMMMCC0gFPMiFPxQxEslFBuDFPAH1tZslEJSACJWJaJZJYFJRDJR7FVE4FRHVM3JQI1EkC1B4IgMJaJeJR4PWInGGlZR4MIfgDmJJSmOqJxUxcnmnOpSeuImUc2LgCwHWv4P4OyCkUfCAHoJukzs5aReWIFcEXFYnsFW5SQPZTOMxaoEoCxSJnQOxfAFZUxQFUkP4LFRgLAIJdZSAAAHrDDIw4APySVajwCujqgJV1UPzhgtUgC1i1jYUlhlgEWIDVhQB1gNi3IGC4CdiQDNCJjUA0XUB0U9gMVMVoBNZ9BjiUDsg3hES0DqpWXV7ZVODoBmSdCCAgSoBia6ANzHUN46QgAewJWBndAuCCXZW0D9gDRHr-VJVJD2VDW4UjWVhjVEUkW2hzXwiUVLXIAdgrXdgMBMWtC2TVUgTqhGTeWJx6gGh_W1WtC6ioCJiSXggPKuREAtycXjUuDZXwAIS42wDjrsgPVhbZWUgxTiLWRWU01PWYDkCYjcRqXg0TV805KC3lkaoKA81EVfXlgNzezqVHjSDXweUIynyK2IAnUeDJYqA1UeBoiK101YAtR9jdhvB5VUBC3pScXa0gDNxCo5LpQbjpQIS2CCA4Ss1PVtJ43glUg0hTzqXtFZUeDYAC01D8FIBzQeDtFvg-1ZCSWG0eA7SDWFjDX4Vg280DW1hAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/showcase/ribs_table_interaction/src/index.ts",
        "description": "This showcase demonstrates many of our interaction features."
    },
    {
        "href": "examples/three.js/clipping/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1Delw8lD8SWVgsFgN8pRwEhDUZfx6cJRQAK60DbBgBGWdXASU8ps1HqmijOS6qvxwXEV5p6jncIcmt_dHJumqr3DkGhDyBNtJRR5IiUdCLWAhOAach5KHkYxoTC4AgPECsExfH5_cImRIpTgmFhQYQgAA0IAgcAAQmh-BokkgwPwoC4AL7kuEIjDYHAosggKg0OgEBgQIhjDT_ABUXAuXG8AAkAEoAURVXDAGkoRC4HhKGhgMA8dU4Yol_2AcS4KoAaiqAHLebwATQACirSVbvgJaDaIDB8ubPSJvfxaNJ4BNqMGeABBVBisNTVBKMP8GNcACS8cT4mo3g0_HIAGsM186DAC4aMwBxGDa2z01N2DOCdAAGUptFQmk4rI1Wp1HgAAnA5Ip3ppjKp_fleyATahOAAKC5JVDkLjLgCUXFcrC4lpExmMDgNYZgsq4M4D5q91Cy19n5r3svy_AkZ59MD9t8okuXI8rGeC4ynQShyEWGwaBwZpbBVWBoIIKkkkzdBlw8EDUV3OUFW8ABZdsAGEzguBCYCQjMeCKMoPCIJJf0Df8CA8K1WW3RcrRPL8LyvFw4CjJcQwff5-ME19-HfT9Q3DSNk0Aq0eHEEtbEQRTRA8ABmcoAE4wHKAAWMBKkCchyhgAA2AB2fhAisoz0ECAzNKLGByDAdBNIAJiqAydKsqyvMwPRKnIdA9AAVn4Spwr0TSdM0wIIoinSvP4coIosmBAk0qzNMqGADIi8gIpgGywFK2YIq8mAMr0czNIs9ADIM6LUrAKzykEdLNO02qEoikKwC8iL0B0lrAn4MBNIM9BKjbSo9HQKK9DAQIdKc7zBv8w0dMsqoLL0EafIslqmoy2zDvqwI9AMypykM9A1p09AvIqnTKh0kLAmy8gbr2mA9H8KyIvKQ6YFy8gjrGizJsWzSSqKvQppcmBQaNMl1JBTAoEYzwNCgWiQEIAh5DgRATzgTBFjMnAYEWfxyGFQsoH8cocDHBQYEnDQcCoIgPCoq50CJ-iIwE5NWJEdjOOPU8oAg5kHCgX55DQZouF6XR4AcRYNANGgoCSLhwNQAByf58n_YsuEKEpZSIPR_RoLgIPIJZBK409mgV5GoGV1X1c1voe0uK2NBtmB1G4O28Adp3hVd8h3cWQTSWDgQXEyQ1Gk0GAyhJsmKeMKhMDgXRwsMHApmMOBjEWMAsFQAzKHvVBHx2Ys6EuVwnz_SUcDGLJXS1JmJdQZpYPgsAwDcghvEoLv253RceDAf8t0FR9LzQbZF-77d1IgMAt077uAG0YAAXT3Vxe48AT-FbkAuAAH1fvel7gS-b7v-_ieRs_Q-IgrA3iYgPIeBAR4QTkhPHABoQTqBVDPOey4YAcViHLLgAB1S8MlLz2HdoHCewdtZe3lFELgqB_xECVukA05A8zcEwLQDQRA0A63yHgCAjhMhFEvHBFEAd5ATjbo-IhIj1auhDpeXuPZ8jymVGqHA0jtbLnkYo1UKocA2jnv-TSy5yjp0qMY7cpjZY8G4rgrg550Cu2WNsSh1DMCOLDLbS874XY7GEWI_4lBljyAcb3MSksQFcCngQAA8gE5YKF7T8BsBhEAShKD_g8MAqwOBIAYGXMuSgu59yuxwLQ1hEAlYAEI75cEWNybJ3NtzlIsaEU82Cog9nUFoEol4wEvjkJcPQhpuCLHkOgC8di5yynQHYrpwi1YkK1j2K0bZOxZArBoZctoHROjdNom0mYVTYNdJEpU3gdH7MOcc7wAB9TwrolCxm8CqJQ6cdx7gPEBUQ_jSbLBwM4mAAB-XkhYOkuGbPwXJ6ACnvPUtRE-y47FoCyLoJmlAT51gbAQJsaZdwfKsDwCFfNqAdNoOgSJegABWc9z49OYtXdAN85SKi0TgfC8A8AZLxZkkpmgyn-0ZUo7R-ELw_GZNuPmKtJET1UaHV858JFzOaNK6-q9OVbnhYSu4mgSVkspYw6lz5aVFAZZcJlyjWVjg5aq8J3KRV8pNQKllwreViokbIQQlB8g922BoRYMAVVWFZOpGWbEMFCUsaeBeT44CLGZBAAAXpeGZMAUGMPThMtsspuC6FzMmPejjLzlkWcJdu_xMVFmLOTLMOYSnJgLOW8-v8uANpVWWkscBB6pzwApMJ4gbCVvPiYrgBl06BCvkLP5ZQvmBIIL80EMBylC3OEseAZQB3GPXRUAyOAIobsHXu4xY71LyDDKUXUIAy3tz6EwwWR8hQaDGFe5MRMVY9jpFLHgwaw3NPcTxWg-bM05uoCbNMviAM1uoGC18Gjq1Jgg2mJJ2bwNLjJN68tcAN2BFDTwRDsGUxpngTARQbje6Yt9SqnDTCwUczsJKGDTCV6YPDZmuxGbPzeJmYWo0IhONVhgPA1JM62xgtXAmJDYKsOZCZj2Xj_HKAzuGaM30mhBIMdQOxVTZIKTUlpPSRkzI2TkmPSWfgcEcDkvmKgfkgpuwikQCAS0IBMCKG5Buf0qJkAjk5hONQU4wHzjUiATSOAfLBZveevABoMYBcqDgcoTkcCVA8OyOiH5kMBcRDyIkYXMS_BRB4DzIAkWSnyx4Y90IYD-wy7gIkXB_D-F2HQMLehFjQHQCVkAZWmb-2a61q43JqvECgElz0jmo5KEI3QTArn4D5Yc51ir_hmsYFgBodrAA9dm5QvLbrC9kRQOW_jrYijgLdEUkusk05SGkqA6QMkQEyFkMB2SFYrgYXAgpICT3M9QKz1AbMMAc2gbJEgYDtlSfIaBtBGGSyQKRmAI2nDoCVBVygghImoCInICeUW4cjbAe1vQWpPXzhG7QcUV6oulbpF1pLl3tM3d0_d_TT3yQog-y0MzFnftCnoHZhz_M1YrciX8ZM7mHPY3BJTgU2oQSoHM2FhBlB1BERl8KdzD2XAjfgPhUEkvMx3t2Pl3HD9_HlaFfIfLGv4ceEwO7OkuHLfM5G7bvohYmHm8d490ndJBHtZVNICy2XMU8JYrDn11uQBfJUKtpANuuxhewIoH4SFmTjaoG7_87njcgAohINP_4wz_lZXYRT_Ajfh5GxL2AyP5hLGvbHkAfzhseGwCnTA-Xz4eD-VcqvM3MaOfjyAK-F3yRXZ03dq3rIp9AA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/three.js/clipping/src/index.ts",
        "description": "Clip part of the geometry with a clipping plane."
    },
    {
        "href": "examples/three.js/converted_geometry/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1Delw8lD8SWVgsFgN8pRwEhDUZfx6cJRQAK60DbBgBGWdXASU8ps1HqmijOS6qvxwXEV5p6jncIcmt_dHJumqr3DkGhDyBNtJRR5IiUdCLWAhOAach5KHkYxoTC4AgPECsExfH5_cImRIpTgmFhQYQgAA0IAgcAAQmh-BokkgwPwoC4AL7kuEIjDYHAosggKg0OgEBgQIhjDT_YBxBwaAS0ABqEBg-QlBFJMu-8pg0ngE2oGpEAHEYJQbAR6Up-HZDTwAJLeOUwAByoJgnFZXDAGjNXA8AAE4HJFO9NMZVMr8poPHVYqhBVlMnR0K7xJBTuJqFxXFwABRmWBlLI_VDNUlcGxwOD8ZowIsWtDNACU2dYXGlIggYDzqa7EAzU1QOEUGiIlP13FcU64AHJmhpdLR0DOWx2rKgVVxe-nrYP8xJYOXgFw8WVK9Xa1xWU3YyJPTAWTArt3c9v-7vqMPNGOq4OuABCacZ0wVBlWXVcZR4N8B0_OUAEdFngAgAAVv3HPcm15KJUFzEcfwnVt20g0QuzzPD0KzKccznBchXAoiRCsHgN3yLdKDTd9MxwgsYCPE9QQGCs9RrJ9r1vJir2IsSZVZD1b04XMLiSeM8xbVw2zXUJjFlbUuHsCMVTVTVqETAzVUoSVsz0_J-AkHTrRgJVDIsghc00nhnguMp0EochFhsGgcFrAgAFFYACggqSSO10FzDxPNRFsLi4AAJbwAFkABkAGEzguMKYAi20SPQMoPCIJInPMyUPBkm84x4YxtK1By9KTX9qGM1BExcDrJ2s2z_ha2hdT6tziPEcgAGtbEQYieA8ABmcoAE4wHKAAWMBKkCchyhgAA2AB2fhAiOrb0ECDbFv4cgYHIMB0EWgAmKoNpWo6juezA9Eqch0D0ABWfhKgBvRFpWxbAkBwGVue_hykBg6YECRajsWyoYA2wHyEBmATrAPHZkB56YERvR9sWg70A2jaQbhsAjvKQQEcW5aychwHfrAZ7AfQFbacCfgwEWjb0EqQRxb0dBgb0MBAhWq6Xq5j6YBgFbDqqA69F516Dtp6nEdO7WKcCPQNsqcpNvQeWVvQZ7CZWyoVt-wIUfIM2NZgPR_COwHym1mA0fIHX-YOoXKnB3Hsb0YWbpgf33TJYiQUwKAqs8DQoDKkBCAIeQ4EQJq4EwRY9pwGBFn8O6aAXKB_HKHAgwUGBQw0HAqCIDxip4Ioc4q0aJ1qu96tQGUmq4AB1J85UELhKGWbYoi4VA3SX60uCjTfF22SgHCgX4usTBf88XnNeqHxiuCC2wAHllnkZYoudfgbDikAlEoCyPCbYicEgDAuZcyUDUm2SgOAiAOR-MyAC05FjcgAa3Js_55IiAnsNJ89hThQCgLHaa69_iUi4Nge6yxW6b2wjAdQWgShPlXpgBwchSzwCPkNPQVlcwsVdJgAA_GUB0TpuEwFAQxKwpFcz_i4W6FscoCCLA0KgcSogJ4Wn4NQlwekcFcHQNaewJQN5ELQEvJ8Xw6BPgtGrE8D5KCsRKEQ-h7or5SMwLyBc6jlC6KAegER7llHaTABZYh1CkhcFrGaWw9JtG6PLFASgzRjFLydDgAAVpcSgehkn3RROWfIeB-x4CuNwOxlxTgaKIbQrg6V4B4Hms-PM6BClZF0HdSg3YTThItEkK0dgIJXysC4DA0EPw4Q8O080lpdHdy4AAAzGRErpuiygABJgDoFZNM0eEkPImQWDAHAsTmi5nQB3ag1Cly3wyVkgA2mZNUOAigAF1NlMVklfaSd5UGNW0hcCYzQinLxPo_IazJcG3SmnpDADgQVXH-NQO6MpAXLBwIseQOjaC5RwXg8FOYQ5KJDsAh-SKHGj2vLmUeZIKTUlpPSRkzI2TknkGCkSKT5ioH5IKWg9BEAgGlCATAihuTxmVKiZAAZm4hjUGGMy0YkBLRwK9eVHh2TlVsmPWVFJuS4CJN3DwmJfgog8KKkATSarqsZdCB8hSkT4GIFALg_h_C7DoDqkAehFjQHQIajw5q7p2rdR6q1PJtUgGVXyqhSgYACpAuQYVhreU-ofP4N1GBYAaC9SAAAeo3coz0cCAxddkRQeq_jpozYDHAG081KtZBSykNJUB0gZIgJkj52TGt0ADQwJzUCQGaCy6g7LqCcpFNy3laAAESBgJlL-8hkI-loOQLihqLSIQ1LnOk6AABK1jBC31QNlJhtZl0aFXR4My6a9A-nyC4NNycQC0HFH0Wg6aE1QCVbWqlDaaXNrpTANtKJBS9v7Wy5AAoh3CgYLyzu8hoCaFvn8QcIreWp3BEnOaYGiAglQKkl1coQTqGymaCKIqW0uDXfAdKoJUN2iFD6eQx7T3GoXha9KChDWkd4h4TA5A-gLiXbSx8a7uO8eGax-jAmyMeDsBoYK6aQrSAOi64s_YCAMc4yAE-Khb3oe6Kpu92ARximFMyCNVA-MWRFSu9ThUJCmYstaCyVS7Bov4GptdKHYDbvmEsfj6GHFKvI1gHjixMCGquR4BxAB9DzLC726Y8A8mt5I63UqbRx1kGWgA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/three.js/converted_geometry/src/index.ts",
        "description": "Retrieve the converted three.js geometry from the scene tree."
    },
    {
        "href": "examples/three.js/gizmo/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1Delw8lD8SWVgsFgN8pRwEhDUZfx6cJRQAK60DbBgBGWdXASU8ps1HqmijOS6qvxwXEV5p6jncIcmt_dHJumqr3DkGhDyBNtJRR5IiUdCLWAhOAach5KHkYxoTC4AgPECsExfH5_cImRIpTgmFhQYQgAA0IAgcAAQmh-BokkgwPwoC4AL7kuEIjDYHAosggKg0OgEBixVAQIhjDT_YBxBwaAS0ABqEBg-SlBFJcu-ipg0ngE2oWpEAElfNAYAAFOn8Gy0DQAQXkEGNPF8ABkHQBxAD63gAmpaAKKurgm7waXRwMCUDREfjiaicVlcMAaShELgeAACcDkinemmMqlV-U0HjqnAlGq4ACouBcuN4ABIAJSDQdT6czHhKCpgFarktjMqbkdQ0djRAAwtQCOmWVwU2mM1mQH2YDBjNhbb14MYAFZwIjGQXzhZwYwRqMxuOzmgL1GV8XD6VcYBcdTkADMpK48YIAAWJcu1XDxmigfwAJ-LBB1QTgAAoLiSVByC4BCAEouFcVh3zlYxjHlXUG0_UsNW1agslItUa1cBt8n4CQiITGAVRokcENlEQeGeC4ynQShyEWGwaBwZpbCDWARIIKkkhNdAEI8XjUSwxtm28ABZd1pzOC5JJgaTQx4Ioyg8IgkjY9URw8OVWQw58eAI5jaBIlw4ENeCREFKi3I87D6MY_4dRY_V3KmVBOLlHhxHIABrWxECi0QlIANgATjAFLvxSgB2ABWao8pgPLZnKfgYEAwCipS8gYD0QIcpgchAP4WZ0CqtLKgAJj0Lr-DAHryBy_hasa9Byr0bK0vKLrAOKtKury9AwEA8oarylbKnQZrKnKQDyB_LrAn4PLAOO9Bym_dBdu_coYDAB7-Cqe7Ajy8h0HavLbv4b8cu_cqwBgNKUpgbacsAlL-CqypAnIcolrAQJAnQLrv2_NKlpOwCcrS1rUaRwCBtOMA9D0WYHvKKp2sqHKyvB5Gnq68gSq6kmsr0Fr_BS1aBuB9A8rSyavtK-7yE68hZqZdAcvQJGPCM_9QRgKBLM8DQoFMkBCAIeQ4EQAi4HQDRGsWOGcBgRZ_Fqh9mX8cocDzBRQbUTQcCoIh5aSky13M0KPJskQ7OffDCIdS4ShgLhmggAAvEEHEWDQFRoKAki4AT4C4VBKH-fJY1irhChKbYoi4MYqPkdNarC1Bmi4e7AfIFE_zLLgFRBdQS4MxpNAHEQAHk9APJqCBweKkjgBCS3Y6UcHLghLSrg00GaMSJIekfvEoeKJ0wjCcFvIMRrwBCEJ2HesJwvDuOoqzZ_nxfBOX2ucHbyh1CDDem7P7e6Hs2z_6eUcoRcS_wI5cEoMseQywS4JkLpHBiNBtiUG2OOSccYKITn-BKfg4lLR9FQDAfuUCYF0V8uFNeBBiE62WLJAAcraGAikQAmnjOJLg-DdADhABhAA2pUAAusHEQTlgouXsIPYeTdvxKAbJcewvQRqRzwAsTAWhdDoEyLYLuZdxiTGoMgnRBhFgYBXlwAwWAHDCnLF5SiYC0G3gAuFThtUVFQDUf5Qh-Qmxtg7DgSRI8ZGYQcg4OxVw2FWgIUQh6Lh_h0S_N-N2UBqBMK9hEzhhDqHQNHtnTAABCHAxjTG1ypIYQpkDinNGkPIKICo3bWI0HKQB0UHFTgTM4vorjVGu3Lvo1ADtbCKRvjgvBUT-4xNsPwgRCsRmRK4eMsAsTeHlGmWk3BczMkTIILwrqAimnCOAc5SO4D5w3inKEh8F5MFUTPAuTxaoxxnLvHOR8QyrDTzvqPDcMAABScBZwKgCU3OAbtGGRgVh8jUvI8D9j-QCohQ8R4guTmo12AkiD6WkvssUhyxHHNLkCggMjMjzlNgQROkcNENg-lcMBKDwFfDoH3HiYT5B0mFIS-53iWztiDP4xF0ilDBMweeKAOAEx2EcGfVpcZ2nUBcTANxajmll3ZTQQl4qPoIVuQsShzZlaKA0HvEJbLk5UIFaPQQClTkTkcXK1ACqlWaBVZCkc0LYX_NjAiqRKIHbWxgJqhSpqOUWsASHK43BwFKTkLXbh9d1BIKgJSWghCtCtwVIICBMDwHQQgJYlcmZwGKK6e4zQDYMANnkL0NOTEdg6MgTQ_4uTmUXNFYGoMCaCDumTUyo10bdDiXluhGAl9cJcSsN5f4ubLF0QAoBA-3YlTMkWPAN5VguA4E3Ta9BTj5WdMVd0jQOBp28koA6JO_RMJJTDTfJy6b4DaPAZQLZPcFSGOzv8BQ1baXbDztsCU8Akpzt5GgvotA11WGnQrHgUGko8ASTgQhzQWJTyaokvFmE_yzIydExZtgMLXoOaISdEakT-Ww2MkhOSlYFO3XaxME4D6IhNNyLAEHRBnzKOGGVu7UCju2DgIo2FXB0Q8NIJQPpo5x0oD6adAcrAquMmAdCiJsBcDySJrgdssLjvXRR-ZVHEM0ZA083jcBeGqawAI49CYYL-WnSEngKZlYuGvuu8J6ycNZOWEZ_Jgbry2raQxyKN8rDezExJqTIJZO2bzZ7ULog5MJaDklVkOLRCutnoseQ41aB0KVghfTmTDPNrySqlLQDQiEXvdHLIZbwHTgdBpIMrYHQ-l8LygAWp2fIURCHqC0OAo2uDo610aF-ugDwRCwCCmC_gvh-wxxgGULIPxa4hJ1WKq1HbhTdrq6m5hw3mijeaFbGN4l0BDrACYpu4Vh2dp017ZTCEYCdpwOcJYkcRN0VJSOtz67Tg2EjAtzcS3_KZctR9XwfRmgIQ9N6P0gY-WNea619rXWgyKZAi5yOun3lkTdW_dQ0PcHarmyDmAS2sdpcDjew5Cpav2h0dOfudDvAmjoZ4funhpA-nbHQpQLWOdekMWeNAixIFwFTm3OgHiGX-uuXSne95xCoAl4sOArZZeaDMfEgns8rUk9h0leHvoAzBhwCztnHOuc8750GAXQu6FemxSIwiDOe2DdLlb9nnPue8-kM2B0Sh-4AHUfQaQdJaH0nhLRKAdN4Tsdaxdq8l9L7LuX8WR0dgJfIU2WVYOQcruc4vJeyEEJQfIGkFCeByyxcH-vIfoCN-x03iOLc-5t_7n0gfg9h4j1HmPceE9Bld3ZYVqAyQUmpLSekjJmRsnJGyuK6ycBHmoPyM8woGCyhAJgRQ3JUKqlRMgHMjsCwuw0MWUs5YkAeESV1e2XVPbrhhZuDwiUQCVBwOUQI87KgeDshmSMTwR34Uisb4DEBQAv6Yi_Aogf675ZB0gEAf4eCmq1RQCkY8hEhab-C7B0Av56CLDQCXZgHoHKzmLEHuJYG4BEiAFah76vZKAwAH6YBH6AZkBoF0gYH-BEEYCwCNJgEAB69sM0OAeUL-2QigsBfwqBIAQheUOA86EhIArIrIU-lINIqAdIDIiATILIMA7IIAcAGiFibs1AkAq86-k-yAAoc42-iAIAu-aAkA4otA7olAuwj8tAt2SYSAv2DBTg6AWuySgg_cqA04523CiAARHgHycheg6Yeet-DBtAkoYG0RXB0IysgBGhM-2hc-ehC-hh5IKIgolha-8wNhFA9h9Ajhu-7szoAh_cfw4UJ-u-IIYIEIYB7sIIqAR4L-ROMAs4RA0kJ--hLgDB8AGkoI4IMALG9ouwH-sRxhkC2R1e8gH-ExMADBmA5AfQkYDGWxxRuxTUBx9qGxxxBhqRdIoCchQY0gKUMB84EATcyxGgK6DBDaKgghn-3QKBZIHg2AhqAGNAzIzBVAhxsYJ-KxBkEgEJsYCYsYGktgggCY_A7xnxZksxsAWu8wSwRxYBza9BQJWA-xiwmAH-vCHgzasmOJHBuxyaHgAi6h5Imhs-uh2xahrIQAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/three.js/gizmo/src/index.ts",
        "description": "Use the three.js gizmo to move objects."
    },
    {
        "href": "examples/three.js/three.js_data/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1Delw8lD8SWVgsFgN8pRwEhDUZfx6cJRQAK60DbBgBGWdXASU8ps1HqmijOS6qvxwXEV5p6jncIcmt_dHJumqr3DkGhDyBNtJRR5IiUdCLWAhOAach5KHkYxoTC4AgPECsExfH5_cImRIpTgmFhQYQgAA0IAgcAAQmh-BokkgwPwoC4AL7kuEIjDYHAosggKg0OgEBixVAQIhjDT_YBxBwaAS0ABqEBg-SlBFJcu-ipg0ngE2oWpE3gVMAAcqCYMaeN48GaAFZwJT8Ow2zLkOgwU0wGCcVlcMAaShELgeAACcDkinemmMqlV-U0HjqnAlGq4ACouBcuN4ABIAJQAosXA8HQx4SmaU2KABQXJKochcOsASi4rlYXFlImMxnlupzXATao12uoWRHiYzrhz-X4EkHrpgKrHlGldd7VmeFzK6Eo5EWNhoOGatmLsBPBCpSQAkug6x5d6iO7n894ALIAGQAwmcLkvGBr3dHgijKDwiCSNd1Q3AgPDlVk21TPsBx1FdhxcOBDVQCdUCnLCcM7edF3-dDaH1bCplQLc5R4cRyAAa1sRA6NEDwAGZygATjAcoABYwEqQJyHKGAADYAHZ-ECSTBPQQJ-I4_hPXIMB0A4gAmKp-O4yTJM0zA9Eqch0D0ABWfhKjMvQOO4jjAnM8zuM0_hynM8SYECDjJI4yoYH48zyHMmBpLAELZnMzSYHcvQxI48T0H4_irJcsBJPKQQ3I4riYvs8zjLATTzPQbjksCfgwA4_j0EqQRar0dBLL0MBAm4xStIKvTfW4iSqnEvRiu08TksS9yZIGuLAj0fjKnKAT0Fa7j0E08LuMqbjjMCLzyGm3qYD0fxJPM8oBpgHzyEG0rxIqypbOCwK9Eq5SYBOv0yTYkFMCgGDPA0KAIJAQgCHkOBEH7OBMEWUScBgRZ_E9GgNGZfxyhwKMFBgWMNBwKgiA8UCrnQQGoMonCEJEJCULlftl1oYdUCtbY5DI6g7DQS5KEWLR0Fdfg8KnatfSdS1MGI1A1TzM1RZgdtqdQumYBzbgAHk9AdGByAIDilGV9Ac3QfWlx2ZmlcZsXc3sXm7CuWh8ZEQUp0odXxclgsS2LHA1Y1rWdbluUhZgEWrRwa3-BweRFijOsJfyPN7WF50-brZ2HTbZCxR4Wn6uVpIuEYxEuEoMBmbNLgnVt4DLhNkpXSL9XNfgh3J3-c8Q1selXbj93SxwbwNyjgBxGB24Iek6yqUkuA4qfTtn6oM-b_D_iIFcfmZLu8yLXvP3gPAqQuCByE_NeIGZLcHAWDdNiwMA76EyouCpgX_h2DQo83nvPd36O25sMekhT1XrQdeUBF48FTjgeqdY35R0XjTAcOcShmyZjXKIHovTbDLrofWix5DWz9CIL4XofQwBwMGSgBAoGG1_HgaAj5A7B0wOAjBEtSHkMoJQnAeCCFKk0Dhf2IhRywWlNw_BK5BFIUEWSCk1JaT0kZMyNk5J5AqUYvwc8OAnTUH5IKWg9BEAgFlCATAihuTNlVKiZAEYMYxjUHGYRyYkCcRwNpVxBMqwJ3eqxEAlQcDlEUjgSoHh2SQUXLhZxFJuS4CJB4kAmJfgog8NY-JdhpTJI8Ko6EMAoBXGifgYguT_D-F2HQOJehFj0IySALJnpckVPoXkpEBSSAhK1CYmAqglAwDMZgCx8BknGNqTk_wFSMCwA0NUgAemjcomkcDmTidkRQCS_jTPMjgfiCyQmshkZSGkqA6QMkQEyFkMB2TxJwQYXAgpIDNC0fMVAui2bCgYMYtAkBxS0G_Jw-QAAFYMtAtbUWSWPRY1oPBOHQIWHJlBBAq1QLQ3Q55QXvwhSAYR1S9DBnyC4SZH0QB216CuapwyoAhL2XIw5CiTlKPOeSFEtyWgPJ0cgAULyDFGOfCGeQ0BNAqz-NRKxxivrgm8dyogIJUBOjiQqEE6hfwhmvFY05Lh2nwE_KCMVd4hTBnkKi8F7T5jc09CffViizntMwOQPoyNxDUGSaq9F1rbWumomax1dL2lpPPPBSJxZpDiTiVkH4WsDXoq5gQFQ-KfHdD9eqrAigfjXmZN0qgdqNxWLBei4CEg00bldBuXedgw7hvaaK2AML5hLHtREnx5t3qhJANgG1ixMDJIANoeAbQAfQrQMglcaPAAF1dnkn2fI45TrWQzqAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/three.js/three.js_data/src/index.ts",
        "description": "Add custom three.js data to the scene tree."
    },
    {
        "href": "examples/viewport/branding/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1dR6poozkuqr8cFxFef2og3DdJuOTPSbpqvNw5BoQ8gRc2Yp5RJToAK6wIXAa5Hmn5MZomLgEUyCsJitrG-EmiSmcJixQwiAAGhAEDgACE0PwNEkkGB-FAXABfIGXa4YbA4e5kEBUGh0AgMCBEeSUDSbYAODQCWgANQgMHyxNJAK4AFFqSyAHLebwATQACiyuAiuGANJQiFwPAABOByRSLTTGVR0_KaDxdVCcAAUQySqHIXC1AEouK5WFxgHFQsYKVSYFx7Mr6YyCFacVkuE6GSTNq4Hfl-BJbfwaSqXVrLSIeLMhmV0JRyAcbDQcM1bCzYMmCKCkgBJdBajwxh4moZcAAS3gAsgAZADCAyGGZgWYBVp4RTKHiISVp9LVgPbXD0Gl06VQzTKkasPCglGalC7IEIBHkcEQxkiMCg8gxhQItA0OCoRGMONoNGM6H4p6iO_8BH3h-MI7HxjnC5w8gnHjbUdEej8OQADWzRigcGB1pQc4aEuADEYBgNU1T8PwHhDgiVoIkaGrYcaGqAsCYIQlCMJwoiQLyEBwH8GmOAAFZwNQWLnniDCWiAmCKGi-p0g8yDSrKCgwAqGhKiqA6IB4ADMOAAEzlPJHhIt2gaakgHg3Oivy_h4LzrPcHgCSAWSQq6GkgFRZzbiMaK4L8XD-P4lDcbpIB6Ac0DoEZHhWeQNkeV5tm3PgxBQMpbacTAqhKDA3GYLx8BGRxfnbv4HkYLAGg-SAAB6inlHJOAAKxuds8CrAZOW5cVOAACwlcpCKESC4KoJC0KILC8IwEiJljgYuA4pAzQMUxqAsdQF74ogIAcWgkCoBIMA1pQLl8mKtDkOI1BGQQGgHDAkVOOgABK26UIIADyqB1nIE4wHtB1HR4Xo5SOlD5C42WDiAtBElAIaPRZqXhSAzVAq1JGdd1FF_Ss1AjWNzHINiU1sbNHEnvI0CaFdGwQNQ_EcXshzHBZJ57KgjFuZSezqFBRBZvxsMvSA8BVvsRwwLmuJivIT2HZFTEHNZVYKEZrORZg5CA6OO3qV15FszLcshoTqDiwLZE9ZFdgaGm5lSSALLSAAbG5WRrNtgts5QBwECoP3G-kWRudgihrFmcKxVQ8skvx-1Cx4LYSL7JIhiSVa2IIIZoUgQds6T3PnUxUAOxrOWoPswMqezWCywcmBGQA2h42eYAA-snsAPNLILmQAuhDRFtR1OuIgiCJAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/viewport/branding/src/index.ts",
        "description": "Adjusting (removing or changing) the logo of the viewer and setting the color and opacity of the logo background."
    },
    {
        "href": "examples/viewport/cameras/change_camera/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1dR6poozkuqr8cFxFef2og3DdJuOTPSbpqvOLmdm5HvKUcBIQ1GX8enCUUACutA0ElPJlAKz13XFWvC6w5AQj6GP8NhpDDyJPXhXcTULiDU4wPKKZyKN5qGDdaFwWHidQmYG7VA9KyMDGg8EnSEeS7ybok9HyEFYx6A3GUzFg_gQvIGAiXIjdVnsilU7G9PHcAlEkCwMAEbqigg8zF8-ICxnMjwaFqEbrK1pS4wC2VA-n4pmEvJgDTUcUgVjG03S6g6ulUhWGjx6fjkADWnJdrut1IBvWMLxgb3mxkW8zg5GVlK42UUeSIlHQJ1gITgGnIeVT5GMaEwuAIU3NJnDkYI4RMiRSnBMLCgwhAABoQBA4AAhND8DRJJBgJkuAC-jcz2Yw2Bw-bIICoNDoBAYECImw072ANIcGgEtGk8G21Hrq4jG5gADUIDB8ouCHvfQB5ABK3gAEteAOK3gCCAAUHwBJADCAH1fzfABZABRd9_yUb9b1A39vG_a8ADlHj7LhLSILgPAAATgORFEWTRjFUU98k0DwuhER4pyyBxvk0fgt1ed5XF4B9vGAgAZRjAwIUDYBsGhWHQShyBOASCBwZpbD4mBxJbJJv3QAAKDx-h-P4QAASgonhHiUoYklQcguCUzSuFcVguBXX1jGMNdDy4exiLPC992oGjnPPSgl3Mxz8n4CR7P4WgTxc7yCCU6zAVmIYymE0TxMk6T-JneTFJUycBg0syhi4NjON_LK4Bk8Sr0BIoyg8IgklCrylw8Vc-201dbKC2hHMybdMTc1AaJcOAd24Fj-H8wKD2CmAtwGzFItXHhxDdWxEDm0QPBuSoYD0AAmfgtoANnQdB-H4AAWABmLb-nKQItsCQI9ECfhyi2jawHKABOE6ezOm49Ae8ozpgL7zv4GBAne9A9puAB2d73vKfhAihsAIYEXbKie8hAhOjaTuh8h0DAA69HISoPoJ8o9tB8obn4d7-D2vQzv4aH0Hh6Gtq2k6bhuLa4chvR0D5vRyjAfambAMAzr0aHBGO8hykJs70HWqXnRO9AyYxm49rJwJKkJsBAjAaHufIT6DsEPQTvKSnZbO87yhgTnlb296ma202zrevbof8X6LZuFGdsqcgUfILafoegQzpp469FDlWPDKp540wKBas8DQoEqkBCAIeQ4EQWy4HQDRoZgE4FZwSv_HIGdfigfxyhwXCFBgAiNBwKgOQbFaKswkBqqmwaGt9JqdMw31qPeJEUXhQr1N8zyL27ujfgAQknnqaJJRf6OXkjV_G2hryXPBKGaX55DwCByH335TMn-argf_gcHSdc4VBFi70fF93xfj_IBEC4E3yQWgrBeCSEcDeGvB-be093LvC5JQIgb9D5hSXN3dcE0z4lEvtfW-99178CfquVB6DSEfwgF_e0v97xPlfJ-H8AEgJgQglBGCcEEKIRwC2a83g4HAUQVYGeXBJQYJYivcKODDz4IvlfBQxC37kN9JI6hn8eIMgYf_ZhQC2GgM4ZAnhMCOKgV8N4URohxHqkIFIsER9ZEnxgAowhyi76qOar6OxBA340LoTorgf8mGANYSAjh4CuFQN4TgW835nxsWsTwcRloaAOJkdglxbilE308aQtRVg0l-M0bQ7RP9gmMIASw4B7CwEQO4dAvhvhbxISsY8HeKDPQZKcVk3Bp9z7uLySQ9ShTRDOjdP4rR38hqVL0WE2pRiokmKafwt8v4ADSyTHFYIkkMbYzRUCqLnto9Q_iijeN0tPUh3E3g4GoI4XQUlfKmXMpZKKTw4CFAII4Eyal6K3IkkKMyHzopDBgIPEkHhlq-kBJkvZ01DmqL3tQi5z9ARcD0Lg102yxHgsHpQ6FK0rDwpwPsloRyCmUPOegS5GKeBYoEDijpsKbH4o8JKIlrKSW9IRQcyloyNHqRwGi4l4zsW4rZS4QeviuX0p4KS8lSKCm-JpXS-ljL-DMsoty2i0qPDFLlfKxViKBX0SUsUtV6LASau1Vc-l_R9UgAme6JAYqFW8rJaa1RLqrXusxRKsVmAexJgIDC-VOy6p8opcczQyJTkwD9ayvsLK4WepOPII6tAxk8D7JPJqYyGxNlbO2Ts3ZewwAHCAeQnp-BSRwAAKyOKgCcU5aD0EQCAFcIBMCKBHEZU8BZkDYTbvheEGgiIkTIm6kAZ0cBbRbltDwA4qoBVQESpsI5cA1mTh4YsEBKRDu7VkDsZplrVo7PXKAIwt34GINe_w_grh0F3c6k40B0AbprWmGA169DvqgOgG9uY70kGXXuHtMBVBKBgH2zAA74DQu7d-q9_h_0YFgBoDdAA9Fuz0cA3FfTGeAEYD1no8Nhm4OAToEeXX2ItzY2yoA7F2RAPYoD9kHLodABhcBTkgM0RtzbW2mhnAwbtaBICoAkDADilArgfhNLQGZ0KCAaEJBBpw6Bby_soIIa8Ry5CoCkqp9TMAIOeQ3Viyg-QXBYb7iAWgC4oATS_Ze39y6GMluY2WtjFaq35n4y0IT1ARPTg7V21SaD5DQE0NePUvUkNVQTEmBEM6e7xlQE219654xnLQeJId7GXAQfgMBFLsBvzThNKSJAamNN7soCcH9wEFDQuK-ZjwmByAud-FSdrFaIPdd68FTErXat-Y451xzHYpLkZAKBaQe1X1ZGVG8UzDWQBNYICoez570hZFfdgaE84ZxMhg1QPr3kh31em7JCQF3vLBW8sBWwcs7Abem2nVLOmjinH6zO1ACY0srpANgHrJxMDQoANoeCB5gf833YAFiG82M0ABdejjZGOltYx1vsBOgA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/viewport/cameras/change_camera/src/index.ts",
        "description": "Change the active camera from the different cameras available."
    },
    {
        "href": "examples/viewport/cameras/movement/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1dR6poozkuqr8cFxFef2og3DdJuOTPSbpqvNw5BoQ8gRc2Yp5RJToAK6wIXAa5Hmn5MZomLgEUyCsJitrG-EmiSmcJixQwiAAGhAEDgACE0PwNEkkGB-FAXABfIGXa4YbA4e5kEBUGh0AgMCBEeSUDSbYAODQCWgANQgMHyxNJAIpVJg0ngcAg1C4CK4YA0lCIXA8AAE4HJFItNMZVHT8poPF1UJwABRDJKochcFUASi4rlYXGAcVCxhZ_FoXHssvpjIIJpxWS4NoZJM2rit-X4EnNNLldpVxpEPFmQzK6Eo5AONhoOGatgAorAYwRQUkAJLoFUeUMPPVDLgACW8AFkADIAYQGQyTMBTAJNPCKZQ8RCStNtbo8JoROqVPGMZtWrKtmQ5XOVIkdmxccE53I9_C9PuHFrZ4-ogcbWwg5AA1rZENueB4AKyVGB6ABM_CvADZ0Oh-PwACwAZiv_XKgSvgUCekCfhyivC8wHKABOF9YTfU89AA8o3xgKD334GBAnA9A71PAB2cDwPKfhAiwsAMIEW9KiA8hAhfC8X2w8h0DAB89HISoIIY8o71Q8pT34cD-DvPQ334bD0Hw7CryvF9T1PK88MwvR0DkvRyjAe8hLAMA3z0bDBGfchykYt90HPLS9FfdA2Io087zYwJKkYsBAjAbDpPISCH0EPQX3KTjdLfd9yhgSTjLvcChKvVy3zAu9sP8WCPNPEib0qcgSPIK8YIAgQ3x4589FSkyPAbYMuD2TAoA7fJPA0KAWxAQgCHkOBEEHOB0A0bCYAOAycG6_xyDxDQ4X8cocHFBQYClDQcCoIhiu3ZthRANt2TnCduxEXslRNQcuHjTYShgBx-BsYauEoMAtiiZ05QVKdqCdfozvsD0XTtWbTs0fgAEIdpEJdvU2Z7vpwXRCTXbNSoAbWPI04Z4YlOXEagyhB4acEwWEjgIAAFShkYnEqrCsOwNAOtGvoxrH-Bx7xIQOuGkThoMSdEJGJAnMpoY6ZlKj5gBdYm2a2BnDy4aH-a4KXKgFpnhasVmRY5lHUG5qXeeloWEdF8nxclvnBaZ7dtdK8lDmG1X2mqaoeRNPtYgB5dgap_gcAAL0oQVvEoXV_p4QGV1dnBKRcAg_c4XsI9QQFgTBCEoRhOFESBeR-H3fh4xwAArOBqCxHFaHoRAQGNEBMEUNFNTpB5kFFCbJTUaUXQVJAPDfHArzGq8PGZlbvWVNvgTRXBfgWkAXnWe4PDrieyftIe07OGAoBGEf8GIVf_H8ShK_HvQDmgdAZ48JfBtXg-j7X24N5IXuG3LmBVCUGBK8wav4Bnsuz5X_wD4wWAGgT4gAAHpjWAjgU849tjwFWFPYBIDTw4BfJA3uCJY4gnBKgSE0JECwnhDAJEE9dDoAMLgHEkBmg5zzjHZA2JqBF3xCXMuaBICoAkDAMsXt5C4wFLQcgqsZ4EA0AcGAD8nDoAAEor0oIIAA8qgCschUDxiESIsRHgXTAL0AKfILggGAg8LQIkUA1zAJ_lAXuGD47YMTng5OhCgT3AoS0ah-c6GFzxAwMuc15DQE0HIjYE5a5l3KkcGAwC5p7FQLncelI9jqArIKFMtd8EuAfvAEs-xwnplxAKeQajREPzzgcZeJYFAzzSRox-5BTGWw2knAhD9MC1MhBaCc5SCmNPSUYsWC8jwgATNIO848shrAEYU6plADgEBUAYgZ6Qsjj2wIoNYKY4QvyoJbEktdhFFI8HWCQmySQWhJCWWwek7CTIfmE2A0i85QBmQ0gZqB9gRJAH3bAtSDiYBnrDEArzMAAH1bmf0MeXEEC8BboKBJghOuCqkIiRUAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/viewport/cameras/movement/src/index.ts",
        "description": "Various ways of how the camera can be moved programmatically."
    },
    {
        "href": "examples/viewport/cameras/restrictions/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1dR6poozkuqr8cFxFef2og3DdJuOTPSbpqvNw5BoQ8gRc2Yp5RJToAK6wIXAa5Hmn5MZomLgEUyCsJitrG-EmiSmcJixQwiAAGhAEDgACE0PwNEkkGB-FAXABfIGXa4YbA4e5kEBUGh0AgMWKoCBEeSUDSbYBxBwaAS0aTwOAQagAqmrWkwABqEBg-VJ5JZIgAkgAFTRwRTkcTqADC_BsGn4AEF5BBOAiuGANJQiFwPAABOByRSLTTGVTc_KaDxdVCcAAUQySqHIXDtAEouK5WFxKSJjMZqeyuPZzTy-QRWdQslxQ7yyZtXMH8vwJIH-LQuWH43bfVZZkMyuhKOQDjYaDhmrYAKKwMsEUFJQXoO0efMPD1DLgACW8AFkADKyiZDGswOsCqxFMoeIhJTNx8keKkIt02nj-tO0YOZBlM20iHHRlxwRnUT1JlObNnpmD0k97nNUnjicgAa1siCfog8AFZKjA9AAJn4QCADZ0HQfh-AAFgAZkA_pykCQDAkCPRAn4cpAP_MBygATmg2FYJ_PR0PKWCYEIuD-BgQI8PQUCfwAdjwvDyn4QJGLAeiBBAypMPIQJoP_aCmPIdAwHAvRyEqfDxPKUCaPKH9-Dw_hQL0WD-CY9A2KYwDAOgn8f0A1iGL0dBTL0cowDAzSwDAWC9CYwQoPIcoJNg9A_0cvQYPQWT-J_UDZMCSoJLAQIwCYozyAI8DBD0aDygUlzYLg8oYAMrzQLwzTAJi2DcNApj_BI-Kf244DKnIbjyEA4j0IEWDlKgvQau8jwJ1EPZMCgedPA0KBpxAQgCHkOBEH9OB0A0JiYAOdycAW_xyDxBUoH8cocENBQYBNDQcCoIguq_KddRAWc71PW0QGXVdCR4Q8rzlTR7ETRgRTFCUpRgWV5SVFVWFjcMjtehUAEIbVZcH-COg49BgYVKEZcRqAAJXgAg1klPdz1zHq0DKABtfxBVQSAiWyAEuDJim0AkJIacqABdbqeCIfgsBJ8nKcZmneYZ6muEFqmkhZ5c1wcWH4cR7xIUrAhMayHG0e4RMCY5omuFJ0X-dpvXhdZ9muE57mdcNpmRfpsWBZtxmJZEBEpf6AGcC1Ow1eV7GIFxs8Na_Ig0EVAAvYkDhKRVUGaWAyjpvnhY3TBYSOTY48twOudD8PI-j2PrYTq2k5gFOoDTguhaSQO0GRqBISjmOYDKSoaeL0uCGbzOsFr-u86brg8MqUIA2T_hU_aMLJce6W3d0YkbxbEQeGJr8eE1qwuFJVG9xJrbAiYmn_HS6CaZS43V9EOwNEVspXbenBR9T-Xr9sC-kQv9erC3iQd51raW9poZE-XAwpswvs-BWH4Z730fmXZ-is34mzXuAzeKMf7UFvjLWBBBkbb2ZCgq-N9oEKgfiXMecDIERiXqIBEX4wHUM_lwQ4Co1btGqNUL8tCRAPRECDeM7s6CYA0O6G0K4RGcEBMCMEEIoQwjhIiIE8h-Bvn4JWHAAArOA1AsQ4loPQRAIBKQgEwIoNEzpuQPGQPqXaxo1CmljFaJAHhYI4EAttQCHh36XRTLdT8wI0S4F-KdEALx1j3A8FYkJV8IxOJAEos4MAoAjACfgYgST_D-EoKY4JegDjQHQBEjw8S1pJNyfk5JtxUkkE8SyYxMBVBKBgKYzA5j4ARKMcUxJ_hckYFgBoQpIAAB620sI4B_ME7Y8BVhhIGYMn8OBoJjM8QiSRIJwSoEhNCRAsJ4QwCRCE3Q6ADC4BxJAZoGitGoB0dQPR-IDFGLQAnGA_ZKBZOFB7GAftfHYwODAWpTh0CYygJQQQAB5VA0o5DRxgBEn5fyPCxgGXoLU-QXD9MBB4WgJI660AGZ0qAnjVnSI2bI7Z8i9lAnuKcloFztHIGxDcvEDAjHHRVH00FGw9yWKMb1I4MLYnHT2KgTRwSaR7BlNqOslidkuFqfAXs-w-Xk1oFqeQsKNC_NqVog4CTewKAiTK-FdTyB1xYXuA15LamYBNZCdMe49Vqrkbs2phDX6xKrNIUCwSVa-xiYgOFtTKARxUOivx6QsjBOwIoNYdY4SNKoCwskliA0eDHBIeNZJ0xkl7LYVydh1WapnIq2AytKBQAjua2JqB9j8q8dgE1BxMARJXiAatmAAD6vLYAPCtSCGJLMVlAjWTIrZhqETjqAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/viewport/cameras/restrictions/src/index.ts",
        "description": "Restrict the position, target, rotation and zooming of the camera."
    },
    {
        "href": "examples/viewport/cameras/turntable_controls/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlqKMUGgA1pxWPBowUO4gcAQAnrBweDC2HnHxeIlgKYQE8nCIxsYArqjy0QDmOFRExmBQlADuehIwAAIAjDgALDgA7MboEGntnT19OERoLXBw-SI8YQUmOYLCOwbo6eE8jNOqXGmZMCldEOgEeIhcgwAMbwCkANxcORCNQgvd5fb4eU4Rci6VT8OBcB4pKGoGHrECsExIlEQkwXbFwcgaCDyAhcDKKFJESjoGqwEJwDTkFL08jGNCYXAEVHo4z4wnEvEEokk5mlAjlSrVOoNZqtObdXq0IajCZTGYEOULWg4ABWXJMvKF4RMRxOnF2xCgwhAABoQDMAEJofgadJIMD8KAuAC-tuZrIw2BwnLIICoNDoBAYECI8koGhJACouLDtEoAGpcMAaShELgefrZBQwC6aYyqCAwLqaDxg1DR2PxrjAAoASXtlEosF0AFFYDYaNbW9IopgNL2YP2CIORASBLQAMI1NI5zwQThezPZ3P5wuKEsaMsVqsaHCFxLoHCYSn-HJQRQaGucetxknALjqcgAZi4G6zObzICNFA_hEPwBCElgj6oJwAAUjC6Cc9wYN0ACUODSOmXCuKmaa1rBsLpKg5BcDBKFYawTYFGGaTvkeDYkth_BdPwEg4S0iRgTAaZ0S-MHNps8LoC8HhEOk3GVvRHjTlYmKwi8jAABLeAAsgAMvO0KwuOk6sOglDkDUk44I0tjaRG9rpC26AwR4smoihBReihtY8NRwrwHAEDUFhybMaxGFpuxc4wNIHleagfEFDwDzCSAomhWs4VSVFpIQOQ0S2IgKU8B46AAJzkIMgSDHon4AGyfm86BgOQbwwOMACsAgNfwn7kNVbwAEwwCMeUjG84x6OM6BlWV5DFuMZWDIMDV6CMehvIMIyBJ-eideg7V6IE5DrTNeUNSMMArYE6BFZ1DVNegrXjJ-gSBGV6BNWVs0wGAn6DGVeX8OMbz8DAeV6M9IyzYEgiVXV6Cdftz0nT1ZWlWAFXoOMtWVYEeWBJ15B5Z1vX3WD_WNQDlXA2AYBVb9C0wEttXTeTIw1SV5UjJ-eWYG8tXnR9HP8GA_i3SMY0NZ1gz8IIC1lQzJ3kFCMCdaVGMFWAnWdclAmUpgUDiV0ngaFAsVlBUVQ8ugGjjDANSFTgFv-ONNAaB6_jDLuxZqJoLQ5hsPBOXhM7UDRBCUBlqBwth5YSS-OCxmkAAK2bjYlqDNCZBDdmTMDkAQ3hB3QcCkS5XAAPJ6NqGcEDgGXpHngfB3AaFgHG3b8I4MEwQQZGuBR4ddPRUeULH8dhUnOCJJS6hp2AZdtyhzmcFR_sklCNgOz53e90vmj8AAhMmcIBTgLYx5ocCKJnbsacv_AAILyBAvuuQvXAXD5ekGUZs6cWZNA2SAFweLPIgLingyLAPunlxDeWwh4fgeg4CdhqLQKCPAgHXFAYHeQPkPBfCQU_NQwCbg4FgGABiAFsEgALigkBMAcD3EeHgTBIBOpvFHjg1-hkIw4BNDgBQigMDzjwNAayFwAGuQ4guJcgciCrhsgJAA2tlXgbYOxdlQF_AgrB-LxFEGSGAsUDCdgENBG0CieCoH4DYWKdAYGwG8DUDQNBrEwHnNQcCnZUTSS0Vwag_DdAmQ0lAKAehm7RBeDBGEUAai6K4PolRHcKKaM8a5cxm9rZmL0DYuxDj0lOJcdmT0q8PSRILlon0Jj3yFKie6T0MAFGlIEmcJRBiex9gjBospOi9HKMMWrRJZiLEASsdkmOnZnQACVKB2AgUYjxWjvFyCTk4j0gTgmhPCZEl4MTDFxMovU-IG8HapMccMqAYyJlgXCgUiJMBinxDqYktZUTwKRNqTMiILZhwPE0GotpuyeAdIAnAEc1ZjG_K4H0qJIk0DHOdFfJOtIQWJLmb4xZASgnpVWRUl4qBDJ6E0NshJiT9n8BHmcqZoz4DgTSlMpYUKRkaFhUBGAlyillLuZ4h5Lw3ivKsMsVAnLuWiFAlgYEgQuVlLSDAeQnKcCDBeQoxg7ygVjhaTQH5iT_keEBZ8h8CLPHgtikK6F9K4U1N1bM1APiFn-OWeikiHKwU4rxeRHZiSkmXxJZM8K5K0iEjPtQJY_AsBGoZbAZl1zWUCp4PaoqYrQW8v5WUoVIrY2JIlVKrgbwZVyt2Qq9sTTVEqvUQS-IGqQCbN0D0vVyTLFpNgFfAAXtGBBeBxmeuoJW81lq_FLLRSEu1mLoldN0PispbqUmDLrY2ogzbW3nMgeUq5NyrBsq0fap5NTdkrreR80c3zi1WFLVq0cHb4j6oAryhtTanghtNZGrxFr5ndtRSs_tVysWOo0CO0FY6DnZjbagb1lK_WoBpagS907r0mrDUu0QW6rD2v5mVFNnj41cEQ8hrRSauDlQw_ENN0rZWboFQqndXzC1qs8YepVJ6rBnpEoG8Dzab00dEEiq1PaX1hIHdioguLP3Ov3Xs5Jv7SVeopb66lQrGOQcZdBiNZT7U4bvah9DynA0vCU-K2g6bM2EZKcRxV2q93tPSIoWKR7gV3royAAgmS7DZIcBGTQaGuCQTNfENjT6bV9q42-h1vGnWdxda6olQY7OOPnE5rQYcM6fhwH-IgaYKl51HaIB5d6ZLCeJbZ-x9nYCRfDBoWRgwAC6GXRChZy1k_LUXZGdRK6lkRni4NpYHbhnlaAXhOwamp4VrwetaclQR7NWiSNKuM6Cqj2qWOmOrQBKreWmV21oFofwXB0gzfvV2lF3mMV-Z43xr9rqHBZbC7liLUXV6xfi1uJLVyUvfoq6dhbF3CuyLeGV1LUaKnlZ_dl8L2SCsrbqw1x7TX9MKba8pzraGZq9eBAN0F-GM1ZqI_Kwzu7yOCb-aZiFqRqPudo3NjwL2HPLec2t-tm3PM7d7Xt9Z_nDsCdS5VgHNXCtXa_DdnMd3IkPeO39s71WnG1Y-79k77rSfs-B6V8XDzGswe9ne-17XBUw-6_D_rd7ke6dqSlT7Ak_4iAAU5fOnAbR2jgI6MxLo3Qem9LaeQwT-AmR1HA1AIYwy0HoIgEAzZf6SroJgIiFZUTIB3HIPcbsDzd2BVlEAcWRY4FVsYkABZI-u3UDHo87szzFkvBOSgN4kj3g8PHxPwwU-lLiixIx8e2SBhYFAZKqRBTEjD_7tIzoCBl48E7hkSR4QBlwE3tD_hKC8Jb3oGogje8gH7-NKA0SZ9QHQEP9k-ALQeGr5gVQShA8BhD_AMv_uF9JH8NPjAsAdXx4AHrDEGJ1HADUW86INMSOft-GrKhfyAL0XoLcHQnRbdEAqkHdUhdB0ADBcAwxIBmhdRqBPcXEIwGB_c0BIA6xaBVIOx5A44Jky4kokB11BwQAnB0ByVOhBBC4H1kUy9iCPBu4589BswugXAdUSDaAYwTlEEkA-9nRF9t9ACrdgDXRQD7cYAfQbN8RqA4C3dEDkBQxkCfc_dbIcxb5r9C5iRwoO8RIqQaRTV49WhKRUBdQW9R5KB1BnEiBJww8wCYASD4BlI9DYAWxCsJ86CNBIkSC4E7FxplIFAy87CSDMByATkHYplAjxDgiM4wi51UB_D5BIjqkODnQU459uxpAyoW8fUqUPCvCPBKAEEVAb9co1QW9sB7xowIwPR98qBwi4ww96CQAJwJBai4wwI4xlJbBBAwJ-A8j7DdDqRYBvV4EIjeCQBUAqRTVq9sBQiahMAy95EJipiAB9DWfQ9xUotIDwErAA20IAm3UQuw__L0IAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/viewport/cameras/turntable_controls/src/index.ts",
        "description": "Controls that allow to turn the object like it is on a table."
    },
    {
        "href": "examples/viewport/cameras/zoom_to_object/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1dR6poozkuqr8cFxFef2og3DdJuOTPSbpqvNw5BoQ8gRc2Yp5RJToAK6wIXAa5Hmn5MZomLgEUyCsJitrG-EmiSmcJixQwiAAGhAEDgACE0PwNEkkGB-FAXABfIGXa4YbA4e5kEBUGh0AgMWKoCBEeSUDSbYAODQCWgANQgMHypPJAKpNJg0ngcAg1C4CK4YA0lCIXA8AAE4HJFItNMZVAz8poPF0iSSyRSuOpyABmPkCoUijzNKD-Ij8AhrLDKwkACiGSVQ5C4NoAlFxXKwuMA4qFjGzzTAuPZ5YzmQQfTispqFWH3UH8vwJP66TH1TbvSIeLMhmV0JRyAcbDQcM1bABRWBFgigpIASXQNo82YebqGXAAEt4ALIAGQAwgMhhWYFWAT6eEUyh4iEl6aH1R4fQiXSqeMY_at2UHMlyeagI9Qoy44Nzea544nNpuA5yT3v0-OthByABrWyIR88DwAVkqMD0ABM_AAQAbOg6D8PwAAs2oAf05SBABgSBHogT8OUAF_mA5QAJxQbC2rfnoqHlNqMD4TB_AwIEOHoCB34AOw4Th5T8IE9FgLRAjAZU6HkIEUF_lBDHkOgYBgXo5CVLhonlCBVHlN-_A4fwIF6Nq_AMegLEMQBAFQd-34AcxdF6Ogxl6OUYCgepYBgNqegMYIkHkOUYnaugv72Xo0HoNJvHfiB0mBJUYlgIEYAMQZ5B4WBgh6FB5RyU52oweUMB6R5IE4epAFRdq2EgQx_hEbF36cUBlTkJx5AAYRqECNqimQXoVWeR4Y6ZlweyYFAc75J4GhQFOICEAQ8hwIg65wOgGgMTAByuTgC3-OQeIaHC_jlDgkoKDAMoaDgVBEB1j6TqKIAzrep77iAS4roSa5-qWmwlIG_Q2BtXCUGAWxRNGjJKiIkZXvwn32OeIZMuqR1g5o_AAIQqj665cC9f2BpQBzjdj32_W9XB5mSB6oFGRMaAA8tj8i4-ex43SWthUzj1ZJAAcnDjYgEolDEyALoANqVAAusjIjGAAVBL44S1wABaFMU12tZswA4lwAAKACCABK3gVDLMuZHYGCQugXAAF68ydmYS8YPr8AmSYffDOBW8K3iUDa5PMzTBA4Kg-wwAjOAGAcGBoM0oKGA9-7i361IuOGIiO5eDhwxtOCJ7Y6aEwcG3iNQZQAb-lR8rHKNS0bCtKyr6va3rXAAYbttBuggyOvtlvW1whQlCMRLiHChMQNS5CF3Hoh249DiHps7tEL4_Dj2ScYAaus-k5s6RjxPcZatqOCCsKtJwgc8A2pUrJbaylQV_HyaBgTpLcnvujm3YGjo2aqAHHCUBJBJlGMOEdUDNGkPIKI1I4w-2ptjAOQcQ4gPSGA6OuBkGRwgVAmAG8QZbEhOjc8GCwFYM0DAI6eJNC4LnpkfoUBI5LxXloIhWNQHgMgWQrOggIAHGGLLBejCCBkmoVvLgL8JB7n3jAHUOBBANkfAfI61IAyuk6lYT-L01GiEUUQI44h5AAMbF1Hgijry0FUZ-Eeu89xaKsIo4-RBT5QHPnAG0Kw4QMOXkIjQrJ3H0LAYIskvi6GeKYS6R84SRD3yehjPOBc9zDDgIocgEBIDwEaJQfIXAoDUGaCMV6_A3zDCEWjWwWxKCxMgKgYe4iJ4OydqDcGO0c61Jsfgr-thWSUkOPEouXAQpl2XCqZcroVSAmBGCCEUIYRwkRECeQy8Xz8FLDgAAVnAagWIcS0HoIgEA3oQCYEUGiR0DIHjIHFLtaUahZRQyVEgDwh8ALbWbiAJE05Ey3Q_MCNEuBfinRAC8dY9wPAXMBZ_cMDyQALLODAKAA9bj4GIPC_w_hKDHIBXoA40B0Cgo8DCta8KsU4oReif5byxyHJgKoJQMBjmYFOfAUFByCVwv8FijAsANB4pAAAPW2hhHA34AXbHgKsYFPLeXfhwFBIVHgEQInGSCcE1TpmIFhPCGASJAXvwMLgHEkBmhrI2agLZ1Adn4j2QctAVSJAwB7LzeQGshS0HHnuUFFpz6UqcOgHWcLKCCApqgPscgwEwA9RoL1HgoY8r0EKfILhuWAg8LQEkUAAw8tZVAeVSrJmquhOq2ZWqgT3ANS0Y1mzkDYnNXiBgBzjryGgJoCmGwEnMunPsI44aoXHT2KgdZALqR7HUH2YUVZzkapcJS-AXZO2wFrLiIU8gI1RsBVjWFXYFCgsnTASlmByDpt6V8nde7pGHvNHuTdy6ZmaspRo2wPKyzSBAgCrIaxx4rt3R4LGBAVBJu-ekLIALsCKDWFWOEtKqAFzJOcz1X6QAjgkJBsk5oyRdlsM5Own7KU9S7X6jZzi6lQsDpgeV06sAHoOKRpAAsPAkZgAAfVw7AB4e6QSQuFoqoEyqpkFp3QqhEQA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/viewport/cameras/zoom_to_object/src/index.ts",
        "description": "Variations of how to zoom to an object."
    },
    {
        "href": "examples/viewport/cameras/zooming_with_buttons/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1dR6poozkuqr8cFxFef2og3DdJuOTPSbpqvOLmdm5HvKUcBIQ1GX8enCUUACutA0ElPJlnd1xVrwQRM2rOTB5hcWlXACslfJYLogTIach5HDGJ78ZrwYzyU5wfwGXBwVTNEKjDxPZoAfXhJymwLC9ysjGxr3WBSKJTKfwBQJBYI8EKhMLgxiIaAJSMMOFR6OBmJA2JxnNQBJCxJE8WMi3mcHIGgg8gIXGyijyREo6BOsBCcFBeQN5EhGGwOAIhNYJgVSpV4RMiRSnBMLCgwhAABphXAAEJofgaJJIMD8KAuAC-3tZsLF3ORfLRZBAVBodAIDEY_K4WBIqDgeUIBGuxmM-XLOHyAGYcJQNM1jAAmaqVYz8kJNVoEPKNgAsIVUEBg-V9hjylS4_gAnAA2Cez-dzkKfEo9_sga3yfglLjoPIAWUbgUq_l7vcqeHPlVUQUqAAkj9fjwAtfe94-3gCOQSrXBP5R-Gd_CrcocB-bxyinAB2fxIKg78fl7fxEKCH4wNgxsoO8D930qT8T0CX8QPQgCZwg6D_Cgmcq0_FDEIqTDULA7xcKCY9P0Iv8KkArhiPAqiq0o6jaN7X5RMCNCfgYrDAhw9iJ0I4DQKk0jvAE2DoIQ0SUPKTCuAk5jWJfIgCLw8oq1EidG0YqcqwIWz_Gs-D_ws6dBKcghHJsmjYIsv8vKgrhbM82yuCc_CKj80KPKcoKq2fEzgObZ8PDCG00VYL0fX9VBA2DRBQ3DGAo2FIhoVhfFEQTflk1TWh6EQJhs1zKB80LAhi0QUty3ySsazrBtm2qNs0QHIcRzHDwJys0S-2mLcdz3Dx93KKDPXMu9zIANVWzbyh2qs7ygnbyj2raoM2qsTs2qCVqnT1Dp-ABhGtAnuoiHpwN7eM9H4dqnABBRtPUbLjKk9CcfhB07IKBkGwYhsLynWqctuextkdeqcwsqHBMYqd6UqJa0RuaTLoz9AMgxDMNI29Y1TUwXBLVq6h6ozRrYlQJ5Ng0VVgHuRUBFoLbxt5ghPUFjRhZgaR4G2ahJZEABJAAFTQ4EUchxHUJ7-BsDR-AB-QIE4CMuDADRKCILgPAAATgORFEWTRjEHYdNA8LpUE4AAKIYklQcguF9gBKLhXFYLgBZEUsHGl7cYC4ex3fycXBeoLIuFT8WI-T_J-AkeOZdF4dxd9mOrFmIYynQShyBOGwaBwGECAAUVgJuCF9JJlfQX2PGrwlw6GLg728fcABk9YmIYO5gLulasIoyg8IgklLtO6wIDx7gjUPvZ4OOhcT5PMnl3YfZEVMs5cOAFe4Vx88L1UT9oOX78viuSTVCByAAa1sIgH-PAPBVkqOgcggR-BVkwtUGcU5yDlECOgGcElKg_AODAN6_ByjkAxo2GBjY9ASXQI2GA5Cpw_CrFAyB5AZwULAFBKcYAZy9nQHoGc6BcEwHIJg8gYBCJThgFBKsVY9DvkCGAKs6BZFQT0Mg6h5QGEzn4PwfBjYZx6HUeUGAehEFgHPFBSoXD0BQXwXoahNDyDoDAFUWcehyBQTAD8Jx6ATHoHMrI_gYA9BVhnD8RBXDDFOKgjAGc0jezUR-IEACUT-DQKguUXs5jAhQXSTAaoajkkxOwVWKCZjTyIMyQEqcslzHMMbFOd8TjdKxIXL2KcVSfgeCXqILUmAoCb08BoKAq8QBFnkHALqbZ0AaDCScJBOAYAnH8OQdMhsoCwT5E7GALsNA4CoEQVpP8V62xAOvD-D9d4iH3t7e4cdW5qiiA4fWmh7CUDANcpOqdPbX0zq_O5hs84523psr5_AACEydhhqw1lrHWMA9YGyNibQ-z8i79BhTgAAXpQa23hKBh3ObHYwXA0XWxGFfHgN9VTYlVgiPOdcG5dxbrYeeXce59wHqVXElUPCh0BfC8lCJaxBygH_f-ecw4RyjpXUQSL7movRUQTFvh1GXC0E_SVhtpUYsoPK7WdZJx_hwKJAAVLc5FBKiDSEUGs-FJKAVqtlVig-e8cVHzxSarglAzgZ3zGS54-4uTDCftSxu6Y6Xt07umJl_csTPFFL6jlXL7jYh9eKOAfLyACoAcK8Okdo4_xVfwG1cqFXauVdak1BatVaAANS6oNUaqVJqzUwAtTmktMrMXYodWbUO7bUBZQgJTXK1MCq02Kt6LcADyo4AAFZHB7cgFMbN0wMAFiATAigzRByHISZA9tHYKDWWoV2ryNAeGASAGsGMcCNg8FGNehcfZICxGaXAbodkgFtMqS0J7l1ZEDDvB9IAtyghgFAIlTN8DEBA_4fwVw6Cvr0CcaA6AT0bEDPMkD8HEOgfNC-kAN6V0wFUEoGAa7MAbvgF-lDQGlnwYwLAY9_6AB6oFdJgVfeqeAioP3IZAAxtCvZWO4YjL2_teUaZFRKnAXQHDeSpkgM0KdM7WZpgaiAZdaBIDc1oJPdF8hVZW1oNrS-J6CAaBODASWAzAzoAAErAcoIIAA8qgJ6chUAwmM6Z8zHhU7cb0FbfILh6MWdoEQeEiduOAbQ9e4TOVRNDvE96S0smWgKeoEp9mS7B7WxNnRhzKpL5buXR03UMBuNbK1Kgadr7pZal1tbLuW7CouAs_Afc2oSvKzTFbeQHmzMWaOCcID-4FAnqa15_DqbAzbiM2J5rHhMCTcNuIagw2euzfG3YesthuNt2kDOV9WQlTa16-Nt1BAVD0dPekLIr7sCKCVF3MMRGqBLbrFukzfWPALwkM9us246z7lsIIbc_ATsWeK7AWzRxTjLfvae1A2pSu4Za1gVNJxMAnoANoeAR5gUU7XYCEgs9dv9ABdITFNYuDrGxGWnQA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/viewport/cameras/zooming_with_buttons/src/index.ts",
        "description": "Zooming with a plus and a minus button."
    },
    {
        "href": "examples/viewport/contact_shadows/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlqKMUGgA1lwaMFDuIHAEAJ6wcHgwtiF48WBJhATycIjGxgCuqPLRAOY4VETGYFCUAO56EjAAAgCMOAAsOADsxugQKc2tHV04RGgNcHAhYZw8JlmCwmu8Buip4evjqlwp6TBJbRDoBHiIXL0ADI8ApADcXFkQtYT3T69vDyHCLkXSqfhwLjXJKg1Dg5YgVgmWHw4EmY5ouDkDQQeQELhpRRJIiUdAVWAhOAachJKnkYxoTC4AgIpHGLE4vHbETrDm4_F0woEYqlcpVGr1RpTdqdWh9QYjMYTAjSma0HAAK1ZJj5XJ2Jj2B04G2IUGEIAANCAJgAhND8DSpJBgfhQFwAXytdIZGGwOBZZBAVBodAIDAgRHklA0-OADni_FoADUIDA2lGYxb4wJaNJ4HAINQuO6uGANJQiFwPN1MgoYMdNMZVKm2poPIDUBGM7Hs4mYABhCopCueCBZgCSNsolFgugAorAbDQJ9IopgNAuYEv8SWyxWqyAa3JFA2NE2W5ocLX4ugcJgSf4slBFBp25xOAAKCGpVDkLgfgBKLhXFYLhgB2cpe1oLh7GbNNux2YMUi4OD02jfFXBgtp-AkKCYBTeD0I_cCeQcMEIXudBKHICptxwWpbE3bcbVScd0A_DwUQhDwgIhLgAAlvAAWQAGX7ci4CY0MLR2HhrnuDwiFSAjW1fEAdndACOx4SCE3QLhKAqfEAEcKk0VIuHkB1-BsWhnFLaMD3EchohyEAYIwA8SUwKAVM8DQoA8RDqGQioAoABWsohIUw1A0y4TwACURLzB1HEijQbLgD8rgwdocFaUFxGoK8BGpPAtOC1BkOc1yMK4MKoAyrL6NsD8AHJatsdrKpEJD8W8hI_IC4CGoiqK4FaggOsG3yW38qAeo7KrkJcJZC24TD-Gw3DsRzGA83W6hiNkqF0HudqlMOgtqHamTSK6gh7kergAH5Xq4dr-H4QIwAATj-gBmR4Bj0dBBF6QGADYgf4XoACZAfIP7ekCYZ-Ch_hhihgZyEhwGBgAVnIAYBkCQJegGQRhnIYZHnQYY_vBmBej0Qn2b0YZ4cZwmwD0PR4bAdAoZdfhod-sBAnITAWfFwJ4d6YZhlZmByEB37QcBv7yEJmA_r5nnCb0GApfhtnJcl8GoceXn0Fx9A8bpwIBkeBXUepx4oZNwnhkCOHHil3o-ahvQcfh_XehgLnGZZv69AR9BHj-0mxcV53frFvQfv8X3yECKHyBgQGwEFxWaceUP-B18G-b0ZOTYGGA7tO2bhqge5W_mkb3s-ooSjKdl0A0QIYAqPGcFH_xC5oTKoH8fpaxPNRL0adqNN6iDjDwgksksqLbE0BqIAM7hbhgOJvkIU5rhgFb8QqCAVBOTCqJoui9r7KSaA644lp2B-n5XjSLAHAUYCzFU2p9fgeg4AziMk3bSR9AFnBAQQSg8hRrtUeO1RBAC1BAPODgK4Nw8CYPho8eIRAcE7FfrRUMOBDQ4AUIoDA_Y8DQHYng1QvUeAf1oIOYcRBRwfgANqnUYJOacs5UBfwIKwEiVgeCEhgBdAwM4BCoGbqRHg4IoBmXuKhbsDRqB2HIAQWQgh2gpgLJ0KIaR7qKK4KgGyKjPrNhsdACQqQtGOOoGw3QDFxJQCgFnFy9xvy_n_Lo_RXA1HSKAiBMCp0rCGPQsYmgVdzFyCom0axEBbFeNGtEmAiCrDulOp6cR45Vw3w3IuUM8jkkElSIoC6cA1yaB8Yo4pBiWxGODKYrJli2j8RgJfAgDjFHzFQPcR4kyrBEH4FgP48zRApBgPIWZOBHi9FWTwZxNgLoDMyRYnJozxldKsH4uQqBAmuhCVXaI4S4A_j_B-HpTjaLGw0Ak0CCjHEoT6Wk45ZjTntHOT8eqABqYppTulApjDgCo8hwa0EAnCng5TSKVNIhImp65ZGNO0c01pn12m1MuaID5qTEUgqGTkpQDpohxSWHsrg0zZlssWcsh4cymnrM2VwR42zdlNIOa49qdKwVtEZRoZl-ZKU8GuQEgc9zQlPJgi8yJ7zXQxNQF8zQvyknEp0Qigg6TBnStlfKpYo0YW6pKU0rFZTVl4o6XUrcDT_lWGUW091iqUIOt6YRWlJiTnZPaDaPRGguVoE5U07lfw-XEoFVsnZbLxVHLDaCiNbQo1hQDcq25qrgnquea8qJQbPlEG-Ua718KQ3mqlbm_NWhML2r0Y64lzrRA4qsG62phL61KJaRK8l64A3UrNRa8NwyADyVlyBeNjTMoVXKlkrP5bQQVwr01ipcVmjJOb52Lq8YW1A_ji1BIeWEzVFadWdvuPqmthrgJ_KaaaxtM7j05IXVXQp7bYVOoqTsAAulmLhvVNLos4Jaa0cA7TOMdM6V0HorSLuiPwBimpYGoEDAM0MDBwIgEwCwzAv5UwImQNWRe9Zl5nlQm2JAHhAY4AVmxjwMlDy0dPOeNMl5rz1jvFuSgj4Egvg8IgFjbH-jww8JUkAiy0CSY8IyP0LBAqWg8LqFkkniMpAdAQFTIArLUgSFCX0uANNcH8P4dBdBOMeD0A_KA6BjOmcLlAWJLn9Jqas6aeTXHMCqCUBsug5Gl3wD0x4DzCR_DOYwLANSUmQAAD1-gIxwITRzIBlE6eM6lwmCpssgHdO6ODtp7TIcQC6N0MBPTJF0OgAwuBgyQHqFqag-GTGEcQCAYjaBICdloCJac8hwrlloGYjakmCAaDMlxpw6BEoJEoIIOdF6bkMVm_NmAXHULGb0OWNoLg1JcdoJGKAfZ3NpQSPJirCGqtOhq6h-rVoWRte-DhrryAgw9foH14jjR5DQE0AuiBVHiPeXJLfZjf2iAklQFqHLlDKDqH7BWbcVHasuC4_AISpIYfjhDOWeQO2FvacMmZoSChJM472x4TA5AruZQgXT17QXVYs8TBtGnZOUN1fOw6BiRm4dzmkFDHLKQcRmPJwzkAhkCAqGS4z5UOXsAvgjKGV0oWqCs-jFRubFOQBbgkLr6MiZoxCVsIIRM_A5dceh7AFbsC9Fs7h6gUksOFPYGZxUTAkmxEgE95gAA-k7qLWmSNq5AKB8rVpKtIee_Tsr7ogA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/viewport/contact_shadows/src/index.ts",
        "description": "Try the new default settings values for an example model."
    },
    {
        "href": "examples/viewport/fullscreen/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXBDo7iCqEDAA7vKUGgQqqiFwBEmwOQVZBHiIXACMAAxtAKQA3FxREADmhM3tXb3pcPJQ_EnNYLBYvcVwEhDUzfx6cJRQAK60vbBgBM1jXASU8qedHqmijOS6qvxwmdkej6jPcLcmn993EzpVSAuDkDQQeQEc5JRQ5IiUdC7WCVDTkHJwNHGNCYXAEH4gVgmMEQqHhEyJFKcEwsKDCEAAGhAEDgACE0PwNEkkGB-FAXABfJmY8jYjDYHD4sggKg0OgEBgQIjFUpcYAODQCWgANXyRRKBAZGq1MGk8BW1C4Aq4YA0lCIXA8AAE4HJFMDNMY8oVNB5urFULKqlxvfrSuUuK4uOhKORdjYaDgBrYAKKwBMEVlJACS6AAFB5QyqymoPABKf2oThB6EuDAAOUo4kgj3ElqjebMsGaVQhqAGRpscDg_GTPYIfYGZcjrDVcUyYC4ecbzYgrbWqBwig0RBZFu4rkPXAA5AMNLpaOhj9PgPOeKhClwVxAW_w26hOxJYEb1ZTmkOR2TK0K3na0YH5GAFyXZ9X3fLdNF3YcNy4ABCI9j0wVB8ivG87yfJsXzXN8NxwTUAEddngAgAAUEL3Dc8zLSUog_bdEP3Gc5xEKwXyXNj6PbdCzwvGAcK4qwrAfAp8NXddqE_cwfy4P8uAA0dIIFEDuNEAU8M0yseF01ABUratqGDC4BgGWBfGRflwRgOhIyXadXFnW8RF4vMUJjOMMxwMA7JJRzUDTGAM1w7SiwNcoAH5SJgCiqNsqB7M1OhGJwVtHDzTQtDc8SJLrdAYKI98CxAFMNDtDQPCNAADKqaq4N9aGVcR-3OSguDoTZYBtOz_GCpyEUwZoABJgDynA1OTa080m6bUH4GxNPqrSrH00CeogwqeC83z43lHBsAkFK0pCyKJOjWMjsTU6CHO4aPw2nTQM4IzODzF4kkDFzOI8nh52MYxjTfSD7Gi0p5xrEM9WLZz-AKfgJDBnV4YNPNAdEf4XmaQ7_OTAgwozLNcwq3GCWnF4uAACW8ABZAAZABhJ4XhJ-UGTwrJmg8Igkl1Qpiw8UCtOB0GHPBlquBcJDqBh8za3NZCoyRlHoSl2gzXlj9sZ4cRyAAa1sRA8KBkAAFY2hgPQACZ-DtgA2dB0H4fgABYAGY7ceFpAjtwJAj0QJ-BaO2bbAFoAE4Pd5L3Lb0EOWi9mA4-9_gYECaP0Cdy2AHZo-jlp-ECPOwBzgRHbaMPyECD2bY9_PyHQMAXb0cg2hjluWidzOWkt_ho_4J29C9_h8_QYv87tu2Pcty27aL3O9HQJe9BaMBnbHsAwC9vR88Ed3yBaVuvfQa2970T30C7mvLadrvAjaVuwECMB8_n8hY5dwQ9A9lovdD5e29i0GAs9z5O2jmPO2n8vZRydvnfwicf6Wwrg7No5AK7kDtgnEOAgvYD3dnoTBF86p4VGuBIWBRPAaCgHzEAhACDyDgIgEGcB0AaHzjAXYJ8Tq7H8OQeU54oD-BaDgV0ChRJqE0Fle05DtK80dCAAWOt9yixEFtKsIgQYtVdjLPQ-wLjcAuF1Ky_VAqpWeorVAwZLEXToKyIx7Ybp-WOlrGAnMaAVUMQQYx5YDIDSsQ5RxzjNy0CwAQFm1BaA0Gch4bwlBzGQSeiEqsIBAn2Oek4vx1AJHVFgFuSgKx3zxJAJsbYexaB-nnFktJOTjE4GoOQKAa4jbOUstZGAqT0qoECVDEsqh4oKEUBgPMdTekNOoFpTSjFKyMmZGyDkXIeR8kFEyeQ_BjbqRwAAK22KgaUspYkKkQCAW8IBMCjMwuQfIBJkDOkke6GRGgvR6l9EgDwXscB23EXbDwQp-Yo3SWbZk4pcC0nISAEkkJ8QeAedCuw0NPkgE2WicCmRwX4GIFALg_h_CXDoFCwx0B0Dwo8GioRuKSVQHQJi3E2KSAAu5pcmAqglAwGuXQW58B4UXMpeBfwhiMCwFqiigAeuI8OOBLZQuqIoGFUJyUgHFZbHAHsZUAoFAslk7JlorMQLyCCQpoW6HQAYXAspIADD2Qco5MT5QMAuWgSAWFaBM0oJcaidpaDkHfPCiclEWVOHQAAJXApQQQAB5VALM5D9hgAGjQQbCx6mVXoO0BQXBipZW1KY4NlUCqgACnVSz9XckNWsmAJr8RWsGLa6g9q5T0DORcqgypoCaCjVCDc9yLmjWRImlF7aESoH2VCzUCJ1DRKIBme5RqXAsvgAzREg7sxyjtPIJNKboWUF2OihmCh4ULpgCyzALTOTEQVqsiCZ6YAXvPO-Q9W6b2Lo8EiomyqUzSCdlC3sa4CDbtPR4PdJYxWgomIBxkHhsDbiVPKPkHKqCPpKPcwNwGQDhQkEhkob4SgM1sEfOwQGWUDtgOGyp-wNzKtQIiIdgLMNYBabsTA8KADaHhaOYAAPpkd5dBy5LIoMAF1tVMl1csitJ6BQyaAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/viewport/fullscreen/src/index.ts",
        "description": "Button to toggle fullscreen on a div."
    },
    {
        "href": "examples/viewport/lights/light_scene/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1dR6poozkuqr8cFxFef2og3DdJuOTPSbpqvNw5BoQ8gRc2Yp5RJToAK6wIXAa5Hmn5MZomLgEUyCsJitrG-EmiSmcJixQwiAAGhAEDgACE0PwNEkkGB-FAXABfIGXa4YbA4e5kEBUGh0AgMWKoCBEeSUDSbYAODQCWjSeBwCDUAFUmkwABqEBg-VJ5K4CK4YA0lCIXA8AAE4HJFItNMZVJz8poPF1UJwABRDJKochcNUASi4rlYXGAcVCxhZ_FoXHs8q5PIIZpxWS4du5ZM2rht-X4EkttA59o9atNIh4syGZXQlHIBxsNBwzVsAFFYPGCKCkgBJdBqjwRh4GoZcAAS3gAsgAZADCAyGqZg6YBZp4RTKHiISUD7vJHjNCL1Kp4xgtq1ZNsy9MZqpEzs2LjgDOohu9vs2Y6tMDpi-nIZbWwg5AA1rZEPueB4AMzlACcYHKABYwJVAuRyjAAGwAdn4gS_T_QQIH0vfhyBgcgwHQS8ACYqgfG8vy_aDMD0SpyHQPQAFZ-EqDC9EvG9L0CTDMJvaD-HKTCPxgQJLy_S9KhgB9MPITCYB_MA2P4LDoJgSi9HfS8P3QB8HxwsiwC_cpBAoy9rz4wjMNQsBoMw9Ab1EwJ-DAS8H3QSpBH0vR0GwvQwECG8gJgpSEJgGAb0_KoPz0VTYI_UThMo39nIEwI9AfSpykfdBzJvdBoM4m9KhvVDAho8g_IcmA9H8L9MPKZyYDo8gXPUj8tMqfDWOYvRtJAmB0pgDxmzDLg9kwKBu08DQoHbEBCAIeQ4EQEc4EwA43xwGADn8MCaA0OF_HKHBJQUGAZQ0HAqCIar9zbUUQE7bcl1VEB-0HQlh1HalNwnKAWkITIxpgZk_UKKAoC4PQYBtHdmlQeabQOAhhStQ84SgJInWoF1ztaAhpGulc3QdJaTtoSsLoh679QAQhVM0RxtdB0AnD78htIg9E5GguDBwhbs2e7Hue7HMFxn6tiiBwDg0alSfJ-druB1AXX4ImSYIRHwZXTnIboGAcEMgBBAW8WFwgQwcSgoDJNqAGIwGfapKhCAcMZELHDLxrkuHSalyHEag4TJpHKa4amnpewzPsZkoXtjNm8VtkWVglnmXXN8CrdQOEFc9H3CHFj6pZxlQLZDsOkb3WqqFVjQNeqLXqlW1OhghuRo3yMoCA0A4qpEfXOAHfUVUBYEwQhKEYThREgXkUCj34JMcAAKzgagsRxWh6EQEBTRATBFDRbVOQeZBxVm6U1FlN0lSQK8cFgrePCRDtfV2s9gTRXBflWkAXnWe4PAXi-7F7DeQA7s4YEem50V-Lh_H8Shp_PvQDjQHQDfDwz8wI00AVAXG79T7ECgLvZsk8YCqCUDAaemBZ7wBvhPMBr9_AAIwLADQICQAAD1prlGgjgTC59tjwFWFfEhpDMI4AfNQ3eCJ64gnBKHZuiBYTwhgEiC-ugMKGCWtQSAzQ-4D1QEPagI98RjwnmgSARIEaUF_gABSFLQS204b6l3Logpw6AABKr9KCCAAPKoGrHIVASZDFlxuh4N0JC9BCnyC4YhgIPC0BJFATcJDcHwJAJwoE3Cm7Qn4a3IRQJ7g4ikTIweyBsQKLxAwCey15DQE0NYjY0554T3qkcKqj9lp7FQP3c-1I9jqGrMKdM88BEuEQfAcs-wylZlxEKeQzjjEeAHqzMC5YFA31aa4pB5AgkTRDhMuJiDMAzMhH9agYz-kt0EYg--SZHSP2TNID858shrEtgMqZlBvrxxIekLI59sCKDWOmOEqCqBzLJPPIxUzGwSDeWSK0ZJyy2BknYC5iDSmwAsQPKA30DGP1QPscpe8QDYBmQcTAN8ADaHhEWYAAPqQqwX4yeIJ9kAF0IkNx4ZCGJkyEQMqAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/viewport/lights/light_scene/src/index.ts",
        "description": "Creation of a new light scene with custom lights."
    },
    {
        "href": "examples/viewport/lights/shadow_map/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1dR6poozkuqr8cFxFef2og3DdJuOTPSbpqvNw5BoQ8gRc2Yp5RJToAK6wIXAa5Hmn5MZomLgEUyCsJitrG-EmiSmcJixQwiAAGhAEDgACE0PwNEkkGB-FAXABfIGXa4YbA4e5kEBUGh0AgMWKoCBEeSUDSbYBxBwaAS0ABqEBg-VJ5IBVNWtJg0ngcAg1DZIgAMgBJADiAAlvAB9bwATQACgBRAU8YUqGnkcTUOGClqEACC8ggnARXDAGkoRC4HgAAnA5IpFppjKpGflNB4uqhOAAKIZJVDkLg-gCUXFcrC4lJExmM1M5XHsrqZLII7OoWS4yeZZM2rkT-X4Enj_HpbtTPujVlmQzK6Eo5AONhoOGatkVsGbBFBSWF6B9HhrDzDQy4koAsoKAMIDIYdmBdlWiIplDxEJIMlO5jxUhEhr08WMl2iJzI8vnekQ4zMuOC86jhgtFzYc0tc8_UStUnjicgAa1sRBv1EDwAGZygATjAcoABYwEqQJyHKGAADYAHZ-ECNC4PQQIYNA_hyBgcgwHQUCACYqhgiC0LQ8jMD0SpyHQPQAFZ-EqFi9FAiDQMCVjWIg8j-HKViUJgQJQLQ0DKhgGDWPIViYAwsAlP4NjyJgUS9GQ0CUPQGCYI4oSwDQ8pBBE0DwK03jWMYsByNY9AIMMwJ-DAUCYPQSpBG8vR0HYvQwECCC8IouyaJgGAINQqoUL0RzKJQwz9NEzD4p0wI9Bgypylg9Bgog9ByNUiDKggxjAgk8gspimA9H8NDWPKeKYCk8gEuclC3MqbjFPkvR3IImBmpgDwlx4PZMCgTd8k8DQoFXEBCAIeQ4EQWM4EwA4kJwGADn8IiaA0OF_HKHB7QUGAnQ0HAqCIcbgJXa0QHXbk7wvHcRD3L101QTMoD1AhpCOmBH2zVMcEB1pgdBgBCA9Qjjd0z0hRwzTJLYoi4aHCGGEpS0TGkuHSDUtVQOFEwwRp-HUTI5HrfIpivDNNlx-4AHUJDwWRBEoJmyjVCAyYvHUgcNCAAG0AF1H0YIWRe1KBdRhiWZdYAcRB4AB5PQACtiIIHBBigA54B9dmQboGAoaBuAQxwSAoFoDRNasHgLbDCNgKsKAMSSRRw1cfMRQlaU5SVHAlGFAAlRUp28YVtYAOX1QUuAAMgzn3RB9eX1UN0XlfFo1WCgB3-iyXnGaD_MCA0M3gJDKl90JHgwExi3bBGR9KgaCBeBxu2uZKav-bgKG6GaEp-4AalnsMq1EI9HF0Zo0GaLGwcumuiAULgaTgShTfJkZAxpIZ4C3rgAEcDjhcQkgBLg9AONn-c0fHscUDQO40PfAxjS1kjGm-NKAvzBqSd0WhKBgC2PkcBPpMCwiOAQdolRyIwWbsA9mcAR48wZuPSWEBpYXUIfkccCgY7wGPm_C8j5yKVBgoERGh44wlG3uQrge95AvwgKOEEB94Ckn-hAPQsAMZaA4VwWBYAXCbFgdfHe_NuEKGAkeCAcCSiCIQUcdAECuCVGftIyg-tDZcF0VAfRldNj2GUfkGR3AJAuCgGAYCuD8FjyZsQ0h9jKHyHBKOfM_hKg4GqKBRGCITQhlDF6QEwIwQQihDCOEiIgTyEIn-fgbYcB6yPqgLEOJaD0EQCASkIBMCKDRIGRkDxkC2kuo6NQzpsweiQGBHAlFOkeCRGuIs3p2nAjRLgX4j0QAvHWPcDw9Txl2HJNMjwGSzgwCgGfW4-BiCrP8P4SgVSxmv2gOgBZIAllEVWQcqxaz0SjJAL0ipMBVBKBgFUzANT4DTPKaclZ_hX4YFgBoY5AA9c65RyI4FYmM7Y8BViTKBaxHAMFwU9IRPEkE4IKbJMQLCeEMAkTjN0CxQwd1qCQGaLk_JhTqDFPxKU8paBIBEloIKSguz5QWloJqT6SB65mzZMtSE6BqFQEoIIbWqApxyFQG2aZPKYB8uzMcvQFomZtL5bQEkUA3zHK-VAHpqLEkYuhFi1JuKgT3BxKS8l1BKW4hKWUwclojT_O1hsC8dTylTSOGNQZ909ioDyWMmkex1BTktF2Op2KXB8vgOOfYXrhS4gtPIGVDc5UeCPgcZZ_jpmRrTfc8gmqTrkxzSavlmAC2QlLBebNKScVqshG2NMgzFTSBQmMrIaxNQpt5R4Sgb91THPSFkMZ2Af7EjxHCJ5VAi1kjqbK6NRAJBTrJKWMk45bAWTsN2vNnrYDUKPifLlQEQCoH2N6u52AC0HEwNMyWHhT2YClLu95gIPBDqbdLFFQI0VJKNbmhEAGgA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/viewport/lights/shadow_map/src/index.ts",
        "description": "Adjust the shadow map resolution and bias manually."
    },
    {
        "href": "examples/viewport/lights/sunlight/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=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",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/tree/development/examples/viewport/lights/sunlight/src",
        "description": "Example of how the sunlight can be simulated."
    },
    {
        "href": "examples/viewport/post_processing/custom_effect/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlqKMUGgA1pxWPBowUO4gcAQAnrBweDC2HnHxeIlgKYQE8nCIxsYArqjy0QDmOFRExmBQlADuehIwAAIAjDgALDgA7MboEGntnT19OERoLXBw-SI8YQUmOYLCOwbo6eE8jNOqXGmZMCldEOgEeIhcgwAMbwCkANxcORCNQgvd5fb4eU4Rci6VT8OBcB4pKGoGHrECsExIlEQkwXbEXeHoFI1CAha6wFLyShwCQQagvfh6OCUKA1WhgtE4tTYuDkDQQeQELgZRQpIiUdA1WCkjTkFJwGXGNCYXAEVHo4w8vkCg6bXia_mC-WyjxlCpVWr1JotShtDrdXq0IajCZTGYEOb2xYAKzVJn12p2xiOJ04u2IUGEIAANCAZgAhND8DTpJBgfhQFwAXxjRsVGGwOFVZBAVBodAIDAgREpGkFACouLDtEoAGpcMAaG1cDz9bIKGAXTTGVQQGBdTQeMGoKs1wXAByJfi0aTwanUKMLgS0FujrqzriZ9udojdkC9uSKQcaYe7icgKczyi1rjzgCiYDAMHIBAACrC4BuABKdCYBof5rAeR5dh4lJpPInbkKuaCNJOnCPs-86eNOYBPkQG4tl-BBPgAzJBHbQSATyJDAqHTtWT5zlwcawBgvh1N-tKoBu76ft-ZHHqesHlAhSGoCh96cJwAAUjC6Cc9wYN0ACUODSK2XCuM2LZTpwpZpEe_CNDYNCyIImgaVwAAGnB1BAOEaCe6jkKR44AoQcA6cilAPFwRD8GgACSfmNDAUl6YKaBcE5IzwvUrIAMLMk-G7hbFUVfgATFwNSqBulCsul5Axfl5QJUlGhKS-klEay8hlZ0WiadFUloHVBCJQ1OAaI0ehcA2rmAqqG6tfVT44PwSlTpmnCWZ52D7uQUD_lw8U1GkNo8YRXDYLQGBwptfHAAU1RcAAxIkjScSt1BpBoNTfk-cJSYMSmSSI4V3Q9GhSZVR26nANSKN9HiretRAHQQHgbh2hnGQQpmgRuf3xFwegsegbGoBxdJMejmPY6gOAAHIAPKAQAsgAggAMlGBRWLZ9lEJUXCoGOXDkwoUkANrcx4A3uVDrPs1hdm4VJbNdFwBFfcRP1KQAugrr26pmk0FNNqDHcYZ0gRdV2Jagt33URzhcM9Kua9JsLpFj5uVa4rBVSIJ28luMCNlFu6zgUqUjmO-6afwXT-YKbtLjAO4BwxUnI6ImKwi86CUOQNRwzgIUEK-sBw3G6QBegUkeAnqKVU2AAS3jk9T8XQrC2cwHDdO6g8LweEQ6RR3uDEbDwatTlsOvh7QnsuGsnG-zdhpIdQFnB6Hm4Ryu4_ULH9NChA5DRLYiDrzwHgAJwAKz8PwIxH4MgxH2AGV6GmbwwMfbyXxl4x3wf5AH2AxEHxln_jAA3-MARgjHIAANj_mAvQGV-BHyPuMC-xFiIjAymAoqbwwFgIEOgDKGDUEH2IrfQI5BBgHwPrkcggRAhHwPiMPQehyBvGIvwQIbxqEjH4GA9AGDv7oD0AAo-VC3j8A-OgMAIwwFH0oXodAxEYBH2IugHBB83gSLoRfcBX8OFpm4XIwI9CYCsLAMI8Ybx-HoE_oEA-YCz7EShKAhBAh-AH3GBYy-4xBhyMGHofg5B0CSLeOgQY_g0FvC_mAQIuCRhgEGGARCYSP6YDoYELh6Bxh0NgVDdeYpMBQC7p4DQUA24gFNJUaocB0AaHGDAe6wwan-EQjQDQ6Z_DDD7JeNQmhrRECyS3dAxSO7LzXFrEAGt1ZaxEPPCQwspY_mPDMUKUlEhMigOoB2TsXAEG8FWGAJUlnwGZOoDcbwlLjO1o2DiMIR5PA9n5VANR0xcCEv4eCKdRIoREP7butYcBCTmW88eYkli6AeVAH8VJfwiUBY0CyBA7owE8oPLgmdGxQCgEKHIwtEJrCTOkLglA9BekInCciJ4blcEpj-AKk8jZhxtLBcyTVvYMV-RC_52LqRApgB-QiiV6IuA0AAQgHg4KeVxGkeyZdHH5VFcgACk4CJUSCTQlxKcA8joAiml-koQ2GaRZL5s5CxFHlYqp8MAVVEu_HAFo_A9X8ERaEHWgh0BPP_PARsGBto8utZPflXSXXgTgBLdmwF8xgX_FJDVbMUp2s0BNM5Lsh6LhHvYak1ZYAODWkRE83LeKCl0K6xwugQoYo9ozXC2qw7Zo2j6wUmlJYrRreDOtP0RWpzBhDHAFaHI2s2UXEAAtVRC0baLJmIapYy1NnLQYxzjmnMTTwVoDKNDjSUUGidXAIYbt1fGlKzaIanKmkpNtnBoyxjgAmVAuLUzpizDGeQvjoiGRgDgH01Biyll2hWRAIAjogEwIofMWNRyomQD2dpA5OnXi-XeXeIBiI4AysMDKWSQBCVeRy5CHh4NgJwD_HAgw0OypokgDwbxCOBDGG8Dw2Z27-RGfBpUBYWBQDQ_6YdZAPBpCTJDMj6GkyIXRcx3ArGuD-H8JQIDaG9DEigOgHDMFBNJFRnJ11In8Dhlo3TADMBVBKBgEBzAIH4A4f_Y-mUSR_CyYwLADQimQAAD1hiDAyjgI-xH0iKA4w5xzR9nQeZAJmTM574yJmTLejMMBsypELQYXApZIDNHfagT91Bv0MH_WgSA05aDU0oFJ_5tACY4bhTUGAOmnDoGAp0QQJNUDxTkGJUjiAysVY8F8hzehOxdAFcRxu8glq0AcxZoTtHQuXvCymRAaYosxdVIlgEb6mSpeQCWdL5ZMvF3pdATQJMBScTA_-nJkoWvbaIGKVAPo0OJDFOoPlcMwOzZcDp-A5NxSnYCmWTs8hSvwp00yGolnOa_ciy9jwmBFpJiXBPMH7XdNQ-aeIagIOcPPfh3YbqeR-OvmkGA9jcLN58da_9jwJUVD2f49MNIaH5qaB2TQdMBmqBI8en98rr3lgEGZ0-JcT5ya2EEEufg7P4cndgMBFZrJYfwdQOKUjdGQDYEWjUTAOG-YgDl5gAA-uL0z0YIdug8ArELMYwvXoizNu90XgtAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/viewport/post_processing/custom_effect/src/index.ts",
        "description": "An example of how you create a custom effect."
    },
    {
        "href": "examples/viewport/post_processing/direct_access/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlqKMUGgA1pxWPBowUO4gcAQAnrBweDC2HnHxeIlgKYQE8nCIxsYArqjy0QDmOFRExmBQlADuehIwAAIAjDgALDgA7MboEGntnT19OERoLXBw-SI8YQUmOYLCOwbo6eE8jNOqXGmZMCldEOgEeIhcgwAMbwCkANxcORCNQgvd5fb4eU4Rci6VT8OBcB4pKGoGHrECsExIlEQkwXbEXeHoFI1CAha6wFLyShwCQQagvfh6OCUKA1WhgtE4tTYuDkDQQeQELgZRQpIiUdA1WCkjTkFJwGXGNCYXAEVHo4w8vkCg6bXia_mC-WyjxlCpVWr1JotShtDrdXq0IajCZTGYEOb2xYAKzVJn12p2xiOJ04u2IUGEIAANCAZgAhND8DTpJBgfhQFwAXxjRsVGGwOFVZBAVBodAIDAgREpGkFACouLDtEoAGpcMAaG1cDz9bIKGAXTTGVQQGBdTQeMGoKs1wXAByJfi0aTwanUKMLgS0FujrqzriZ9udojdkC9uSKQcaYe7icgKczyi1rjzgCiYDAMHIBAACrC4BuP4QFgSRLrSqDvp-34bgASnQmAaH-awHkeXYeJSaTyJ25CrmgjSTpwnAABSMLoJz3Bg3QAJQ4NIrZcK4zYtlOxGwukqDkFwRFUQxrAvgU1SbkuMCNlwI5jrOBSlmkYm7vujH8F0_ASEJ25yU-BBEcABQ8JisIvOglDkDUNg0DgjS2K-sCmQQcbpAAkugREeHpqI8U2AAS3gALIADIAMLQrCVkwDZUY6QSLweEQ6Q7hJGkbDwmZUVOWzGKpIn2C4azgVJ1Aydla7cApSkqbyW4wCuOXUFpEXiOQ0S2IgEU8B4ACcACs_D8CMHWDIMHVgAATHoaZvDAnVvP1Q3jKNbXkG1YAAMxtUNC3jBtq0wCMIzkAAbGte16EN_AdR14x9UtS0jENe3kCMbx7XtAjoENj23W1S0jYE5CDG1bW5OQgSBB1bUjHoejkG8S38IEbwgyM_B7egj3LegegbR1wNvPwHzoGAIx7R1QN6OgS0wB1S3oK9bVvIT4N9fti2I2mKPk4EEMwHDYA4-MbwY-gC2BG1e09UtUK7RdAj8G14yC_14yDOTgx6Pw5DoETbzoIM_h3W8i1gIEb0jGAgxgDh-vzZg4OBMj6DjODp0eOFupipgUBxV0ngaFAUUgKalTVHA6AaOMMA1L9ODh_4OE0Bo6b-MMfaXmomjWkQzsRQ8fsxVVRWJQeKWESIinKYKqBjlwP7HjMMBEURiRMlA6g8a4fEuAQ3hVjAlCsg38DMuoG5vFRReoAJ6Vq-IMK0EKORcEQug1OmXAYQQ_hYUZuGoPhIjiXuGk4Gv1dbzlO9LEv6Y_lSv7YdvjQMUKGg1DALEiIJFmCumUBzyJFc4WsJM6QuCUD0F6L8qpUInieCJAAgj-eyeVUAyVaBhTQj996ziPjfE-ADqTnxgB-CB_kbRoI0AAQlSg4fKhpY4iUYpgw-TxEgwAAFJwBIYkAA8mAiBcAcA8joK_JBKD-A2Hjhg9StZCxFFyOwzhMAeHgO_PwqE4j-BvzSo2amq9_zwEbBgLghCoKqjytWKkadBDoCQnAIiFcuhcDgvmRC_4iKCIrhuNRmh-CjyodJQU8hgKgXENQSCEDH72KrkEqAYFQlEO_NxPxpCLEaBwFYmxdjK5hO_Bkrx8cNyBJAjEkJEF4kEF8ZwZKiTODRljHABMqAgGpnTFmGM8g1bRH4BZHAPpqDFlLLQegiAQDaRAJgRQ-YOKjlRMgHsycByp2vPvO8zUQBLRwENYYQ1M4gDXpvPBeEPCrL2jgFaOBBgeGzNFZS48kAeCVAWFgUAdn-lMWQDwaQkwECOehJMOEf4PNwE8rg_h_CUAmTsvQxIoDoB-bsv5SQuBQugOgeE-YgXhkueFMZMBVBKBgBMzAUz4BHNGe0mUSR_BQowLADQcKAB6wxBhDRwB1HZwp4C8gNAyjqzo2UgEzJmWp8ZEzJmaRmGA2ZUi6HRoYa0qBIDNF6agfp1BBkVmGaMtAkBpy0F8pQcFJ9aDflykgAgz8YDYqcOgOCnRBBcNQP5OQO8YBHPNS_bF-84V6E7F0FwdLoweFoNWYprq7nwopc8gVwr6mipTIgNMEqpWqlLIqnpTIVXIBLGq8sDBRmoOgJoLhApwIzNGW7SUYbVmtDFKgH0OzEhinUCQogNkZmJpcNi-A3lxSVvsmWTs8g3UWuxUyGoFLvIKCOR2y1HhMDkBifHEp06WmzpxQupMsTUCTqHeKztQakyfzha-aQe0XnmogN-YdHqPC9wICoANqzphpB2dgRQfIbLpnxVQJdT4ZnurXaFCQ36nxLifN5Wwgglz8GvWuitsA4JN1ZKa1ZqBxRhquSAbAC6aiYCOQAbQ8GhzAAB9eDJLA1jLdB4AAukKmMIrGlioTauwVmYgA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/viewport/post_processing/direct_access/src/index.ts",
        "description": "Access to the post-processing library directly."
    },
    {
        "href": "examples/viewport/post_processing/effect_preview/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlqKMUGgA1pxWPBowUO4gcAQAnrBweDC2HnHxeIlgKYQE8nCIxsYArqjy0QDmOFRExmBQlADuehIwAAIAjDgALDgA7MboEGntnT19OERoLXBw-SI8YQUmOYLCOwbo6eE8jNOqXGmZMCldEOgEeIhcgwAMbwCkANxcORCNQgvd5fb4eU4Rci6VT8OBcB4pKGoGHrECsExIlEQkwXbEXeHoFI1CAha6wFLyShwCQQagvfh6OCUKA1WhgtE4tTYuDkDQQeQELgZRQpIiUdA1WCkjTkFJwGXGNCYXAEVHo4w8vkCg6bXia_mC-WyjxlCpVWr1JotShtDrdXq0IajCZTGYEOb2xYAKzVJn12p2xiOJ04u2IUGEIAANCAZgAhND8DTpJBgfhQFwAXxjRsVGGwOFVZBAVBodAIDAgREpGkFACouLDtEoAGpcMAaG1cDz9bIKGAXTTGVQQGBdTQeMGoKs1wXAAq8gS0aTwanUKMLxL8Wgt0ddWcbkQABQA8tJvAB9I8AJRPAGEAKLSaQASQAcgBxC8P3y-B93y9vAATSPB9OEzdtOyIbsQF7ORFEHDRhz3CcQCnTgAApGF0E57gwboAEocGkVsuFcZsW3Q1AMNhdJUHILgMIIsjWC4ecRGqBwt1oRsuBHMdZwXag0j4vdZzIxsun4CQuKXGBdwEyhaww9irExWEXnQShyBqGwaBwRpbAfWA9IION0hfdAMI8dTUWYpsAAlvAAWQAGTvaFYWMmBTMPKwHheDwiHSBT9yUggNh4TMCKnLZjFk7cYF4lw1lpVAhNQESUrXbhyP4KSZMXRKV1S6gVIKHhxHIaJbEQCrRA8ABOABWfh-BGZrBkGZqwAAJj0NM3hgFq3i63rxgGxryEasAAGZGt66bxmWhaYBGEZyAANkWza9F6_hmua8ZOtm2aRl6zbyBGN5Ns2gR0F6m6Lsa2b-sCchBkaxrcnIQJAmaxqRj0PRyDeWb-ECN5_pGfhNvQG65vQPRluav63n4D50DAEZNua369HQWaYGa2b0Aexq3hxoHOq2maYbTeGicCYGYEhsB0fGN5kfQabAkazb2tmqENuOgR-Ea8Yea68ZBiJwY9H4ch0Fxt50EGfxLreGawECR6RjAQYwHIGAtamzAgcCOH0HGIGDo8PzRDFTAoFCzwNCgQKQFNSpqjgdANHGGAag-nAg_8Y2aA0dN_GGPsELUTRrSIe36oCmDgpKnLIq4aKqJ4UsRLwBXKAfMAwBgcgCG8Sgaty0TFNrHBKTSI9O2N1LUGaQR0FL8vK_K3V5E7RRa1HSo2Pqng0FoTKJHSF5xnq7N6uFGAXlPc8r1vR9n3fL8fz_ACL2A0CcAcuMAEETwKXPOAykS9E6G1e4rqua7oCT-LCxvm4IVvtNXGgLuZMX791UqIIelAR7iHgC8cB_kyyzwyMCHAzUHZWBZMsVAuhjbeCKPAPAzJ0AvDeKg9BogaoaFQEkaQEAABea8KI4AANKaGoVAWhDCz6eA_GBXUy9dSr3XmeS8N57xPlfJ-b8v5_yARAg-HAcZXInhPM5G-MU74iALoKPANQYA6AIDUKO4hqCgLfrXT-YlwpNypH_NugDO44G7mYgeVhIHQLHnAyeVxtxGO3GlF4Mcl7kKEVwDeojt4SL3tIw-cjT4OU8A-C80gL7eE8NeVJL4TxvnUXnBwwlBQjkaNQggtAzHVwseRL-s4bEt3sR3YBPcy6v1caIUJ4St7iN3lIg-sjj7yJwC2F8H43wPm8N4PhUUNGoGikxKc0ZYxwATNg5MqZ0xZhjPIRW0R-CGRwD6agxZSwzwrIgEA84QCYEUPmeiY8PDIB7HHAcCckJf1QnVEAs0cC9WGL1Dwy8QBEGkulJAHglQFhYFAFOqReQGlRA81Idhaz3I8FsmUSR4T5lwJCrg_h_BQLoNCvQxIoDoBRSANFxsoBcGJdAdAmLlT4HDP8jclyYCqCUDAa5mBbnwHuRcylSR_DEowLADQ5KAB6wxBi9VQdC1e_oIqgpABK5qzpmr_MzAs-MiZVmIDTBmGA2ZUi6CRoYa0qBIDNAOagI51ATkMAuWgSA05aCuUoFA_-tBK5pXuQQDQejWVOHQNeJIlBBAnlQHeOQncYB-oDTAVlX9yV6E7F0Fw4roweFoNWKAiVyWCqhSALVMYdUrJTPq9ZRqYyqlLFa_ZTJbXIBLPa8sjqbI2nkNATQJ4BRpXhRcp2ko43KtaGKVAPpoWJDFOoO8NpTLwoNS4Vl8BnLimHS-Msw942Bo8EyIxxtnIKHuUuxNHhMDkDzcY31azDWsovVe_x1Aj3yBPVW1lSLDJKo-U-Ta0K0h8krjus9IBKCshUJmj50w0jQuwCPKs5Z0ycqoMYpS8L_W7pAD5CQyGlLbiUs5Wwghtz8GA6yodsBQ1MhZCYkFHzUDihHQC7Al6aiYHuQAbQ8AxzAF4KN8qzZct0HgAC6JbFnLKTBW09mZZNAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/viewport/post_processing/effect_preview/src/index.ts",
        "description": "Multiple effects being added via the API."
    },
    {
        "href": "examples/viewport/post_processing/effects/bloom/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlqKMUGgA1pxWPBowUO4gcAQAnrBweDC2HnHxeIlgKYQE8nCIxsYArqjy0QDmOFRExmBQlADuehIwAAIAjDgALDgA7MboEGntnT19OERoLXBw-SI8YQUmOYLCOwbo6eE8jNOqXGmZMCldEOgEeIhcgwAMbwCkANxcORCNQgvd5fb4eU4Rci6VT8OBcB4pKGoGHrECsExIlEQkwXbEXeHoFI1CAha6wFLyShwCQQagvfh6OCUKA1Wi_AiUeQvUHgnFqbFwcgaCDyAhcDKKFJESjoGqwUkacgpOCK4xoTC4Aio9HGQXC0UHTa8PUisUqpUeMoVKq1epNFqUNodbq9WhDUYTKYzAhzF2LABW2pMJoNO2MRxOnF2xCgwhAABoQDMAEJofgadJIMD8KAuAC-ifNaow2BwWrIICoNDoBAYECIlI0YoAVFxYdolAA1LhgDSOrgefrZBQwC6aYyqCAwLqaDxg1D1xti4AFZOwDC-OrkcTUeMFIUCWjSeDU3f7xL8WidqddJd7kQAaU0qCS0ggAC8YPeeAAFADy0jeAA-j-ABKf4AMIAKLSNIACSAByADiQFQb4vhQRBwHeAAmj-UGcHmPZ9kQA4gEOciKGOGgTjes4gPOi6UE2XAriIB6XjAEE1GkjqeBA35cHByaUMyAioFBsA2DQglwUofbyOg3QSVJNaydIUSYBokkwNJBCEcR_aDsOVFqOOk7TpoODDok6A4Jg0r-DkUCKBoc6cExLHAEJa6iUQUFgGAMDbkoMCQAuO7cERvZGeRJmjmZNEWTObkMZwnAABSMLoJz3Bg3QAJQ4NIXZcK4HadvOmWwukqDkFwGUFWVrCsQU1QOBetBtlwyVLvu1BpD1N5LmVbZdPwEgdYeMDXtOS4ZWxViYrCLxKeQNR6TgjS2DpenJukcHoBlHjLaiTXtgAEt4ACyAAyEHQrCu1qQUPAPC8HhEOks23sx-kgAUeYFfOWzGFNnHdS4ay0qg_WoINUOntw5X8ONk0cUeJ4wwtr3ihA5DRLYiC4zwHgAJwAKz8PwIwU4MgwU2AABMejZm8MCU289NM-MrNk-QZNgAAzGTTMC-MEuizAIwjOQABsYty3oTP8BTFPjHTQtCyMTNy-QIxvHLcsCOgTOG7rZNCyzgTkIMZNk7k5CBIEFNkyMeh6OQbxC_wgRvC7Iz8HL6CG8L6B6BLFPO28_AfOgYAjHLFNO3o6BCzAFNC-gptk28ifu3T8uC4H2Yh-ngQezAftgDH4xvBH6AC4EZNyzTQtQrLGsCPwZPjI39PjIM6eDHo_DkOgSdvOggz-HrbyC2AgRmyMYCDGA5AwPP_OYO7gTB-g4zu6rHiCTw0qYFAP2eBoUAfSAVqVNUcDoBo4wwDUts4O__gbzQGg5v4YY8VqIOiICfXG70yJfWPNDagGweBAyquxAaYo9CdEdAFIKIUwpoBpHSHy6D_KBWCgQUK4U8HI1akaeQClNDiHgC8Ra8RjDNlbN4HIXA0F0HQD2LckUuCUDAOKPAMwuBhSwQQHADVMDZjlAQF4a5uGbjqpFHAABBJQSgmrNmMCTTh650DKO3DDBRBijGqI0UoU-ogWFsI4Wgvy8JqzwwkOkKRGUZH8DkcCHAbxtG6KNG9Zx1IMg-LeNYrYrCuDsJgPomoWhCYaBfFAK4H4YDuM8d4rgT4kmvjSTgW6ajQJISgv4vRiTklvk_C8HJlT8mFOKVBCJoQokQWoAQPsuZhGxLgNKSgTwXxrAEUIp4sSWTLFQLoDewjEjZGZHZLgoFdDbXhHCAA2uE14ABdDJYUvFQHkVwN4vimYUzKYErg4y0x1RgNIPpTw0CNG5CcimzTbHRI4VcyZNyZnwDwPMqRSyZixIeXCGELIQWUC4EQWE0QBGsi4OgdMiSxGqRoHCNA3Sri_3SYs5ZsTREbPjNs3ZsiDnPLJuc-IlyNrXI3uw2Z_yoDoApW8qJUFJlcLhMxRFMwGRZGhSKGF8g4kaFJfsw52ZcwwCpfEZY8hhVrniS8KVLhcYFlxhKGALx_yARAuBaCsFEIoTQhhLCQFcL4RwMmW6f4_zXUBiDBwKD9F-UwSQ7wlBCaUN6n9HAlI0g_j7BvaGqBmiCHQO67cx0jQOIwcQ7B5DIoFGBuldinUuI8Q5EQfiMarBrL0YwOSCklJdBUrpGsrAmHUsmTYO-iiNx8JhuAi5PAtV3xfpyUtsMEx6J4NQCCcgw1cRzFAUeBMXgZXBTUbVVwOmPKaq4Fq1bqWuvjRIshuDVE0M5HQqccAACEOAuGNpUTDUaf49D-hITgad8A82rqsA2wxTa4GttEAVNZABqO9Wy2xwmfeYmGTrH2-qbP6qkBAg2UBDdSMNOAaiKU4lGggD7H08DjUQiRnrvXNOpZhlDm6IrNvfTwVN76NXvscJQfGDCuCXuvduHAhN0hwAyoB19qACp4Z6jmGdLwGM3rvWxjjZ7qBFXVNgP8YA0OroIwm0hODiPUH9bQps-6j0npfWJ1AB6-1cAKnoyj1Ki0iTEroZ6NAq36drbOz6QqFBKtSjx9tZEDDmZ7TxgdQ7toPSgGOse0RJ13peO52AuhF3Lv0xhwhhGlMUNU7u9T8Aj3ysVSyLQ5U70gdXWByRAaoPBqxvBxDSLaAodk4--T2GvV0B41YarJCiMUOiwZnLVhjO5b47Oxriat0w0S65ehh6lgOfkE5ozzSi0aQeJoSzBBrPvts3fNAtAXEZBbY-1zHg4CaXol51Ag78V-YCxOhqIWuCoA2noTQkWqHobXVhpr8Xt1qeG0e1bdAQnpFGtl1reWIOBqK6G5opXkMKcq3J2LCmcN1dazFt1CnmvJtI21_TnXqUXd64ppNA2d1DY0zgT7630g8YmdyMn_AsDAnCfptIMAuRHN8YMSbha4Iza0vNxbj7ltkS-VM259yRFhs26u7bqQ9vOf09547o7x1BfO91l4V2iA3Y0Hdld-Hocbpe3jt7hP-c3LuaJB5Ybfvdfa_EAHBXoOwceQhpD5WIfw8eyh2HqB6uiGx8jkjD3yOPox1bpXruke65U_jvdKWcCG43sb_pwvGhk7QBT_TMLqevB4_TxnxyPgs4uYHs47PJdc816IXnHgY8wAZX8-ZovqXi927NqX76ZfDpO_L4LweVdq416173YfUCDcjyNyv1e5nMvNxCy3VhreQdt8V0HjuYAVZd9j93nuEfrue7jt9fvp9cAL6ILH2vt_9fD_rqPo-ig1-ZUn1AKf31p-BJn2g2ffFc1Zxcot8ku3KRLzZ_gOtNzDLLgfwLgCpPJT8OveIcXTtRSZSaAqwVvXzOXQLTvCFZXa7W7Zqe7dDfvHfQfCPZLEbCAqAKpWJLLC3f7YaP1G3YHODRfMrZfZ3VHTfJ7bcdfVfE_PrZTWGVHf3VdQ_HgajWjSoejK9G9FjNjWpSAmVHjY_RHHXAgofYgo9Ug8gozXGLZaxNaDaGsLaHaNFAgfaQ6Y6EAYkDwc6OEK6O6FQVQebFNecIGRqecBMJMOAVMSZDMLMHMfMRMeQQLfgbaHAQMagCsKsNbWsRAEAFcEATARQEsOqfdDwZAYySiBKdQJKOiVKYmEAIWHAJmYYJmcBOKdI6iWiSyMVGyUceyXSSgJyJIVyFIjwfIwogojwDVEAGFNAZopMEsXAFgKAEokMLUFI2ItIdMf6XIgIxUJIJxDUfAGMUA_wXdTzDwPQYkZlXomYjeFJDY6AHhSTAYmMDovcOImAVQUKBIzAJI-AMYjwHYpIfwDYjAWAHIjwAAPWGEGCZhwAphKK1RGN6I-Ipg9H-JADzDzDcJTDTG8MQFVRgALFSF0HDkMAdFQEgGaFCNQHCPaRrAYFiLQCTRgFulEnkGg1oGMTgSQA6RnTOKcHQFAiSEoEED_EOx8xgBSNpK_A8GSl6L0D7C6BcClxAFoAbCgE4m2PTF2I6OhI8NhMzHhN8MRMTC1CrExJCKZBxOQErDxPoGiNiNaHkGgE0D_FFBhlRFSK6JlDlE5KQBOkdGlFQEDBKMSGlHUDaSID0ktIRLOPgGuhtNgDgmrAUi5I0DpJ20oHiQ3mugUBSN9I8EwHIAlP_mTR8OlTOKTJTMvBhljPkHjOVLOLsA0G2imI8BgjlmGPnW3DDIjJACjNIQgHeLiO9BKOwFcnrBrBzFCioFTOYktO5L9OWEU17MvGYmulsEEEvH4FrJ5OtNlFgCZKZBZDTNyNQBlDtM6OwGTJqEwBSILRAHXMwCAnPltNREzNbJAC2ShMTBhK8MVIRMhLzCAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/viewport/post_processing/effects/bloom/src/index.ts",
        "description": "A bloom post-processing effect is a visual enhancement technique commonly used in computer graphics and video games to simulate the appearance of bright objects."
    },
    {
        "href": "examples/viewport/post_processing/effects/chromatic_abberation/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlqKMUGgA1pxWPBowUO4gcAQAnrBweDC2HnHxeIlgKYQE8nCIxsYArqjy0QDmOFRExmBQlADuehIwAAIAjDgALDgA7MboEGntnT19OERoLXBw-SI8YQUmOYLCOwbo6eE8jNOqXGmZMCldEOgEeIhcgwAMbwCkANxcORCNQgvd5fb4eU4Rci6VT8OBcB4pKGoGHrECsExIlEQkwXbEXeHoFI1CAha6wFLyShwCQQagvfh6OCUKA1Wi_AiUeQvUHgnFqbFwcgaCDyAhcDKKFJESjoGqwUkacgpOCK4xoTC4Aio9HGQXC0UHTa8PUisUqpUeMoVKq1epNFqUNodbq9WhDUYTKYzAhzF2LABW2pMJoNO2MRxOnF2xCgwhAABoQDMAEJofgadJIMD8KAuAC-ifNaow2BwWrIICoNDoBAYECIlI0YoAVFxYdolAA1LhgDSOrgefrZBQwC6aYyqCAwLqaDxg1D1xti4AFZOwDC-OrkcTUeMFIUCWjSeDU3f7xL8WidqddJd7kQABQA8tJvAB9B8AJSfAGEAKLSNIACSAByADib5_r4vh_j-77eAAmg-f6cHmPZ9kQA4gEOciKGOGgTjes4gPOi6UE2XAriIB6XjAP41GkjqeBA948EByaUMyAioH-sA2DQrFcEBSh9vI6DdDxfE1oJQHSFEmAaLxMD8QQqHof2g7DnhajjpO06aDgw6JOgOCYNK_g5FAigaHOnBkRRwBcOo5AAExcGhvYaSAjRQP4RCXsKWC2agnAABSMLoJz3Bg3QAJQ4NIXZcK4HadvOYWwukqDkFwoWxclrCUQU1QOBetBtk5N5Lvu1BpJV05LslbZdPwEilYeMDXg15EEKFVFWJisIvOJ5A1CpOCNLYSkqcm6RAegoUeINqL5e2AAS3gALIADI_tCsLTdJBQ8A8LweEQ6RdbePUbDweaxfOWzGO1tEVS4ay0iF1G1WaJ6fU1_AtW1NFHn91B9cd4oQOQ0S2IgkM8B4ACcACs_D8CMKODIMKNgC5ejZm8MCo282MueMBNI-QSNgAAzEjLnU-MzMMzAIwjOQABsjOc3oLn8CjKPjFjtO0yMLmc-QIxvJznMCOgLkyxLSO0_jgTkIMSNI7k5CBIEKNIyMeh6OQby0_wgRvPrIz8Jz6Ay3T6B6MzKN628_AfOgYAjJzKO63o6C0zAKO0-gCtI28PtG1jXM0zb2b20HgTGzAltgO74xvM76DU4ESOcxjtNQhzwsCPwSPjDn2PjIMQeDHo_DkOgvtvOggz-JLbw02AgSKyMYCDGA5AwF3VOYEbgR2-g4xGwLHiCTw0qYFAV2eBoUBnSAVqVNUcDoBo4wwDUGs4Ef_jDzQGg5v4wxaaOOkaA6RDz5Dp1YRdx4fdQt3uQ9nA1agOqjgMKXmhgAQT0JoK-O4eJgDADAbcSgYCQAXDAl4iVOw4CAj-IojpQHkAgVA0B1A_xwIQQQJBKCaTUCav1UQ8hRKaHEPAF4dCrDGGbK2bwOQuB6HXOgHsW4YFcEoGAcUeAZhcGQfA7cOBcqYGzHKAgLw1x0HQJubKMCcAgSfJ-TaYDtr5WbMYBGvD-EaO3J9FR5ihGfW0bo_R20F6iA4VwnhS85TEO4KIsALgCByKfKgKA6Q2zyHkFEeA8IxEAAMr7TBzJtGUniYHRPhHCOgDJYAmXkcg_gSjuQ4BxkYkxRpF5JKgF4p8cC_EFJxs4rYnCuDcJgA4Zk5ERHVNsHI0KCi8lQGUVwAA2m8HAHxBjxi4CMj4bwUYAF1immJ8TUoZUzSYTNWTM2Z9TQiNIAOo5CeJocRLTpHkKuHgSgcoBGQK4B4iptABH3CeBVOJEAcxcEaK8ms3Ten5J7DmFwCzSlcFeQk8pXiXjZlzDASGBZIYShgC8Z8r4Pzfn_IBUCEEoIwTgm-RCyEcA_jWt-fR3hsFvjAcmP8n5PxgLJU-ECBQ8yPVaYAsUwC8HiAIZAjQ0DPqkJkQQbwlBYbcBSnpa6TYcCUjSA-Psw8PqoGaIIdAAryGLSNBy_yXLCG8q8WqxByC0DUK-jwP-pqXq0HooxIgzENVWEGaYxgwlRLiS6JJZSNZWBsPiKgfgNhN6qI3LY7-CZTE8ARZvfenI3UhTDcCng1AcG6EmntKAUAG4wxeKFGELJEVXAIMKJV-VXCFR9fEBwuDtXgJ5XykhZDDVUK0QwzkTCpxwAAIQ4D4WoixwiUpPj0P6chOBc01HgPait8Qg3qJDRaqdXBYqDIANRjpgLMtscIZ19s-iyhdEqlzSqpAQOVlAFXUiVTgGoYlaIGt6uG-IWr8G6rrbAwVwrRXbIrU-nVtb9UNooUa1Bn0H1mr3fEOFCbK2UGhiwrgg7h2yNhukOAoVt1ztil-pyOZx0vAQyOtdqH0OaM-vFdU2AqmToXT-mtRCYF3soca5tjCmztq7T24NJHqAdofbFUxkGK3Oo4lxXQh0aDeofX6gNWFQVQESbKe5IH40LsjVhAwIm41YaTXIJVdEcwZsbtEbNa6XjqdgLoEtZbQOVpAb-uj_KAOMeA9QaVLHmGdpwLJ-TyT_ripwzAcDFaD09SPbK-Vf1L3XvQLegDVGF02c5bRvV9GAMfroFhgaVbn1_pS4KpzJrrPmoXQJqdJmEvVu5fZ-teWgMmtc621j8Au1efBTA_j2znVyQeJoMTBAJNQak_mjwSzbBcH8FwIKymp2qY8HAeSxEtOoGTbptNBms25TK6gMaPLLNFSgzwcKzkXKsBo5V5LDmatNrsS26y7mu0jYICWoZ1meBroy6IQ7CDjtxfi7lRgR2TtZbs-d6r5D8vMYa3dnAD2-P7dELFWKHbBmDFmdZ2ZgX4jBalTKk94XFXNCizFwVP2p2nZff-99Ir0svfK9lqrb6we1ba3DorU6StBf89m_7X3WAk8y7ZpLr6GNM-u25tj0POmqSgwjpHbwtkPuWKgbkWH_JYGBFhtIMAuSTNGWM9rTrZLzcUlJcT5bRCDc3g9sbXB0gvygzN1IRu7cLu0ymvT6bM1GY25zrgW2iA7YKnt37n3XKA4F2doXjmRcuZu22prEvfG2Ce46uHB3ueh7Jzli7jOrsx7F_HmHsv5ep-w3mtHGOrBY_8Tj09560AE5vbQO9fPH1A8FxT8haXUDvZ4Jn-nwvc_zqnazit7PMc-5D996zfeQcM8bUx0XkPxcPd44j5HxeF2K-Vwr_gavXga9oNrjZgx9fAs60b3r_WF0W_fq1z6VTE-qSmxWh3c3us2Wf_EV3K39Oe-Mz7v3APUtIPeLGfSPS7BfPPJfePO5SpSXJqNdCvUQKvULXHM9CLBvaLJvWLGnMAjvbcLvHvWnYHcAnPSAofCtEfCDLDMrPA3LMg5zVAerW7cXWAmBB_PxFXNAbfKDVXdXB9TXI_XXUmfjSGDfUQEaMab5SaAgXrWaeaRaEAYkDwVaOEDaHaFQVQXrAoc1e6PKecBMJMOAVMP1DMLMAFGAAsEAeQQzfgSaHAQMagCsKsWgegRAEAFcEATARQEsbKdtDwZATSXCe-dQAiCVYieGEAWmHAFyYYFyF-bCO-fCQifSR-IyUcUyZSSgCyJIayAIjwaI2ImIjwOFEAfyNAfIpMEsXAFgKABIkMLUAIzwtIdMJ_SImwxUJIeEao_AGMMbfwVtTTDwPQYkKAdASojo4eKAXhUYgRcjGomMEovcLwmAVQJBHwzAPw-AJojwSYpIfwEYjAWAD_SIgAPWGEGBchwBRgSIRQaMqNOJRg9BuJADzDzEMJTDTDMMQChXzELF0CdkMAdFQEgGaEcNQGcOoFcNrHcM8LQCbRgG2k4nkFPVoEsVDUQELXHWWKcHQE_CSEoEEECWW0mgCKxJgGWIlUqL0D7C6BcA_2WNoAbHuRhSQF2PTCmJKI-OMK-MzB-IsKsK1CrFBIcKZAhOQErChJrAYE8NaHkGgE0CfFFE-lRECLKPKVZMiNaGlFQEDASMSGlHUB_EdBUlVN-IpI8HgG81gCAmrFEjJI0GxNm0uU6M2gUACPNOWMwHIAqVfQ9IsK9IQV9K8TdPkH9OhUZPTBkMqIAk5nqMLWhjaPJOWMuQoQgBOI8GmDSASOwGsnrBrBzCQSoGgXIlVOTMtOWEA2LMvHIk2lsEEEvH4AdKdPVIUxgHxKZBZDazZJAFQBlFZNKOwB9JqEwACMdV7P7LfDuW2LDS8O9A8FmXeMTE-NML5PNLeLzCAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/viewport/post_processing/effects/chromatic_abberation/src/index.ts",
        "description": "Chromatic aberration is a post-processing effect commonly used in computer graphics and video games to simulate a lens aberration that occurs in real-world cameras and lenses."
    },
    {
        "href": "examples/viewport/post_processing/effects/depth_of_field/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlqKMUGgA1pxWPBowUO4gcAQAnrBweDC2HnHxeIlgKYQE8nCIxsYArqjy0QDmOFRExmBQlADuehIwAAIAjDgALDgA7MboEGntnT19OERoLXBw-SI8YQUmOYLCOwbo6eE8jNOqXGmZMCldEOgEeIhcgwAMbwCkANxcORCNQgvd5fb4eU4Rci6VT8OBcB4pKGoGHrECsExIlEQkwXbEXeHoFI1CAha6wFLyShwCQQagvfh6OCUKA1Wi_AiUeQvUHgnFqbFwcgaCDyAhcDKKFJESjoGqwUkacgpOCK4xoTC4Aio9HGQXC0UHTa8PUisUqpUeMoVKq1epNFqUNodbq9WhDUYTKYzAhzF2LABW2pMJoNO2MRxOnF2xCgwhAABoQDMAEJofgadJIMD8KAuAC-ifNaow2BwWrIICoNDoBAYECIlI0YoAVFxYdolAA1LhgDSOrgefrZBQwC6aYyqCAwLqaDxg1D1xti4AFZOwDC-OrkcTUeMFIUCWjSeDU3f7xL8WidqddJd7kQABQA8tJvAB9B8AJSfAGEAKLSNIACSAByADib5_r4vh_j-77eAAmg-f6cHmPZ9kQA4gEOciKGOGgTjes4gPOi6UE2XAriIB6XjAP41GkjqeBA948EBSh9vI6DdKgf6wDYNCsVwQHSFEmAaHxMACQQqHof2g7DnhajjpO06aDgw6JOgOCYNK_g5FAigaHOnCcAAFIwugnPcGDdAAlDg0hdlwrgdp287mbC6SoOQXBmXZLmsJRBTVA4F60G2XCqbe5EydR1BpFFN5Li5bZdPwEhhYeMDXtOS5mVRViYrCLzceQNTSTgjS2JJ0nJukQHoGZHjFaiAXtgAEt4ACyAAyP7QrCtU1kJPAPC8HhEOkuUxU2Gw8HmdnzlsxhZbRkUuGstKoPuCVmie22pfw6WZTRR4HdQBUFDw4jkNEtiINdogeAAnAArPw_AjG9gyDG9YAAEx6NmbwwO9by_QD4zAy95AvWAADML0A3D4xo8jMAjCM5AAGwozjegA_wb1veMP0IwjIwAzj5AjG8OM4wI6AA_T1MvQjQOBOQgwvS9uTkIEgRvS9Ix6Ho5BvAj_CBG8QsjPwOPoPTiPoHoaNvYLbz8B86BgCMONvQLejoAjMBvQj6DMy9bz66LP24_D8vZkrpuBGLMAy2AWvjG8avoHDgQvTjX0I1C2NkwI_AveM_u_eMgym4Mej8OQ6AG286CDP4NNvPDYCBCzIxgIMYDkDAuew5gouBIr6DjKLxMeKNXDSpgUAzZ4GhQBNIBWpU1RwOgGjjDANTczgo_-GXNAaDm_jDIpo7KRoDpEE3T3jVhU3Hlt1DzVwi0efFqCJZgop4E-YC-FOUDoH-YBgDA25KDAkALjuqAvE5nY4OxMDn5fa-SQ74PyfgQF-b8aTUFSoVUQ8hOKaHEPAF4sCrDGGbK2bwOQuB6HXOgHsW4P5cEoGAcUeAZhcFfo_bcOA_KYGzHKAgLw1x0HQJuHyH8cAgSfJ-bqABBXqAVmzGCejwXBrD2Hbm2swvBkjOHcN4QI5uWwMFcCwTAK4UJYDENIU8DRBh7p4BwSyFedDX78EYS8N6OA3hCJEUaMRlBDHSC0TAKxNjlGhFUeorgqByJEBzBAAAXqOHslBypwmmGkXQZdaGfl0NVeEcIADabwPGvBsQAXVoWZehFioBMK4Gk2xXBhGiLCRElQ0SfJuKKR48p6DMHYLAOEhiXBZ6oGqnEhJGiKGpPScMN42SzEMIKdyGxgw7HlJaRE-JnTanFMGE9AsT0JS1OfK-D835_yAVAhBKCME4JvkQshHASg_wPm8B1N8T5fBvl8EBP8vUlAFDzEfHgVZT7_yeIAm-IDqEEG8E4ugqVopLhwJSNID4-xly2p0nAgh_lgOakaM-Pyr5_PvgCiBaAoE7REEtUy1Fwp0QYhyIgzEUVWGSeUxg7FOLcS6LxfiNZWCoPiKgfgNge4sI3IQ7a68HGiDWT3IenJGU7QTOUng1AfxyHmQNKAUBk53ReGZGELJalpGFJ0gKrggrsviFwNFF8MXAKxWAnF79toQoQU2KccAACEOBxF8o4YdVyT49D-jATgDVNR4BUqNfEXlbD-V7yFVYOyySADU_qYCZLbHCUNcjtrLWDTwMFsUIVUgINC8JB14U1C4rRC124g0Zp4Ca355rQHbiBfdVAnijXVrNbfMt4DX64o_tK0QhLI0H2bQ4PAlAICwpeF6n1ND7rpDgGZFN4bUB2SHfGid3rfXxrnQu911AHLqmwJfCtwbW1APbXWztkDOHwM5Igh1zrXVhp3agR1va7LlJWUKulokHiaGGjQNlvbOXcqwgYmAeAXE5hgIKjNIqsJwDEsRIdsr5XVUVcqlO0Q1Wrt8RVPQmg9UGt7VW75prT1Iufl2611BbU3vtfAe9wLwOuNBTmAN6aM1ZqbDmqFMLC3NGLegUt56j0ZpPZi89Da6BDqsGJ2t2LKN4qI1wftGaP0cdY7U2TZ75OXptdeoySCnUusYxB2AQ7lifyKeZ_gWBgRvCHWkf-4yIbvs8V-hDEkWX_sNaIIDtSPAzIYlUuwNToPBtgx4eDP7jJSoHchnpaGVWYb8th1AuH8OBWCgO4jAC23kYvd2vTdrDPOsC3AYLMSNGuXjex4NnGCDcbzbxuF_GS20A7SJ49JGa3abAZJptSmcvorIx2q1insvKdq1YNTdWNOlW63l0bCmr3FbvTgMrFWanmbQNyaztnXgOdoFyOpHwllCpm1Ydz0W_0EAAwOvzPcytzOqmFo1EXUgede_EeLCqczodVSlubOGiB4Y0ARrLlbjULZG-esbK3aMlfW60uAz2qtRQ01N-I9XGv5thdSItbWYAdcG1D3LMOAX9ek6ILT-W4cComyp4NF2sdA5p0t3T1H9O3vo0j2ZPTtuWfs72gJ-3BiHacydlz52nqZObmVCqNYqo1S8wQeqjVmogGJB4dqcIup9RUKoG7BR-2LX8vOBMSY4Cpk5RmLMOZ8yJnkBh_gXTAzUArFWWg9BEAgBXCAM-rC6DkAdR4ZAClcJL3UARaKxFHogARjgAGwwAbr2wovfChE1Ir00qOHSUlKD6SSEZUPHgE9J8Tx4FZIAAloBL0mEsuAWBQFTyGLUoe_fRLmkgDwTvFRJHhA3_AMYuD-H8DeyVe4QB6GJLfOvvey5QBwTP_B-7G8xkr5PzAqgX6KBLD5EPZAe_pgX_4afGBYAxbjwAPWGIMAGOA3qp7Wa3uvV_rFjEfyAPMeYLcpjTLbxAbMXMGAAsVIXQVWQwB0VASAZoN3VAD3agL3WsH3P3NAS9GAXqSgTkfNWgKRPeJAAgDQANSfJwdAT8JISgQQJ8VAOVHpUPQg4gjwaKOvPQPsLoFwGLSfWgBsKAWiOfY_JISvX_K3f_TMQA-3EAxMLUKsGAnAOAhA6sb3X3FqR0eQaATQJ8UUbaVEMPavGUOUKDbvSsR0aUVAQMVPRIaUdQH8EwmsHQoAlwSfeAbqfQ2AICasTiegogmASfJkGoPvbqBQUPBwnwjwTAcgXg2eHtO3YAzfJ-SIy8baQI-QYIiQrg9MaqGSIwgCHGFvQgsdLIxABg0IkASgVkFQS_MI70VPbAIyesGsHMF-KgKI8iHQ4opw5YTtZoy8cibqWwQQS8fgLwxgvQ2UWAcgpkFkaIuPPxTADfDwbACImoOYpAGlEAWYmAN8VuAw1ETfaokATJH_RMP_G3MQkI7_PMIAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/viewport/post_processing/effects/depth_of_field/src/index.ts",
        "description": "Depth of field is a post-processing effect used in computer graphics and video games to mimic the selective focus of a camera lens."
    },
    {
        "href": "examples/viewport/post_processing/effects/dot_screen/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlqKMUGgA1pxWPBowUO4gcAQAnrBweDC2HnHxeIlgKYQE8nCIxsYArqjy0QDmOFRExmBQlADuehIwAAIAjDgALDgA7MboEGntnT19OERoLXBw-SI8YQUmOYLCOwbo6eE8jNOqXGmZMCldEOgEeIhcgwAMbwCkANxcORCNQgvd5fb4eU4Rci6VT8OBcB4pKGoGHrECsExIlEQkwXbEXeHoFI1CAha6wFLyShwCQQagvfh6OCUKA1Wi_AiUeQvUHgnFqbFwcgaCDyAhcDKKFJESjoGqwUkacgpOCK4xoTC4Aio9HGQXC0UHTa8PUisUqpUeMoVKq1epNFqUNodbq9WhDUYTKYzAhzF2LABW2pMJoNO2MRxOnF2xCgwhAABoQDMAEJofgadJIMD8KAuAC-ifNaow2BwWrIICoNDoBAYECIlI0YoAVFxYdolAA1LhgDSOrgefrZBQwC6aYyqCAwLqaDxg1D1xti4AFZOwDC-OrkcTUeMFIUCWjSeDU3f7xL8WidqddJd7kQASSUlAI0gPdAAomAwDBt0oYJAC47qg948AACgA8tI3gAPpgQAShBADCH7SNID4AHIAOIwR-vi-B-SGwd4ACaYEfpweY9n2RADiAQ5yIoY4aBON6ziA86LpQTZcCuIgHpeMBITUaSOp4ECgVwT59vI6DdKgH6wDYNCSQ-0hRJgGiKTAykEJR1H9oOw5MWo46TtOmg4MOiToDgmDSv4ORQIoGhzpwnAABSMLoJz3Bg3QAJQ4NIXZcK4HadvOnmwukqDkFwHkBWFrC8QU1QOBetBtlw5m3txen8dQaQ5TeS5hW2XT8BIGWHjA17TkuHl8VYmKwi8cnkDUuk4I0tjabpybpA-6AeR4rWokl7YABLeAAsgAMkh0Kwv1NaSTwDwvB4RDpPVeVNhsPB5gF85bMYNWCdlLhrLSqD7kVZonrd5X8JV1UCUeT3UE1BQ8OI5DRLYiC_aIHgAJwAKz8PwIwQ4MgwQ2AABMejZm8MCQ288NI-MqNg-QYNgAAzGDSME-MFOkzAIwjOQABsZN03oSP8BDEPjHDRNEyMSN0-QIxvHTdMCOgSOC7zYNEyjgTkIMYNg7k5CBIEENgyMeh6OQbxE_wgRvCrIz8HT6CC8T6B6BTEPK28_AfOgYAjHTENK3o6BEzAENE-gotg28jvq3D9OE4b2Ym-7gQazAetgDb4xvBb6AE4EYN0zDRNQrTHMCPwYPjIn8PjIM7uDHo_DkOgTtvOggz-HzbyE2AgRiyMYCDGA5AwPX-OYOrgTG-g4zq6zHjrVw0qYFAe2eBoUBbSAVqVNUcDoBo4wwDUss4Ov_gdzQGg5v4wzGaOpkaA6RAjyDm10Ttx43dQh1cMdUWFagxVya-74Kd-v4EP-gE0jpFJZ8n9Eifh_n-ACaBAHcHCs1UQ8gZKaHEPAF48CrDGGbK2bwOQuB6HXOgHsW5gJcEoGAcUeAZhcAAj-bcOAEqYGzHKAgLw1x0HQJuOKwEcAYQgvBWaABBeaSVmzGBBjwfB7DOHbluqwgh0juG8P4UI0eWwsFcBwTANsqBGiwFIeQp4WiP5cHkJeWgGhUD0I8ow_gzDgQ4HZiIsRRoeC6F0TAex7NVGhHUZoq4UI9FkIoUYl8JizGaEsQwgCtioAsNeDgN4TjxH-JzB4-JbwQYFhBhKNJkFoJwUQihNCmEcJ4QIkRGCpFyI4CUBBWC0gkLwQ_B-DCBQ8ynQcA9LgH83xgO_rQgg3hKCA1gSVBq-UcCUjSGBPsHcbo6JwIIdAX4BmjSND0r-Kzf7_2gcBAoJ13L8UykJESHIiDiTWVYAA2skxg0lORyS6ApJSNZWDoPiKgfgNg55sI3MQ26l8XGiByXPFeDz5KAviKIagSE5A6KEjmKApcAYvA8jCFkaS0jCh0UlVwKV3lQo2X0rZkCAHcMQZyZBU44AAEIcCSL-Vw564UIJ6H9L_HA6KajwEuVC-IvyOH_IfkCqwAUrkAGouUwAALptjhAKhRt0Ol8rGftAgkyqQEBmZQOZ1IFk1FkoJElBBeUqp4ES3I_Tf5DJGd4wlL5emWuNTsoCAKRWiAOe6rJ7rHCUAgHMl4rL2V0MBukOAHkFVCtQAFO1OUczcsDWyjlUrw2RqZdQIK6psAQTAKavlFrwEDJdTAyZSCmzUrpQywV6bUA0uSTwAKyTvVQruepB4mhVo0DefWrgnzvl0TcfKBMPaQV0TgBpdisaYVwt6ktKASKy7RFRVKl4qAup6E0Li_FPbzUOs2RAv-UDXXUFLZS8t8A6WDq0eFKVyq-W5SXBq6Zsynr6sNbQY1eaVUFqtduG1dBY1WB_c6o9MCd1cE9Sq5t9741pOAwe4t5Ky0oNpYsnRsBY3LFQNyTD_AsAvCJjgQYIxY1pBgFyLgbwEmDCbd41tE6tIvK7QS0Qfa0keEFKkyFfLR0cYY9xqF063EIvncipdCUV29vXZu5KqV3W7tAU6hDoGkNnpQ3Szjeib2wbvVCh9EyplapffM5oBr0BGoPV-_Ne7iUHv_SBcDCnHWFu2Spt1ZqIO6dENBvTsH2o2aU0WtzJ6KUuXU1ZAJMBMNoBwz2ogeHgSkdoBRqjHwaNArzCDaVo8OpdRrD1PqTGCCDWGqNEAxIPCTThDNBaKhVCdoKg2-cx1ErzgTEmOAqZPkZizDmfMiZTEA34L1HAgZqAVirLQegiAQArhAJgRQJY4rUo8MgIyjET7qBYrldiwMQCEaRsMJGl96LH2YqxCyZ9rKjjsjpSgjkkguVWx4A7R2PBZJAPFtAz2kwllwCwKAJ2QxalW3NtI6Y9JIA8KYxUSR4R_fwDGLg_h_CUrusOkAehiRQHQD9mHHcoB4Ox4QrN_2Yzvb3PNmAqh_yLcwMt-AoPofpgJ_4LHGBYCuShyAAAesMQYSMHEnZycDn7POIYeghu9vM7WUxph64gbMuYYAFlSLoc2hgHSoEgM0MbqAJvUCm7WGbc20BkpgPNSgnJtW0BkQ_JABANDcsp04dA8EkiUEEBBVAsLhOrcd87jwuUft6D7F0FwXPKe0AbFAQSeOWdJHe7Lzr8vMyK76yrxMWoqw69G0yfXyBKyG5rAwObrR5DQE0BBUUt1URrc-zKOUMAfutGlKgQMJ3EjSnUEhR0uk69K5cJT-As1G-wAfNWGS_undRY45QGosPZoKFW4P2fVPyCx_3ns3ryvKeYA3-mS8t0l_yBXxnqP6ZeqQ726hOmQPHf-uvwHtf8-_4QC53t6YaQTvYBcvWGsOY_4VAW-3Edez-w-ywh6wBl43Es0tgggl4_A0-geDesosA7uTILI2-e2qAMozeIAH22AG-NQmAq2NyIAuBmAME48TeqIe-3oHg0qMuiYcu3Waeq-eYnBQAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/viewport/post_processing/effects/dot_screen/src/index.ts",
        "description": "A dot screen post-processing effect is a visual technique used in computer graphics and image processing to simulate the appearance of halftone printing."
    },
    {
        "href": "examples/viewport/post_processing/effects/god_rays/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlqKMUGgA1pxWPBowUO4gcAQAnrBweDC2HnHxeIlgKYQE8nCIxsYArqjy0QDmOFRExmBQlADuehIwAAIAjDgALDgA7MboEGntnT19OERoLXBw-SI8YQUmOYLCOwbo6eE8jNOqXGmZMCldEOgEeIhcgwAMbwCkANxcORCNQgvd5fb4eU4Rci6VT8OBcB4pKGoGHrECsExIlEQkwXbEXeHoFI1CAha6wFLyShwCQQagvfh6OCUKA1Wi_AiUeQvUHgnFqbFwcgaCDyAhcDKKFJESjoGqwUkacgpOCK4xoTC4Aio9HGQXC0UHTa8PUisUqpUeMoVKq1epNFqUNodbq9WhDUYTKYzAhzF2LABW2pMJoNO2MRxOnF2xCgwhAABoQDMAEJofgadJIMD8KAuAC-ifNaow2BwWrIICoNDoBAYECIlI0YoAVFxYdolAA1LhgDSOrgAcn62QUMAummMqggMC6mgHYNQ9cbYuABR4ydgGF8dXI4mo8bXDkS_Fo0ng1P3h6FAlonenXWXB6NAHEZQAlfjpOAAUTAYBgu5PlYACSr7oB-X6_v-u5KDAkCLnuqBAaIADSmioEk0gQAAXjAyE8AACgA8tI3gAPoEW-REAMLftI0jAQAcs-ZHfr4vjftR5HeAAmgR36cHmPZ9kQg7DnIijjhok73nOC5LpQTZcKuRrXieMDUTUaSOp4ED4VwwHJpQzICKg36wDYND6cBSh9vI6DdGZFk1tZ0hRJgGjmTAlkEIJwn9kOI6SWoE5TjOmg4COiToDgmDSv4ORQIoGjzpwnAABSMLoJz3Bg3QAJQ4NIXZcK4HadguGWwukqDkFw6X5aVrDKYe1RHjeMBtlwYUPopvmqdQaTdfey6lW2XT8BI7XqXeM7LulKnxKImKwi8DnkDUPk4I0theT5ybpMB6DpR4K2oo17YABLeAAsgAMtR0KwntLmHlYDwvB4RDpLNvVNhsVh5vlC5WG1am0F1LhrLSqBXoNZrnjDY38BNU3gzAZ7Q9QC1vaI4jkNEtiILjS0eAAnAArPw_AjBTgyDBTYAAEx6NmbwwJTbz00z4ys2T5Bk2AADMZNMwL4wS6LMAjCM5AAGxi3LehM_wFMU-MdNC0LIxM3L5AjG8ctywI6BM4butk0LLOBOQgxk2TuTkIEgQU2TIx6Ho5BvEL_CBG8LsjPwcvoIbwvoHoEsU87bz8B86BgCMcsU07ejoELMAU0L6Cm2TbyJ-7dPy4LgfZiH6eBB7MB-2AMfjG8EfoALgRk3LNNC1CssawI_Bk-Mjf0-Mgzp4Mej8OQ6BJ286CDP4etvILYCBGbIxgIMYDkDA8_85g7uBMH6DjO7qsePpVjSpgUC_Z4GhQJ9IBWpU1RwOgGjjDANS2zg7_-BvNAaDm_hhhBTHCFDQDoiAnxJgSO-31MYXlhiAQ8QNKpGhRpNMUGEuhcAIiJGYMB0qJCZFAdQTUri2G8PWGAlBWQEPgMydQ8YuBvHysDNKA1UBDUaO-T8P4_wAQILBeCNI6QGTAhBXh0EBFwTQMI7gZVFpLS4PIOymhxDwBeAoxRohjDNlbN4HIXA9CbnQD2HciEuCUDAOKPAMwuBwUkTgeqmBsxygIC8DcdB0DblqohIq1E3zfm_IxRqzZjBQKsEYzx3jdww3ccY6JvjpD-MCYxU-iidGtgAOo5CeJoaxnUuEmP_l-K4eBqFQBMXoTqRiagaGiuKSgXBoof06umcQ2ZdxwEcelZx_BXEvAIBoGoMAQlhKNFompGgBlDLwuE7RuiuAAEFuA1HkMlQx1CMA9kUvkq4J5akniRpY3ZlB1D_ygFAOxfDdzdN6f014OBmFcFCXMng5AoD8AbDdfgWBgSPLSUtDJSzuDQBZMsVAhzqBcEwFCdIPYx4cjAU4uCfSoBuKYTgMmozXnQoAp-bkmKAXxCBfozqmAOESDhcc3JXAoiAjFMUrpyKXFooJS3bF4zFHkupBkNlcsiWgwWYshw8NdBihPLQVANRIXcCoPYiA5Bpw0FuSi-5bwcByw5Voqw2BKRwFqTAAl_KcUkoMZMrghMNAYUudSXCjjLrtlQI0-x_D4RWPNbY6YcAGSwBisy1F6K0JWswjhGARUbqLLundLV2qeCWutVhXCLwg0JtDeGyNd0BXzNbMKulhAmmfi4LOAE-aOmIpVSy9F6qRgxtjcW-lBKRhQILFAiUhrsEkXIpRGidEGLMVYuxTi3E-LfhwM-IiSgyJvkWTxaQ-k8wg2WvDLghTxFQX4d4SghM5HDTmn1HAeqCA4MoBvaGqBmiCHQOu3c6VV08OvVIoRiF8psKsFWIa1DyisjGlDeB21bBEVZPIVkB1GKfPwR4S6ikcLUDsFAIyBAOQQJAIVeCx1GmuGagAQkoDgMAikiAnhwGgd5NRMBwBOiAQjtBhQ5g8CwrDi6eA9WXAeqkR6-ynupOe7a3DILXK1AAbTvfxyRm7t0AF1Iq2DuiWgg0hqGKnwZ-4DBAcBOswFhl9sNVLHloJpbSRBdLpUE1AxgNk7IOS6E5byNZWCaO1RCmwd8PFbjMTDSBnKlptrvi_TkVmEFZp4NQaichz0aRzFAUeBMXjpRhCydtaRhTnsaphlqXntUiYkfwwRMjfHKM5Ko6ccAsM4EiW5nxSMypET0P6fhOB4vDIo65rx7nqD5UEwAakazACTbY4QtYSTDJjsbRAsf3Ye49XG0DNFWegdSD7b18ey7ucTdBGFZYfblhCMNWEZa0eNpsbG0hTcRjxzbAm4DCeWw-tbqApMuAILJ-lCnakb3Sip1k6mZQwC0zilt-3lplIVeorgNW6s3MJl-dKg22uoHykF7qOZhkvHB_VnrzX4lw8KuqbAREwBLfAvegT23ZEHpUU2YrpXyutcq9QP7GWAdaPM0ZEyugXo0Hszipz7aPCTM86N8U6RFB3wMGzwLOKQthZ2o9C50XoixZ6y8MXsBdCpeag5wXF3JGk_yxTtRJWyssi0GVHrI3BeHbU5NzjZ3Zv2QWwJwna6BN3Y2zdkn0idvtfN6Ny3x2OMntt7xonon-FXe1xurddAHsybk69pTH2gNfY0797Tgume--R-2iPMFPdk4K8lA31PjfNqJeZtyDxNAc4IFzwHPAee-boDy9IAvRs-a4B4OA7lNCt9jVL3QMvIvy8V1nl4UqiBVI0Or9LgurA58fXlmG5PCuU_gKV7llKxpm5xVYP31vA9nrt_N2gi35-u5Xe7nXefn0-9jXv9jp3D_B-d5I8Pl_I-Sek09uPin3ufbUyngzunojkrhfiHitgvl7qgMvoXlTrFE3pSojuCtyEgT8sCIjmkDAFyBih8IMKXmZsBBXh5NXrXoLg3h3iADCp-L3tqu3p3t3hoDQVov3uFrLlFmPArvVKAePpPtPprqNvPrrkvgXkVmvvAbClvlnrftqvfidjbk_nNg7pIk7sTmJlHkhGAS_jltfrttIQdiNBNg_vIdxs0PPm_uAbduoTHt_i9r_spkngAT9kAaNhnnfqPpoaodoU-sIfrnAVQekEgWgCgTioRr8q8BgbQNgeqrgfgRluXgwSQfwUtOQR4PWoQEwYonQakAwRkUtCwYPnLhwSPglmPptLwaQkkZlu_rnt4dQDAaIYbmkWKKblITvmNgYUdvvtNjxooSfo7mfuoW7hYR7rUfDnoYorIQHt0aYdUUJgMZ_o9s9oQPHn_g4d9ppmni4SAe4YIToXUSIavo0TAHJoEagMEXXlwKEegTipgVEY8lzLEczoQQkc5JzpUVYCkSALqlSAarkfEFkV3pXowQmJLqgKFgPhFoUTFlwe4TwZoHwW0TwLsaMfUYcaVt8fqokJIQluMUtJMY_iYTgL0TAKfrMefsiYvt7oibun9FbkYQfoSWYddsMWoQsbHrYW9vYV-o4Rsf9tsSUR4aHjUZSdAQcUXl_FgHqgaqcecYLlceETcZEQSjEYzmXs8UCYkdzuBnfO8p8vIN8lgH8VYACTkSCRcfkZCewdCXFrCWUfCRUdSRSVAaieKbqV8j8ticMrifEPicYTNkSfbn0cofMetoKRAUIVSRcbvh0XSXIQyf6UySGfdl_ksfJnYYntyesannyTiqAU6fnr4WIW6fqT8jKUwqgWEYMBEVgcqQ8aqQQbZP5o5JqRcZ8fGiGrhEaXjMLrzpQZZo5F2cFmCdLpacPjCQKXCVPg6VGaIPmXrivuKe2VAImp1C0TidSb6fGT0YGSSf0WSYMWGVtnsWMRuTGf7gSQmbMeYVoatlYSmT_pyRmaplmc4bGq4dqo4JQCDpUGDrVvVlDhRimh2SMvySjoeSMSKS6XAUuSuc2oeBJowutJtDWP-gQNXgdEdJRsSPRv1lwNdPdCoKoNXtpkDA1N8AmEmHAKmBChmFmDmPmImPIBwfwDtDgIGNQBWFWJKrWIgCAKuJQVgZ4nQIqvAB4MgB4OJKOFJDJOFMCcTCAELDgEzMMEzJAiAJJcFGcjJbOGAlFGOPAfFIlMlGJR4IpcpUpR4C2lRpNAgvJbjrgCwFAGpSGFqGJfxWkG0iZSAExUppcvZfgDGFwP4P4IVhLiAHoMSBUl5T5RvJchFdACYv5Y5ZZQeAJaoLBIoCWLVMVm5R4DFUkP4BFRgLAHJR4AAHrDCDBMw4AUxqVtouVeVlUUwei1UgB5h5gUUphpi0WIDZi5gwAFipC6DhyGAOioCQDNDsWoCcWwY1gMD8VoBPowB3TGTyDHq0AxLUBiWDLDKpVODgRJCUCCBETDkQnbUzKpU9ReV6B9hdAuDAmpW0ANgfK0DRXpixWWWdVUXdWZi9X0UDWJhahVgTVsVMjTXICVizX0C8X8WtDyDQCaBESigwyojiVUYyhygwBeWtDSioCBhqWJDSjqDUSOg-So19UuCpXwA3QY2wDATVh2TnW7Wd52HfLyBiUU2zICW6n_yIQc3_WpUwofK80wxs3839WPXpg7S-RIAeB0RyzOWDIKoy2IA7Vc2foqClWUHehqW6qaCUI0A5iwRUC82KSo1q1U3LBSIm0niKQ3S2CCAnj8BM1c3nyY1vh0Ish82y0gAp4pUeDYCkaYBiWma-0_ZkRu1ZBqVeoy0SYdWJhdU0W_Wc3tV5hAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/viewport/post_processing/effects/god_rays/src/index.ts",
        "description": "God rays, also known as crepuscular rays or volumetric lighting, are a post-processing effect used in computer graphics and video games to simulate the phenomenon of light scattering and creating visible rays or beams of light in an atmospheric or foggy environment."
    },
    {
        "href": "examples/viewport/post_processing/effects/grid/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlqKMUGgA1pxWPBowUO4gcAQAnrBweDC2HnHxeIlgKYQE8nCIxsYArqjy0QDmOFRExmBQlADuehIwAAIAjDgALDgA7MboEGntnT19OERoLXBw-SI8YQUmOYLCOwbo6eE8jNOqXGmZMCldEOgEeIhcgwAMbwCkANxcORCNQgvd5fb4eU4Rci6VT8OBcB4pKGoGHrECsExIlEQkwXbEXeHoFI1CAha6wFLyShwCQQagvfh6OCUKA1Wi_AiUeQvUHgnFqbFwcgaCDyAhcDKKFJESjoGqwUkacgpOCK4xoTC4Aio9HGQXC0UHTa8PUisUqpUeMoVKq1epNFqUNodbq9WhDUYTKYzAhzF2LABW2pMJoNO2MRxOnF2xCgwhAABoQDMAEJofgadJIMD8KAuAC-ifNaow2BwWrIICoNDoBAYECIlI0YoAVFxYdolAA1LhgDSOrgAcn62QUMAummMqggMC6mgHYNQ9cbYuABR4ydgGF8dXI4mo8bXDkS_Fo0ng1P3h6FAlonenXWXB6NAEkAOLC9AAUTAYBgu6UMCQIue6oE-VgAAoAPLSN4AD64EAEqQQAwp-0jSM-AByr6wZ-vi-J-yFwd4ACa4GfpweY9n2RCDsOciKOOGiTvec4LkulBNlwwBHjeMDITUaSOp4EDxlwz5KH28joN0qCfrANg0GJz7SFEmAaPJMCKWKVG9v2Q4joxagTlOM6aDgI6JOgOCYNK_g5FAigaPOnCcAAFIwugnPcGDdAAlDg0hdlwrgdp2C7ubC6SoOQXBuX5IWsNxh7VLxJ4wG2XCmQ-nEEFe1BpFl97LiFbZdPwEhpbexW5W5q5GlYmKwi8MnkDU2k4I0tiadpybpM-6BuR4TWogl7YABLeAAsgAMsh0Kwj1NZgfEPAPC8HhEOkd4zsuGxWHmfkLlYqXXulmUuGstKoPlqCFZdF7cKF_DlZVZ2nue111YeVjiOQ0S2IgP2rVwHgAJwAKz8PwIwQ4MgwQ2AABMejZm8MCQ288NI-MqNg-QYNgAAzGDSME-MFOkzAIwjOQABsZN03oSP8BDEPjHDRNEyMSN0-QIxvHTdMCOgSOC7zYNEyjgTkIMYNg7k5CBIEENgyMeh6OQbxE_wgRvCrIz8HT6CC8T6B6BTEPK28_AfOgYAjHTENK3o6BEzAENE-gotg28jvq3D9OE4b2Ym-7gQazAetgDb4xvBb6AE4EYN0zDRNQrTHMCPwYPjIn8PjIM7uDHo_DkOgTtvOggz-HzbyE2AgRiyMYCDGA5AwPX-OYOrgTG-g4zq6zHgrat0qYFAO1dJ4GhQBtIBWpU1RwOgGjjDANSyzgG_-B3NAaDm_jDIZY7GRoDpECPwNreg89bWeV3UPtoiHRFRpVoVjQft-v7_oBaA0jpOJd8Dwf5_gIABICgCnrJQaqIeQUlNDiHgC8eqIN4jGGbK2bwOQuB6E3OgHsO4QJcEoGAcUeAZhcEAr_AgOA4qYGzHKAgLwNx0HQNuGKIEcBTU8DNbwz5wIzRIglZsxhr7xHwewzhu5rqsIITI7hvD-GCOEaPdBoQsFcBwRlQUOYMpkIoRlL-DwuDyBPLQDQqB6FuUYfwZhwIcBvFEeIuBq09GwEcW8CRBYJEShgC8KCMF4JIVQuhLCOE8IESIrBUi5EcCvgQhJdReZjqiA_mKExX4fzgO8JQAGMDsrLhwJSNI4E-wdyuqgZoghsm0LclksBf8oEgSOq5d-x5aACSEkQESbkADaEjGASSkjJLockFI1lYGgjRPBUD8BsPPNhW5iHXSvm4-I_j56r05GMm6CYJFWGoMhOQ1T-I5igKXf6Lw3IwhZAEq4BBhTVISq4JKMzZlWEaTk5pADuEIM5Eg6ccAACEOApErK4ddUqkE9D-nATgO5NR4BuWWRw1Z1A_L9IANRIpgAAXTbHCNFijrppM-aIIpuUSlUgIOUyglTqTVJwDUaS6UmkEAad_H5BA8kFLEt82hkC_nXTaRsg66j0GOEoBASpLxYXwt3DgAG6Q4CooURi1AflJUgzxfKuFCK8VqpJZqgK6psCQTAFy0BPLhXAWuiUxBTZgVgoheiqF1AQV-R8Tqs4Kk1KaCWjQaZhzRDzMWaDVIUJ5QHPFaILZka4ABo0OsilxzTldXmlAS5Zdog3L1VwVA7U9CaFee80Nq1BXgLtdAx1gLnXwDBR4jKoU8XkopUVXa1LSl0oqZ9ZlrL0Dsp5daupuT8l0AFdyoV_97WYvbeg3xcaeAFqrb8ud1iAVOWQaCiy0aYC-viMsVA3JD1WCIPwLALwkZntEGkGAXIuBvCcVjHxh58ViVau1GsnVuqTJoH1AaQ0QDEg8GNOEk1ZoqFUEGgg3rUCHXit8BMSY4CpnmRmLMOZ8yJnMf9fgXUcCBmoBWKstB6CIBAKuEAmBFAlhisCjwyAPD0VHExFiZkU1IA8ETHASNhhIyviAVjRl1DMWyuZSyY4bJaUoPZJITkmM8b4wJjwviQAXrQEppMJZcAsCgEJkMWomPUbSOmPK3GQDmMVEkeEun8Axi4P4fwgL9kHhAHoYkUB0Daesx3KAeCvOEPNXpmMan3OYFUABOjmAGPwBMx4PzSR_CeYwLALjQMQAAD1hiDCRjgCGQn_FGe01liGHpCsgDzHmFDKY0yYcQNmXMMACypF0ObQwDpUCQGaMR1ApHqDkdrJR6jaAWkwBmpQTk9LaCyKfkgJ5yL3NOHQAhJIlBBCQVQCc3QXUmOLYPR4bK2m9B9i6C4Lj7naANigOlXz6Z_Nqdq2h-rmZGvYZa4mLUVYetEaZP15AlZBs1gYNR1o8hoCaEgqKa6qJmMaZlHKGA2nWjSlQIGITiRpTqGQo6bScOmsuHc_AKaiPYDPmrFJfbGglseCZDUGzU0FBMcJ4dmjf5bsHxAizj7EWOfphPNdJn8gefNau-mLqFnMtoTpoZp5sqpcHfc5QVkKgMseGmGkIT2AnL1hrDmACVAuecTh0rjwWkJCG84ieTiU1bCCBPPwantOEeylgGtpkLJueWdQDKZHVXidYHICyTATHBkgF95gWC48keogi96Dw-KauJjqxht7rPqt5iAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/viewport/post_processing/effects/grid/src/index.ts",
        "description": "A grid post-processing effect is a visual technique used in computer graphics and image processing to overlay a grid pattern onto an image."
    },
    {
        "href": "examples/viewport/post_processing/effects/hbao/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlqKMUGgA1pxWPBowUO4gcAQAnrBweDC2HnHxeIlgKYQE8nCIxsYArqjy0QDmOFRExmBQlADuehIwAAIAjDgALDgA7MboEGntnT19OERoLXBw-SI8YQUmOYLCOwbo6eE8jNOqXGmZMCldEOgEeIhcgwAMbwCkANxcORCNQgvd5fb4eU4Rci6VT8OBcB4pKGoGHrECsExIlEQkwXbEXeHoFI1CAha6wFLyShwCQQagvfh6OCUKA1Wi_AiUeQvUHgnFqbFwcgaCDyAhcDKKFJESjoGqwUkacgpOCK4xoTC4Aio9HGQXC0UHTa8PUisUqpUeMoVKq1epNFqUNodbq9WhDUYTKYzAhzF2LABW2pMJoNO2MRxOnF2xCgwhAABoQDMAEJofgadJIMD8KAuAC-ifNaow2BwWrIICoNDoBAYECIlI0YoAVFxYdolAA1LhgDSOrgefrZBQwC6aYyqCAwLqaDxg1D1xti4AFIUCWjSeDU6jx1eJfi0TtTrpL3ciACSAAlkwBBADyAFEwGAYOQCEoYJAF-IdwUAAp3tI3gAPp_gASneADCD7SNI54AHIAOLAQ-vi-A-kEgd4ACaf4PpweY9n2RADiAQ5yIoY4aBOx6ziA86LpQTZcCuIhrgeMCQTUaSOp4EBnjw56QcyTEPrANg0AJXDntIUSYBoYkwBJBAEUR_aDsOlFqOOk7TpoODDok6A4Jg0r-DkUCKBoc6cJwAAUjC6Cc9wYN0ACUODSF2XCuB2nbzvZsLpKg5BcHZbk-awLEFNUDj7rQbZcLpJ5MSpbHUGkSXHkuPltl0_ASHF64wEe05LnZrFWJisIvOglDkDUyk4I0tiKcpybpOe6B2R41WohF7aXt4ACyAAykHQrCbU1lJPAPC8HhEOkpUpU2Gw8HmbnzlsxhFRxiUuGstKoKuGVmlux25fw-WFexG4XdQFUFDw4jkNEtiIM9ogePw_AAEwAKxgOQ6BgIMgz8OMgT8AIoNvAAnOgDJvHo_DkAAzPwABs5AAyM8O_Vj8MwADbxgETeh6IM6MjIEBN_Tj6ODPD8N6PD6OYJT6MwOM6DowD6NY1j6Ds_D7xgyM_BvCMIx_fDz56OMz6BLLpPw4E6AA-gmsy8-BMY9zgzjIMMBY-jeia4M-ODGA6N_XTMCA_wL5Y5-6NvOg-N_e7wsjGAf0jBjIOy0TuNY4EWNgHT5DkH9egjOgf1S-MIxs6zYDoIEAeCJLegwFngxYyM_ja4IROy-jvMwBD8cwO7ggvoDMDwwDdeBMECZfdKmBQCtngaFAC0gFalTVHA2swKof04DANT-OQNYaDm_jDJpo7aRoDpEB4s0EkPS2bkd1DrVwm0BelqCZXgqOUE-L5vh-X40nS0nXved-vu-n5oM_3C-ZVoh5B9isuIeALwAFWGMM2Vs3gchcESEyFkP5uCChzDALglAwDijgfwIgvQawYJjiybcqAcBhUwNmOUBBgQRWbMYL6CR4DMlZMdaQUJYDAl3lsaBXBYHoLgLg-QWRsEHjbIkcU_B3rcCslweQEAsBJHFJQBwjp5CsnQU8dBuD8E0EIeQYhx0yF2QofwKhLxAi0PoUaHgcB5Bci4IELhoQeHCRoH2XM2D0FL2mNxXUEAABe6DMGeLbHgqcuj6r6O4pdNAXAuhMSgOgLgdQJBwCMSYsxXA_qWIYVwaYaRdALxeH9JxUDWyuIIO4uEeBug9lhGKTRoSdFikiQY6gdTMBwmuvwdIcSJB4Dyd6Qp6DYnxIHkklJWp0mflMVAahrwcnWMGQUkKMBzzVkvhIdInDcllK4DeWRNREhQF6emcQaQIChSrJU5kPYmIhLQLQTZGQMFYMafeLg_h4F1DhI0_gyinh9hqICEJYA6hvkupSLodl_nxnhBs6kGQ3Jwq6HgS5Ay5C_LgZ-e-LSsFIw0FItAjQxECDhPcJ4XBpTiO0eElpRDonUGmZQuZLwAaLPiPCp5iLtlcABqUnhfCVGdC0MEv5YSCGtMZaQ8hMzMl6CgGjaIHL4hUBFUPAAxB8bVbwd67MFXA3o7YniiJmMklwSSwD3MaTiz-8K4kJImd-NJsqWXzPeCqqwRrKivDeAKmBcCniXOiKgLc8I3k4IlREhlJCuC2rfMy2Z8y3g4HZVwOhuSg1vVDWsbkqazz6oDeg1AjU86iqwX0JeyC4RirgZgVAlAZjEtkbCF1xi5WsoWemqxnLK0HmOj6wY_reFwO8RAbiryQmUhmEybg-ToiJsyYMNNGallju4sCflhaR1eOJTWiN6Dp1rHafOxdnaRietEMKVAjQfUjGHTeKA8xfnKMEP6biDS4FoA6DUOgC9J2NJZEQew0xnyaD_SM7gjT62NupDeltawz3ureJengQH-B_jRcCP127H3PqUW2dA77MqNO_SyCDAG60wFFAM0DL5EirPtdBugsHm3yFbUh4pqG8nUaeJhiAxSH1Pu6C-wjxHP2QZ_RR2txamLAagIMsDDH_2xOYw2pt8H2OIddUml46McCA24w2jQ8n-N6YM1upZeyhUCIbMIk1Yp0zoO4qOJjcCj2zuWQunTS6sbcds0IsBrwsZfQLF9CUMAXgASAqBCC0FYIIWQqhdCmFgI4TwjgN-d4Ch5m2ioy-Ypr7_I_m-bwlApG5WSkuHAlI0h_j7AvI6N6cCCHQCVggPUjRFdvmBh-39vzHQKFtWybF4qcQ_bxCAnWrAAG1cmMBknJTQ00aCsAgfEVAuDIukQQcw5BbC0F6qWS9dIigh5wCW9ZTux2MGoEgnIG9nEcxQFRm9F4dkYTkZeCWvBmgIquCiutzl3X2uPx_sgmrwDNCgLgAAQhwLtpBrD2HoN8p939eXOU8Cq6lGrVICD1fqhdZrNR5BI1oO16bWOrAg96wQMrUinHA5vqD_rv9clWGGzdsLN30fbdp7isHA2mVAM5NDqccOEdMKR9QA7sAmdUrQHmodHOqX8CwDsm7aRqPK9yTzzlC3ZIPGW-JGsa3VebZsOduxR3qcRfO5d23WPqD3d0C1CaT7XvRHe3z77pa_uRWijdngVZEEwBwJ0RodkIvBL51z6nPABefyF7_SHYumwS_h7Y-QuUADUfPMdY5x02PHdWGvE-aKT8nMBKeq5pyzunDO6AK_r8VunKfkF164PHrH-ui85l_S8JPfWn4Q9FyAzPBk7EK-WKgTX1PgMa64EXBX2v7GDD104w3l2VsEHNzdy322PD5LsKsp3nL7ekQu8bq7CuXcPfd89r3PuB_bZ-2W_7gOu_D6_qPwx4_xd4B4cT9hlKtX9C9OVi8CBS8Cdy8mtK8ycOJa9g9RAf8m9UAW9UCG9Bc2dO8UCe9OU-9IDX8h9sDk9cD_8ocM8gCTIhlVkZ8lcuAU0VcbtF9sNV9aB7EU0PgN8lkiCIhFsb9d999qdD8h4QDVl1luUtlz94hL8PBr95JZCrB783cntPclUX8vsuB38A8Acg8E8_gyCR9wdKD08YdgC6CF4pC6AeUwDyMID4goCYDCdGs4MEDq9kDDDE9jD6dytm8u8fC28cC_9j58DHCNoFdfcjDgjyDQjSEADqDJcJDrCEUtkGC58mCZ91dBNVc1880eDN95tBD5JhCgdRAxDSJHlbCZDrs7dTsj9UhHc6jnc7sH91CXtNCwpojdCNBP8DCE8f8O8zCJ8aDqjnlek0dwCu9nDatYCid4CcAq8kC6cqdDC0D_CMDAiYiesQjTCwjDCCD4h-CrBoihiKCRcqCLCcBxieUMjuRsil87YOCdcmCcBCi-Ct8SiTclIzdyieBKiPBvVlDRB5Cmib8QSeBVDHsPdOi3tuiSCdD_c-jA9_isDYiTDhcEirjJ9vV7CMcZjspcc5jXCK8ljECKdVjtiNjGdqTfDhiDiE8jirATjRAzj6SLjsTzDcSIBYR7isjVc2DfUcMtdOCCi3heDCCvijdSjTdVs0TASQAs0Q0txITxQGiHcISWjOVoTH8ND4SPtETej-i0Sgjdi4j9iuTRjJdlSc04QpiHDCSypiT8dSTFjljKTcU1jBjfD0DMCzTWd4iu9mTRBWTsdETzj4i09rT4dbStx-SRSF8cjhSXiuD3iJSiilkFthIRUyiLctsh41UmI1SwSizb9VddSOjn8ETtC0hr1GgTTv8OSozEjriyz8SYAIi2SiSS8SS4D3DyTPCqSUCAzG9Nj_SdjAzLTgyuywykoIzmzLTozADJcyzMyDdviFI5S98FSCyqjaAq0B0SyNSr9mi782i1DYTqzDTtDjTUSmyMTf8lzWzJ8-1q0OyuzscezoC-yFiByPSa9hzvDJyxzaSRyQK9isSZzVc5z2THyGSrSVz4c3yB0EzHi9NUzgR1z4ht8hDtyRCsdFT11UQFcwTFC6JzzXcYSn8uibzB8kTfsUT9DTSIKLSsTlykj4diKPynTVofzXT-ziVByVivS6THy_SxLzTMT2dwiYKoiFz4LOSOLrjiK0LBTkzni8ixS3iPipTiiZSfjlICLOUiK91jyztTytTKL2irzaKejkTGyUDIznycSaD6z7T5zHSUDZiBK_yhKAKvDvCaSAjwLnKoLZLud5LtCwrU8Xy3K901LWDkzC5MLXhsKrBcLZTfj5T8yrdSJ0N-NzLGjyLyybtKzbKDT7LGLHL1jFz2K4rJcCq0UeLvLvyXDBKScKTALRLQrfTxzJKpzwrDjZyor6KYqx9XLGrGoMM0VEqkyl8_pEysd8idKMzPiRsNyDKtzsqdzcrGjMAaNCrtS5CTyFCzyKyLzqL9Tvcaz6K7zmKHypKnz6rJrgDeM8B-MWrDCfKy8_LOqhyergLgqtjerFKgyIrqdYKFKnqELlLJ8Dq-NZrBTGClrOUhTFrUruC1q9KToszNy8yD89yPBjNTM0UirNSlDjqVDLq9S4Sbq6K38HL7ynK6rYrXqcASacxPqHSCTWrnTezfK3D_KurArarxL-rQaYbOToLIrVc4KpaWz2bOaoB-M5qschTSZMb0zJTjiC08atqCbRCibUhBEshybLLKbrLLyaLKqjSmaHqWawaXLuSaCAthEebOzeLqtfyhb_qRLP5vTqdgaJzxrBsIbe9Rr-dWaJqXbJc3b4A1a0aNKSktLXidaWSvoABdXeOqBqJqFqAgXfDqLqHqEAYkDwAaOEIaMaFQVQXfIbecTacKecBMJMOAVMTbDMLMHMfMRMdjN6fgFqHAQMagCsa5GsBgFcEAA6ugetcgCXDwZADSCidedQaiZKOiT6EAfTP6YYP6PVMiNeKiGiPSTeQyUcEyJSSgcyJIKyRejwHevejwMLEAYDNAe-pMEsXAFgKAA-kMLUReqegpNaJADwdjRURRdUUsH-z5fwMXE6TuEAPQYkRJD-8BheBTZB6AJJKB7-mMZ-3caeyeD8RQEsEKBesgMB9MDB_wZBjAWAK7LegAPWGEGGngBgPoi3_o_qYYBg9A4ZADzDzFbpTDTC7sQGzFzBgALBNv0EMAdFQEgGaBHtQDHuoCeVrEQBACnu_XBxgFGkoE5EJ1oAhWPiQEqV_UIacHQDAiSEoEEDvBppgEXosZgEIeSg_r0D7C6BcHLKVKUiEQ4jQeoaSGfpEfbrEczAkZ7ukcTC1CrCUeHtnTUY2U0e0d6lUWgE0DvFFCPModfplDlGcdAcrEdGlFQEDAPsSGlHUGEiIGUlRGiakcIfgGGkKdgBsOARcY0EsYUMoCOQXmGgUEXskZcEIcwH0XTH7TMaabGeP1fEVUPOoCGfkBGZicIbsA0ALo_pghC0QbrMuRUnMZ6bcY8H6ffAgEYeP29APuwCsnrBrBzA_CoCrSYkadcZaeWC_heYPCYmGlsEEAPH4G6d6YKdlFgFscQRYRmeJplGKZfuwCiUwEXrmxAAbUwGAm7iKZIuubSA8EzuEcTFEc7qidGekaEaAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/viewport/post_processing/effects/hbao/src/index.ts",
        "description": "HBAO stands for \"Horizon-Based Ambient Occlusion,\" a rendering technique commonly used in modern video games and computer graphics to enhance the visual realism of 3D scenes. Ambient occlusion is a shading and lighting technique that simulates the soft shadows created by ambient light in the environment."
    },
    {
        "href": "examples/viewport/post_processing/effects/hue_saturation/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlqKMUGgA1pxWPBowUO4gcAQAnrBweDC2HnHxeIlgKYQE8nCIxsYArqjy0QDmOFRExmBQlADuehIwAAIAjDgALDgA7MboEGntnT19OERoLXBw-SI8YQUmOYLCOwbo6eE8jNOqXGmZMCldEOgEeIhcgwAMbwCkANxcORCNQgvd5fb4eU4Rci6VT8OBcB4pKGoGHrECsExIlEQkwXbEXeHoFI1CAha6wFLyShwCQQagvfh6OCUKA1Wi_AiUeQvUHgnFqbFwcgaCDyAhcDKKFJESjoGqwUkacgpOCK4xoTC4Aio9HGQXC0UHTa8PUisUqpUeMoVKq1epNFqUNodbq9WhDUYTKYzAhzF2LABW2pMJoNO2MRxOnF2xCgwhAABoQDMAEJofgadJIMD8KAuAC-ifNaow2BwWrIICoNDoBAYECIlI0YoAVFxYdolAA1LhgDSOrgefrZBQwC6aYyqCAwLqaDxg1D1xti4AFZOwDC-OrkcTUeMFIUCWjSeDU3f7xL8WidqddJd7kQAaU0qCS0ggAC8YPeeAAFADy0jeAA-j-ABKf4AMIAKLSNIACSAByADiQFQb4vhQRBwHeAAmj-UGcHmPZ9kQA4gEOciKGOGgTjes4gPOi6UE2XAriIB6XjAEE1GkjqeBA35cHByaUMyAioFBsA2DQglwUofbyOg3QSVJNaydIUSYBokkwNJBCEcR_aDsOVFqOOk7TpoODDok6A4Jg0r-DkUCKBoc6cExLHAEJa6iUQUFgGAMDbkoMCQAuO7cERvZGeRJmjmZNEWTObkMZwnAABSMLoJz3Bg3QAJQ4NIXZcK4HadvOmWwukqDkFwGUFWVrCsQU1QOBetBtlwyVLvu1BpD1N5LmVbZdPwEgdYeMDXtOS4ZWxViYrCLxKeQNR6TgjS2DpenJukcHoBlHjLaiTXtgAEt4ACyAAyEHQrCu1qQUPAPC8HhEOks23sx-kgAUeYFfOWzGFNnHdS4ay0qg_WoINUOntw5X8ONk0cUeJ4wwtr3ihA5DRLYiC4zwHgAJwAKz8PwIwU4MgwU2AABMejZm8MCU289NM-MrNk-QZNgAAzGTTMC-MEuizAIwjOQABsYty3oTP8BTFPjHTQtCyMTNy-QIxvHLcsCOgTOG7rZNCyzgTkIMZNk7k5CBIEFNkyMeh6OQbxC_wgRvC7Iz8HL6CG8L6B6BLFPO28_AfOgYAjHLFNO3o6BCzAFNC-gptk28ifu3T8uC4H2Yh-ngQezAftgDH4xvBH6AC4EZNyzTQtQrLGsCPwZPjI39PjIM6eDHo_DkOgSdvOggz-HrbyC2AgRmyMYCDGA5AwPP_OYO7gTB-g4zu6rHiCTw0qYFAP2eBoUAfSAVqVNUcDoBo4wwDUts4O__gbzQGg5v4YY8VqIOiICfXG70yJfWPNDagGweBAyquxAaYo9CdEdAFIKIUwpoBpHSHy6D_KBWCgQUK4U8HI1akaeQClNDiHgC8Ra8RjDNlbN4HIXA0F0HQD2LckUuCUDAOKPAMwuBhSwQQHADVMDZjlAQF4a5uGbjqpFHAABBJQSgmrNmMCTTh650DKO3DDBRBijGqI0UoU-ogWFsI4Wgvy8JqzwwkOkKRGUZH8DkcCHAbxtG6KNG9Zx1IMg-LeNYrYrCuDsJgPomoWhCYaBfFAK4H4YDuM8d4rgT4kmvjSTgW6ajQJISgv4vRiTklvk_C8HJlT8mFOKVBCJoQokQWoAQPsuZhGxLgNKSgTwXxrAEUIp4sSWTLFQLoDewjEjZGZHZLgoFdDbXhHCAA2uE14ABdDJYUvFQHkVwN4vimYUzKYErg4y0x1RgNIPpTw0CNG5CcimzTbHRI4VcyZNyZnwDwPMqRSyZixIeXCGELIQWUC4EQWE0QBGsi4OgdMiSxGqRoHCNA3Sri_3SYs5ZsTREbPjNs3ZsiDnPLJuc-IlyNrXI3uw2Z_yoDoApW8qJUFJlcLhMxRFMwGRZGhSKGF8g4kaFJfsw52ZcwwCpfEZY8hhVrniS8KVLhcYFlxhKGALx_yARAuBaCsFEIoTQhhLCQFcL4RwMmW6f4_zXUBiDBwKD9F-UwSQ7wlBCaUN6n9HAlI0g_j7BvaGqBmiCHQO67cx0jQOIwcQ7B5DIoFGBuldinUuI8Q5EQfiMarBrL0YwOSCklJdBUrpGsrAmHUsmTYO-iiNx8JhuAi5PAtV3xfpyUtsMEx6J4NQCCcgw1cRzFAUeBMXgZXBTUbVVwOmPKaq4Fq1bqWuvjRIshuDVE0M5HQqccAACEOAuGNpUTDUaf49D-hITgad8A82rqsA2wxTa4GttEAVNZABqO9Wy2xwmfeYmGTrH2-qbP6qkBAg2UBDdSMNOAaiKU4lGggD7H08DjUQiRnrvXNOpZhlDm6IrNvfTwVN76NXvscJQfGDCuCXuvduHAhN0hwAyoB19qACp4Z6jmGdLwGM3rvWxjjZ7qBFXVNgP8YA0OroIwm0hODiPUH9bQps-6j0npfWJ1AB6-1cAKnoyj1Ki0iTEroZ6NAq36drbOz6QqFBKtSjx9tZEDDmZ7TxgdQ7toPSgGOse0RJ13peO52AuhF3Lv0xhwhhGlMUNU7u9T8Aj3ysVSyLQ5U70gdXWByRAaoPBqxvBxDSLaAodk4--T2GvV0B41YarJCiMUOiwZnLVhjO5b47Oxriat0w0S65ehh6lgOfkE5ozzSi0aQeJoSzBBrPvts3fNAtAXEZBbY-1zHg4CaXol51Ag78V-YCxOhqIWuCoA2noTQkWqHobXVhpr8Xt1qeG0e1bdAQnpFGtl1reWIOBqK6G5opXkMKcq3J2LCmcN1dazFt1CnmvJtI21_TnXqUXd64ppNA2d1DY0zgT7630g8YmdyMn_AsDAnCfptIMAuRHN8YMSbha4Iza0vNxbj7ltkS-VM259yRFhs26u7bqQ9vOf09547o7x1BfO91l4V2iA3Y0Hdld-Hocbpe3jt7hP-c3LuaJB5Ybfvdfa_EAHBXoOwceQhpD5WIfw8eyh2HqB6uiGx8jkjD3yOPox1bpXruke65U_jvdKWcCG43sb_pwvGhk7QBT_TMLqevB4_TxnxyPgs4uYHs47PJdc816IXnHgY8wAZX8-ZovqXi927NqX76ZfDpO_L4LweVdq416173YfUCDcjyNyv1e5nMvNxCy3VhreQdt8V0HjuYAVZd9j93nuEfrue7jt9fvp9cAL6ILH2vt_9fD_rqPo-ig1-ZUn1AKf31p-BJn2g2ffFc1Zxcot8ku3KRLzZ_gOtNzDLLgfwLgCpPJT8OveIcXTtRSZSaAqwVvXzOXQLTvCFZXa7W7Zqe7dDfvHfQfCPZLEbCAqAKpWJLLC3f7YaP1G3YHODRfMrZfZ3VHTfJ7bcdfVfE_PrZTWGVHf3VdQ_HgajWjSoejK9G9FjNjWpSAmVHjY_RHHXAgofYgo9Ug8gozXGLZaxNaDaGsLaHaNFAgfaQ6Y6EAYkDwc6OEK6O6FQVQebFNecIGRqecBMJMOAVMSZDMLMHMfMRMeQQLfgbaHAQMagCsKsNbWsRAEAFcEATARQEsOqfdDwZAYySiBKdQJKOiVKYmEAIWHAJmYYJmcBOKdI6iWiSyMVGyUceyXSSgJyJIVyFIjwfIwogojwDVEAGFNAZopMEsXAFgKAEokMLUFI2ItIdMf6XIgIxUJIJxDUfAGMUA_wXdTzDwPQYkZlXomYjeFJDY6AHhSTAYmMDovcOImAVQUKBIzAJI-AMYjwHYpIfwDYjAWAHIjwAAPWGEGCZhwAphKK1RGN6I-Ipg9H-JADzDzDcJTDTG8MQFVRgALFSF0HDkMAdFQEgGaFCNQHCPaRrAYFiLQCTRgFulEnkGg1oGMTgSQA6RnTOKcHQFAiSEoEED_EOx8xgBSNpK_A8GSl6L0D7C6BcClxAFoAbCgE4m2PTF2I6OhI8NhMzHhN8MRMTC1CrExJCKZBxOQErDxPoGiNiNaHkGgE0D_FFBhlRFSK6JlDlE5KQBOkdGlFQEDBKMSGlHUDaSID0ktIRLOPgGuhtNgDgmrAUi5I0DpJ20oHiQ3mugUBSN9I8EwHIAlP_mTR8OlTOKTJTMvBhljPkHjOVLOLsA0G2imI8BgjlmGPnW3DDIjJACjNIQgHeLiO9BKOwFcnrBrBzFCioFTOYktO5L9OWEU17MvGYmulsEEEvH4FrJ5OtNlFgCZKZBZDTNyNQBlDtM6OwGTJqEwBSILRAHXMwCAnPltNREzNbJAC2ShMTBhK8MVIRMhLzCAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/viewport/post_processing/effects/hue_saturation/src/index.ts",
        "description": "A simple hue-saturation post-processing effect to adapt the hue and saturation of the output image."
    },
    {
        "href": "examples/viewport/post_processing/effects/noise/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlqKMUGgA1pxWPBowUO4gcAQAnrBweDC2HnHxeIlgKYQE8nCIxsYArqjy0QDmOFRExmBQlADuehIwAAIAjDgALDgA7MboEGntnT19OERoLXBw-SI8YQUmOYLCOwbo6eE8jNOqXGmZMCldEOgEeIhcgwAMbwCkANxcORCNQgvd5fb4eU4Rci6VT8OBcB4pKGoGHrECsExIlEQkwXbEXeHoFI1CAha6wFLyShwCQQagvfh6OCUKA1Wi_AiUeQvUHgnFqbFwcgaCDyAhcDKKFJESjoGqwUkacgpOCK4xoTC4Aio9HGQXC0UHTa8PUisUqpUeMoVKq1epNFqUNodbq9WhDUYTKYzAhzF2LABW2pMJoNO2MRxOnF2xCgwhAABoQDMAEJofgadJIMD8KAuAC-ifNaow2BwWrIICoNDoBAYECIlI0YoAVFxYdolAA1LhgDSOrgAcn62QUMAummMqggMC6mgHYNQ9cbYuABR4ydgGF8dXI4mo8bXDkS_Fo0ng1P3h6FAlonenXWXB6NAEkAHKUGYwACiYDAMF3SgwJAi57qgT5WAACgA8tI3gAPoQQASlBADCX7SNIb4AOJwV-vi-F-KHwd4ACaEFfoeeY9n2RCDsOciKOOGiTvec4LkulBNlwwBHjeMAoTUaSOp4EDxlwz7JpQzICKgX6wDYNBic-Sh9vI6DdLJ8k1lwVG9v2Q4joxagTlOM6aDgI6JOgOCYNK_g5FAigaPOnCcAAFIwugnPcGDdAAlDg0hdlwrgdp2C7ubC6SoOQXBuX5IWsNxh7VLxJ4wG2XCmQ-nEEFe1BpFl97LiFbZdPwEhpbexW5W5q5GlYmKwi86nkDUCkEDgjS2HJMAdcm6TPugbkeE1qIJe2AAS3gALIADIodCsK9R14HxDwDwvB4RDpHeM7LhsVh5n5C5WKl17pZlLhrLSqD5aghXXRe3Chfw5WVRdp7nrddWHlY4jkNEtiIH961cB4ACcACs_D8CMUODIMUNgAATHo2ZvDA0NvIjKPjOjEPkBDYAAMwQyjRPjFT5MwCMIzkAAbBTDN6Cj_BQ1D4wIyTJMjCjDPkCMbwMwzAjoCjwv8xDJNo4E5CDBDEO5OQgSBFDEMjHoejkG8JP8IEbxqyM_AM-gwuk-gehU1DqtvPwHzoGAIwM1DKt6OgJMwFDJPoOLENvM7msI4zxPG9mZue4EWswAbYB2-MbxW-gROBBDDNwyTUL01zAj8BD4zJ4j4yDJ7gx6Pw5DoC7bzoIM_gC28xNgIEEsjGAgxgOQMCN4TmCa4EpvoOMmvsx4a3rdKmBQHtXSeBoUBbSAVqVNUcDoBo4wwDU8s4Fv_hdzQGg5v4wyGWOxkaA6RBj6DG3oIvO1njd1CHaIx0RUaVaFagH4uD-f4ASAmgGkdJxLvk_P_f8BBALARAS9ZKDVRDyFUpocQ8AXj1TBvEYwzZWzeByFwPQm50A9h3KBLglAwDijwDMLgQEAGdTipgbMcoCAvA3HQdA24YqgUCihRCX4vyvgSs2Ywt94hEM4dw3ct12HEOkbw6Q_DBGvnHlg0IuCuAAHUchPE0NQjKP9PxXDwJQOUJC9AZSIKwkUUQxxcHuE8Ax8J6isgcMyTicJkG0i0ByQhxC0DNCYUBfgrCXjZlzDAERYjEHrWQX1Gx8goDpHCTmFw4iCziIlDAF40FYIIWQmhDC2FcL4UIsRMiX4cCvigs-aQFEjR5nut_X-35fxQO8JQIG8DsrLhwJSNIEE-xdxuqgZogh0CQN3G5Ixf92mANgaBE6rlP7HloAJISRARJuQANriMYMpVS6kuiaT6jWVgmD1E8FQPwGwi8OFbjIbdG-sT4jZMXuvTkxy7oJnEVYagKE5BjP4jmKA5dAYvDcjCFkOSrgEGFGMhKrgkqXKuVYWZbSGEwOAbw5BnJUHTjgAAQhwJIx5PDbqlSgnof0UCcDQpqPANyDyuFPOoH5HZABqBlMAAC6bY4QsoUbdU6aKrC9Nyv0qkBAhmUBGdSMZOAahqXSlMggMzWlqs6d0sSGK1XYpArdZZryjpqKwY4D8IyXjUtpbuHAQN0hwGZfItlqA_JmrBjy61NK6U8qdUK11AV1TYCgmADVED5nQKAYa6g_SUFNkJSSslrKKXUCJX5DJHqzgSSkrAXQK1zmovUTcu54MQDxOsVAcQST0gvLFe8stBhpK6DrWigFQLuqLSgGCiu0RIVesIbmmSSKUV_LBnqyNBq4FxvxQm-AJKK2JOSaVHloqxU8AlU2KVgzhnfUVcq9AqrI3hrmQw7VdBdWasndGuBxqxWZJNaIAdE6sU3txfGtBxK40JKrbY2trymlGl5WJVq7UaxdR6lpGgA0hojRAMSDwE04TTXmioVQBaaAZtQMdeK3wExJjgKmG5GYsxpJgAWctvb-DdRwIGagFYqy0HoIgEAq4QCYEUCWGKhKPDIA8PRUcTEWJmQ0LxjwJMcAo2GCjG-IABNGXUMxbK5lLJjhsn1Sg9kkhOTEyACTUnJMeEySAIgFUfkgyTCWXALAoCyZDFqXjbG0jpjykgDw8h0xdygC4jU-AYxcH8P4fFPyDwgD0MSKA6BdMecVEkQhEWSHBuszGIzoXMCqEApxzA3H4COfc55pI_hwsYFgKJtzIAAB6wxBgoxwFDWT2T7O6Yq1DD09WQB5jzPhlMaYSOIAifmQsuhLaGAdKgSAzQ6OoAY9QJjtYWNsbQIsmAc0pLyFlbQGRL8kDwsZaFpw6BEJJEoIIKCqBAW6G6rx3bMBQvZV03oPsXQXBldC7QBsUB0rRYK7Zjr3XCO9czP1sjFGtRVgm7Rpk03kCVlmzWBgbHWjyGgJoKCopbqoj4yZmUcoYC6daNKVAgZZOJGlOoFCjoOqY4G7djw8AZo49gM-asqlrsaD2x4JkNRYszQULxmnaX_yfaPqBfnZHBfkGFyeW6vP5Bi8iW99M3VXMWfQgzOz8KIC7jZxzkAZjoEQDKxZ6YaRZPYCcvWGsOZAJUBF54nXtOQB9QkDbziJ5OIzVsIIE8_AHehcnrjo7TIWSi_Kz_TAqW6dYElzUCPSA9kgHDzAOCAesiyZN653lXXEw9eI0DmnnW8xAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/viewport/post_processing/effects/noise/src/index.ts",
        "description": "A noise post-processing effect is a visual technique used in computer graphics and image processing to simulate random variations in pixel values, creating a grainy or textured appearance. "
    },
    {
        "href": "examples/viewport/post_processing/effects/outline/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlqKMUGgA1pxWPBowUO4gcAQAnrBweDC2HnHxeIlgKYQE8nCIxsYArqjy0QDmOFRExmBQlADuehIwAAIAjDgALDgA7MboEGntnT19OERoLXBw-SI8YQUmOYLCOwbo6eE8jNOqXGmZMCldEOgEeIhcgwAMbwCkANxcORCNQgvd5fb4eU4Rci6VT8OBcB4pKGoGHrECsExIlEQkwXbEXeHoFI1CAha6wFLyShwCQQagvfh6OCUKA1Wi_AiUeQvUHgnFqbFwcgaCDyAhcDKKFJESjoGqwUkacgpOCK4xoTC4Aio9HGQXC0UHTa8PUisUqpUeMoVKq1epNFqUNodbq9WhDUYTKYzAhzF2LABW2pMJoNO2MRxOnF2xCgwhAABoQDMAEJofgadJIMD8KAuAC-ifNaow2BwWrIICoNDoBAYECIlI0YoAVFxYdolAA1LhgDSOrgAcn62QUMAummMqggMC6mgHYNQ9cbYuABR4ydgGF8dXI4mo8bXDkS_Fo0ng1P3h6FAlonenXWXB6NAEkAPKsqKoGAAUTAYBgu5KDAkCLnuqBPlYADSmhflA0gQAAXjAEGiAACq-0jeAA-qhABKr4AMLftI0jPgAcgA4lh36-L434Edh3gAJqod-nB5j2fZEIOw5yIo44aJO95zguS6UE2XCrka14njABE1GkjqeBAKE8M-yaUMyAioN-sA2DQqlcM-BHMuJukwPpBCGc-Sh9vI6DdDpek1tZ0hRJgGjmZZ7Gcf2Q4jvxagTlOM6aDgI6JOgOCYNK_g5FAigaPOnCcAAFIwugnPcGDdAAlDg0hdlwrgdp2C5pbC6SoOQXCpblxWsJJh7VEeN4wG2XAhQ-4kEFe1BpJ197LsVbZdPwEitbJd4zsuqVSfEoiYrCLwOeQNSWTgjS2F5NbJukz7oKlHhLai9XtgAEt4ACyAAyBHQrCO0GYeVgPC8HhEOk03dU2GxWHmuULlYLUybQHUuGstKoH1qADRDF7cCV_BjRNoMwGekPUHNL2iOI5DRLYiA4wtHgAJwAKz8PwIzk4Mgzk2AABMejZm8MAU28dOM-MLOk-QpNgAAzKTjP8-M4sizAIwjOQABsouy3ojP8OT5PjLTguCyMjOy-QIxvLLssCOgjMGzrpOC8zgTkIMpOk7k5CBIE5OkyMeh6OQbyC_wgRvM7Iz8LL6AG0L6B6OL5NO28_AfOgYAjLL5OO3o6CCzA5OC-gJuk28Cdu7TcsCwH2bB2ngTuzAvtgNH4xvOH6D84EpOy9TgtQjL6sCPwpPjA3dPjIMaeDHo_DkOgidvOggz-LrbwC2AgSmyMYCDGA5AwHPfOYG7gRB-g4xuyrHiGVY0qYFA32eBoUDvSAVqVNUcDoBo4wwDUNs4G__jrzQGg5v4wwApjiChoB0RBj7EwJLfT6GMEZ_VEADcqRpkbjTFF-LoXBUJcRmDAVKiQmRQHUA1K4thvD1hgJQVkeD4DMnUPGLgbxcqAxStJfqYpKGSDQD-P8AECBARAjSOkRl3ycK_L-f8gFgJoEEYjJqRorDyDspocQ8AXjzQWvEYwzZWzeByFwPQm50A9h3GBLglAwDijwDMLgwEJEEBwLVTA2Y5QEBeBuOg6BtzVTAgVAiuFvzfjIvVZsxhIFWAMR4rxu4oZuMMVEnx0g_EBLIifDRWjWwAHUchPE0JY9qHDPztWyJQqARi9DtQMTUDQkUHGpScfwFxLxsy5hgME0J8iNGVI0E0nMLhUkLXSVwXR7UxxbSuAQRIqBGhPFqfUxprwcCMK4CEsJohRnowmXQaZzxXj9M0dooZeiqCdC0OYv4DxMDcHWXAWZwEGlQFcVwAAxIzU2Od-BtNWTwKxWc6DfnQFtEyJzb4vLedHCBHSBkHOGfolkWgCYaFglcRCMBbnOIeS8aCiKkjwSQjgTs35cJMSwtIK6ABBG6N1PmQviAi2CuKYCYpgjilF-LCXEtJRSm6ezgbQr0agda5TTkWLgPwBsWQuAKTHD2cSXAiAuJmGK-QsA2w0AgDmdV1IpkONwjAAAjsSfBXAMkwD0BRG6XBGZovuY8pZKyaWnwVaK8VaBGjch5aIQZML5ByhcFcRQY4HFks6jmGo-SLFIT7FwaYoqIlwhyVwH1LSbE8N3Na-ZbxFnUo0fEJNLhpABvQO6r5oQ-XtWObKs5U5qQRJsQC-A6aMXPL_C2sA2ac2iGrRACJ_zAWmW6VwDwTzW1_ghR2z1Bysm2ByKc8g5AWSYCMfIdMWozEiqSLw6VlA9D-l4XCYpcoyntS7RExtjyJlhvbeOrAuF-DpBeBe5CkCCyQIlIyzBGFsJ4UIsRUilFqK0XooxFi34cCvh8DdcibEjR5iBotNhZiPxcPEbw7wlACayK6suHAlI0hYMoOvSG2rBDoBQ7uVKBTkOpr4VI0CUNcqHiwz1HDVICD4cI1q5olGxHUbgAAbW49wuxaGMMAF0cAkbPLAaJWN4ZQxwKgGUMAACEzDobSWPLQeSikiDKVSnxyBjAbJ2Qcl0JyFkaysHUeO1AYr30eHcVuExUMx3jvFOkRQt9n6clM9DBMJbqAETkFMuSOYoAj3xi8VKMIWTvrSMKKZ9VXCNWs25nggmyM0YET4xRnJlHTjgMpnAESnPeKhiNV8O7eE4Bi2GuAqVHOeOc9QXKfGADUtWYCibbHCRr8SoZwbSzwJjTYWN4b7Bx11OAaj2VkplijSGePCfQ3QehGXqP8OkWBNTQ3O1DWY7htjE3zxTfW3Y_jZ3UMrdQOJyTG6ZOoFSnJ6gCmlOqcGx2l9DrFp4EoBAQjLxKu7rTQTdI9W-vNdQLlD1w3Q3vqB9Vzr4O4mQ_yuqbAr4wALdEUJ3hm26Mvdy4lFRhXiso7K9QVTz69lGY0lpXQT0CBWZLbZmwt8umufHW-9nmlYC6E5x2wLwXAVhYi9EKLnWXgGHp1D4hqW0uXckdl-TRP8vwCK10kanWPtpZG_Yw77GTvapm-gOb1HseFMyyJ1biGceZfxzInbu3BozQO6xw3RGuOLdx7uC73urfXdu1nKTvCoZPZOy9xTmB3slq-7ruHLxFdZa2yrpRTYCsa7hdTwz6lefaUZ8z77PBWf2ZADeu9Auc3c8HSAaXfO_Mw7MagILugRdQHC6PcXtVJf6Lz7oJLKWS1WCTw7nLaeSdFfL-kLXcOddub12No7BGjfNBN2buxFuqPLYw2t_3G3aOO7n-OhfBvjue5wEnv3dvqPW5uxJ4P92wLh8xqgV70enfjrj_PhPtvLf7-V4TuPhnjgFPtnjSkZm5A8JoAXvLhoiXrfOstIJslMk8JXhotXh4HAO5JoGgQtELq3qFu3mLhLj_gKkQEKgPnIs7r_lvnjgfmPnlunurp_PWkgZMtsjPrFkfh2ifu7mfpxtNrNrQPNknrfrvtfnYqPvRtwTmrweNsvufpfgJnvtvnQEHugCHg9s_gjG_iph_p9o3j3iPvQanowRPiwVtGwVsk8I3ssKgMWkXnKvwFgMCB8I3mkDAFyAwosoMGATmhAdgZ5M5DQIXmlvATXvKg8oqi6lMrgfEBgakIEXEcPs3sLoQR3pFt3qQYKpoJQbAeOsYQAa_qrkwaTpEeIM6sqq6pwWGjIRonIUvpNsbkIT7gQJvktldjvjQR0Urini1nUQtA0R7gIUoaIYHvfhoY_mHs9q_lHnoQMVwF_sfj_oUX0cUUAcweUdEVUVMrYWgA4WlkQM4a4e4bQF4b4TSksfEAEVAUERZiEfkfEOER4HmujIWskbjB5qXlgbcR8elqkQQfdEQZ3iQbFi8GQRQXLkPqIKsQTusWYcAa8QWrkEYiVNrtCcNvtqNqfgoQIWvsIebmMV0bCYfhiS7j9PrnwbiadioXusoRIZ0WoRMZoU_jMboTHo4VcbISsbSb0XCThhsaTkiYWnsfYQwrYcca8G8KcZ4dyD4X4RokZkCmZMEUzo8VYM8SACerAL2nJP2n8e5p5jXhWhoAafgSFkCRkV3tFj_vFq6nkWSSSQwcTsAdqT-PWsqVoGibPmSUMfwVNvia0e0a0WId0a0VIf0b6ViZSfIU0V7gyb7vSX_qoXfndtJqyRHrMW9voTmlyfUTyQmcnvySUeYW6bqZ6QqQtEqf2jASznZrfD8pcuWfqf5o4QkSaWaQCRaaLiCVkWCeMglo0A6Y4cPryUWTIgKQicwY2X8h6f2jUTAAsVYH6dSc0abgSRvkSTbk6dIVGa7tiVSXGRfmOVfsmYyamQ_umdMZmeyTmRonmYMQWWeXyROSWcATOTpHOScpWdccZj5o5LWY4ZqZrv4FwHSiykhAaQkd5vZI5J2S3t2cCZkTaf2RCbkVCSOTCWORGfCS6cweBXBCiguUuXtvuTGY0SvoIeuUGVueBGGfbiYZGZhZiWRYvsMTSYWaebQbuLfuoSydeS_reQsQ-fEI4H9gDlwAjiDjAGDqlFivSiitDiWkYdhYxbhWrqTgRQys-oeKJvQqtOtDWJtNtKqXtAdEdCAMSB4GdHCJdLdCoKoIzgxqgADHVAuAmEmHAKmLZhmFmL0jAAWCAMuvjPwFtDgIGNQBWFWLQPQIgCAKuCAJgIoCWNVAVh4MgB4LxKOAJEJKFKaUgB4ILDgIzMMIzBAiAFlYFOoIJF1GFBFIGjFJQHFEkIlOlYVcVaVR4C-iAEcWgG1UmCWLgCwFAOVSGFqOlQlWkCuv1cuoqEkPCINfgDGFwP4P4Hlg3h4HoMSKUjNemOvFAPottUYujkNTGF1QeIlTAKoEBMlZcuQGlWQC8XtUkP4FtRgLAPlUTCAAAHrDCDBWrkzlVvpjX9XfXkweiA0gB5h5geUphpi-WIDNL5iFi6BhyGAOioCQDNARWoBRXUAxW1hxUJVoDZYwA3SaTyD4a0APbpWPoXVODoC6qdCCCvhdlbS00aBhoXVdT9V6B9hdAuD5UXW0DiqyS7VzUjVQ2w1eXw2ZiI3-WBVahVhY3hVMi43ICVj401gMAJWtDyDQCaCviihQyogZU9UyhygwD9WtDSioCBjlWJDSjqAmRECWSm1I1PogDwBXQW2wDPjVh2Qc1c2YGUJzVXQKDpUe0XWYDzrpgnguZ-UtLR0ARQBx1gTh3yCR3-XC3phbS9QFUgDESyyjUTL_b52IB00eAcIqCfUeAxr50XXYCJTkI0A5hARUB_wcjOBB2e0WQSDt3iQnjiRXS2CCAnj8A90XVnyW26oEKsgJ1fVzHnUeDYDzo1CYDpUGYgBzFYTT1ZDlX10eCiYw2Jhw0-Vy0e3Q15hAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/viewport/post_processing/effects/outline/src/index.ts",
        "description": "An outline post-processing effect is a visual technique used in computer graphics and image processing to emphasize the edges of objects in an image by adding a distinct border or outline around them."
    },
    {
        "href": "examples/viewport/post_processing/effects/pixelation/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlqKMUGgA1pxWPBowUO4gcAQAnrBweDC2HnHxeIlgKYQE8nCIxsYArqjy0QDmOFRExmBQlADuehIwAAIAjDgALDgA7MboEGntnT19OERoLXBw-SI8YQUmOYLCOwbo6eE8jNOqXGmZMCldEOgEeIhcgwAMbwCkANxcORCNQgvd5fb4eU4Rci6VT8OBcB4pKGoGHrECsExIlEQkwXbEXeHoFI1CAha6wFLyShwCQQagvfh6OCUKA1Wi_AiUeQvUHgnFqbFwcgaCDyAhcDKKFJESjoGqwUkacgpOCK4xoTC4Aio9HGQXC0UHTa8PUisUqpUeMoVKq1epNFqUNodbq9WhDUYTKYzAhzF2LABW2pMJoNO2MRxOnF2xCgwhAABoQDMAEJofgadJIMD8KAuAC-ifNaow2BwWrIICoNDoBAYECIlI0YoAVFxYdolAA1LhgDSOrgAcn62QUMAummMqggMC6mgHYNQ9cbYuADkS_FoAGEamlHZ4IPGuABJaRRTAaACisBsNC4eZ7faIg-HckU440k-ns40OBHiXQOCYNK_g5FAigaPOnBLpQTZcMABQ8EKAi0NI8DUtQ8YIWuyEwJ2X7LphRpHgAChAWBJButKoBeYBgDA5AEEoMCQIu4gYVhxEAPLSN4AD6xEAEqcZuF7SNIR4AHIAOK8Revi-Bem58d4ACaxEXlh969v2Q4jm-agTlOM5zgunAABSMLoJz3Bg3QAJQ4NIXZcK4HadqZqBmbC6SoOQXBmXZLmsHBWHVNhG4wG2XBGV0y5YVWaTRfhMFiq5_BdPwEjhbQeEzsuZnwUaViYrCLzoJQ5A1DeBA4I0thXjA1XJukR7oGZHglaigXtgAEt4ACyAAym7QrCDXVYR8SiA8LweEQ6S5bFKUbFYeZ2QuVhhUhEVRS4axUfF1CJXt6HcGlGVZdtKFoVRBVYVY4jkNEtiIPdU1cB4ACcACs_D8CM32DIM31gAATHo2ZvDAP1vEDoPjBDn3kJ9YAAMyfaDyPjNjGMwCMIzkAAbJjhN6KD_Dfd94yA6jqMjKDhPkCMbyE4TAjoKDLMM59qPg4E5CDJ9n25OQgSBN9n0jHoejkG8qP8IEbziyM_CE-gLNo-gejY99YtvPwHzoGAIyE99ot6OgqMwN9qPoBzn1vCbUuA0TKMq9m6tW4E0swIrYD6-Mbza-gyOBJ9hP_ajUIE9TAj8J94wh0D4yDFbgx6Pw5DoKbbzoIM_iM28KNgIEnMjGAgxgOQMBF0jmBS4EavoOMUsUx4k3vdKmBQItngaFAs0gFalTVHA6AaOMMA1ALOBT_41c0BoOb-MMeljgZP6tO3b08DNH0gPNqH7dQK2iGtHnFUdYryGRFFsdRtH0YxzFoDSdLHqR5FQJR1A0XRDFMRYm_M6IUiqiHkH2cC4h4AvEKu9eIxhmytm8DkLgN8v5cEaEvVAcp0wSHSDgfymBsxygIC8VGbwcBvECs2YwO94hYN0Lg4UGRyGULePQgs9CJQwBeFxHi_EhIiTEpJGSckFJKV4qpdSOBiJHgABoXkGgAQW8EeTiElNKHVQIldBd8qJ_yft4Sgz0QExWXDgSkaRiJ9mrvtVAzRBDoEMQxMyejv73xcc_IB987KcHiuuLcO4OREH3GZAA2vQxgJ4zyaHGjWVgcD4GiFQPwGwg9GE4O_iw9I28wFTR4YPOAsSNB5OSaIagm45AOJgCNKAUAM5PReGZGELJeFcBwUQPQmhAquGCkk8pVh3E_wfv_bxr976WMgZoaBcAACEtVsHMPwS5aKOYagwA2oMqw5iUqWKpAQGxFUboOJwDUeQ6AIpeLcbfDxBjH4MWMaYw8wzPEPPGaxKi616GrQ7uU1pGyXivPuWMwBEyqJTM5DM6c8zFlMOyfgv5yTlioG5Ei-BRB-BYGBB8dF700gwC5FwdhgxOFYQALqHnKpVaqtV6rXhrM1Vq7UQDEg8N1OEfUhoqFUPEmgfjUBrQCguBMSY4CplSRmLMOZ8yJnkJnaI_A6o4EDNQCsVZaD0EQCAeCIBMCKBLL5GFHhkAeBfKOd8n5jKlKQB4VGOBQbDFBtvEA5r9LqA_DFTQv4nBjkAo1SgIEkjgRNXah1TqPBcIPplVAoakwllwCwKALqQxahNbqtI6YCBxvlYqJI8IE34BjFwfw_goWxoTB4PQxIoDoBzemauUAuDVugOgAtGoi0kEjZhPVMBVBMQNZgI18B00eFzY2_w1aMCwBta9EAAA9YYgxQY4G-i6nhqa43zu-h6NdIA8x5lFSmNMUrEDZlzDAAsqRdBa0MA6VAkBmiqtQOq6gmrazat1WgHxMBBqUE5Ec2gDEDpIAIBoDZPanDoAEkkSgghOKoCqboOqJqwMQY8DFONeg-xdBcDanttAGweJgPWvNyb91HvFSezMZ6ZWXsTFqKsj6VVMhfcgSsb6awMF1a0G-M7OKiioqiU1B8ZRyhI7ajjRBpSoEDC6xI0p1CbkdNVYT56XA9vgP1MTsAjzVkgah8DMAe1MhqHm_qCgTXqeMx4TA5BskjKs3RntdmHP3ws_IJzF6CPpjqtmyTolCYprAxABihn0MgEoKyFQs7bPehddgcC9Yaw5iYlQJeHJnDhZsyARqEg0swQ3DBfqthBAbn4NlntXdxMwaZCye-cbUAygk1G7A9maiYBNZEkATXMC8Wq1kF10w0geHJYexMx7JU0eswevMQA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/viewport/post_processing/effects/pixelation/src/index.ts",
        "description": "Pixelation is a post-processing effect used in computer graphics and image processing to intentionally degrade the resolution and visibility of an image by increasing the size of individual pixels."
    },
    {
        "href": "examples/viewport/post_processing/effects/scanline/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlqKMUGgA1pxWPBowUO4gcAQAnrBweDC2HnHxeIlgKYQE8nCIxsYArqjy0QDmOFRExmBQlADuehIwAAIAjDgALDgA7MboEGntnT19OERoLXBw-SI8YQUmOYLCOwbo6eE8jNOqXGmZMCldEOgEeIhcgwAMbwCkANxcORCNQgvd5fb4eU4Rci6VT8OBcB4pKGoGHrECsExIlEQkwXbEXeHoFI1CAha6wFLyShwCQQagvfh6OCUKA1Wi_AiUeQvUHgnFqbFwcgaCDyAhcDKKFJESjoGqwUkacgpOCK4xoTC4Aio9HGQXC0UHTa8PUisUqpUeMoVKq1epNFqUNodbq9WhDUYTKYzAhzF2LABW2pMJoNO2MRxOnF2xCgwhAABoQDMAEJofgadJIMD8KAuAC-ifNaow2BwWrIICoNDoBAYECIlI0YoAVFxYdolAA1LhgDSOrgAcn62QUMAummMqggMC6mgHYNQ9cbYuABR4ydgGF8dXI4mo8bXDkS_Fo0ng1P3h6FAlonenXWXB6NAAUAPLSbwAfWfACVXwBhABRaRpAASQAOQAcU_QDfF8QD_y_bwAE1n0Azg8x7PsiEHYc5EUccNEne85wXJdKCbLhgCPG8YH_Go0kdTwIHjLhQKUPt5HQbpUEA2AbBoVjQOkKJMA0PiYAEsVMN7fshxHAi1AnKcZ00HAR0SdAcEwaV_ByKBFA0edOE4AAKRhdBOe4MG6ABKHBpC7LhXA7TsFzM2F0lQcguFM2znNYKjD2qGiTxgNsuBUh8KIIK9qDSSL72XZy2y6fgJFC28kpi0zVyNKxMVhF5uPIGopJwRpbAkqTk3SUD0FMjxCtRfz2wACW8ABZAAZf9oVhaqayfeJRAeF4PCIdI7xnZcNisPNbIXKwQuvMKIpcNZaVQOLUASjaL24Fz-DSjLVtPc8ttyw8rHEcholsRBrpGrgPAATgAVn4fgRnewZBnesAACY9GzN4YA-t4_sB8YQde8hXrAABmV7Afh8Z0ZRmARhGcgADZUdxvRAf4d73vGX7EcRkZAdx8gRjeXHcYEdBAYZmnXsR4HAnIQZXte3JyECQJ3tekY9D0cg3kR_hAjeYWRn4XH0AZpH0D0dH3qFt5-A-dAwBGXH3sFvR0ERmB3sR9AWdet4DbF368YRhXs2Vs3AnFmBZbAbXxjedX0HhwJXtx77EahHHyYEfhXvGAO_vGQYzcGPR-HIdBDbedBBn8Wm3gRsBAlZkYwEGMByBgPO4cwMXAiV9BxjFkmPGG57pUwKBpq6TwNCgcaQCtSpqjgdANHGGAah5nBx_8cuaA0HN_GGBSxyUjQHSIZunp4MaXpASaz026g5tEBb3KNKs9qRKJUBgQCwDAGBdyUGBIEXPdUBeRzOxwYSr7QW_76PwIM_V-NJqApTys9Lg8hOKaHEPAF4kCoGiGMM2Vs3gchcD0JudAPYdzvy4JQMA4o8AzC4C_B-u4cC-UwNmOUBAXgbjoOgbc3l344FfJ2QCP5uoAEFkL-WbMYLe8RsHMNYbuLajCcESPYZw7hfDkIt2QaENBXAMHhUFLoa-4VMC7QkOkahplaH8HocCHAgN3qCOEflZ6ejqQZHMZYkRBYREShgC8N8H5vx_iAiBCC0FYLwUQp-FCaEHL_l4eBbqEFALKK4HmHal9tH_zvpQgg3hKD3UOolGaMUcCUjSM-Ps5dNqoGaIIdAaSgGmS0agHR1Sn4vzQGA1Ai0TLn2PLQeijEiDMVMgAbREYwdinFuJdF4vxGsrAkEqNQPwGwfcmFbnwVtTetiRruL7iPTk4ztoJhEVYag_45DlLojmKAKc7ovFMjCFkHirgEGFOU_yrhAqzJUaIOpDTAFNNAewmBnI4HTjgAAQhwGIlZbCtopVfHof0QCcB3JqPAUyyyWGrOoLZAZABqZFMAAC6bY4TotkVtJanyrBRWXAUqkBBimUFKdScpOAahcTCo0ggtS_4305Zk7JrFvmpN-cA5pb8trtI2fEVxUqCp4EoBAUpLw4UIqofddIcA0UyMxW0-JUD8XKvhYi_FmrSU6vsuqbAr4wDcpSbykVICWkAtgU2EF4LIUYuhdQUFtkXF6oiMJUSmhBo0BmYc0Q8zFm73sQY9ZlKtm7zgEGjQcbPnHNOZVPqUBLmp2iDcg1XBUBlT0JoV57zw0jSFfa9JjrxXUAKS6-BYLtJ0AcekFK-KKWUp4NS_JhT6UlIuiytl6AOUittfU4V6T-V0EFTygBNaxWtMlZSmVlKC1VoXUA2trSG1AtdfAcFMaMj-pGssD-XA3inviEQfgWBgRXorY8mAXJL04Ehi4w8BLWIlTKjWCqVUpk0FqvVRqIBiQeFanCDqPUVCqBDQQX1qAFp-QXAmJMcBUzzIzFmHM-ZEzyFzfwSqOBAzUArFWWg9BEAgFXCATAigSzeRBR4ZAHg8KjkIsRVSKakAeERhY4YgNN4gA44pdQREopqQ0mOFtul9KGVY_xwTFiPCuL3ulfZj0kwllwCwKAImQxalY3RtI6ZYp8ZAIRxUSR4S6fwDGLg_h_BAv2QeEAehiRQHQEpqz6Zy5QCwV53Blq9MxjU-5zAqhn6Mb0eQFjZAPDWYC_4TzGBYC8e0wAPWGIMQGOB3oifcUZ3zWX3oekKyAPMeZ0MpjTDhxA2ZcwwALKkXQatDAOlQJAZoZHUAUeoFR2sNG6NoH-TAbqlBOQMtoJIo-SAnkovc04dAP4kiUEEK-VAJzdCVVY4tmA7moq-b0H2LoLhePudoA2KAYVfPJaSGp2rmH6uZka3hlriYtRVh66Rpk_XkCVkGzWBgdHWjyGgJoV8ootqojY3vGUcoYC-daNKVAgYROJGlOof8jopJw6ay4dz8BOqI9gKBasnF9saCWx4JkNQbOdQUKxwnh2PCYHILd-e78Wcfci4_LnJ4tpM_kLz5rV30yVQs9p4CuNDNPMVdLg77nKCshUJl9n3oRPYEMvWGsOZn5UG5xROHyuPCSQkIbiiJ4KKdVsIIE8_Bqe04R7KWAa2mQsh55Z1AMpkdVeJ1gTnNRMCsaGSAX3mBPxtyR6iSLWuQAEpq4mOr2G3us-q3mIAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/viewport/post_processing/effects/scanline/src/index.ts",
        "description": "A scanline post-processing effect is a visual technique used in computer graphics and image processing to simulate the appearance of a cathode ray tube (CRT) display or an analog video signal."
    },
    {
        "href": "examples/viewport/post_processing/effects/selective_bloom/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlqKMUGgA1pxWPBowUO4gcAQAnrBweDC2HnHxeIlgKYQE8nCIxsYArqjy0QDmOFRExmBQlADuehIwAAIAjDgALDgA7MboEGntnT19OERoLXBw-SI8YQUmOYLCOwbo6eE8jNOqXGmZMCldEOgEeIhcgwAMbwCkANxcORCNQgvd5fb4eU4Rci6VT8OBcB4pKGoGHrECsExIlEQkwXbEXeHoFI1CAha6wFLyShwCQQagvfh6OCUKA1Wi_AiUeQvUHgnFqbFwcgaCDyAhcDKKFJESjoGqwUkacgpOCK4xoTC4Aio9HGQXC0UHTa8PUisUqpUeMoVKq1epNFqUNodbq9WhDUYTKYzAhzF2LABW2pMJoNO2MRxOnF2xCgwhAABoQDMAEJofgadJIMD8KAuAC-ifNaow2BwWrIICoNDoBAYECIlI0YoAVFxYdolAA1LhgDSOrgefrZBQwC6aYyqCAwLqaDxg1D1xti4AFZOwDC-OrkcTUeMFIUCWjSeDU3f7xL8WidqddJd7kQASWPsG3ahga8ojoAomAwDBt0oMCQAuO6oPePAANKaKgSTSBAABeMDgVwAAKADy0jeAA-ihABKaEAMJftI0gPgAcgA4lhX6-L4X4Edh3gAJooV-yHPv-4jqB-36_pxnB5j2fZEAOIBDnIihjhoE43rOIDzoulBNlwK4iAel4wARNRpI6ngQMhD7Jp-sC6F-sA2DQBlKH28joN0qBmTAFkEAZ0hRJgGiOc5AlCf2g7DpJb7SZO06aDgw6JOgOCYNK_g5FAigaHOnCcAAFIwugnPcGDdAAlDg0hdlwrgdp285pbC6SoOQXCpblxWsCpBTVA4F60G2XAhbeSkEPu1BpJ1N5LsVbZdPwEitYeMDXtOS6papViYrCLx2eQNTOTgjS2F5NbJukD7oKlHhLai9XtgAEt4ACyAAyBHQrCO2WQUPAPC8HhEOkM3dU2Gw8HmuXzlsxiTRpHUuGstKoH1qADRDp7cCV_BjRN6lHieUPzS94oQOQ0S2Ig2M8B4ACcACs_D8CMZODIMZNgAATHo2ZvDA5NvLTDPjMzJPkCTYAAMwkwzfPjGLwswCMIzkAAbCLMt6Az_Bk2T4w0wLAsjAzMvkCMbwyzLAjoAz-vayTAtM4E5CDCTJO5OQgSBGTJMjHoejkG8Av8IEbxOyM_Ay-g-uC-gehi2TjtvPwHzoGAIwy2TDt6OgAswGTAvoMbJNvPHrs07L_P-9mQep4EbswD7YBR-Mbxh-gfOBCTMtUwLULS2rAj8CT4z17T4yDKngx6Pw5DoAnbzoIM_g628_NgIEJsjGAgxgOQMCz7zmCu4EgfoOMrvKx4yE8NKmBQN9ngaFA70gFalTVHA6AaOMMA1NbOCv_4a80BoOb-MMAVRxBQdEQI-2M3qiU-seSG1A_pcABuVEQyNxpihgl0VCwkZgwFSqlRITIoDqHqq4RqLgCDeHrDASgrJcHwGZOoeMXA3i5UBilNS_UzRJE4m-HiRAfx_gAkBNANI6RcCfJw183FOi8X4QQQCwFhGIyakaCUMAXjoUwjhfCRESLkSojROiDEsLMVYgVL8N16LeAfJ2L8WFkw3TQmhK6x8uDyBspocQ8AXgLXiMYZsrZvA5C4Hodc6AexblAlwSgYBxR4BmFwICMicC1UwNmOUBAXhrjoOgTc1VQI4AAIJKCUPVZsxgiZBJCTk18IjMkbnCVDApRTnFbD8VwAJMAKmfhEmgWgsMJDpCSalFJ_A0nAhwEwrgpTyk9LoNSDIYy3jNNCK09pFSahaHxhoGCUArgIRgIM4ZoyuBQS2bBPZOAbr5NwhRL8JSylGh4Js7ZcFEIvBOc885lzrlsXKb41sBFqAED7LmGJHS4DSkoE8GCaxInRKeB0lkyxUC6DXjEvBeBmRRS4LhXQW14RwgANqLNeAAXQOUBEZUB0mMPGQzMmdzymIrTNVGA0gIVPDQI0bktKyZLL-W0wJTLkUsrRfADFUAsU4qwTEuJMIWQdI5FwIgsJoiRNZFwdA6ZNnxPMjWOEaBQVXG_vs7FuKOlxKJQwwYZLkkUqOW8HAJMGUPK4EKlFMAAnosxdykmfLWlfmRcE-AkStDTDgAyLISqRTKvkGsjQ5LUlUpeNmXMMBnXxCjfIGNa51nJpzC4P1rYA0RuDUpDVMwS36rhYE4eeNGh9jqKEuJMA5U1A0qEsAZb4WdP7FCKAa0oCXgabaxN1KgU1DTZM-5GaASoCUu-EeTQG0YBeOOmA2M8wFDzEDBw7CrjiK4u-KRvC-Lbm8JQfGiiupLhwJSNIKE-xr0hqgZogh0B8M4kdI0LgXyHp4R-gR8jQIFBYSIa9PVb1UgIA-ygT7qQvvCge7hx6ANagJdjH9XDJFdNQ-ey9BQyVvo4tU1AqV4YNLnZgAAhKB88U0tI6SIHpL9Vh0MusYA-aynI7JdAcrqmgrBvEZuRTYG-tTsn1NgQmcpPAVE3yftx-yYCXU8GoAROQL7NI5igLW6ILxUqttUVcIFnKiGNSExm_dv7kM4dPbIwRIEGmuM5O4qccAqM4CDXU3JUMRpoT0P6TiOBDNwBY5Zqw4mqnAZU6IXKBKADUhmSVtjhJFyTqAd3hfA02SD97H0YwQzUWyGlUNhfCzwTDEij22ZkXhugSyM2Vb_ShuzcihHRfK1wUDnXssEFy9B_Lz7mhNZs9IzicA2OdYq0h7DY2z0XroDJ0QhHM7EdAmRjG1AcCUZgDRzL8QCxLccJQXGniuD-cC9uHA-N0ihbSz56guUGudRzBOl4F2gshdSvdkj-V1TYDQmAMrlmRuzZPTItrjmtvOcSh49znnKnpao0t3K5TDvscMsZAQfGnI1kE0tkTRmPrRoUDmpK0mYtydEgYZk2PlPhbUxpra90oA6cXfpwzLwacmVQGZpRnXQfVbm_ZoDTm3FNjcx55YWbScsi0CVQz-2M29f6zBuDnKcBFc1bQUrS2rCC__XZurYE9eiANy1iHDmFGm-6-VlXd6BuwYK8NmbQvwfjcm1N83NXOLG9Nyt9Aa3Mbka2ztvbS30dZde0Z73wvIcKNveLuHUuSfyDJ2jpZHGjK09Mvxgg-OYuE5vrO-dyZF31qoRgenlmqceG53TinDPUDqbNSztneMOfR_pKgdIfOLONdd4by3ovodJ8lzgEviQy91uXaEhX0elfxHt1BtXzvNfFZ13Z4H4XY_u_m5e57-vB8W84vHjr5XbdZaGhBh3q-huIes2D1DE3TfTcf273DC3oYxZ4AHoP1ANsYFUBtsZRdtL8DtntOcrMsMP9Wsrc8kYdXN4APNJ8F0Z9K90AM9ykOM3IHhNAnp89-9RAi9RIZk-kMhq8M1a9Uh3I5JntGdW9tNdNO95UXhUB1o9BNA-9Tdd9UMz8xcXMJdkCJ9qxyD0gRpFdTdl88snd78tcSst9X9oCqsh9fcv9D8zdj8fdAN2soYbdF8rBpDHd1cENeC7MX8f9ND39VD99FtLC_8kMACQ9gCw9wCrBI9LMoCzDh9dDR9BDk8RDek5l0hnskVuRQj-AsBgRFkls0gYAuQaUOYsCMdcCPICCC9wsSCPA3UWU2VPwOUX1KD4hqC4BaDyd6Dm8mctNWdmDaooD2CiBOCNBuDLDvDT94CBDYdx8ci148jIVYkX0JCF8pDr8ctb9Bt4Nmh5DN8ZFt8QctDhdjcNC38YCbCRdfDv9Os3Cl9Ri-txjZDJiH9ViT9twLCptlDmttCyEv9_ccAiNHDSNnCQDqNtj_pICu8LjRs991iodgDEChD4cejWV2UBjGhQi0BwiltlUojXhns4iEiHUPhBhkiM0cCyj0iiCeAsiQAgTPUxVMUiirASiyjCTRAGDNM29aiDMPiGimiWiBcFjvj-C_CujhDcSih8SJUhj5UDDRAjC79DjpiYBddLCViVCTjriD8lC2idDfj9CRjZob8V8JiNcZS0NpTGTP98N7C7jVsHjACEZniwDeSPDlcPi1TmS_ix82T1pmU148TshMVwTUBISYtoTgQ4TaAETxkkiXVTSIhOMbIeMcdnIMjLNsTgl1kuB_AuAnkzlEJSTZN0hFB5MgylNG9LNyTmcmD2c6iaSOCuCGp-dysLSOiWSkD4c4yoAXkOl58eSFSfo9jlSDiNchSRTzi1SliNTrCJTLT5TLD-SVTTDNTzDPcGSeyri_cdT7jrMnDNsXDQDw8Yt_TFoMVTtKhzsAsgsbtQt3l4y013jWDPin84CR8rT_Dx8qyay0dsYSVnFVp1oaxNpto889oDojoQBiQPAzo4RLpboVBVACCQN5wAY6p5wEwkw4BUxkUMwsx80YACwQB5BF1-AtocBAxqAKwqxelaxEAQAVwQBMBFASxqo3MPBkB_IJIgF1BgpZJydCYQABYcAGZhgGYwExJAEpIZJQp40IpRxoonJKA4okhEpyKPAmKWLmKPBDsQBlU0AxKkwSxcAWAoB2KQwtRyKCK0h0xeokAPBkLFQkh4QlL8AYxoz_AXNoZpMQA9BiQJUFKDK14dlbLoAm0TKVLpK9xCKW1AJiLMBSL4BNL9L0wnL_BbKMBYB6KPAAA9YYQYBmHAMmdilRdShS6KsmD0JKkAPMPMCClMNMWCxAFNfMQsXQUOQwB0VASAZoDC1ALCwFGsBgAitAIDGAG6T8eQGDWgEjcitdLypwdAXCJISgQQNCSos1XqjQCdLyrqBSvQPsLoFwcojwWgBsQdWgBykKpIaSvKqCgqzMIq-CxCrUKsaq9CpkOq5ASsBq-gPCgi1oeQaATQNCUUKGVECi2SmUOUddPS66ogaUVAQMdixIaUdQAFf6vVci4qpCDweAK6L62AB8asGySa6ajwJkdZNeK6BQKG-CryzAcgQdX-YDOC1NfG_8ImodagbG-QXGsmla9MLaXShi4iGWNSkzbcVGmGkAKhWRCAKKwi70di7ARKChGgHMQCKgYmpSd6vq2G5YezKWy8JSK6WwQQS8fgLmry0-b6oa_BVkPQ36nbTy2GrAQmmoTAci9DEAHbLCHWrIdisNXSklXKxMfKmCg66GnKvMIAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/viewport/post_processing/effects/selective_bloom/src/index.ts",
        "description": "A bloom post-processing effect is a visual enhancement technique commonly used in computer graphics and video games to simulate the appearance of bright objects. This is a specific case of the bloom effect where specific objects are selected to which the bloom is applied to."
    },
    {
        "href": "examples/viewport/post_processing/effects/sepia/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlqKMUGgA1pxWPBowUO4gcAQAnrBweDC2HnHxeIlgKYQE8nCIxsYArqjy0QDmOFRExmBQlADuehIwAAIAjDgALDgA7MboEGntnT19OERoLXBw-SI8YQUmOYLCOwbo6eE8jNOqXGmZMCldEOgEeIhcgwAMbwCkANxcORCNQgvd5fb4eU4Rci6VT8OBcB4pKGoGHrECsExIlEQkwXbEXeHoFI1CAha6wFLyShwCQQagvfh6OCUKA1Wi_AiUeQvUHgnFqbFwcgaCDyAhcDKKFJESjoGqwUkacgpOCK4xoTC4Aio9HGQXC0UHTa8PUisUqpUeMoVKq1epNFqUNodbq9WhDUYTKYzAhzF2LABW2pMJoNO2MRxOnF2xCgwhAABoQDMAEJofgadJIMD8KAuAC-ifNaow2BwWrIICoNDoBAYECIlI0YoAVFxYdolAA1LhgDSOrgAcn62QUMAummMqggMC6mgHYNQ9cbYuABR4ydgGF8dXI4mo8bXDkS_Fo0ng1P3h6FAlonenXWXB6NAEkz_IIPwAKJgMAwXdKGBIEXPdUCfKwAAUAHlpG8AB9cCACVIIAYU_aRpGfAA5ABxWDP18XxP2QuDvAATXAz9ODzHs-yIQdhzkRRxw0Sd7znBcl0oJsuGAI8bxgZCajSR1PAgeMuGfJQ-3kdBulQT9YBsGguGo3t-yHEcmLUCcpxnTQcBHRJ0BwTBpX8HIoEUDR504TgAApGF0E57gwboAEocGkLsuFcDtOwXezYXSVByC4Oy3J81geMPao-JPGA2y4XSHy4ggr2oNIkvvZcfLbLp-AkOLb2y1K7NXI0rExWEXlk8gaiUggcEaWwFJgBrk3SZ90DsjwqtRCL2wACW8ABZAAZZDoVhVqGrA-IeAeF4PCIdI7xnZcNisPM3IXKxYuveLEpcNZaVQdLUEy46L24Xz-HywqDtPc9TrKw8rHEcholsRA3vmrgPAATgAVn4fgRiBwZBiBsAACY9GzN4YGBt5IZh8Z4YB8gAbAABmAGYax8YifxmARhGcgADYCYpvQYf4IGgfGCGcZxkYYYp8gRjeCmKYEdAYe59mAZxuHAnIQYAYB3JyECQIgYBkY9D0cg3hx_hAjeOWRn4Cn0G53H0D0Imgdlt5-A-dAwBGCmgZlvR0BxmAgZx9B-YBt5rcViHKex7Xsz1x3AiVmANbAM3xjeI30CxwIAYpsGcahcmmYEfgAfGaPIfGQZHcGPR-HIdAbbedBBn8Dm3mxsBAgFkYwEGMByBgSvMcwRXAl19BxkV-mPDm-bpUwKA1q6TwNCgJaQCtSpqjgdANHGGAanFnAl_8JuaA0HN_GGTSx20jQHSIPvfoW9BJ5Ws8TuoTbRG2gKjSrS6YHfL8fz_AgAKAmk6Qkt8P2_L-f8gE0A_xutFCqoh5DSU0OIeALxyp_XiMYZsrZvA5C4HoTc6Aew7hAlwSgYBxR4BmFwQCQDGphUwNmOUBAXgbjoOgbcIUQI4EwpBBCI0ACCY0IrNmMKfeIWDGHMN3Kdeh2DRGsPYZwnh_d4gFkERKGALwoIwXgkhVC6EsK4XwoRYisEyIUU8p-cCz4uHyLzOdZ-r9AEf28JQL64DkrLhwJSNI4E-xNxOqgZogh0B2N3HZFwtj37AO_iBNytlH7HloIJYSRBRJ2QANqCMYJJaSskujyUUjWVgiCkGiFQPwGwk8GFbjwadE-kD5rKMnvPTkWSzoJkEVYagyE5C-IEjmKA-dPovDsjCFkKirgEGFL4iKrgooFMKfEEJACwmfxAcBU6biYFNmnHAAAhDgYRFSWGnVypBPQ_oP44CGTUeAdlylMMqdQNyySADUFyYAAF02xwhuVI06u1ZnxBcalNxVICCeMoN46kvicA1BkvFQJBBgkvwWRQhxTjxLzLfhQr-oDIm_NmYomp8RHCUAgN4l4xzTm7hwF9dIcBrmSLuagNy8ikEvLJScs5LzaVfIZR5dU2BIJgARaEzFyywFrM5LAzZOy9m3IOdQLZUSCVWKNK88StV6o1iai1XJNAOpdR6iAYkHgBpwmGuNFQqgZo1kVdtcKC4ExJjgKmYpGYsw5nzImeQBdoj8GajgQM1AKxVloPQRAIBVwgEwIoEsIVNkeGQB4Bio5mKsT0hoeNHgcY4BhsMGGJ8QBJq0uoFiyV9KGTHCZNqlBzJJCshmkAWac3Zo8IokARACrNJ-kmEsuAWBQHzSGLU8aI1pHTGlJAHgvWKiSPCHt-AYxcH8P4CVzSDwgD0MSKA6B61TqblATBm6cF8t7TGFta7MCqAAtGzAsb4DDsnemPd_gN0YFgOmidIAAB6wxBgwxwEDfNyjB31s_UDD0AGQB5jzA6lMaZXWIGzLmGABZUi6ENoYB0qBIDNADagIN1AQ21jDRGtAESYBjUoJyUFtAxE3yQGMy5a6nDoAQkkSgghIKoA6boZq8aGMwDXcleteg-xdBcO-tdtAGxQHijux9SQW0wadXBzMCH3XIcTFqKs2H_VMjw8gSsBGawMAja0d8b7IKilOqiBNbaZRyhgPW1o0pUCBnzYkaU6hkKOgajZxDLg13wBGvZ2Az5qzST4xoRjHgmQ1GnSNBQ8b_MCY8JgcgMmt4gSS-p89f4MsnlOgl-Q2WkOSfTM1cdXa0IUwHWMkllX-NrsoKyFQ76u3TDSPm7AVl6w1hzABKgmWuI2cax4NqEgBtcRPFxEathBAnn4JF6LdnZSwFY0yFkWWP2oBlI5yDgWsDpZqJgeNqSQA7cwLBQeDnUTnu9B4V50HEywZdap5LUG8xAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/viewport/post_processing/effects/sepia/src/index.ts",
        "description": "A sepia post-processing effect is a visual technique used in computer graphics and image processing to simulate the appearance of aged or antique photographs."
    },
    {
        "href": "examples/viewport/post_processing/effects/ssao/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlqKMUGgA1pxWPBowUO4gcAQAnrBweDC2HnHxeIlgKYQE8nCIxsYArqjy0QDmOFRExmBQlADuehIwAAIAjDgALDgA7MboEGntnT19OERoLXBw-SI8YQUmOYLCOwbo6eE8jNOqXGmZMCldEOgEeIhcgwAMbwCkANxcORCNQgvd5fb4eU4Rci6VT8OBcB4pKGoGHrECsExIlEQkwXbEXeHoFI1CAha6wFLyShwCQQagvfh6OCUKA1Wi_AiUeQvUHgnFqbFwcgaCDyAhcDKKFJESjoGqwUkacgpOCK4xoTC4Aio9HGQXC0UHTa8PUisUqpUeMoVKq1epNFqUNodbq9WhDUYTKYzAhzF2LABW2pMJoNO2MRxOnF2xCgwhAABoQDMAEJofgadJIMD8KAuAC-ifNaow2BwWrIICoNDoBAYECIlI0YoAVFxYdolAA1LhgDSOrgAcn62QUMAummMqggMC6mgHYNQ9cbYuABSFAlo0ng1Oo8bXiX4tE7066y73IgAktJpABBADyAFEwGAYOQCEoYJBF-JdwUAAp3tI3gAPp_gASneADCD7XheAByADiwEPr4vgPpBIHeAAmn-D6cHmPZ9kQg7DnIijjhok4nnOC5LpQTZcKuIjroeMCQTUaSOp4EDnjwF6Qcy9EPrANg0LxXBXlEmAaMJMCiQQ-GEf2Q4juRagTlOM6aDgI6JOgOCYNK_g5FAigaPOnCcAAFIwugnPcGDdAAlDg0hdlwrgdp2C7WbC6SoOQXBWU5HmsIxBTVA4B60G2XCaae9EKcx1BpHFJ7Lh5bZdPwEhRRuMDHjOy5WUxViYrCLzoJQ5A1PJOCNLYsnycm6QXugVkeOVqIhe2AAS3gALIADKQdCsJNTW4k8A8LweEQ6SFQlTYbDweZOQuWzGHlrGxS4ay0qga4pWa24HZl_DZblLGbqd1AlQUPDiOQ0S2IgD2iB4ACcACs_D8CM32DIM31gAATHo2ZvDAP1vEDoPjBDn3kJ9YAAMyfaDyPjNjGMwCMIzkAAbJjhN6KD_Dfd94yA6jqMjKDhPkCMbyE4TAjoKDLMM59qPg4E5CDJ9n25OQgSBN9n0jHoejkG8qP8IEbziyM_CE-gLNo-gejY99YtvPwHzoGAIyE99ot6OgqMwN9qPoBzn1vCbUuA0TKMq9m6tW4E0swIrYD6-Mbza-gyOBJ9hP_ajUIE9TAj8J94wh0D4yDFbgx6Pw5DoKbbzoIM_iM28KNgIEnMjGAgxgOQMBF0jmBS4EavoOMUsUx4U1cNKmBQItngaFAs0gFalTVHA6AaOMMA1ALOBT_41c0BoOb-MMqljupGgOkQ7fvTNXBzekW77dQK1cGtPnJagqVrPwlBPi-b4fl-NJ0hJ173vfr7vp-aAv9wnmlVEPIPsZlxDwBeIAqwxhmytm8DkLgiQmQsh_NwQUOYYBcEoGAcU8D-BEF6DWTB5ByAsh3KgHAQVMDZjlAQYEIVmzGHegkeAzJWQHWkFCWAwIO5bBgVwOBGC4B4PkFkHBh42yJHFPwF63AzJcHkBALASRxSUAcI6eQrIMFPAwXgghNAiEkI4gdChVkqH8BoS8QI9DGFGh4HAeQXIuCBB4aEPhAlF7MjhNohBggIAcV1BAAAXhgrBOCdH4OnPo6qhiyHwm4F0eiUB0BcDqBIOAJizEWK4KjaxTCuDTDSLoauLxUYuOga2dxBA-y5j-N0HssIxTeN0ZEsU0TSFnQ9vALK_B0hcHuE8fJ3oikYLQH0xJyTUlagyZ-cxUBaFcDeDgb6uTbGDMKQFGAF5qxXwkOkbkSyyl8JvPImoiQoC9PTOINIEBApViqcyHs9EwlxNoDsjImDsHePvFwfwCC6heNwaop4fYaiAmeWAOob4zqUi6FZW-8YXl0GpBkJyCKuh4BuXgP47ZvGfgfq07B6B0wyLQI0CRAg4T9KxdKSRzTCFtKMdQaZ1C5nAjeCs-IiK3l7NeG8Q5sD4FUE6FoUJTSIn0uIe0pllCZlZL0FATO0QOXxCFfRQeABiD4Wq3g70Oqs8p_D4GoFqnoTQHz4S0CXiguEor4GYFQJQGYpL5GwnSTKll8zBjKqsH0K1B1KivH5YajBS9pgcXNd4ykMwmTcAKdEZlszPXLK4AwvJoa_EBuBkGgRCDSU2s-fAqNaxqBrPje6xNLwRjetEMKVAjQA0jCDTeKA8wvGqMEP6DijT4FoA6DUOg1cI3wJZEQew0xnyaAHSM7g3j7WOupHWl1awE1ZPeNWngI7-B_gxWyptLbuhtrbOgTtqVvG9pZFOodGDMCiixeOl8iQNlxOeXOp1i75CupXayrgoN135JgLe7dEAXigz3a2lRR6T3dunX2y9tqMEOo0KOqAgyJ2PsHaM2ddB53Oo_cu8tWTUY4FBsm1NqzEPIaAyU4j31s3wKEQ2URTxxHpgwRxMcz7I3zpjaWr9nrCZ_oYyI8BrxCbvQLO9CUMAXgASAqBCC0FYKIWQqhdCmEcIPlcreO8BQ8wbTUVfM0Qi74TrfN4SgMjMrxWXDgSkaQ_x9mrvtOtOBBDoE_m-KyN8TP4qfr_FBTlLLMWimxLtXEIBWQANpBasIwSSDxNATRoKwSBohUB4Ok_vEAiDWEoI4eg3VnKpODzgFJTQhX4jUEgnIOtbEcxQAzs9F4VkYQXpeMa_BmgQquDCqlqw3mPPf2fig2zIDNBgLgAAQhwDl5B7DOEYM8q1_t-nOXWcSrZqkBAHPVVOi5mo8giW0EG154zg3zMyIRQN0zQ3_MHXWnkiTqzluZeu75n-35jHAM5ON6cU2ZssLm9QfLsAXHLFQPswYYP-BYG4XktIAHIfiY7nF6QZWZIiRrClvJ6WbAlYcRVqwxWsulYSxoQnogqs1YaqNFtjXojNZe-1k1XXQrhVWTwKsSCYA4E6I0KyUnQkvcCxzq4Z2bt-c-0y77oC_vTfsfITKABqF7q34jrabJt-zjm9vNAO0dmAJ23tfwu3QK74v3vDfu2r1aLimdi9voNyXf9Rs_abHLnSDiwdoDh6s0dsOuCE0bfD2gjjBjI_eqj9HSWCDY_IxlweBS7AbIp49dIigSvo9T5g1A1XdA0_q_TxnOZ-3M86xobrvW8l2It1_Z3I2Ze_fgNNpPwyrMl5gDb0QGuCBa-2zr5zevDusSN7XszFmzcO583Xj7f8HurKe2tjvLxjeP1nw3sb7vm8GSGRs73EOFk4Ch3k_3u6Q-I8Px8cPRpF8RHi9JGPcfOW48yx4VvGytmvORekbPxOPCk-kmzyp3zzqzp0VWLzay4A61NQrzZz61EFX1uyl3IUby33-3f2rk_yRV2XbwvS7x4B7z7x2ycwXSHwN1H0dxu1N1QHN0oMtzu2oHn05VvysHt0QPry-03wmxb130wO2W_3325GhwD1A3P0cUWSvwjyNCjzJ0f3gJf0HjQC_12V_3T1f1SCzwTDyWANq1pwa3AKCnt2gNZx63Z05RrzoJnyt2ly4I9yUOwPeSWw73wLSiKg2zs37120HxwH1xHxu1O0sPH0uynyd3X2t0ezt2XxCIlzCJsLd24JwHsO5UEIWWEJKVENWQR3EJwEkJvxR34kEgxzkix3kITyy1VXJy0NWT_0rEKKANz2p1AP0Ka0MKiLSFrUaErzMPMPYNiJQNsO3wqNwJW2r1cKWl7w8OIN1x8OH2O38MQOoNoOnzX2sNQCYPiBYO7zaLHyQJd1QISIqKkNi3v0S0x2S1KLxyy19UPH9VUIzxJ00JcR0ILzAJaJayiOMNgNMPgIsOWN2I33iLsMtRuJSmGM71GMIMmIH1IJmPIPmJ2MWOiPoOQPWKsE2IIO2MCP-M4MBO32uOtRSL5RPxhxKRcSyOBCOLvzR1kLONjwuPUPTQ4juPUIAPKyqM5WeKaKL1aMgM-K6J-KRKsIYP6NxP-0ZLhCcLwIhPSncK2ymO8N8LmPxQCL-MRN6NWNRNEHRLikxL-I4LiNl233FMJLSOyQyM5XJMv1hkpLOBOKKPkif3iAUKyw6NRBcRqNZMqKeIaJAL0O5PeN5JZy-Kr1F3VOFNd0NLFLzTBJcMhLlOhNJVhL8OVIWInxoMFJWOFM1NtzyTYJ2P1JFMjOm1dJNOJID0GEJjJNDwpLyMjztLkJxzKI8E3SA2ZMzzJ3qLz10MLwMIDNLygKDP5NGLDOQIjKb3-xbIxRjOlLcM1yhK8JhMVMN3hKxLVPzL6OzLPkiMgJHL2IGInNqi3QxVLL9xJJ_SJMyOrKtOvzRPPDrOpIf1pMdKsGdLfwAyeFbPZPiA9MeO0J9O7NeIZx5P7L5LgOHPXNWLHLQJb3fLwCA2nNFzjO1wXMTKXIoNVLTKWNCI1K721LzKxILKgoSJvQ_OPJPx91SLLJAwvItKvIkOtNrL1WOIfNOOKPOMbMuI8AoxzE_PdLUPbMAK_KsE5L9N7KMMHLAtDIgvDP2I924qgHgslJGMQplLnPjJQv21mOXJTIRMwozOxMYNwu3P7N3IBKLJwHkqAxPM5VPy4G-hoviEtPopvK1LvOkPrKfPpJK2ESyDbIeI7KEsp3_JeOaKAr7My1Au-PAoIr6KIo9yE1ESUvBJUtnImPUpINQq0vQvOz0tMvCIX2Mte2ktHNku3wSvgGsviFst5irIvxcpzKYq4AAF0EUqoao6oGoCAY8Wo2oOoQBiQPAeo4R-phoVBVAY8Rc1pgoFwEwkw4BUx0sMwswcx8xEwP1np-AGocBAxqAKw7kawGBVwQAb06B7VyA_sPBkAPBSJRwKIqItJKi3oQAiNQZhhQYd4QAbq1J1BKJ4ptJdIxwDI5JKBjIkgzJLqPAXq3qPAJMQBR00AIakwSxcAWAoAPqQwtRLqjrCllokAPAP1FRlF1RSxUafl_AftDotCQA9BiQklEaCbq4UMaboBkliaUaYwYa9xjqYBVAPxFASwAoLqyB8b0xGb_AaaMBYBHqPAAA9YYQYUGJZD6qTDGxGmW76D0b6GGvMWalMNMJaxAbMXMGAAsVIXQLWQwB0VASAZoHa1APa6gV5WsRAEAI63tfzGAIaSgTkHbWgKFE-JAKpftLmpwdAMCJISgQQO8YKmAS6oOmALm-KRGvQPsLoFwL0jwWgRjViem0WpIGG3W-a_WzMQ2lak2xMLUKsG27amNB27ZZ212zqdRaATQO8UUW44WuGmUOUWOvG2oogaUVAQMD6xIaUdQASAemsVEUu42rm-AAabu2ALAkBOOjQYO__SgU5auAaBQS6o2lwLmzAEhdMEEymmeg-t84-v1agHe-QPesurmuwDQTqxGmCMTKm9om5BSQOtehOjwTe98CAaW4670D67AMyesGsHMD8KgK1eiae-Oue5Yb-WBw8eiAaWwQQQ8fgVe9eru2UWAcOpBNhAOp6h1TATmjwbAQxChpAaLEAchmAYCLuHut0t_UBkAJqnWxMPWxaku_ek2vMPMIAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/viewport/post_processing/effects/ssao/src/index.ts",
        "description": "SSAO stands for \"Screen Space Ambient Occlusion,\" which is another rendering technique used in computer graphics and video games to enhance the realism and visual quality of 3D scenes. SSAO is a variant of ambient occlusion that operates in screen-space, meaning it uses only the information available in the rendered image without requiring access to the full 3D scene geometry."
    },
    {
        "href": "examples/viewport/post_processing/effects/tilt_shift/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlqKMUGgA1pxWPBowUO4gcAQAnrBweDC2HnHxeIlgKYQE8nCIxsYArqjy0QDmOFRExmBQlADuehIwAAIAjDgALDgA7MboEGntnT19OERoLXBw-SI8YQUmOYLCOwbo6eE8jNOqXGmZMCldEOgEeIhcgwAMbwCkANxcORCNQgvd5fb4eU4Rci6VT8OBcB4pKGoGHrECsExIlEQkwXbEXeHoFI1CAha6wFLyShwCQQagvfh6OCUKA1Wi_AiUeQvUHgnFqbFwcgaCDyAhcDKKFJESjoGqwUkacgpOCK4xoTC4Aio9HGQXC0UHTa8PUisUqpUeMoVKq1epNFqUNodbq9WhDUYTKYzAhzF2LABW2pMJoNO2MRxOnF2xCgwhAABoQDMAEJofgadJIMD8KAuAC-ifNaow2BwWrIICoNDoBAYECIlI0YoAVFxYdolAA1LhgDSOrgAcn62QUMAummMqggMC6mgHYNQ9cbYuABR4ydgGF8dXI4mo8bXDkS_Fo0ng1P3h6FAlonenXWXB6NAElvNACLIIGACABRMBgGBdyUGBIEXPdUCfKwAGlNFQJJpAgAAvGBINEAAFAB5aRvAAfTQgAlDCAGEf2kaRnwAOQAcRwn9fF8H8iNw7wAE00J_Q88x7PsiEHYc5EUccNEne85wXJdKCbLhgCPG8YCImo0kdTwIHjLhnyUPt5HQbpUB_WAbBoNTn2kKJMA0fSYEMsUuN7fshxHQS1AnKcZ00HAR0SdAcEwaV_ByKBFA0edOE4AAKRhdBOe4MG6ABKHBpC7LhXA7TsF3C2F0lQcguDCuKUtYaTD2qWSTxgNsuFch9JIIK9qDSKr72XFK2y6fgJDK29mtqsLVyNKxMVhF4dPIGprJwRpbEs6zk3SZ90DCjwhtRAr2wACW8ABZAAZIjoVhGaa1Q-ICReDwiHSO8Z2XDYrDzOKFysUrr3KyqXDWWlUHq1BGo-i9uFS_h2s617T3PL6-sPKxxHIaJbEQaHTq4DwAE4AFZ-H4EZ0cGQZ0bAAAmPRszeGAMbePHCfGEnUfIVGwAAZlRwn6fGdmWZgEYRnIAA2Vneb0Qn-HR9HxlxxnGZGQnefIEY3l53mBHQQmFZl1HGeJwJyEGVHUdychAkCdHUZGPQ9HIN5Gf4QI3mNkZ-F59AFaZ9A9HZ9GjbefgPnQMARl59HDb0dBGZgdHGfQFXUbeAOzdxvmGYd7NnbDwJzZgW2wG98Y3nd9B6cCVHeexxmoR58WBH4VHxgLvHxkGMPBj0fhyHQQO3nQQZ_Flt4GbAQJVZGMBBjAcgYD7unMDNwInfQcYzZFjwTviaVMCga6uk8DQoHOkArUqao4HQDRxhgGodZwc__HHmgNBzfxhkcsdnI0B0iGXpGeAePfLrPT7qB3VEA9J6ogfqNXEFAD8eAvy_n_IBAgwFQI0jpOpN8UDPzfj_ABICIE0AoMBsVAaoh5BaU0OIeALx-rI3iMYZsrZvA5C4HoTc6Aew7nAlwSgYBxQwLhCBHBBAcB5UwNmOUBAXgbjoOgbcOVwI4AohhfCW0ACCO0CrNmMF_eILDpGyN3F9SRrD9HyMUcotRK8aF0IYUwpk344JrC4Twp4FUwCUDGnCdMAguBjimnAYRYVRH8HEdyHAjMNFaOIadACJ4cgaFCYzSxyNrFcEYRVRIUATzOSuEhCq3DeGuPcYpNsx4AlBJCVwN4owInaKsG4jxKjjyhJGEk06KS0nMJZFoeGGg4JQBychMpIFglQJeDBXp8Fck4C2j-JQz5PBbRqVE-IPS-kIWQmM2CkzBkzLmQs1ptD6GpKYRkrJ6gnFgBcGKfJLiexFM8aUkRwyKlVLeEsmhVhuGXIRpUg5z0jkdL7HYThNymH1OKV4-waAuD32mLofxTyxGjMqTgN5XBNG1NEECrJqC3jaILNoiUMAXiYWwnhQiJEyKURonRBiTEcKsXYjgbwz4dq4WkOtZ8vhvArzzKAngVYIHvkwXAwR3hKDw0IdVZcOBKRpDQn2cen1UDNEEOgbBCCwqQOgbAjVuDkHgTiqFI0YN5KKQ5EQFSYUADa2jGAaS0jpLoekDI1lYNQj5PBUD8BsHvKRW4OFfU_ssmG6RFB7xPpyJ130EyYp4NQIicgVXyRzFAFucMXhhRhCyYlVwCDChVQVVwRUPWephsKmBWD4H6vwfI0hnJyHTjgAAQhwLogNcivqtQwnof0CCcDZpqPAMK_qZGBuoHFa1ABqQdMAAC6bY4SjpMV9flZaeDStqrKqkBAFXuIhiqnANRtLlT1QQLVFbdXVoIOKyValtUirPUg2tX1Hpxq4ASkNohHCUAgEql4Pa-27hwPDdIcAR3GPHagOKfzRCzoA72_ts7wPLqgwldU2AMJgAvRgytoqEHPrAl9WVZCmxNtbe2sdnbqDNqNcsz9ND7WmQeJoI6NB3Xvu9b6lG4AbxxODeuole84BmU0AJstCak1TX2lANNrdoiZvg1wVA409CaCLSW995bcNXsEYRghJGG1kfgK2mJLitCpVnWu9dm6mzbvlYqg9zRj3oFPdenDOqq1iolXQe9l6vMEbwURid1nkYMbLUph9eGn1BYM_WoKFCW04DM3E2DPBlioG5GlrgRB-BYGBNltIMAuQospvig5THRMWVdex0tHyuO5o8OCuAjSBDic9UJnjImWMaHax8yTuhpOpvTQpvKSmVNEDUxoDTRD13ac8_hmtwXUCGYS-R5L9zWv2EszmIdoXPW2aEXK3djnlXOZPbQM9HnH3Xtvb58U_nFuINi4a_b8RwsHd27mqLunAsGuI_FxtJmNsNOPNljLWX325fy68N4hXaAldeYMcrdqTJVbYwQDjX6vU-sayAL5Vy-s0M6x4br5kifIwG8mmTcmM1ja-y8CbU2Zt1cE49mL_3qCraB0lgnthWpWa03Bnqdnjt7qVdSQ9Lm3OCOu9F27PmIIPZ0wFpbBC33Y4_dlyL7Pr36braRxLra-cEHB2gSHmvocFffUVxHqLkf0Yq2jnrGOsfroa3vbF4EKenRJ6kKrPv4hU6G7JkbimGfKdU-pwqs25s8B-6r57nOVuA-M0lr3Xads5rezQw79mTv7rO0ei7MArsJ6e3dpX5eOcvpC--j7Hydcq6e_rgHhv1sZ8vJb83vyod5ZeFtWJOA0LPnh8V0JZXHeo80lG3SrvWfIw9zx1Z2yYCB9DeGnjkbtK6XX6IYPKbQ_yfDzmxnUfpsx4Xx13XemXtt6M0bkDWyoDrIqlnvbQuN0i6Ozu8XTni-uaXbubV4K53rK4LY17LYa7roN40I_p_qUJcCAb9qgbgbjJrK5IwbvpN4QF6535c6p6P4r4v65L4qHhzpqSjTjQ1iTTTQ1YEBzQLRLQgDEgeBrRwibS7QqCqAY50YPT5QLgJhJhwCpjeoZhZg5j5iJjyDyb8BTQ4CBjUAVhVi0D0CIAgCrggCYCKAlg5RNoeDIAeD8SjhCQiRuS9ZIAeCMw4CEzDCEyfwgDGFOTqDCTVTuSeRjg-RWSUD-RJBBQGFWE2F2EeAEogC5ZoABFJgli4AsBQAOEhhagGGaFpDph1SWEgAyGKhJDwjRH4AxhcD-D-ANoxoHggB6DEhQDoCRGZHjz9LlHQBsIYYxExghGlGYCqDAQ6GYB6HwBJEeA1FJD-DlEYCwAWGIwgAAB6wwgwhMOA6MDhRKCRkREx6MHo8xIAeYeYQhKYaY4hiA2YuYMABYqQugbshgDoqAkAzQihqAyh1AqhtY6hmhaABqMAO0lAnIe6tABigCSA-aQ6pRTg6A-ESQlAggGEqAiag2a-fxGgAJHg1UkRegfYXQLgFhpRtADYmStA1R6YtRIR2xIhuxmY-xkhRxiYWoVYVxChTItxyAlY9xNYDAmhrQ8g0AmgGEooX0qIhhYRMocoMJ4xrQ0oqAgYDhiQ0o6gREjo1kPJBxLgpR8AW0_JsAz41YWkBh_xKEpOlANQWRg-8gBh8p2pWhgEmS983uEhhxbRZp6YOKqABpRpZJGJ6YU0aR4xpEvM8R-af67pWppRupiCEAYxHg0waQDh2AQU9YNYOYwEVAFpkkPJ_pHgVkEgcZkkJ4kkW0tgggJ4_AmpcJJpa8ApIJTILIlp4xqAMoMJoR2A5ALImABhtqIAVZmAOExZWQDhYZaRc6WxiYOxYhJJxpmxeYQAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/viewport/post_processing/effects/tilt_shift/src/index.ts",
        "description": "A tilt-shift post-processing effect is a visual technique used in computer graphics and image processing to simulate the appearance of a miniature scene or model-like photography."
    },
    {
        "href": "examples/viewport/post_processing/effects/vignette/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlqKMUGgA1pxWPBowUO4gcAQAnrBweDC2HnHxeIlgKYQE8nCIxsYArqjy0QDmOFRExmBQlADuehIwAAIAjDgALDgA7MboEGntnT19OERoLXBw-SI8YQUmOYLCOwbo6eE8jNOqXGmZMCldEOgEeIhcgwAMbwCkANxcORCNQgvd5fb4eU4Rci6VT8OBcB4pKGoGHrECsExIlEQkwXbEXeHoFI1CAha6wFLyShwCQQagvfh6OCUKA1Wi_AiUeQvUHgnFqbFwcgaCDyAhcDKKFJESjoGqwUkacgpOCK4xoTC4Aio9HGQXC0UHTa8PUisUqpUeMoVKq1epNFqUNodbq9WhDUYTKYzAhzF2LABW2pMJoNO2MRxOnF2xCgwhAABoQDMAEJofgadJIMD8KAuAC-ifNaow2BwWrIICoNDoBAYECIlI0YoAVFxYdolAA1LhgDSOrgAcn62QUMAummMqggMC6mgHYNQ9cbYuABR4ydgGF8dXI4mo8bXDkS_Fo0ng1P3h6FAlonenXWXB6NAEk741ULZaABRMBgGC7pQYEgRc91QJ8rAABQAeWkbwAH0IIAJSggBhL9pGkZ8ADkAHE4K_XxfC_FD4O8ABNCCv3A0Q3w_AhaG8f88EXABHGoYE4PMez7IhB2HORFHHDRJ3vOcFyXSgmy4YAjxvGAUJqNJHU8CB4y4Z8lD7eR0G6VAv1gGwaDU59pCiTANH0mBDLFLje37IcR0EtQJynGdNBwEdEnQHBMGlfwcigRQNHnThOAACkYXQTnuDBugAShwaQuy4VwO07BdwthdJUHILgwrilLWGkw9qlkk8YDbLhXIfSSCCvag0iq-9lxStsun4CQytvZrarC1cjSsTFYReHTyBqaycEaWxLOs5N0mfdAwo8IbUQK9sAAlvAAWQAGRQ6FYRmmtqPiAkXg8Ih0jvGdlw2Kw8zihcrFK69ysqlw1lpVB6tQRqPovbhUv4drOte09zy-vrDyscRyGiWxEGh06uA8ABOABWfh-BGdHBkGdGwAAJj0bM3hgDG3jxwnxhJ1HyFRsAAGZUcJ-nxnZlmYBGEZyAANlZ3m9EJ_h0fR8ZccZxmRkJ3nyBGN5ed5gR0EJhWZdRxnicCchBlR1HcnIQJAnR1GRj0PRyDeRn-ECN5jZGfhefQBWmfQPR2fRo23n4D50DAEZefRw29HQRmYHRxn0BV1G3gDs3cb5hmHezZ2w8Cc2YFtsBvfGN53fQenAlR3nscZqEefFgR-FR8YC7x8ZBjDwY9H4ch0EDt50EGfxZbeBmwECVWRjAQYwHIGA-7pzAzcCJ30HGM2RY8E74mlTAoGurpPA0KBzpAK1KmqOB0A0cYYBqHWcHP_xx5oDQc38YZHLHZyNAdIhl6RngHj3y6z0-6gd1RAPQykaKsjUpzvk_DAH8f4AJATQDSOk6laLQNgf-AggFgJIMBsVAaoh5BaU0OIeALx-rI3iMYZsrZvA5C4HoTc6Aew7lAlwSgYBxR4BmFwICcCCA4DypgbMcoCAvA3HQdA24cqgRwFhKCiEtoAEEdoFWbMYL-8QGESKkbuL6YjGE6JkXIhRyiV4UKoTQuhqD6IVXQOmaIH41gCLCkI_gIjuQ4HRqo9R-DTp2I0A488Hj0ZmORhYrgtCKrWNoGw38Lh-GCKAm4qAoiuBvE8d4jRVh2FgHicE0Jp1wmRK4NEiqtBHCsXYs41x7iSkAjogxJilSYA4CUARRRngdreEyb4-I5TmIQDYjAF4pTGIVMGVUtpvgOldI0QWDREphlcGgrBBCyE0IYWwnhAiRESJwXIpRHAnZnw4Swl-bw3gqKHjzD9CB9S0G_gwd4Sg8NcHVWXDgSkaQIJ9nHp9VAzRBDoHQbuMKkCGkwMefA7BoFHqhTAceWgCklJEBUmFAA2hoxgGktI6S6HpAyNZWDkIoaIVA_AbB73EVuFhX1P69JhukRQe8T6cjxd9BMWTRDUBQnIAF8kcxQBbnDF4YKczsReGkYUAKCquCKiS0l8RwUPL4VgxBMjCGcmIdOOAABCHAWiaXSK-q1KCeh_QYJwDCFk8AwrUskbS6gcV0UAGprXsQALptjhPawxX0nqKqVT1JsnyqQEB-ZQP51IAU4BqNpcqIKCBgvuTYxNzzXlqWVamqFmCEEgS-nChlwCCnxEcJQCAfyXhmotbuHA8N0hwDtQYx1qA4olqsO6pZ1bLWdsbb6ltCV1TYCgmAZNUDs2qrzTgz5RCmw6v1Yah1xrqC6rinMkt2LTIPE0EdGgxKuU8HJZSlGIB_GBLWPSwN4omVLI8HAMymhL2Bp5Xyqa-0oBCtbtEUVnaXioHGnoTQsr5UHqDeO78Oa1X5uoDOrVc74D6rPY4uEqVO0BqvTwd5tVQ3fN-RDGNca7EQb4WOiFaaXl0EzSm4jGCoM4MLVe-ZRbMPiqWVmmj0L1VfVg0FEheqfL2OQ-20QyxUDcmEzwIg_AsDAgk1cWgXI0k4EpuurFJkH0WUJXuhVpKj23pADk-JT7FWLL3ve7dGhjOkpfboN9grhXfryr-rg_6iCAY0MBvBGHRDschZOmF3HNW8fnTgQzthWpodAx24N_Cvnhrw_85ohGE05tIyqp5FGwJNXA352jU7YXodJUxq9znfOJroxq2dfH9VhYIHJ0T4nQNSZk68OTaQYCKfSSp3pxXkbYs0my3Su6CD7uYy5il-nRlNImRxTlY3TMntZdpXSVmKE2f5e-z9IqnOsclQQaVjRPM6ZK9R3LnHoOoB49qhDZZptDNNeantrHG1TfGUM51brWNevbK9gZQzCsnZuthuLEao1oCS_GjjSays5vTZR7LZHIP5YLQD5GvXFVloraQrg3ba31pe6dsZf32JttA853H_De1hV-80wdJYsAjrSxOvLAWYNBeu_x_pzTV1zMPB6tSo1xo1kmtNLTBA5oLSWiAYkHg1pwk2rtFQqhhtrtQA9fKC4ExJjgKmclGYsw5nzImeQX7-BTRwIGagFYqy0HoIgEAq5T0dYkXQcgOqPDIA8PxUcQkRJuUs0gDwjMcCE2GITT-IBvdOXUMJaq7lPJjh8lZSg_kkhBQ90HkPYePDzJAFJtAGekz0_wDGCPIYtQe8d2kdMdVA8gBN4qJI8Ji8sCgFwfw_gtUcoPCAPQxIoDoELw38ebe-_QCYUO3Arec898wKoQCigSw5Xd2QDww-kj-D7xgWAAfEYgAAHrDEGITTxEfFnl8L_v9GHp0Y57zFrlMaZ9eIGzLmGABZUi6DdoYB0qBIDNEt1QGt2oFt1rHt0dzQBhRgB2koE5AjXKVAg9323Yh7ycHQEQiSEoEECglQF5Vs1m0QGQJgB72qkLz0D7C6BcADx71oAbCgHKiH3TBHxzwfx1yf0zBf0N3f0TC1CrH_wtyZCAOQErBAJrAYEd1aHkGgE0CglFC-lRE9zzxlDlAIOWkdGlFQEDAj0SGlHUBQnUJrAUNfxcB73gC2mUNgGfGrC0iQI0BQLvUoBqEby2gUA92MOII8EwHIHoPvkQINzf1n3_B8JPC-hcPkDcK4JoPTCmlrz33Ql5jL32wrViKIJ70cMwQgF308O9Aj2wCCnrBrBzEAioF8MkgUNSI8CsgkGKMkhPEki2lsEEBPH4FsPsKUNlFgAwKZBZD8L31QBlFm1z2wG8JqEwA90xRAH6MwDgjXhUNRFnxyJAA9Xv0TEfz1w4PcLzC2KAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/viewport/post_processing/effects/vignette/src/index.ts",
        "description": "A vignette post-processing effect is a visual technique used in computer graphics and image processing to darken or fade the corners or edges of an image, creating a subtle or dramatic framing effect."
    },
    {
        "href": "examples/viewport/post_processing/effects_and_interaction/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlqKMUGgA1pxWPBowUO4gcAQAnrBweDC2HnHxeIlgKYQE8nCIxsYArqjy0QDmOFRExmBQlADuehIwAAIAjDgALDgA7MboEGntnT19OERoLXBw-SI8YQUmOYLCOwbo6eE8jNOqXGmZMCldEOgEeIhcgwAMbwCkANxcORCNQgvd5fb4eU4Rci6VT8OBcB4pKGoGHrECsExIlEQkwXbEXeHoFI1CAha6wFLyShwCQQagvfh6OCUKA1WhgtE4tTYuDkDQQeQELgZRQpIiUdA1WCkjTkFJwGXGNCYXAEVHo4w8vkCg6bXia_mC-WyjxlCpVWr1JotShtDrdXq0IajCZTGYEOb2xYAKzVJn12p2xiOJ04u2IUGEIAANCAZgAhND8DTpJBgfhQFwAXxjRsVGGwOFVZBAVBodAIDAgREpGkFACouLDtEoAGpcMAaG1cDz9bIKGAXTTGVQQGBdTQeMGoKs1wXAAqCdAAGTddE0UYKcdgGF8dXI4moG5EvIEtGk8Gph4KJ_4tBbo66s6PPAAkgB5VlRVAwACiYDAMD7koMCQNOB6oM-XAANKaN-UDSBAABeMCQQACm-0jeAA-qhABKb4AMI_tI0gvgAcgA4lhP6-L4P4Edh3gAJqoT-nCZu2nZEN2IC9nIiiDhow4PhOIBTjOlC1lw84iC-ZYaPw-60qgP6oI0aAoQU56wPuACyuj8I064FHJtAKUp1BKLe_CQS-SgKY0P7qDQ7GcV2PZ9gJahDiOY6aDgAG3jUiRwDgaBmYp4GTpwnAABSMLoJz3Bg3QAJQ4NIrZcK4zYtlOcWwukqDkFwsWpdlrDSQU1QOIkt4wI2XC-Y-kkENe1BpE1D6ztljZdPwEi1aeMD3mOs6xTJViYrCLzoJQ5A1DYNA4EZBA_rAS0EHG6QvugsUeNNqLlU2AAS3i6UuBHQrC60wJtkE8A8LweEQ6SjS1tYbDwmapVOWzGEN9WNS4azKe1qCdSDl7cDl_D9YNN5nheykTQUPDiOQ0S2IgaOiB4ACcACs_D8CMhODIMhNgAATHoaZvDARNvBT1PjHT-PkPjYAAMz49TnPjILfMwCMIzkAAbPz4t6NT_CE4T4zk9z3MjNT4vkCMbzi-LAjoNTWtq_j3O04E5CDPj-O5OQgSBIT-MjHoejkG83P8IEby2yM_Di-gWs8-geiC4TNtvPwHzoGAIzi4T1t6Og3MwIT3PoHr-NvFHDvkxLXNe2mvsJ4EjswO7YCh-MbyB-gnOBPj4uk9zUJi4rAj8Pj4xVxT4yDAngx6Ip6DR286CDP46tvFzYCBPrIxgIMYDkDA48c5gDuBD76DjA7cseA9XBipgUDvZ4GhQM9ICmpU1RwOgGjjDANRmzg9_-AvNAKVA_jDJ5A7eRo1pEDvXGT0eKvXPKDagX0uA_XyseDqgpKCfg0n-ACQEQJoBpHSLg75EHfmQYBAgwFQIYJhlVXU8hOyKFrKOSopD4ihDrA2bwOQuB6G3Ogdse5wJcEoGAIUeAZhcBAigggOBSqYDTJKAgLwtx0HQLuYq4EMoEVwj-H8ZFyp1mMLjHgrDZHyIsqgaRbD9GKIAIJLlQidUxu8tgMK4AAdRyE8TQfCGoIMkBpK4eAEFQHYXoBqrDgqJHQKI2K4j-CSJeGmDMMANFaN1DolkGgXgEA0DUTSCT6GMOYQOIyVxUl0EaE8UJ4TImvBwG8OJ2jBHoCMtIApaknjAjeDYrJXAmENSoJ0LQPC_gPEwNwXJ8ASkgQiVAKRXAADE1N9Zp34FUzJ_CU50B_LUmABFmSSTPpM_8uywCAMycYOxHSWFJK4FjDQcErhIRgCMiR4yXgwUuUkBCyEcAth_LhJiWFpC6XMUuBZdCLlwVeTAR5sEXk3JwEuUxuEKI_laUc7JDVUCLX8T03hcB-DViyFwGoLh2FgEknvSRMxsXyFgI2GgEB0w0upGpURuEYAAEdiQhQcTAPQFElxcGpncsZEzKlcE0dUogpKsU4rQI0F4LTqlIvacw-QkoXBXEUAOURpimrpnSdw3hyFOxcGmFi3RcJnFcCVTEwR_58H8rKW8CpgL4gWpcNINV6AZWIuOcwrpxLekjmpLompRlQpiNGWUnZeywCOqsP6iAujVlGQ2d07Zkb9nRjlXYxxtgcg9PIOQFkmB2HyCTKqXVVwkj4IHNwvQXp8FwmyD4vxDVY26NtQ8oUaTYnCviXQrAuF-DpBSZ23G2ZcbCjBVwdCmEcL4SIiRciVEaJ0QYlhZirEcBvh8EucibERCZj-g4OB3CcG_mtfubwlAsYkOarOHAlI0ioU7AvUGDLFx4P3PtXU7ivynuEYQ9BUURC_RiiIGqiMGpmvCpoSKylVLqW_FSotnYRyYHhIKM1N7WrVtrfucGnUoPmXAnBzxOVvxdCwfJGD1BiPfliph2swHUDVQBuB1x5adLgX0qgQyLjdDsMXGhvDhoK16V0EZLQpGxzaBEwQLjPGNBlQPQRqjKk1IaRwIuUy0GDFyfE7FFwHGuPicYwUIlWhYqwEFBAXqbxfjWcYOW8BqAcCoHFLcxw0Ab50BwNuIpeA7MAGoAvlUmqIKGykXNuZaPw3xiRUAAG0IAAF0cDoGsne_FeBYpkYoxFAxVk7ATXY_godOqfqMasOF6gkXMDRc83FxLKWajyDS3eTQ0NFMFEzCBngi4VxpDXApzKLYcA_g-WRbwa6fw4HIt4T5piGLvjIhlH8S56LYTfGRKMpUu2uEqqFngpZOo30Mk5csLw7IOTOzQXqDUmyXdO85AgB6eD0ZEfeggj75rIwZd-pBZ7VTxb-7ggHF6r0pfzQIDQ2l8Eowq6IN7d6qSfafT95owPf11qBye99BAwd0BS4uGHBjP10JO45J7NWYC43h9A9iqVOuoGjLGOACZuPJlTOmLMMZi2Yx4zgH01BiylloPQRAIB5wgEwIofMxVqEeGQB5fiP91BCWaqJHGIBuY4GpsMamgDeLf0EsJPyf9AoEGCsM5TBiFceG17rnXHhR0gCIANJjSAPBKgLCwKABv_SqgV5LtIJbbcgGLTKJI8J8y4B91wfw_hKAy4N3oYkvjQ_h4XlAFhqf2Fe5j-GJ3G4pcwFUMBGXAzyDy7IB4DPSR_Ap4wLADQoeAB6wxBh8sJgb8d_vW-E2dF3kAmZMzM_jImDniBonc9SHxgwuBSyQGaILpnyASzUFFxWcXku0BENoEuSgievu0Bt0gVJ6Si9OHQEyzogg3yoAInINS1PT-dqL81UPehOxdBcM39NIBaA4r1Tp5JiZ5O6j6s7j4piT5c4wDZj_48jUCL4C5Mgr4UDr7lgMCS6tDyDQCaBvgCjKSoiK4u7iiSjP6a6tBiioA-gG6JBijqAbJECbREFT6aQgDwC6SkGwBaYUIK5n5sFMjBQLz6TyAK6sFF6YD5pJi3hgyc4xISGARQDSGcYKBiEwFF52AaCrSh7ETix-6pIQC4Yv7n4eDuIqC_6a5GptR_7YCUJVjljpjARUAKQECSREH8FF53QSBOGSS3iSS6S2CCDWR8Gv4vRcEwBMpMgshRQe4gCuaYCF4eDYD5o1AJFIDxYeDxEwBYT7xkGogSFugeBJYj4xhj7s5QGsHD6ZhAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/viewport/post_processing/effects_and_interaction/src/index.ts",
        "description": "The outline effect combined with interactions."
    },
    {
        "href": "examples/viewport/post_processing/remove_default_effect/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlqKMUGgA1pxWPBowUO4gcAQAnrBweDC2HnHxeIlgKYQE8nCIxsYArqjy0QDmOFRExmBQlADuehIwAAIAjDgALDgA7MboEGntnT19OERoLXBw-SI8YQUmOYLCOwbo6eE8jNOqXGmZMCldEOgEeIhcgwAMbwCkANxcORCNQgvd5fb4eU4Rci6VT8OBcB4pKGoGHrECsExIlEQkwXbEXeHoFI1CAha6wFLyShwCQQagvfh6OCUKA1WhgtE4tTYuDkDQQeQELgZRQpIiUdA1WCkjTkFJwGXGNCYXAEVHo4w8vkCg6bXia_mC-WyjxlCpVWr1JotShtDrdXq0IajCZTGYEOb2xYAKzVJn12p2xiOJ04u2IUGEIAANCAZgAhND8DTpJBgfhQFwAXxjRsVGGwOFVZBAVBodAIDE4nAgREpGkFwAciX4tAAahAYF06wQo02BLRpPBqdQuJmuGANDauB5-tkFDALppjKoO11NB4wahOAAKWHpVDkLjbgCUXFcrC4wAK1T7LZgXHsK873YKpbSXCfXco9bPD66_AkW821XbttyvXVMVhF50EocgahsGgcEaWwAFFYAQgg43SABJdBtw8SDUVPWEuAACW8ABZAAZABhaFYTQmAMKjAoeAeF4PCIdJ22fb8CA2HhM2PTctmMID73sFw1lpLcRDfQ0hxk39-H_QDeX7GBB2k6gwNYoUIHIaJbEQPSeA8ABmQYAE4wEGEYwDeQJyEGGAADZxn4QJxns9BAhGcz-HIGByDAdBzIAJneEYrPGcZwswPQ3nIdA9AAVn4N4Ur0cyrPMwJUtSqzwv4QZUtcmBAnM8ZzLeGARlS8hUpgDywCahlUvCmBSr0FzzNc9ARhGDKirAcZBkEErzMsrrctSxKwHC1L0CswbAn4MBzJGdA3kEba9HQdK9DAQIrL8iK5pi3IrLc95XL0RbItcwb-tKzy7p6wI9BGN5Bjs9Bjqs9Bwtaqy3isxLAgq8hPuumA9H8cZUsGO6YCq8h7uW1y1rebLGvqvR1oCmAkZgDwWN1MVMCgHiuk8DQoA4kBTUqao4EwGpnJwGAan8IKaA0dN_GGOdFEXDRrSIMm9PY6cQC4rThy3EACiEzdrzEzpKHkIUikoGpAQfKAoC4RJGjdTQFy4GAwDAYLVQfDATaYyh1B1piCjAb8j3koV4W4T9uxwSk0gABUnILpNQZpkIIFCbbt7xKCM1A4BPY89IDvig6pAgw9gxSo5wRIxXUOPbfIAhtwIYTOCEk9N2jWM4ATVAkxTRA0wzGBsxAeRAuifhkJwH1qGLUtaHoRAQCvEBMEUfMDw7VFkBnEWFzUJdP3XJALJwSK948bNOIApWTNjfNcBYKApdSXkDWXme0iTfid97pMguNpUCyvrh_H8LW6A3z0MSKA6APBnz7jKJIXBgHQHQH7ZU-BwyHxYrPGAqglAwHnpgRe8BwEz0gR_fwwCMCwA0OAjwAA9YYgxwo4FSjfYU8A74CgoSAShqVnQMJAJmTMjd4yJmTKmdMWYcy6BSoYa0qBIDNBHqgMe1AJ4VinjPNAkBUB9CopQLWedaAVxkuAggGgagwFQU4dAAAlJIlBBAAHlUA0TkFHUmSAjEmNQZ-NhehJxdBcOQ6MHhaC1igHeNhhCkiH34c3QR7dO6iJAKqUsMjh5MnkcgEsijywMBnq0eQ0BNC2IFDJB-nFxSShcWfVoYpUA-hvsXF2MAaI2gwsvOJpiPDwAomU2A2EyyTnkIY4x7TUh6ygRRBQ4C2moMwOQEJAtxDUEmSI4ZMy5kthkuMgZwiu6oLsBoGObCULSFcjfNIfIK6DPcR4PWBAVD-LPtMNIN9sCKD5BhdMmCqDzO_MvNxwymISE-d-Fs34KK2AmnYS5wzKblKsUyFkCzT4eFQOKFxR8QDYFmTUTA4CADayLUUAH0YVZBvo8l-ABdPhMYBGtyER3ZZvDMxAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/viewport/post_processing/remove_default_effect/src/index.ts",
        "description": "Remove all post-processing effects."
    },
    {
        "href": "examples/viewport/screenshot/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1dR6poozkuqr8cFxFef2og3DdJuOTPSbpqvNw5BoQ8gRc2Yp5RJToAK6wIXAa5Hmn5MZomLgEUyCsJitrG-EmiSmcJixQwiAAGhAEDgACE0PwNEkkGB-FAXABfIGXa4YbA4e5kEBUGh0AgMWKoCBEeSUDSbYBxBwaAS0ABqEBg-VJ5IBVNWtJg0ngcAg1DZIkE6AAMiDaKhNAKeABROnSgBy3m8AE0AArSgUIrhgDSUIhcDwAATgckUi00xlUjPymg8XVQnAAFEMkqhyFxHQBKLiuVhcSkiYzGamcrj2K1MlkEdnULJcCPMsmbVxh_L8CQh_j061Rx0BqyzIZldCUcgHGw0HDNWzS2AVgigpIASXQjo8hYe3qGXAAEt4ALLCgDCAyGtZg9aloiKZQ8RCSDMjSY8U4RnvtVKDmdoYcyPL5DpEOLjLjgvOoPtT6c2HKzXP31DzVJ44nIAGtbIhn6IPABmcoAJxgOUAAsYCVIE5DlDAABsADs_CBHBYHoIEIG_vw5AwOQYDoL-ABMVQgQBcFwfhmB6JU5DoHoACs_CVDRei_gBv6BLRtEAfh_DlLRMEwIEv5wb-lQwCBtHkLRMAIWAUn8HR-EwLxejQb-MHoCBIEMVxYBweUgg8b-_5KaxtGUWA-G0egAGaYE_BgL-IHoJUQqVHo6D0XoYCBABaEEWZJEwDAAGwVUMF6JZhEwZp6m8Yh4UqYEeggZU5Sgeg3kAeg-GyQBlQAZRgQCeQSUhTAej-HBtHlOFMBCeQEXWTBdlub-kniXo9kYTA1UwCu357JgUCLvkngaFAs4gIQBDyHAiBBnAmAHFBOAwAc_hYTQGhwv45Q4CaCgwOaGg4FQRD9SIPAzgaIDztyZ4HhdPBrhugbBmmGYHDQ0BbFE2oQM4mx6AIBzZFwNJomsqDNFwb4QO-wxoFS_AfZsEr5Fwqq6kQIIwI6jo0nAlBQOo3q-t-QqilkdCaI6soKkqarSjgABKCpKNKLNNvKADiOCgtKACCPjKgA-mz8oc1zvOi743NNtIPbSkoALg_AxOk1O66EjwW63ju9gvEFqAmpQ0ZHrGmxG3QpvJvGOZJlWtjSByNt4GbXqvbrwamxj1sm-7mxoFslDyFwsBgDeZIShoMYm5s8g0gml7o1wTZEPw1aOpZlSqzn2siInMAJvt2SwDgpK8uIF4ph48lE1AoN9SA9o8EXJdZDkMAYqHl4eLUdpUu31r7Wcl7-7brdcCWZb1jgnw4AoigYI6w9MgXa6e5wgLAmCEJQjCcKIkC8iYW-mfdwAVkTqBYji4r4ogICUiAmDL5gbqMg8yBGgdZpqBaBMtokB_hwIRMBHgkRznTA6EBwI0S4F-P1EALx1j3A8D_FBdhyQYI8KfM4MAoAjAQfgYgRD_D-FDnQZBegDjQHQLgkA-CsJENofQ4htxSEkEgWyV-xclAwHfnQcgX8MEv2YYQ_wtCMCwFjnAgAentco-EcC0WQdseAqw0GMPkbRHAIFVGQIRDvEE4JUCQmhIgWE8IYBIhQboGihhTrUEgM0HA19qB32oA_BgL80CQCJLQYUlBQ5YzNthausDEAEA0AcGAvCnDoBZoQygggADyqAhxyGhs3aJsT4keATIwvQup8guDkbw2gJIoB3kYRIqAkCTF73MQfKxR9bFAnuDiVx7ib5eNxPQJ-L8zryGgJoNJGwDzfxfoNI4uT2x6j2Kga-yCaR7HUEORZeJv7WJcLw-A_Z9hzKbLiXU8gMExLibwomBwCH9gUBg3ZBS-HkBqdtSJjz2m8MwK8yEWYDz3POYfGxlTITVmjHA6U0gYLIKyGscgEK8lXI8JQUGKg5FflfmKZB2BFBrHrHCARVB3lkm_pc55E4JBErJFmMk_ZbAGTsBc_JvDZmwGSQ3UGj04GoH2M3KBIBsCvIOJgDBABtDwvLMCizZfAZB6QsgeAALrGKBKY_elinkIm1UAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/viewport/screenshot/src/index.ts",
        "description": "Take a screenshot and display it."
    },
    {
        "href": "examples/viewport/settings/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlqKMUGgA1lwaMFDuIHAEAJ6wcHgwtiF48WBJhATycIjGxgCuqPLRAOY4VETGYFCUAO56EjAAAgCMOAAsOADsxugQKc2tHV04RGgNcHAhYZw8JlmCwmu8Buip4evjqlwp6TBJbRDoBHiIXL0ADI8ApADcXFkQtYT3T69vDyHCLkXSqfhwLjXJKg1Dg5YgVgmWHw4EmY5ouDkDQQeQELhpRRJIiUdAVWAhOAachJKnkYxoTC4AgIpHGLE4vHbETrDm4_F0woEYqlcpVGr1RpTdqdWh9QYjMYTAjSma0HAAK1ZJj5XJ2Jj2B04G2IUGEIAANCAJgAhND8DSpJBgfhQFwAXytdIZGGwOBZZBAVBodAIDAgRHklA0-IAVFwIdolAA1LhgDSUIhcADk3UyChgx00xlUEBgbU02cBqAjUZjXGADni_FoAGEKilM54IBauABJJQZ-TodqoACisBsNC47rTGazufziiLGhLZYrGhw-fi6BwmBJ_iyUEUGirnAAFIxdAcrhh2gBKHDSFNcVxJ5PVi8Q1Kochcc_3q-rANjsPDBikXCluWdb4m-_BtPwEjvg0za0Mm64weewCgVYULoPc2ZEKk6HQdGBDZhaOFWCiEL3IwAAS3gALIADKtmCEITjAU4EKwI7kBUPE4LUthcTxNqpH26DntmNFwNm96UTyuGlnAECdFEaT3M-yY4MmfbSH2Np9ixfbeAAmgA-kxADyShjjgTEAIIAHKeE5LE4e696fsp5RxAI6BcJQFT4gAjhUmipFw8gOvwNi0M4abRlwHjiOQ0Q5CACYYKlIAkpgUAkW0ngaFAHg4eB-IVGVAAKcVEJCb6oOWXCeAASix0gCNSeD1Ro8VwOet4jm0OCtKC4jUFuPWOD5lXUBB6WZbBXA1VA_WDcJtgycttgKdW1GLfiBUJMVpVQK-a11Q1cDbQQMmnUV64XQdnALagEEuEsEDUFd8GIfiOkoQItDdT91BYVRojXARRHg2p1AUdDPB7QQ9xo1wAD8WM5vw_CBGAACcRMAMyPAMejoIIvSkwAbGT_C9AATKT5BE70gTDPwdP8MMdMDOQtOkwMACs5ADAMgSBL0AyCMM5DDI86DDET1MwL0eii9rejDMzqui2Aeh6MzYDoHTLr8PThNgIE5CYBr1uBMzvTDMMmswOQpOE5TpNE-QoswETRsG6LegwHbzNa7btvU3TjyG-ggvoELSuBAMjwu5z8uPHTEei8MgRM48du9EbdN6ALzPB70MB66rGtE3oLPoI8ROS1brvp4TVt6AT_iF-QgR0-QMCk2ApuuwrjyV_wAfU0bejtxHAwwMjylWE951lfcW8vWV2O49mRQlGU7LoBogQwBUQs4Nf_ijzQA1QP4_RLoWaiaA0mbZl582oB9L6thxCoFqE1ZCmAXTkgIN1YUaAwEAG1syQP4NA7MABdQ6ogAZIW-ojVAOAFDyCgKkWBICwFYUgpofBBEKKQXXJoe4jZgyQFqPcFwcDQFDUArOT0DZ6GkRjEwhMGgMYaEir2UENgBpiIkVwOgpYMyoB4rImAvYRItWfqo3sUQfjowJOItRMVKApHkBmUeP1QHaNOI_GAqiZwzn_jhKCbQYJbjwO0K6BBDG-SsDg_ELi3FSM0PwLGOAABelBMzeEoOeKokC0CFl7MAMkA0pqoHuI8byvjRD-WxKDGACYuAX0oMOUcXApwVAJJQU4VwCCOC4OHAgFY6DFIgGAMAmhQynGAfA5Yykqo9M4WA7sKgThvn4oJUMIMWwwDEqGGSxw3rKQ4eQuAoy1BbjSLAHAUY1LpKutmfgeg4CUCgKFNeWCeCrL6Rs1QWzzg4CuDcPAhzmaPHiEQM8KzelcLuQ8nZBBSmHMeN8qwkyhKGkIfIRQGBWx4GgNJG5fyIBjP_tRVCMB2ydiIN2c8CCUa8AHEOUa45JyhlYNhDeuFUapEUAREpZS2ioHXjSmlqB4p2JzGQvprK2VWCgMchIBEeVcL5fysCHiIAWPuDZPQGpPYEBwJlVIQ1gYoOgaKsBilCVWHBOcrlcqFXkCVSqtVKY9wwCgVAGBvztU4EZNgGyYBFlWtQTahSSkJWiGoPC3QIl2JQCgH3DK9xvy_n_I6rA9xUCCXDhoQCrhgJUu9TSwZyKwFXXVW6zVdq4AIKNYq5VMBVXnmzda21wy4D3gQVG9BCZIQqsoGAAkdKYDNogTmm1Wq4CYN1Wy_xPSIYEKISQntlD1DOF-hknMdCXGMP4Sw747C80AQcXwxsgSyLCIdNY4JMiDFyIURAJRKjD1GI0SEqA1jdG_HPb2PZxRzHwDUlY-9Ni6Bcu8ZFdd6LU3ukJQB5S6DewZvWaitQ_9vIAWrJaa0cA7QcsdM6V0HorSxQyvwESmpTmoEDMGWg9BEAgGwiATAsLMC_jLAiZAHg8xyGXJ_Vc86NAeEQB4UmOAXZcY8JREA9GCwrjXOWL-25CyWoPEeE8bGONcf6MzDwnoPBEEQgApAHgo34FNLxjwuoWRsdIykB0BAZMgFitSBIUJfS4BYJdfw_hSl0B0yAPQFREWmfM6PS6rnEVWaZFpkgim-OYFUEoGAFG6DkGowZjwnmEj-FcxgWArH1MgAAHr9BZjgUWznCTwGxPyUzaXRYKhyyAd07o4O2ntMhxALo3QwE9MkXQ6ADC4CXfULU1B8PUEI2GYjpG0CQBrLQFiUT5C1QzLQE1062PfrUR4Jw6B2oJEoIIGyqA_WgJgHNwxfGXGmb0BmNoLgUt8doJGQVtAPMOi84pqrCGatOjq6hxrVoWQdZw915AQZeuhgYKRxo8hoCaBsniadNHSMFXJDt1LjQSSoC1M5z5lB1CtkzDxGj9WXB8fgExUkMO-whiHLtiRumQoWaYgoNj2OFtkc9oKtJs2UMNeCwzuK6SqfyBp6987DoRImdS2OaQdNnMpBxCa0ndOQoEBUCl9jZHlTOewCeCMoZXRhaoGk6MNH5u4_mLLz20YWzRiYrYQQLZ-BS749D2AK3TnnPSaZ1ApJYdKZANgcg5zMBsYJSAF3mBLK2_gM58YKQPDoMq1aarSHnu04q-6IAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/viewport/settings/src/index.ts",
        "description": "Try the new default settings values for an example model."
    },
    {
        "href": "examples/viewport/spinner_change/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1dR6poozkuqr8cFxFef2og3DdJuOTPSbpqvNw5BoQ8gRc2Yp5RJToAK6wIXAa5Hmn5MZomLgEUyCsJitrG-EmiSmcJixQwiAAGhAEDgACE0PwNEkkGB-FAXABfIGXa4YbA4e5kEBUGh0AgMCBEeSUDSbYBxBwaAS0ABqEBg-WJpIBFIAojTWQA5bzeACaAAVWSyRL4ADIAQQA4gB9PmC4U8aT8gCSnM5rIAStL-QB5aTK7zKnWc1WShVcGnK_Wg5Wig286UAWR1SlZnARXDAGkoRC4HgAAnA5IpFppjKp6flNB4uqhOAAKIZJVDkLjxgCUXFcrC45JExmMlOpMC49gjDKZBApOKyXHLjJJm1cpfy_AkRf4tMjlfjeassyGZXQlHIBxsNBwzVsrNg44IoKSyvQ8Y8A4emaGXAAEt5HaKAMIDIYzmBz808IplDxEJJ0hnRwEUnh6DS6dKoZplPtWLh6A5wJJHX2GBpHkNBUE0RAnx_DxCAIeQ4EQAt600HAgwUGBQw0HAqCIcMAGZjCSSgDgIA49BgcMihgShymMfoCHFLJvVQfhSJweQPw8c9RDgMDUAgjR-UoOAJAgag0E_bQVTVTVtT1A0jRNTlJRwUEdR5HVHWlUVWV8bxoKRaCI1EvRoAkJIykta1bXtJ0XVZHBVWkbxxW5CkEXTWMKXrSscEEdBfCgfhmnjMUpVlAVHNBTxpAdZ1XS8910wzWNAWBMEIShGE4URIF5H4cgAGsQpgHAACs4GoLEcVoehEBAckQEwRQ0RTekHmQAN0JDNQwxQjQPCgkB8JwAAmcpxo8IyQCINs4yQDwbnRX5uI8F51nuIamqySEq0WkACrOGAoBGNFcF-Lh_H8ShWrWkA_2gdAho8I7yBO38Dies7bnwYgoGmllmpgVQlBgVrMHa-BtteyF3qgfw_wwWBBoOgA9SbyjGnAAFZ7u2eBVk2l6QDRnGcAAFlx6aEXSkFwVY7LEFheEYCREA4DfAxcBxSBmgqqrUBq6g6vxBqmrQSBUAkGBRUoW7-W9WhyHEaghoIDQDhgIGnHQDUTsoQQdVQfc5A_GB1c17WPHrEmX0ofIXFRoHaCJYLaBJt6TumunMsZ6FmdytmgXuXmWgF6rkGxEW8QYJrcLAlGdQ2cTUE6pq9kOY4DtwvZUEq-6qT2dR9x9OdOpZlwgfgICs5gZVcW9eRLa1oGqoOY7HQUIbK-t4HyGC19VYWwPWaBzAB8hTtU675ucrHjw7A0Kd9uG1lpAANnu5iIBVlu-5IggVFR4b0iye7sEUNY5zhMGqCHklOo11uPFPCQ75JTsSUdWxBE7fh95A0zkcGA-sqpQFIqnEmqBgKA1flgAeBxMBDQANoeBgZgaUwDYAPHHiCfaABdWmQJ6ZZQDr3BElCgA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/viewport/spinner_change/src/index.ts",
        "description": "Adjustments to the busy spinner that is shown and positioning of it."
    },
    {
        "href": "examples/viewport/visibility/example.html",
        "codeSandBoxUrl": "https://codesandbox.io/api/v1/sandboxes/define?parameters=N4IgZglgNgpgziAXKCA7AJjAHgOgBYAuAtlEqAMYD2qBMNSIAPISQHwA6qABF8zAIboO3HrwIQCsVgGU8_AA4wAIhABuMAE5dp_DACNKWRgHpxkmMNG8iMAvy7k5GuLYC87EAFUAKgDEAtAAcHlzGlrzGeAJCnJw8jAboAJ7h8ehqXHAESbDuIADuEOgEeIhcAIwADJUApADcXFEQAOaEZVW1dR6poozkuqr8cFxFef2og3DdJuOTPSbpqvNw5BoQ8gRc2Yp5RJToAK6wIXAa5Hmn5MZomLgEUyCsJitrG-EmiSmcJixQwiAAGhAEDgACE0PwNEkkGB-FAXABfIGXa4YbA4e5kEBUGh0AgMCBEeSUDSbYAODQCWgANQgMHyxNJAIpVJg0ngcAg1GZ1IAktJeaDeQAZXneACaAH0ALIAeSUAFEuAiuGANJQiFwPAABOByRSLTTGVR0_KaDxdVCcAAUQySqHIXGtAEouK5WFxgHFQsYWfxaFx7Cb6YyCN6cVkuMGGSTNq5A_l-BI_TTTaHrV6RDxZkMyuhKOQDjYaDhmrYFbBiwRQUleehrR4cw9XUMuAAJbzS4UAYQGQwrMCrAO9PCKZQ8RCStPp5sBI6jIIgemgEiSZT5AqFoolMvlCpw0oAggA5TyH4XehHOy3e4y-1aswOZDlcq0iCObFxwTnUN0JpObA-_psi-1AZvO4jkAA1rYiDzjwHgAKyVDAegAEz8GhABs6DoPw_AACwAMxof05SBGhgSBHogT8OUaEoWA5QAJwEbCRGIXoNHlERMBscR_AwIEzHoFhiEAOzMcx5T8IEYlgCJAiYZUdHkIEBEoQR4nkOgYA4Xo5CVCxOnlFhgnlIh_DMfwWF6ER_Dieg0niWhaEEYhiFoVJol6OgXl6OUYDYXZYBgERejiYI-HkOUulEegyFhXohHoEZKmIVhRmBJUulgIEYDie55CsThgh6AR5SmZFRHEeUMCufFWHMXZaGFURTFYeJ_icSViEKRhlTkAp5BoRxNECERFn4Xog0JR4w5ZlweyYFA075J4GhQOOICEAQ8hwIgd5wOgGjiTABwxTg53-OQeIaHC_jlDgeoKDAhoaDgVBEPN85jlqICTuy36vh4l7XrEb48HemR4JQ-RbFEmS3agMBcPkUTcDA6hQiUaDNCMwyUoISTetGobPbD8PxgQGgHDAlpXi6lqAsCYIQlCMJwoiQLyPw0H8GWOAAFZwNQWI4rQ9CICAXogJgihog6dIPMgOovQaahGtGs5wSARE4GhT1oR4SITkmVpIB4Nzor8P0gC86z3B4qv23YpLOx4vNnDAUAjGiuC_Fw_j-JQCt23oBzQOgHsgF7t2-xHUd-7c-DEFAJvDnLWNKDACuYEr8DO7Lcc-_4EcYLAGgxwAek99E4IhdvbPAqyOzXiE4ARDcmwiLMguCqCQtCiCwvCMBIvbujoAYuA4pAzTC6LqDi9Qkv4tLstoJAqASDAwqUKHAAK6q0OQ4jUM7NN05nTjoAASj7lCCLKqDdnIqBlpftMwJn0Yx3o6p8guCrnOEAtAiRQGAjHEu6cQC9yBP3dmw9R7czASsag89F5i2QNiVeeIGCyy-vIaAmhZQbFfCrWWy0jgwBjl9PYqARZ20pHsdQ3YNRVhVign-Hh4DSn2DQ3kuJ1TyC_tfDwosDje2lAoZ23DM6YHIJA-658LYjy5jwrOSjIT-lfDI0RnMx6ZzdmWMMlsQAKmkFhO2WQ1hnzEZoygBwCAqBAbrdIWQ7bYEUGsKscIc5UBUSSFWV9NGDgkAEkk_oSTSlsFFOwDjM7UNgA_UWUBnEg3MagfYtC4GZ2wEog4mBnYAG0PDZMwJKZJhdQEeLMQAXXgazAeQ9DGIgRAiIAA",
        "githubUrl": "https://github.com/shapediver/ViewerExamples/blob/development/examples/viewport/visibility/src/index.ts",
        "description": "Decide yourself when you want to show the contents of the viewport."
    }
];
const markdownFiles = [
    {
        "markdown": "<h3>Augmented Reality</h3>\n<p>The examples in this section show different use cases of how to use the Augmented Reality feature.</p>\n<p>Create an AR experience from the contents of the viewport. You can do this by either <a href=\"https://viewer.shapediver.com/v3/latest/api/interfaces/IViewportApi.html#viewInAR\">triggering AR directly</a> or <a href=\"https://viewer.shapediver.com/v3/latest/api/interfaces/IViewportApi.html#createArSessionLink\">creating a QR-code</a>.</p>\n<p><em>Read more about this in our <a href=\"https://help.shapediver.com/doc/augmented-reality-ar\">help desk section</a>!</em></p>\n",
        "path": "examples/AR/"
    },
    {
        "markdown": "<p>This is a collection of examples for the ShapeDiver Viewer.<br/>\nIn each example you have a home button to return back to this page, a button that opens the GitHub page with the code for the example and a button that opens the example in a new CodeSandbox.</p>\n<p>For the documentation of the Viewer, there are three main pages:</p>\n<ul>\n<li><a href=\"https://help.shapediver.com/doc/viewer\">The Viewer help desk</a> which offers introductions, descriptions and guides.</li>\n<li><a href=\"https://viewer.shapediver.com/v3/latest/api/index.html\">The Viewer API documentation</a> which offers the technical documentation of the API.</li>\n<li><a href=\"https://viewer.shapediver.com/v3/examples/index.html\">The Viewer examples page</a> which offers various examples (with github links and CodeSandBoxes).</li>\n</ul>\n<p>If you have any questions or need help with the viewer, please visit the <a href=\"https://forum.shapediver.com/\">ShapeDiver Forum</a>.</p>\n<p>If you find errors or have suggestions for improvements, please let us know!</p>\n",
        "path": "examples/"
    },
    {
        "markdown": '<h3>Animations</h3>\n<p>The examples in this section show different use cases of how to use animations.</p>\n<p>A feature that can make your models much more lively is animations. In our viewer, animations can be defined by using <a href="https://viewer.shapediver.com/v3/latest/api/interfaces/IAnimationData.html">AnimationData</a>. An <a href="https://viewer.shapediver.com/v3/latest/api/interfaces/IAnimationData.html">AnimationData</a> consists of one or multiple <a href="https://viewer.shapediver.com/v3/latest/api/interfaces/IAnimationTrack.html">AnimationTracks</a>. The <a href="https://viewer.shapediver.com/v3/latest/api/interfaces/IAnimationTrack.html">AnimationTracks</a> define which object moves how. The <a href="https://viewer.shapediver.com/v3/latest/api/interfaces/IAnimationData.html">AnimationData</a> is a wrapper around multiple <a href="https://viewer.shapediver.com/v3/latest/api/interfaces/IAnimationTrack.html">AnimationTracks</a> to execute them together. In this tutorial, we\u2019ll show you how to do that, and what is possible.</p>\n<p><em>Read more about this in our <a href="https://help.shapediver.com/doc/animations">help desk section</a>!</em></p>\n',
        "path": "examples/animations/"
    },
    {
        "markdown": '<h3>Attribute Visualization</h3>\n<p>The examples in this section show different use cases of how to use <a href="https://viewer.shapediver.com/v3/latest/api/features/attribute-visualization/index.html">attribute visualization</a>.</p>\n<p>With our Grasshopper Plugin and the invention of <a href="https://github.com/shapediver/sdTF">sdTF</a> a lot more data can be added to your models. This data can potentially be anything at all, in this case, we\u2019ll look at how we can visualize primitive data. This can be expanded by yourself to much more complex data though. Attributes are key-value pairs that can be specified at every step of the node tree. The number and type of attributes does not have to be consistent over the scene tree.</p>\n<p><em>Read more about this in our <a href="https://help.shapediver.com/doc/attribute-visualization">help desk section</a>!</em></p>\n',
        "path": "examples/attribute_visualization/"
    },
    {
        "markdown": "<h3>Drawing Tools</h3>\n<p>The examples in this section show different use cases of how to use <a href=\"https://viewer.shapediver.com/v3/latest/api/features/drawing-tools/index.html\">drawing tools</a>.</p>\n<p>The drawing tools can be used to create or edit point and line data. Points can be added, moved or removed.\nRestrictions can be used to restrict the point movement to either a grid, angular connections to neighboring lines or other geometry.</p>\n<p><em>Read more about this in our <a href=\"https://help.shapediver.com/doc/drawing-tools\">help desk section</a>!</em></p>\n",
        "path": "examples/drawing_tools/"
    },
    {
        "markdown": "<h3>General</h3>\n<p>The examples in this section show general settings and properties that can be set.</p>\n<p>These settings and properties can be used in a variety of ways for console branding, error handling or events.</p>\n",
        "path": "examples/general/"
    },
    {
        "markdown": "<h3>Gumball Transform</h3>\n<p>The examples in this section show different use cases of how to use the <a href=\"https://viewer.shapediver.com/v3/latest/api/features/transformation-tools/index.html\">GumballTransform feature</a>.</p>\n<p>The GumballTransform can be used to translate, rotate or scale objects in the scene.</p>\n<p><em>Read more about this in our <a href=\"https://help.shapediver.com/doc/gumball\">help desk section</a>!</em></p>\n",
        "path": "examples/gumball_transform/"
    },
    {
        "markdown": '<h3>HTML Anchors</h3>\n<p>The examples in this section show different use cases of how to use HTML anchors.</p>\n<p>Sometimes, you might want to enhance your scene with <a href="https://viewer.shapediver.com/v3/latest/api/classes/HTMLElementAnchorTextData.html">text elements</a> to describe objects, <a href="https://viewer.shapediver.com/v3/latest/api/classes/HTMLElementAnchorImageData.html">show images</a> next to them, or to connect them better with <a href="https://viewer.shapediver.com/v3/latest/api/classes/HTMLElementAnchorCustomData.html">custom HTML elements</a>, like an UI. Therefore, we implemented as specific data format that let\u2019s you put anchors in the scene which can then be used to display HTML elements on the projected position on the canvas.</p>\n<p><em>Read more about this in our <a href="https://help.shapediver.com/doc/html-elements">help desk section</a>!</em></p>\n',
        "path": "examples/html_anchors/"
    },
    {
        "markdown": "<h3>Interactions</h3>\n<p>The examples in this section show different use cases of how to use the <a href=\"https://viewer.shapediver.com/v3/latest/api/features/interaction/index.html\">interaction feature</a>. There are separate sub-sections for hovering, selection and dragging.</p>\n<p>Interactions are a great way to create more interactive experiences in the 3D viewer by letting users select and drag objects from the 3D scene, using their mouse or touchscreen. There are 3 ways to interact with the geometry directly: selecting, hovering and dragging.</p>\n<p><em>Read more about this in our <a href=\"https://help.shapediver.com/doc/interactions-part-1\">help desk section</a>!</em></p>\n",
        "path": "examples/interactions/"
    },
    {
        "markdown": "<!-- collapse -->\n\n<h3>Advanced</h3>\n",
        "path": "examples/interactions/advanced/"
    },
    {
        "markdown": "<!-- collapse -->\n\n<h3>Dragging</h3>\n<p>Dragging is the most complex of the interactions. While for selecting and hovering, the object stays still, for dragging the object is moved and we can decide how it is doing that.</p>\n<p><em>Read more about this in our <a href=\"https://help.shapediver.com/doc/interactions-part-2#Interactions-Part2-Dragging\">help desk section</a>!</em></p>\n",
        "path": "examples/interactions/dragging/"
    },
    {
        "markdown": "<!-- collapse -->\n\n<h3>Hovering</h3>\n<p>Hovering happens when the pointer is moved over the an object that has hovering enabled.</p>\n<p><em>Read more about this in our <a href=\"https://help.shapediver.com/doc/interactions-part-1#Interactions-Part1-Hovering\">help desk section</a>!</em></p>\n",
        "path": "examples/interactions/hovering/"
    },
    {
        "markdown": "<!-- collapse -->\n\n<h3>Selecting</h3>\n<p>Selecting happens when the pointer is clicked on an object that has selection enabled.</p>\n<p><em>Read more about this in our <a href=\"https://help.shapediver.com/doc/interactions-part-1#Interactions-Part1-Selection\">help desk section</a>!</em></p>\n",
        "path": "examples/interactions/selecting/"
    },
    {
        "markdown": "<h3>Materials</h3>\n<p>The examples in this section show different use cases for materials. There are separate sub-sections for gem materials and specific material properties.</p>\n<p>The materials play the most important factor in the appearance of models, therefore it is sometimes needed to adjust them. With the <a href=\"https://viewer.shapediver.com/v3/latest/api/classes/MaterialStandardData.html\">standard material</a>, there are already a lot of options available, but there are many other material options to chose from.</p>\n<p><em>Read more about this in our <a href=\"https://help.shapediver.com/doc/materials\">help desk section</a>!</em></p>\n",
        "path": "examples/materials/"
    },
    {
        "markdown": "<!-- collapse -->\n\n<h3>Gem Material</h3>\n<p>To achieve a high-quality 3D rendering of a gemstone, specialized software and techniques designed for rendering gemstones are often necessary. On the web, this task is even more challenging as resources are more limited.</p>\n<p><em>Read more about this in our <a href=\"https://help.shapediver.com/doc/gemstone-material\">help desk section</a>!</em></p>\n",
        "path": "examples/materials/gem_material/"
    },
    {
        "markdown": "<!-- collapse -->\n\n<h3>Properties</h3>\n<p>The various properties of the materials.</p>\n",
        "path": "examples/materials/properties/"
    },
    {
        "markdown": "<h3>Rectangle Transform</h3>\n<p>The examples in this section show different use cases of how to use the <a href=\"https://viewer.shapediver.com/v3/latest/api/features/transformation-tools/index.html\">RectangleTransform feature</a>.</p>\n<p>The RectangleTransform can be used to translate, rotate or scale objects in the scene using a 2D rectangular handle on a defined plane.</p>\n<p><em>Read more about this in our <a href=\"https://help.shapediver.com/doc/rectangle-transform\">help desk section</a>!</em></p>\n",
        "path": "examples/rectangle_transform/"
    },
    {
        "markdown": "<h3>Scene Tree Manipulation</h3>\n<p>The examples in this section show different use cases of how to manipulate the <a href=\"https://viewer.shapediver.com/v3/latest/api/interfaces/ITree.html\">scene tree</a>.</p>\n<p>This application has it&#39;s own <a href=\"https://viewer.shapediver.com/v3/latest/api/interfaces/ITree.html\">scene tree</a> in which sessions store their computed outputs as <a href=\"https://viewer.shapediver.com/v3/latest/api/interfaces/ITreeNode.html\">nodes</a>, but you can also create, adjust and remove parts of the scene tree yourself.</p>\n<p><em>Read more about this in our <a href=\"https://help.shapediver.com/doc/the-scene-tree\">help desk section</a>!</em></p>\n",
        "path": "examples/scene_tree_manipulation/"
    },
    {
        "markdown": "<h3>Session</h3>\n<p>The examples in this section show different use cases of how to use <a href=\"https://viewer.shapediver.com/v3/latest/api/interfaces/ISessionApi.html\">sessions</a>. There are separate sub-sections for <a href=\"https://viewer.shapediver.com/v3/latest/api/interfaces/IParameterApi.html\">parameters</a>, <a href=\"https://viewer.shapediver.com/v3/latest/api/interfaces/IExportApi.html\">exports</a> and <a href=\"https://viewer.shapediver.com/v3/latest/api/interfaces/IOutputApi.html\">outputs</a>.</p>\n<p>Your models running on ShapeDiver are hosted on one of our Geometry Backend systems. The access to triggering customizations and downloading computation results is controlled by <a href=\"https://viewer.shapediver.com/v3/latest/api/interfaces/ISessionApi.html\">sessions</a>. In order to create a session from an instance of the viewer embedded in a website, you need to provide a ticket for embedding.</p>\n<p><em>Read more about this in our <a href=\"https://help.shapediver.com/doc/sessions\">help desk section</a>!</em></p>\n",
        "path": "examples/session/"
    },
    {
        "markdown": "<!-- collapse -->\n\n<h3>Advanced Examples</h3>\n",
        "path": "examples/session/advanced/"
    },
    {
        "markdown": "<!-- collapse -->\n\n<h3>Exports</h3>\n<p>Exports are used for outputting data which should not be visualized in the scene, or which should not be accessible via the viewport.</p>\n<p><em>Read more about this in our <a href=\"https://help.shapediver.com/doc/sessions#Sessions-Exports\">help desk section</a>!</em></p>\n",
        "path": "examples/session/exports/"
    },
    {
        "markdown": "<!-- collapse -->\n\n<h3>Outputs</h3>\n<p>Outputs represent the channels through which data is output from the model represented by a session. They are computed as part of customizations.</p>\n",
        "path": "examples/session/outputs/"
    },
    {
        "markdown": "<!-- collapse -->\n\n<h3>Parameters</h3>\n<p>Parameters represent the channels through which data can be input into the model represented by a session.</p>\n<p><em>Read more about this in our <a href=\"https://help.shapediver.com/doc/sessions#Sessions-Parameters\">help desk section</a>!</em></p>\n",
        "path": "examples/session/parameters/"
    },
    {
        "markdown": "<h3>Setup</h3>\n<p>The examples in this section show different use cases on how to set up the viewer API.</p>\n<p>You can use the Viewer with with our npm package (recommended) or our CDN. Both variants have their advantages, so it&#39;s on you to choose.</p>\n<p><em>Read more about this in our <a href=\"https://help.shapediver.com/doc/installation-guide\">help desk section</a>!</em></p>\n",
        "path": "examples/setup/"
    },
    {
        "markdown": "<h3>Multiple Sessions or Viewports</h3>\n<p>It is also possible to use multiple sessions or multiple viewports with our Viewer API.</p>\n",
        "path": "examples/setup/multiple/"
    },
    {
        "markdown": "<h3>Showcase</h3>\n<p>The examples in this section show different advanced use cases to get inspired.</p>\n<p>In our showcase examples we present the combination of many features and create powerful applications with them.</p>\n",
        "path": "examples/showcase/"
    },
    {
        "markdown": '<h3>Three.js</h3>\n<p>The examples in this section show different use cases where three.js is used directly.</p>\n<p>Our Viewer is using <a href="https://threejs.org/">three.js</a>, an awesome graphics library that uses WebGL to render the contents in 2D and 3D. If you don\u2019t want to, you will never have to touch anything related to three.js, but that might not be the case for all. Therefore, here are some examples on how to interact with three.js in combination with the Viewer API.</p>\n<p><em>Read more about this in our <a href="https://help.shapediver.com/doc/three-js-objects">help desk section</a>!</em></p>\n',
        "path": "examples/three.js/"
    },
    {
        "markdown": "<h3>Viewport</h3>\n<p>The examples in this section show different use cases of how to use <a href=\"https://viewer.shapediver.com/v3/latest/api/interfaces/IViewportApi.html\">viewports</a>. There are separate sub-sections for cameras, lights and post-processing.</p>\n<p>The Viewport is responsible for rendering and rendering related settings. For example, camera and light management happens here. Additionally, a Viewport has many options, as rendering options can be enabled or disabled (shadows, ambient occlusion, etc.) and scene properties can be adjusted (groundplane, grid, etc.). A Viewport can exist completely without a Session, as a Session can exist without a Viewport.</p>\n<p><em>Read more about this in our <a href=\"https://help.shapediver.com/doc/viewer\">help desk section</a>!</em></p>\n",
        "path": "examples/viewport/"
    },
    {
        "markdown": "<!-- collapse -->\n\n<h3>Cameras</h3>\n<p>Via the Viewer API you can add, edit and remove different cameras with different types.</p>\n<p><em>Read more about this in our <a href=\"https://help.shapediver.com/doc/viewers#Viewports-Cameras\">help desk section</a>!</em></p>\n",
        "path": "examples/viewport/cameras/"
    },
    {
        "markdown": "<!-- collapse -->\n\n<h3>Lights</h3>\n<p>Via the Viewer API you can add, edit and remove light scenes which are collections of different lights.</p>\n<p><em>Read more about this in our <a href=\"https://help.shapediver.com/doc/viewers#Viewports-Lights\">help desk section</a>!</em></p>\n",
        "path": "examples/viewport/lights/"
    },
    {
        "markdown": "<!-- collapse -->\n\n<h3>Post-Processing</h3>\n<p>Post-processing refers to applying additional visual effects or modifications to a rendered scene after it has been initially drawn to the screen. This technique is commonly used to enhance the overall look and feel of a 3D scene or to achieve specific visual effects like ambient occlusion, bloom, motion blur, depth-of-field and more.</p>\n<p><em>Read more about this in our <a href=\"https://help.shapediver.com/doc/post-processing\">help desk section</a>!</em></p>\n",
        "path": "examples/viewport/post_processing/"
    },
    {
        "markdown": "<!-- collapse -->\n\n<h3>Effects</h3>\n<p>All currently supported post-processing effects.</p>\n",
        "path": "examples/viewport/post_processing/effects/"
    }
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"h9QnT":[function(require,module,exports,__globalThis) {
'use strict';
// eslint-disable-next-line no-multi-assign
exports.randomBytes = exports.rng = exports.pseudoRandomBytes = exports.prng = require("9f84b01a6f751e2b");
// eslint-disable-next-line no-multi-assign
exports.createHash = exports.Hash = require("6215218888164bf3");
// eslint-disable-next-line no-multi-assign
exports.createHmac = exports.Hmac = require("41dc42cb22bbf5f8");
var algos = require("acce2639fd57a8ee");
var algoKeys = Object.keys(algos);
var hashes = [
    'sha1',
    'sha224',
    'sha256',
    'sha384',
    'sha512',
    'md5',
    'rmd160'
].concat(algoKeys);
exports.getHashes = function() {
    return hashes;
};
var p = require("b26231bc996405c3");
exports.pbkdf2 = p.pbkdf2;
exports.pbkdf2Sync = p.pbkdf2Sync;
var aes = require("cd296f7efacbf3dd");
exports.Cipher = aes.Cipher;
exports.createCipher = aes.createCipher;
exports.Cipheriv = aes.Cipheriv;
exports.createCipheriv = aes.createCipheriv;
exports.Decipher = aes.Decipher;
exports.createDecipher = aes.createDecipher;
exports.Decipheriv = aes.Decipheriv;
exports.createDecipheriv = aes.createDecipheriv;
exports.getCiphers = aes.getCiphers;
exports.listCiphers = aes.listCiphers;
var dh = require("f35f6f689077fd07");
exports.DiffieHellmanGroup = dh.DiffieHellmanGroup;
exports.createDiffieHellmanGroup = dh.createDiffieHellmanGroup;
exports.getDiffieHellman = dh.getDiffieHellman;
exports.createDiffieHellman = dh.createDiffieHellman;
exports.DiffieHellman = dh.DiffieHellman;
var sign = require("e955328ff9b7dd32");
exports.createSign = sign.createSign;
exports.Sign = sign.Sign;
exports.createVerify = sign.createVerify;
exports.Verify = sign.Verify;
exports.createECDH = require("84e3bfaa4f6c843e");
var publicEncrypt = require("eeb59405cf029b93");
exports.publicEncrypt = publicEncrypt.publicEncrypt;
exports.privateEncrypt = publicEncrypt.privateEncrypt;
exports.publicDecrypt = publicEncrypt.publicDecrypt;
exports.privateDecrypt = publicEncrypt.privateDecrypt;
// the least I can do is make error messages for the rest of the node.js/crypto api.
// [
//   'createCredentials'
// ].forEach(function (name) {
//   exports[name] = function () {
//     throw new Error('sorry, ' + name + ' is not implemented yet\nwe accept pull requests\nhttps://github.com/browserify/crypto-browserify');
//   };
// });
var rf = require("327f527258516f60");
exports.randomFill = rf.randomFill;
exports.randomFillSync = rf.randomFillSync;
exports.createCredentials = function() {
    throw new Error('sorry, createCredentials is not implemented yet\nwe accept pull requests\nhttps://github.com/browserify/crypto-browserify');
};
exports.constants = {
    DH_CHECK_P_NOT_SAFE_PRIME: 2,
    DH_CHECK_P_NOT_PRIME: 1,
    DH_UNABLE_TO_CHECK_GENERATOR: 4,
    DH_NOT_SUITABLE_GENERATOR: 8,
    NPN_ENABLED: 1,
    ALPN_ENABLED: 1,
    RSA_PKCS1_PADDING: 1,
    RSA_SSLV23_PADDING: 2,
    RSA_NO_PADDING: 3,
    RSA_PKCS1_OAEP_PADDING: 4,
    RSA_X931_PADDING: 5,
    RSA_PKCS1_PSS_PADDING: 6,
    POINT_CONVERSION_COMPRESSED: 2,
    POINT_CONVERSION_UNCOMPRESSED: 4,
    POINT_CONVERSION_HYBRID: 6
};

},{"9f84b01a6f751e2b":"jXr3f","6215218888164bf3":"aPKzt","41dc42cb22bbf5f8":"hOD8w","acce2639fd57a8ee":"eulfJ","b26231bc996405c3":"6Io3h","cd296f7efacbf3dd":"5st97","f35f6f689077fd07":"a4Tsm","e955328ff9b7dd32":"g5lRC","84e3bfaa4f6c843e":"hGQW9","eeb59405cf029b93":"iUbRY","327f527258516f60":"dmZ1q"}],"jXr3f":[function(require,module,exports,__globalThis) {
var global = arguments[3];
var process = require("9f5c61be6bd9c67a");
'use strict';
// limit of Crypto.getRandomValues()
// https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
var MAX_BYTES = 65536;
// Node supports requesting up to this number of bytes
// https://github.com/nodejs/node/blob/master/lib/internal/crypto/random.js#L48
var MAX_UINT32 = 4294967295;
function oldBrowser() {
    throw new Error('Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11');
}
var Buffer = require("caff9346743c214e").Buffer;
var crypto = global.crypto || global.msCrypto;
if (crypto && crypto.getRandomValues) module.exports = randomBytes;
else module.exports = oldBrowser;
function randomBytes(size, cb) {
    // phantomjs needs to throw
    if (size > MAX_UINT32) throw new RangeError('requested too many random bytes');
    var bytes = Buffer.allocUnsafe(size);
    if (size > 0) {
        if (size > MAX_BYTES) // can do at once see https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
        for(var generated = 0; generated < size; generated += MAX_BYTES)// buffer.slice automatically checks if the end is past the end of
        // the buffer so we don't have to here
        crypto.getRandomValues(bytes.slice(generated, generated + MAX_BYTES));
        else crypto.getRandomValues(bytes);
    }
    if (typeof cb === 'function') return process.nextTick(function() {
        cb(null, bytes);
    });
    return bytes;
}

},{"9f5c61be6bd9c67a":"4jeNM","caff9346743c214e":"1Yph5"}],"4jeNM":[function(require,module,exports,__globalThis) {
// shim for using process in browser
var process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var cachedSetTimeout;
var cachedClearTimeout;
function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') cachedSetTimeout = setTimeout;
        else cachedSetTimeout = defaultSetTimout;
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') cachedClearTimeout = clearTimeout;
        else cachedClearTimeout = defaultClearTimeout;
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
})();
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;
function cleanUpNextTick() {
    if (!draining || !currentQueue) return;
    draining = false;
    if (currentQueue.length) queue = currentQueue.concat(queue);
    else queueIndex = -1;
    if (queue.length) drainQueue();
}
function drainQueue() {
    if (draining) return;
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;
    var len = queue.length;
    while(len){
        currentQueue = queue;
        queue = [];
        while(++queueIndex < len)if (currentQueue) currentQueue[queueIndex].run();
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}
process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) runTimeout(drainQueue);
};
// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};
function noop() {}
process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;
process.listeners = function(name) {
    return [];
};
process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
process.cwd = function() {
    return '/';
};
process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() {
    return 0;
};

},{}],"1Yph5":[function(require,module,exports,__globalThis) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ var buffer = require("7e0d6ecd698c3ca6");
var Buffer = buffer.Buffer;
// alternative to using Object.keys for old browsers
function copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) module.exports = buffer;
else {
    // Copy properties from require('buffer')
    copyProps(buffer, exports);
    exports.Buffer = SafeBuffer;
}
function SafeBuffer(arg, encodingOrOffset, length) {
    return Buffer(arg, encodingOrOffset, length);
}
SafeBuffer.prototype = Object.create(Buffer.prototype);
// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer);
SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return Buffer(arg, encodingOrOffset, length);
};
SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return Buffer(size);
};
SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return buffer.SlowBuffer(size);
};

},{"7e0d6ecd698c3ca6":"cjdyz"}],"aPKzt":[function(require,module,exports,__globalThis) {
'use strict';
var inherits = require("45ce174cec337471");
var MD5 = require("4170b0039f3b4aab");
var RIPEMD160 = require("efcc6ede1fda4d98");
var sha = require("65b1a51ddac82548");
var Base = require("ac5a46c0f3b4d769");
function Hash(hash) {
    Base.call(this, 'digest');
    this._hash = hash;
}
inherits(Hash, Base);
Hash.prototype._update = function(data) {
    this._hash.update(data);
};
Hash.prototype._final = function() {
    return this._hash.digest();
};
module.exports = function createHash(alg) {
    alg = alg.toLowerCase();
    if (alg === 'md5') return new MD5();
    if (alg === 'rmd160' || alg === 'ripemd160') return new RIPEMD160();
    return new Hash(sha(alg));
};

},{"45ce174cec337471":"dwCbX","4170b0039f3b4aab":"eeqUY","efcc6ede1fda4d98":"cKnjx","65b1a51ddac82548":"9j4zZ","ac5a46c0f3b4d769":"gsniA"}],"dwCbX":[function(require,module,exports,__globalThis) {
if (typeof Object.create === 'function') // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

},{}],"eeqUY":[function(require,module,exports,__globalThis) {
'use strict';
var inherits = require("634114d48656c754");
var HashBase = require("4b170874b4cb8d4e");
var Buffer = require("72d4e45c6a42a2da").Buffer;
var ARRAY16 = new Array(16);
function MD5() {
    HashBase.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
}
inherits(MD5, HashBase);
MD5.prototype._update = function() {
    var M = ARRAY16;
    for(var i = 0; i < 16; ++i)M[i] = this._block.readInt32LE(i * 4);
    var a = this._a;
    var b = this._b;
    var c = this._c;
    var d = this._d;
    a = fnF(a, b, c, d, M[0], 0xd76aa478, 7);
    d = fnF(d, a, b, c, M[1], 0xe8c7b756, 12);
    c = fnF(c, d, a, b, M[2], 0x242070db, 17);
    b = fnF(b, c, d, a, M[3], 0xc1bdceee, 22);
    a = fnF(a, b, c, d, M[4], 0xf57c0faf, 7);
    d = fnF(d, a, b, c, M[5], 0x4787c62a, 12);
    c = fnF(c, d, a, b, M[6], 0xa8304613, 17);
    b = fnF(b, c, d, a, M[7], 0xfd469501, 22);
    a = fnF(a, b, c, d, M[8], 0x698098d8, 7);
    d = fnF(d, a, b, c, M[9], 0x8b44f7af, 12);
    c = fnF(c, d, a, b, M[10], 0xffff5bb1, 17);
    b = fnF(b, c, d, a, M[11], 0x895cd7be, 22);
    a = fnF(a, b, c, d, M[12], 0x6b901122, 7);
    d = fnF(d, a, b, c, M[13], 0xfd987193, 12);
    c = fnF(c, d, a, b, M[14], 0xa679438e, 17);
    b = fnF(b, c, d, a, M[15], 0x49b40821, 22);
    a = fnG(a, b, c, d, M[1], 0xf61e2562, 5);
    d = fnG(d, a, b, c, M[6], 0xc040b340, 9);
    c = fnG(c, d, a, b, M[11], 0x265e5a51, 14);
    b = fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20);
    a = fnG(a, b, c, d, M[5], 0xd62f105d, 5);
    d = fnG(d, a, b, c, M[10], 0x02441453, 9);
    c = fnG(c, d, a, b, M[15], 0xd8a1e681, 14);
    b = fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20);
    a = fnG(a, b, c, d, M[9], 0x21e1cde6, 5);
    d = fnG(d, a, b, c, M[14], 0xc33707d6, 9);
    c = fnG(c, d, a, b, M[3], 0xf4d50d87, 14);
    b = fnG(b, c, d, a, M[8], 0x455a14ed, 20);
    a = fnG(a, b, c, d, M[13], 0xa9e3e905, 5);
    d = fnG(d, a, b, c, M[2], 0xfcefa3f8, 9);
    c = fnG(c, d, a, b, M[7], 0x676f02d9, 14);
    b = fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20);
    a = fnH(a, b, c, d, M[5], 0xfffa3942, 4);
    d = fnH(d, a, b, c, M[8], 0x8771f681, 11);
    c = fnH(c, d, a, b, M[11], 0x6d9d6122, 16);
    b = fnH(b, c, d, a, M[14], 0xfde5380c, 23);
    a = fnH(a, b, c, d, M[1], 0xa4beea44, 4);
    d = fnH(d, a, b, c, M[4], 0x4bdecfa9, 11);
    c = fnH(c, d, a, b, M[7], 0xf6bb4b60, 16);
    b = fnH(b, c, d, a, M[10], 0xbebfbc70, 23);
    a = fnH(a, b, c, d, M[13], 0x289b7ec6, 4);
    d = fnH(d, a, b, c, M[0], 0xeaa127fa, 11);
    c = fnH(c, d, a, b, M[3], 0xd4ef3085, 16);
    b = fnH(b, c, d, a, M[6], 0x04881d05, 23);
    a = fnH(a, b, c, d, M[9], 0xd9d4d039, 4);
    d = fnH(d, a, b, c, M[12], 0xe6db99e5, 11);
    c = fnH(c, d, a, b, M[15], 0x1fa27cf8, 16);
    b = fnH(b, c, d, a, M[2], 0xc4ac5665, 23);
    a = fnI(a, b, c, d, M[0], 0xf4292244, 6);
    d = fnI(d, a, b, c, M[7], 0x432aff97, 10);
    c = fnI(c, d, a, b, M[14], 0xab9423a7, 15);
    b = fnI(b, c, d, a, M[5], 0xfc93a039, 21);
    a = fnI(a, b, c, d, M[12], 0x655b59c3, 6);
    d = fnI(d, a, b, c, M[3], 0x8f0ccc92, 10);
    c = fnI(c, d, a, b, M[10], 0xffeff47d, 15);
    b = fnI(b, c, d, a, M[1], 0x85845dd1, 21);
    a = fnI(a, b, c, d, M[8], 0x6fa87e4f, 6);
    d = fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10);
    c = fnI(c, d, a, b, M[6], 0xa3014314, 15);
    b = fnI(b, c, d, a, M[13], 0x4e0811a1, 21);
    a = fnI(a, b, c, d, M[4], 0xf7537e82, 6);
    d = fnI(d, a, b, c, M[11], 0xbd3af235, 10);
    c = fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15);
    b = fnI(b, c, d, a, M[9], 0xeb86d391, 21);
    this._a = this._a + a | 0;
    this._b = this._b + b | 0;
    this._c = this._c + c | 0;
    this._d = this._d + d | 0;
};
MD5.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = Buffer.allocUnsafe(16);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    return buffer;
};
function rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function fnF(a, b, c, d, m, k, s) {
    return rotl(a + (b & c | ~b & d) + m + k | 0, s) + b | 0;
}
function fnG(a, b, c, d, m, k, s) {
    return rotl(a + (b & d | c & ~d) + m + k | 0, s) + b | 0;
}
function fnH(a, b, c, d, m, k, s) {
    return rotl(a + (b ^ c ^ d) + m + k | 0, s) + b | 0;
}
function fnI(a, b, c, d, m, k, s) {
    return rotl(a + (c ^ (b | ~d)) + m + k | 0, s) + b | 0;
}
module.exports = MD5;

},{"634114d48656c754":"dwCbX","4b170874b4cb8d4e":"fVWQ8","72d4e45c6a42a2da":"1Yph5"}],"fVWQ8":[function(require,module,exports,__globalThis) {
'use strict';
var Buffer = require("27eaec8a721206a5").Buffer;
var Transform = require("c9c4fcebe200e6bf").Transform;
var inherits = require("91e9fa68d440541e");
function HashBase(blockSize) {
    Transform.call(this);
    this._block = Buffer.allocUnsafe(blockSize);
    this._blockSize = blockSize;
    this._blockOffset = 0;
    this._length = [
        0,
        0,
        0,
        0
    ];
    this._finalized = false;
}
inherits(HashBase, Transform);
HashBase.prototype._transform = function(chunk, encoding, callback) {
    var error = null;
    try {
        this.update(chunk, encoding);
    } catch (err) {
        error = err;
    }
    callback(error);
};
HashBase.prototype._flush = function(callback) {
    var error = null;
    try {
        this.push(this.digest());
    } catch (err) {
        error = err;
    }
    callback(error);
};
var useUint8Array = typeof Uint8Array !== 'undefined';
var useArrayBuffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && ArrayBuffer.isView && (Buffer.prototype instanceof Uint8Array || Buffer.TYPED_ARRAY_SUPPORT);
function toBuffer(data, encoding) {
    // No need to do anything for exact instance
    // This is only valid when safe-buffer.Buffer === buffer.Buffer, i.e. when Buffer.from/Buffer.alloc existed
    if (data instanceof Buffer) return data;
    // Convert strings to Buffer
    if (typeof data === 'string') return Buffer.from(data, encoding);
    /*
   * Wrap any TypedArray instances and DataViews
   * Makes sense only on engines with full TypedArray support -- let Buffer detect that
   */ if (useArrayBuffer && ArrayBuffer.isView(data)) {
        if (data.byteLength === 0) return Buffer.alloc(0) // Bug in Node.js <6.3.1, which treats this as out-of-bounds
        ;
        var res = Buffer.from(data.buffer, data.byteOffset, data.byteLength);
        // Recheck result size, as offset/length doesn't work on Node.js <5.10
        // We just go to Uint8Array case if this fails
        if (res.byteLength === data.byteLength) return res;
    }
    /*
   * Uint8Array in engines where Buffer.from might not work with ArrayBuffer, just copy over
   * Doesn't make sense with other TypedArray instances
   */ if (useUint8Array && data instanceof Uint8Array) return Buffer.from(data);
    /*
   * Old Buffer polyfill on an engine that doesn't have TypedArray support
   * Also, this is from a different Buffer polyfill implementation then we have, as instanceof check failed
   * Convert to our current Buffer implementation
   */ if (Buffer.isBuffer(data) && data.constructor && typeof data.constructor.isBuffer === 'function' && data.constructor.isBuffer(data)) return Buffer.from(data);
    throw new TypeError('The "data" argument must be of type string or an instance of Buffer, TypedArray, or DataView.');
}
HashBase.prototype.update = function(data, encoding) {
    if (this._finalized) throw new Error('Digest already called');
    data = toBuffer(data, encoding) // asserts correct input type
    ;
    // consume data
    var block = this._block;
    var offset = 0;
    while(this._blockOffset + data.length - offset >= this._blockSize){
        for(var i = this._blockOffset; i < this._blockSize;)block[i++] = data[offset++];
        this._update();
        this._blockOffset = 0;
    }
    while(offset < data.length)block[this._blockOffset++] = data[offset++];
    // update length
    for(var j = 0, carry = data.length * 8; carry > 0; ++j){
        this._length[j] += carry;
        carry = this._length[j] / 0x0100000000 | 0;
        if (carry > 0) this._length[j] -= 0x0100000000 * carry;
    }
    return this;
};
HashBase.prototype._update = function() {
    throw new Error('_update is not implemented');
};
HashBase.prototype.digest = function(encoding) {
    if (this._finalized) throw new Error('Digest already called');
    this._finalized = true;
    var digest = this._digest();
    if (encoding !== undefined) digest = digest.toString(encoding);
    // reset state
    this._block.fill(0);
    this._blockOffset = 0;
    for(var i = 0; i < 4; ++i)this._length[i] = 0;
    return digest;
};
HashBase.prototype._digest = function() {
    throw new Error('_digest is not implemented');
};
module.exports = HashBase;

},{"27eaec8a721206a5":"1Yph5","c9c4fcebe200e6bf":"1CYjc","91e9fa68d440541e":"dwCbX"}],"1CYjc":[function(require,module,exports,__globalThis) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
module.exports = Stream;
var EE = require("96b62835346f84f0").EventEmitter;
var inherits = require("4a6ee9586f51c38d");
inherits(Stream, EE);
Stream.Readable = require("e6206e1f4d20abc7");
Stream.Writable = require("a3f1405f37e1dfb1");
Stream.Duplex = require("6691a72c5fc222fd");
Stream.Transform = require("43a905ce7ec6ac9e");
Stream.PassThrough = require("dd715550d7783885");
Stream.finished = require("d90a3520974ec96e");
Stream.pipeline = require("eb2779cfd287c5c9");
// Backwards-compat with node 0.4.x
Stream.Stream = Stream;
// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.
function Stream() {
    EE.call(this);
}
Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable) {
            if (false === dest.write(chunk) && source.pause) source.pause();
        }
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if (EE.listenerCount(this, 'error') === 0) throw er; // Unhandled stream error in pipe.
    }
    source.on('error', onerror);
    dest.on('error', onerror);
    // remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};

},{"96b62835346f84f0":"9O3iX","4a6ee9586f51c38d":"dwCbX","e6206e1f4d20abc7":"iiPxh","a3f1405f37e1dfb1":"31zPq","6691a72c5fc222fd":"71LGu","43a905ce7ec6ac9e":"hwuAh","dd715550d7783885":"l3CZy","d90a3520974ec96e":"bEUMt","eb2779cfd287c5c9":"5ED5k"}],"9O3iX":[function(require,module,exports,__globalThis) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var R = typeof Reflect === 'object' ? Reflect : null;
var ReflectApply = R && typeof R.apply === 'function' ? R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var ReflectOwnKeys;
if (R && typeof R.ownKeys === 'function') ReflectOwnKeys = R.ownKeys;
else if (Object.getOwnPropertySymbols) ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function EventEmitter() {
    EventEmitter.init.call(this);
}
module.exports = EventEmitter;
module.exports.once = once;
// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;
EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;
function checkListener(listener) {
    if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
        return defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
        defaultMaxListeners = arg;
    }
});
EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
    this._maxListeners = n;
    return this;
};
function _getMaxListeners(that) {
    if (that._maxListeners === undefined) return EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return _getMaxListeners(this);
};
EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === 'error';
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === 'function') ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = arrayClone(handler, len);
        for(var i = 0; i < len; ++i)ReflectApply(listeners[i], this, args);
    }
    return true;
};
function _addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === 'function') // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = _getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            ProcessEmitWarning(w);
        }
    }
    return target;
}
EventEmitter.prototype.addListener = function addListener(type, listener) {
    return _addListener(this, type, listener, false);
};
EventEmitter.prototype.on = EventEmitter.prototype.addListener;
EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return _addListener(this, type, listener, true);
};
function onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function _onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
EventEmitter.prototype.once = function once(type, listener) {
    checkListener(listener);
    this.on(type, _onceWrap(this, type, listener));
    return this;
};
EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    checkListener(listener);
    this.prependListener(type, _onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
        }
    } else if (typeof list !== 'function') {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
    }
    return this;
};
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === 'function') this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function _listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === 'function') return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}
EventEmitter.prototype.listeners = function listeners(type) {
    return _listeners(this, type, true);
};
EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return _listeners(this, type, false);
};
EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
    else return listenerCount.call(emitter, type);
};
EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};
function arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
            resolve([].slice.call(arguments));
        }
        eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== 'error') addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === 'function') eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
}
function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === 'function') {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

},{}],"iiPxh":[function(require,module,exports,__globalThis) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
var global = arguments[3];
var process = require("5cd4b65a2667f30e");
'use strict';
module.exports = Readable;
/*<replacement>*/ var Duplex;
/*</replacement>*/ Readable.ReadableState = ReadableState;
/*<replacement>*/ var EE = require("c152f2119aca4689").EventEmitter;
var EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};
/*</replacement>*/ /*<replacement>*/ var Stream = require("ee1c46a25703890d");
/*</replacement>*/ var Buffer = require("efffad1605c95e76").Buffer;
var OurUint8Array = (typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function _uint8ArrayToBuffer(chunk) {
    return Buffer.from(chunk);
}
function _isUint8Array(obj) {
    return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}
/*<replacement>*/ var debugUtil = require("f6690d8cb5f89003");
var debug;
if (debugUtil && debugUtil.debuglog) debug = debugUtil.debuglog('stream');
else debug = function debug() {};
/*</replacement>*/ var BufferList = require("f8c4515e8234bd59");
var destroyImpl = require("2b842a435cfab72e");
var _require = require("6f90938893f80e4b"), getHighWaterMark = _require.getHighWaterMark;
var _require$codes = require("daceb54799edbc39").codes, ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE, ERR_STREAM_PUSH_AFTER_EOF = _require$codes.ERR_STREAM_PUSH_AFTER_EOF, ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED, ERR_STREAM_UNSHIFT_AFTER_END_EVENT = _require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
// Lazy loaded to improve the startup performance.
var StringDecoder;
var createReadableStreamAsyncIterator;
var from;
require("6b2730f2f68f00ce")(Readable, Stream);
var errorOrDestroy = destroyImpl.errorOrDestroy;
var kProxyEvents = [
    'error',
    'close',
    'destroy',
    'pause',
    'resume'
];
function prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}
function ReadableState(options, stream, isDuplex) {
    Duplex = Duplex || require("d53c82af0b49f760");
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new BufferList();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!StringDecoder) StringDecoder = require("e7e497563ff3b269").StringDecoder;
        this.decoder = new StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}
function Readable(options) {
    Duplex = Duplex || require("d53c82af0b49f760");
    if (!(this instanceof Readable)) return new Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof Duplex;
    this._readableState = new ReadableState(options, this, isDuplex);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
    }
    Stream.call(this);
}
Object.defineProperty(Readable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;
Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = Buffer.from(chunk, encoding);
                encoding = '';
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function(chunk) {
    return readableAddChunk(this, chunk, null, true, false);
};
function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    debug('readableAddChunk', chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = chunkInvalid(state, chunk);
        if (er) errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) chunk = _uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) errorOrDestroy(stream, new ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else addChunk(stream, state, chunk, true);
            } else if (state.ended) errorOrDestroy(stream, new ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);
                    else maybeReadMore(stream, state);
                } else addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            maybeReadMore(stream, state);
        }
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit('data', chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) emitReadable(stream);
    }
    maybeReadMore(stream, state);
}
function chunkInvalid(state, chunk) {
    var er;
    if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new ERR_INVALID_ARG_TYPE('chunk', [
        'string',
        'Buffer',
        'Uint8Array'
    ], chunk);
    return er;
}
Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};
// backwards compatibility.
Readable.prototype.setEncoding = function(enc) {
    if (!StringDecoder) StringDecoder = require("e7e497563ff3b269").StringDecoder;
    var decoder = new StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding;
    // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = '';
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== '') this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB
var MAX_HWM = 0x40000000;
function computeNewHighWaterMark(n) {
    if (n >= MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function(n) {
    debug('read', n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) endReadable(this);
        else emitReadable(this);
        return null;
    }
    n = howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    debug('need readable', doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        debug('length less than watermark', doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        debug('reading or ended', doRead);
    } else if (doRead) {
        debug('do read');
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) endReadable(this);
    }
    if (ret !== null) this.emit('data', ret);
    return ret;
};
function onEofChunk(stream, state) {
    debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            emitReadable_(stream);
        }
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
    var state = stream._readableState;
    debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        process.nextTick(emitReadable_, stream);
    }
}
function emitReadable_(stream) {
    var state = stream._readableState;
    debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        process.nextTick(maybeReadMore_, stream, state);
    }
}
function maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function(n) {
    errorOrDestroy(this, new ERR_METHOD_NOT_IMPLEMENTED('_read()'));
};
Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) process.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        debug('onend');
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = pipeOnDrain(src);
    dest.on('drain', ondrain);
    var cleanedUp = false;
    function cleanup() {
        debug('cleanup');
        // cleanup event handlers once the pipe is broken
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on('data', ondata);
    function ondata(chunk) {
        debug('ondata');
        var ret = dest.write(chunk);
        debug('dest.write', ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                debug('false write response, pause', state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if (EElistenerCount(dest, 'error') === 0) errorOrDestroy(dest, er);
    }
    // Make sure our error handler is attached before userland ones.
    prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        debug('unpipe');
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit('pipe', src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        debug('pipe resume');
        src.resume();
    }
    return dest;
};
function pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        debug('pipeOnDrain', state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
            state.flowing = true;
            flow(src);
        }
    };
}
Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit('unpipe', this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function(ev, fn) {
    var res = Stream.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === 'data') {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            debug('on readable', state.length, state.reading);
            if (state.length) emitReadable(this);
            else if (!state.reading) process.nextTick(nReadingNextTick, this);
        }
    }
    return res;
};
Readable.prototype.addListener = Readable.prototype.on;
Readable.prototype.removeListener = function(ev, fn) {
    var res = Stream.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    process.nextTick(updateReadableListening, this);
    return res;
};
Readable.prototype.removeAllListeners = function(ev) {
    var res = Stream.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    process.nextTick(updateReadableListening, this);
    return res;
};
function updateReadableListening(self1) {
    var state = self1._readableState;
    state.readableListening = self1.listenerCount('readable') > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self1.listenerCount('data') > 0) self1.resume();
}
function nReadingNextTick(self1) {
    debug('readable nexttick read 0');
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        debug('resume');
        // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        resume(this, state);
    }
    state.paused = false;
    return this;
};
function resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        process.nextTick(resume_, stream, state);
    }
}
function resume_(stream, state) {
    debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
Readable.prototype.pause = function() {
    debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState.paused = true;
    return this;
};
function flow(stream) {
    var state = stream._readableState;
    debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on('end', function() {
        debug('wrapped end');
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on('data', function(chunk) {
        debug('wrapped data');
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < kProxyEvents.length; n++)stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        debug('wrapped _read', n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};
if (typeof Symbol === 'function') Readable.prototype[Symbol.asyncIterator] = function() {
    if (createReadableStreamAsyncIterator === undefined) createReadableStreamAsyncIterator = require("746c700ae68bf97c");
    return createReadableStreamAsyncIterator(this);
};
Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty(Readable.prototype, 'readableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty(Readable.prototype, 'readableFlowing', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
});
// exposed for testing purposes only.
Readable._fromList = fromList;
Object.defineProperty(Readable.prototype, 'readableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
});
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function endReadable(stream) {
    var state = stream._readableState;
    debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        process.nextTick(endReadableNT, state, stream);
    }
}
function endReadableNT(state, stream) {
    debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}
if (typeof Symbol === 'function') Readable.from = function(iterable, opts) {
    if (from === undefined) from = require("7770a768738aeba9");
    return from(Readable, iterable, opts);
};
function indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

},{"5cd4b65a2667f30e":"4jeNM","c152f2119aca4689":"9O3iX","ee1c46a25703890d":"6WLwc","efffad1605c95e76":"cjdyz","f6690d8cb5f89003":"4TE4R","f8c4515e8234bd59":"fojFR","2b842a435cfab72e":"iGtXS","6f90938893f80e4b":"jG3M7","daceb54799edbc39":"2mf2H","6b2730f2f68f00ce":"dwCbX","d53c82af0b49f760":"71LGu","e7e497563ff3b269":"6a4se","746c700ae68bf97c":"90IP8","7770a768738aeba9":"f5QXF"}],"6WLwc":[function(require,module,exports,__globalThis) {
module.exports = require("256d09989820a7e9").EventEmitter;

},{"256d09989820a7e9":"9O3iX"}],"fojFR":[function(require,module,exports,__globalThis) {
'use strict';
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var _require = require("56f983784a0fab6f"), Buffer = _require.Buffer;
var _require2 = require("95cdcc9e77389728"), inspect = _require2.inspect;
var custom = inspect && inspect.custom || 'inspect';
function copyBuffer(src, target, offset) {
    Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        _classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    _createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return '';
                var p = this.head;
                var ret = '' + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return Buffer.alloc(0);
                var ret = Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: custom,
            value: function value(_, options) {
                return inspect(this, _objectSpread(_objectSpread({}, options), {}, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

},{"56f983784a0fab6f":"cjdyz","95cdcc9e77389728":"4TE4R"}],"iGtXS":[function(require,module,exports,__globalThis) {
var process = require("688ab6a28ddb436d");
'use strict';
// undocumented cb() API, needed for core, not for public API
function destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) process.nextTick(emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                process.nextTick(emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) process.nextTick(emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                process.nextTick(emitErrorAndCloseNT, _this, err);
            } else process.nextTick(emitCloseNT, _this);
        } else if (cb) {
            process.nextTick(emitCloseNT, _this);
            cb(err);
        } else process.nextTick(emitCloseNT, _this);
    });
    return this;
}
function emitErrorAndCloseNT(self, err) {
    emitErrorNT(self, err);
    emitCloseNT(self);
}
function emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit('close');
}
function undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function emitErrorNT(self, err) {
    self.emit('error', err);
}
function errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit('error', err);
}
module.exports = {
    destroy: destroy,
    undestroy: undestroy,
    errorOrDestroy: errorOrDestroy
};

},{"688ab6a28ddb436d":"4jeNM"}],"jG3M7":[function(require,module,exports,__globalThis) {
'use strict';
var ERR_INVALID_OPT_VALUE = require("4543c6055fd8382c").codes.ERR_INVALID_OPT_VALUE;
function highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : 'highWaterMark';
            throw new ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    }
    // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: getHighWaterMark
};

},{"4543c6055fd8382c":"2mf2H"}],"2mf2H":[function(require,module,exports,__globalThis) {
'use strict';
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var codes = {};
function createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === 'string') return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        _inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function includes(str, search, start) {
    if (typeof start !== 'number') start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
createErrorType('ERR_INVALID_OPT_VALUE', function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
createErrorType('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === 'string' && startsWith(expected, 'not ')) {
        determiner = 'must not be';
        expected = expected.replace(/^not /, '');
    } else determiner = 'must be';
    var msg;
    if (endsWith(name, ' argument')) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
    else {
        var type = includes(name, '.') ? 'property' : 'argument';
        msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
createErrorType('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF');
createErrorType('ERR_METHOD_NOT_IMPLEMENTED', function(name) {
    return 'The ' + name + ' method is not implemented';
});
createErrorType('ERR_STREAM_PREMATURE_CLOSE', 'Premature close');
createErrorType('ERR_STREAM_DESTROYED', function(name) {
    return 'Cannot call ' + name + ' after a stream was destroyed';
});
createErrorType('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times');
createErrorType('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable');
createErrorType('ERR_STREAM_WRITE_AFTER_END', 'write after end');
createErrorType('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
createErrorType('ERR_UNKNOWN_ENCODING', function(arg) {
    return 'Unknown encoding: ' + arg;
}, TypeError);
createErrorType('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event');
module.exports.codes = codes;

},{}],"71LGu":[function(require,module,exports,__globalThis) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.
var process = require("34d2aeaf352b4512");
'use strict';
/*<replacement>*/ var objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = Duplex;
var Readable = require("7b75ce1e482a8dfb");
var Writable = require("fd2e3b6f36c506e9");
require("7dcb079aaf2f7ac6")(Duplex, Readable);
// Allow the keys array to be GC'ed.
var keys = objectKeys(Writable.prototype);
for(var v = 0; v < keys.length; v++){
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
}
function Duplex(options) {
    if (!(this instanceof Duplex)) return new Duplex(options);
    Readable.call(this, options);
    Writable.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once('end', onend);
        }
    }
}
Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty(Duplex.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty(Duplex.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
// the no-half-open enforcer
function onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    process.nextTick(onEndNT, this);
}
function onEndNT(self) {
    self.end();
}
Object.defineProperty(Duplex.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

},{"34d2aeaf352b4512":"4jeNM","7b75ce1e482a8dfb":"iiPxh","fd2e3b6f36c506e9":"31zPq","7dcb079aaf2f7ac6":"dwCbX"}],"31zPq":[function(require,module,exports,__globalThis) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
var global = arguments[3];
var process = require("960325341c691095");
'use strict';
module.exports = Writable;
/* <replacement> */ function WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var Duplex;
/*</replacement>*/ Writable.WritableState = WritableState;
/*<replacement>*/ var internalUtil = {
    deprecate: require("7d0952b2aab2880f")
};
/*</replacement>*/ /*<replacement>*/ var Stream = require("d4a8b8f0181be806");
/*</replacement>*/ var Buffer = require("329aa7fef0ab6df1").Buffer;
var OurUint8Array = (typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function _uint8ArrayToBuffer(chunk) {
    return Buffer.from(chunk);
}
function _isUint8Array(obj) {
    return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}
var destroyImpl = require("6a39a8b28b6e8ab4");
var _require = require("4b9079029d7ad85f"), getHighWaterMark = _require.getHighWaterMark;
var _require$codes = require("4d4d95a33057eaa").codes, ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED, ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK, ERR_STREAM_CANNOT_PIPE = _require$codes.ERR_STREAM_CANNOT_PIPE, ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED, ERR_STREAM_NULL_VALUES = _require$codes.ERR_STREAM_NULL_VALUES, ERR_STREAM_WRITE_AFTER_END = _require$codes.ERR_STREAM_WRITE_AFTER_END, ERR_UNKNOWN_ENCODING = _require$codes.ERR_UNKNOWN_ENCODING;
var errorOrDestroy = destroyImpl.errorOrDestroy;
require("df23fd9c6d29b882")(Writable, Stream);
function nop() {}
function WritableState(options, stream, isDuplex) {
    Duplex = Duplex || require("a02e72411207d1a6");
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new CorkedRequest(this);
}
WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty(WritableState.prototype, 'buffer', {
            get: internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", 'DEP0003')
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
    realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty(Writable, Symbol.hasInstance, {
        value: function value(object) {
            if (realHasInstance.call(this, object)) return true;
            if (this !== Writable) return false;
            return object && object._writableState instanceof WritableState;
        }
    });
} else realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};
function Writable(options) {
    Duplex = Duplex || require("a02e72411207d1a6");
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof Duplex;
    if (!isDuplex && !realHasInstance.call(Writable, this)) return new Writable(options);
    this._writableState = new WritableState(options, this, isDuplex);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
    }
    Stream.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function() {
    errorOrDestroy(this, new ERR_STREAM_CANNOT_PIPE());
};
function writeAfterEnd(stream, cb) {
    var er = new ERR_STREAM_WRITE_AFTER_END();
    // TODO: defer error events consistently everywhere, not just the cb
    errorOrDestroy(stream, er);
    process.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== 'string' && !state.objectMode) er = new ERR_INVALID_ARG_TYPE('chunk', [
        'string',
        'Buffer'
    ], chunk);
    if (er) {
        errorOrDestroy(stream, er);
        process.nextTick(cb, er);
        return false;
    }
    return true;
}
Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && _isUint8Array(chunk);
    if (isBuf && !Buffer.isBuffer(chunk)) chunk = _uint8ArrayToBuffer(chunk);
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = 'buffer';
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== 'function') cb = nop;
    if (state.ending) writeAfterEnd(this, cb);
    else if (isBuf || validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
Writable.prototype.cork = function() {
    this._writableState.corked++;
};
Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
    }
};
Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
    if (!([
        'hex',
        'utf8',
        'utf-8',
        'ascii',
        'binary',
        'base64',
        'ucs2',
        'ucs-2',
        'utf16le',
        'utf-16le',
        'raw'
    ].indexOf((encoding + '').toLowerCase()) > -1)) throw new ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty(Writable.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = 'buffer';
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        process.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        process.nextTick(finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        errorOrDestroy(stream, er);
        // this can emit finish, but finish must
        // always follow error
        finishMaybe(stream, state);
    }
}
function onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== 'function') throw new ERR_MULTIPLE_CALLBACK();
    onwriteStateUpdate(state);
    if (er) onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(stream, state);
        if (sync) process.nextTick(afterWrite, stream, state, finished, cb);
        else afterWrite(stream, state, finished, cb);
    }
}
function afterWrite(stream, state, finished, cb) {
    if (!finished) onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
}
// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        doWrite(stream, state, true, state.length, buffer, '', holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new ERR_METHOD_NOT_IMPLEMENTED('_write()'));
};
Writable.prototype._writev = null;
Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) endWritable(this, state, cb);
    return this;
};
Object.defineProperty(Writable.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit('prefinish');
        finishMaybe(stream, state);
    });
}
function prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            process.nextTick(callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function finishMaybe(stream, state) {
    var need = needFinish(state);
    if (need) {
        prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit('finish');
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function endWritable(stream, state, cb) {
    state.ending = true;
    finishMaybe(stream, state);
    if (cb) {
        if (state.finished) process.nextTick(cb);
        else stream.once('finish', cb);
    }
    state.ended = true;
    stream.writable = false;
}
function onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty(Writable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

},{"960325341c691095":"4jeNM","7d0952b2aab2880f":"53bfb","d4a8b8f0181be806":"6WLwc","329aa7fef0ab6df1":"cjdyz","6a39a8b28b6e8ab4":"iGtXS","4b9079029d7ad85f":"jG3M7","4d4d95a33057eaa":"2mf2H","df23fd9c6d29b882":"dwCbX","a02e72411207d1a6":"71LGu"}],"53bfb":[function(require,module,exports,__globalThis) {
/**
 * Module exports.
 */ var global = arguments[3];
module.exports = deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function deprecate(fn, msg) {
    if (config('noDeprecation')) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if (config('throwDeprecation')) throw new Error(msg);
            else if (config('traceDeprecation')) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === 'true';
}

},{}],"6a4se":[function(require,module,exports,__globalThis) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
/*<replacement>*/ var Buffer = require("2a29807c689a070a").Buffer;
/*</replacement>*/ var isEncoding = Buffer.isEncoding || function(encoding) {
    encoding = '' + encoding;
    switch(encoding && encoding.toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
        case 'raw':
            return true;
        default:
            return false;
    }
};
function _normalizeEncoding(enc) {
    if (!enc) return 'utf8';
    var retried;
    while(true)switch(enc){
        case 'utf8':
        case 'utf-8':
            return 'utf8';
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return 'utf16le';
        case 'latin1':
        case 'binary':
            return 'latin1';
        case 'base64':
        case 'ascii':
        case 'hex':
            return enc;
        default:
            if (retried) return; // undefined
            enc = ('' + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
    var nenc = _normalizeEncoding(enc);
    if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
    return nenc || enc;
}
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.StringDecoder = StringDecoder;
function StringDecoder(encoding) {
    this.encoding = normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case 'utf16le':
            this.text = utf16Text;
            this.end = utf16End;
            nb = 4;
            break;
        case 'utf8':
            this.fillLast = utf8FillLast;
            nb = 4;
            break;
        case 'base64':
            this.text = base64Text;
            this.end = base64End;
            nb = 3;
            break;
        default:
            this.write = simpleWrite;
            this.end = simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = Buffer.allocUnsafe(nb);
}
StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return '';
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return '';
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || '';
};
StringDecoder.prototype.end = utf8End;
// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return '\ufffd';
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return '\ufffd';
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return '\ufffd';
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
    var total = utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString('utf8', i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString('utf8', i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + '\ufffd';
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString('utf16le', i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString('utf16le', i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString('utf16le', 0, end);
    }
    return r;
}
function base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString('base64', i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString('base64', i, buf.length - n);
}
function base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : '';
}

},{"2a29807c689a070a":"1Yph5"}],"90IP8":[function(require,module,exports,__globalThis) {
var process = require("cc8bd4d851c0d480");
'use strict';
var _Object$setPrototypeO;
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var finished = require("c70af6a403549764");
var kLastResolve = Symbol('lastResolve');
var kLastReject = Symbol('lastReject');
var kError = Symbol('error');
var kEnded = Symbol('ended');
var kLastPromise = Symbol('lastPromise');
var kHandlePromise = Symbol('handlePromise');
var kStream = Symbol('stream');
function createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function readAndResolve(iter) {
    var resolve = iter[kLastResolve];
    if (resolve !== null) {
        var data = iter[kStream].read();
        // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[kLastPromise] = null;
            iter[kLastResolve] = null;
            iter[kLastReject] = null;
            resolve(createIterResult(data, false));
        }
    }
}
function onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    process.nextTick(readAndResolve, iter);
}
function wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[kEnded]) {
                resolve(createIterResult(undefined, true));
                return;
            }
            iter[kHandlePromise](resolve, reject);
        }, reject);
    };
}
var AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf((_Object$setPrototypeO = {
    get stream () {
        return this[kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[kError];
        if (error !== null) return Promise.reject(error);
        if (this[kEnded]) return Promise.resolve(createIterResult(undefined, true));
        if (this[kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            process.nextTick(function() {
                if (_this[kError]) reject(_this[kError]);
                else resolve(createIterResult(undefined, true));
            });
        });
        // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise(wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[kStream].read();
            if (data !== null) return Promise.resolve(createIterResult(data, false));
            promise = new Promise(this[kHandlePromise]);
        }
        this[kLastPromise] = promise;
        return promise;
    }
}, _defineProperty(_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), _defineProperty(_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve(createIterResult(undefined, true));
        });
    });
}), _Object$setPrototypeO), AsyncIteratorPrototype);
var createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create(ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, _defineProperty(_Object$create, kStream, {
        value: stream,
        writable: true
    }), _defineProperty(_Object$create, kLastResolve, {
        value: null,
        writable: true
    }), _defineProperty(_Object$create, kLastReject, {
        value: null,
        writable: true
    }), _defineProperty(_Object$create, kError, {
        value: null,
        writable: true
    }), _defineProperty(_Object$create, kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), _defineProperty(_Object$create, kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[kStream].read();
            if (data) {
                iterator[kLastPromise] = null;
                iterator[kLastResolve] = null;
                iterator[kLastReject] = null;
                resolve(createIterResult(data, false));
            } else {
                iterator[kLastResolve] = resolve;
                iterator[kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[kLastPromise] = null;
    finished(stream, function(err) {
        if (err && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') {
            var reject = iterator[kLastReject];
            // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[kLastPromise] = null;
                iterator[kLastResolve] = null;
                iterator[kLastReject] = null;
                reject(err);
            }
            iterator[kError] = err;
            return;
        }
        var resolve = iterator[kLastResolve];
        if (resolve !== null) {
            iterator[kLastPromise] = null;
            iterator[kLastResolve] = null;
            iterator[kLastReject] = null;
            resolve(createIterResult(undefined, true));
        }
        iterator[kEnded] = true;
    });
    stream.on('readable', onReadable.bind(null, iterator));
    return iterator;
};
module.exports = createReadableStreamAsyncIterator;

},{"cc8bd4d851c0d480":"4jeNM","c70af6a403549764":"bEUMt"}],"bEUMt":[function(require,module,exports,__globalThis) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';
var ERR_STREAM_PREMATURE_CLOSE = require("260b8c2ccb6493b7").codes.ERR_STREAM_PREMATURE_CLOSE;
function once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function noop() {}
function isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
function eos(stream, opts, callback) {
    if (typeof opts === 'function') return eos(stream, null, opts);
    if (!opts) opts = {};
    callback = once(callback || noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on('finish', onfinish);
    };
    if (isRequest(stream)) {
        stream.on('complete', onfinish);
        stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (opts.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    return function() {
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
}
module.exports = eos;

},{"260b8c2ccb6493b7":"2mf2H"}],"f5QXF":[function(require,module,exports,__globalThis) {
module.exports = function() {
    throw new Error('Readable.from is not available in the browser');
};

},{}],"hwuAh":[function(require,module,exports,__globalThis) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
'use strict';
module.exports = Transform;
var _require$codes = require("181e3ac8da6bd561").codes, ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED, ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK, ERR_TRANSFORM_ALREADY_TRANSFORMING = _require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, ERR_TRANSFORM_WITH_LENGTH_0 = _require$codes.ERR_TRANSFORM_WITH_LENGTH_0;
var Duplex = require("74feb8f76dae610a");
require("7382ff9fb3538488")(Transform, Duplex);
function afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit('error', new ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function Transform(options) {
    if (!(this instanceof Transform)) return new Transform(options);
    Duplex.call(this, options);
    this._transformState = {
        afterTransform: afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on('prefinish', prefinish);
}
function prefinish() {
    var _this = this;
    if (typeof this._flush === 'function' && !this._readableState.destroyed) this._flush(function(er, data) {
        done(_this, er, data);
    });
    else done(this, null, null);
}
Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return Duplex.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new ERR_METHOD_NOT_IMPLEMENTED('_transform()'));
};
Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
Transform.prototype._destroy = function(err, cb) {
    Duplex.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function done(stream, er, data) {
    if (er) return stream.emit('error', er);
    if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);
    // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

},{"181e3ac8da6bd561":"2mf2H","74feb8f76dae610a":"71LGu","7382ff9fb3538488":"dwCbX"}],"l3CZy":[function(require,module,exports,__globalThis) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';
module.exports = PassThrough;
var Transform = require("ef151ac5a8afeb5c");
require("ad2dd1617f55ad62")(PassThrough, Transform);
function PassThrough(options) {
    if (!(this instanceof PassThrough)) return new PassThrough(options);
    Transform.call(this, options);
}
PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

},{"ef151ac5a8afeb5c":"hwuAh","ad2dd1617f55ad62":"dwCbX"}],"5ED5k":[function(require,module,exports,__globalThis) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';
var eos;
function once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}
var _require$codes = require("e9d469d31ac56495").codes, ERR_MISSING_ARGS = _require$codes.ERR_MISSING_ARGS, ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED;
function noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
function destroyer(stream, reading, writing, callback) {
    callback = once(callback);
    var closed = false;
    stream.on('close', function() {
        closed = true;
    });
    if (eos === undefined) eos = require("96a756f22061fd7");
    eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true;
        // request.destroy just do .end - .abort is what we want
        if (isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === 'function') return stream.destroy();
        callback(err || new ERR_STREAM_DESTROYED('pipe'));
    };
}
function call(fn) {
    fn();
}
function pipe(from, to) {
    return from.pipe(to);
}
function popCallback(streams) {
    if (!streams.length) return noop;
    if (typeof streams[streams.length - 1] !== 'function') return noop;
    return streams.pop();
}
function pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new ERR_MISSING_ARGS('streams');
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach(call);
            if (reading) return;
            destroys.forEach(call);
            callback(error);
        });
    });
    return streams.reduce(pipe);
}
module.exports = pipeline;

},{"e9d469d31ac56495":"2mf2H","96a756f22061fd7":"bEUMt"}],"cKnjx":[function(require,module,exports,__globalThis) {
'use strict';
var Buffer = require("c813c8075bcf823e").Buffer;
var inherits = require("84928993e7c3934b");
var HashBase = require("4b3519823770a56d");
var ARRAY16 = new Array(16);
var zl = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var zr = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var sl = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var sr = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];
var hl = [
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
];
var hr = [
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
];
function rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function fn1(a, b, c, d, e, m, k, s) {
    return rotl(a + (b ^ c ^ d) + m + k | 0, s) + e | 0;
}
function fn2(a, b, c, d, e, m, k, s) {
    return rotl(a + (b & c | ~b & d) + m + k | 0, s) + e | 0;
}
function fn3(a, b, c, d, e, m, k, s) {
    return rotl(a + ((b | ~c) ^ d) + m + k | 0, s) + e | 0;
}
function fn4(a, b, c, d, e, m, k, s) {
    return rotl(a + (b & d | c & ~d) + m + k | 0, s) + e | 0;
}
function fn5(a, b, c, d, e, m, k, s) {
    return rotl(a + (b ^ (c | ~d)) + m + k | 0, s) + e | 0;
}
function RIPEMD160() {
    HashBase.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
}
inherits(RIPEMD160, HashBase);
RIPEMD160.prototype._update = function() {
    var words = ARRAY16;
    for(var j = 0; j < 16; ++j)words[j] = this._block.readInt32LE(j * 4);
    var al = this._a | 0;
    var bl = this._b | 0;
    var cl = this._c | 0;
    var dl = this._d | 0;
    var el = this._e | 0;
    var ar = this._a | 0;
    var br = this._b | 0;
    var cr = this._c | 0;
    var dr = this._d | 0;
    var er = this._e | 0;
    // computation
    for(var i = 0; i < 80; i += 1){
        var tl;
        var tr;
        if (i < 16) {
            tl = fn1(al, bl, cl, dl, el, words[zl[i]], hl[0], sl[i]);
            tr = fn5(ar, br, cr, dr, er, words[zr[i]], hr[0], sr[i]);
        } else if (i < 32) {
            tl = fn2(al, bl, cl, dl, el, words[zl[i]], hl[1], sl[i]);
            tr = fn4(ar, br, cr, dr, er, words[zr[i]], hr[1], sr[i]);
        } else if (i < 48) {
            tl = fn3(al, bl, cl, dl, el, words[zl[i]], hl[2], sl[i]);
            tr = fn3(ar, br, cr, dr, er, words[zr[i]], hr[2], sr[i]);
        } else if (i < 64) {
            tl = fn4(al, bl, cl, dl, el, words[zl[i]], hl[3], sl[i]);
            tr = fn2(ar, br, cr, dr, er, words[zr[i]], hr[3], sr[i]);
        } else {
            tl = fn5(al, bl, cl, dl, el, words[zl[i]], hl[4], sl[i]);
            tr = fn1(ar, br, cr, dr, er, words[zr[i]], hr[4], sr[i]);
        }
        al = el;
        el = dl;
        dl = rotl(cl, 10);
        cl = bl;
        bl = tl;
        ar = er;
        er = dr;
        dr = rotl(cr, 10);
        cr = br;
        br = tr;
    }
    // update state
    var t = this._b + cl + dr | 0;
    this._b = this._c + dl + er | 0;
    this._c = this._d + el + ar | 0;
    this._d = this._e + al + br | 0;
    this._e = this._a + bl + cr | 0;
    this._a = t;
};
RIPEMD160.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset] = 0x80;
    this._blockOffset += 1;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = Buffer.alloc ? Buffer.alloc(20) : new Buffer(20); // eslint-disable-line no-buffer-constructor
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    buffer.writeInt32LE(this._e, 16);
    return buffer;
};
module.exports = RIPEMD160;

},{"c813c8075bcf823e":"cjdyz","84928993e7c3934b":"dwCbX","4b3519823770a56d":"4W0rX"}],"4W0rX":[function(require,module,exports,__globalThis) {
'use strict';
var Buffer = require("ea4e3721a4f6adbf").Buffer;
var toBuffer = require("b99b08e3ffdd19c0");
var Transform = require("2ab9181faebfff90").Transform;
var inherits = require("e0af63c0b0b7ead5");
function HashBase(blockSize) {
    Transform.call(this);
    this._block = Buffer.allocUnsafe(blockSize);
    this._blockSize = blockSize;
    this._blockOffset = 0;
    this._length = [
        0,
        0,
        0,
        0
    ];
    this._finalized = false;
}
inherits(HashBase, Transform);
HashBase.prototype._transform = function(chunk, encoding, callback) {
    var error = null;
    try {
        this.update(chunk, encoding);
    } catch (err) {
        error = err;
    }
    callback(error);
};
HashBase.prototype._flush = function(callback) {
    var error = null;
    try {
        this.push(this.digest());
    } catch (err) {
        error = err;
    }
    callback(error);
};
HashBase.prototype.update = function(data, encoding) {
    if (this._finalized) throw new Error('Digest already called');
    var dataBuffer = toBuffer(data, encoding); // asserts correct input type
    // consume data
    var block = this._block;
    var offset = 0;
    while(this._blockOffset + dataBuffer.length - offset >= this._blockSize){
        for(var i = this._blockOffset; i < this._blockSize;){
            block[i] = dataBuffer[offset];
            i += 1;
            offset += 1;
        }
        this._update();
        this._blockOffset = 0;
    }
    while(offset < dataBuffer.length){
        block[this._blockOffset] = dataBuffer[offset];
        this._blockOffset += 1;
        offset += 1;
    }
    // update length
    for(var j = 0, carry = dataBuffer.length * 8; carry > 0; ++j){
        this._length[j] += carry;
        carry = this._length[j] / 0x0100000000 | 0;
        if (carry > 0) this._length[j] -= 0x0100000000 * carry;
    }
    return this;
};
HashBase.prototype._update = function() {
    throw new Error('_update is not implemented');
};
HashBase.prototype.digest = function(encoding) {
    if (this._finalized) throw new Error('Digest already called');
    this._finalized = true;
    var digest = this._digest();
    if (encoding !== undefined) digest = digest.toString(encoding);
    // reset state
    this._block.fill(0);
    this._blockOffset = 0;
    for(var i = 0; i < 4; ++i)this._length[i] = 0;
    return digest;
};
HashBase.prototype._digest = function() {
    throw new Error('_digest is not implemented');
};
module.exports = HashBase;

},{"ea4e3721a4f6adbf":"1Yph5","b99b08e3ffdd19c0":"2cost","2ab9181faebfff90":"aOZk9","e0af63c0b0b7ead5":"dwCbX"}],"2cost":[function(require,module,exports,__globalThis) {
'use strict';
var Buffer = require("c9b4421075c9c9e1").Buffer;
var toBuffer = require("22001790412e43d1");
var useUint8Array = typeof Uint8Array !== 'undefined';
var useArrayBuffer = useUint8Array && typeof ArrayBuffer !== 'undefined';
var isView = useArrayBuffer && ArrayBuffer.isView;
module.exports = function(thing, encoding) {
    if (typeof thing === 'string' || Buffer.isBuffer(thing) || useUint8Array && thing instanceof Uint8Array || isView && isView(thing)) return toBuffer(thing, encoding);
    throw new TypeError('The "data" argument must be a string, a Buffer, a Uint8Array, or a DataView');
};

},{"c9b4421075c9c9e1":"1Yph5","22001790412e43d1":"2pnit"}],"2pnit":[function(require,module,exports,__globalThis) {
'use strict';
var Buffer = require("7e6e9c1fdaa0601e").Buffer;
var isArray = require("f071f69779c69342");
var typedArrayBuffer = require("8efe291d278d5eea");
var isView = ArrayBuffer.isView || function isView(obj) {
    try {
        typedArrayBuffer(obj);
        return true;
    } catch (e) {
        return false;
    }
};
var useUint8Array = typeof Uint8Array !== 'undefined';
var useArrayBuffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined';
var useFromArrayBuffer = useArrayBuffer && (Buffer.prototype instanceof Uint8Array || Buffer.TYPED_ARRAY_SUPPORT);
module.exports = function toBuffer(data, encoding) {
    if (Buffer.isBuffer(data)) {
        if (data.constructor && !('isBuffer' in data)) // probably a SlowBuffer
        return Buffer.from(data);
        return data;
    }
    if (typeof data === 'string') return Buffer.from(data, encoding);
    /*
	 * Wrap any TypedArray instances and DataViews
	 * Makes sense only on engines with full TypedArray support -- let Buffer detect that
	 */ if (useArrayBuffer && isView(data)) {
        // Bug in Node.js <6.3.1, which treats this as out-of-bounds
        if (data.byteLength === 0) return Buffer.alloc(0);
        // When Buffer is based on Uint8Array, we can just construct it from ArrayBuffer
        if (useFromArrayBuffer) {
            var res = Buffer.from(data.buffer, data.byteOffset, data.byteLength);
            /*
			 * Recheck result size, as offset/length doesn't work on Node.js <5.10
			 * We just go to Uint8Array case if this fails
			 */ if (res.byteLength === data.byteLength) return res;
        }
        // Convert to Uint8Array bytes and then to Buffer
        var uint8 = data instanceof Uint8Array ? data : new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
        var result = Buffer.from(uint8);
        /*
		 * Let's recheck that conversion succeeded
		 * We have .length but not .byteLength when useFromArrayBuffer is false
		 */ if (result.length === data.byteLength) return result;
    }
    /*
	 * Uint8Array in engines where Buffer.from might not work with ArrayBuffer, just copy over
	 * Doesn't make sense with other TypedArray instances
	 */ if (useUint8Array && data instanceof Uint8Array) return Buffer.from(data);
    var isArr = isArray(data);
    if (isArr) for(var i = 0; i < data.length; i += 1){
        var x = data[i];
        if (typeof x !== 'number' || x < 0 || x > 255 || ~~x !== x // NaN and integer check
        ) throw new RangeError('Array items must be numbers in the range 0-255.');
    }
    /*
	 * Old Buffer polyfill on an engine that doesn't have TypedArray support
	 * Also, this is from a different Buffer polyfill implementation then we have, as instanceof check failed
	 * Convert to our current Buffer implementation
	 */ if (isArr || Buffer.isBuffer(data) && data.constructor && typeof data.constructor.isBuffer === 'function' && data.constructor.isBuffer(data)) return Buffer.from(data);
    throw new TypeError('The "data" argument must be a string, an Array, a Buffer, a Uint8Array, or a DataView.');
};

},{"7e6e9c1fdaa0601e":"1Yph5","f071f69779c69342":"65yVV","8efe291d278d5eea":"kwcV5"}],"65yVV":[function(require,module,exports,__globalThis) {
var toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return toString.call(arr) == '[object Array]';
};

},{}],"kwcV5":[function(require,module,exports,__globalThis) {
'use strict';
var $TypeError = require("e48e3bf1182f54b");
var callBound = require("749d73ae9b5b61d0");
/** @type {undefined | ((thisArg: import('.').TypedArray) => Buffer<ArrayBufferLike>)} */ var $typedArrayBuffer = callBound('TypedArray.prototype.buffer', true);
var isTypedArray = require("ab9db50ce28124c2");
/** @type {import('.')} */ // node <= 0.10, < 0.11.4 has a nonconfigurable own property instead of a prototype getter
module.exports = $typedArrayBuffer || function typedArrayBuffer(x) {
    if (!isTypedArray(x)) throw new $TypeError('Not a Typed Array');
    return x.buffer;
};

},{"e48e3bf1182f54b":"2VLQN","749d73ae9b5b61d0":"hTEFT","ab9db50ce28124c2":"CqRo3"}],"2VLQN":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./type')} */ module.exports = TypeError;

},{}],"hTEFT":[function(require,module,exports,__globalThis) {
'use strict';
var GetIntrinsic = require("90205503fa989ea7");
var callBindBasic = require("79b99f4b8fc521d");
/** @type {(thisArg: string, searchString: string, position?: number) => number} */ var $indexOf = callBindBasic([
    GetIntrinsic('%String.prototype.indexOf%')
]);
/** @type {import('.')} */ module.exports = function callBoundIntrinsic(name, allowMissing) {
    /* eslint no-extra-parens: 0 */ var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ GetIntrinsic(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) return callBindBasic(/** @type {const} */ [
        intrinsic
    ]);
    return intrinsic;
};

},{"90205503fa989ea7":"058XE","79b99f4b8fc521d":"gTJWl"}],"058XE":[function(require,module,exports,__globalThis) {
'use strict';
var undefined1;
var $Object = require("2664640474097f21");
var $Error = require("ff34c740859aa28e");
var $EvalError = require("349515b7ea9b6cef");
var $RangeError = require("9da01653b2dd9abf");
var $ReferenceError = require("68586abd6b0136da");
var $SyntaxError = require("662263fdbc077fc8");
var $TypeError = require("abdfc34e5f6bb86");
var $URIError = require("daca1f932429e03e");
var abs = require("6a52a0c0ffccac74");
var floor = require("d01cf04757c5320b");
var max = require("a2657a92cb7dae87");
var min = require("6367c0241be1f01");
var pow = require("9bee48b90a8c96d");
var round = require("b5cc049891156ba3");
var sign = require("8d956274d8c0407e");
var $Function = Function;
// eslint-disable-next-line consistent-return
var getEvalledConstructor = function(expressionSyntax) {
    try {
        return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};
var $gOPD = require("7f0abb73c570ef31");
var $defineProperty = require("3cbcb7341b0412ef");
var throwTypeError = function() {
    throw new $TypeError();
};
var ThrowTypeError = $gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $gOPD(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return throwTypeError;
        }
    }
}() : throwTypeError;
var hasSymbols = require("1f00f712d594ccf")();
var getProto = require("89cf41d095fe5a0a");
var $ObjectGPO = require("a5e781ace21741c8");
var $ReflectGPO = require("db08b186beb7f382");
var $apply = require("213af9137f841281");
var $call = require("56d5af438508fcc0");
var needsEval = {};
var TypedArray = typeof Uint8Array === 'undefined' || !getProto ? undefined : getProto(Uint8Array);
var INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': needsEval,
    '%AsyncGenerator%': needsEval,
    '%AsyncGeneratorFunction%': needsEval,
    '%AsyncIteratorPrototype%': needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $Error,
    '%eval%': eval,
    '%EvalError%': $EvalError,
    '%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $Function,
    '%GeneratorFunction%': needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': $Object,
    '%Object.getOwnPropertyDescriptor%': $gOPD,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $RangeError,
    '%ReferenceError%': $ReferenceError,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': hasSymbols && getProto ? getProto(''[Symbol.iterator]()) : undefined,
    '%Symbol%': hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $SyntaxError,
    '%ThrowTypeError%': ThrowTypeError,
    '%TypedArray%': TypedArray,
    '%TypeError%': $TypeError,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $URIError,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
    '%Function.prototype.call%': $call,
    '%Function.prototype.apply%': $apply,
    '%Object.defineProperty%': $defineProperty,
    '%Object.getPrototypeOf%': $ObjectGPO,
    '%Math.abs%': abs,
    '%Math.floor%': floor,
    '%Math.max%': max,
    '%Math.min%': min,
    '%Math.pow%': pow,
    '%Math.round%': round,
    '%Math.sign%': sign,
    '%Reflect.getPrototypeOf%': $ReflectGPO
};
if (getProto) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var errorProto = getProto(getProto(e));
    INTRINSICS['%Error.prototype%'] = errorProto;
}
var doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && getProto) value = getProto(gen.prototype);
    }
    INTRINSICS[name] = value;
    return value;
};
var LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};
var bind = require("7c5e688e48cd07b0");
var hasOwn = require("af36d49b4b8c6c7c");
var $concat = bind.call($call, Array.prototype.concat);
var $spliceApply = bind.call($apply, Array.prototype.splice);
var $replace = bind.call($call, String.prototype.replace);
var $strSlice = bind.call($call, String.prototype.slice);
var $exec = bind.call($call, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var stringToPath = function stringToPath(string) {
    var first = $strSlice(string, 0, 1);
    var last = $strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $replace(string, rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
        alias = LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if (hasOwn(INTRINSICS, intrinsicName)) {
        var value = INTRINSICS[intrinsicName];
        if (value === needsEval) value = doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $TypeError('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $TypeError('"allowMissing" argument must be a boolean');
    if ($exec(/^%?[^%]*%?$/, name) === null) throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $spliceApply(parts, $concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $strSlice(part, 0, 1);
        var last = $strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $SyntaxError('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if (hasOwn(INTRINSICS, intrinsicRealName)) value = INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($gOPD && i + 1 >= parts.length) {
                var desc = $gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = hasOwn(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

},{"2664640474097f21":"7Ksp8","ff34c740859aa28e":"3wbXc","349515b7ea9b6cef":"l1Wrc","9da01653b2dd9abf":"libr5","68586abd6b0136da":"3WvY5","662263fdbc077fc8":"hXlpg","abdfc34e5f6bb86":"2VLQN","daca1f932429e03e":"3FHAd","6a52a0c0ffccac74":"2kgQT","d01cf04757c5320b":"j9J4P","a2657a92cb7dae87":"bxY7u","6367c0241be1f01":"7bI20","9bee48b90a8c96d":"6zn0m","b5cc049891156ba3":"jyGHM","8d956274d8c0407e":"ftZgq","7f0abb73c570ef31":"lzdql","3cbcb7341b0412ef":"2ifPq","1f00f712d594ccf":"fHFMn","89cf41d095fe5a0a":"8ic6N","a5e781ace21741c8":"5WFhV","db08b186beb7f382":"axg4N","213af9137f841281":"g4Nh3","56d5af438508fcc0":"6JU9c","7c5e688e48cd07b0":"juBRo","af36d49b4b8c6c7c":"1Mo7m"}],"7Ksp8":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('.')} */ module.exports = Object;

},{}],"3wbXc":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('.')} */ module.exports = Error;

},{}],"l1Wrc":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./eval')} */ module.exports = EvalError;

},{}],"libr5":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./range')} */ module.exports = RangeError;

},{}],"3WvY5":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./ref')} */ module.exports = ReferenceError;

},{}],"hXlpg":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./syntax')} */ module.exports = SyntaxError;

},{}],"3FHAd":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./uri')} */ module.exports = URIError;

},{}],"2kgQT":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./abs')} */ module.exports = Math.abs;

},{}],"j9J4P":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./floor')} */ module.exports = Math.floor;

},{}],"bxY7u":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./max')} */ module.exports = Math.max;

},{}],"7bI20":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./min')} */ module.exports = Math.min;

},{}],"6zn0m":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./pow')} */ module.exports = Math.pow;

},{}],"jyGHM":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./round')} */ module.exports = Math.round;

},{}],"ftZgq":[function(require,module,exports,__globalThis) {
'use strict';
var $isNaN = require("d292273fa9eecbef");
/** @type {import('./sign')} */ module.exports = function sign(number) {
    if ($isNaN(number) || number === 0) return number;
    return number < 0 ? -1 : 1;
};

},{"d292273fa9eecbef":"1ZAPK"}],"1ZAPK":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./isNaN')} */ module.exports = Number.isNaN || function isNaN(a) {
    return a !== a;
};

},{}],"lzdql":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('.')} */ var $gOPD = require("2065a078be813600");
if ($gOPD) try {
    $gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $gOPD = null;
}
module.exports = $gOPD;

},{"2065a078be813600":"ggfvZ"}],"ggfvZ":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./gOPD')} */ module.exports = Object.getOwnPropertyDescriptor;

},{}],"2ifPq":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('.')} */ var $defineProperty = Object.defineProperty || false;
if ($defineProperty) try {
    $defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $defineProperty = false;
}
module.exports = $defineProperty;

},{}],"fHFMn":[function(require,module,exports,__globalThis) {
'use strict';
var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = require("3fb25678c62d2fce");
/** @type {import('.')} */ module.exports = function hasNativeSymbols() {
    if (typeof origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if (typeof origSymbol('foo') !== 'symbol') return false;
    if (typeof Symbol('bar') !== 'symbol') return false;
    return hasSymbolSham();
};

},{"3fb25678c62d2fce":"f53QL"}],"f53QL":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./shams')} */ /* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if (typeof Symbol.iterator === 'symbol') return true;
    /** @type {{ [k in symbol]?: unknown }} */ var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(var _ in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {PropertyDescriptor} */ Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

},{}],"8ic6N":[function(require,module,exports,__globalThis) {
'use strict';
var reflectGetProto = require("ba0ea764912daf49");
var originalGetProto = require("1bd809a13f9b0f46");
var getDunderProto = require("fbec8086c64f7968");
/** @type {import('.')} */ module.exports = reflectGetProto ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return reflectGetProto(O);
} : originalGetProto ? function getProto(O) {
    if (!O || typeof O !== 'object' && typeof O !== 'function') throw new TypeError('getProto: not an object');
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return originalGetProto(O);
} : getDunderProto ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return getDunderProto(O);
} : null;

},{"ba0ea764912daf49":"axg4N","1bd809a13f9b0f46":"5WFhV","fbec8086c64f7968":"ldPsE"}],"axg4N":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./Reflect.getPrototypeOf')} */ module.exports = typeof Reflect !== 'undefined' && Reflect.getPrototypeOf || null;

},{}],"5WFhV":[function(require,module,exports,__globalThis) {
'use strict';
var $Object = require("23f06d8f004a91fb");
/** @type {import('./Object.getPrototypeOf')} */ module.exports = $Object.getPrototypeOf || null;

},{"23f06d8f004a91fb":"7Ksp8"}],"ldPsE":[function(require,module,exports,__globalThis) {
'use strict';
var callBind = require("20202e6273970ec3");
var gOPD = require("6e9e415ed4ed192c");
var hasProtoAccessor;
try {
    // eslint-disable-next-line no-extra-parens, no-proto
    hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ [].__proto__ === Array.prototype;
} catch (e) {
    if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') throw e;
}
// eslint-disable-next-line no-extra-parens
var desc = !!hasProtoAccessor && gOPD && gOPD(Object.prototype, /** @type {keyof typeof Object.prototype} */ '__proto__');
var $Object = Object;
var $getPrototypeOf = $Object.getPrototypeOf;
/** @type {import('./get')} */ module.exports = desc && typeof desc.get === 'function' ? callBind([
    desc.get
]) : typeof $getPrototypeOf === 'function' ? /** @type {import('./get')} */ function getDunder(value) {
    // eslint-disable-next-line eqeqeq
    return $getPrototypeOf(value == null ? value : $Object(value));
} : false;

},{"20202e6273970ec3":"gTJWl","6e9e415ed4ed192c":"lzdql"}],"gTJWl":[function(require,module,exports,__globalThis) {
'use strict';
var bind = require("d6d8aee3c61fa381");
var $TypeError = require("3ad70b4ee76fdc3");
var $call = require("79792e7530a25b0e");
var $actualApply = require("1883a23d55f655c3");
/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */ module.exports = function callBindBasic(args) {
    if (args.length < 1 || typeof args[0] !== 'function') throw new $TypeError('a function is required');
    return $actualApply(bind, $call, args);
};

},{"d6d8aee3c61fa381":"juBRo","3ad70b4ee76fdc3":"2VLQN","79792e7530a25b0e":"6JU9c","1883a23d55f655c3":"cYY6R"}],"juBRo":[function(require,module,exports,__globalThis) {
'use strict';
var implementation = require("12e173b4dbaee960");
module.exports = Function.prototype.bind || implementation;

},{"12e173b4dbaee960":"6zMRe"}],"6zMRe":[function(require,module,exports,__globalThis) {
'use strict';
/* eslint no-invalid-this: 1 */ var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var toStr = Object.prototype.toString;
var max = Math.max;
var funcType = '[object Function]';
var concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var joiny = function(arr, joiner) {
    var str = '';
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.apply(target) !== funcType) throw new TypeError(ERROR_MESSAGE + target);
    var args = slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, concatty(args, arguments));
    };
    var boundLength = max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
    bound = Function('binder', 'return function (' + joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

},{}],"6JU9c":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./functionCall')} */ module.exports = Function.prototype.call;

},{}],"cYY6R":[function(require,module,exports,__globalThis) {
'use strict';
var bind = require("ba0cb57b961776b");
var $apply = require("8002d8d4a5e40cd8");
var $call = require("dd5326344bf1485c");
var $reflectApply = require("ddbf3cfadf2f22c");
/** @type {import('./actualApply')} */ module.exports = $reflectApply || bind.call($call, $apply);

},{"ba0cb57b961776b":"juBRo","8002d8d4a5e40cd8":"g4Nh3","dd5326344bf1485c":"6JU9c","ddbf3cfadf2f22c":"bVefI"}],"g4Nh3":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./functionApply')} */ module.exports = Function.prototype.apply;

},{}],"bVefI":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./reflectApply')} */ module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;

},{}],"1Mo7m":[function(require,module,exports,__globalThis) {
'use strict';
var call = Function.prototype.call;
var $hasOwn = Object.prototype.hasOwnProperty;
var bind = require("126cb75e62f8e17b");
/** @type {import('.')} */ module.exports = bind.call(call, $hasOwn);

},{"126cb75e62f8e17b":"juBRo"}],"CqRo3":[function(require,module,exports,__globalThis) {
'use strict';
var whichTypedArray = require("ccf73e5f240c2b8");
/** @type {import('.')} */ module.exports = function isTypedArray(value) {
    return !!whichTypedArray(value);
};

},{"ccf73e5f240c2b8":"ek7bY"}],"ek7bY":[function(require,module,exports,__globalThis) {
var global = arguments[3];
'use strict';
var forEach = require("2941d48f36957e3c");
var availableTypedArrays = require("beaf5502a5823cce");
var callBind = require("e5d203a1b4c809f9");
var callBound = require("c1f328b1ef67e936");
var gOPD = require("ce6b45c571ba4e3e");
var getProto = require("4877134a9146c5d7");
var $toString = callBound('Object.prototype.toString');
var hasToStringTag = require("9e7ef6c88184c56")();
var g = typeof globalThis === 'undefined' ? global : globalThis;
var typedArrays = availableTypedArrays();
var $slice = callBound('String.prototype.slice');
/** @import { BoundSet, BoundSlice, Cache, Getter } from './types' */ /** @import { TypedArrayName } from '.' */ /** @type {<T = unknown>(array: readonly T[], value: unknown) => number} */ var $indexOf = callBound('Array.prototype.indexOf', true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
/** @type {Cache} */ var cache = {
    __proto__: null
};
if (hasToStringTag && gOPD && getProto) forEach(typedArrays, function(typedArray) {
    var arr = new g[typedArray]();
    if (Symbol.toStringTag in arr && getProto) {
        var proto = getProto(arr);
        // @ts-expect-error TS won't narrow inside a closure
        var descriptor = gOPD(proto, Symbol.toStringTag);
        if (!descriptor && proto) {
            var superProto = getProto(proto);
            // @ts-expect-error TS won't narrow inside a closure
            descriptor = gOPD(superProto, Symbol.toStringTag);
        }
        if (descriptor && descriptor.get) {
            var bound = callBind(descriptor.get);
            cache[/** @type {`$${TypedArrayName}`} */ '$' + typedArray] = bound;
        }
    }
});
else forEach(typedArrays, function(typedArray) {
    var arr = new g[typedArray]();
    var fn = arr.slice || arr.set;
    if (fn) {
        var bound = /** @type {BoundSlice | BoundSet} */ // @ts-expect-error TODO FIXME
        callBind(fn);
        cache[/** @type {`$${TypedArrayName}`} */ '$' + typedArray] = bound;
    }
});
/** @type {(value: object) => false | TypedArrayName} */ function tryTypedArrays(value) {
    /** @type {ReturnType<typeof tryTypedArrays>} */ var found = false;
    forEach(/** @type {Record<`$${TypedArrayName}`, Getter>} */ cache, /** @param {Getter} getter @param {`$${TypedArrayName}`} typedArray */ function(getter, typedArray) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            if ('$' + getter(value) === typedArray) found = /** @type {TypedArrayName} */ $slice(typedArray, 1);
        } catch (e) {}
    });
    return found;
}
/** @type {(value: object) => false | TypedArrayName} */ function trySlices(value) {
    /** @type {ReturnType<typeof trySlices>} */ var found = false;
    forEach(/** @type {Record<`$${TypedArrayName}`, Getter>} */ cache, /** @param {Getter} getter @param {`$${TypedArrayName}`} name */ function(getter, name) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            getter(value);
            found = /** @type {TypedArrayName} */ $slice(name, 1);
        } catch (e) {}
    });
    return found;
}
/** @type {(tag: unknown) => tag is typeof typedArrays[number]} */ function isTATag(tag) {
    return $indexOf(typedArrays, tag) > -1;
}
/**
 * @type {import('.')}
 * @param {unknown} value
 */ module.exports = function whichTypedArray(value) {
    if (!value || typeof value !== 'object') return false;
    if (!hasToStringTag) {
        var tag = $slice($toString(value), 8, -1);
        if (isTATag(tag)) return tag;
        if (tag !== 'Object') return false;
        // node < 0.6 hits here on real Typed Arrays
        return trySlices(value);
    }
    if (!gOPD) return null;
     // unknown engine
    return tryTypedArrays(value);
};

},{"2941d48f36957e3c":"jov5e","beaf5502a5823cce":"NFlzf","e5d203a1b4c809f9":"2es3y","c1f328b1ef67e936":"hTEFT","ce6b45c571ba4e3e":"lzdql","4877134a9146c5d7":"8ic6N","9e7ef6c88184c56":"9mzTN"}],"jov5e":[function(require,module,exports,__globalThis) {
'use strict';
var isCallable = require("e50ebc24bbb25feb");
var toStr = Object.prototype.toString;
var hasOwnProperty = Object.prototype.hasOwnProperty;
/** @type {<This, A extends readonly unknown[]>(arr: A, iterator: (this: This | void, value: A[number], index: number, arr: A) => void, receiver: This | undefined) => void} */ var forEachArray = function forEachArray(array, iterator, receiver) {
    for(var i = 0, len = array.length; i < len; i++)if (hasOwnProperty.call(array, i)) {
        if (receiver == null) iterator(array[i], i, array);
        else iterator.call(receiver, array[i], i, array);
    }
};
/** @type {<This, S extends string>(string: S, iterator: (this: This | void, value: S[number], index: number, string: S) => void, receiver: This | undefined) => void} */ var forEachString = function forEachString(string, iterator, receiver) {
    for(var i = 0, len = string.length; i < len; i++)// no such thing as a sparse string.
    if (receiver == null) iterator(string.charAt(i), i, string);
    else iterator.call(receiver, string.charAt(i), i, string);
};
/** @type {<This, O>(obj: O, iterator: (this: This | void, value: O[keyof O], index: keyof O, obj: O) => void, receiver: This | undefined) => void} */ var forEachObject = function forEachObject(object, iterator, receiver) {
    for(var k in object)if (hasOwnProperty.call(object, k)) {
        if (receiver == null) iterator(object[k], k, object);
        else iterator.call(receiver, object[k], k, object);
    }
};
/** @type {(x: unknown) => x is readonly unknown[]} */ function isArray(x) {
    return toStr.call(x) === '[object Array]';
}
/** @type {import('.')._internal} */ module.exports = function forEach(list, iterator, thisArg) {
    if (!isCallable(iterator)) throw new TypeError('iterator must be a function');
    var receiver;
    if (arguments.length >= 3) receiver = thisArg;
    if (isArray(list)) forEachArray(list, iterator, receiver);
    else if (typeof list === 'string') forEachString(list, iterator, receiver);
    else forEachObject(list, iterator, receiver);
};

},{"e50ebc24bbb25feb":"8pR5E"}],"8pR5E":[function(require,module,exports,__globalThis) {
'use strict';
var fnToStr = Function.prototype.toString;
var reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var badArrayLike;
var isCallableMarker;
if (typeof reflectApply === 'function' && typeof Object.defineProperty === 'function') try {
    badArrayLike = Object.defineProperty({}, 'length', {
        get: function() {
            throw isCallableMarker;
        }
    });
    isCallableMarker = {};
    // eslint-disable-next-line no-throw-literal
    reflectApply(function() {
        throw 42;
    }, null, badArrayLike);
} catch (_) {
    if (_ !== isCallableMarker) reflectApply = null;
}
else reflectApply = null;
var constructorRegex = /^\s*class\b/;
var isES6ClassFn = function isES6ClassFunction(value) {
    try {
        var fnStr = fnToStr.call(value);
        return constructorRegex.test(fnStr);
    } catch (e) {
        return false; // not a function
    }
};
var tryFunctionObject = function tryFunctionToStr(value) {
    try {
        if (isES6ClassFn(value)) return false;
        fnToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var toStr = Object.prototype.toString;
var objectClass = '[object Object]';
var fnClass = '[object Function]';
var genClass = '[object GeneratorFunction]';
var ddaClass = '[object HTMLAllCollection]'; // IE 11
var ddaClass2 = '[object HTML document.all class]';
var ddaClass3 = '[object HTMLCollection]'; // IE 9-10
var hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`
var isIE68 = !(0 in [
    , 
]); // eslint-disable-line no-sparse-arrays, comma-spacing
var isDDA = function isDocumentDotAll() {
    return false;
};
if (typeof document === 'object') {
    // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
    var all = document.all;
    if (toStr.call(all) === toStr.call(document.all)) isDDA = function isDocumentDotAll(value) {
        /* globals document: false */ // in IE 6-8, typeof document.all is "object" and it's truthy
        if ((isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) try {
            var str = toStr.call(value);
            return (str === ddaClass || str === ddaClass2 || str === ddaClass3 // opera 12.16
             || str === objectClass // IE 6-8
            ) && value('') == null; // eslint-disable-line eqeqeq
        } catch (e) {}
        return false;
    };
}
module.exports = reflectApply ? function isCallable(value) {
    if (isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    try {
        reflectApply(value, null, badArrayLike);
    } catch (e) {
        if (e !== isCallableMarker) return false;
    }
    return !isES6ClassFn(value) && tryFunctionObject(value);
} : function isCallable(value) {
    if (isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    if (hasToStringTag) return tryFunctionObject(value);
    if (isES6ClassFn(value)) return false;
    var strClass = toStr.call(value);
    if (strClass !== fnClass && strClass !== genClass && !/^\[object HTML/.test(strClass)) return false;
    return tryFunctionObject(value);
};

},{}],"NFlzf":[function(require,module,exports,__globalThis) {
var global = arguments[3];
'use strict';
var possibleNames = require("3021d1584ad62785");
var g = typeof globalThis === 'undefined' ? global : globalThis;
/** @type {import('.')} */ module.exports = function availableTypedArrays() {
    var /** @type {ReturnType<typeof availableTypedArrays>} */ out = [];
    for(var i = 0; i < possibleNames.length; i++)if (typeof g[possibleNames[i]] === 'function') // @ts-expect-error
    out[out.length] = possibleNames[i];
    return out;
};

},{"3021d1584ad62785":"eUdnT"}],"eUdnT":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('.')} */ module.exports = [
    'Float16Array',
    'Float32Array',
    'Float64Array',
    'Int8Array',
    'Int16Array',
    'Int32Array',
    'Uint8Array',
    'Uint8ClampedArray',
    'Uint16Array',
    'Uint32Array',
    'BigInt64Array',
    'BigUint64Array'
];

},{}],"2es3y":[function(require,module,exports,__globalThis) {
'use strict';
var setFunctionLength = require("f4b53071c102d4e");
var $defineProperty = require("3426ee59b177cf96");
var callBindBasic = require("48445b01a0d39287");
var applyBind = require("2ccc4afca1db8d27");
module.exports = function callBind(originalFunction) {
    var func = callBindBasic(arguments);
    var adjustedLength = 1 + originalFunction.length - (arguments.length - 1);
    return setFunctionLength(func, adjustedLength > 0 ? adjustedLength : 0, true);
};
if ($defineProperty) $defineProperty(module.exports, 'apply', {
    value: applyBind
});
else module.exports.apply = applyBind;

},{"f4b53071c102d4e":"7Yrlh","3426ee59b177cf96":"2ifPq","48445b01a0d39287":"gTJWl","2ccc4afca1db8d27":"dGL48"}],"7Yrlh":[function(require,module,exports,__globalThis) {
'use strict';
var GetIntrinsic = require("8b1c9107ef1524f2");
var define = require("37dd1486f0f556ef");
var hasDescriptors = require("6a9d2b46085df706")();
var gOPD = require("2d412b0f532d1834");
var $TypeError = require("4352c534d27fe477");
var $floor = GetIntrinsic('%Math.floor%');
/** @type {import('.')} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== 'function') throw new $TypeError('`fn` is not a function');
    if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $floor(length) !== length) throw new $TypeError('`length` must be a positive 32-bit integer');
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ('length' in fn && gOPD) {
        var desc = gOPD(fn, 'length');
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if (hasDescriptors) define(/** @type {Parameters<define>[0]} */ fn, 'length', length, true, true);
        else define(/** @type {Parameters<define>[0]} */ fn, 'length', length);
    }
    return fn;
};

},{"8b1c9107ef1524f2":"058XE","37dd1486f0f556ef":"6xKI2","6a9d2b46085df706":"jZzuO","2d412b0f532d1834":"lzdql","4352c534d27fe477":"2VLQN"}],"6xKI2":[function(require,module,exports,__globalThis) {
'use strict';
var $defineProperty = require("f17fd23367965521");
var $SyntaxError = require("50f12088ee0f6bb");
var $TypeError = require("45c79de2b2f9c949");
var gopd = require("3f9bd39335781ec7");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== 'object' && typeof obj !== 'function') throw new $TypeError('`obj` must be an object or a function`');
    if (typeof property !== 'string' && typeof property !== 'symbol') throw new $TypeError('`property` must be a string or a symbol`');
    if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) throw new $TypeError('`nonEnumerable`, if provided, must be a boolean or null');
    if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) throw new $TypeError('`nonWritable`, if provided, must be a boolean or null');
    if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) throw new $TypeError('`nonConfigurable`, if provided, must be a boolean or null');
    if (arguments.length > 6 && typeof arguments[6] !== 'boolean') throw new $TypeError('`loose`, if provided, must be a boolean');
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!gopd && gopd(obj, property);
    if ($defineProperty) $defineProperty(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $SyntaxError('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
};

},{"f17fd23367965521":"2ifPq","50f12088ee0f6bb":"hXlpg","45c79de2b2f9c949":"2VLQN","3f9bd39335781ec7":"lzdql"}],"jZzuO":[function(require,module,exports,__globalThis) {
'use strict';
var $defineProperty = require("1c3b0ce871129f60");
var hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$defineProperty;
};
hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$defineProperty) return null;
    try {
        return $defineProperty([], 'length', {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = hasPropertyDescriptors;

},{"1c3b0ce871129f60":"2ifPq"}],"dGL48":[function(require,module,exports,__globalThis) {
'use strict';
var bind = require("a42cbe56dcf9275");
var $apply = require("374f458abdeecf5a");
var actualApply = require("5dc0de3ccb73e5d2");
/** @type {import('./applyBind')} */ module.exports = function applyBind() {
    return actualApply(bind, $apply, arguments);
};

},{"a42cbe56dcf9275":"juBRo","374f458abdeecf5a":"g4Nh3","5dc0de3ccb73e5d2":"cYY6R"}],"9mzTN":[function(require,module,exports,__globalThis) {
'use strict';
var hasSymbols = require("2ef89576d4959bff");
/** @type {import('.')} */ module.exports = function hasToStringTagShams() {
    return hasSymbols() && !!Symbol.toStringTag;
};

},{"2ef89576d4959bff":"f53QL"}],"aOZk9":[function(require,module,exports,__globalThis) {
exports = module.exports = require("68bb3bdae87803ec");
exports.Stream = exports;
exports.Readable = exports;
exports.Writable = require("74167f79b688eaf7");
exports.Duplex = require("84600f6783428a47");
exports.Transform = require("23bee5f697448a0");
exports.PassThrough = require("e0ec4b8e438dbbd");

},{"68bb3bdae87803ec":"f1FWv","74167f79b688eaf7":"bL6kH","84600f6783428a47":"e5d07","23bee5f697448a0":"dr4NM","e0ec4b8e438dbbd":"jcn46"}],"f1FWv":[function(require,module,exports,__globalThis) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
var global = arguments[3];
var process = require("896ff8d56553f7a");
'use strict';
/*<replacement>*/ var pna = require("6a3257a5fd38b090");
/*</replacement>*/ module.exports = Readable;
/*<replacement>*/ var isArray = require("e90e9a84ea2f1bd2");
/*</replacement>*/ /*<replacement>*/ var Duplex;
/*</replacement>*/ Readable.ReadableState = ReadableState;
/*<replacement>*/ var EE = require("16782d660ac22e0c").EventEmitter;
var EElistenerCount = function(emitter, type) {
    return emitter.listeners(type).length;
};
/*</replacement>*/ /*<replacement>*/ var Stream = require("9a34f23fa53f83f7");
/*</replacement>*/ /*<replacement>*/ var Buffer = require("1711a8218ab7e640").Buffer;
var OurUint8Array = (typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function _uint8ArrayToBuffer(chunk) {
    return Buffer.from(chunk);
}
function _isUint8Array(obj) {
    return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}
/*</replacement>*/ /*<replacement>*/ var util = Object.create(require("aec0c91a1241db87"));
util.inherits = require("19affa8ce41f090d");
/*</replacement>*/ /*<replacement>*/ var debugUtil = require("a4a723b7297c7152");
var debug = void 0;
if (debugUtil && debugUtil.debuglog) debug = debugUtil.debuglog('stream');
else debug = function() {};
/*</replacement>*/ var BufferList = require("ce0c5a097ab7ecd0");
var destroyImpl = require("efa8155386cc4283");
var StringDecoder;
util.inherits(Readable, Stream);
var kProxyEvents = [
    'error',
    'close',
    'destroy',
    'pause',
    'resume'
];
function prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}
function ReadableState(options, stream) {
    Duplex = Duplex || require("f1c95f846e94e4eb");
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    var hwm = options.highWaterMark;
    var readableHwm = options.readableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new BufferList();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!StringDecoder) StringDecoder = require("6392acd10886f115").StringDecoder;
        this.decoder = new StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}
function Readable(options) {
    Duplex = Duplex || require("f1c95f846e94e4eb");
    if (!(this instanceof Readable)) return new Readable(options);
    this._readableState = new ReadableState(options, this);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
    }
    Stream.call(this);
}
Object.defineProperty(Readable.prototype, 'destroyed', {
    get: function() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;
Readable.prototype._destroy = function(err, cb) {
    this.push(null);
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = Buffer.from(chunk, encoding);
                encoding = '';
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function(chunk) {
    return readableAddChunk(this, chunk, null, true, false);
};
function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = chunkInvalid(state, chunk);
        if (er) stream.emit('error', er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) chunk = _uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));
                else addChunk(stream, state, chunk, true);
            } else if (state.ended) stream.emit('error', new Error('stream.push() after EOF'));
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);
                    else maybeReadMore(stream, state);
                } else addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) state.reading = false;
    }
    return needMoreData(state);
}
function addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        stream.emit('data', chunk);
        stream.read(0);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) emitReadable(stream);
    }
    maybeReadMore(stream, state);
}
function chunkInvalid(state, chunk) {
    var er;
    if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new TypeError('Invalid non-string/buffer chunk');
    return er;
}
// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function needMoreData(state) {
    return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}
Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};
// backwards compatibility.
Readable.prototype.setEncoding = function(enc) {
    if (!StringDecoder) StringDecoder = require("6392acd10886f115").StringDecoder;
    this._readableState.decoder = new StringDecoder(enc);
    this._readableState.encoding = enc;
    return this;
};
// Don't raise the hwm > 8MB
var MAX_HWM = 0x800000;
function computeNewHighWaterMark(n) {
    if (n >= MAX_HWM) n = MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function(n) {
    debug('read', n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
        debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) endReadable(this);
        else emitReadable(this);
        return null;
    }
    n = howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    debug('need readable', doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        debug('length less than watermark', doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        debug('reading or ended', doRead);
    } else if (doRead) {
        debug('do read');
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = true;
        n = 0;
    } else state.length -= n;
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) endReadable(this);
    }
    if (ret !== null) this.emit('data', ret);
    return ret;
};
function onEofChunk(stream, state) {
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    // emit 'readable' now to make sure it gets picked up.
    emitReadable(stream);
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
    var state = stream._readableState;
    state.needReadable = false;
    if (!state.emittedReadable) {
        debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        if (state.sync) pna.nextTick(emitReadable_, stream);
        else emitReadable_(stream);
    }
}
function emitReadable_(stream) {
    debug('emit readable');
    stream.emit('readable');
    flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        pna.nextTick(maybeReadMore_, stream, state);
    }
}
function maybeReadMore_(stream, state) {
    var len = state.length;
    while(!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark){
        debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
        else len = state.length;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function(n) {
    this.emit('error', new Error('_read() is not implemented'));
};
Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) pna.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        debug('onend');
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = pipeOnDrain(src);
    dest.on('drain', ondrain);
    var cleanedUp = false;
    function cleanup() {
        debug('cleanup');
        // cleanup event handlers once the pipe is broken
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    // If the user pushes more data while we're writing to dest then we'll end up
    // in ondata again. However, we only want to increase awaitDrain once because
    // dest will only emit one 'drain' event for the multiple writes.
    // => Introduce a guard on increasing awaitDrain.
    var increasedAwaitDrain = false;
    src.on('data', ondata);
    function ondata(chunk) {
        debug('ondata');
        increasedAwaitDrain = false;
        var ret = dest.write(chunk);
        if (false === ret && !increasedAwaitDrain) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                debug('false write response, pause', state.awaitDrain);
                state.awaitDrain++;
                increasedAwaitDrain = true;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
    }
    // Make sure our error handler is attached before userland ones.
    prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        debug('unpipe');
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit('pipe', src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        debug('pipe resume');
        src.resume();
    }
    return dest;
};
function pipeOnDrain(src) {
    return function() {
        var state = src._readableState;
        debug('pipeOnDrain', state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
            state.flowing = true;
            flow(src);
        }
    };
}
Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit('unpipe', this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function(ev, fn) {
    var res = Stream.prototype.on.call(this, ev, fn);
    if (ev === 'data') // Start flowing on next tick if stream isn't explicitly paused
    {
        if (this._readableState.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        var state = this._readableState;
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.emittedReadable = false;
            if (!state.reading) pna.nextTick(nReadingNextTick, this);
            else if (state.length) emitReadable(this);
        }
    }
    return res;
};
Readable.prototype.addListener = Readable.prototype.on;
function nReadingNextTick(self1) {
    debug('readable nexttick read 0');
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        debug('resume');
        state.flowing = true;
        resume(this, state);
    }
    return this;
};
function resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        pna.nextTick(resume_, stream, state);
    }
}
function resume_(stream, state) {
    if (!state.reading) {
        debug('resume read 0');
        stream.read(0);
    }
    state.resumeScheduled = false;
    state.awaitDrain = 0;
    stream.emit('resume');
    flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
Readable.prototype.pause = function() {
    debug('call pause flowing=%j', this._readableState.flowing);
    if (false !== this._readableState.flowing) {
        debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    return this;
};
function flow(stream) {
    var state = stream._readableState;
    debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on('end', function() {
        debug('wrapped end');
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on('data', function(chunk) {
        debug('wrapped data');
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function(method) {
        return function() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < kProxyEvents.length; n++)stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        debug('wrapped _read', n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};
Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._readableState.highWaterMark;
    }
});
// exposed for testing purposes only.
Readable._fromList = fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.head.data;
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = fromListPartial(n, state.buffer, state.decoder);
    return ret;
}
// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromListPartial(n, list, hasStrings) {
    var ret;
    if (n < list.head.data.length) {
        // slice is the same for buffers and strings
        ret = list.head.data.slice(0, n);
        list.head.data = list.head.data.slice(n);
    } else if (n === list.head.data.length) // first chunk is a perfect match
    ret = list.shift();
    else // result spans more than one buffer
    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
    return ret;
}
// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBufferString(n, list) {
    var p = list.head;
    var c = 1;
    var ret = p.data;
    n -= ret.length;
    while(p = p.next){
        var str = p.data;
        var nb = n > str.length ? str.length : n;
        if (nb === str.length) ret += str;
        else ret += str.slice(0, n);
        n -= nb;
        if (n === 0) {
            if (nb === str.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = str.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBuffer(n, list) {
    var ret = Buffer.allocUnsafe(n);
    var p = list.head;
    var c = 1;
    p.data.copy(ret);
    n -= p.data.length;
    while(p = p.next){
        var buf = p.data;
        var nb = n > buf.length ? buf.length : n;
        buf.copy(ret, ret.length - n, 0, nb);
        n -= nb;
        if (n === 0) {
            if (nb === buf.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = buf.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
function endReadable(stream) {
    var state = stream._readableState;
    // If we get here before consuming all the bytes, then that is a
    // bug in node.  Should never happen.
    if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
    if (!state.endEmitted) {
        state.ended = true;
        pna.nextTick(endReadableNT, state, stream);
    }
}
function endReadableNT(state, stream) {
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
    }
}
function indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

},{"896ff8d56553f7a":"4jeNM","6a3257a5fd38b090":"k0e3G","e90e9a84ea2f1bd2":"jE8lV","16782d660ac22e0c":"9O3iX","9a34f23fa53f83f7":"gXP1a","1711a8218ab7e640":"YgO7L","aec0c91a1241db87":"5hNNg","19affa8ce41f090d":"dwCbX","a4a723b7297c7152":"4TE4R","ce0c5a097ab7ecd0":"lJpPy","efa8155386cc4283":"ci9Nd","f1c95f846e94e4eb":"e5d07","6392acd10886f115":"Z93KL"}],"k0e3G":[function(require,module,exports,__globalThis) {
var process = require("36724de317ab1d63");
'use strict';
module.exports = {
    nextTick: nextTick
};
function nextTick(fn, arg1, arg2, arg3) {
    if (typeof fn !== 'function') throw new TypeError('"callback" argument must be a function');
    var len = arguments.length;
    var args, i;
    switch(len){
        case 0:
        case 1:
            return process.nextTick(fn);
        case 2:
            return process.nextTick(function afterTickOne() {
                fn.call(null, arg1);
            });
        case 3:
            return process.nextTick(function afterTickTwo() {
                fn.call(null, arg1, arg2);
            });
        case 4:
            return process.nextTick(function afterTickThree() {
                fn.call(null, arg1, arg2, arg3);
            });
        default:
            args = new Array(len - 1);
            i = 0;
            while(i < args.length)args[i++] = arguments[i];
            return process.nextTick(function afterTick() {
                fn.apply(null, args);
            });
    }
}

},{"36724de317ab1d63":"4jeNM"}],"jE8lV":[function(require,module,exports,__globalThis) {
var toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return toString.call(arr) == '[object Array]';
};

},{}],"gXP1a":[function(require,module,exports,__globalThis) {
module.exports = require("ed88fc9aa73f911").EventEmitter;

},{"ed88fc9aa73f911":"9O3iX"}],"YgO7L":[function(require,module,exports,__globalThis) {
/* eslint-disable node/no-deprecated-api */ var buffer = require("56b5c8483611624a");
var Buffer = buffer.Buffer;
// alternative to using Object.keys for old browsers
function copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) module.exports = buffer;
else {
    // Copy properties from require('buffer')
    copyProps(buffer, exports);
    exports.Buffer = SafeBuffer;
}
function SafeBuffer(arg, encodingOrOffset, length) {
    return Buffer(arg, encodingOrOffset, length);
}
// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer);
SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return Buffer(arg, encodingOrOffset, length);
};
SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return Buffer(size);
};
SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return buffer.SlowBuffer(size);
};

},{"56b5c8483611624a":"cjdyz"}],"5hNNg":[function(require,module,exports,__globalThis) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(arg) {
    if (Array.isArray) return Array.isArray(arg);
    return objectToString(arg) === '[object Array]';
}
exports.isArray = isArray;
function isBoolean(arg) {
    return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;
function isNull(arg) {
    return arg === null;
}
exports.isNull = isNull;
function isNullOrUndefined(arg) {
    return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;
function isNumber(arg) {
    return typeof arg === 'number';
}
exports.isNumber = isNumber;
function isString(arg) {
    return typeof arg === 'string';
}
exports.isString = isString;
function isSymbol(arg) {
    return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;
function isUndefined(arg) {
    return arg === void 0;
}
exports.isUndefined = isUndefined;
function isRegExp(re) {
    return objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;
function isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;
function isDate(d) {
    return objectToString(d) === '[object Date]';
}
exports.isDate = isDate;
function isError(e) {
    return objectToString(e) === '[object Error]' || e instanceof Error;
}
exports.isError = isError;
function isFunction(arg) {
    return typeof arg === 'function';
}
exports.isFunction = isFunction;
function isPrimitive(arg) {
    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
    typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;
exports.isBuffer = require("552a2cbe55fe12b9").Buffer.isBuffer;
function objectToString(o) {
    return Object.prototype.toString.call(o);
}

},{"552a2cbe55fe12b9":"cjdyz"}],"lJpPy":[function(require,module,exports,__globalThis) {
'use strict';
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var Buffer = require("af88c2f3f038c5e4").Buffer;
var util = require("33fc21125524aa4d");
function copyBuffer(src, target, offset) {
    src.copy(target, offset);
}
module.exports = function() {
    function BufferList() {
        _classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    BufferList.prototype.push = function push(v) {
        var entry = {
            data: v,
            next: null
        };
        if (this.length > 0) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
        ++this.length;
    };
    BufferList.prototype.unshift = function unshift(v) {
        var entry = {
            data: v,
            next: this.head
        };
        if (this.length === 0) this.tail = entry;
        this.head = entry;
        ++this.length;
    };
    BufferList.prototype.shift = function shift() {
        if (this.length === 0) return;
        var ret = this.head.data;
        if (this.length === 1) this.head = this.tail = null;
        else this.head = this.head.next;
        --this.length;
        return ret;
    };
    BufferList.prototype.clear = function clear() {
        this.head = this.tail = null;
        this.length = 0;
    };
    BufferList.prototype.join = function join(s) {
        if (this.length === 0) return '';
        var p = this.head;
        var ret = '' + p.data;
        while(p = p.next)ret += s + p.data;
        return ret;
    };
    BufferList.prototype.concat = function concat(n) {
        if (this.length === 0) return Buffer.alloc(0);
        var ret = Buffer.allocUnsafe(n >>> 0);
        var p = this.head;
        var i = 0;
        while(p){
            copyBuffer(p.data, ret, i);
            i += p.data.length;
            p = p.next;
        }
        return ret;
    };
    return BufferList;
}();
if (util && util.inspect && util.inspect.custom) module.exports.prototype[util.inspect.custom] = function() {
    var obj = util.inspect({
        length: this.length
    });
    return this.constructor.name + ' ' + obj;
};

},{"af88c2f3f038c5e4":"YgO7L","33fc21125524aa4d":"4TE4R"}],"ci9Nd":[function(require,module,exports,__globalThis) {
'use strict';
/*<replacement>*/ var pna = require("9f0440d9375d6fc0");
/*</replacement>*/ // undocumented cb() API, needed for core, not for public API
function destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) pna.nextTick(emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                pna.nextTick(emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) pna.nextTick(emitErrorNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                pna.nextTick(emitErrorNT, _this, err);
            }
        } else if (cb) cb(err);
    });
    return this;
}
function undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function emitErrorNT(self, err) {
    self.emit('error', err);
}
module.exports = {
    destroy: destroy,
    undestroy: undestroy
};

},{"9f0440d9375d6fc0":"k0e3G"}],"e5d07":[function(require,module,exports,__globalThis) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.
'use strict';
/*<replacement>*/ var pna = require("20e11028560825d2");
/*</replacement>*/ /*<replacement>*/ var objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = Duplex;
/*<replacement>*/ var util = Object.create(require("e230ec8f8c439672"));
util.inherits = require("aa7b11ba5bf4defc");
/*</replacement>*/ var Readable = require("68a7582259cd5865");
var Writable = require("93d042f8bb80078e");
util.inherits(Duplex, Readable);
// avoid scope creep, the keys array can then be collected
var keys = objectKeys(Writable.prototype);
for(var v = 0; v < keys.length; v++){
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
}
function Duplex(options) {
    if (!(this instanceof Duplex)) return new Duplex(options);
    Readable.call(this, options);
    Writable.call(this, options);
    if (options && options.readable === false) this.readable = false;
    if (options && options.writable === false) this.writable = false;
    this.allowHalfOpen = true;
    if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
    this.once('end', onend);
}
Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._writableState.highWaterMark;
    }
});
// the no-half-open enforcer
function onend() {
    // if we allow half-open state, or if the writable side ended,
    // then we're ok.
    if (this.allowHalfOpen || this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    pna.nextTick(onEndNT, this);
}
function onEndNT(self) {
    self.end();
}
Object.defineProperty(Duplex.prototype, 'destroyed', {
    get: function() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});
Duplex.prototype._destroy = function(err, cb) {
    this.push(null);
    this.end();
    pna.nextTick(cb, err);
};

},{"20e11028560825d2":"k0e3G","e230ec8f8c439672":"5hNNg","aa7b11ba5bf4defc":"dwCbX","68a7582259cd5865":"f1FWv","93d042f8bb80078e":"bL6kH"}],"bL6kH":[function(require,module,exports,__globalThis) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
var global = arguments[3];
'use strict';
/*<replacement>*/ var pna = require("6c800b281e0a9a0");
/*</replacement>*/ module.exports = Writable;
/* <replacement> */ function WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var asyncWrite = (0, pna.nextTick);
/*</replacement>*/ /*<replacement>*/ var Duplex;
/*</replacement>*/ Writable.WritableState = WritableState;
/*<replacement>*/ var util = Object.create(require("e7c005d8f0ba1903"));
util.inherits = require("10dad555ffe77dde");
/*</replacement>*/ /*<replacement>*/ var internalUtil = {
    deprecate: require("dc51171b07b54af1")
};
/*</replacement>*/ /*<replacement>*/ var Stream = require("44a3cc22ec64fcd3");
/*</replacement>*/ /*<replacement>*/ var Buffer = require("b11d62463b2702d9").Buffer;
var OurUint8Array = (typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function _uint8ArrayToBuffer(chunk) {
    return Buffer.from(chunk);
}
function _isUint8Array(obj) {
    return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}
/*</replacement>*/ var destroyImpl = require("acf48fb5d9dc6204");
util.inherits(Writable, Stream);
function nop() {}
function WritableState(options, stream) {
    Duplex = Duplex || require("c5e7171d6f58d3c0");
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    var hwm = options.highWaterMark;
    var writableHwm = options.writableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new CorkedRequest(this);
}
WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty(WritableState.prototype, 'buffer', {
            get: internalUtil.deprecate(function() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", 'DEP0003')
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
    realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty(Writable, Symbol.hasInstance, {
        value: function(object) {
            if (realHasInstance.call(this, object)) return true;
            if (this !== Writable) return false;
            return object && object._writableState instanceof WritableState;
        }
    });
} else realHasInstance = function(object) {
    return object instanceof this;
};
function Writable(options) {
    Duplex = Duplex || require("c5e7171d6f58d3c0");
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) return new Writable(options);
    this._writableState = new WritableState(options, this);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
    }
    Stream.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function() {
    this.emit('error', new Error('Cannot pipe, not readable'));
};
function writeAfterEnd(stream, cb) {
    var er = new Error('write after end');
    // TODO: defer error events consistently everywhere, not just the cb
    stream.emit('error', er);
    pna.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
    var valid = true;
    var er = false;
    if (chunk === null) er = new TypeError('May not write null values to stream');
    else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new TypeError('Invalid non-string/buffer chunk');
    if (er) {
        stream.emit('error', er);
        pna.nextTick(cb, er);
        valid = false;
    }
    return valid;
}
Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && _isUint8Array(chunk);
    if (isBuf && !Buffer.isBuffer(chunk)) chunk = _uint8ArrayToBuffer(chunk);
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = 'buffer';
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== 'function') cb = nop;
    if (state.ended) writeAfterEnd(this, cb);
    else if (isBuf || validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
Writable.prototype.cork = function() {
    var state = this._writableState;
    state.corked++;
};
Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
    }
};
Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
    if (!([
        'hex',
        'utf8',
        'utf-8',
        'ascii',
        'binary',
        'base64',
        'ucs2',
        'ucs-2',
        'utf16le',
        'utf-16le',
        'raw'
    ].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
function decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = 'buffer';
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        pna.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        pna.nextTick(finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        stream.emit('error', er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        stream.emit('error', er);
        // this can emit finish, but finish must
        // always follow error
        finishMaybe(stream, state);
    }
}
function onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    onwriteStateUpdate(state);
    if (er) onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = needFinish(state);
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(stream, state);
        if (sync) /*<replacement>*/ asyncWrite(afterWrite, stream, state, finished, cb);
        else afterWrite(stream, state, finished, cb);
    }
}
function afterWrite(stream, state, finished, cb) {
    if (!finished) onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
}
// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        doWrite(stream, state, true, state.length, buffer, '', holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new Error('_write() is not implemented'));
};
Writable.prototype._writev = null;
Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) endWritable(this, state, cb);
};
function needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) stream.emit('error', err);
        state.prefinished = true;
        stream.emit('prefinish');
        finishMaybe(stream, state);
    });
}
function prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function') {
            state.pendingcb++;
            state.finalCalled = true;
            pna.nextTick(callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function finishMaybe(stream, state) {
    var need = needFinish(state);
    if (need) {
        prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit('finish');
        }
    }
    return need;
}
function endWritable(stream, state, cb) {
    state.ending = true;
    finishMaybe(stream, state);
    if (cb) {
        if (state.finished) pna.nextTick(cb);
        else stream.once('finish', cb);
    }
    state.ended = true;
    stream.writable = false;
}
function onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty(Writable.prototype, 'destroyed', {
    get: function() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function(err, cb) {
    this.end();
    cb(err);
};

},{"6c800b281e0a9a0":"k0e3G","e7c005d8f0ba1903":"5hNNg","10dad555ffe77dde":"dwCbX","dc51171b07b54af1":"53bfb","44a3cc22ec64fcd3":"gXP1a","b11d62463b2702d9":"YgO7L","acf48fb5d9dc6204":"ci9Nd","c5e7171d6f58d3c0":"e5d07"}],"Z93KL":[function(require,module,exports,__globalThis) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
/*<replacement>*/ var Buffer = require("da459cfeb4b18f6c").Buffer;
/*</replacement>*/ var isEncoding = Buffer.isEncoding || function(encoding) {
    encoding = '' + encoding;
    switch(encoding && encoding.toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
        case 'raw':
            return true;
        default:
            return false;
    }
};
function _normalizeEncoding(enc) {
    if (!enc) return 'utf8';
    var retried;
    while(true)switch(enc){
        case 'utf8':
        case 'utf-8':
            return 'utf8';
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return 'utf16le';
        case 'latin1':
        case 'binary':
            return 'latin1';
        case 'base64':
        case 'ascii':
        case 'hex':
            return enc;
        default:
            if (retried) return; // undefined
            enc = ('' + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
    var nenc = _normalizeEncoding(enc);
    if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
    return nenc || enc;
}
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.StringDecoder = StringDecoder;
function StringDecoder(encoding) {
    this.encoding = normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case 'utf16le':
            this.text = utf16Text;
            this.end = utf16End;
            nb = 4;
            break;
        case 'utf8':
            this.fillLast = utf8FillLast;
            nb = 4;
            break;
        case 'base64':
            this.text = base64Text;
            this.end = base64End;
            nb = 3;
            break;
        default:
            this.write = simpleWrite;
            this.end = simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = Buffer.allocUnsafe(nb);
}
StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return '';
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return '';
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || '';
};
StringDecoder.prototype.end = utf8End;
// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return '\ufffd';
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return '\ufffd';
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return '\ufffd';
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
    var total = utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString('utf8', i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString('utf8', i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + '\ufffd';
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString('utf16le', i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString('utf16le', i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString('utf16le', 0, end);
    }
    return r;
}
function base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString('base64', i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString('base64', i, buf.length - n);
}
function base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : '';
}

},{"da459cfeb4b18f6c":"YgO7L"}],"dr4NM":[function(require,module,exports,__globalThis) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
'use strict';
module.exports = Transform;
var Duplex = require("db11ebf938e536ed");
/*<replacement>*/ var util = Object.create(require("11a2a5d5defdcffa"));
util.inherits = require("82049677fa603d40");
/*</replacement>*/ util.inherits(Transform, Duplex);
function afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (!cb) return this.emit('error', new Error('write callback called multiple times'));
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function Transform(options) {
    if (!(this instanceof Transform)) return new Transform(options);
    Duplex.call(this, options);
    this._transformState = {
        afterTransform: afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on('prefinish', prefinish);
}
function prefinish() {
    var _this = this;
    if (typeof this._flush === 'function') this._flush(function(er, data) {
        done(_this, er, data);
    });
    else done(this, null, null);
}
Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return Duplex.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function(chunk, encoding, cb) {
    throw new Error('_transform() is not implemented');
};
Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
Transform.prototype._destroy = function(err, cb) {
    var _this2 = this;
    Duplex.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
        _this2.emit('close');
    });
};
function done(stream, er, data) {
    if (er) return stream.emit('error', er);
    if (data != null) stream.push(data);
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');
    if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');
    return stream.push(null);
}

},{"db11ebf938e536ed":"e5d07","11a2a5d5defdcffa":"5hNNg","82049677fa603d40":"dwCbX"}],"jcn46":[function(require,module,exports,__globalThis) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';
module.exports = PassThrough;
var Transform = require("7ab21291895ec3d2");
/*<replacement>*/ var util = Object.create(require("b9f805fab8ec0508"));
util.inherits = require("f24ec1883eef5e9b");
/*</replacement>*/ util.inherits(PassThrough, Transform);
function PassThrough(options) {
    if (!(this instanceof PassThrough)) return new PassThrough(options);
    Transform.call(this, options);
}
PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

},{"7ab21291895ec3d2":"dr4NM","b9f805fab8ec0508":"5hNNg","f24ec1883eef5e9b":"dwCbX"}],"9j4zZ":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = function SHA(algorithm) {
    var alg = algorithm.toLowerCase();
    var Algorithm = module.exports[alg];
    if (!Algorithm) throw new Error(alg + ' is not supported (we accept pull requests)');
    return new Algorithm();
};
module.exports.sha = require("54c9313943368ce2");
module.exports.sha1 = require("6e6f42e0b6fe29ef");
module.exports.sha224 = require("cefe70c6f9f68940");
module.exports.sha256 = require("3b4e2aa73bc3fef5");
module.exports.sha384 = require("be7da8b8e5a0fd78");
module.exports.sha512 = require("25610a4ba83316a4");

},{"54c9313943368ce2":"fz58t","6e6f42e0b6fe29ef":"GgelC","cefe70c6f9f68940":"7ifMI","3b4e2aa73bc3fef5":"5PYy5","be7da8b8e5a0fd78":"4XZ6b","25610a4ba83316a4":"963ZH"}],"fz58t":[function(require,module,exports,__globalThis) {
'use strict';
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-0, as defined
 * in FIPS PUB 180-1
 * This source code is derived from sha1.js of the same repository.
 * The difference between SHA-0 and SHA-1 is just a bitwise rotate left
 * operation was added.
 */ var inherits = require("55404b425acd1c6f");
var Hash = require("457bc9c7737d761f");
var Buffer = require("44759e57eb2992a").Buffer;
var K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var W = new Array(80);
function Sha() {
    this.init();
    this._w = W;
    Hash.call(this, 64, 56);
}
inherits(Sha, Hash);
Sha.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function rotl5(num) {
    return num << 5 | num >>> 27;
}
function rotl30(num) {
    return num << 30 | num >>> 2;
}
function ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
Sha.prototype._update = function(M) {
    var w = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)w[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)w[i] = w[i - 3] ^ w[i - 8] ^ w[i - 14] ^ w[i - 16];
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = rotl5(a) + ft(s, b, c, d) + e + w[j] + K[s] | 0;
        e = d;
        d = c;
        c = rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
Sha.prototype._hash = function() {
    var H = Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = Sha;

},{"55404b425acd1c6f":"dwCbX","457bc9c7737d761f":"jKNZG","44759e57eb2992a":"1Yph5"}],"jKNZG":[function(require,module,exports,__globalThis) {
'use strict';
var Buffer = require("fe67468afd3c1b91").Buffer;
var toBuffer = require("aad9bfe4929a1d67");
// prototype class for hash functions
function Hash(blockSize, finalSize) {
    this._block = Buffer.alloc(blockSize);
    this._finalSize = finalSize;
    this._blockSize = blockSize;
    this._len = 0;
}
Hash.prototype.update = function(data, enc) {
    /* eslint no-param-reassign: 0 */ data = toBuffer(data, enc || 'utf8');
    var block = this._block;
    var blockSize = this._blockSize;
    var length = data.length;
    var accum = this._len;
    for(var offset = 0; offset < length;){
        var assigned = accum % blockSize;
        var remainder = Math.min(length - offset, blockSize - assigned);
        for(var i = 0; i < remainder; i++)block[assigned + i] = data[offset + i];
        accum += remainder;
        offset += remainder;
        if (accum % blockSize === 0) this._update(block);
    }
    this._len += length;
    return this;
};
Hash.prototype.digest = function(enc) {
    var rem = this._len % this._blockSize;
    this._block[rem] = 0x80;
    /*
	 * zero (rem + 1) trailing bits, where (rem + 1) is the smallest
	 * non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
	 */ this._block.fill(0, rem + 1);
    if (rem >= this._finalSize) {
        this._update(this._block);
        this._block.fill(0);
    }
    var bits = this._len * 8;
    // uint32
    if (bits <= 0xffffffff) this._block.writeUInt32BE(bits, this._blockSize - 4);
    else {
        var lowBits = (bits & 0xffffffff) >>> 0;
        var highBits = (bits - lowBits) / 0x100000000;
        this._block.writeUInt32BE(highBits, this._blockSize - 8);
        this._block.writeUInt32BE(lowBits, this._blockSize - 4);
    }
    this._update(this._block);
    var hash = this._hash();
    return enc ? hash.toString(enc) : hash;
};
Hash.prototype._update = function() {
    throw new Error('_update must be implemented by subclass');
};
module.exports = Hash;

},{"fe67468afd3c1b91":"1Yph5","aad9bfe4929a1d67":"2pnit"}],"GgelC":[function(require,module,exports,__globalThis) {
'use strict';
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
 * in FIPS PUB 180-1
 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for details.
 */ var inherits = require("bf0dcaa2121c06d3");
var Hash = require("788f05b1f9753762");
var Buffer = require("ee7c2a3e649d259f").Buffer;
var K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var W = new Array(80);
function Sha1() {
    this.init();
    this._w = W;
    Hash.call(this, 64, 56);
}
inherits(Sha1, Hash);
Sha1.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function rotl1(num) {
    return num << 1 | num >>> 31;
}
function rotl5(num) {
    return num << 5 | num >>> 27;
}
function rotl30(num) {
    return num << 30 | num >>> 2;
}
function ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
Sha1.prototype._update = function(M) {
    var w = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)w[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)w[i] = rotl1(w[i - 3] ^ w[i - 8] ^ w[i - 14] ^ w[i - 16]);
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = rotl5(a) + ft(s, b, c, d) + e + w[j] + K[s] | 0;
        e = d;
        d = c;
        c = rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
Sha1.prototype._hash = function() {
    var H = Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = Sha1;

},{"bf0dcaa2121c06d3":"dwCbX","788f05b1f9753762":"jKNZG","ee7c2a3e649d259f":"1Yph5"}],"7ifMI":[function(require,module,exports,__globalThis) {
'use strict';
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */ var inherits = require("1759318dd61b32af");
var Sha256 = require("5a24a8ff4dc414f6");
var Hash = require("377596dd27739a66");
var Buffer = require("381289f917f16a20").Buffer;
var W = new Array(64);
function Sha224() {
    this.init();
    this._w = W; // new Array(64)
    Hash.call(this, 64, 56);
}
inherits(Sha224, Sha256);
Sha224.prototype.init = function() {
    this._a = 0xc1059ed8;
    this._b = 0x367cd507;
    this._c = 0x3070dd17;
    this._d = 0xf70e5939;
    this._e = 0xffc00b31;
    this._f = 0x68581511;
    this._g = 0x64f98fa7;
    this._h = 0xbefa4fa4;
    return this;
};
Sha224.prototype._hash = function() {
    var H = Buffer.allocUnsafe(28);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    return H;
};
module.exports = Sha224;

},{"1759318dd61b32af":"dwCbX","5a24a8ff4dc414f6":"5PYy5","377596dd27739a66":"jKNZG","381289f917f16a20":"1Yph5"}],"5PYy5":[function(require,module,exports,__globalThis) {
'use strict';
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */ var inherits = require("682a6716eeab42dd");
var Hash = require("f062bd789841a9ce");
var Buffer = require("1d47643a8adb8c1b").Buffer;
var K = [
    0x428A2F98,
    0x71374491,
    0xB5C0FBCF,
    0xE9B5DBA5,
    0x3956C25B,
    0x59F111F1,
    0x923F82A4,
    0xAB1C5ED5,
    0xD807AA98,
    0x12835B01,
    0x243185BE,
    0x550C7DC3,
    0x72BE5D74,
    0x80DEB1FE,
    0x9BDC06A7,
    0xC19BF174,
    0xE49B69C1,
    0xEFBE4786,
    0x0FC19DC6,
    0x240CA1CC,
    0x2DE92C6F,
    0x4A7484AA,
    0x5CB0A9DC,
    0x76F988DA,
    0x983E5152,
    0xA831C66D,
    0xB00327C8,
    0xBF597FC7,
    0xC6E00BF3,
    0xD5A79147,
    0x06CA6351,
    0x14292967,
    0x27B70A85,
    0x2E1B2138,
    0x4D2C6DFC,
    0x53380D13,
    0x650A7354,
    0x766A0ABB,
    0x81C2C92E,
    0x92722C85,
    0xA2BFE8A1,
    0xA81A664B,
    0xC24B8B70,
    0xC76C51A3,
    0xD192E819,
    0xD6990624,
    0xF40E3585,
    0x106AA070,
    0x19A4C116,
    0x1E376C08,
    0x2748774C,
    0x34B0BCB5,
    0x391C0CB3,
    0x4ED8AA4A,
    0x5B9CCA4F,
    0x682E6FF3,
    0x748F82EE,
    0x78A5636F,
    0x84C87814,
    0x8CC70208,
    0x90BEFFFA,
    0xA4506CEB,
    0xBEF9A3F7,
    0xC67178F2
];
var W = new Array(64);
function Sha256() {
    this.init();
    this._w = W; // new Array(64)
    Hash.call(this, 64, 56);
}
inherits(Sha256, Hash);
Sha256.prototype.init = function() {
    this._a = 0x6a09e667;
    this._b = 0xbb67ae85;
    this._c = 0x3c6ef372;
    this._d = 0xa54ff53a;
    this._e = 0x510e527f;
    this._f = 0x9b05688c;
    this._g = 0x1f83d9ab;
    this._h = 0x5be0cd19;
    return this;
};
function ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function maj(x, y, z) {
    return x & y | z & (x | y);
}
function sigma0(x) {
    return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10);
}
function sigma1(x) {
    return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7);
}
function gamma0(x) {
    return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ x >>> 3;
}
function gamma1(x) {
    return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ x >>> 10;
}
Sha256.prototype._update = function(M) {
    var w = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    var f = this._f | 0;
    var g = this._g | 0;
    var h = this._h | 0;
    for(var i = 0; i < 16; ++i)w[i] = M.readInt32BE(i * 4);
    for(; i < 64; ++i)w[i] = gamma1(w[i - 2]) + w[i - 7] + gamma0(w[i - 15]) + w[i - 16] | 0;
    for(var j = 0; j < 64; ++j){
        var T1 = h + sigma1(e) + ch(e, f, g) + K[j] + w[j] | 0;
        var T2 = sigma0(a) + maj(a, b, c) | 0;
        h = g;
        g = f;
        f = e;
        e = d + T1 | 0;
        d = c;
        c = b;
        b = a;
        a = T1 + T2 | 0;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
    this._f = f + this._f | 0;
    this._g = g + this._g | 0;
    this._h = h + this._h | 0;
};
Sha256.prototype._hash = function() {
    var H = Buffer.allocUnsafe(32);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    H.writeInt32BE(this._h, 28);
    return H;
};
module.exports = Sha256;

},{"682a6716eeab42dd":"dwCbX","f062bd789841a9ce":"jKNZG","1d47643a8adb8c1b":"1Yph5"}],"4XZ6b":[function(require,module,exports,__globalThis) {
'use strict';
var inherits = require("2a5cbb73fedd61b");
var SHA512 = require("fdb4d0946b31cdb5");
var Hash = require("50aa04d4bd2df0e1");
var Buffer = require("3d3bcc84ec383b74").Buffer;
var W = new Array(160);
function Sha384() {
    this.init();
    this._w = W;
    Hash.call(this, 128, 112);
}
inherits(Sha384, SHA512);
Sha384.prototype.init = function() {
    this._ah = 0xcbbb9d5d;
    this._bh = 0x629a292a;
    this._ch = 0x9159015a;
    this._dh = 0x152fecd8;
    this._eh = 0x67332667;
    this._fh = 0x8eb44a87;
    this._gh = 0xdb0c2e0d;
    this._hh = 0x47b5481d;
    this._al = 0xc1059ed8;
    this._bl = 0x367cd507;
    this._cl = 0x3070dd17;
    this._dl = 0xf70e5939;
    this._el = 0xffc00b31;
    this._fl = 0x68581511;
    this._gl = 0x64f98fa7;
    this._hl = 0xbefa4fa4;
    return this;
};
Sha384.prototype._hash = function() {
    var H = Buffer.allocUnsafe(48);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    return H;
};
module.exports = Sha384;

},{"2a5cbb73fedd61b":"dwCbX","fdb4d0946b31cdb5":"963ZH","50aa04d4bd2df0e1":"jKNZG","3d3bcc84ec383b74":"1Yph5"}],"963ZH":[function(require,module,exports,__globalThis) {
'use strict';
var inherits = require("8d87c82d5ce5743");
var Hash = require("27d0146c4419ba93");
var Buffer = require("602d9c7256ca6bf7").Buffer;
var K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
var W = new Array(160);
function Sha512() {
    this.init();
    this._w = W;
    Hash.call(this, 128, 112);
}
inherits(Sha512, Hash);
Sha512.prototype.init = function() {
    this._ah = 0x6a09e667;
    this._bh = 0xbb67ae85;
    this._ch = 0x3c6ef372;
    this._dh = 0xa54ff53a;
    this._eh = 0x510e527f;
    this._fh = 0x9b05688c;
    this._gh = 0x1f83d9ab;
    this._hh = 0x5be0cd19;
    this._al = 0xf3bcc908;
    this._bl = 0x84caa73b;
    this._cl = 0xfe94f82b;
    this._dl = 0x5f1d36f1;
    this._el = 0xade682d1;
    this._fl = 0x2b3e6c1f;
    this._gl = 0xfb41bd6b;
    this._hl = 0x137e2179;
    return this;
};
function Ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function maj(x, y, z) {
    return x & y | z & (x | y);
}
function sigma0(x, xl) {
    return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25);
}
function sigma1(x, xl) {
    return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23);
}
function Gamma0(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ x >>> 7;
}
function Gamma0l(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25);
}
function Gamma1(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ x >>> 6;
}
function Gamma1l(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26);
}
function getCarry(a, b) {
    return a >>> 0 < b >>> 0 ? 1 : 0;
}
Sha512.prototype._update = function(M) {
    var w = this._w;
    var ah = this._ah | 0;
    var bh = this._bh | 0;
    var ch = this._ch | 0;
    var dh = this._dh | 0;
    var eh = this._eh | 0;
    var fh = this._fh | 0;
    var gh = this._gh | 0;
    var hh = this._hh | 0;
    var al = this._al | 0;
    var bl = this._bl | 0;
    var cl = this._cl | 0;
    var dl = this._dl | 0;
    var el = this._el | 0;
    var fl = this._fl | 0;
    var gl = this._gl | 0;
    var hl = this._hl | 0;
    for(var i = 0; i < 32; i += 2){
        w[i] = M.readInt32BE(i * 4);
        w[i + 1] = M.readInt32BE(i * 4 + 4);
    }
    for(; i < 160; i += 2){
        var xh = w[i - 30];
        var xl = w[i - 30 + 1];
        var gamma0 = Gamma0(xh, xl);
        var gamma0l = Gamma0l(xl, xh);
        xh = w[i - 4];
        xl = w[i - 4 + 1];
        var gamma1 = Gamma1(xh, xl);
        var gamma1l = Gamma1l(xl, xh);
        // w[i] = gamma0 + w[i - 7] + gamma1 + w[i - 16]
        var Wi7h = w[i - 14];
        var Wi7l = w[i - 14 + 1];
        var Wi16h = w[i - 32];
        var Wi16l = w[i - 32 + 1];
        var Wil = gamma0l + Wi7l | 0;
        var Wih = gamma0 + Wi7h + getCarry(Wil, gamma0l) | 0;
        Wil = Wil + gamma1l | 0;
        Wih = Wih + gamma1 + getCarry(Wil, gamma1l) | 0;
        Wil = Wil + Wi16l | 0;
        Wih = Wih + Wi16h + getCarry(Wil, Wi16l) | 0;
        w[i] = Wih;
        w[i + 1] = Wil;
    }
    for(var j = 0; j < 160; j += 2){
        Wih = w[j];
        Wil = w[j + 1];
        var majh = maj(ah, bh, ch);
        var majl = maj(al, bl, cl);
        var sigma0h = sigma0(ah, al);
        var sigma0l = sigma0(al, ah);
        var sigma1h = sigma1(eh, el);
        var sigma1l = sigma1(el, eh);
        // t1 = h + sigma1 + ch + K[j] + w[j]
        var Kih = K[j];
        var Kil = K[j + 1];
        var chh = Ch(eh, fh, gh);
        var chl = Ch(el, fl, gl);
        var t1l = hl + sigma1l | 0;
        var t1h = hh + sigma1h + getCarry(t1l, hl) | 0;
        t1l = t1l + chl | 0;
        t1h = t1h + chh + getCarry(t1l, chl) | 0;
        t1l = t1l + Kil | 0;
        t1h = t1h + Kih + getCarry(t1l, Kil) | 0;
        t1l = t1l + Wil | 0;
        t1h = t1h + Wih + getCarry(t1l, Wil) | 0;
        // t2 = sigma0 + maj
        var t2l = sigma0l + majl | 0;
        var t2h = sigma0h + majh + getCarry(t2l, sigma0l) | 0;
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        el = dl + t1l | 0;
        eh = dh + t1h + getCarry(el, dl) | 0;
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        al = t1l + t2l | 0;
        ah = t1h + t2h + getCarry(al, t1l) | 0;
    }
    this._al = this._al + al | 0;
    this._bl = this._bl + bl | 0;
    this._cl = this._cl + cl | 0;
    this._dl = this._dl + dl | 0;
    this._el = this._el + el | 0;
    this._fl = this._fl + fl | 0;
    this._gl = this._gl + gl | 0;
    this._hl = this._hl + hl | 0;
    this._ah = this._ah + ah + getCarry(this._al, al) | 0;
    this._bh = this._bh + bh + getCarry(this._bl, bl) | 0;
    this._ch = this._ch + ch + getCarry(this._cl, cl) | 0;
    this._dh = this._dh + dh + getCarry(this._dl, dl) | 0;
    this._eh = this._eh + eh + getCarry(this._el, el) | 0;
    this._fh = this._fh + fh + getCarry(this._fl, fl) | 0;
    this._gh = this._gh + gh + getCarry(this._gl, gl) | 0;
    this._hh = this._hh + hh + getCarry(this._hl, hl) | 0;
};
Sha512.prototype._hash = function() {
    var H = Buffer.allocUnsafe(64);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    writeInt64BE(this._gh, this._gl, 48);
    writeInt64BE(this._hh, this._hl, 56);
    return H;
};
module.exports = Sha512;

},{"8d87c82d5ce5743":"dwCbX","27d0146c4419ba93":"jKNZG","602d9c7256ca6bf7":"1Yph5"}],"gsniA":[function(require,module,exports,__globalThis) {
'use strict';
var Buffer = require("631f7eb12d35b579").Buffer;
var Transform = require("5b378a2a05398c5").Transform;
var StringDecoder = require("d42da7de127e1c4b").StringDecoder;
var inherits = require("7a0f2f27fe0a389b");
var toBuffer = require("9de06680f1af8ff1");
function CipherBase(hashMode) {
    Transform.call(this);
    this.hashMode = typeof hashMode === 'string';
    if (this.hashMode) this[hashMode] = this._finalOrDigest;
    else this['final'] = this._finalOrDigest;
    if (this._final) {
        this.__final = this._final;
        this._final = null;
    }
    this._decoder = null;
    this._encoding = null;
}
inherits(CipherBase, Transform);
CipherBase.prototype.update = function(data, inputEnc, outputEnc) {
    var bufferData = toBuffer(data, inputEnc); // asserts correct input type
    var outData = this._update(bufferData);
    if (this.hashMode) return this;
    if (outputEnc) outData = this._toString(outData, outputEnc);
    return outData;
};
CipherBase.prototype.setAutoPadding = function() {};
CipherBase.prototype.getAuthTag = function() {
    throw new Error('trying to get auth tag in unsupported state');
};
CipherBase.prototype.setAuthTag = function() {
    throw new Error('trying to set auth tag in unsupported state');
};
CipherBase.prototype.setAAD = function() {
    throw new Error('trying to set aad in unsupported state');
};
CipherBase.prototype._transform = function(data, _, next) {
    var err;
    try {
        if (this.hashMode) this._update(data);
        else this.push(this._update(data));
    } catch (e) {
        err = e;
    } finally{
        next(err);
    }
};
CipherBase.prototype._flush = function(done) {
    var err;
    try {
        this.push(this.__final());
    } catch (e) {
        err = e;
    }
    done(err);
};
CipherBase.prototype._finalOrDigest = function(outputEnc) {
    var outData = this.__final() || Buffer.alloc(0);
    if (outputEnc) outData = this._toString(outData, outputEnc, true);
    return outData;
};
CipherBase.prototype._toString = function(value, enc, fin) {
    if (!this._decoder) {
        this._decoder = new StringDecoder(enc);
        this._encoding = enc;
    }
    if (this._encoding !== enc) throw new Error("can\u2019t switch encodings");
    var out = this._decoder.write(value);
    if (fin) out += this._decoder.end();
    return out;
};
module.exports = CipherBase;

},{"631f7eb12d35b579":"1Yph5","5b378a2a05398c5":"1CYjc","d42da7de127e1c4b":"6a4se","7a0f2f27fe0a389b":"dwCbX","9de06680f1af8ff1":"2pnit"}],"hOD8w":[function(require,module,exports,__globalThis) {
'use strict';
var inherits = require("6a73c7c8ca6b61fa");
var Legacy = require("e1b443c27c833bc0");
var Base = require("7571755cc57fd60e");
var Buffer = require("b8ba1339feab1938").Buffer;
var md5 = require("c00fb3fd28cadeb2");
var RIPEMD160 = require("b7f8eae556813ec1");
var sha = require("40c5a912778271f7");
var ZEROS = Buffer.alloc(128);
function Hmac(alg, key) {
    Base.call(this, 'digest');
    if (typeof key === 'string') key = Buffer.from(key);
    var blocksize = alg === 'sha512' || alg === 'sha384' ? 128 : 64;
    this._alg = alg;
    this._key = key;
    if (key.length > blocksize) {
        var hash = alg === 'rmd160' ? new RIPEMD160() : sha(alg);
        key = hash.update(key).digest();
    } else if (key.length < blocksize) key = Buffer.concat([
        key,
        ZEROS
    ], blocksize);
    var ipad = this._ipad = Buffer.allocUnsafe(blocksize);
    var opad = this._opad = Buffer.allocUnsafe(blocksize);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = alg === 'rmd160' ? new RIPEMD160() : sha(alg);
    this._hash.update(ipad);
}
inherits(Hmac, Base);
Hmac.prototype._update = function(data) {
    this._hash.update(data);
};
Hmac.prototype._final = function() {
    var h = this._hash.digest();
    var hash = this._alg === 'rmd160' ? new RIPEMD160() : sha(this._alg);
    return hash.update(this._opad).update(h).digest();
};
module.exports = function createHmac(alg, key) {
    alg = alg.toLowerCase();
    if (alg === 'rmd160' || alg === 'ripemd160') return new Hmac('rmd160', key);
    if (alg === 'md5') return new Legacy(md5, key);
    return new Hmac(alg, key);
};

},{"6a73c7c8ca6b61fa":"dwCbX","e1b443c27c833bc0":"4JU9Z","7571755cc57fd60e":"gsniA","b8ba1339feab1938":"1Yph5","c00fb3fd28cadeb2":"iegWi","b7f8eae556813ec1":"cKnjx","40c5a912778271f7":"9j4zZ"}],"4JU9Z":[function(require,module,exports,__globalThis) {
'use strict';
var inherits = require("2baf2864ece10f11");
var Buffer = require("c7fb5e22d675c53c").Buffer;
var Base = require("8fdec7d6b96329ea");
var ZEROS = Buffer.alloc(128);
var blocksize = 64;
function Hmac(alg, key) {
    Base.call(this, 'digest');
    if (typeof key === 'string') key = Buffer.from(key);
    this._alg = alg;
    this._key = key;
    if (key.length > blocksize) key = alg(key);
    else if (key.length < blocksize) key = Buffer.concat([
        key,
        ZEROS
    ], blocksize);
    var ipad = this._ipad = Buffer.allocUnsafe(blocksize);
    var opad = this._opad = Buffer.allocUnsafe(blocksize);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = [
        ipad
    ];
}
inherits(Hmac, Base);
Hmac.prototype._update = function(data) {
    this._hash.push(data);
};
Hmac.prototype._final = function() {
    var h = this._alg(Buffer.concat(this._hash));
    return this._alg(Buffer.concat([
        this._opad,
        h
    ]));
};
module.exports = Hmac;

},{"2baf2864ece10f11":"dwCbX","c7fb5e22d675c53c":"1Yph5","8fdec7d6b96329ea":"gsniA"}],"iegWi":[function(require,module,exports,__globalThis) {
var MD5 = require("f07cc93582c49804");
module.exports = function(buffer) {
    return new MD5().update(buffer).digest();
};

},{"f07cc93582c49804":"eeqUY"}],"eulfJ":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("b6a65ebe2480cb5a");

},{"b6a65ebe2480cb5a":"6Wqgr"}],"6Wqgr":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"sha224WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha224\",\"id\":\"302d300d06096086480165030402040500041c\"},\"RSA-SHA224\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha224\",\"id\":\"302d300d06096086480165030402040500041c\"},\"sha256WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha256\",\"id\":\"3031300d060960864801650304020105000420\"},\"RSA-SHA256\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha256\",\"id\":\"3031300d060960864801650304020105000420\"},\"sha384WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha384\",\"id\":\"3041300d060960864801650304020205000430\"},\"RSA-SHA384\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha384\",\"id\":\"3041300d060960864801650304020205000430\"},\"sha512WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha512\",\"id\":\"3051300d060960864801650304020305000440\"},\"RSA-SHA512\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha512\",\"id\":\"3051300d060960864801650304020305000440\"},\"RSA-SHA1\":{\"sign\":\"rsa\",\"hash\":\"sha1\",\"id\":\"3021300906052b0e03021a05000414\"},\"ecdsa-with-SHA1\":{\"sign\":\"ecdsa\",\"hash\":\"sha1\",\"id\":\"\"},\"sha256\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha256\",\"id\":\"3031300d060960864801650304020105000420\"},\"sha224\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha224\",\"id\":\"302d300d06096086480165030402040500041c\"},\"sha384\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha384\",\"id\":\"3041300d060960864801650304020205000430\"},\"sha512\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha512\",\"id\":\"3051300d060960864801650304020305000440\"},\"DSA-SHA\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA-SHA1\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA-WITH-SHA224\":{\"sign\":\"dsa\",\"hash\":\"sha224\",\"id\":\"\"},\"DSA-SHA224\":{\"sign\":\"dsa\",\"hash\":\"sha224\",\"id\":\"\"},\"DSA-WITH-SHA256\":{\"sign\":\"dsa\",\"hash\":\"sha256\",\"id\":\"\"},\"DSA-SHA256\":{\"sign\":\"dsa\",\"hash\":\"sha256\",\"id\":\"\"},\"DSA-WITH-SHA384\":{\"sign\":\"dsa\",\"hash\":\"sha384\",\"id\":\"\"},\"DSA-SHA384\":{\"sign\":\"dsa\",\"hash\":\"sha384\",\"id\":\"\"},\"DSA-WITH-SHA512\":{\"sign\":\"dsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-SHA512\":{\"sign\":\"dsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-RIPEMD160\":{\"sign\":\"dsa\",\"hash\":\"rmd160\",\"id\":\"\"},\"ripemd160WithRSA\":{\"sign\":\"rsa\",\"hash\":\"rmd160\",\"id\":\"3021300906052b2403020105000414\"},\"RSA-RIPEMD160\":{\"sign\":\"rsa\",\"hash\":\"rmd160\",\"id\":\"3021300906052b2403020105000414\"},\"md5WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"md5\",\"id\":\"3020300c06082a864886f70d020505000410\"},\"RSA-MD5\":{\"sign\":\"rsa\",\"hash\":\"md5\",\"id\":\"3020300c06082a864886f70d020505000410\"}}");

},{}],"6Io3h":[function(require,module,exports,__globalThis) {
'use strict';
exports.pbkdf2 = require("50310b85983e4f32");
exports.pbkdf2Sync = require("5f7b0df9c2ef196d");

},{"50310b85983e4f32":"fJ1B1","5f7b0df9c2ef196d":"gKywC"}],"fJ1B1":[function(require,module,exports,__globalThis) {
var global = arguments[3];
'use strict';
var Buffer = require("a1f6b66eddae53e0").Buffer;
var checkParameters = require("a915fb954a5b62ac");
var defaultEncoding = require("76b8747fb257c65c");
var sync = require("f6f43e3eaadd9ae9");
var toBuffer = require("d12cab846fc3f945");
var ZERO_BUF;
var subtle = global.crypto && global.crypto.subtle;
var toBrowser = {
    sha: 'SHA-1',
    'sha-1': 'SHA-1',
    sha1: 'SHA-1',
    sha256: 'SHA-256',
    'sha-256': 'SHA-256',
    sha384: 'SHA-384',
    'sha-384': 'SHA-384',
    'sha-512': 'SHA-512',
    sha512: 'SHA-512'
};
var checks = [];
var nextTick;
function getNextTick() {
    if (nextTick) return nextTick;
    if (global.process && global.process.nextTick) nextTick = global.process.nextTick;
    else if (global.queueMicrotask) nextTick = global.queueMicrotask;
    else if (global.setImmediate) nextTick = global.setImmediate;
    else nextTick = global.setTimeout;
    return nextTick;
}
function browserPbkdf2(password, salt, iterations, length, algo) {
    return subtle.importKey('raw', password, {
        name: 'PBKDF2'
    }, false, [
        'deriveBits'
    ]).then(function(key) {
        return subtle.deriveBits({
            name: 'PBKDF2',
            salt: salt,
            iterations: iterations,
            hash: {
                name: algo
            }
        }, key, length << 3);
    }).then(function(res) {
        return Buffer.from(res);
    });
}
function checkNative(algo) {
    if (global.process && !global.process.browser) return Promise.resolve(false);
    if (!subtle || !subtle.importKey || !subtle.deriveBits) return Promise.resolve(false);
    if (checks[algo] !== undefined) return checks[algo];
    ZERO_BUF = ZERO_BUF || Buffer.alloc(8);
    var prom = browserPbkdf2(ZERO_BUF, ZERO_BUF, 10, 128, algo).then(function() {
        return true;
    }, function() {
        return false;
    });
    checks[algo] = prom;
    return prom;
}
function resolvePromise(promise, callback) {
    promise.then(function(out) {
        getNextTick()(function() {
            callback(null, out);
        });
    }, function(e) {
        getNextTick()(function() {
            callback(e);
        });
    });
}
module.exports = function(password, salt, iterations, keylen, digest, callback) {
    if (typeof digest === 'function') {
        callback = digest;
        digest = undefined;
    }
    keylen = checkParameters(iterations, keylen);
    password = toBuffer(password, defaultEncoding, 'Password');
    salt = toBuffer(salt, defaultEncoding, 'Salt');
    if (typeof callback !== 'function') throw new Error('No callback provided to pbkdf2');
    digest = digest || 'sha1';
    var algo = toBrowser[digest.toLowerCase()];
    if (!algo || typeof global.Promise !== 'function') {
        getNextTick()(function() {
            var out;
            try {
                out = sync(password, salt, iterations, keylen, digest);
            } catch (e) {
                callback(e);
                return;
            }
            callback(null, out);
        });
        return;
    }
    resolvePromise(checkNative(algo).then(function(resp) {
        if (resp) return browserPbkdf2(password, salt, iterations, keylen, algo);
        return sync(password, salt, iterations, keylen, digest);
    }), callback);
};

},{"a1f6b66eddae53e0":"1Yph5","a915fb954a5b62ac":"iDhte","76b8747fb257c65c":"7JfV7","f6f43e3eaadd9ae9":"gKywC","d12cab846fc3f945":"8smXL"}],"iDhte":[function(require,module,exports,__globalThis) {
'use strict';
var $isFinite = isFinite;
var MAX_ALLOC = Math.pow(2, 30) - 1; // default in iojs
module.exports = function(iterations, keylen) {
    if (typeof iterations !== 'number') throw new TypeError('Iterations not a number');
    if (iterations < 0 || !$isFinite(iterations)) throw new TypeError('Bad iterations');
    if (typeof keylen !== 'number') throw new TypeError('Key length not a number');
    if (keylen < 0 || keylen > MAX_ALLOC || keylen !== keylen) throw new TypeError('Bad key length');
    // `-0` passes the `keylen < 0` guard above (since `-0 < 0` is `false`), but
    // the native binding requires a true Int32; `-0` is held as a double and
    // aborts the process (SIGABRT) on Node.js 15+. Coerce it to `+0`.
    return keylen + 0;
};

},{}],"7JfV7":[function(require,module,exports,__globalThis) {
var global = arguments[3];
var process = require("6b9fe6b7a0bbf941");
'use strict';
var defaultEncoding;
/* istanbul ignore next */ if (global.process && global.process.browser) defaultEncoding = 'utf-8';
else if (global.process && global.process.version) {
    var pVersionMajor = parseInt(process.version.split('.')[0].slice(1), 10);
    defaultEncoding = pVersionMajor >= 6 ? 'utf-8' : 'binary';
} else defaultEncoding = 'utf-8';
module.exports = defaultEncoding;

},{"6b9fe6b7a0bbf941":"4jeNM"}],"gKywC":[function(require,module,exports,__globalThis) {
'use strict';
var md5 = require("1e04e1c2d51cd13d");
var RIPEMD160 = require("42015ac33af139f8");
var sha = require("a7eb8e83614997ca");
var Buffer = require("290c92d9373f664d").Buffer;
var checkParameters = require("1b04775c4713da3d");
var defaultEncoding = require("b290a762e8475e9f");
var toBuffer = require("82c0eccfe5526b2c");
var ZEROS = Buffer.alloc(128);
var sizes = {
    __proto__: null,
    md5: 16,
    sha1: 20,
    sha224: 28,
    sha256: 32,
    sha384: 48,
    sha512: 64,
    'sha512-256': 32,
    ripemd160: 20,
    rmd160: 20
};
var mapping = {
    __proto__: null,
    'sha-1': 'sha1',
    'sha-224': 'sha224',
    'sha-256': 'sha256',
    'sha-384': 'sha384',
    'sha-512': 'sha512',
    'ripemd-160': 'ripemd160'
};
function rmd160Func(data) {
    return new RIPEMD160().update(data).digest();
}
function getDigest(alg) {
    function shaFunc(data) {
        return sha(alg).update(data).digest();
    }
    if (alg === 'rmd160' || alg === 'ripemd160') return rmd160Func;
    if (alg === 'md5') return md5;
    return shaFunc;
}
function Hmac(alg, key, saltLen) {
    var hash = getDigest(alg);
    var blocksize = alg === 'sha512' || alg === 'sha384' ? 128 : 64;
    if (key.length > blocksize) key = hash(key);
    else if (key.length < blocksize) key = Buffer.concat([
        key,
        ZEROS
    ], blocksize);
    var ipad = Buffer.allocUnsafe(blocksize + sizes[alg]);
    var opad = Buffer.allocUnsafe(blocksize + sizes[alg]);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    var ipad1 = Buffer.allocUnsafe(blocksize + saltLen + 4);
    ipad.copy(ipad1, 0, 0, blocksize);
    this.ipad1 = ipad1;
    this.ipad2 = ipad;
    this.opad = opad;
    this.alg = alg;
    this.blocksize = blocksize;
    this.hash = hash;
    this.size = sizes[alg];
}
Hmac.prototype.run = function(data, ipad) {
    data.copy(ipad, this.blocksize);
    var h = this.hash(ipad);
    h.copy(this.opad, this.blocksize);
    return this.hash(this.opad);
};
function pbkdf2(password, salt, iterations, keylen, digest) {
    keylen = checkParameters(iterations, keylen);
    password = toBuffer(password, defaultEncoding, 'Password');
    salt = toBuffer(salt, defaultEncoding, 'Salt');
    var lowerDigest = (digest || 'sha1').toLowerCase();
    var mappedDigest = mapping[lowerDigest] || lowerDigest;
    var size = sizes[mappedDigest];
    if (typeof size !== 'number' || !size) throw new TypeError('Digest algorithm not supported: ' + digest);
    var hmac = new Hmac(mappedDigest, password, salt.length);
    var DK = Buffer.allocUnsafe(keylen);
    var block1 = Buffer.allocUnsafe(salt.length + 4);
    salt.copy(block1, 0, 0, salt.length);
    var destPos = 0;
    var hLen = size;
    var l = Math.ceil(keylen / hLen);
    for(var i = 1; i <= l; i++){
        block1.writeUInt32BE(i, salt.length);
        var T = hmac.run(block1, hmac.ipad1);
        var U = T;
        for(var j = 1; j < iterations; j++){
            U = hmac.run(U, hmac.ipad2);
            for(var k = 0; k < hLen; k++)T[k] ^= U[k];
        }
        T.copy(DK, destPos);
        destPos += hLen;
    }
    return DK;
}
module.exports = pbkdf2;

},{"1e04e1c2d51cd13d":"iegWi","42015ac33af139f8":"cKnjx","a7eb8e83614997ca":"9j4zZ","290c92d9373f664d":"1Yph5","1b04775c4713da3d":"iDhte","b290a762e8475e9f":"7JfV7","82c0eccfe5526b2c":"8smXL"}],"8smXL":[function(require,module,exports,__globalThis) {
'use strict';
var Buffer = require("cc6579c2e1506b6d").Buffer;
var toBuffer = require("84a6c57190a4a01");
var useUint8Array = typeof Uint8Array !== 'undefined';
var useArrayBuffer = useUint8Array && typeof ArrayBuffer !== 'undefined';
var isView = useArrayBuffer && ArrayBuffer.isView;
module.exports = function(thing, encoding, name) {
    if (typeof thing === 'string' || Buffer.isBuffer(thing) || useUint8Array && thing instanceof Uint8Array || isView && isView(thing)) return toBuffer(thing, encoding);
    throw new TypeError(name + ' must be a string, a Buffer, a Uint8Array, or a DataView');
};

},{"cc6579c2e1506b6d":"1Yph5","84a6c57190a4a01":"2pnit"}],"5st97":[function(require,module,exports,__globalThis) {
var DES = require("9fddd06e02c9f65f");
var aes = require("c080e0e074a10616");
var aesModes = require("deca4106fa6cf801");
var desModes = require("7141e0762da15af0");
var ebtk = require("ca278cb2f2d32ea3");
function createCipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if (aesModes[suite]) {
        keyLen = aesModes[suite].key;
        ivLen = aesModes[suite].iv;
    } else if (desModes[suite]) {
        keyLen = desModes[suite].key * 8;
        ivLen = desModes[suite].iv;
    } else throw new TypeError('invalid suite type');
    var keys = ebtk(password, false, keyLen, ivLen);
    return createCipheriv(suite, keys.key, keys.iv);
}
function createDecipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if (aesModes[suite]) {
        keyLen = aesModes[suite].key;
        ivLen = aesModes[suite].iv;
    } else if (desModes[suite]) {
        keyLen = desModes[suite].key * 8;
        ivLen = desModes[suite].iv;
    } else throw new TypeError('invalid suite type');
    var keys = ebtk(password, false, keyLen, ivLen);
    return createDecipheriv(suite, keys.key, keys.iv);
}
function createCipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if (aesModes[suite]) return aes.createCipheriv(suite, key, iv);
    if (desModes[suite]) return new DES({
        key: key,
        iv: iv,
        mode: suite
    });
    throw new TypeError('invalid suite type');
}
function createDecipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if (aesModes[suite]) return aes.createDecipheriv(suite, key, iv);
    if (desModes[suite]) return new DES({
        key: key,
        iv: iv,
        mode: suite,
        decrypt: true
    });
    throw new TypeError('invalid suite type');
}
function getCiphers() {
    return Object.keys(desModes).concat(aes.getCiphers());
}
exports.createCipher = exports.Cipher = createCipher;
exports.createCipheriv = exports.Cipheriv = createCipheriv;
exports.createDecipher = exports.Decipher = createDecipher;
exports.createDecipheriv = exports.Decipheriv = createDecipheriv;
exports.listCiphers = exports.getCiphers = getCiphers;

},{"9fddd06e02c9f65f":"9pDbS","c080e0e074a10616":"3oQJX","deca4106fa6cf801":"2XKyV","7141e0762da15af0":"6lVh0","ca278cb2f2d32ea3":"9zBbP"}],"9pDbS":[function(require,module,exports,__globalThis) {
var CipherBase = require("4df025afd5a20f9f");
var des = require("8ea0942e2f125a3");
var inherits = require("8a7d640fedcdd788");
var Buffer = require("c9c674d2a2a092c4").Buffer;
var modes = {
    'des-ede3-cbc': des.CBC.instantiate(des.EDE),
    'des-ede3': des.EDE,
    'des-ede-cbc': des.CBC.instantiate(des.EDE),
    'des-ede': des.EDE,
    'des-cbc': des.CBC.instantiate(des.DES),
    'des-ecb': des.DES
};
modes.des = modes['des-cbc'];
modes.des3 = modes['des-ede3-cbc'];
module.exports = DES;
inherits(DES, CipherBase);
function DES(opts) {
    CipherBase.call(this);
    var modeName = opts.mode.toLowerCase();
    var mode = modes[modeName];
    var type;
    if (opts.decrypt) type = 'decrypt';
    else type = 'encrypt';
    var key = opts.key;
    if (!Buffer.isBuffer(key)) key = Buffer.from(key);
    if (modeName === 'des-ede' || modeName === 'des-ede-cbc') key = Buffer.concat([
        key,
        key.slice(0, 8)
    ]);
    var iv = opts.iv;
    if (!Buffer.isBuffer(iv)) iv = Buffer.from(iv);
    this._des = mode.create({
        key: key,
        iv: iv,
        type: type
    });
}
DES.prototype._update = function(data) {
    return Buffer.from(this._des.update(data));
};
DES.prototype._final = function() {
    return Buffer.from(this._des.final());
};

},{"4df025afd5a20f9f":"gsniA","8ea0942e2f125a3":"dGvuU","8a7d640fedcdd788":"dwCbX","c9c674d2a2a092c4":"1Yph5"}],"dGvuU":[function(require,module,exports,__globalThis) {
'use strict';
exports.utils = require("c56851640eb0e265");
exports.Cipher = require("22f0b7ac3b9c9316");
exports.DES = require("d0445787359f92a0");
exports.CBC = require("203ada8fdbbff440");
exports.EDE = require("736756ddbc573f7");

},{"c56851640eb0e265":"ek1kH","22f0b7ac3b9c9316":"ljz0c","d0445787359f92a0":"fChPv","203ada8fdbbff440":"l6P7f","736756ddbc573f7":"4piTM"}],"ek1kH":[function(require,module,exports,__globalThis) {
'use strict';
exports.readUInt32BE = function readUInt32BE(bytes, off) {
    var res = bytes[0 + off] << 24 | bytes[1 + off] << 16 | bytes[2 + off] << 8 | bytes[3 + off];
    return res >>> 0;
};
exports.writeUInt32BE = function writeUInt32BE(bytes, value, off) {
    bytes[0 + off] = value >>> 24;
    bytes[1 + off] = value >>> 16 & 0xff;
    bytes[2 + off] = value >>> 8 & 0xff;
    bytes[3 + off] = value & 0xff;
};
exports.ip = function ip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >>> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >>> j + i & 1;
        }
    }
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inR >>> j + i & 1;
        }
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inL >>> j + i & 1;
        }
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
exports.rip = function rip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 0; i < 4; i++)for(var j = 24; j >= 0; j -= 8){
        outL <<= 1;
        outL |= inR >>> j + i & 1;
        outL <<= 1;
        outL |= inL >>> j + i & 1;
    }
    for(var i = 4; i < 8; i++)for(var j = 24; j >= 0; j -= 8){
        outR <<= 1;
        outR |= inR >>> j + i & 1;
        outR <<= 1;
        outR |= inL >>> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
exports.pc1 = function pc1(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    // 7, 15, 23, 31, 39, 47, 55, 63
    // 6, 14, 22, 30, 39, 47, 55, 63
    // 5, 13, 21, 29, 39, 47, 55, 63
    // 4, 12, 20, 28
    for(var i = 7; i >= 5; i--){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outL <<= 1;
        outL |= inR >> j + i & 1;
    }
    // 1, 9, 17, 25, 33, 41, 49, 57
    // 2, 10, 18, 26, 34, 42, 50, 58
    // 3, 11, 19, 27, 35, 43, 51, 59
    // 36, 44, 52, 60
    for(var i = 1; i <= 3; i++){
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outR <<= 1;
        outR |= inL >> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
exports.r28shl = function r28shl(num, shift) {
    return num << shift & 0xfffffff | num >>> 28 - shift;
};
var pc2table = [
    // inL => outL
    14,
    11,
    17,
    4,
    27,
    23,
    25,
    0,
    13,
    22,
    7,
    18,
    5,
    9,
    16,
    24,
    2,
    20,
    12,
    21,
    1,
    8,
    15,
    26,
    // inR => outR
    15,
    4,
    25,
    19,
    9,
    1,
    26,
    16,
    5,
    11,
    23,
    8,
    12,
    7,
    17,
    0,
    22,
    3,
    10,
    14,
    6,
    20,
    27,
    24
];
exports.pc2 = function pc2(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    var len = pc2table.length >>> 1;
    for(var i = 0; i < len; i++){
        outL <<= 1;
        outL |= inL >>> pc2table[i] & 0x1;
    }
    for(var i = len; i < pc2table.length; i++){
        outR <<= 1;
        outR |= inR >>> pc2table[i] & 0x1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
exports.expand = function expand(r, out, off) {
    var outL = 0;
    var outR = 0;
    outL = (r & 1) << 5 | r >>> 27;
    for(var i = 23; i >= 15; i -= 4){
        outL <<= 6;
        outL |= r >>> i & 0x3f;
    }
    for(var i = 11; i >= 3; i -= 4){
        outR |= r >>> i & 0x3f;
        outR <<= 6;
    }
    outR |= (r & 0x1f) << 1 | r >>> 31;
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
var sTable = [
    14,
    0,
    4,
    15,
    13,
    7,
    1,
    4,
    2,
    14,
    15,
    2,
    11,
    13,
    8,
    1,
    3,
    10,
    10,
    6,
    6,
    12,
    12,
    11,
    5,
    9,
    9,
    5,
    0,
    3,
    7,
    8,
    4,
    15,
    1,
    12,
    14,
    8,
    8,
    2,
    13,
    4,
    6,
    9,
    2,
    1,
    11,
    7,
    15,
    5,
    12,
    11,
    9,
    3,
    7,
    14,
    3,
    10,
    10,
    0,
    5,
    6,
    0,
    13,
    15,
    3,
    1,
    13,
    8,
    4,
    14,
    7,
    6,
    15,
    11,
    2,
    3,
    8,
    4,
    14,
    9,
    12,
    7,
    0,
    2,
    1,
    13,
    10,
    12,
    6,
    0,
    9,
    5,
    11,
    10,
    5,
    0,
    13,
    14,
    8,
    7,
    10,
    11,
    1,
    10,
    3,
    4,
    15,
    13,
    4,
    1,
    2,
    5,
    11,
    8,
    6,
    12,
    7,
    6,
    12,
    9,
    0,
    3,
    5,
    2,
    14,
    15,
    9,
    10,
    13,
    0,
    7,
    9,
    0,
    14,
    9,
    6,
    3,
    3,
    4,
    15,
    6,
    5,
    10,
    1,
    2,
    13,
    8,
    12,
    5,
    7,
    14,
    11,
    12,
    4,
    11,
    2,
    15,
    8,
    1,
    13,
    1,
    6,
    10,
    4,
    13,
    9,
    0,
    8,
    6,
    15,
    9,
    3,
    8,
    0,
    7,
    11,
    4,
    1,
    15,
    2,
    14,
    12,
    3,
    5,
    11,
    10,
    5,
    14,
    2,
    7,
    12,
    7,
    13,
    13,
    8,
    14,
    11,
    3,
    5,
    0,
    6,
    6,
    15,
    9,
    0,
    10,
    3,
    1,
    4,
    2,
    7,
    8,
    2,
    5,
    12,
    11,
    1,
    12,
    10,
    4,
    14,
    15,
    9,
    10,
    3,
    6,
    15,
    9,
    0,
    0,
    6,
    12,
    10,
    11,
    1,
    7,
    13,
    13,
    8,
    15,
    9,
    1,
    4,
    3,
    5,
    14,
    11,
    5,
    12,
    2,
    7,
    8,
    2,
    4,
    14,
    2,
    14,
    12,
    11,
    4,
    2,
    1,
    12,
    7,
    4,
    10,
    7,
    11,
    13,
    6,
    1,
    8,
    5,
    5,
    0,
    3,
    15,
    15,
    10,
    13,
    3,
    0,
    9,
    14,
    8,
    9,
    6,
    4,
    11,
    2,
    8,
    1,
    12,
    11,
    7,
    10,
    1,
    13,
    14,
    7,
    2,
    8,
    13,
    15,
    6,
    9,
    15,
    12,
    0,
    5,
    9,
    6,
    10,
    3,
    4,
    0,
    5,
    14,
    3,
    12,
    10,
    1,
    15,
    10,
    4,
    15,
    2,
    9,
    7,
    2,
    12,
    6,
    9,
    8,
    5,
    0,
    6,
    13,
    1,
    3,
    13,
    4,
    14,
    14,
    0,
    7,
    11,
    5,
    3,
    11,
    8,
    9,
    4,
    14,
    3,
    15,
    2,
    5,
    12,
    2,
    9,
    8,
    5,
    12,
    15,
    3,
    10,
    7,
    11,
    0,
    14,
    4,
    1,
    10,
    7,
    1,
    6,
    13,
    0,
    11,
    8,
    6,
    13,
    4,
    13,
    11,
    0,
    2,
    11,
    14,
    7,
    15,
    4,
    0,
    9,
    8,
    1,
    13,
    10,
    3,
    14,
    12,
    3,
    9,
    5,
    7,
    12,
    5,
    2,
    10,
    15,
    6,
    8,
    1,
    6,
    1,
    6,
    4,
    11,
    11,
    13,
    13,
    8,
    12,
    1,
    3,
    4,
    7,
    10,
    14,
    7,
    10,
    9,
    15,
    5,
    6,
    0,
    8,
    15,
    0,
    14,
    5,
    2,
    9,
    3,
    2,
    12,
    13,
    1,
    2,
    15,
    8,
    13,
    4,
    8,
    6,
    10,
    15,
    3,
    11,
    7,
    1,
    4,
    10,
    12,
    9,
    5,
    3,
    6,
    14,
    11,
    5,
    0,
    0,
    14,
    12,
    9,
    7,
    2,
    7,
    2,
    11,
    1,
    4,
    14,
    1,
    7,
    9,
    4,
    12,
    10,
    14,
    8,
    2,
    13,
    0,
    15,
    6,
    12,
    10,
    9,
    13,
    0,
    15,
    3,
    3,
    5,
    5,
    6,
    8,
    11
];
exports.substitute = function substitute(inL, inR) {
    var out = 0;
    for(var i = 0; i < 4; i++){
        var b = inL >>> 18 - i * 6 & 0x3f;
        var sb = sTable[i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    for(var i = 0; i < 4; i++){
        var b = inR >>> 18 - i * 6 & 0x3f;
        var sb = sTable[256 + i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    return out >>> 0;
};
var permuteTable = [
    16,
    25,
    12,
    11,
    3,
    20,
    4,
    15,
    31,
    17,
    9,
    6,
    27,
    14,
    1,
    22,
    30,
    24,
    8,
    18,
    0,
    5,
    29,
    23,
    13,
    19,
    2,
    26,
    10,
    21,
    28,
    7
];
exports.permute = function permute(num) {
    var out = 0;
    for(var i = 0; i < permuteTable.length; i++){
        out <<= 1;
        out |= num >>> permuteTable[i] & 0x1;
    }
    return out >>> 0;
};
exports.padSplit = function padSplit(num, size, group) {
    var str = num.toString(2);
    while(str.length < size)str = '0' + str;
    var out = [];
    for(var i = 0; i < size; i += group)out.push(str.slice(i, i + group));
    return out.join(' ');
};

},{}],"ljz0c":[function(require,module,exports,__globalThis) {
'use strict';
var assert = require("85cfb697294fd1d8");
function Cipher(options) {
    this.options = options;
    this.type = this.options.type;
    this.blockSize = 8;
    this._init();
    this.buffer = new Array(this.blockSize);
    this.bufferOff = 0;
    this.padding = options.padding !== false;
}
module.exports = Cipher;
Cipher.prototype._init = function _init() {
// Might be overrided
};
Cipher.prototype.update = function update(data) {
    if (data.length === 0) return [];
    if (this.type === 'decrypt') return this._updateDecrypt(data);
    else return this._updateEncrypt(data);
};
Cipher.prototype._buffer = function _buffer(data, off) {
    // Append data to buffer
    var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
    for(var i = 0; i < min; i++)this.buffer[this.bufferOff + i] = data[off + i];
    this.bufferOff += min;
    // Shift next
    return min;
};
Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
    this._update(this.buffer, 0, out, off);
    this.bufferOff = 0;
    return this.blockSize;
};
Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = (this.bufferOff + data.length) / this.blockSize | 0;
    var out = new Array(count * this.blockSize);
    if (this.bufferOff !== 0) {
        inputOff += this._buffer(data, inputOff);
        if (this.bufferOff === this.buffer.length) outputOff += this._flushBuffer(out, outputOff);
    }
    // Write blocks
    var max = data.length - (data.length - inputOff) % this.blockSize;
    for(; inputOff < max; inputOff += this.blockSize){
        this._update(data, inputOff, out, outputOff);
        outputOff += this.blockSize;
    }
    // Queue rest
    for(; inputOff < data.length; inputOff++, this.bufferOff++)this.buffer[this.bufferOff] = data[inputOff];
    return out;
};
Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
    var out = new Array(count * this.blockSize);
    // TODO(indutny): optimize it, this is far from optimal
    for(; count > 0; count--){
        inputOff += this._buffer(data, inputOff);
        outputOff += this._flushBuffer(out, outputOff);
    }
    // Buffer rest of the input
    inputOff += this._buffer(data, inputOff);
    return out;
};
Cipher.prototype.final = function final(buffer) {
    var first;
    if (buffer) first = this.update(buffer);
    var last;
    if (this.type === 'encrypt') last = this._finalEncrypt();
    else last = this._finalDecrypt();
    if (first) return first.concat(last);
    else return last;
};
Cipher.prototype._pad = function _pad(buffer, off) {
    if (off === 0) return false;
    while(off < buffer.length)buffer[off++] = 0;
    return true;
};
Cipher.prototype._finalEncrypt = function _finalEncrypt() {
    if (!this._pad(this.buffer, this.bufferOff)) return [];
    var out = new Array(this.blockSize);
    this._update(this.buffer, 0, out, 0);
    return out;
};
Cipher.prototype._unpad = function _unpad(buffer) {
    return buffer;
};
Cipher.prototype._finalDecrypt = function _finalDecrypt() {
    assert.equal(this.bufferOff, this.blockSize, 'Not enough data to decrypt');
    var out = new Array(this.blockSize);
    this._flushBuffer(out, 0);
    return this._unpad(out);
};

},{"85cfb697294fd1d8":"kTSEF"}],"kTSEF":[function(require,module,exports,__globalThis) {
module.exports = assert;
function assert(val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
}
assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || 'Assertion failed: ' + l + ' != ' + r);
};

},{}],"fChPv":[function(require,module,exports,__globalThis) {
'use strict';
var assert = require("2e43e10aa2de50ed");
var inherits = require("551480b8aa09d318");
var utils = require("b6dc5b7926f5a82f");
var Cipher = require("38547d2f1967e2cd");
function DESState() {
    this.tmp = new Array(2);
    this.keys = null;
}
function DES(options) {
    Cipher.call(this, options);
    var state = new DESState();
    this._desState = state;
    this.deriveKeys(state, options.key);
}
inherits(DES, Cipher);
module.exports = DES;
DES.create = function create(options) {
    return new DES(options);
};
var shiftTable = [
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1
];
DES.prototype.deriveKeys = function deriveKeys(state, key) {
    state.keys = new Array(32);
    assert.equal(key.length, this.blockSize, 'Invalid key length');
    var kL = utils.readUInt32BE(key, 0);
    var kR = utils.readUInt32BE(key, 4);
    utils.pc1(kL, kR, state.tmp, 0);
    kL = state.tmp[0];
    kR = state.tmp[1];
    for(var i = 0; i < state.keys.length; i += 2){
        var shift = shiftTable[i >>> 1];
        kL = utils.r28shl(kL, shift);
        kR = utils.r28shl(kR, shift);
        utils.pc2(kL, kR, state.keys, i);
    }
};
DES.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._desState;
    var l = utils.readUInt32BE(inp, inOff);
    var r = utils.readUInt32BE(inp, inOff + 4);
    // Initial Permutation
    utils.ip(l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    if (this.type === 'encrypt') this._encrypt(state, l, r, state.tmp, 0);
    else this._decrypt(state, l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    utils.writeUInt32BE(out, l, outOff);
    utils.writeUInt32BE(out, r, outOff + 4);
};
DES.prototype._pad = function _pad(buffer, off) {
    if (this.padding === false) return false;
    var value = buffer.length - off;
    for(var i = off; i < buffer.length; i++)buffer[i] = value;
    return true;
};
DES.prototype._unpad = function _unpad(buffer) {
    if (this.padding === false) return buffer;
    var pad = buffer[buffer.length - 1];
    for(var i = buffer.length - pad; i < buffer.length; i++)assert.equal(buffer[i], pad);
    return buffer.slice(0, buffer.length - pad);
};
DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
    var l = lStart;
    var r = rStart;
    // Apply f() x16 times
    for(var i = 0; i < state.keys.length; i += 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        utils.expand(r, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = utils.substitute(keyL, keyR);
        var f = utils.permute(s);
        var t = r;
        r = (l ^ f) >>> 0;
        l = t;
    }
    // Reverse Initial Permutation
    utils.rip(r, l, out, off);
};
DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
    var l = rStart;
    var r = lStart;
    // Apply f() x16 times
    for(var i = state.keys.length - 2; i >= 0; i -= 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        utils.expand(l, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = utils.substitute(keyL, keyR);
        var f = utils.permute(s);
        var t = l;
        l = (r ^ f) >>> 0;
        r = t;
    }
    // Reverse Initial Permutation
    utils.rip(l, r, out, off);
};

},{"2e43e10aa2de50ed":"kTSEF","551480b8aa09d318":"dwCbX","b6dc5b7926f5a82f":"ek1kH","38547d2f1967e2cd":"ljz0c"}],"l6P7f":[function(require,module,exports,__globalThis) {
'use strict';
var assert = require("63ac301527fc117b");
var inherits = require("7d48f4d3d39d3b86");
var proto = {};
function CBCState(iv) {
    assert.equal(iv.length, 8, 'Invalid IV length');
    this.iv = new Array(8);
    for(var i = 0; i < this.iv.length; i++)this.iv[i] = iv[i];
}
function instantiate(Base) {
    function CBC(options) {
        Base.call(this, options);
        this._cbcInit();
    }
    inherits(CBC, Base);
    var keys = Object.keys(proto);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        CBC.prototype[key] = proto[key];
    }
    CBC.create = function create(options) {
        return new CBC(options);
    };
    return CBC;
}
exports.instantiate = instantiate;
proto._cbcInit = function _cbcInit() {
    var state = new CBCState(this.options.iv);
    this._cbcState = state;
};
proto._update = function _update(inp, inOff, out, outOff) {
    var state = this._cbcState;
    var superProto = this.constructor.super_.prototype;
    var iv = state.iv;
    if (this.type === 'encrypt') {
        for(var i = 0; i < this.blockSize; i++)iv[i] ^= inp[inOff + i];
        superProto._update.call(this, iv, 0, out, outOff);
        for(var i = 0; i < this.blockSize; i++)iv[i] = out[outOff + i];
    } else {
        superProto._update.call(this, inp, inOff, out, outOff);
        for(var i = 0; i < this.blockSize; i++)out[outOff + i] ^= iv[i];
        for(var i = 0; i < this.blockSize; i++)iv[i] = inp[inOff + i];
    }
};

},{"63ac301527fc117b":"kTSEF","7d48f4d3d39d3b86":"dwCbX"}],"4piTM":[function(require,module,exports,__globalThis) {
'use strict';
var assert = require("d5bfc55b5aa12c8d");
var inherits = require("39ce41101e752862");
var Cipher = require("ba2db61b5607fad4");
var DES = require("f13080dd5389ba87");
function EDEState(type, key) {
    assert.equal(key.length, 24, 'Invalid key length');
    var k1 = key.slice(0, 8);
    var k2 = key.slice(8, 16);
    var k3 = key.slice(16, 24);
    if (type === 'encrypt') this.ciphers = [
        DES.create({
            type: 'encrypt',
            key: k1
        }),
        DES.create({
            type: 'decrypt',
            key: k2
        }),
        DES.create({
            type: 'encrypt',
            key: k3
        })
    ];
    else this.ciphers = [
        DES.create({
            type: 'decrypt',
            key: k3
        }),
        DES.create({
            type: 'encrypt',
            key: k2
        }),
        DES.create({
            type: 'decrypt',
            key: k1
        })
    ];
}
function EDE(options) {
    Cipher.call(this, options);
    var state = new EDEState(this.type, this.options.key);
    this._edeState = state;
}
inherits(EDE, Cipher);
module.exports = EDE;
EDE.create = function create(options) {
    return new EDE(options);
};
EDE.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._edeState;
    state.ciphers[0]._update(inp, inOff, out, outOff);
    state.ciphers[1]._update(out, outOff, out, outOff);
    state.ciphers[2]._update(out, outOff, out, outOff);
};
EDE.prototype._pad = DES.prototype._pad;
EDE.prototype._unpad = DES.prototype._unpad;

},{"d5bfc55b5aa12c8d":"kTSEF","39ce41101e752862":"dwCbX","ba2db61b5607fad4":"ljz0c","f13080dd5389ba87":"fChPv"}],"3oQJX":[function(require,module,exports,__globalThis) {
var ciphers = require("852cf53431a1f811");
var deciphers = require("cf65999dbb4c5e15");
var modes = require("deceb76ffb34f58f");
function getCiphers() {
    return Object.keys(modes);
}
exports.createCipher = exports.Cipher = ciphers.createCipher;
exports.createCipheriv = exports.Cipheriv = ciphers.createCipheriv;
exports.createDecipher = exports.Decipher = deciphers.createDecipher;
exports.createDecipheriv = exports.Decipheriv = deciphers.createDecipheriv;
exports.listCiphers = exports.getCiphers = getCiphers;

},{"852cf53431a1f811":"7Zy06","cf65999dbb4c5e15":"h0sKm","deceb76ffb34f58f":"1jxDX"}],"7Zy06":[function(require,module,exports,__globalThis) {
var MODES = require("634015cf40a677fe");
var AuthCipher = require("ca7c032525082be8");
var Buffer = require("2bd35013f47d4062").Buffer;
var StreamCipher = require("2b03aae3a1335af6");
var Transform = require("138a78277ccfd16f");
var aes = require("cc8a1e2b2934f08f");
var ebtk = require("b149eab8b94068d4");
var inherits = require("ebc328fc178264d2");
function Cipher(mode, key, iv) {
    Transform.call(this);
    this._cache = new Splitter();
    this._cipher = new aes.AES(key);
    this._prev = Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
inherits(Cipher, Transform);
Cipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get()){
        thing = this._mode.encrypt(this, chunk);
        out.push(thing);
    }
    return Buffer.concat(out);
};
var PADDING = Buffer.alloc(16, 0x10);
Cipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) {
        chunk = this._mode.encrypt(this, chunk);
        this._cipher.scrub();
        return chunk;
    }
    if (!chunk.equals(PADDING)) {
        this._cipher.scrub();
        throw new Error('data not multiple of block length');
    }
};
Cipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function Splitter() {
    this.cache = Buffer.allocUnsafe(0);
}
Splitter.prototype.add = function(data) {
    this.cache = Buffer.concat([
        this.cache,
        data
    ]);
};
Splitter.prototype.get = function() {
    if (this.cache.length > 15) {
        var out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
Splitter.prototype.flush = function() {
    var len = 16 - this.cache.length;
    var padBuff = Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)padBuff.writeUInt8(len, i);
    return Buffer.concat([
        this.cache,
        padBuff
    ]);
};
function createCipheriv(suite, password, iv) {
    var config = MODES[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    if (typeof password === 'string') password = Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length);
    if (typeof iv === 'string') iv = Buffer.from(iv);
    if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length);
    if (config.type === 'stream') return new StreamCipher(config.module, password, iv);
    else if (config.type === 'auth') return new AuthCipher(config.module, password, iv);
    return new Cipher(config.module, password, iv);
}
function createCipher(suite, password) {
    var config = MODES[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    var keys = ebtk(password, false, config.key, config.iv);
    return createCipheriv(suite, keys.key, keys.iv);
}
exports.createCipheriv = createCipheriv;
exports.createCipher = createCipher;

},{"634015cf40a677fe":"2XKyV","ca7c032525082be8":"gDv3o","2bd35013f47d4062":"1Yph5","2b03aae3a1335af6":"eRrLH","138a78277ccfd16f":"gsniA","cc8a1e2b2934f08f":"LaDt2","b149eab8b94068d4":"9zBbP","ebc328fc178264d2":"dwCbX"}],"2XKyV":[function(require,module,exports,__globalThis) {
var modeModules = {
    ECB: require("c49ddaf3154fac1e"),
    CBC: require("7c781e2d9206f623"),
    CFB: require("12dfbd130b5827a1"),
    CFB8: require("ae02434166690767"),
    CFB1: require("15ddc45cf76ec123"),
    OFB: require("62e3e290f0879f98"),
    CTR: require("1e6578fa70b860a7"),
    GCM: require("1e6578fa70b860a7")
};
var modes = require("b313067770c9aed2");
for(var key in modes)modes[key].module = modeModules[modes[key].mode];
module.exports = modes;

},{"c49ddaf3154fac1e":"dlW1s","7c781e2d9206f623":"dS5r5","12dfbd130b5827a1":"73Vme","ae02434166690767":"aLZOn","15ddc45cf76ec123":"0XeIJ","62e3e290f0879f98":"7c0dn","1e6578fa70b860a7":"4yikT","b313067770c9aed2":"1jxDX"}],"dlW1s":[function(require,module,exports,__globalThis) {
exports.encrypt = function(self, block) {
    return self._cipher.encryptBlock(block);
};
exports.decrypt = function(self, block) {
    return self._cipher.decryptBlock(block);
};

},{}],"dS5r5":[function(require,module,exports,__globalThis) {
var xor = require("587e692127ea2c31");
exports.encrypt = function(self, block) {
    var data = xor(block, self._prev);
    self._prev = self._cipher.encryptBlock(data);
    return self._prev;
};
exports.decrypt = function(self, block) {
    var pad = self._prev;
    self._prev = block;
    var out = self._cipher.decryptBlock(block);
    return xor(out, pad);
};

},{"587e692127ea2c31":"8mLRB"}],"8mLRB":[function(require,module,exports,__globalThis) {
var Buffer = require("ccae1b11eb3a9ec8").Buffer;
module.exports = function xor(a, b) {
    var length = Math.min(a.length, b.length);
    var buffer = new Buffer(length);
    for(var i = 0; i < length; ++i)buffer[i] = a[i] ^ b[i];
    return buffer;
};

},{"ccae1b11eb3a9ec8":"cjdyz"}],"73Vme":[function(require,module,exports,__globalThis) {
var Buffer = require("7747ec7a535c746a").Buffer;
var xor = require("fe4415d84c8f2a05");
function encryptStart(self, data, decrypt) {
    var len = data.length;
    var out = xor(data, self._cache);
    self._cache = self._cache.slice(len);
    self._prev = Buffer.concat([
        self._prev,
        decrypt ? data : out
    ]);
    return out;
}
exports.encrypt = function(self, data, decrypt) {
    var out = Buffer.allocUnsafe(0);
    var len;
    while(data.length){
        if (self._cache.length === 0) {
            self._cache = self._cipher.encryptBlock(self._prev);
            self._prev = Buffer.allocUnsafe(0);
        }
        if (self._cache.length <= data.length) {
            len = self._cache.length;
            out = Buffer.concat([
                out,
                encryptStart(self, data.slice(0, len), decrypt)
            ]);
            data = data.slice(len);
        } else {
            out = Buffer.concat([
                out,
                encryptStart(self, data, decrypt)
            ]);
            break;
        }
    }
    return out;
};

},{"7747ec7a535c746a":"1Yph5","fe4415d84c8f2a05":"8mLRB"}],"aLZOn":[function(require,module,exports,__globalThis) {
var Buffer = require("36c8b61b54eac90b").Buffer;
function encryptByte(self, byteParam, decrypt) {
    var pad = self._cipher.encryptBlock(self._prev);
    var out = pad[0] ^ byteParam;
    self._prev = Buffer.concat([
        self._prev.slice(1),
        Buffer.from([
            decrypt ? byteParam : out
        ])
    ]);
    return out;
}
exports.encrypt = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = encryptByte(self, chunk[i], decrypt);
    return out;
};

},{"36c8b61b54eac90b":"1Yph5"}],"0XeIJ":[function(require,module,exports,__globalThis) {
var Buffer = require("5eb46e1eefd15734").Buffer;
function encryptByte(self, byteParam, decrypt) {
    var pad;
    var i = -1;
    var len = 8;
    var out = 0;
    var bit, value;
    while(++i < len){
        pad = self._cipher.encryptBlock(self._prev);
        bit = byteParam & 1 << 7 - i ? 0x80 : 0;
        value = pad[0] ^ bit;
        out += (value & 0x80) >> i % 8;
        self._prev = shiftIn(self._prev, decrypt ? bit : value);
    }
    return out;
}
function shiftIn(buffer, value) {
    var len = buffer.length;
    var i = -1;
    var out = Buffer.allocUnsafe(buffer.length);
    buffer = Buffer.concat([
        buffer,
        Buffer.from([
            value
        ])
    ]);
    while(++i < len)out[i] = buffer[i] << 1 | buffer[i + 1] >> 7;
    return out;
}
exports.encrypt = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = encryptByte(self, chunk[i], decrypt);
    return out;
};

},{"5eb46e1eefd15734":"1Yph5"}],"7c0dn":[function(require,module,exports,__globalThis) {
var Buffer = require("b3ff65e516d49ef1").Buffer;
var xor = require("7f0c2ff10cf58835");
function getBlock(self) {
    self._prev = self._cipher.encryptBlock(self._prev);
    return self._prev;
}
exports.encrypt = function(self, chunk) {
    while(self._cache.length < chunk.length)self._cache = Buffer.concat([
        self._cache,
        getBlock(self)
    ]);
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return xor(chunk, pad);
};

},{"b3ff65e516d49ef1":"cjdyz","7f0c2ff10cf58835":"8mLRB"}],"4yikT":[function(require,module,exports,__globalThis) {
var xor = require("9e40d7dfdb715c7");
var Buffer = require("53cb1eb6f102a1c9").Buffer;
var incr32 = require("57780b841d591d93");
function getBlock(self) {
    var out = self._cipher.encryptBlockRaw(self._prev);
    incr32(self._prev);
    return out;
}
var blockSize = 16;
exports.encrypt = function(self, chunk) {
    var chunkNum = Math.ceil(chunk.length / blockSize);
    var start = self._cache.length;
    self._cache = Buffer.concat([
        self._cache,
        Buffer.allocUnsafe(chunkNum * blockSize)
    ]);
    for(var i = 0; i < chunkNum; i++){
        var out = getBlock(self);
        var offset = start + i * blockSize;
        self._cache.writeUInt32BE(out[0], offset + 0);
        self._cache.writeUInt32BE(out[1], offset + 4);
        self._cache.writeUInt32BE(out[2], offset + 8);
        self._cache.writeUInt32BE(out[3], offset + 12);
    }
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return xor(chunk, pad);
};

},{"9e40d7dfdb715c7":"8mLRB","53cb1eb6f102a1c9":"1Yph5","57780b841d591d93":"ltMZg"}],"ltMZg":[function(require,module,exports,__globalThis) {
function incr32(iv) {
    var len = iv.length;
    var item;
    while(len--){
        item = iv.readUInt8(len);
        if (item === 255) iv.writeUInt8(0, len);
        else {
            item++;
            iv.writeUInt8(item, len);
            break;
        }
    }
}
module.exports = incr32;

},{}],"1jxDX":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"aes-128-ecb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-192-ecb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-256-ecb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-128-cbc\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-192-cbc\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-256-cbc\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes128\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes192\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes256\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-128-cfb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-192-cfb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-256-cfb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-128-cfb8\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-192-cfb8\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-256-cfb8\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-128-cfb1\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-192-cfb1\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-256-cfb1\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-128-ofb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-192-ofb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-256-ofb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-128-ctr\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-192-ctr\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-256-ctr\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-128-gcm\":{\"cipher\":\"AES\",\"key\":128,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"},\"aes-192-gcm\":{\"cipher\":\"AES\",\"key\":192,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"},\"aes-256-gcm\":{\"cipher\":\"AES\",\"key\":256,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"}}");

},{}],"gDv3o":[function(require,module,exports,__globalThis) {
var aes = require("b0edcf3ce18ae4ef");
var Buffer = require("2c8f7ba691c38788").Buffer;
var Transform = require("1432783a1879aa01");
var inherits = require("60e0d0bfceaaf739");
var GHASH = require("f76de0f4100ad13f");
var xor = require("a9c82903acf3978e");
var incr32 = require("4e429278132497a7");
function xorTest(a, b) {
    var out = 0;
    if (a.length !== b.length) out++;
    var len = Math.min(a.length, b.length);
    for(var i = 0; i < len; ++i)out += a[i] ^ b[i];
    return out;
}
function calcIv(self, iv, ck) {
    if (iv.length === 12) {
        self._finID = Buffer.concat([
            iv,
            Buffer.from([
                0,
                0,
                0,
                1
            ])
        ]);
        return Buffer.concat([
            iv,
            Buffer.from([
                0,
                0,
                0,
                2
            ])
        ]);
    }
    var ghash = new GHASH(ck);
    var len = iv.length;
    var toPad = len % 16;
    ghash.update(iv);
    if (toPad) {
        toPad = 16 - toPad;
        ghash.update(Buffer.alloc(toPad, 0));
    }
    ghash.update(Buffer.alloc(8, 0));
    var ivBits = len * 8;
    var tail = Buffer.alloc(8);
    tail.writeUIntBE(ivBits, 0, 8);
    ghash.update(tail);
    self._finID = ghash.state;
    var out = Buffer.from(self._finID);
    incr32(out);
    return out;
}
function StreamCipher(mode, key, iv, decrypt) {
    Transform.call(this);
    var h = Buffer.alloc(4, 0);
    this._cipher = new aes.AES(key);
    var ck = this._cipher.encryptBlock(h);
    this._ghash = new GHASH(ck);
    iv = calcIv(this, iv, ck);
    this._prev = Buffer.from(iv);
    this._cache = Buffer.allocUnsafe(0);
    this._secCache = Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._alen = 0;
    this._len = 0;
    this._mode = mode;
    this._authTag = null;
    this._called = false;
}
inherits(StreamCipher, Transform);
StreamCipher.prototype._update = function(chunk) {
    if (!this._called && this._alen) {
        var rump = 16 - this._alen % 16;
        if (rump < 16) {
            rump = Buffer.alloc(rump, 0);
            this._ghash.update(rump);
        }
    }
    this._called = true;
    var out = this._mode.encrypt(this, chunk);
    if (this._decrypt) this._ghash.update(chunk);
    else this._ghash.update(out);
    this._len += chunk.length;
    return out;
};
StreamCipher.prototype._final = function() {
    if (this._decrypt && !this._authTag) throw new Error('Unsupported state or unable to authenticate data');
    var tag = xor(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID));
    if (this._decrypt && xorTest(tag, this._authTag)) throw new Error('Unsupported state or unable to authenticate data');
    this._authTag = tag;
    this._cipher.scrub();
};
StreamCipher.prototype.getAuthTag = function getAuthTag() {
    if (this._decrypt || !Buffer.isBuffer(this._authTag)) throw new Error('Attempting to get auth tag in unsupported state');
    return this._authTag;
};
StreamCipher.prototype.setAuthTag = function setAuthTag(tag) {
    if (!this._decrypt) throw new Error('Attempting to set auth tag in unsupported state');
    this._authTag = tag;
};
StreamCipher.prototype.setAAD = function setAAD(buf) {
    if (this._called) throw new Error('Attempting to set AAD in unsupported state');
    this._ghash.update(buf);
    this._alen += buf.length;
};
module.exports = StreamCipher;

},{"b0edcf3ce18ae4ef":"LaDt2","2c8f7ba691c38788":"1Yph5","1432783a1879aa01":"gsniA","60e0d0bfceaaf739":"dwCbX","f76de0f4100ad13f":"jum0V","a9c82903acf3978e":"8mLRB","4e429278132497a7":"ltMZg"}],"LaDt2":[function(require,module,exports,__globalThis) {
// based on the aes implimentation in triple sec
// https://github.com/keybase/triplesec
// which is in turn based on the one from crypto-js
// https://code.google.com/p/crypto-js/
var Buffer = require("9c4f04f75f375be").Buffer;
function asUInt32Array(buf) {
    if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf);
    var len = buf.length / 4 | 0;
    var out = new Array(len);
    for(var i = 0; i < len; i++)out[i] = buf.readUInt32BE(i * 4);
    return out;
}
function scrubVec(v) {
    for(var i = 0; i < v.length; v++)v[i] = 0;
}
function cryptBlock(M, keySchedule, SUB_MIX, SBOX, nRounds) {
    var SUB_MIX0 = SUB_MIX[0];
    var SUB_MIX1 = SUB_MIX[1];
    var SUB_MIX2 = SUB_MIX[2];
    var SUB_MIX3 = SUB_MIX[3];
    var s0 = M[0] ^ keySchedule[0];
    var s1 = M[1] ^ keySchedule[1];
    var s2 = M[2] ^ keySchedule[2];
    var s3 = M[3] ^ keySchedule[3];
    var t0, t1, t2, t3;
    var ksRow = 4;
    for(var round = 1; round < nRounds; round++){
        t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[s1 >>> 16 & 0xff] ^ SUB_MIX2[s2 >>> 8 & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++];
        t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[s2 >>> 16 & 0xff] ^ SUB_MIX2[s3 >>> 8 & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++];
        t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[s3 >>> 16 & 0xff] ^ SUB_MIX2[s0 >>> 8 & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++];
        t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[s0 >>> 16 & 0xff] ^ SUB_MIX2[s1 >>> 8 & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++];
        s0 = t0;
        s1 = t1;
        s2 = t2;
        s3 = t3;
    }
    t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
    t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
    t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
    t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
    t0 = t0 >>> 0;
    t1 = t1 >>> 0;
    t2 = t2 >>> 0;
    t3 = t3 >>> 0;
    return [
        t0,
        t1,
        t2,
        t3
    ];
}
// AES constants
var RCON = [
    0x00,
    0x01,
    0x02,
    0x04,
    0x08,
    0x10,
    0x20,
    0x40,
    0x80,
    0x1b,
    0x36
];
var G = function() {
    // Compute double table
    var d = new Array(256);
    for(var j = 0; j < 256; j++)if (j < 128) d[j] = j << 1;
    else d[j] = j << 1 ^ 0x11b;
    var SBOX = [];
    var INV_SBOX = [];
    var SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    var INV_SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    // Walk GF(2^8)
    var x = 0;
    var xi = 0;
    for(var i = 0; i < 256; ++i){
        // Compute sbox
        var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
        sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
        SBOX[x] = sx;
        INV_SBOX[sx] = x;
        // Compute multiplication
        var x2 = d[x];
        var x4 = d[x2];
        var x8 = d[x4];
        // Compute sub bytes, mix columns tables
        var t = d[sx] * 0x101 ^ sx * 0x1010100;
        SUB_MIX[0][x] = t << 24 | t >>> 8;
        SUB_MIX[1][x] = t << 16 | t >>> 16;
        SUB_MIX[2][x] = t << 8 | t >>> 24;
        SUB_MIX[3][x] = t;
        // Compute inv sub bytes, inv mix columns tables
        t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
        INV_SUB_MIX[0][sx] = t << 24 | t >>> 8;
        INV_SUB_MIX[1][sx] = t << 16 | t >>> 16;
        INV_SUB_MIX[2][sx] = t << 8 | t >>> 24;
        INV_SUB_MIX[3][sx] = t;
        if (x === 0) x = xi = 1;
        else {
            x = x2 ^ d[d[d[x8 ^ x2]]];
            xi ^= d[d[xi]];
        }
    }
    return {
        SBOX: SBOX,
        INV_SBOX: INV_SBOX,
        SUB_MIX: SUB_MIX,
        INV_SUB_MIX: INV_SUB_MIX
    };
}();
function AES(key) {
    this._key = asUInt32Array(key);
    this._reset();
}
AES.blockSize = 16;
AES.keySize = 32;
AES.prototype.blockSize = AES.blockSize;
AES.prototype.keySize = AES.keySize;
AES.prototype._reset = function() {
    var keyWords = this._key;
    var keySize = keyWords.length;
    var nRounds = keySize + 6;
    var ksRows = (nRounds + 1) * 4;
    var keySchedule = [];
    for(var k = 0; k < keySize; k++)keySchedule[k] = keyWords[k];
    for(k = keySize; k < ksRows; k++){
        var t = keySchedule[k - 1];
        if (k % keySize === 0) {
            t = t << 8 | t >>> 24;
            t = G.SBOX[t >>> 24] << 24 | G.SBOX[t >>> 16 & 0xff] << 16 | G.SBOX[t >>> 8 & 0xff] << 8 | G.SBOX[t & 0xff];
            t ^= RCON[k / keySize | 0] << 24;
        } else if (keySize > 6 && k % keySize === 4) t = G.SBOX[t >>> 24] << 24 | G.SBOX[t >>> 16 & 0xff] << 16 | G.SBOX[t >>> 8 & 0xff] << 8 | G.SBOX[t & 0xff];
        keySchedule[k] = keySchedule[k - keySize] ^ t;
    }
    var invKeySchedule = [];
    for(var ik = 0; ik < ksRows; ik++){
        var ksR = ksRows - ik;
        var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)];
        if (ik < 4 || ksR <= 4) invKeySchedule[ik] = tt;
        else invKeySchedule[ik] = G.INV_SUB_MIX[0][G.SBOX[tt >>> 24]] ^ G.INV_SUB_MIX[1][G.SBOX[tt >>> 16 & 0xff]] ^ G.INV_SUB_MIX[2][G.SBOX[tt >>> 8 & 0xff]] ^ G.INV_SUB_MIX[3][G.SBOX[tt & 0xff]];
    }
    this._nRounds = nRounds;
    this._keySchedule = keySchedule;
    this._invKeySchedule = invKeySchedule;
};
AES.prototype.encryptBlockRaw = function(M) {
    M = asUInt32Array(M);
    return cryptBlock(M, this._keySchedule, G.SUB_MIX, G.SBOX, this._nRounds);
};
AES.prototype.encryptBlock = function(M) {
    var out = this.encryptBlockRaw(M);
    var buf = Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[1], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[3], 12);
    return buf;
};
AES.prototype.decryptBlock = function(M) {
    M = asUInt32Array(M);
    // swap
    var m1 = M[1];
    M[1] = M[3];
    M[3] = m1;
    var out = cryptBlock(M, this._invKeySchedule, G.INV_SUB_MIX, G.INV_SBOX, this._nRounds);
    var buf = Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[3], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[1], 12);
    return buf;
};
AES.prototype.scrub = function() {
    scrubVec(this._keySchedule);
    scrubVec(this._invKeySchedule);
    scrubVec(this._key);
};
module.exports.AES = AES;

},{"9c4f04f75f375be":"1Yph5"}],"jum0V":[function(require,module,exports,__globalThis) {
var Buffer = require("815beeecbe039d1a").Buffer;
var ZEROES = Buffer.alloc(16, 0);
function toArray(buf) {
    return [
        buf.readUInt32BE(0),
        buf.readUInt32BE(4),
        buf.readUInt32BE(8),
        buf.readUInt32BE(12)
    ];
}
function fromArray(out) {
    var buf = Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0] >>> 0, 0);
    buf.writeUInt32BE(out[1] >>> 0, 4);
    buf.writeUInt32BE(out[2] >>> 0, 8);
    buf.writeUInt32BE(out[3] >>> 0, 12);
    return buf;
}
function GHASH(key) {
    this.h = key;
    this.state = Buffer.alloc(16, 0);
    this.cache = Buffer.allocUnsafe(0);
}
// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
// by Juho Vähä-Herttua
GHASH.prototype.ghash = function(block) {
    var i = -1;
    while(++i < block.length)this.state[i] ^= block[i];
    this._multiply();
};
GHASH.prototype._multiply = function() {
    var Vi = toArray(this.h);
    var Zi = [
        0,
        0,
        0,
        0
    ];
    var j, xi, lsbVi;
    var i = -1;
    while(++i < 128){
        xi = (this.state[~~(i / 8)] & 1 << 7 - i % 8) !== 0;
        if (xi) {
            // Z_i+1 = Z_i ^ V_i
            Zi[0] ^= Vi[0];
            Zi[1] ^= Vi[1];
            Zi[2] ^= Vi[2];
            Zi[3] ^= Vi[3];
        }
        // Store the value of LSB(V_i)
        lsbVi = (Vi[3] & 1) !== 0;
        // V_i+1 = V_i >> 1
        for(j = 3; j > 0; j--)Vi[j] = Vi[j] >>> 1 | (Vi[j - 1] & 1) << 31;
        Vi[0] = Vi[0] >>> 1;
        // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
        if (lsbVi) Vi[0] = Vi[0] ^ -520093696;
    }
    this.state = fromArray(Zi);
};
GHASH.prototype.update = function(buf) {
    this.cache = Buffer.concat([
        this.cache,
        buf
    ]);
    var chunk;
    while(this.cache.length >= 16){
        chunk = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        this.ghash(chunk);
    }
};
GHASH.prototype.final = function(abl, bl) {
    if (this.cache.length) this.ghash(Buffer.concat([
        this.cache,
        ZEROES
    ], 16));
    this.ghash(fromArray([
        0,
        abl,
        0,
        bl
    ]));
    return this.state;
};
module.exports = GHASH;

},{"815beeecbe039d1a":"1Yph5"}],"eRrLH":[function(require,module,exports,__globalThis) {
var aes = require("499d62308d7dac40");
var Buffer = require("bc4a1f7113303d58").Buffer;
var Transform = require("e701745abb80bc49");
var inherits = require("3765f10ec3d7a831");
function StreamCipher(mode, key, iv, decrypt) {
    Transform.call(this);
    this._cipher = new aes.AES(key);
    this._prev = Buffer.from(iv);
    this._cache = Buffer.allocUnsafe(0);
    this._secCache = Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._mode = mode;
}
inherits(StreamCipher, Transform);
StreamCipher.prototype._update = function(chunk) {
    return this._mode.encrypt(this, chunk, this._decrypt);
};
StreamCipher.prototype._final = function() {
    this._cipher.scrub();
};
module.exports = StreamCipher;

},{"499d62308d7dac40":"LaDt2","bc4a1f7113303d58":"1Yph5","e701745abb80bc49":"gsniA","3765f10ec3d7a831":"dwCbX"}],"9zBbP":[function(require,module,exports,__globalThis) {
var Buffer = require("adb33291e0f9c65a").Buffer;
var MD5 = require("15f984dc9e3797d9");
/* eslint-disable camelcase */ function EVP_BytesToKey(password, salt, keyBits, ivLen) {
    if (!Buffer.isBuffer(password)) password = Buffer.from(password, 'binary');
    if (salt) {
        if (!Buffer.isBuffer(salt)) salt = Buffer.from(salt, 'binary');
        if (salt.length !== 8) throw new RangeError('salt should be Buffer with 8 byte length');
    }
    var keyLen = keyBits / 8;
    var key = Buffer.alloc(keyLen);
    var iv = Buffer.alloc(ivLen || 0);
    var tmp = Buffer.alloc(0);
    while(keyLen > 0 || ivLen > 0){
        var hash = new MD5();
        hash.update(tmp);
        hash.update(password);
        if (salt) hash.update(salt);
        tmp = hash.digest();
        var used = 0;
        if (keyLen > 0) {
            var keyStart = key.length - keyLen;
            used = Math.min(keyLen, tmp.length);
            tmp.copy(key, keyStart, 0, used);
            keyLen -= used;
        }
        if (used < tmp.length && ivLen > 0) {
            var ivStart = iv.length - ivLen;
            var length = Math.min(ivLen, tmp.length - used);
            tmp.copy(iv, ivStart, used, used + length);
            ivLen -= length;
        }
    }
    tmp.fill(0);
    return {
        key: key,
        iv: iv
    };
}
module.exports = EVP_BytesToKey;

},{"adb33291e0f9c65a":"1Yph5","15f984dc9e3797d9":"eeqUY"}],"h0sKm":[function(require,module,exports,__globalThis) {
var AuthCipher = require("2f5914bdcee0aab2");
var Buffer = require("2eedc5cbfd1eafeb").Buffer;
var MODES = require("2b861a45e2a2d1fe");
var StreamCipher = require("54b6d333d74ae9c8");
var Transform = require("4b438dd1327af64e");
var aes = require("928aea47daff81dc");
var ebtk = require("25542df8da1646fe");
var inherits = require("153b885d89d2089e");
function Decipher(mode, key, iv) {
    Transform.call(this);
    this._cache = new Splitter();
    this._last = void 0;
    this._cipher = new aes.AES(key);
    this._prev = Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
inherits(Decipher, Transform);
Decipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get(this._autopadding)){
        thing = this._mode.decrypt(this, chunk);
        out.push(thing);
    }
    return Buffer.concat(out);
};
Decipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) return unpad(this._mode.decrypt(this, chunk));
    else if (chunk) throw new Error('data not multiple of block length');
};
Decipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function Splitter() {
    this.cache = Buffer.allocUnsafe(0);
}
Splitter.prototype.add = function(data) {
    this.cache = Buffer.concat([
        this.cache,
        data
    ]);
};
Splitter.prototype.get = function(autoPadding) {
    var out;
    if (autoPadding) {
        if (this.cache.length > 16) {
            out = this.cache.slice(0, 16);
            this.cache = this.cache.slice(16);
            return out;
        }
    } else if (this.cache.length >= 16) {
        out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
Splitter.prototype.flush = function() {
    if (this.cache.length) return this.cache;
};
function unpad(last) {
    var padded = last[15];
    if (padded < 1 || padded > 16) throw new Error('unable to decrypt data');
    var i = -1;
    while(++i < padded){
        if (last[i + (16 - padded)] !== padded) throw new Error('unable to decrypt data');
    }
    if (padded === 16) return;
    return last.slice(0, 16 - padded);
}
function createDecipheriv(suite, password, iv) {
    var config = MODES[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    if (typeof iv === 'string') iv = Buffer.from(iv);
    if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length);
    if (typeof password === 'string') password = Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length);
    if (config.type === 'stream') return new StreamCipher(config.module, password, iv, true);
    else if (config.type === 'auth') return new AuthCipher(config.module, password, iv, true);
    return new Decipher(config.module, password, iv);
}
function createDecipher(suite, password) {
    var config = MODES[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    var keys = ebtk(password, false, config.key, config.iv);
    return createDecipheriv(suite, keys.key, keys.iv);
}
exports.createDecipher = createDecipher;
exports.createDecipheriv = createDecipheriv;

},{"2f5914bdcee0aab2":"gDv3o","2eedc5cbfd1eafeb":"1Yph5","2b861a45e2a2d1fe":"2XKyV","54b6d333d74ae9c8":"eRrLH","4b438dd1327af64e":"gsniA","928aea47daff81dc":"LaDt2","25542df8da1646fe":"9zBbP","153b885d89d2089e":"dwCbX"}],"6lVh0":[function(require,module,exports,__globalThis) {
exports['des-ecb'] = {
    key: 8,
    iv: 0
};
exports['des-cbc'] = exports.des = {
    key: 8,
    iv: 8
};
exports['des-ede3-cbc'] = exports.des3 = {
    key: 24,
    iv: 8
};
exports['des-ede3'] = {
    key: 24,
    iv: 0
};
exports['des-ede-cbc'] = {
    key: 16,
    iv: 8
};
exports['des-ede'] = {
    key: 16,
    iv: 0
};

},{}],"a4Tsm":[function(require,module,exports,__globalThis) {
var Buffer = require("55a084ce1a29baa3").Buffer;
var generatePrime = require("5ed99cf028c947ad");
var primes = require("8da23ed5d7edf952");
var DH = require("981b8db942febaf3");
function getDiffieHellman(mod) {
    var prime = new Buffer(primes[mod].prime, 'hex');
    var gen = new Buffer(primes[mod].gen, 'hex');
    return new DH(prime, gen);
}
var ENCODINGS = {
    'binary': true,
    'hex': true,
    'base64': true
};
function createDiffieHellman(prime, enc, generator, genc) {
    if (Buffer.isBuffer(enc) || ENCODINGS[enc] === undefined) return createDiffieHellman(prime, 'binary', enc, generator);
    enc = enc || 'binary';
    genc = genc || 'binary';
    generator = generator || new Buffer([
        2
    ]);
    if (!Buffer.isBuffer(generator)) generator = new Buffer(generator, genc);
    if (typeof prime === 'number') return new DH(generatePrime(prime, generator), generator, true);
    if (!Buffer.isBuffer(prime)) prime = new Buffer(prime, enc);
    return new DH(prime, generator, true);
}
exports.DiffieHellmanGroup = exports.createDiffieHellmanGroup = exports.getDiffieHellman = getDiffieHellman;
exports.createDiffieHellman = exports.DiffieHellman = createDiffieHellman;

},{"55a084ce1a29baa3":"cjdyz","5ed99cf028c947ad":"l0Yih","8da23ed5d7edf952":"jbBfo","981b8db942febaf3":"hq2Yo"}],"l0Yih":[function(require,module,exports,__globalThis) {
var randomBytes = require("e11b752ebf414e01");
module.exports = findPrime;
findPrime.simpleSieve = simpleSieve;
findPrime.fermatTest = fermatTest;
var BN = require("6139735ee181267b");
var TWENTYFOUR = new BN(24);
var MillerRabin = require("7b3f73f9ab7b2b6a");
var millerRabin = new MillerRabin();
var ONE = new BN(1);
var TWO = new BN(2);
var FIVE = new BN(5);
var SIXTEEN = new BN(16);
var EIGHT = new BN(8);
var TEN = new BN(10);
var THREE = new BN(3);
var SEVEN = new BN(7);
var ELEVEN = new BN(11);
var FOUR = new BN(4);
var TWELVE = new BN(12);
var primes = null;
function _getPrimes() {
    if (primes !== null) return primes;
    var limit = 0x100000;
    var res = [];
    res[0] = 2;
    for(var i = 1, k = 3; k < limit; k += 2){
        var sqrt = Math.ceil(Math.sqrt(k));
        for(var j = 0; j < i && res[j] <= sqrt; j++)if (k % res[j] === 0) break;
        if (i !== j && res[j] <= sqrt) continue;
        res[i++] = k;
    }
    primes = res;
    return res;
}
function simpleSieve(p) {
    var primes = _getPrimes();
    for(var i = 0; i < primes.length; i++)if (p.modn(primes[i]) === 0) {
        if (p.cmpn(primes[i]) === 0) return true;
        else return false;
    }
    return true;
}
function fermatTest(p) {
    var red = BN.mont(p);
    return TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
}
function findPrime(bits, gen) {
    if (bits < 16) {
        // this is what openssl does
        if (gen === 2 || gen === 5) return new BN([
            0x8c,
            0x7b
        ]);
        else return new BN([
            0x8c,
            0x27
        ]);
    }
    gen = new BN(gen);
    var num, n2;
    while(true){
        num = new BN(randomBytes(Math.ceil(bits / 8)));
        while(num.bitLength() > bits)num.ishrn(1);
        if (num.isEven()) num.iadd(ONE);
        if (!num.testn(1)) num.iadd(TWO);
        if (!gen.cmp(TWO)) while(num.mod(TWENTYFOUR).cmp(ELEVEN))num.iadd(FOUR);
        else if (!gen.cmp(FIVE)) while(num.mod(TEN).cmp(THREE))num.iadd(FOUR);
        n2 = num.shrn(1);
        if (simpleSieve(n2) && simpleSieve(num) && fermatTest(n2) && fermatTest(num) && millerRabin.test(n2) && millerRabin.test(num)) return num;
    }
}

},{"e11b752ebf414e01":"jXr3f","6139735ee181267b":"3h8HW","7b3f73f9ab7b2b6a":"829Lg"}],"3h8HW":[function(require,module,exports,__globalThis) {
(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = require("a4b3a214327293bc").Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) {
            this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
            i++;
        }
        // Clear words above the requested width so the result stays below 2 ** width
        for(; i < this.length; i++)this.words[i] = 0;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        if (num === 0) {
            this.length = 1;
            this._normSign();
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.mod.abs();
        var half = num.abs().iushrn(1);
        var r2 = num.words[0] & 1;
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up, away from zero
        var up = new BN(1);
        up.negative = this.negative ^ num.negative;
        return dm.div.iadd(up);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

},{"a4b3a214327293bc":"4TE4R"}],"829Lg":[function(require,module,exports,__globalThis) {
var bn = require("31d279a7646d17e9");
var brorand = require("1ed277e13aa258c6");
function MillerRabin(rand) {
    this.rand = rand || new brorand.Rand();
}
module.exports = MillerRabin;
MillerRabin.create = function create(rand) {
    return new MillerRabin(rand);
};
MillerRabin.prototype._randbelow = function _randbelow(n) {
    var len = n.bitLength();
    var min_bytes = Math.ceil(len / 8);
    // Generage random bytes until a number less than n is found.
    // This ensures that 0..n-1 have an equal probability of being selected.
    do var a = new bn(this.rand.generate(min_bytes));
    while (a.cmp(n) >= 0);
    return a;
};
MillerRabin.prototype._randrange = function _randrange(start, stop) {
    // Generate a random number greater than or equal to start and less than stop.
    var size = stop.sub(start);
    return start.add(this._randbelow(size));
};
MillerRabin.prototype.test = function test(n, k, cb) {
    var len = n.bitLength();
    var red = bn.mont(n);
    var rone = new bn(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    var prime = true;
    for(; k > 0; k--){
        var a = this._randrange(new bn(2), n1);
        if (cb) cb(a);
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return false;
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) return false;
    }
    return prime;
};
MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
    var len = n.bitLength();
    var red = bn.mont(n);
    var rone = new bn(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    for(; k > 0; k--){
        var a = this._randrange(new bn(2), n1);
        var g = n.gcd(a);
        if (g.cmpn(1) !== 0) return g;
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return x.fromRed().subn(1).gcd(n);
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) {
            x = x.redSqr();
            return x.fromRed().subn(1).gcd(n);
        }
    }
    return false;
};

},{"31d279a7646d17e9":"6bfM6","1ed277e13aa258c6":"eefBI"}],"6bfM6":[function(require,module,exports,__globalThis) {
(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = require("1a01f12e7676c433").Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) {
            this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
            i++;
        }
        // Clear words above the requested width so the result stays below 2 ** width
        for(; i < this.length; i++)this.words[i] = 0;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        if (num === 0) {
            this.length = 1;
            this._normSign();
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.mod.abs();
        var half = num.abs().iushrn(1);
        var r2 = num.words[0] & 1;
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up, away from zero
        var up = new BN(1);
        up.negative = this.negative ^ num.negative;
        return dm.div.iadd(up);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

},{"1a01f12e7676c433":"4TE4R"}],"eefBI":[function(require,module,exports,__globalThis) {
var r;
module.exports = function rand(len) {
    if (!r) r = new Rand(null);
    return r.generate(len);
};
function Rand(rand) {
    this.rand = rand;
}
module.exports.Rand = Rand;
Rand.prototype.generate = function generate(len) {
    return this._rand(len);
};
// Emulate crypto API using randy
Rand.prototype._rand = function _rand(n) {
    if (this.rand.getBytes) return this.rand.getBytes(n);
    var res = new Uint8Array(n);
    for(var i = 0; i < res.length; i++)res[i] = this.rand.getByte();
    return res;
};
if (typeof self === 'object') {
    if (self.crypto && self.crypto.getRandomValues) // Modern browsers
    Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.crypto.getRandomValues(arr);
        return arr;
    };
    else if (self.msCrypto && self.msCrypto.getRandomValues) // IE
    Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.msCrypto.getRandomValues(arr);
        return arr;
    };
    else if (typeof window === 'object') // Old junk
    Rand.prototype._rand = function() {
        throw new Error('Not implemented yet');
    };
} else // Node.js or Web worker with no crypto support
try {
    var crypto = require("e8ad0674730919a8");
    if (typeof crypto.randomBytes !== 'function') throw new Error('Not supported');
    Rand.prototype._rand = function _rand(n) {
        return crypto.randomBytes(n);
    };
} catch (e) {}

},{"e8ad0674730919a8":"4TE4R"}],"jbBfo":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"modp1\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff\"},\"modp2\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff\"},\"modp5\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff\"},\"modp14\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff\"},\"modp15\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff\"},\"modp16\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff\"},\"modp17\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff\"},\"modp18\":{\"gen\":\"02\",\"prime\":\"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\"}}");

},{}],"hq2Yo":[function(require,module,exports,__globalThis) {
var Buffer = require("18c258c24cda4205").Buffer;
var BN = require("6cfaed55db270425");
var MillerRabin = require("8bc0d9823ee74460");
var millerRabin = new MillerRabin();
var TWENTYFOUR = new BN(24);
var ELEVEN = new BN(11);
var TEN = new BN(10);
var THREE = new BN(3);
var SEVEN = new BN(7);
var primes = require("dd39d03f4b3404fc");
var randomBytes = require("e2757e55299a3ebc");
module.exports = DH;
function setPublicKey(pub, enc) {
    enc = enc || 'utf8';
    if (!Buffer.isBuffer(pub)) pub = new Buffer(pub, enc);
    this._pub = new BN(pub);
    return this;
}
function setPrivateKey(priv, enc) {
    enc = enc || 'utf8';
    if (!Buffer.isBuffer(priv)) priv = new Buffer(priv, enc);
    this._priv = new BN(priv);
    return this;
}
var primeCache = {};
function checkPrime(prime, generator) {
    var gen = generator.toString('hex');
    var hex = [
        gen,
        prime.toString(16)
    ].join('_');
    if (hex in primeCache) return primeCache[hex];
    var error = 0;
    if (prime.isEven() || !primes.simpleSieve || !primes.fermatTest(prime) || !millerRabin.test(prime)) {
        //not a prime so +1
        error += 1;
        if (gen === '02' || gen === '05') // we'd be able to check the generator
        // it would fail so +8
        error += 8;
        else //we wouldn't be able to test the generator
        // so +4
        error += 4;
        primeCache[hex] = error;
        return error;
    }
    if (!millerRabin.test(prime.shrn(1))) //not a safe prime
    error += 2;
    var rem;
    switch(gen){
        case '02':
            if (prime.mod(TWENTYFOUR).cmp(ELEVEN)) // unsuidable generator
            error += 8;
            break;
        case '05':
            rem = prime.mod(TEN);
            if (rem.cmp(THREE) && rem.cmp(SEVEN)) // prime mod 10 needs to equal 3 or 7
            error += 8;
            break;
        default:
            error += 4;
    }
    primeCache[hex] = error;
    return error;
}
function DH(prime, generator, malleable) {
    this.setGenerator(generator);
    this.__prime = new BN(prime);
    this._prime = BN.mont(this.__prime);
    this._primeLen = prime.length;
    this._pub = undefined;
    this._priv = undefined;
    this._primeCode = undefined;
    if (malleable) {
        this.setPublicKey = setPublicKey;
        this.setPrivateKey = setPrivateKey;
    } else this._primeCode = 8;
}
Object.defineProperty(DH.prototype, 'verifyError', {
    enumerable: true,
    get: function() {
        if (typeof this._primeCode !== 'number') this._primeCode = checkPrime(this.__prime, this.__gen);
        return this._primeCode;
    }
});
DH.prototype.generateKeys = function() {
    if (!this._priv) this._priv = new BN(randomBytes(this._primeLen));
    this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
    return this.getPublicKey();
};
DH.prototype.computeSecret = function(other) {
    other = new BN(other);
    other = other.toRed(this._prime);
    var secret = other.redPow(this._priv).fromRed();
    var out = new Buffer(secret.toArray());
    var prime = this.getPrime();
    if (out.length < prime.length) {
        var front = new Buffer(prime.length - out.length);
        front.fill(0);
        out = Buffer.concat([
            front,
            out
        ]);
    }
    return out;
};
DH.prototype.getPublicKey = function getPublicKey(enc) {
    return formatReturnValue(this._pub, enc);
};
DH.prototype.getPrivateKey = function getPrivateKey(enc) {
    return formatReturnValue(this._priv, enc);
};
DH.prototype.getPrime = function(enc) {
    return formatReturnValue(this.__prime, enc);
};
DH.prototype.getGenerator = function(enc) {
    return formatReturnValue(this._gen, enc);
};
DH.prototype.setGenerator = function(gen, enc) {
    enc = enc || 'utf8';
    if (!Buffer.isBuffer(gen)) gen = new Buffer(gen, enc);
    this.__gen = gen;
    this._gen = new BN(gen);
    return this;
};
function formatReturnValue(bn, enc) {
    var buf = new Buffer(bn.toArray());
    if (!enc) return buf;
    else return buf.toString(enc);
}

},{"18c258c24cda4205":"cjdyz","6cfaed55db270425":"3h8HW","8bc0d9823ee74460":"829Lg","dd39d03f4b3404fc":"l0Yih","e2757e55299a3ebc":"jXr3f"}],"g5lRC":[function(require,module,exports,__globalThis) {
'use strict';
var Buffer = require("9c72b70d69889676").Buffer;
var createHash = require("efe64c48bedfa38e");
var stream = require("6a5343e9b2081ca8");
var inherits = require("f95e32eac8325984");
var sign = require("6e9f6edb752a2c10");
var verify = require("c2f6e4379d1db430");
var algorithms = require("2d93707c75adaee");
Object.keys(algorithms).forEach(function(key) {
    algorithms[key].id = Buffer.from(algorithms[key].id, 'hex');
    algorithms[key.toLowerCase()] = algorithms[key];
});
function Sign(algorithm) {
    stream.Writable.call(this);
    var data = algorithms[algorithm];
    if (!data) throw new Error('Unknown message digest');
    this._hashType = data.hash;
    this._hash = createHash(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
inherits(Sign, stream.Writable);
Sign.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
Sign.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === 'string' ? Buffer.from(data, enc) : data);
    return this;
};
Sign.prototype.sign = function signMethod(key, enc) {
    this.end();
    var hash = this._hash.digest();
    var sig = sign(hash, key, this._hashType, this._signType, this._tag);
    return enc ? sig.toString(enc) : sig;
};
function Verify(algorithm) {
    stream.Writable.call(this);
    var data = algorithms[algorithm];
    if (!data) throw new Error('Unknown message digest');
    this._hash = createHash(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
inherits(Verify, stream.Writable);
Verify.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
Verify.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === 'string' ? Buffer.from(data, enc) : data);
    return this;
};
Verify.prototype.verify = function verifyMethod(key, sig, enc) {
    var sigBuffer = typeof sig === 'string' ? Buffer.from(sig, enc) : sig;
    this.end();
    var hash = this._hash.digest();
    return verify(sigBuffer, hash, key, this._signType, this._tag);
};
function createSign(algorithm) {
    return new Sign(algorithm);
}
function createVerify(algorithm) {
    return new Verify(algorithm);
}
module.exports = {
    Sign: createSign,
    Verify: createVerify,
    createSign: createSign,
    createVerify: createVerify
};

},{"9c72b70d69889676":"1Yph5","efe64c48bedfa38e":"aPKzt","6a5343e9b2081ca8":"aOZk9","f95e32eac8325984":"dwCbX","6e9f6edb752a2c10":"hOz0V","c2f6e4379d1db430":"lKdnm","2d93707c75adaee":"6Wqgr"}],"hOz0V":[function(require,module,exports,__globalThis) {
'use strict';
// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js
var Buffer = require("6ae1d89b9934a98d").Buffer;
var createHmac = require("a8da94153ecfc34b");
var crt = require("51cccb2c4d98daac");
var EC = require("94cc3a287d70a03d").ec;
var BN = require("e83ac2526d8afeba");
var parseKeys = require("892f1603b4523d84");
var curves = require("d22eecc2600c2d97");
var RSA_PKCS1_PADDING = 1;
function sign(hash, key, hashType, signType, tag) {
    var priv = parseKeys(key);
    if (priv.curve) {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type');
        return ecSign(hash, priv);
    } else if (priv.type === 'dsa') {
        if (signType !== 'dsa') throw new Error('wrong private key type');
        return dsaSign(hash, priv, hashType);
    }
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type');
    if (key.padding !== undefined && key.padding !== RSA_PKCS1_PADDING) throw new Error('illegal or unsupported padding mode');
    hash = Buffer.concat([
        tag,
        hash
    ]);
    var len = priv.modulus.byteLength();
    var pad = [
        0,
        1
    ];
    while(hash.length + pad.length + 1 < len)pad.push(0xff);
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    var out = crt(pad, priv);
    return out;
}
function ecSign(hash, priv) {
    var curveId = curves[priv.curve.join('.')];
    if (!curveId) throw new Error('unknown curve ' + priv.curve.join('.'));
    var curve = new EC(curveId);
    var key = curve.keyFromPrivate(priv.privateKey);
    var out = key.sign(hash);
    return Buffer.from(out.toDER());
}
function dsaSign(hash, priv, algo) {
    var x = priv.params.priv_key;
    var p = priv.params.p;
    var q = priv.params.q;
    var g = priv.params.g;
    var r = new BN(0);
    var k;
    var H = bits2int(hash, q).mod(q);
    var s = false;
    var kv = getKey(x, q, hash, algo);
    while(s === false){
        k = makeKey(q, kv, algo);
        r = makeR(g, k, p, q);
        s = k.invm(q).imul(H.add(x.mul(r))).mod(q);
        if (s.cmpn(0) === 0) {
            s = false;
            r = new BN(0);
        }
    }
    return toDER(r, s);
}
function toDER(r, s) {
    r = r.toArray();
    s = s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    var total = r.length + s.length + 4;
    var res = [
        0x30,
        total,
        0x02,
        r.length
    ];
    res = res.concat(r, [
        0x02,
        s.length
    ], s);
    return Buffer.from(res);
}
function getKey(x, q, hash, algo) {
    x = Buffer.from(x.toArray());
    if (x.length < q.byteLength()) {
        var zeros = Buffer.alloc(q.byteLength() - x.length);
        x = Buffer.concat([
            zeros,
            x
        ]);
    }
    var hlen = hash.length;
    var hbits = bits2octets(hash, q);
    var v = Buffer.alloc(hlen);
    v.fill(1);
    var k = Buffer.alloc(hlen);
    k = createHmac(algo, k).update(v).update(Buffer.from([
        0
    ])).update(x).update(hbits).digest();
    v = createHmac(algo, k).update(v).digest();
    k = createHmac(algo, k).update(v).update(Buffer.from([
        1
    ])).update(x).update(hbits).digest();
    v = createHmac(algo, k).update(v).digest();
    return {
        k: k,
        v: v
    };
}
function bits2int(obits, q) {
    var bits = new BN(obits);
    var shift = (obits.length << 3) - q.bitLength();
    if (shift > 0) bits.ishrn(shift);
    return bits;
}
function bits2octets(bits, q) {
    bits = bits2int(bits, q);
    bits = bits.mod(q);
    var out = Buffer.from(bits.toArray());
    if (out.length < q.byteLength()) {
        var zeros = Buffer.alloc(q.byteLength() - out.length);
        out = Buffer.concat([
            zeros,
            out
        ]);
    }
    return out;
}
function makeKey(q, kv, algo) {
    var t;
    var k;
    do {
        t = Buffer.alloc(0);
        while(t.length * 8 < q.bitLength()){
            kv.v = createHmac(algo, kv.k).update(kv.v).digest();
            t = Buffer.concat([
                t,
                kv.v
            ]);
        }
        k = bits2int(t, q);
        kv.k = createHmac(algo, kv.k).update(kv.v).update(Buffer.from([
            0
        ])).digest();
        kv.v = createHmac(algo, kv.k).update(kv.v).digest();
    }while (k.cmp(q) !== -1);
    return k;
}
function makeR(g, k, p, q) {
    return g.toRed(BN.mont(p)).redPow(k).fromRed().mod(q);
}
module.exports = sign;
module.exports.getKey = getKey;
module.exports.makeKey = makeKey;

},{"6ae1d89b9934a98d":"1Yph5","a8da94153ecfc34b":"hOD8w","51cccb2c4d98daac":"kxPiZ","94cc3a287d70a03d":"djGmg","e83ac2526d8afeba":"cohIo","892f1603b4523d84":"4ddHc","d22eecc2600c2d97":"d1eQF"}],"kxPiZ":[function(require,module,exports,__globalThis) {
'use strict';
var BN = require("5d911a7c773081c");
var randomBytes = require("cfe4d67488897360");
var Buffer = require("c3cdabfc1104331b").Buffer;
function getr(priv) {
    var len = priv.modulus.byteLength();
    var r;
    do r = new BN(randomBytes(len));
    while (r.cmp(priv.modulus) >= 0 || !r.umod(priv.prime1) || !r.umod(priv.prime2));
    return r;
}
function blind(priv) {
    var r = getr(priv);
    var blinder = r.toRed(BN.mont(priv.modulus)).redPow(new BN(priv.publicExponent)).fromRed();
    return {
        blinder: blinder,
        unblinder: r.invm(priv.modulus)
    };
}
function crt(msg, priv) {
    var blinds = blind(priv);
    var len = priv.modulus.byteLength();
    var blinded = new BN(msg).mul(blinds.blinder).umod(priv.modulus);
    var c1 = blinded.toRed(BN.mont(priv.prime1));
    var c2 = blinded.toRed(BN.mont(priv.prime2));
    var qinv = priv.coefficient;
    var p = priv.prime1;
    var q = priv.prime2;
    var m1 = c1.redPow(priv.exponent1).fromRed();
    var m2 = c2.redPow(priv.exponent2).fromRed();
    var h = m1.isub(m2).imul(qinv).umod(p).imul(q);
    return m2.iadd(h).imul(blinds.unblinder).umod(priv.modulus).toArrayLike(Buffer, 'be', len);
}
crt.getr = getr;
module.exports = crt;

},{"5d911a7c773081c":"cohIo","cfe4d67488897360":"jXr3f","c3cdabfc1104331b":"1Yph5"}],"cohIo":[function(require,module,exports,__globalThis) {
(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = require("bd440367abe2ded7").Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, 'Invalid character in ' + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, 'Invalid character');
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== 'undefined' && typeof Symbol.for === 'function') try {
        BN.prototype[Symbol.for('nodejs.util.inspect.custom')] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === 'le' ? 'LE' : 'BE';
        this['_toArrayLike' + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) {
            this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
            i++;
        }
        // Clear words above the requested width so the result stays below 2 ** width
        for(; i < this.length; i++)this.words[i] = 0;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        if (num === 0) {
            this.length = 1;
            this._normSign();
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.mod.abs();
        var half = num.abs().iushrn(1);
        var r2 = num.words[0] & 1;
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up, away from zero
        var up = new BN(1);
        up.negative = this.negative ^ num.negative;
        return dm.div.iadd(up);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

},{"bd440367abe2ded7":"4TE4R"}],"djGmg":[function(require,module,exports,__globalThis) {
'use strict';
var elliptic = exports;
elliptic.version = require("e6672bc3ba1c9961").version;
elliptic.utils = require("5bc72f89931ad0f5");
elliptic.rand = require("7f90d752a36f35cf");
elliptic.curve = require("d11da69c91421223");
elliptic.curves = require("6845bad4ed92c3e4");
// Protocols
elliptic.ec = require("b5f2e1f615acc4b");
elliptic.eddsa = require("79ae761761517980");

},{"e6672bc3ba1c9961":"d25Oj","5bc72f89931ad0f5":"6D83a","7f90d752a36f35cf":"eefBI","d11da69c91421223":"esRb3","6845bad4ed92c3e4":"jfEPU","b5f2e1f615acc4b":"dPpl0","79ae761761517980":"lBLCy"}],"d25Oj":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"name\":\"elliptic\",\"version\":\"6.6.1\",\"description\":\"EC cryptography\",\"main\":\"lib/elliptic.js\",\"files\":[\"lib\"],\"scripts\":{\"lint\":\"eslint lib test\",\"lint:fix\":\"npm run lint -- --fix\",\"unit\":\"istanbul test _mocha --reporter=spec test/index.js\",\"test\":\"npm run lint && npm run unit\",\"version\":\"grunt dist && git add dist/\"},\"repository\":{\"type\":\"git\",\"url\":\"git@github.com:indutny/elliptic\"},\"keywords\":[\"EC\",\"Elliptic\",\"curve\",\"Cryptography\"],\"author\":\"Fedor Indutny <fedor@indutny.com>\",\"license\":\"MIT\",\"bugs\":{\"url\":\"https://github.com/indutny/elliptic/issues\"},\"homepage\":\"https://github.com/indutny/elliptic\",\"devDependencies\":{\"brfs\":\"^2.0.2\",\"coveralls\":\"^3.1.0\",\"eslint\":\"^7.6.0\",\"grunt\":\"^1.2.1\",\"grunt-browserify\":\"^5.3.0\",\"grunt-cli\":\"^1.3.2\",\"grunt-contrib-connect\":\"^3.0.0\",\"grunt-contrib-copy\":\"^1.0.0\",\"grunt-contrib-uglify\":\"^5.0.0\",\"grunt-mocha-istanbul\":\"^5.0.2\",\"grunt-saucelabs\":\"^9.0.1\",\"istanbul\":\"^0.4.5\",\"mocha\":\"^8.0.1\"},\"dependencies\":{\"bn.js\":\"^4.11.9\",\"brorand\":\"^1.1.0\",\"hash.js\":\"^1.0.0\",\"hmac-drbg\":\"^1.0.1\",\"inherits\":\"^2.0.4\",\"minimalistic-assert\":\"^1.0.1\",\"minimalistic-crypto-utils\":\"^1.0.1\"}}");

},{}],"6D83a":[function(require,module,exports,__globalThis) {
'use strict';
var utils = exports;
var BN = require("f4cbcf6f6eb25ca0");
var minAssert = require("d8ee30463f95a0fd");
var minUtils = require("997429d6bbd82d59");
utils.assert = minAssert;
utils.toArray = minUtils.toArray;
utils.zero2 = minUtils.zero2;
utils.toHex = minUtils.toHex;
utils.encode = minUtils.encode;
// Represent num in a w-NAF form
function getNAF(num, w, bits) {
    var naf = new Array(Math.max(num.bitLength(), bits) + 1);
    var i;
    for(i = 0; i < naf.length; i += 1)naf[i] = 0;
    var ws = 1 << w + 1;
    var k = num.clone();
    for(i = 0; i < naf.length; i++){
        var z;
        var mod = k.andln(ws - 1);
        if (k.isOdd()) {
            if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
            else z = mod;
            k.isubn(z);
        } else z = 0;
        naf[i] = z;
        k.iushrn(1);
    }
    return naf;
}
utils.getNAF = getNAF;
// Represent k1, k2 in a Joint Sparse Form
function getJSF(k1, k2) {
    var jsf = [
        [],
        []
    ];
    k1 = k1.clone();
    k2 = k2.clone();
    var d1 = 0;
    var d2 = 0;
    var m8;
    while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
        // First phase
        var m14 = k1.andln(3) + d1 & 3;
        var m24 = k2.andln(3) + d2 & 3;
        if (m14 === 3) m14 = -1;
        if (m24 === 3) m24 = -1;
        var u1;
        if ((m14 & 1) === 0) u1 = 0;
        else {
            m8 = k1.andln(7) + d1 & 7;
            if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
            else u1 = m14;
        }
        jsf[0].push(u1);
        var u2;
        if ((m24 & 1) === 0) u2 = 0;
        else {
            m8 = k2.andln(7) + d2 & 7;
            if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
            else u2 = m24;
        }
        jsf[1].push(u2);
        // Second phase
        if (2 * d1 === u1 + 1) d1 = 1 - d1;
        if (2 * d2 === u2 + 1) d2 = 1 - d2;
        k1.iushrn(1);
        k2.iushrn(1);
    }
    return jsf;
}
utils.getJSF = getJSF;
function cachedProperty(obj, name, computer) {
    var key = '_' + name;
    obj.prototype[name] = function cachedProperty() {
        return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
    };
}
utils.cachedProperty = cachedProperty;
function parseBytes(bytes) {
    return typeof bytes === 'string' ? utils.toArray(bytes, 'hex') : bytes;
}
utils.parseBytes = parseBytes;
function intFromLE(bytes) {
    return new BN(bytes, 'hex', 'le');
}
utils.intFromLE = intFromLE;

},{"f4cbcf6f6eb25ca0":"2BT8j","d8ee30463f95a0fd":"kTSEF","997429d6bbd82d59":"LMeZ3"}],"2BT8j":[function(require,module,exports,__globalThis) {
(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = require("1cf9b8cfa268aab5").Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) {
            this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
            i++;
        }
        // Clear words above the requested width so the result stays below 2 ** width
        for(; i < this.length; i++)this.words[i] = 0;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        if (num === 0) {
            this.length = 1;
            this._normSign();
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.mod.abs();
        var half = num.abs().iushrn(1);
        var r2 = num.words[0] & 1;
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up, away from zero
        var up = new BN(1);
        up.negative = this.negative ^ num.negative;
        return dm.div.iadd(up);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

},{"1cf9b8cfa268aab5":"4TE4R"}],"LMeZ3":[function(require,module,exports,__globalThis) {
'use strict';
var utils = exports;
function toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg !== 'string') {
        for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
        return res;
    }
    if (enc === 'hex') {
        msg = msg.replace(/[^a-z0-9]+/ig, '');
        if (msg.length % 2 !== 0) msg = '0' + msg;
        for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
    } else for(var i = 0; i < msg.length; i++){
        var c = msg.charCodeAt(i);
        var hi = c >> 8;
        var lo = c & 0xff;
        if (hi) res.push(hi, lo);
        else res.push(lo);
    }
    return res;
}
utils.toArray = toArray;
function zero2(word) {
    if (word.length === 1) return '0' + word;
    else return word;
}
utils.zero2 = zero2;
function toHex(msg) {
    var res = '';
    for(var i = 0; i < msg.length; i++)res += zero2(msg[i].toString(16));
    return res;
}
utils.toHex = toHex;
utils.encode = function encode(arr, enc) {
    if (enc === 'hex') return toHex(arr);
    else return arr;
};

},{}],"esRb3":[function(require,module,exports,__globalThis) {
'use strict';
var curve = exports;
curve.base = require("59d486bd2037506a");
curve.short = require("eb37617ef6927580");
curve.mont = require("be9c662572da2183");
curve.edwards = require("60763dd06fe64e8d");

},{"59d486bd2037506a":"jmePl","eb37617ef6927580":"faLu2","be9c662572da2183":"7lnMe","60763dd06fe64e8d":"c02cO"}],"jmePl":[function(require,module,exports,__globalThis) {
'use strict';
var BN = require("70865a568c61cc60");
var utils = require("fb5111a3810a8235");
var getNAF = utils.getNAF;
var getJSF = utils.getJSF;
var assert = utils.assert;
function BaseCurve(type, conf) {
    this.type = type;
    this.p = new BN(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? BN.red(conf.prime) : BN.mont(this.p);
    // Useful for many curves
    this.zero = new BN(0).toRed(this.red);
    this.one = new BN(1).toRed(this.red);
    this.two = new BN(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new BN(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
module.exports = BaseCurve;
BaseCurve.prototype.point = function point() {
    throw new Error('Not implemented');
};
BaseCurve.prototype.validate = function validate() {
    throw new Error('Not implemented');
};
BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    assert(p.precomputed);
    var doubles = p._getDoubles();
    var naf = getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        assert(z !== 0);
        if (p.type === 'affine') {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === 'affine' ? acc.toP() : acc;
};
BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === 'affine') acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
BaseCurve.BasePoint = BasePoint;
BasePoint.prototype.eq = function eq() {
    throw new Error('Not implemented');
};
BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = utils.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) assert(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) assert(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error('Unknown point format');
};
BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray('be', len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray('be', len));
};
BasePoint.prototype.encode = function encode(enc, compact) {
    return utils.encode(this._encode(compact), enc);
};
BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};

},{"70865a568c61cc60":"2BT8j","fb5111a3810a8235":"6D83a"}],"faLu2":[function(require,module,exports,__globalThis) {
'use strict';
var utils = require("89f794ef417dc31c");
var BN = require("c314b0ac30b69c4a");
var inherits = require("6ac4d7c73f24ab9c");
var Base = require("6e622edb7498c94");
var assert = utils.assert;
function ShortCurve(conf) {
    Base.call(this, 'short', conf);
    this.a = new BN(conf.a, 16).toRed(this.red);
    this.b = new BN(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
inherits(ShortCurve, Base);
module.exports = ShortCurve;
ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new BN(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new BN(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new BN(vec.a, 16),
            b: new BN(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : BN.mont(num);
    var tinv = new BN(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new BN(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new BN(1);
    var y1 = new BN(0);
    var x2 = new BN(0);
    var y2 = new BN(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new BN(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error('invalid point');
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function Point(curve, x, y, isRed) {
    Base.BasePoint.call(this, curve, 'affine');
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new BN(x, 16);
        this.y = new BN(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
inherits(Point, Base.BasePoint);
ShortCurve.prototype.point = function point(x, y, isRed) {
    return new Point(this, x, y, isRed);
};
ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return Point.fromJSON(this, obj, red);
};
Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === 'string') obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' y: ' + this.y.fromRed().toString(16, 2) + '>';
};
Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
Point.prototype.mul = function mul(k) {
    k = new BN(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function JPoint(curve, x, y, z) {
    Base.BasePoint.call(this, curve, 'jacobian');
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new BN(0);
    } else {
        this.x = new BN(x, 16);
        this.y = new BN(y, 16);
        this.z = new BN(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
inherits(JPoint, Base.BasePoint);
ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new JPoint(this, x, y, z);
};
JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
JPoint.prototype.mul = function mul(k, kbase) {
    k = new BN(k, kbase);
    return this.curve._wnafMul(this, k);
};
JPoint.prototype.eq = function eq(p) {
    if (p.type === 'affine') return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC JPoint Infinity>';
    return '<EC JPoint x: ' + this.x.toString(16, 2) + ' y: ' + this.y.toString(16, 2) + ' z: ' + this.z.toString(16, 2) + '>';
};
JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};

},{"89f794ef417dc31c":"6D83a","c314b0ac30b69c4a":"2BT8j","6ac4d7c73f24ab9c":"dwCbX","6e622edb7498c94":"jmePl"}],"7lnMe":[function(require,module,exports,__globalThis) {
'use strict';
var BN = require("ebdf19f04f3ed250");
var inherits = require("cb5bb4841a749f68");
var Base = require("51280941230b3f98");
var utils = require("ea7949a80be00261");
function MontCurve(conf) {
    Base.call(this, 'mont', conf);
    this.a = new BN(conf.a, 16).toRed(this.red);
    this.b = new BN(conf.b, 16).toRed(this.red);
    this.i4 = new BN(4).toRed(this.red).redInvm();
    this.two = new BN(2).toRed(this.red);
    this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
inherits(MontCurve, Base);
module.exports = MontCurve;
MontCurve.prototype.validate = function validate(point) {
    var x = point.normalize().x;
    var x2 = x.redSqr();
    var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
    var y = rhs.redSqrt();
    return y.redSqr().cmp(rhs) === 0;
};
function Point(curve, x, z) {
    Base.BasePoint.call(this, curve, 'projective');
    if (x === null && z === null) {
        this.x = this.curve.one;
        this.z = this.curve.zero;
    } else {
        this.x = new BN(x, 16);
        this.z = new BN(z, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    }
}
inherits(Point, Base.BasePoint);
MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    return this.point(utils.toArray(bytes, enc), 1);
};
MontCurve.prototype.point = function point(x, z) {
    return new Point(this, x, z);
};
MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return Point.fromJSON(this, obj);
};
Point.prototype.precompute = function precompute() {
// No-op
};
Point.prototype._encode = function _encode() {
    return this.getX().toArray('be', this.curve.p.byteLength());
};
Point.fromJSON = function fromJSON(curve, obj) {
    return new Point(curve, obj[0], obj[1] || curve.one);
};
Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};
Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
Point.prototype.dbl = function dbl() {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
    // 2M + 2S + 4A
    // A = X1 + Z1
    var a = this.x.redAdd(this.z);
    // AA = A^2
    var aa = a.redSqr();
    // B = X1 - Z1
    var b = this.x.redSub(this.z);
    // BB = B^2
    var bb = b.redSqr();
    // C = AA - BB
    var c = aa.redSub(bb);
    // X3 = AA * BB
    var nx = aa.redMul(bb);
    // Z3 = C * (BB + A24 * C)
    var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
    return this.curve.point(nx, nz);
};
Point.prototype.add = function add() {
    throw new Error('Not supported on Montgomery curve');
};
Point.prototype.diffAdd = function diffAdd(p, diff) {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
    // 4M + 2S + 6A
    // A = X2 + Z2
    var a = this.x.redAdd(this.z);
    // B = X2 - Z2
    var b = this.x.redSub(this.z);
    // C = X3 + Z3
    var c = p.x.redAdd(p.z);
    // D = X3 - Z3
    var d = p.x.redSub(p.z);
    // DA = D * A
    var da = d.redMul(a);
    // CB = C * B
    var cb = c.redMul(b);
    // X5 = Z1 * (DA + CB)^2
    var nx = diff.z.redMul(da.redAdd(cb).redSqr());
    // Z5 = X1 * (DA - CB)^2
    var nz = diff.x.redMul(da.redISub(cb).redSqr());
    return this.curve.point(nx, nz);
};
Point.prototype.mul = function mul(k) {
    var t = k.clone();
    var a = this; // (N / 2) * Q + Q
    var b = this.curve.point(null, null); // (N / 2) * Q
    var c = this; // Q
    for(var bits = []; t.cmpn(0) !== 0; t.iushrn(1))bits.push(t.andln(1));
    for(var i = bits.length - 1; i >= 0; i--)if (bits[i] === 0) {
        // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
        a = a.diffAdd(b, c);
        // N * Q = 2 * ((N / 2) * Q + Q))
        b = b.dbl();
    } else {
        // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
        b = a.diffAdd(b, c);
        // N * Q + Q = 2 * ((N / 2) * Q + Q)
        a = a.dbl();
    }
    return b;
};
Point.prototype.mulAdd = function mulAdd() {
    throw new Error('Not supported on Montgomery curve');
};
Point.prototype.jumlAdd = function jumlAdd() {
    throw new Error('Not supported on Montgomery curve');
};
Point.prototype.eq = function eq(other) {
    return this.getX().cmp(other.getX()) === 0;
};
Point.prototype.normalize = function normalize() {
    this.x = this.x.redMul(this.z.redInvm());
    this.z = this.curve.one;
    return this;
};
Point.prototype.getX = function getX() {
    // Normalize coordinates
    this.normalize();
    return this.x.fromRed();
};

},{"ebdf19f04f3ed250":"2BT8j","cb5bb4841a749f68":"dwCbX","51280941230b3f98":"jmePl","ea7949a80be00261":"6D83a"}],"c02cO":[function(require,module,exports,__globalThis) {
'use strict';
var utils = require("7bd66a4710450b08");
var BN = require("ccef46dcf03d45c6");
var inherits = require("19937272cbe23c92");
var Base = require("108c8ead5f54502b");
var assert = utils.assert;
function EdwardsCurve(conf) {
    // NOTE: Important as we are creating point in Base.call()
    this.twisted = (conf.a | 0) !== 1;
    this.mOneA = this.twisted && (conf.a | 0) === -1;
    this.extended = this.mOneA;
    Base.call(this, 'edwards', conf);
    this.a = new BN(conf.a, 16).umod(this.red.m);
    this.a = this.a.toRed(this.red);
    this.c = new BN(conf.c, 16).toRed(this.red);
    this.c2 = this.c.redSqr();
    this.d = new BN(conf.d, 16).toRed(this.red);
    this.dd = this.d.redAdd(this.d);
    assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
    this.oneC = (conf.c | 0) === 1;
}
inherits(EdwardsCurve, Base);
module.exports = EdwardsCurve;
EdwardsCurve.prototype._mulA = function _mulA(num) {
    if (this.mOneA) return num.redNeg();
    else return this.a.redMul(num);
};
EdwardsCurve.prototype._mulC = function _mulC(num) {
    if (this.oneC) return num;
    else return this.c.redMul(num);
};
// Just for compatibility with Short curve
EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
    return this.point(x, y, z, t);
};
EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new BN(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var x2 = x.redSqr();
    var rhs = this.c2.redSub(this.a.redMul(x2));
    var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));
    var y2 = rhs.redMul(lhs.redInvm());
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error('invalid point');
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
    y = new BN(y, 16);
    if (!y.red) y = y.toRed(this.red);
    // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
    var y2 = y.redSqr();
    var lhs = y2.redSub(this.c2);
    var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
    var x2 = lhs.redMul(rhs.redInvm());
    if (x2.cmp(this.zero) === 0) {
        if (odd) throw new Error('invalid point');
        else return this.point(this.zero, y);
    }
    var x = x2.redSqrt();
    if (x.redSqr().redSub(x2).cmp(this.zero) !== 0) throw new Error('invalid point');
    if (x.fromRed().isOdd() !== odd) x = x.redNeg();
    return this.point(x, y);
};
EdwardsCurve.prototype.validate = function validate(point) {
    if (point.isInfinity()) return true;
    // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
    point.normalize();
    var x2 = point.x.redSqr();
    var y2 = point.y.redSqr();
    var lhs = x2.redMul(this.a).redAdd(y2);
    var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));
    return lhs.cmp(rhs) === 0;
};
function Point(curve, x, y, z, t) {
    Base.BasePoint.call(this, curve, 'projective');
    if (x === null && y === null && z === null) {
        this.x = this.curve.zero;
        this.y = this.curve.one;
        this.z = this.curve.one;
        this.t = this.curve.zero;
        this.zOne = true;
    } else {
        this.x = new BN(x, 16);
        this.y = new BN(y, 16);
        this.z = z ? new BN(z, 16) : this.curve.one;
        this.t = t && new BN(t, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
        if (this.t && !this.t.red) this.t = this.t.toRed(this.curve.red);
        this.zOne = this.z === this.curve.one;
        // Use extended coordinates
        if (this.curve.extended && !this.t) {
            this.t = this.x.redMul(this.y);
            if (!this.zOne) this.t = this.t.redMul(this.z.redInvm());
        }
    }
}
inherits(Point, Base.BasePoint);
EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return Point.fromJSON(this, obj);
};
EdwardsCurve.prototype.point = function point(x, y, z, t) {
    return new Point(this, x, y, z, t);
};
Point.fromJSON = function fromJSON(curve, obj) {
    return new Point(curve, obj[0], obj[1], obj[2]);
};
Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' y: ' + this.y.fromRed().toString(16, 2) + ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};
Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
};
Point.prototype._extDbl = function _extDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #doubling-dbl-2008-hwcd
    // 4M + 4S
    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = 2 * Z1^2
    var c = this.z.redSqr();
    c = c.redIAdd(c);
    // D = a * A
    var d = this.curve._mulA(a);
    // E = (X1 + Y1)^2 - A - B
    var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
    // G = D + B
    var g = d.redAdd(b);
    // F = G - C
    var f = g.redSub(c);
    // H = D - B
    var h = d.redSub(b);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
Point.prototype._projDbl = function _projDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #doubling-dbl-2008-bbjlp
    //     #doubling-dbl-2007-bl
    // and others
    // Generally 3M + 4S or 2M + 4S
    // B = (X1 + Y1)^2
    var b = this.x.redAdd(this.y).redSqr();
    // C = X1^2
    var c = this.x.redSqr();
    // D = Y1^2
    var d = this.y.redSqr();
    var nx;
    var ny;
    var nz;
    var e;
    var h;
    var j;
    if (this.curve.twisted) {
        // E = a * C
        e = this.curve._mulA(c);
        // F = E + D
        var f = e.redAdd(d);
        if (this.zOne) {
            // X3 = (B - C - D) * (F - 2)
            nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F^2 - 2 * F
            nz = f.redSqr().redSub(f).redSub(f);
        } else {
            // H = Z1^2
            h = this.z.redSqr();
            // J = F - 2 * H
            j = f.redSub(h).redISub(h);
            // X3 = (B-C-D)*J
            nx = b.redSub(c).redISub(d).redMul(j);
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F * J
            nz = f.redMul(j);
        }
    } else {
        // E = C + D
        e = c.redAdd(d);
        // H = (c * Z1)^2
        h = this.curve._mulC(this.z).redSqr();
        // J = E - 2 * H
        j = e.redSub(h).redSub(h);
        // X3 = c * (B - E) * J
        nx = this.curve._mulC(b.redISub(e)).redMul(j);
        // Y3 = c * E * (C - D)
        ny = this.curve._mulC(e).redMul(c.redISub(d));
        // Z3 = E * J
        nz = e.redMul(j);
    }
    return this.curve.point(nx, ny, nz);
};
Point.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    // Double in extended coordinates
    if (this.curve.extended) return this._extDbl();
    else return this._projDbl();
};
Point.prototype._extAdd = function _extAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #addition-add-2008-hwcd-3
    // 8M
    // A = (Y1 - X1) * (Y2 - X2)
    var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
    // B = (Y1 + X1) * (Y2 + X2)
    var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
    // C = T1 * k * T2
    var c = this.t.redMul(this.curve.dd).redMul(p.t);
    // D = Z1 * 2 * Z2
    var d = this.z.redMul(p.z.redAdd(p.z));
    // E = B - A
    var e = b.redSub(a);
    // F = D - C
    var f = d.redSub(c);
    // G = D + C
    var g = d.redAdd(c);
    // H = B + A
    var h = b.redAdd(a);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
Point.prototype._projAdd = function _projAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #addition-add-2008-bbjlp
    //     #addition-add-2007-bl
    // 10M + 1S
    // A = Z1 * Z2
    var a = this.z.redMul(p.z);
    // B = A^2
    var b = a.redSqr();
    // C = X1 * X2
    var c = this.x.redMul(p.x);
    // D = Y1 * Y2
    var d = this.y.redMul(p.y);
    // E = d * C * D
    var e = this.curve.d.redMul(c).redMul(d);
    // F = B - E
    var f = b.redSub(e);
    // G = B + E
    var g = b.redAdd(e);
    // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
    var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
    var nx = a.redMul(f).redMul(tmp);
    var ny;
    var nz;
    if (this.curve.twisted) {
        // Y3 = A * G * (D - a * C)
        ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
        // Z3 = F * G
        nz = f.redMul(g);
    } else {
        // Y3 = A * G * (D - C)
        ny = a.redMul(g).redMul(d.redSub(c));
        // Z3 = c * F * G
        nz = this.curve._mulC(f).redMul(g);
    }
    return this.curve.point(nx, ny, nz);
};
Point.prototype.add = function add(p) {
    if (this.isInfinity()) return p;
    if (p.isInfinity()) return this;
    if (this.curve.extended) return this._extAdd(p);
    else return this._projAdd(p);
};
Point.prototype.mul = function mul(k) {
    if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else return this.curve._wnafMul(this, k);
};
Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, false);
};
Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, true);
};
Point.prototype.normalize = function normalize() {
    if (this.zOne) return this;
    // Normalize coordinates
    var zi = this.z.redInvm();
    this.x = this.x.redMul(zi);
    this.y = this.y.redMul(zi);
    if (this.t) this.t = this.t.redMul(zi);
    this.z = this.curve.one;
    this.zOne = true;
    return this;
};
Point.prototype.neg = function neg() {
    return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
};
Point.prototype.getX = function getX() {
    this.normalize();
    return this.x.fromRed();
};
Point.prototype.getY = function getY() {
    this.normalize();
    return this.y.fromRed();
};
Point.prototype.eq = function eq(other) {
    return this === other || this.getX().cmp(other.getX()) === 0 && this.getY().cmp(other.getY()) === 0;
};
Point.prototype.eqXToP = function eqXToP(x) {
    var rx = x.toRed(this.curve.red).redMul(this.z);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(this.z);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
// Compatibility with BaseCurve
Point.prototype.toP = Point.prototype.normalize;
Point.prototype.mixedAdd = Point.prototype.add;

},{"7bd66a4710450b08":"6D83a","ccef46dcf03d45c6":"2BT8j","19937272cbe23c92":"dwCbX","108c8ead5f54502b":"jmePl"}],"jfEPU":[function(require,module,exports,__globalThis) {
'use strict';
var curves = exports;
var hash = require("1c9db357c0845afa");
var curve = require("47ec78745540f875");
var utils = require("e30b16e4a47a5405");
var assert = utils.assert;
function PresetCurve(options) {
    if (options.type === 'short') this.curve = new curve.short(options);
    else if (options.type === 'edwards') this.curve = new curve.edwards(options);
    else this.curve = new curve.mont(options);
    this.g = this.curve.g;
    this.n = this.curve.n;
    this.hash = options.hash;
    assert(this.g.validate(), 'Invalid curve');
    assert(this.g.mul(this.n).isInfinity(), 'Invalid curve, G*N != O');
}
curves.PresetCurve = PresetCurve;
function defineCurve(name, options) {
    Object.defineProperty(curves, name, {
        configurable: true,
        enumerable: true,
        get: function() {
            var curve = new PresetCurve(options);
            Object.defineProperty(curves, name, {
                configurable: true,
                enumerable: true,
                value: curve
            });
            return curve;
        }
    });
}
defineCurve('p192', {
    type: 'short',
    prime: 'p192',
    p: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff',
    a: 'ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc',
    b: '64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1',
    n: 'ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831',
    hash: hash.sha256,
    gRed: false,
    g: [
        '188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012',
        '07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811'
    ]
});
defineCurve('p224', {
    type: 'short',
    prime: 'p224',
    p: 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001',
    a: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe',
    b: 'b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4',
    n: 'ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d',
    hash: hash.sha256,
    gRed: false,
    g: [
        'b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21',
        'bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34'
    ]
});
defineCurve('p256', {
    type: 'short',
    prime: null,
    p: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff',
    a: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc',
    b: '5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b',
    n: 'ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551',
    hash: hash.sha256,
    gRed: false,
    g: [
        '6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296',
        '4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5'
    ]
});
defineCurve('p384', {
    type: 'short',
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: hash.sha384,
    gRed: false,
    g: [
        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
    ]
});
defineCurve('p521', {
    type: 'short',
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: hash.sha512,
    gRed: false,
    g: [
        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
    ]
});
defineCurve('curve25519', {
    type: 'mont',
    prime: 'p25519',
    p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
    a: '76d06',
    b: '1',
    n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
    hash: hash.sha256,
    gRed: false,
    g: [
        '9'
    ]
});
defineCurve('ed25519', {
    type: 'edwards',
    prime: 'p25519',
    p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
    a: '-1',
    c: '1',
    // -121665 * (121666^(-1)) (mod P)
    d: '52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3',
    n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
    hash: hash.sha256,
    gRed: false,
    g: [
        '216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a',
        // 4/5
        '6666666666666666666666666666666666666666666666666666666666666658'
    ]
});
var pre;
try {
    pre = require("9eada5f7049e7dfd");
} catch (e) {
    pre = undefined;
}
defineCurve('secp256k1', {
    type: 'short',
    prime: 'k256',
    p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f',
    a: '0',
    b: '7',
    n: 'ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141',
    h: '1',
    hash: hash.sha256,
    // Precomputed endomorphism
    beta: '7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee',
    lambda: '5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72',
    basis: [
        {
            a: '3086d221a7d46bcde86c90e49284eb15',
            b: '-e4437ed6010e88286f547fa90abfe4c3'
        },
        {
            a: '114ca50f7a8e2f3f657c1108d9d44cfd8',
            b: '3086d221a7d46bcde86c90e49284eb15'
        }
    ],
    gRed: false,
    g: [
        '79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798',
        '483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8',
        pre
    ]
});

},{"1c9db357c0845afa":"aS0HP","47ec78745540f875":"esRb3","e30b16e4a47a5405":"6D83a","9eada5f7049e7dfd":"iGTC2"}],"aS0HP":[function(require,module,exports,__globalThis) {
var hash = exports;
hash.utils = require("38593959f18bd562");
hash.common = require("31a457752237e8ad");
hash.sha = require("3e37816d2a2fd68d");
hash.ripemd = require("ce5a13b5bd10f171");
hash.hmac = require("c32fbac97a361580");
// Proxy hash functions to the main object
hash.sha1 = hash.sha.sha1;
hash.sha256 = hash.sha.sha256;
hash.sha224 = hash.sha.sha224;
hash.sha384 = hash.sha.sha384;
hash.sha512 = hash.sha.sha512;
hash.ripemd160 = hash.ripemd.ripemd160;

},{"38593959f18bd562":"bpBY3","31a457752237e8ad":"dw3hz","3e37816d2a2fd68d":"22Ii5","ce5a13b5bd10f171":"HYmJG","c32fbac97a361580":"eiOyv"}],"bpBY3":[function(require,module,exports,__globalThis) {
'use strict';
var assert = require("6002b0feade022a4");
var inherits = require("d4826c9d0ff1b1f");
exports.inherits = inherits;
function isSurrogatePair(msg, i) {
    if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) return false;
    if (i < 0 || i + 1 >= msg.length) return false;
    return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}
function toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg === 'string') {
        if (!enc) {
            // Inspired by stringToUtf8ByteArray() in closure-library by Google
            // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
            // Apache License 2.0
            // https://github.com/google/closure-library/blob/master/LICENSE
            var p = 0;
            for(var i = 0; i < msg.length; i++){
                var c = msg.charCodeAt(i);
                if (c < 128) res[p++] = c;
                else if (c < 2048) {
                    res[p++] = c >> 6 | 192;
                    res[p++] = c & 63 | 128;
                } else if (isSurrogatePair(msg, i)) {
                    c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
                    res[p++] = c >> 18 | 240;
                    res[p++] = c >> 12 & 63 | 128;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                } else {
                    res[p++] = c >> 12 | 224;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                }
            }
        } else if (enc === 'hex') {
            msg = msg.replace(/[^a-z0-9]+/ig, '');
            if (msg.length % 2 !== 0) msg = '0' + msg;
            for(i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        }
    } else for(i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
    return res;
}
exports.toArray = toArray;
function toHex(msg) {
    var res = '';
    for(var i = 0; i < msg.length; i++)res += zero2(msg[i].toString(16));
    return res;
}
exports.toHex = toHex;
function htonl(w) {
    var res = w >>> 24 | w >>> 8 & 0xff00 | w << 8 & 0xff0000 | (w & 0xff) << 24;
    return res >>> 0;
}
exports.htonl = htonl;
function toHex32(msg, endian) {
    var res = '';
    for(var i = 0; i < msg.length; i++){
        var w = msg[i];
        if (endian === 'little') w = htonl(w);
        res += zero8(w.toString(16));
    }
    return res;
}
exports.toHex32 = toHex32;
function zero2(word) {
    if (word.length === 1) return '0' + word;
    else return word;
}
exports.zero2 = zero2;
function zero8(word) {
    if (word.length === 7) return '0' + word;
    else if (word.length === 6) return '00' + word;
    else if (word.length === 5) return '000' + word;
    else if (word.length === 4) return '0000' + word;
    else if (word.length === 3) return '00000' + word;
    else if (word.length === 2) return '000000' + word;
    else if (word.length === 1) return '0000000' + word;
    else return word;
}
exports.zero8 = zero8;
function join32(msg, start, end, endian) {
    var len = end - start;
    assert(len % 4 === 0);
    var res = new Array(len / 4);
    for(var i = 0, k = start; i < res.length; i++, k += 4){
        var w;
        if (endian === 'big') w = msg[k] << 24 | msg[k + 1] << 16 | msg[k + 2] << 8 | msg[k + 3];
        else w = msg[k + 3] << 24 | msg[k + 2] << 16 | msg[k + 1] << 8 | msg[k];
        res[i] = w >>> 0;
    }
    return res;
}
exports.join32 = join32;
function split32(msg, endian) {
    var res = new Array(msg.length * 4);
    for(var i = 0, k = 0; i < msg.length; i++, k += 4){
        var m = msg[i];
        if (endian === 'big') {
            res[k] = m >>> 24;
            res[k + 1] = m >>> 16 & 0xff;
            res[k + 2] = m >>> 8 & 0xff;
            res[k + 3] = m & 0xff;
        } else {
            res[k + 3] = m >>> 24;
            res[k + 2] = m >>> 16 & 0xff;
            res[k + 1] = m >>> 8 & 0xff;
            res[k] = m & 0xff;
        }
    }
    return res;
}
exports.split32 = split32;
function rotr32(w, b) {
    return w >>> b | w << 32 - b;
}
exports.rotr32 = rotr32;
function rotl32(w, b) {
    return w << b | w >>> 32 - b;
}
exports.rotl32 = rotl32;
function sum32(a, b) {
    return a + b >>> 0;
}
exports.sum32 = sum32;
function sum32_3(a, b, c) {
    return a + b + c >>> 0;
}
exports.sum32_3 = sum32_3;
function sum32_4(a, b, c, d) {
    return a + b + c + d >>> 0;
}
exports.sum32_4 = sum32_4;
function sum32_5(a, b, c, d, e) {
    return a + b + c + d + e >>> 0;
}
exports.sum32_5 = sum32_5;
function sum64(buf, pos, ah, al) {
    var bh = buf[pos];
    var bl = buf[pos + 1];
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    buf[pos] = hi >>> 0;
    buf[pos + 1] = lo;
}
exports.sum64 = sum64;
function sum64_hi(ah, al, bh, bl) {
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    return hi >>> 0;
}
exports.sum64_hi = sum64_hi;
function sum64_lo(ah, al, bh, bl) {
    var lo = al + bl;
    return lo >>> 0;
}
exports.sum64_lo = sum64_lo;
function sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    var hi = ah + bh + ch + dh + carry;
    return hi >>> 0;
}
exports.sum64_4_hi = sum64_4_hi;
function sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
    var lo = al + bl + cl + dl;
    return lo >>> 0;
}
exports.sum64_4_lo = sum64_4_lo;
function sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    lo = lo + el >>> 0;
    carry += lo < el ? 1 : 0;
    var hi = ah + bh + ch + dh + eh + carry;
    return hi >>> 0;
}
exports.sum64_5_hi = sum64_5_hi;
function sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var lo = al + bl + cl + dl + el;
    return lo >>> 0;
}
exports.sum64_5_lo = sum64_5_lo;
function rotr64_hi(ah, al, num) {
    var r = al << 32 - num | ah >>> num;
    return r >>> 0;
}
exports.rotr64_hi = rotr64_hi;
function rotr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
exports.rotr64_lo = rotr64_lo;
function shr64_hi(ah, al, num) {
    return ah >>> num;
}
exports.shr64_hi = shr64_hi;
function shr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
exports.shr64_lo = shr64_lo;

},{"6002b0feade022a4":"kTSEF","d4826c9d0ff1b1f":"dwCbX"}],"dw3hz":[function(require,module,exports,__globalThis) {
'use strict';
var utils = require("e9291abdfb47ee4f");
var assert = require("ea8841b701712638");
function BlockHash() {
    this.pending = null;
    this.pendingTotal = 0;
    this.blockSize = this.constructor.blockSize;
    this.outSize = this.constructor.outSize;
    this.hmacStrength = this.constructor.hmacStrength;
    this.padLength = this.constructor.padLength / 8;
    this.endian = 'big';
    this._delta8 = this.blockSize / 8;
    this._delta32 = this.blockSize / 32;
}
exports.BlockHash = BlockHash;
BlockHash.prototype.update = function update(msg, enc) {
    // Convert message to array, pad it, and join into 32bit blocks
    msg = utils.toArray(msg, enc);
    if (!this.pending) this.pending = msg;
    else this.pending = this.pending.concat(msg);
    this.pendingTotal += msg.length;
    // Enough data, try updating
    if (this.pending.length >= this._delta8) {
        msg = this.pending;
        // Process pending data in blocks
        var r = msg.length % this._delta8;
        this.pending = msg.slice(msg.length - r, msg.length);
        if (this.pending.length === 0) this.pending = null;
        msg = utils.join32(msg, 0, msg.length - r, this.endian);
        for(var i = 0; i < msg.length; i += this._delta32)this._update(msg, i, i + this._delta32);
    }
    return this;
};
BlockHash.prototype.digest = function digest(enc) {
    this.update(this._pad());
    assert(this.pending === null);
    return this._digest(enc);
};
BlockHash.prototype._pad = function pad() {
    var len = this.pendingTotal;
    var bytes = this._delta8;
    var k = bytes - (len + this.padLength) % bytes;
    var res = new Array(k + this.padLength);
    res[0] = 0x80;
    for(var i = 1; i < k; i++)res[i] = 0;
    // Append length
    len <<= 3;
    if (this.endian === 'big') {
        for(var t = 8; t < this.padLength; t++)res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len & 0xff;
    } else {
        res[i++] = len & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        for(t = 8; t < this.padLength; t++)res[i++] = 0;
    }
    return res;
};

},{"e9291abdfb47ee4f":"bpBY3","ea8841b701712638":"kTSEF"}],"22Ii5":[function(require,module,exports,__globalThis) {
'use strict';
exports.sha1 = require("3835379564860fd7");
exports.sha224 = require("bb9f72f042233648");
exports.sha256 = require("20a3b0fa42e37dfe");
exports.sha384 = require("ad4827efa7d953c2");
exports.sha512 = require("301292595a944c1d");

},{"3835379564860fd7":"3rfGw","bb9f72f042233648":"bhdbq","20a3b0fa42e37dfe":"iTpvM","ad4827efa7d953c2":"jZX8U","301292595a944c1d":"2AfnD"}],"3rfGw":[function(require,module,exports,__globalThis) {
'use strict';
var utils = require("b75f3c1442bf9100");
var common = require("a29e68029e4c48f8");
var shaCommon = require("1be62f90a237cba5");
var rotl32 = utils.rotl32;
var sum32 = utils.sum32;
var sum32_5 = utils.sum32_5;
var ft_1 = shaCommon.ft_1;
var BlockHash = common.BlockHash;
var sha1_K = [
    0x5A827999,
    0x6ED9EBA1,
    0x8F1BBCDC,
    0xCA62C1D6
];
function SHA1() {
    if (!(this instanceof SHA1)) return new SHA1();
    BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.W = new Array(80);
}
utils.inherits(SHA1, BlockHash);
module.exports = SHA1;
SHA1.blockSize = 512;
SHA1.outSize = 160;
SHA1.hmacStrength = 80;
SHA1.padLength = 64;
SHA1.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    for(i = 0; i < W.length; i++){
        var s = ~~(i / 20);
        var t = sum32_5(rotl32(a, 5), ft_1(s, b, c, d), e, W[i], sha1_K[s]);
        e = d;
        d = c;
        c = rotl32(b, 30);
        b = a;
        a = t;
    }
    this.h[0] = sum32(this.h[0], a);
    this.h[1] = sum32(this.h[1], b);
    this.h[2] = sum32(this.h[2], c);
    this.h[3] = sum32(this.h[3], d);
    this.h[4] = sum32(this.h[4], e);
};
SHA1.prototype._digest = function digest(enc) {
    if (enc === 'hex') return utils.toHex32(this.h, 'big');
    else return utils.split32(this.h, 'big');
};

},{"b75f3c1442bf9100":"bpBY3","a29e68029e4c48f8":"dw3hz","1be62f90a237cba5":"25bPt"}],"25bPt":[function(require,module,exports,__globalThis) {
'use strict';
var utils = require("f0fb61f828bacd0f");
var rotr32 = utils.rotr32;
function ft_1(s, x, y, z) {
    if (s === 0) return ch32(x, y, z);
    if (s === 1 || s === 3) return p32(x, y, z);
    if (s === 2) return maj32(x, y, z);
}
exports.ft_1 = ft_1;
function ch32(x, y, z) {
    return x & y ^ ~x & z;
}
exports.ch32 = ch32;
function maj32(x, y, z) {
    return x & y ^ x & z ^ y & z;
}
exports.maj32 = maj32;
function p32(x, y, z) {
    return x ^ y ^ z;
}
exports.p32 = p32;
function s0_256(x) {
    return rotr32(x, 2) ^ rotr32(x, 13) ^ rotr32(x, 22);
}
exports.s0_256 = s0_256;
function s1_256(x) {
    return rotr32(x, 6) ^ rotr32(x, 11) ^ rotr32(x, 25);
}
exports.s1_256 = s1_256;
function g0_256(x) {
    return rotr32(x, 7) ^ rotr32(x, 18) ^ x >>> 3;
}
exports.g0_256 = g0_256;
function g1_256(x) {
    return rotr32(x, 17) ^ rotr32(x, 19) ^ x >>> 10;
}
exports.g1_256 = g1_256;

},{"f0fb61f828bacd0f":"bpBY3"}],"bhdbq":[function(require,module,exports,__globalThis) {
'use strict';
var utils = require("fe5acd040463c159");
var SHA256 = require("fa3503eda3738d05");
function SHA224() {
    if (!(this instanceof SHA224)) return new SHA224();
    SHA256.call(this);
    this.h = [
        0xc1059ed8,
        0x367cd507,
        0x3070dd17,
        0xf70e5939,
        0xffc00b31,
        0x68581511,
        0x64f98fa7,
        0xbefa4fa4
    ];
}
utils.inherits(SHA224, SHA256);
module.exports = SHA224;
SHA224.blockSize = 512;
SHA224.outSize = 224;
SHA224.hmacStrength = 192;
SHA224.padLength = 64;
SHA224.prototype._digest = function digest(enc) {
    // Just truncate output
    if (enc === 'hex') return utils.toHex32(this.h.slice(0, 7), 'big');
    else return utils.split32(this.h.slice(0, 7), 'big');
};

},{"fe5acd040463c159":"bpBY3","fa3503eda3738d05":"iTpvM"}],"iTpvM":[function(require,module,exports,__globalThis) {
'use strict';
var utils = require("32ad3e510bd41f2a");
var common = require("469ad88ad505772a");
var shaCommon = require("fffa7d1ddf1f0b43");
var assert = require("126369f57b5225ed");
var sum32 = utils.sum32;
var sum32_4 = utils.sum32_4;
var sum32_5 = utils.sum32_5;
var ch32 = shaCommon.ch32;
var maj32 = shaCommon.maj32;
var s0_256 = shaCommon.s0_256;
var s1_256 = shaCommon.s1_256;
var g0_256 = shaCommon.g0_256;
var g1_256 = shaCommon.g1_256;
var BlockHash = common.BlockHash;
var sha256_K = [
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
];
function SHA256() {
    if (!(this instanceof SHA256)) return new SHA256();
    BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xbb67ae85,
        0x3c6ef372,
        0xa54ff53a,
        0x510e527f,
        0x9b05688c,
        0x1f83d9ab,
        0x5be0cd19
    ];
    this.k = sha256_K;
    this.W = new Array(64);
}
utils.inherits(SHA256, BlockHash);
module.exports = SHA256;
SHA256.blockSize = 512;
SHA256.outSize = 256;
SHA256.hmacStrength = 192;
SHA256.padLength = 64;
SHA256.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = sum32_4(g1_256(W[i - 2]), W[i - 7], g0_256(W[i - 15]), W[i - 16]);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    var f = this.h[5];
    var g = this.h[6];
    var h = this.h[7];
    assert(this.k.length === W.length);
    for(i = 0; i < W.length; i++){
        var T1 = sum32_5(h, s1_256(e), ch32(e, f, g), this.k[i], W[i]);
        var T2 = sum32(s0_256(a), maj32(a, b, c));
        h = g;
        g = f;
        f = e;
        e = sum32(d, T1);
        d = c;
        c = b;
        b = a;
        a = sum32(T1, T2);
    }
    this.h[0] = sum32(this.h[0], a);
    this.h[1] = sum32(this.h[1], b);
    this.h[2] = sum32(this.h[2], c);
    this.h[3] = sum32(this.h[3], d);
    this.h[4] = sum32(this.h[4], e);
    this.h[5] = sum32(this.h[5], f);
    this.h[6] = sum32(this.h[6], g);
    this.h[7] = sum32(this.h[7], h);
};
SHA256.prototype._digest = function digest(enc) {
    if (enc === 'hex') return utils.toHex32(this.h, 'big');
    else return utils.split32(this.h, 'big');
};

},{"32ad3e510bd41f2a":"bpBY3","469ad88ad505772a":"dw3hz","fffa7d1ddf1f0b43":"25bPt","126369f57b5225ed":"kTSEF"}],"jZX8U":[function(require,module,exports,__globalThis) {
'use strict';
var utils = require("a696ee34c45713da");
var SHA512 = require("fff95253fdaa49ea");
function SHA384() {
    if (!(this instanceof SHA384)) return new SHA384();
    SHA512.call(this);
    this.h = [
        0xcbbb9d5d,
        0xc1059ed8,
        0x629a292a,
        0x367cd507,
        0x9159015a,
        0x3070dd17,
        0x152fecd8,
        0xf70e5939,
        0x67332667,
        0xffc00b31,
        0x8eb44a87,
        0x68581511,
        0xdb0c2e0d,
        0x64f98fa7,
        0x47b5481d,
        0xbefa4fa4
    ];
}
utils.inherits(SHA384, SHA512);
module.exports = SHA384;
SHA384.blockSize = 1024;
SHA384.outSize = 384;
SHA384.hmacStrength = 192;
SHA384.padLength = 128;
SHA384.prototype._digest = function digest(enc) {
    if (enc === 'hex') return utils.toHex32(this.h.slice(0, 12), 'big');
    else return utils.split32(this.h.slice(0, 12), 'big');
};

},{"a696ee34c45713da":"bpBY3","fff95253fdaa49ea":"2AfnD"}],"2AfnD":[function(require,module,exports,__globalThis) {
'use strict';
var utils = require("7753b1fa702fbb54");
var common = require("81b6970d75627ce1");
var assert = require("f660976cede694e2");
var rotr64_hi = utils.rotr64_hi;
var rotr64_lo = utils.rotr64_lo;
var shr64_hi = utils.shr64_hi;
var shr64_lo = utils.shr64_lo;
var sum64 = utils.sum64;
var sum64_hi = utils.sum64_hi;
var sum64_lo = utils.sum64_lo;
var sum64_4_hi = utils.sum64_4_hi;
var sum64_4_lo = utils.sum64_4_lo;
var sum64_5_hi = utils.sum64_5_hi;
var sum64_5_lo = utils.sum64_5_lo;
var BlockHash = common.BlockHash;
var sha512_K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
function SHA512() {
    if (!(this instanceof SHA512)) return new SHA512();
    BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xf3bcc908,
        0xbb67ae85,
        0x84caa73b,
        0x3c6ef372,
        0xfe94f82b,
        0xa54ff53a,
        0x5f1d36f1,
        0x510e527f,
        0xade682d1,
        0x9b05688c,
        0x2b3e6c1f,
        0x1f83d9ab,
        0xfb41bd6b,
        0x5be0cd19,
        0x137e2179
    ];
    this.k = sha512_K;
    this.W = new Array(160);
}
utils.inherits(SHA512, BlockHash);
module.exports = SHA512;
SHA512.blockSize = 1024;
SHA512.outSize = 512;
SHA512.hmacStrength = 192;
SHA512.padLength = 128;
SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
    var W = this.W;
    // 32 x 32bit words
    for(var i = 0; i < 32; i++)W[i] = msg[start + i];
    for(; i < W.length; i += 2){
        var c0_hi = g1_512_hi(W[i - 4], W[i - 3]); // i - 2
        var c0_lo = g1_512_lo(W[i - 4], W[i - 3]);
        var c1_hi = W[i - 14]; // i - 7
        var c1_lo = W[i - 13];
        var c2_hi = g0_512_hi(W[i - 30], W[i - 29]); // i - 15
        var c2_lo = g0_512_lo(W[i - 30], W[i - 29]);
        var c3_hi = W[i - 32]; // i - 16
        var c3_lo = W[i - 31];
        W[i] = sum64_4_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
        W[i + 1] = sum64_4_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
    }
};
SHA512.prototype._update = function _update(msg, start) {
    this._prepareBlock(msg, start);
    var W = this.W;
    var ah = this.h[0];
    var al = this.h[1];
    var bh = this.h[2];
    var bl = this.h[3];
    var ch = this.h[4];
    var cl = this.h[5];
    var dh = this.h[6];
    var dl = this.h[7];
    var eh = this.h[8];
    var el = this.h[9];
    var fh = this.h[10];
    var fl = this.h[11];
    var gh = this.h[12];
    var gl = this.h[13];
    var hh = this.h[14];
    var hl = this.h[15];
    assert(this.k.length === W.length);
    for(var i = 0; i < W.length; i += 2){
        var c0_hi = hh;
        var c0_lo = hl;
        var c1_hi = s1_512_hi(eh, el);
        var c1_lo = s1_512_lo(eh, el);
        var c2_hi = ch64_hi(eh, el, fh, fl, gh, gl);
        var c2_lo = ch64_lo(eh, el, fh, fl, gh, gl);
        var c3_hi = this.k[i];
        var c3_lo = this.k[i + 1];
        var c4_hi = W[i];
        var c4_lo = W[i + 1];
        var T1_hi = sum64_5_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        var T1_lo = sum64_5_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        c0_hi = s0_512_hi(ah, al);
        c0_lo = s0_512_lo(ah, al);
        c1_hi = maj64_hi(ah, al, bh, bl, ch, cl);
        c1_lo = maj64_lo(ah, al, bh, bl, ch, cl);
        var T2_hi = sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
        var T2_lo = sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        eh = sum64_hi(dh, dl, T1_hi, T1_lo);
        el = sum64_lo(dl, dl, T1_hi, T1_lo);
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        ah = sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
        al = sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
    }
    sum64(this.h, 0, ah, al);
    sum64(this.h, 2, bh, bl);
    sum64(this.h, 4, ch, cl);
    sum64(this.h, 6, dh, dl);
    sum64(this.h, 8, eh, el);
    sum64(this.h, 10, fh, fl);
    sum64(this.h, 12, gh, gl);
    sum64(this.h, 14, hh, hl);
};
SHA512.prototype._digest = function digest(enc) {
    if (enc === 'hex') return utils.toHex32(this.h, 'big');
    else return utils.split32(this.h, 'big');
};
function ch64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ ~xh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function ch64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ ~xl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function maj64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ xh & zh ^ yh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function maj64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ xl & zl ^ yl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function s0_512_hi(xh, xl) {
    var c0_hi = rotr64_hi(xh, xl, 28);
    var c1_hi = rotr64_hi(xl, xh, 2); // 34
    var c2_hi = rotr64_hi(xl, xh, 7); // 39
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function s0_512_lo(xh, xl) {
    var c0_lo = rotr64_lo(xh, xl, 28);
    var c1_lo = rotr64_lo(xl, xh, 2); // 34
    var c2_lo = rotr64_lo(xl, xh, 7); // 39
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function s1_512_hi(xh, xl) {
    var c0_hi = rotr64_hi(xh, xl, 14);
    var c1_hi = rotr64_hi(xh, xl, 18);
    var c2_hi = rotr64_hi(xl, xh, 9); // 41
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function s1_512_lo(xh, xl) {
    var c0_lo = rotr64_lo(xh, xl, 14);
    var c1_lo = rotr64_lo(xh, xl, 18);
    var c2_lo = rotr64_lo(xl, xh, 9); // 41
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function g0_512_hi(xh, xl) {
    var c0_hi = rotr64_hi(xh, xl, 1);
    var c1_hi = rotr64_hi(xh, xl, 8);
    var c2_hi = shr64_hi(xh, xl, 7);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function g0_512_lo(xh, xl) {
    var c0_lo = rotr64_lo(xh, xl, 1);
    var c1_lo = rotr64_lo(xh, xl, 8);
    var c2_lo = shr64_lo(xh, xl, 7);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function g1_512_hi(xh, xl) {
    var c0_hi = rotr64_hi(xh, xl, 19);
    var c1_hi = rotr64_hi(xl, xh, 29); // 61
    var c2_hi = shr64_hi(xh, xl, 6);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function g1_512_lo(xh, xl) {
    var c0_lo = rotr64_lo(xh, xl, 19);
    var c1_lo = rotr64_lo(xl, xh, 29); // 61
    var c2_lo = shr64_lo(xh, xl, 6);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}

},{"7753b1fa702fbb54":"bpBY3","81b6970d75627ce1":"dw3hz","f660976cede694e2":"kTSEF"}],"HYmJG":[function(require,module,exports,__globalThis) {
'use strict';
var utils = require("36495272d446418f");
var common = require("ad8cf0490e28e8d7");
var rotl32 = utils.rotl32;
var sum32 = utils.sum32;
var sum32_3 = utils.sum32_3;
var sum32_4 = utils.sum32_4;
var BlockHash = common.BlockHash;
function RIPEMD160() {
    if (!(this instanceof RIPEMD160)) return new RIPEMD160();
    BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.endian = 'little';
}
utils.inherits(RIPEMD160, BlockHash);
exports.ripemd160 = RIPEMD160;
RIPEMD160.blockSize = 512;
RIPEMD160.outSize = 160;
RIPEMD160.hmacStrength = 192;
RIPEMD160.padLength = 64;
RIPEMD160.prototype._update = function update(msg, start) {
    var A = this.h[0];
    var B = this.h[1];
    var C = this.h[2];
    var D = this.h[3];
    var E = this.h[4];
    var Ah = A;
    var Bh = B;
    var Ch = C;
    var Dh = D;
    var Eh = E;
    for(var j = 0; j < 80; j++){
        var T = sum32(rotl32(sum32_4(A, f(j, B, C, D), msg[r[j] + start], K(j)), s[j]), E);
        A = E;
        E = D;
        D = rotl32(C, 10);
        C = B;
        B = T;
        T = sum32(rotl32(sum32_4(Ah, f(79 - j, Bh, Ch, Dh), msg[rh[j] + start], Kh(j)), sh[j]), Eh);
        Ah = Eh;
        Eh = Dh;
        Dh = rotl32(Ch, 10);
        Ch = Bh;
        Bh = T;
    }
    T = sum32_3(this.h[1], C, Dh);
    this.h[1] = sum32_3(this.h[2], D, Eh);
    this.h[2] = sum32_3(this.h[3], E, Ah);
    this.h[3] = sum32_3(this.h[4], A, Bh);
    this.h[4] = sum32_3(this.h[0], B, Ch);
    this.h[0] = T;
};
RIPEMD160.prototype._digest = function digest(enc) {
    if (enc === 'hex') return utils.toHex32(this.h, 'little');
    else return utils.split32(this.h, 'little');
};
function f(j, x, y, z) {
    if (j <= 15) return x ^ y ^ z;
    else if (j <= 31) return x & y | ~x & z;
    else if (j <= 47) return (x | ~y) ^ z;
    else if (j <= 63) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
function K(j) {
    if (j <= 15) return 0x00000000;
    else if (j <= 31) return 0x5a827999;
    else if (j <= 47) return 0x6ed9eba1;
    else if (j <= 63) return 0x8f1bbcdc;
    else return 0xa953fd4e;
}
function Kh(j) {
    if (j <= 15) return 0x50a28be6;
    else if (j <= 31) return 0x5c4dd124;
    else if (j <= 47) return 0x6d703ef3;
    else if (j <= 63) return 0x7a6d76e9;
    else return 0x00000000;
}
var r = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var rh = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var s = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var sh = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];

},{"36495272d446418f":"bpBY3","ad8cf0490e28e8d7":"dw3hz"}],"eiOyv":[function(require,module,exports,__globalThis) {
'use strict';
var utils = require("596c08b6835a6e2d");
var assert = require("be527907d4f06808");
function Hmac(hash, key, enc) {
    if (!(this instanceof Hmac)) return new Hmac(hash, key, enc);
    this.Hash = hash;
    this.blockSize = hash.blockSize / 8;
    this.outSize = hash.outSize / 8;
    this.inner = null;
    this.outer = null;
    this._init(utils.toArray(key, enc));
}
module.exports = Hmac;
Hmac.prototype._init = function init(key) {
    // Shorten key, if needed
    if (key.length > this.blockSize) key = new this.Hash().update(key).digest();
    assert(key.length <= this.blockSize);
    // Add padding to key
    for(var i = key.length; i < this.blockSize; i++)key.push(0);
    for(i = 0; i < key.length; i++)key[i] ^= 0x36;
    this.inner = new this.Hash().update(key);
    // 0x36 ^ 0x5c = 0x6a
    for(i = 0; i < key.length; i++)key[i] ^= 0x6a;
    this.outer = new this.Hash().update(key);
};
Hmac.prototype.update = function update(msg, enc) {
    this.inner.update(msg, enc);
    return this;
};
Hmac.prototype.digest = function digest(enc) {
    this.outer.update(this.inner.digest());
    return this.outer.digest(enc);
};

},{"596c08b6835a6e2d":"bpBY3","be527907d4f06808":"kTSEF"}],"iGTC2":[function(require,module,exports,__globalThis) {
module.exports = {
    doubles: {
        step: 4,
        points: [
            [
                'e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a',
                'f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821'
            ],
            [
                '8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508',
                '11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf'
            ],
            [
                '175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739',
                'd3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695'
            ],
            [
                '363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640',
                '4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9'
            ],
            [
                '8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c',
                '4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36'
            ],
            [
                '723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda',
                '96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f'
            ],
            [
                'eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa',
                '5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999'
            ],
            [
                '100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0',
                'cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09'
            ],
            [
                'e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d',
                '9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d'
            ],
            [
                'feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d',
                'e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088'
            ],
            [
                'da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1',
                '9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d'
            ],
            [
                '53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0',
                '5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8'
            ],
            [
                '8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047',
                '10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a'
            ],
            [
                '385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862',
                '283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453'
            ],
            [
                '6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7',
                '7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160'
            ],
            [
                '3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd',
                '56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0'
            ],
            [
                '85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83',
                '7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6'
            ],
            [
                '948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a',
                '53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589'
            ],
            [
                '6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8',
                'bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17'
            ],
            [
                'e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d',
                '4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda'
            ],
            [
                'e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725',
                '7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd'
            ],
            [
                '213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754',
                '4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2'
            ],
            [
                '4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c',
                '17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6'
            ],
            [
                'fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6',
                '6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f'
            ],
            [
                '76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39',
                'c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01'
            ],
            [
                'c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891',
                '893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3'
            ],
            [
                'd895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b',
                'febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f'
            ],
            [
                'b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03',
                '2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7'
            ],
            [
                'e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d',
                'eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78'
            ],
            [
                'a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070',
                '7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1'
            ],
            [
                '90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4',
                'e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150'
            ],
            [
                '8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da',
                '662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82'
            ],
            [
                'e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11',
                '1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc'
            ],
            [
                '8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e',
                'efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b'
            ],
            [
                'e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41',
                '2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51'
            ],
            [
                'b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef',
                '67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45'
            ],
            [
                'd68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8',
                'db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120'
            ],
            [
                '324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d',
                '648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84'
            ],
            [
                '4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96',
                '35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d'
            ],
            [
                '9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd',
                'ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d'
            ],
            [
                '6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5',
                '9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8'
            ],
            [
                'a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266',
                '40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8'
            ],
            [
                '7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71',
                '34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac'
            ],
            [
                '928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac',
                'c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f'
            ],
            [
                '85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751',
                '1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962'
            ],
            [
                'ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e',
                '493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907'
            ],
            [
                '827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241',
                'c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec'
            ],
            [
                'eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3',
                'be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d'
            ],
            [
                'e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f',
                '4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414'
            ],
            [
                '1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19',
                'aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd'
            ],
            [
                '146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be',
                'b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0'
            ],
            [
                'fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9',
                '6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811'
            ],
            [
                'da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2',
                '8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1'
            ],
            [
                'a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13',
                '7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c'
            ],
            [
                '174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c',
                'ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73'
            ],
            [
                '959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba',
                '2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd'
            ],
            [
                'd2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151',
                'e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405'
            ],
            [
                '64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073',
                'd99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589'
            ],
            [
                '8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458',
                '38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e'
            ],
            [
                '13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b',
                '69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27'
            ],
            [
                'bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366',
                'd3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1'
            ],
            [
                '8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa',
                '40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482'
            ],
            [
                '8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0',
                '620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945'
            ],
            [
                'dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787',
                '7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573'
            ],
            [
                'f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e',
                'ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82'
            ]
        ]
    },
    naf: {
        wnd: 7,
        points: [
            [
                'f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9',
                '388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672'
            ],
            [
                '2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4',
                'd8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6'
            ],
            [
                '5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc',
                '6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da'
            ],
            [
                'acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe',
                'cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37'
            ],
            [
                '774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb',
                'd984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b'
            ],
            [
                'f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8',
                'ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81'
            ],
            [
                'd7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e',
                '581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58'
            ],
            [
                'defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34',
                '4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77'
            ],
            [
                '2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c',
                '85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a'
            ],
            [
                '352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5',
                '321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c'
            ],
            [
                '2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f',
                '2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67'
            ],
            [
                '9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714',
                '73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402'
            ],
            [
                'daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729',
                'a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55'
            ],
            [
                'c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db',
                '2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482'
            ],
            [
                '6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4',
                'e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82'
            ],
            [
                '1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5',
                'b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396'
            ],
            [
                '605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479',
                '2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49'
            ],
            [
                '62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d',
                '80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf'
            ],
            [
                '80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f',
                '1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a'
            ],
            [
                '7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb',
                'd0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7'
            ],
            [
                'd528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9',
                'eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933'
            ],
            [
                '49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963',
                '758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a'
            ],
            [
                '77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74',
                '958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6'
            ],
            [
                'f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530',
                'e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37'
            ],
            [
                '463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b',
                '5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e'
            ],
            [
                'f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247',
                'cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6'
            ],
            [
                'caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1',
                'cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476'
            ],
            [
                '2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120',
                '4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40'
            ],
            [
                '7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435',
                '91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61'
            ],
            [
                '754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18',
                '673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683'
            ],
            [
                'e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8',
                '59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5'
            ],
            [
                '186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb',
                '3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b'
            ],
            [
                'df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f',
                '55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417'
            ],
            [
                '5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143',
                'efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868'
            ],
            [
                '290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba',
                'e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a'
            ],
            [
                'af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45',
                'f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6'
            ],
            [
                '766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a',
                '744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996'
            ],
            [
                '59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e',
                'c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e'
            ],
            [
                'f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8',
                'e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d'
            ],
            [
                '7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c',
                '30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2'
            ],
            [
                '948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519',
                'e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e'
            ],
            [
                '7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab',
                '100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437'
            ],
            [
                '3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca',
                'ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311'
            ],
            [
                'd3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf',
                '8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4'
            ],
            [
                '1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610',
                '68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575'
            ],
            [
                '733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4',
                'f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d'
            ],
            [
                '15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c',
                'd56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d'
            ],
            [
                'a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940',
                'edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629'
            ],
            [
                'e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980',
                'a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06'
            ],
            [
                '311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3',
                '66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374'
            ],
            [
                '34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf',
                '9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee'
            ],
            [
                'f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63',
                '4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1'
            ],
            [
                'd7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448',
                'fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b'
            ],
            [
                '32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf',
                '5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661'
            ],
            [
                '7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5',
                '8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6'
            ],
            [
                'ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6',
                '8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e'
            ],
            [
                '16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5',
                '5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d'
            ],
            [
                'eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99',
                'f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc'
            ],
            [
                '78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51',
                'f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4'
            ],
            [
                '494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5',
                '42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c'
            ],
            [
                'a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5',
                '204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b'
            ],
            [
                'c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997',
                '4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913'
            ],
            [
                '841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881',
                '73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154'
            ],
            [
                '5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5',
                '39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865'
            ],
            [
                '36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66',
                'd2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc'
            ],
            [
                '336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726',
                'ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224'
            ],
            [
                '8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede',
                '6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e'
            ],
            [
                '1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94',
                '60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6'
            ],
            [
                '85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31',
                '3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511'
            ],
            [
                '29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51',
                'b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b'
            ],
            [
                'a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252',
                'ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2'
            ],
            [
                '4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5',
                'cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c'
            ],
            [
                'd24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b',
                '6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3'
            ],
            [
                'ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4',
                '322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d'
            ],
            [
                'af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f',
                '6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700'
            ],
            [
                'e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889',
                '2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4'
            ],
            [
                '591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246',
                'b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196'
            ],
            [
                '11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984',
                '998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4'
            ],
            [
                '3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a',
                'b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257'
            ],
            [
                'cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030',
                'bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13'
            ],
            [
                'c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197',
                '6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096'
            ],
            [
                'c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593',
                'c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38'
            ],
            [
                'a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef',
                '21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f'
            ],
            [
                '347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38',
                '60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448'
            ],
            [
                'da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a',
                '49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a'
            ],
            [
                'c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111',
                '5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4'
            ],
            [
                '4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502',
                '7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437'
            ],
            [
                '3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea',
                'be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7'
            ],
            [
                'cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26',
                '8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d'
            ],
            [
                'b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986',
                '39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a'
            ],
            [
                'd4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e',
                '62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54'
            ],
            [
                '48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4',
                '25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77'
            ],
            [
                'dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda',
                'ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517'
            ],
            [
                '6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859',
                'cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10'
            ],
            [
                'e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f',
                'f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125'
            ],
            [
                'eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c',
                '6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e'
            ],
            [
                '13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942',
                'fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1'
            ],
            [
                'ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a',
                '1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2'
            ],
            [
                'b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80',
                '5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423'
            ],
            [
                'ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d',
                '438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8'
            ],
            [
                '8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1',
                'cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758'
            ],
            [
                '52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63',
                'c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375'
            ],
            [
                'e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352',
                '6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d'
            ],
            [
                '7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193',
                'ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec'
            ],
            [
                '5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00',
                '9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0'
            ],
            [
                '32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58',
                'ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c'
            ],
            [
                'e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7',
                'd3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4'
            ],
            [
                '8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8',
                'c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f'
            ],
            [
                '4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e',
                '67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649'
            ],
            [
                '3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d',
                'cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826'
            ],
            [
                '674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b',
                '299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5'
            ],
            [
                'd32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f',
                'f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87'
            ],
            [
                '30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6',
                '462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b'
            ],
            [
                'be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297',
                '62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc'
            ],
            [
                '93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a',
                '7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c'
            ],
            [
                'b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c',
                'ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f'
            ],
            [
                'd5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52',
                '4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a'
            ],
            [
                'd3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb',
                'bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46'
            ],
            [
                '463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065',
                'bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f'
            ],
            [
                '7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917',
                '603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03'
            ],
            [
                '74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9',
                'cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08'
            ],
            [
                '30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3',
                '553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8'
            ],
            [
                '9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57',
                '712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373'
            ],
            [
                '176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66',
                'ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3'
            ],
            [
                '75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8',
                '9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8'
            ],
            [
                '809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721',
                '9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1'
            ],
            [
                '1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180',
                '4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9'
            ]
        ]
    }
};

},{}],"dPpl0":[function(require,module,exports,__globalThis) {
'use strict';
var BN = require("2e69183faf5285a1");
var HmacDRBG = require("b0cb641292e4911d");
var utils = require("eab3e45147b180ba");
var curves = require("a5ce61d26ce01c4c");
var rand = require("f6342f89ac472937");
var assert = utils.assert;
var KeyPair = require("eb5ba559e423f6e9");
var Signature = require("7c5e2c76c574ce41");
function EC(options) {
    if (!(this instanceof EC)) return new EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === 'string') {
        assert(Object.prototype.hasOwnProperty.call(curves, options), 'Unknown curve ' + options);
        options = curves[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof curves.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
module.exports = EC;
EC.prototype.keyPair = function keyPair(options) {
    return new KeyPair(this, options);
};
EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return KeyPair.fromPrivate(this, priv, enc);
};
EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return KeyPair.fromPublic(this, pub, enc);
};
EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new HmacDRBG({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || 'utf8',
        entropy: options.entropy || rand(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || 'utf8',
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new BN(2));
    for(;;){
        var priv = new BN(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
EC.prototype._truncateToN = function _truncateToN(msg, truncOnly, bitLength) {
    var byteLength;
    if (BN.isBN(msg) || typeof msg === 'number') {
        msg = new BN(msg, 16);
        byteLength = msg.byteLength();
    } else if (typeof msg === 'object') {
        // BN assumes an array-like input and asserts length
        byteLength = msg.length;
        msg = new BN(msg, 16);
    } else {
        // BN converts the value to string
        var str = msg.toString();
        // HEX encoding
        byteLength = str.length + 1 >>> 1;
        msg = new BN(str, 16);
    }
    // Allow overriding
    if (typeof bitLength !== 'number') bitLength = byteLength * 8;
    var delta = bitLength - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === 'object') {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    if (typeof msg !== 'string' && typeof msg !== 'number' && !BN.isBN(msg)) {
        assert(typeof msg === 'object' && msg && typeof msg.length === 'number', 'Expected message to be an array-like, a hex string, or a BN instance');
        assert(msg.length >>> 0 === msg.length); // non-negative 32-bit integer
        for(var i = 0; i < msg.length; i++)assert((msg[i] & 255) === msg[i]);
    }
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(msg, false, options.msgBitLength);
    // Would fail further checks, but let's make the error message clear
    assert(!msg.isNeg(), 'Can not sign a negative message');
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray('be', bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray('be', bytes);
    // Recheck nonce to be bijective to msg
    assert(new BN(nonce).eq(msg), 'Can not sign message');
    // Instantiate Hmac_DRBG
    var drbg = new HmacDRBG({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || 'utf8'
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new BN(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new BN(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new Signature({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
EC.prototype.verify = function verify(msg, signature, key, enc, options) {
    if (!options) options = {};
    msg = this._truncateToN(msg, false, options.msgBitLength);
    key = this.keyFromPublic(key, enc);
    signature = new Signature(signature, 'hex');
    // Perform primitive values validation
    var r = signature.r;
    var s = signature.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
    assert((3 & j) === j, 'The recovery param is more than two bits');
    signature = new Signature(signature, enc);
    var n = this.n;
    var e = new BN(msg);
    var r = signature.r;
    var s = signature.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error('Unable to find sencond key candinate');
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
    signature = new Signature(signature, enc);
    if (signature.recoveryParam !== null) return signature.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error('Unable to find valid recovery factor');
};

},{"2e69183faf5285a1":"2BT8j","b0cb641292e4911d":"1bode","eab3e45147b180ba":"6D83a","a5ce61d26ce01c4c":"jfEPU","f6342f89ac472937":"eefBI","eb5ba559e423f6e9":"v9CDl","7c5e2c76c574ce41":"kU30M"}],"1bode":[function(require,module,exports,__globalThis) {
'use strict';
var hash = require("629972fec592198f");
var utils = require("c20531edfb274a2c");
var assert = require("43ff1863ab3fce20");
function HmacDRBG(options) {
    if (!(this instanceof HmacDRBG)) return new HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = utils.toArray(options.entropy, options.entropyEnc || 'hex');
    var nonce = utils.toArray(options.nonce, options.nonceEnc || 'hex');
    var pers = utils.toArray(options.pers, options.persEnc || 'hex');
    assert(entropy.length >= this.minEntropy / 8, 'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
    this._init(entropy, nonce, pers);
}
module.exports = HmacDRBG;
HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
HmacDRBG.prototype._hmac = function hmac() {
    return new hash.hmac(this.hash, this.K);
};
HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== 'string') {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = utils.toArray(entropy, entropyEnc);
    add = utils.toArray(add, addEnc);
    assert(entropy.length >= this.minEntropy / 8, 'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error('Reseed is required');
    // Optional encoding
    if (typeof enc !== 'string') {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = utils.toArray(add, addEnc || 'hex');
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return utils.encode(res, enc);
};

},{"629972fec592198f":"aS0HP","c20531edfb274a2c":"LMeZ3","43ff1863ab3fce20":"kTSEF"}],"v9CDl":[function(require,module,exports,__globalThis) {
'use strict';
var BN = require("55cc33a33cda153d");
var utils = require("bda8b1ff480a7f3");
var assert = utils.assert;
function KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
module.exports = KeyPair;
KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof KeyPair) return pub;
    return new KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof KeyPair) return priv;
    return new KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: 'Invalid public key'
    };
    if (!pub.validate()) return {
        result: false,
        reason: 'Public key is not a point'
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: 'Public key * N != O'
    };
    return {
        result: true,
        reason: null
    };
};
KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === 'string') {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === 'hex') return this.priv.toString(16, 2);
    else return this.priv;
};
KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new BN(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === 'mont') assert(key.x, 'Need x coordinate');
        else if (this.ec.curve.type === 'short' || this.ec.curve.type === 'edwards') assert(key.x && key.y, 'Need both x and y coordinate');
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) assert(pub.validate(), 'public point not validated');
    return pub.mul(this.priv).getX();
};
// ECDSA
KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
KeyPair.prototype.verify = function verify(msg, signature, options) {
    return this.ec.verify(msg, signature, this, undefined, options);
};
KeyPair.prototype.inspect = function inspect() {
    return '<Key priv: ' + (this.priv && this.priv.toString(16, 2)) + ' pub: ' + (this.pub && this.pub.inspect()) + ' >';
};

},{"55cc33a33cda153d":"2BT8j","bda8b1ff480a7f3":"6D83a"}],"kU30M":[function(require,module,exports,__globalThis) {
'use strict';
var BN = require("a7ae8f0fe39990e7");
var utils = require("5df7da4811374387");
var assert = utils.assert;
function Signature(options, enc) {
    if (options instanceof Signature) return options;
    if (this._importDER(options, enc)) return;
    assert(options.r && options.s, 'Signature without r or s');
    this.r = new BN(options.r, 16);
    this.s = new BN(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
module.exports = Signature;
function Position() {
    this.place = 0;
}
function getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    if (buf[p.place] === 0x00) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
Signature.prototype._importDER = function _importDER(data, enc) {
    data = utils.toArray(data, enc);
    var p = new Position();
    if (data[p.place++] !== 0x30) return false;
    var len = getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = getLength(data, p);
    if (rlen === false) return false;
    if ((data[p.place] & 128) !== 0) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    if ((data[p.place] & 128) !== 0) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new BN(r);
    this.s = new BN(s);
    this.recoveryParam = null;
    return true;
};
function constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = rmPadding(r);
    s = rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return utils.encode(res, enc);
};

},{"a7ae8f0fe39990e7":"2BT8j","5df7da4811374387":"6D83a"}],"lBLCy":[function(require,module,exports,__globalThis) {
'use strict';
var hash = require("50f9bfa8a484d5d8");
var curves = require("68956d27442d6321");
var utils = require("99ec52641eff141d");
var assert = utils.assert;
var parseBytes = utils.parseBytes;
var KeyPair = require("2ad2982d76b37f15");
var Signature = require("76c25a1d63d10c1b");
function EDDSA(curve) {
    assert(curve === 'ed25519', 'only tested with ed25519 so far');
    if (!(this instanceof EDDSA)) return new EDDSA(curve);
    curve = curves[curve].curve;
    this.curve = curve;
    this.g = curve.g;
    this.g.precompute(curve.n.bitLength() + 1);
    this.pointClass = curve.point().constructor;
    this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
    this.hash = hash.sha512;
}
module.exports = EDDSA;
/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/ EDDSA.prototype.sign = function sign(message, secret) {
    message = parseBytes(message);
    var key = this.keyFromSecret(secret);
    var r = this.hashInt(key.messagePrefix(), message);
    var R = this.g.mul(r);
    var Rencoded = this.encodePoint(R);
    var s_ = this.hashInt(Rencoded, key.pubBytes(), message).mul(key.priv());
    var S = r.add(s_).umod(this.curve.n);
    return this.makeSignature({
        R: R,
        S: S,
        Rencoded: Rencoded
    });
};
/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/ EDDSA.prototype.verify = function verify(message, sig, pub) {
    message = parseBytes(message);
    sig = this.makeSignature(sig);
    if (sig.S().gte(sig.eddsa.curve.n) || sig.S().isNeg()) return false;
    var key = this.keyFromPublic(pub);
    var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
    var SG = this.g.mul(sig.S());
    var RplusAh = sig.R().add(key.pub().mul(h));
    return RplusAh.eq(SG);
};
EDDSA.prototype.hashInt = function hashInt() {
    var hash = this.hash();
    for(var i = 0; i < arguments.length; i++)hash.update(arguments[i]);
    return utils.intFromLE(hash.digest()).umod(this.curve.n);
};
EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
    return KeyPair.fromPublic(this, pub);
};
EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
    return KeyPair.fromSecret(this, secret);
};
EDDSA.prototype.makeSignature = function makeSignature(sig) {
    if (sig instanceof Signature) return sig;
    return new Signature(this, sig);
};
/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/ EDDSA.prototype.encodePoint = function encodePoint(point) {
    var enc = point.getY().toArray('le', this.encodingLength);
    enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
    return enc;
};
EDDSA.prototype.decodePoint = function decodePoint(bytes) {
    bytes = utils.parseBytes(bytes);
    var lastIx = bytes.length - 1;
    var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & -129);
    var xIsOdd = (bytes[lastIx] & 0x80) !== 0;
    var y = utils.intFromLE(normed);
    return this.curve.pointFromY(y, xIsOdd);
};
EDDSA.prototype.encodeInt = function encodeInt(num) {
    return num.toArray('le', this.encodingLength);
};
EDDSA.prototype.decodeInt = function decodeInt(bytes) {
    return utils.intFromLE(bytes);
};
EDDSA.prototype.isPoint = function isPoint(val) {
    return val instanceof this.pointClass;
};

},{"50f9bfa8a484d5d8":"aS0HP","68956d27442d6321":"jfEPU","99ec52641eff141d":"6D83a","2ad2982d76b37f15":"dQeAm","76c25a1d63d10c1b":"dsa6R"}],"dQeAm":[function(require,module,exports,__globalThis) {
'use strict';
var utils = require("387ffb9c0bf065ab");
var assert = utils.assert;
var parseBytes = utils.parseBytes;
var cachedProperty = utils.cachedProperty;
/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/ function KeyPair(eddsa, params) {
    this.eddsa = eddsa;
    this._secret = parseBytes(params.secret);
    if (eddsa.isPoint(params.pub)) this._pub = params.pub;
    else this._pubBytes = parseBytes(params.pub);
}
KeyPair.fromPublic = function fromPublic(eddsa, pub) {
    if (pub instanceof KeyPair) return pub;
    return new KeyPair(eddsa, {
        pub: pub
    });
};
KeyPair.fromSecret = function fromSecret(eddsa, secret) {
    if (secret instanceof KeyPair) return secret;
    return new KeyPair(eddsa, {
        secret: secret
    });
};
KeyPair.prototype.secret = function secret() {
    return this._secret;
};
cachedProperty(KeyPair, 'pubBytes', function pubBytes() {
    return this.eddsa.encodePoint(this.pub());
});
cachedProperty(KeyPair, 'pub', function pub() {
    if (this._pubBytes) return this.eddsa.decodePoint(this._pubBytes);
    return this.eddsa.g.mul(this.priv());
});
cachedProperty(KeyPair, 'privBytes', function privBytes() {
    var eddsa = this.eddsa;
    var hash = this.hash();
    var lastIx = eddsa.encodingLength - 1;
    var a = hash.slice(0, eddsa.encodingLength);
    a[0] &= 248;
    a[lastIx] &= 127;
    a[lastIx] |= 64;
    return a;
});
cachedProperty(KeyPair, 'priv', function priv() {
    return this.eddsa.decodeInt(this.privBytes());
});
cachedProperty(KeyPair, 'hash', function hash() {
    return this.eddsa.hash().update(this.secret()).digest();
});
cachedProperty(KeyPair, 'messagePrefix', function messagePrefix() {
    return this.hash().slice(this.eddsa.encodingLength);
});
KeyPair.prototype.sign = function sign(message) {
    assert(this._secret, 'KeyPair can only verify');
    return this.eddsa.sign(message, this);
};
KeyPair.prototype.verify = function verify(message, sig) {
    return this.eddsa.verify(message, sig, this);
};
KeyPair.prototype.getSecret = function getSecret(enc) {
    assert(this._secret, 'KeyPair is public only');
    return utils.encode(this.secret(), enc);
};
KeyPair.prototype.getPublic = function getPublic(enc) {
    return utils.encode(this.pubBytes(), enc);
};
module.exports = KeyPair;

},{"387ffb9c0bf065ab":"6D83a"}],"dsa6R":[function(require,module,exports,__globalThis) {
'use strict';
var BN = require("696e2c87f819d166");
var utils = require("51b94bcac1dcb2b2");
var assert = utils.assert;
var cachedProperty = utils.cachedProperty;
var parseBytes = utils.parseBytes;
/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/ function Signature(eddsa, sig) {
    this.eddsa = eddsa;
    if (typeof sig !== 'object') sig = parseBytes(sig);
    if (Array.isArray(sig)) {
        assert(sig.length === eddsa.encodingLength * 2, 'Signature has invalid size');
        sig = {
            R: sig.slice(0, eddsa.encodingLength),
            S: sig.slice(eddsa.encodingLength)
        };
    }
    assert(sig.R && sig.S, 'Signature without R or S');
    if (eddsa.isPoint(sig.R)) this._R = sig.R;
    if (sig.S instanceof BN) this._S = sig.S;
    this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
    this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}
cachedProperty(Signature, 'S', function S() {
    return this.eddsa.decodeInt(this.Sencoded());
});
cachedProperty(Signature, 'R', function R() {
    return this.eddsa.decodePoint(this.Rencoded());
});
cachedProperty(Signature, 'Rencoded', function Rencoded() {
    return this.eddsa.encodePoint(this.R());
});
cachedProperty(Signature, 'Sencoded', function Sencoded() {
    return this.eddsa.encodeInt(this.S());
});
Signature.prototype.toBytes = function toBytes() {
    return this.Rencoded().concat(this.Sencoded());
};
Signature.prototype.toHex = function toHex() {
    return utils.encode(this.toBytes(), 'hex').toUpperCase();
};
module.exports = Signature;

},{"696e2c87f819d166":"2BT8j","51b94bcac1dcb2b2":"6D83a"}],"4ddHc":[function(require,module,exports,__globalThis) {
'use strict';
var asn1 = require("a33d2f68b0ffe26d");
var aesid = require("c39bbd52d12adb70");
var fixProc = require("7247fe0465255c67");
var ciphers = require("ea725b5eadc96106");
var pbkdf2Sync = require("aa2a622927353f9f").pbkdf2Sync;
var Buffer = require("11d61e4bc73f5fdc").Buffer;
function decrypt(data, password) {
    var salt = data.algorithm.decrypt.kde.kdeparams.salt;
    var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10);
    var algo = aesid[data.algorithm.decrypt.cipher.algo.join('.')];
    var iv = data.algorithm.decrypt.cipher.iv;
    var cipherText = data.subjectPrivateKey;
    var keylen = parseInt(algo.split('-')[1], 10) / 8;
    var key = pbkdf2Sync(password, salt, iters, keylen, 'sha1');
    var cipher = ciphers.createDecipheriv(algo, key, iv);
    var out = [];
    out.push(cipher.update(cipherText));
    out.push(cipher['final']());
    return Buffer.concat(out);
}
function parseKeys(buffer) {
    var password;
    if (typeof buffer === 'object' && !Buffer.isBuffer(buffer)) {
        password = buffer.passphrase;
        buffer = buffer.key;
    }
    if (typeof buffer === 'string') buffer = Buffer.from(buffer);
    var stripped = fixProc(buffer, password);
    var type = stripped.tag;
    var data = stripped.data;
    var subtype, ndata;
    switch(type){
        case 'CERTIFICATE':
            ndata = asn1.certificate.decode(data, 'der').tbsCertificate.subjectPublicKeyInfo;
        // falls through
        case 'PUBLIC KEY':
            if (!ndata) ndata = asn1.PublicKey.decode(data, 'der');
            subtype = ndata.algorithm.algorithm.join('.');
            switch(subtype){
                case '1.2.840.113549.1.1.1':
                    return asn1.RSAPublicKey.decode(ndata.subjectPublicKey.data, 'der');
                case '1.2.840.10045.2.1':
                    ndata.subjectPrivateKey = ndata.subjectPublicKey;
                    return {
                        type: 'ec',
                        data: ndata
                    };
                case '1.2.840.10040.4.1':
                    ndata.algorithm.params.pub_key = asn1.DSAparam.decode(ndata.subjectPublicKey.data, 'der');
                    return {
                        type: 'dsa',
                        data: ndata.algorithm.params
                    };
                default:
                    throw new Error('unknown key id ' + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case 'ENCRYPTED PRIVATE KEY':
            data = asn1.EncryptedPrivateKey.decode(data, 'der');
            data = decrypt(data, password);
        // falls through
        case 'PRIVATE KEY':
            ndata = asn1.PrivateKey.decode(data, 'der');
            subtype = ndata.algorithm.algorithm.join('.');
            switch(subtype){
                case '1.2.840.113549.1.1.1':
                    return asn1.RSAPrivateKey.decode(ndata.subjectPrivateKey, 'der');
                case '1.2.840.10045.2.1':
                    return {
                        curve: ndata.algorithm.curve,
                        privateKey: asn1.ECPrivateKey.decode(ndata.subjectPrivateKey, 'der').privateKey
                    };
                case '1.2.840.10040.4.1':
                    ndata.algorithm.params.priv_key = asn1.DSAparam.decode(ndata.subjectPrivateKey, 'der');
                    return {
                        type: 'dsa',
                        params: ndata.algorithm.params
                    };
                default:
                    throw new Error('unknown key id ' + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case 'RSA PUBLIC KEY':
            return asn1.RSAPublicKey.decode(data, 'der');
        case 'RSA PRIVATE KEY':
            return asn1.RSAPrivateKey.decode(data, 'der');
        case 'DSA PRIVATE KEY':
            return {
                type: 'dsa',
                params: asn1.DSAPrivateKey.decode(data, 'der')
            };
        case 'EC PRIVATE KEY':
            data = asn1.ECPrivateKey.decode(data, 'der');
            return {
                curve: data.parameters.value,
                privateKey: data.privateKey
            };
        default:
            throw new Error('unknown key type ' + type);
    }
}
parseKeys.signature = asn1.signature;
module.exports = parseKeys;

},{"a33d2f68b0ffe26d":"8MnUk","c39bbd52d12adb70":"5wRPi","7247fe0465255c67":"8Llnq","ea725b5eadc96106":"3oQJX","aa2a622927353f9f":"6Io3h","11d61e4bc73f5fdc":"1Yph5"}],"8MnUk":[function(require,module,exports,__globalThis) {
// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
// Fedor, you are amazing.
'use strict';
var asn1 = require("821e6411e0aeb10a");
exports.certificate = require("6bb4fbbd6e2d2384");
var RSAPrivateKey = asn1.define('RSAPrivateKey', function() {
    this.seq().obj(this.key('version')['int'](), this.key('modulus')['int'](), this.key('publicExponent')['int'](), this.key('privateExponent')['int'](), this.key('prime1')['int'](), this.key('prime2')['int'](), this.key('exponent1')['int'](), this.key('exponent2')['int'](), this.key('coefficient')['int']());
});
exports.RSAPrivateKey = RSAPrivateKey;
var RSAPublicKey = asn1.define('RSAPublicKey', function() {
    this.seq().obj(this.key('modulus')['int'](), this.key('publicExponent')['int']());
});
exports.RSAPublicKey = RSAPublicKey;
var AlgorithmIdentifier = asn1.define('AlgorithmIdentifier', function() {
    this.seq().obj(this.key('algorithm').objid(), this.key('none').null_().optional(), this.key('curve').objid().optional(), this.key('params').seq().obj(this.key('p')['int'](), this.key('q')['int'](), this.key('g')['int']()).optional());
});
var PublicKey = asn1.define('SubjectPublicKeyInfo', function() {
    this.seq().obj(this.key('algorithm').use(AlgorithmIdentifier), this.key('subjectPublicKey').bitstr());
});
exports.PublicKey = PublicKey;
var PrivateKeyInfo = asn1.define('PrivateKeyInfo', function() {
    this.seq().obj(this.key('version')['int'](), this.key('algorithm').use(AlgorithmIdentifier), this.key('subjectPrivateKey').octstr());
});
exports.PrivateKey = PrivateKeyInfo;
var EncryptedPrivateKeyInfo = asn1.define('EncryptedPrivateKeyInfo', function() {
    this.seq().obj(this.key('algorithm').seq().obj(this.key('id').objid(), this.key('decrypt').seq().obj(this.key('kde').seq().obj(this.key('id').objid(), this.key('kdeparams').seq().obj(this.key('salt').octstr(), this.key('iters')['int']())), this.key('cipher').seq().obj(this.key('algo').objid(), this.key('iv').octstr()))), this.key('subjectPrivateKey').octstr());
});
exports.EncryptedPrivateKey = EncryptedPrivateKeyInfo;
var DSAPrivateKey = asn1.define('DSAPrivateKey', function() {
    this.seq().obj(this.key('version')['int'](), this.key('p')['int'](), this.key('q')['int'](), this.key('g')['int'](), this.key('pub_key')['int'](), this.key('priv_key')['int']());
});
exports.DSAPrivateKey = DSAPrivateKey;
exports.DSAparam = asn1.define('DSAparam', function() {
    this['int']();
});
var ECParameters = asn1.define('ECParameters', function() {
    this.choice({
        namedCurve: this.objid()
    });
});
var ECPrivateKey = asn1.define('ECPrivateKey', function() {
    this.seq().obj(this.key('version')['int'](), this.key('privateKey').octstr(), this.key('parameters').optional().explicit(0).use(ECParameters), this.key('publicKey').optional().explicit(1).bitstr());
});
exports.ECPrivateKey = ECPrivateKey;
exports.signature = asn1.define('signature', function() {
    this.seq().obj(this.key('r')['int'](), this.key('s')['int']());
});

},{"821e6411e0aeb10a":"dGTNO","6bb4fbbd6e2d2384":"5Jsvw"}],"dGTNO":[function(require,module,exports,__globalThis) {
var asn1 = exports;
asn1.bignum = require("b4f67f473458f037");
asn1.define = require("3a96ab8454f69498").define;
asn1.base = require("82a96f1d67e1a13d");
asn1.constants = require("f666a445bd64a777");
asn1.decoders = require("e200f1dc591d286b");
asn1.encoders = require("5ea4ddb7d1e6fcb9");

},{"b4f67f473458f037":"c1pB1","3a96ab8454f69498":"cTiTW","82a96f1d67e1a13d":"l0BhD","f666a445bd64a777":"chuJM","e200f1dc591d286b":"8iIv3","5ea4ddb7d1e6fcb9":"bVy39"}],"c1pB1":[function(require,module,exports,__globalThis) {
(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = require("7f1ee543ef73731a").Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) {
            this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
            i++;
        }
        // Clear words above the requested width so the result stays below 2 ** width
        for(; i < this.length; i++)this.words[i] = 0;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        if (num === 0) {
            this.length = 1;
            this._normSign();
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.mod.abs();
        var half = num.abs().iushrn(1);
        var r2 = num.words[0] & 1;
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up, away from zero
        var up = new BN(1);
        up.negative = this.negative ^ num.negative;
        return dm.div.iadd(up);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

},{"7f1ee543ef73731a":"4TE4R"}],"cTiTW":[function(require,module,exports,__globalThis) {
var asn1 = require("ab532762dbbdc666");
var inherits = require("64c493c8ea32f1a7");
var api = exports;
api.define = function define(name, body) {
    return new Entity(name, body);
};
function Entity(name, body) {
    this.name = name;
    this.body = body;
    this.decoders = {};
    this.encoders = {};
}
Entity.prototype._createNamed = function createNamed(base) {
    var named;
    try {
        named = require("62c08f34eab7465f").runInThisContext('(function ' + this.name + '(entity) {\n' + '  this._initNamed(entity);\n' + '})');
    } catch (e) {
        named = function(entity) {
            this._initNamed(entity);
        };
    }
    inherits(named, base);
    named.prototype._initNamed = function initnamed(entity) {
        base.call(this, entity);
    };
    return new named(this);
};
Entity.prototype._getDecoder = function _getDecoder(enc) {
    enc = enc || 'der';
    // Lazily create decoder
    if (!this.decoders.hasOwnProperty(enc)) this.decoders[enc] = this._createNamed(asn1.decoders[enc]);
    return this.decoders[enc];
};
Entity.prototype.decode = function decode(data, enc, options) {
    return this._getDecoder(enc).decode(data, options);
};
Entity.prototype._getEncoder = function _getEncoder(enc) {
    enc = enc || 'der';
    // Lazily create encoder
    if (!this.encoders.hasOwnProperty(enc)) this.encoders[enc] = this._createNamed(asn1.encoders[enc]);
    return this.encoders[enc];
};
Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
    return this._getEncoder(enc).encode(data, reporter);
};

},{"ab532762dbbdc666":"dGTNO","64c493c8ea32f1a7":"dwCbX","62c08f34eab7465f":"k6Y60"}],"k6Y60":[function(require,module,exports,__globalThis) {
var indexOf = function(xs, item) {
    if (xs.indexOf) return xs.indexOf(item);
    else for(var i = 0; i < xs.length; i++){
        if (xs[i] === item) return i;
    }
    return -1;
};
var Object_keys = function(obj) {
    if (Object.keys) return Object.keys(obj);
    else {
        var res = [];
        for(var key in obj)res.push(key);
        return res;
    }
};
var forEach = function(xs, fn) {
    if (xs.forEach) return xs.forEach(fn);
    else for(var i = 0; i < xs.length; i++)fn(xs[i], i, xs);
};
var defineProp = function() {
    try {
        Object.defineProperty({}, '_', {});
        return function(obj, name, value) {
            Object.defineProperty(obj, name, {
                writable: true,
                enumerable: false,
                configurable: true,
                value: value
            });
        };
    } catch (e) {
        return function(obj, name, value) {
            obj[name] = value;
        };
    }
}();
var globals = [
    'Array',
    'Boolean',
    'Date',
    'Error',
    'EvalError',
    'Function',
    'Infinity',
    'JSON',
    'Math',
    'NaN',
    'Number',
    'Object',
    'RangeError',
    'ReferenceError',
    'RegExp',
    'String',
    'SyntaxError',
    'TypeError',
    'URIError',
    'decodeURI',
    'decodeURIComponent',
    'encodeURI',
    'encodeURIComponent',
    'escape',
    'eval',
    'isFinite',
    'isNaN',
    'parseFloat',
    'parseInt',
    'undefined',
    'unescape'
];
function Context() {}
Context.prototype = {};
var Script = exports.Script = function NodeScript(code) {
    if (!(this instanceof Script)) return new Script(code);
    this.code = code;
};
Script.prototype.runInContext = function(context) {
    if (!(context instanceof Context)) throw new TypeError("needs a 'context' argument.");
    var iframe = document.createElement('iframe');
    if (!iframe.style) iframe.style = {};
    iframe.style.display = 'none';
    document.body.appendChild(iframe);
    var win = iframe.contentWindow;
    var wEval = win.eval, wExecScript = win.execScript;
    if (!wEval && wExecScript) {
        // win.eval() magically appears when this is called in IE:
        wExecScript.call(win, 'null');
        wEval = win.eval;
    }
    forEach(Object_keys(context), function(key) {
        win[key] = context[key];
    });
    forEach(globals, function(key) {
        if (context[key]) win[key] = context[key];
    });
    var winKeys = Object_keys(win);
    var res = wEval.call(win, this.code);
    forEach(Object_keys(win), function(key) {
        // Avoid copying circular objects like `top` and `window` by only
        // updating existing context properties or new properties in the `win`
        // that was only introduced after the eval.
        if (key in context || indexOf(winKeys, key) === -1) context[key] = win[key];
    });
    forEach(globals, function(key) {
        if (!(key in context)) defineProp(context, key, win[key]);
    });
    document.body.removeChild(iframe);
    return res;
};
Script.prototype.runInThisContext = function() {
    return eval(this.code); // maybe...
};
Script.prototype.runInNewContext = function(context) {
    var ctx = Script.createContext(context);
    var res = this.runInContext(ctx);
    if (context) forEach(Object_keys(ctx), function(key) {
        context[key] = ctx[key];
    });
    return res;
};
forEach(Object_keys(Script.prototype), function(name) {
    exports[name] = Script[name] = function(code) {
        var s = Script(code);
        return s[name].apply(s, [].slice.call(arguments, 1));
    };
});
exports.isContext = function(context) {
    return context instanceof Context;
};
exports.createScript = function(code) {
    return exports.Script(code);
};
exports.createContext = Script.createContext = function(context) {
    var copy = new Context();
    if (typeof context === 'object') forEach(Object_keys(context), function(key) {
        copy[key] = context[key];
    });
    return copy;
};

},{}],"l0BhD":[function(require,module,exports,__globalThis) {
var base = exports;
base.Reporter = require("59a43dc644aa14a1").Reporter;
base.DecoderBuffer = require("bb5e01939a3ed5de").DecoderBuffer;
base.EncoderBuffer = require("bb5e01939a3ed5de").EncoderBuffer;
base.Node = require("97802675bd1acef");

},{"59a43dc644aa14a1":"77gJS","bb5e01939a3ed5de":"2E4KH","97802675bd1acef":"buc2B"}],"77gJS":[function(require,module,exports,__globalThis) {
var inherits = require("cca99c6acf69321b");
function Reporter(options) {
    this._reporterState = {
        obj: null,
        path: [],
        options: options || {},
        errors: []
    };
}
exports.Reporter = Reporter;
Reporter.prototype.isError = function isError(obj) {
    return obj instanceof ReporterError;
};
Reporter.prototype.save = function save() {
    var state = this._reporterState;
    return {
        obj: state.obj,
        pathLen: state.path.length
    };
};
Reporter.prototype.restore = function restore(data) {
    var state = this._reporterState;
    state.obj = data.obj;
    state.path = state.path.slice(0, data.pathLen);
};
Reporter.prototype.enterKey = function enterKey(key) {
    return this._reporterState.path.push(key);
};
Reporter.prototype.exitKey = function exitKey(index) {
    var state = this._reporterState;
    state.path = state.path.slice(0, index - 1);
};
Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
    var state = this._reporterState;
    this.exitKey(index);
    if (state.obj !== null) state.obj[key] = value;
};
Reporter.prototype.path = function path() {
    return this._reporterState.path.join('/');
};
Reporter.prototype.enterObject = function enterObject() {
    var state = this._reporterState;
    var prev = state.obj;
    state.obj = {};
    return prev;
};
Reporter.prototype.leaveObject = function leaveObject(prev) {
    var state = this._reporterState;
    var now = state.obj;
    state.obj = prev;
    return now;
};
Reporter.prototype.error = function error(msg) {
    var err;
    var state = this._reporterState;
    var inherited = msg instanceof ReporterError;
    if (inherited) err = msg;
    else err = new ReporterError(state.path.map(function(elem) {
        return '[' + JSON.stringify(elem) + ']';
    }).join(''), msg.message || msg, msg.stack);
    if (!state.options.partial) throw err;
    if (!inherited) state.errors.push(err);
    return err;
};
Reporter.prototype.wrapResult = function wrapResult(result) {
    var state = this._reporterState;
    if (!state.options.partial) return result;
    return {
        result: this.isError(result) ? null : result,
        errors: state.errors
    };
};
function ReporterError(path, msg) {
    this.path = path;
    this.rethrow(msg);
}
inherits(ReporterError, Error);
ReporterError.prototype.rethrow = function rethrow(msg) {
    this.message = msg + ' at: ' + (this.path || '(shallow)');
    if (Error.captureStackTrace) Error.captureStackTrace(this, ReporterError);
    if (!this.stack) try {
        // IE only adds stack when thrown
        throw new Error(this.message);
    } catch (e) {
        this.stack = e.stack;
    }
    return this;
};

},{"cca99c6acf69321b":"dwCbX"}],"2E4KH":[function(require,module,exports,__globalThis) {
var inherits = require("ff35534ecc380ed3");
var Reporter = require("5e377fc82488d72a").Reporter;
var Buffer = require("e61f132f215e12f9").Buffer;
function DecoderBuffer(base, options) {
    Reporter.call(this, options);
    if (!Buffer.isBuffer(base)) {
        this.error('Input not Buffer');
        return;
    }
    this.base = base;
    this.offset = 0;
    this.length = base.length;
}
inherits(DecoderBuffer, Reporter);
exports.DecoderBuffer = DecoderBuffer;
DecoderBuffer.prototype.save = function save() {
    return {
        offset: this.offset,
        reporter: Reporter.prototype.save.call(this)
    };
};
DecoderBuffer.prototype.restore = function restore(save) {
    // Return skipped data
    var res = new DecoderBuffer(this.base);
    res.offset = save.offset;
    res.length = this.offset;
    this.offset = save.offset;
    Reporter.prototype.restore.call(this, save.reporter);
    return res;
};
DecoderBuffer.prototype.isEmpty = function isEmpty() {
    return this.offset === this.length;
};
DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
    if (this.offset + 1 <= this.length) return this.base.readUInt8(this.offset++, true);
    else return this.error(fail || 'DecoderBuffer overrun');
};
DecoderBuffer.prototype.skip = function skip(bytes, fail) {
    if (!(this.offset + bytes <= this.length)) return this.error(fail || 'DecoderBuffer overrun');
    var res = new DecoderBuffer(this.base);
    // Share reporter state
    res._reporterState = this._reporterState;
    res.offset = this.offset;
    res.length = this.offset + bytes;
    this.offset += bytes;
    return res;
};
DecoderBuffer.prototype.raw = function raw(save) {
    return this.base.slice(save ? save.offset : this.offset, this.length);
};
function EncoderBuffer(value, reporter) {
    if (Array.isArray(value)) {
        this.length = 0;
        this.value = value.map(function(item) {
            if (!(item instanceof EncoderBuffer)) item = new EncoderBuffer(item, reporter);
            this.length += item.length;
            return item;
        }, this);
    } else if (typeof value === 'number') {
        if (!(0 <= value && value <= 0xff)) return reporter.error('non-byte EncoderBuffer value');
        this.value = value;
        this.length = 1;
    } else if (typeof value === 'string') {
        this.value = value;
        this.length = Buffer.byteLength(value);
    } else if (Buffer.isBuffer(value)) {
        this.value = value;
        this.length = value.length;
    } else return reporter.error('Unsupported type: ' + typeof value);
}
exports.EncoderBuffer = EncoderBuffer;
EncoderBuffer.prototype.join = function join(out, offset) {
    if (!out) out = new Buffer(this.length);
    if (!offset) offset = 0;
    if (this.length === 0) return out;
    if (Array.isArray(this.value)) this.value.forEach(function(item) {
        item.join(out, offset);
        offset += item.length;
    });
    else {
        if (typeof this.value === 'number') out[offset] = this.value;
        else if (typeof this.value === 'string') out.write(this.value, offset);
        else if (Buffer.isBuffer(this.value)) this.value.copy(out, offset);
        offset += this.length;
    }
    return out;
};

},{"ff35534ecc380ed3":"dwCbX","5e377fc82488d72a":"l0BhD","e61f132f215e12f9":"cjdyz"}],"buc2B":[function(require,module,exports,__globalThis) {
var Reporter = require("b93dc035fd1a2dd2").Reporter;
var EncoderBuffer = require("b93dc035fd1a2dd2").EncoderBuffer;
var DecoderBuffer = require("b93dc035fd1a2dd2").DecoderBuffer;
var assert = require("1bf7ce79b1c01d8b");
// Supported tags
var tags = [
    'seq',
    'seqof',
    'set',
    'setof',
    'objid',
    'bool',
    'gentime',
    'utctime',
    'null_',
    'enum',
    'int',
    'objDesc',
    'bitstr',
    'bmpstr',
    'charstr',
    'genstr',
    'graphstr',
    'ia5str',
    'iso646str',
    'numstr',
    'octstr',
    'printstr',
    't61str',
    'unistr',
    'utf8str',
    'videostr'
];
// Public methods list
var methods = [
    'key',
    'obj',
    'use',
    'optional',
    'explicit',
    'implicit',
    'def',
    'choice',
    'any',
    'contains'
].concat(tags);
// Overrided methods list
var overrided = [
    '_peekTag',
    '_decodeTag',
    '_use',
    '_decodeStr',
    '_decodeObjid',
    '_decodeTime',
    '_decodeNull',
    '_decodeInt',
    '_decodeBool',
    '_decodeList',
    '_encodeComposite',
    '_encodeStr',
    '_encodeObjid',
    '_encodeTime',
    '_encodeNull',
    '_encodeInt',
    '_encodeBool'
];
function Node(enc, parent) {
    var state = {};
    this._baseState = state;
    state.enc = enc;
    state.parent = parent || null;
    state.children = null;
    // State
    state.tag = null;
    state.args = null;
    state.reverseArgs = null;
    state.choice = null;
    state.optional = false;
    state.any = false;
    state.obj = false;
    state.use = null;
    state.useDecoder = null;
    state.key = null;
    state['default'] = null;
    state.explicit = null;
    state.implicit = null;
    state.contains = null;
    // Should create new instance on each method
    if (!state.parent) {
        state.children = [];
        this._wrap();
    }
}
module.exports = Node;
var stateProps = [
    'enc',
    'parent',
    'children',
    'tag',
    'args',
    'reverseArgs',
    'choice',
    'optional',
    'any',
    'obj',
    'use',
    'alteredUse',
    'key',
    'default',
    'explicit',
    'implicit',
    'contains'
];
Node.prototype.clone = function clone() {
    var state = this._baseState;
    var cstate = {};
    stateProps.forEach(function(prop) {
        cstate[prop] = state[prop];
    });
    var res = new this.constructor(cstate.parent);
    res._baseState = cstate;
    return res;
};
Node.prototype._wrap = function wrap() {
    var state = this._baseState;
    methods.forEach(function(method) {
        this[method] = function _wrappedMethod() {
            var clone = new this.constructor(this);
            state.children.push(clone);
            return clone[method].apply(clone, arguments);
        };
    }, this);
};
Node.prototype._init = function init(body) {
    var state = this._baseState;
    assert(state.parent === null);
    body.call(this);
    // Filter children
    state.children = state.children.filter(function(child) {
        return child._baseState.parent === this;
    }, this);
    assert.equal(state.children.length, 1, 'Root node can have only one child');
};
Node.prototype._useArgs = function useArgs(args) {
    var state = this._baseState;
    // Filter children and args
    var children = args.filter(function(arg) {
        return arg instanceof this.constructor;
    }, this);
    args = args.filter(function(arg) {
        return !(arg instanceof this.constructor);
    }, this);
    if (children.length !== 0) {
        assert(state.children === null);
        state.children = children;
        // Replace parent to maintain backward link
        children.forEach(function(child) {
            child._baseState.parent = this;
        }, this);
    }
    if (args.length !== 0) {
        assert(state.args === null);
        state.args = args;
        state.reverseArgs = args.map(function(arg) {
            if (typeof arg !== 'object' || arg.constructor !== Object) return arg;
            var res = {};
            Object.keys(arg).forEach(function(key) {
                if (key == (key | 0)) key |= 0;
                var value = arg[key];
                res[value] = key;
            });
            return res;
        });
    }
};
//
// Overrided methods
//
overrided.forEach(function(method) {
    Node.prototype[method] = function _overrided() {
        var state = this._baseState;
        throw new Error(method + ' not implemented for encoding: ' + state.enc);
    };
});
//
// Public methods
//
tags.forEach(function(tag) {
    Node.prototype[tag] = function _tagMethod() {
        var state = this._baseState;
        var args = Array.prototype.slice.call(arguments);
        assert(state.tag === null);
        state.tag = tag;
        this._useArgs(args);
        return this;
    };
});
Node.prototype.use = function use(item) {
    assert(item);
    var state = this._baseState;
    assert(state.use === null);
    state.use = item;
    return this;
};
Node.prototype.optional = function optional() {
    var state = this._baseState;
    state.optional = true;
    return this;
};
Node.prototype.def = function def(val) {
    var state = this._baseState;
    assert(state['default'] === null);
    state['default'] = val;
    state.optional = true;
    return this;
};
Node.prototype.explicit = function explicit(num) {
    var state = this._baseState;
    assert(state.explicit === null && state.implicit === null);
    state.explicit = num;
    return this;
};
Node.prototype.implicit = function implicit(num) {
    var state = this._baseState;
    assert(state.explicit === null && state.implicit === null);
    state.implicit = num;
    return this;
};
Node.prototype.obj = function obj() {
    var state = this._baseState;
    var args = Array.prototype.slice.call(arguments);
    state.obj = true;
    if (args.length !== 0) this._useArgs(args);
    return this;
};
Node.prototype.key = function key(newKey) {
    var state = this._baseState;
    assert(state.key === null);
    state.key = newKey;
    return this;
};
Node.prototype.any = function any() {
    var state = this._baseState;
    state.any = true;
    return this;
};
Node.prototype.choice = function choice(obj) {
    var state = this._baseState;
    assert(state.choice === null);
    state.choice = obj;
    this._useArgs(Object.keys(obj).map(function(key) {
        return obj[key];
    }));
    return this;
};
Node.prototype.contains = function contains(item) {
    var state = this._baseState;
    assert(state.use === null);
    state.contains = item;
    return this;
};
//
// Decoding
//
Node.prototype._decode = function decode(input, options) {
    var state = this._baseState;
    // Decode root node
    if (state.parent === null) return input.wrapResult(state.children[0]._decode(input, options));
    var result = state['default'];
    var present = true;
    var prevKey = null;
    if (state.key !== null) prevKey = input.enterKey(state.key);
    // Check if tag is there
    if (state.optional) {
        var tag = null;
        if (state.explicit !== null) tag = state.explicit;
        else if (state.implicit !== null) tag = state.implicit;
        else if (state.tag !== null) tag = state.tag;
        if (tag === null && !state.any) {
            // Trial and Error
            var save = input.save();
            try {
                if (state.choice === null) this._decodeGeneric(state.tag, input, options);
                else this._decodeChoice(input, options);
                present = true;
            } catch (e) {
                present = false;
            }
            input.restore(save);
        } else {
            present = this._peekTag(input, tag, state.any);
            if (input.isError(present)) return present;
        }
    }
    // Push object on stack
    var prevObj;
    if (state.obj && present) prevObj = input.enterObject();
    if (present) {
        // Unwrap explicit values
        if (state.explicit !== null) {
            var explicit = this._decodeTag(input, state.explicit);
            if (input.isError(explicit)) return explicit;
            input = explicit;
        }
        var start = input.offset;
        // Unwrap implicit and normal values
        if (state.use === null && state.choice === null) {
            if (state.any) var save = input.save();
            var body = this._decodeTag(input, state.implicit !== null ? state.implicit : state.tag, state.any);
            if (input.isError(body)) return body;
            if (state.any) result = input.raw(save);
            else input = body;
        }
        if (options && options.track && state.tag !== null) options.track(input.path(), start, input.length, 'tagged');
        if (options && options.track && state.tag !== null) options.track(input.path(), input.offset, input.length, 'content');
        // Select proper method for tag
        if (state.any) result;
        else if (state.choice === null) result = this._decodeGeneric(state.tag, input, options);
        else result = this._decodeChoice(input, options);
        if (input.isError(result)) return result;
        // Decode children
        if (!state.any && state.choice === null && state.children !== null) state.children.forEach(function decodeChildren(child) {
            // NOTE: We are ignoring errors here, to let parser continue with other
            // parts of encoded data
            child._decode(input, options);
        });
        // Decode contained/encoded by schema, only in bit or octet strings
        if (state.contains && (state.tag === 'octstr' || state.tag === 'bitstr')) {
            var data = new DecoderBuffer(result);
            result = this._getUse(state.contains, input._reporterState.obj)._decode(data, options);
        }
    }
    // Pop object
    if (state.obj && present) result = input.leaveObject(prevObj);
    // Set key
    if (state.key !== null && (result !== null || present === true)) input.leaveKey(prevKey, state.key, result);
    else if (prevKey !== null) input.exitKey(prevKey);
    return result;
};
Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
    var state = this._baseState;
    if (tag === 'seq' || tag === 'set') return null;
    if (tag === 'seqof' || tag === 'setof') return this._decodeList(input, tag, state.args[0], options);
    else if (/str$/.test(tag)) return this._decodeStr(input, tag, options);
    else if (tag === 'objid' && state.args) return this._decodeObjid(input, state.args[0], state.args[1], options);
    else if (tag === 'objid') return this._decodeObjid(input, null, null, options);
    else if (tag === 'gentime' || tag === 'utctime') return this._decodeTime(input, tag, options);
    else if (tag === 'null_') return this._decodeNull(input, options);
    else if (tag === 'bool') return this._decodeBool(input, options);
    else if (tag === 'objDesc') return this._decodeStr(input, tag, options);
    else if (tag === 'int' || tag === 'enum') return this._decodeInt(input, state.args && state.args[0], options);
    if (state.use !== null) return this._getUse(state.use, input._reporterState.obj)._decode(input, options);
    else return input.error('unknown tag: ' + tag);
};
Node.prototype._getUse = function _getUse(entity, obj) {
    var state = this._baseState;
    // Create altered use decoder if implicit is set
    state.useDecoder = this._use(entity, obj);
    assert(state.useDecoder._baseState.parent === null);
    state.useDecoder = state.useDecoder._baseState.children[0];
    if (state.implicit !== state.useDecoder._baseState.implicit) {
        state.useDecoder = state.useDecoder.clone();
        state.useDecoder._baseState.implicit = state.implicit;
    }
    return state.useDecoder;
};
Node.prototype._decodeChoice = function decodeChoice(input, options) {
    var state = this._baseState;
    var result = null;
    var match = false;
    Object.keys(state.choice).some(function(key) {
        var save = input.save();
        var node = state.choice[key];
        try {
            var value = node._decode(input, options);
            if (input.isError(value)) return false;
            result = {
                type: key,
                value: value
            };
            match = true;
        } catch (e) {
            input.restore(save);
            return false;
        }
        return true;
    }, this);
    if (!match) return input.error('Choice not matched');
    return result;
};
//
// Encoding
//
Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
    return new EncoderBuffer(data, this.reporter);
};
Node.prototype._encode = function encode(data, reporter, parent) {
    var state = this._baseState;
    if (state['default'] !== null && state['default'] === data) return;
    var result = this._encodeValue(data, reporter, parent);
    if (result === undefined) return;
    if (this._skipDefault(result, reporter, parent)) return;
    return result;
};
Node.prototype._encodeValue = function encode(data, reporter, parent) {
    var state = this._baseState;
    // Decode root node
    if (state.parent === null) return state.children[0]._encode(data, reporter || new Reporter());
    var result = null;
    // Set reporter to share it with a child class
    this.reporter = reporter;
    // Check if data is there
    if (state.optional && data === undefined) {
        if (state['default'] !== null) data = state['default'];
        else return;
    }
    // Encode children first
    var content = null;
    var primitive = false;
    if (state.any) // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
    else if (state.choice) result = this._encodeChoice(data, reporter);
    else if (state.contains) {
        content = this._getUse(state.contains, parent)._encode(data, reporter);
        primitive = true;
    } else if (state.children) {
        content = state.children.map(function(child) {
            if (child._baseState.tag === 'null_') return child._encode(null, reporter, data);
            if (child._baseState.key === null) return reporter.error('Child should have a key');
            var prevKey = reporter.enterKey(child._baseState.key);
            if (typeof data !== 'object') return reporter.error('Child expected, but input is not object');
            var res = child._encode(data[child._baseState.key], reporter, data);
            reporter.leaveKey(prevKey);
            return res;
        }, this).filter(function(child) {
            return child;
        });
        content = this._createEncoderBuffer(content);
    } else {
        if (state.tag === 'seqof' || state.tag === 'setof') {
            // TODO(indutny): this should be thrown on DSL level
            if (!(state.args && state.args.length === 1)) return reporter.error('Too many args for : ' + state.tag);
            if (!Array.isArray(data)) return reporter.error('seqof/setof, but data is not Array');
            var child = this.clone();
            child._baseState.implicit = null;
            content = this._createEncoderBuffer(data.map(function(item) {
                var state = this._baseState;
                return this._getUse(state.args[0], data)._encode(item, reporter);
            }, child));
        } else if (state.use !== null) result = this._getUse(state.use, parent)._encode(data, reporter);
        else {
            content = this._encodePrimitive(state.tag, data);
            primitive = true;
        }
    }
    // Encode data itself
    var result;
    if (!state.any && state.choice === null) {
        var tag = state.implicit !== null ? state.implicit : state.tag;
        var cls = state.implicit === null ? 'universal' : 'context';
        if (tag === null) {
            if (state.use === null) reporter.error('Tag could be omitted only for .use()');
        } else if (state.use === null) result = this._encodeComposite(tag, primitive, cls, content);
    }
    // Wrap in explicit
    if (state.explicit !== null) result = this._encodeComposite(state.explicit, false, 'context', result);
    return result;
};
Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
    var state = this._baseState;
    var node = state.choice[data.type];
    if (!node) assert(false, data.type + ' not found in ' + JSON.stringify(Object.keys(state.choice)));
    return node._encode(data.value, reporter);
};
Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
    var state = this._baseState;
    if (/str$/.test(tag)) return this._encodeStr(data, tag);
    else if (tag === 'objid' && state.args) return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
    else if (tag === 'objid') return this._encodeObjid(data, null, null);
    else if (tag === 'gentime' || tag === 'utctime') return this._encodeTime(data, tag);
    else if (tag === 'null_') return this._encodeNull();
    else if (tag === 'int' || tag === 'enum') return this._encodeInt(data, state.args && state.reverseArgs[0]);
    else if (tag === 'bool') return this._encodeBool(data);
    else if (tag === 'objDesc') return this._encodeStr(data, tag);
    else throw new Error('Unsupported tag: ' + tag);
};
Node.prototype._isNumstr = function isNumstr(str) {
    return /^[0-9 ]*$/.test(str);
};
Node.prototype._isPrintstr = function isPrintstr(str) {
    return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(str);
};

},{"b93dc035fd1a2dd2":"l0BhD","1bf7ce79b1c01d8b":"kTSEF"}],"chuJM":[function(require,module,exports,__globalThis) {
var constants = exports;
// Helper
constants._reverse = function reverse(map) {
    var res = {};
    Object.keys(map).forEach(function(key) {
        // Convert key to integer if it is stringified
        if ((key | 0) == key) key = key | 0;
        var value = map[key];
        res[value] = key;
    });
    return res;
};
constants.der = require("cd34b6c5ba00554c");

},{"cd34b6c5ba00554c":"jJ8dI"}],"jJ8dI":[function(require,module,exports,__globalThis) {
var constants = require("c9de207563729b47");
exports.tagClass = {
    0: 'universal',
    1: 'application',
    2: 'context',
    3: 'private'
};
exports.tagClassByName = constants._reverse(exports.tagClass);
exports.tag = {
    0x00: 'end',
    0x01: 'bool',
    0x02: 'int',
    0x03: 'bitstr',
    0x04: 'octstr',
    0x05: 'null_',
    0x06: 'objid',
    0x07: 'objDesc',
    0x08: 'external',
    0x09: 'real',
    0x0a: 'enum',
    0x0b: 'embed',
    0x0c: 'utf8str',
    0x0d: 'relativeOid',
    0x10: 'seq',
    0x11: 'set',
    0x12: 'numstr',
    0x13: 'printstr',
    0x14: 't61str',
    0x15: 'videostr',
    0x16: 'ia5str',
    0x17: 'utctime',
    0x18: 'gentime',
    0x19: 'graphstr',
    0x1a: 'iso646str',
    0x1b: 'genstr',
    0x1c: 'unistr',
    0x1d: 'charstr',
    0x1e: 'bmpstr'
};
exports.tagByName = constants._reverse(exports.tag);

},{"c9de207563729b47":"chuJM"}],"8iIv3":[function(require,module,exports,__globalThis) {
var decoders = exports;
decoders.der = require("abb46f93da4a6a9");
decoders.pem = require("f1e062afeaaaac02");

},{"abb46f93da4a6a9":"fjzxl","f1e062afeaaaac02":"fJTly"}],"fjzxl":[function(require,module,exports,__globalThis) {
var inherits = require("7c238308bb002386");
var asn1 = require("2acbc866baed26c6");
var base = asn1.base;
var bignum = asn1.bignum;
// Import DER constants
var der = asn1.constants.der;
function DERDecoder(entity) {
    this.enc = 'der';
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new DERNode();
    this.tree._init(entity.body);
}
module.exports = DERDecoder;
DERDecoder.prototype.decode = function decode(data, options) {
    if (!(data instanceof base.DecoderBuffer)) data = new base.DecoderBuffer(data, options);
    return this.tree._decode(data, options);
};
// Tree methods
function DERNode(parent) {
    base.Node.call(this, 'der', parent);
}
inherits(DERNode, base.Node);
DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
    if (buffer.isEmpty()) return false;
    var state = buffer.save();
    var decodedTag = derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    buffer.restore(state);
    return decodedTag.tag === tag || decodedTag.tagStr === tag || decodedTag.tagStr + 'of' === tag || any;
};
DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
    var decodedTag = derDecodeTag(buffer, 'Failed to decode tag of "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    var len = derDecodeLen(buffer, decodedTag.primitive, 'Failed to get length of "' + tag + '"');
    // Failure
    if (buffer.isError(len)) return len;
    if (!any && decodedTag.tag !== tag && decodedTag.tagStr !== tag && decodedTag.tagStr + 'of' !== tag) return buffer.error('Failed to match tag: "' + tag + '"');
    if (decodedTag.primitive || len !== null) return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
    // Indefinite length... find END tag
    var state = buffer.save();
    var res = this._skipUntilEnd(buffer, 'Failed to skip indefinite length body: "' + this.tag + '"');
    if (buffer.isError(res)) return res;
    len = buffer.offset - state.offset;
    buffer.restore(state);
    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};
DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
    while(true){
        var tag = derDecodeTag(buffer, fail);
        if (buffer.isError(tag)) return tag;
        var len = derDecodeLen(buffer, tag.primitive, fail);
        if (buffer.isError(len)) return len;
        var res;
        if (tag.primitive || len !== null) res = buffer.skip(len);
        else res = this._skipUntilEnd(buffer, fail);
        // Failure
        if (buffer.isError(res)) return res;
        if (tag.tagStr === 'end') break;
    }
};
DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder, options) {
    var result = [];
    while(!buffer.isEmpty()){
        var possibleEnd = this._peekTag(buffer, 'end');
        if (buffer.isError(possibleEnd)) return possibleEnd;
        var res = decoder.decode(buffer, 'der', options);
        if (buffer.isError(res) && possibleEnd) break;
        result.push(res);
    }
    return result;
};
DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
    if (tag === 'bitstr') {
        var unused = buffer.readUInt8();
        if (buffer.isError(unused)) return unused;
        return {
            unused: unused,
            data: buffer.raw()
        };
    } else if (tag === 'bmpstr') {
        var raw = buffer.raw();
        if (raw.length % 2 === 1) return buffer.error('Decoding of string type: bmpstr length mismatch');
        var str = '';
        for(var i = 0; i < raw.length / 2; i++)str += String.fromCharCode(raw.readUInt16BE(i * 2));
        return str;
    } else if (tag === 'numstr') {
        var numstr = buffer.raw().toString('ascii');
        if (!this._isNumstr(numstr)) return buffer.error("Decoding of string type: numstr unsupported characters");
        return numstr;
    } else if (tag === 'octstr') return buffer.raw();
    else if (tag === 'objDesc') return buffer.raw();
    else if (tag === 'printstr') {
        var printstr = buffer.raw().toString('ascii');
        if (!this._isPrintstr(printstr)) return buffer.error("Decoding of string type: printstr unsupported characters");
        return printstr;
    } else if (/str$/.test(tag)) return buffer.raw().toString();
    else return buffer.error('Decoding of string type: ' + tag + ' unsupported');
};
DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
    var result;
    var identifiers = [];
    var ident = 0;
    while(!buffer.isEmpty()){
        var subident = buffer.readUInt8();
        ident <<= 7;
        ident |= subident & 0x7f;
        if ((subident & 0x80) === 0) {
            identifiers.push(ident);
            ident = 0;
        }
    }
    if (subident & 0x80) identifiers.push(ident);
    var first = identifiers[0] / 40 | 0;
    var second = identifiers[0] % 40;
    if (relative) result = identifiers;
    else result = [
        first,
        second
    ].concat(identifiers.slice(1));
    if (values) {
        var tmp = values[result.join(' ')];
        if (tmp === undefined) tmp = values[result.join('.')];
        if (tmp !== undefined) result = tmp;
    }
    return result;
};
DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
    var str = buffer.raw().toString();
    if (tag === 'gentime') {
        var year = str.slice(0, 4) | 0;
        var mon = str.slice(4, 6) | 0;
        var day = str.slice(6, 8) | 0;
        var hour = str.slice(8, 10) | 0;
        var min = str.slice(10, 12) | 0;
        var sec = str.slice(12, 14) | 0;
    } else if (tag === 'utctime') {
        var year = str.slice(0, 2) | 0;
        var mon = str.slice(2, 4) | 0;
        var day = str.slice(4, 6) | 0;
        var hour = str.slice(6, 8) | 0;
        var min = str.slice(8, 10) | 0;
        var sec = str.slice(10, 12) | 0;
        if (year < 70) year = 2000 + year;
        else year = 1900 + year;
    } else return buffer.error('Decoding ' + tag + ' time is not supported yet');
    return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};
DERNode.prototype._decodeNull = function decodeNull(buffer) {
    return null;
};
DERNode.prototype._decodeBool = function decodeBool(buffer) {
    var res = buffer.readUInt8();
    if (buffer.isError(res)) return res;
    else return res !== 0;
};
DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
    // Bigint, return as it is (assume big endian)
    var raw = buffer.raw();
    var res = new bignum(raw);
    if (values) res = values[res.toString(10)] || res;
    return res;
};
DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === 'function') entity = entity(obj);
    return entity._getDecoder('der').tree;
};
// Utility methods
function derDecodeTag(buf, fail) {
    var tag = buf.readUInt8(fail);
    if (buf.isError(tag)) return tag;
    var cls = der.tagClass[tag >> 6];
    var primitive = (tag & 0x20) === 0;
    // Multi-octet tag - load
    if ((tag & 0x1f) === 0x1f) {
        var oct = tag;
        tag = 0;
        while((oct & 0x80) === 0x80){
            oct = buf.readUInt8(fail);
            if (buf.isError(oct)) return oct;
            tag <<= 7;
            tag |= oct & 0x7f;
        }
    } else tag &= 0x1f;
    var tagStr = der.tag[tag];
    return {
        cls: cls,
        primitive: primitive,
        tag: tag,
        tagStr: tagStr
    };
}
function derDecodeLen(buf, primitive, fail) {
    var len = buf.readUInt8(fail);
    if (buf.isError(len)) return len;
    // Indefinite form
    if (!primitive && len === 0x80) return null;
    // Definite form
    if ((len & 0x80) === 0) // Short form
    return len;
    // Long form
    var num = len & 0x7f;
    if (num > 4) return buf.error('length octect is too long');
    len = 0;
    for(var i = 0; i < num; i++){
        len <<= 8;
        var j = buf.readUInt8(fail);
        if (buf.isError(j)) return j;
        len |= j;
    }
    return len;
}

},{"7c238308bb002386":"dwCbX","2acbc866baed26c6":"dGTNO"}],"fJTly":[function(require,module,exports,__globalThis) {
var inherits = require("c2d50a9d5a6f334a");
var Buffer = require("883f76082a59dd03").Buffer;
var DERDecoder = require("dc9bd6cca8dafd6");
function PEMDecoder(entity) {
    DERDecoder.call(this, entity);
    this.enc = 'pem';
}
inherits(PEMDecoder, DERDecoder);
module.exports = PEMDecoder;
PEMDecoder.prototype.decode = function decode(data, options) {
    var lines = data.toString().split(/[\r\n]+/g);
    var label = options.label.toUpperCase();
    var re = /^-----(BEGIN|END) ([^-]+)-----$/;
    var start = -1;
    var end = -1;
    for(var i = 0; i < lines.length; i++){
        var match = lines[i].match(re);
        if (match === null) continue;
        if (match[2] !== label) continue;
        if (start === -1) {
            if (match[1] !== 'BEGIN') break;
            start = i;
        } else {
            if (match[1] !== 'END') break;
            end = i;
            break;
        }
    }
    if (start === -1 || end === -1) throw new Error('PEM section not found for: ' + label);
    var base64 = lines.slice(start + 1, end).join('');
    // Remove excessive symbols
    base64.replace(/[^a-z0-9\+\/=]+/gi, '');
    var input = new Buffer(base64, 'base64');
    return DERDecoder.prototype.decode.call(this, input, options);
};

},{"c2d50a9d5a6f334a":"dwCbX","883f76082a59dd03":"cjdyz","dc9bd6cca8dafd6":"fjzxl"}],"bVy39":[function(require,module,exports,__globalThis) {
var encoders = exports;
encoders.der = require("6153180e09514e51");
encoders.pem = require("babaf0c4b3d9210a");

},{"6153180e09514e51":"1uCEX","babaf0c4b3d9210a":"bo0h6"}],"1uCEX":[function(require,module,exports,__globalThis) {
var inherits = require("94789e1422bf21a1");
var Buffer = require("41574641d7de4531").Buffer;
var asn1 = require("9d8c942bce7973a8");
var base = asn1.base;
// Import DER constants
var der = asn1.constants.der;
function DEREncoder(entity) {
    this.enc = 'der';
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new DERNode();
    this.tree._init(entity.body);
}
module.exports = DEREncoder;
DEREncoder.prototype.encode = function encode(data, reporter) {
    return this.tree._encode(data, reporter).join();
};
// Tree methods
function DERNode(parent) {
    base.Node.call(this, 'der', parent);
}
inherits(DERNode, base.Node);
DERNode.prototype._encodeComposite = function encodeComposite(tag, primitive, cls, content) {
    var encodedTag = encodeTag(tag, primitive, cls, this.reporter);
    // Short form
    if (content.length < 0x80) {
        var header = new Buffer(2);
        header[0] = encodedTag;
        header[1] = content.length;
        return this._createEncoderBuffer([
            header,
            content
        ]);
    }
    // Long form
    // Count octets required to store length
    var lenOctets = 1;
    for(var i = content.length; i >= 0x100; i >>= 8)lenOctets++;
    var header = new Buffer(2 + lenOctets);
    header[0] = encodedTag;
    header[1] = 0x80 | lenOctets;
    for(var i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)header[i] = j & 0xff;
    return this._createEncoderBuffer([
        header,
        content
    ]);
};
DERNode.prototype._encodeStr = function encodeStr(str, tag) {
    if (tag === 'bitstr') return this._createEncoderBuffer([
        str.unused | 0,
        str.data
    ]);
    else if (tag === 'bmpstr') {
        var buf = new Buffer(str.length * 2);
        for(var i = 0; i < str.length; i++)buf.writeUInt16BE(str.charCodeAt(i), i * 2);
        return this._createEncoderBuffer(buf);
    } else if (tag === 'numstr') {
        if (!this._isNumstr(str)) return this.reporter.error("Encoding of string type: numstr supports only digits and space");
        return this._createEncoderBuffer(str);
    } else if (tag === 'printstr') {
        if (!this._isPrintstr(str)) return this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark");
        return this._createEncoderBuffer(str);
    } else if (/str$/.test(tag)) return this._createEncoderBuffer(str);
    else if (tag === 'objDesc') return this._createEncoderBuffer(str);
    else return this.reporter.error('Encoding of string type: ' + tag + ' unsupported');
};
DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
    if (typeof id === 'string') {
        if (!values) return this.reporter.error('string objid given, but no values map found');
        if (!values.hasOwnProperty(id)) return this.reporter.error('objid not found in values map');
        id = values[id].split(/[\s\.]+/g);
        for(var i = 0; i < id.length; i++)id[i] |= 0;
    } else if (Array.isArray(id)) {
        id = id.slice();
        for(var i = 0; i < id.length; i++)id[i] |= 0;
    }
    if (!Array.isArray(id)) return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(id));
    if (!relative) {
        if (id[1] >= 40) return this.reporter.error('Second objid identifier OOB');
        id.splice(0, 2, id[0] * 40 + id[1]);
    }
    // Count number of octets
    var size = 0;
    for(var i = 0; i < id.length; i++){
        var ident = id[i];
        for(size++; ident >= 0x80; ident >>= 7)size++;
    }
    var objid = new Buffer(size);
    var offset = objid.length - 1;
    for(var i = id.length - 1; i >= 0; i--){
        var ident = id[i];
        objid[offset--] = ident & 0x7f;
        while((ident >>= 7) > 0)objid[offset--] = 0x80 | ident & 0x7f;
    }
    return this._createEncoderBuffer(objid);
};
function two(num) {
    if (num < 10) return '0' + num;
    else return num;
}
DERNode.prototype._encodeTime = function encodeTime(time, tag) {
    var str;
    var date = new Date(time);
    if (tag === 'gentime') str = [
        two(date.getFullYear()),
        two(date.getUTCMonth() + 1),
        two(date.getUTCDate()),
        two(date.getUTCHours()),
        two(date.getUTCMinutes()),
        two(date.getUTCSeconds()),
        'Z'
    ].join('');
    else if (tag === 'utctime') str = [
        two(date.getFullYear() % 100),
        two(date.getUTCMonth() + 1),
        two(date.getUTCDate()),
        two(date.getUTCHours()),
        two(date.getUTCMinutes()),
        two(date.getUTCSeconds()),
        'Z'
    ].join('');
    else this.reporter.error('Encoding ' + tag + ' time is not supported yet');
    return this._encodeStr(str, 'octstr');
};
DERNode.prototype._encodeNull = function encodeNull() {
    return this._createEncoderBuffer('');
};
DERNode.prototype._encodeInt = function encodeInt(num, values) {
    if (typeof num === 'string') {
        if (!values) return this.reporter.error('String int or enum given, but no values map');
        if (!values.hasOwnProperty(num)) return this.reporter.error('Values map doesn\'t contain: ' + JSON.stringify(num));
        num = values[num];
    }
    // Bignum, assume big endian
    if (typeof num !== 'number' && !Buffer.isBuffer(num)) {
        var numArray = num.toArray();
        if (!num.sign && numArray[0] & 0x80) numArray.unshift(0);
        num = new Buffer(numArray);
    }
    if (Buffer.isBuffer(num)) {
        var size = num.length;
        if (num.length === 0) size++;
        var out = new Buffer(size);
        num.copy(out);
        if (num.length === 0) out[0] = 0;
        return this._createEncoderBuffer(out);
    }
    if (num < 0x80) return this._createEncoderBuffer(num);
    if (num < 0x100) return this._createEncoderBuffer([
        0,
        num
    ]);
    var size = 1;
    for(var i = num; i >= 0x100; i >>= 8)size++;
    var out = new Array(size);
    for(var i = out.length - 1; i >= 0; i--){
        out[i] = num & 0xff;
        num >>= 8;
    }
    if (out[0] & 0x80) out.unshift(0);
    return this._createEncoderBuffer(new Buffer(out));
};
DERNode.prototype._encodeBool = function encodeBool(value) {
    return this._createEncoderBuffer(value ? 0xff : 0);
};
DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === 'function') entity = entity(obj);
    return entity._getEncoder('der').tree;
};
DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
    var state = this._baseState;
    var i;
    if (state['default'] === null) return false;
    var data = dataBuffer.join();
    if (state.defaultBuffer === undefined) state.defaultBuffer = this._encodeValue(state['default'], reporter, parent).join();
    if (data.length !== state.defaultBuffer.length) return false;
    for(i = 0; i < data.length; i++)if (data[i] !== state.defaultBuffer[i]) return false;
    return true;
};
// Utility methods
function encodeTag(tag, primitive, cls, reporter) {
    var res;
    if (tag === 'seqof') tag = 'seq';
    else if (tag === 'setof') tag = 'set';
    if (der.tagByName.hasOwnProperty(tag)) res = der.tagByName[tag];
    else if (typeof tag === 'number' && (tag | 0) === tag) res = tag;
    else return reporter.error('Unknown tag: ' + tag);
    if (res >= 0x1f) return reporter.error('Multi-octet tag encoding unsupported');
    if (!primitive) res |= 0x20;
    res |= der.tagClassByName[cls || 'universal'] << 6;
    return res;
}

},{"94789e1422bf21a1":"dwCbX","41574641d7de4531":"cjdyz","9d8c942bce7973a8":"dGTNO"}],"bo0h6":[function(require,module,exports,__globalThis) {
var inherits = require("bc3c7930ded74eee");
var DEREncoder = require("cf885a4234262436");
function PEMEncoder(entity) {
    DEREncoder.call(this, entity);
    this.enc = 'pem';
}
inherits(PEMEncoder, DEREncoder);
module.exports = PEMEncoder;
PEMEncoder.prototype.encode = function encode(data, options) {
    var buf = DEREncoder.prototype.encode.call(this, data);
    var p = buf.toString('base64');
    var out = [
        '-----BEGIN ' + options.label + '-----'
    ];
    for(var i = 0; i < p.length; i += 64)out.push(p.slice(i, i + 64));
    out.push('-----END ' + options.label + '-----');
    return out.join('\n');
};

},{"bc3c7930ded74eee":"dwCbX","cf885a4234262436":"1uCEX"}],"5Jsvw":[function(require,module,exports,__globalThis) {
// from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
// thanks to @Rantanen
'use strict';
var asn = require("373dc11d39ac511a");
var Time = asn.define('Time', function() {
    this.choice({
        utcTime: this.utctime(),
        generalTime: this.gentime()
    });
});
var AttributeTypeValue = asn.define('AttributeTypeValue', function() {
    this.seq().obj(this.key('type').objid(), this.key('value').any());
});
var AlgorithmIdentifier = asn.define('AlgorithmIdentifier', function() {
    this.seq().obj(this.key('algorithm').objid(), this.key('parameters').optional(), this.key('curve').objid().optional());
});
var SubjectPublicKeyInfo = asn.define('SubjectPublicKeyInfo', function() {
    this.seq().obj(this.key('algorithm').use(AlgorithmIdentifier), this.key('subjectPublicKey').bitstr());
});
var RelativeDistinguishedName = asn.define('RelativeDistinguishedName', function() {
    this.setof(AttributeTypeValue);
});
var RDNSequence = asn.define('RDNSequence', function() {
    this.seqof(RelativeDistinguishedName);
});
var Name = asn.define('Name', function() {
    this.choice({
        rdnSequence: this.use(RDNSequence)
    });
});
var Validity = asn.define('Validity', function() {
    this.seq().obj(this.key('notBefore').use(Time), this.key('notAfter').use(Time));
});
var Extension = asn.define('Extension', function() {
    this.seq().obj(this.key('extnID').objid(), this.key('critical').bool().def(false), this.key('extnValue').octstr());
});
var TBSCertificate = asn.define('TBSCertificate', function() {
    this.seq().obj(this.key('version').explicit(0)['int']().optional(), this.key('serialNumber')['int'](), this.key('signature').use(AlgorithmIdentifier), this.key('issuer').use(Name), this.key('validity').use(Validity), this.key('subject').use(Name), this.key('subjectPublicKeyInfo').use(SubjectPublicKeyInfo), this.key('issuerUniqueID').implicit(1).bitstr().optional(), this.key('subjectUniqueID').implicit(2).bitstr().optional(), this.key('extensions').explicit(3).seqof(Extension).optional());
});
var X509Certificate = asn.define('X509Certificate', function() {
    this.seq().obj(this.key('tbsCertificate').use(TBSCertificate), this.key('signatureAlgorithm').use(AlgorithmIdentifier), this.key('signatureValue').bitstr());
});
module.exports = X509Certificate;

},{"373dc11d39ac511a":"dGTNO"}],"5wRPi":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"2.16.840.1.101.3.4.1.1\":\"aes-128-ecb\",\"2.16.840.1.101.3.4.1.2\":\"aes-128-cbc\",\"2.16.840.1.101.3.4.1.3\":\"aes-128-ofb\",\"2.16.840.1.101.3.4.1.4\":\"aes-128-cfb\",\"2.16.840.1.101.3.4.1.21\":\"aes-192-ecb\",\"2.16.840.1.101.3.4.1.22\":\"aes-192-cbc\",\"2.16.840.1.101.3.4.1.23\":\"aes-192-ofb\",\"2.16.840.1.101.3.4.1.24\":\"aes-192-cfb\",\"2.16.840.1.101.3.4.1.41\":\"aes-256-ecb\",\"2.16.840.1.101.3.4.1.42\":\"aes-256-cbc\",\"2.16.840.1.101.3.4.1.43\":\"aes-256-ofb\",\"2.16.840.1.101.3.4.1.44\":\"aes-256-cfb\"}");

},{}],"8Llnq":[function(require,module,exports,__globalThis) {
'use strict';
// adapted from https://github.com/apatil/pemstrip
var findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m;
var startRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m;
var fullRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m;
var evp = require("482ca5fecee84bd1");
var ciphers = require("5e77b1b6b79a5d20");
var Buffer = require("fcf1038e6a690508").Buffer;
module.exports = function(okey, password) {
    var key = okey.toString();
    var match = key.match(findProc);
    var decrypted;
    if (!match) {
        var match2 = key.match(fullRegex);
        decrypted = Buffer.from(match2[2].replace(/[\r\n]/g, ''), 'base64');
    } else {
        var suite = 'aes' + match[1];
        var iv = Buffer.from(match[2], 'hex');
        var cipherText = Buffer.from(match[3].replace(/[\r\n]/g, ''), 'base64');
        var cipherKey = evp(password, iv.slice(0, 8), parseInt(match[1], 10)).key;
        var out = [];
        var cipher = ciphers.createDecipheriv(suite, cipherKey, iv);
        out.push(cipher.update(cipherText));
        out.push(cipher['final']());
        decrypted = Buffer.concat(out);
    }
    var tag = key.match(startRegex)[1];
    return {
        tag: tag,
        data: decrypted
    };
};

},{"482ca5fecee84bd1":"9zBbP","5e77b1b6b79a5d20":"3oQJX","fcf1038e6a690508":"1Yph5"}],"d1eQF":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"1.3.132.0.10\":\"secp256k1\",\"1.3.132.0.33\":\"p224\",\"1.2.840.10045.3.1.1\":\"p192\",\"1.2.840.10045.3.1.7\":\"p256\",\"1.3.132.0.34\":\"p384\",\"1.3.132.0.35\":\"p521\"}");

},{}],"lKdnm":[function(require,module,exports,__globalThis) {
'use strict';
// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js
var Buffer = require("c893e8283afd176a").Buffer;
var BN = require("18576d045784617e");
var EC = require("9429de8047bf329a").ec;
var parseKeys = require("88de5f3d7e6f8c00");
var curves = require("69d69f2e18a199ce");
function verify(sig, hash, key, signType, tag) {
    var pub = parseKeys(key);
    if (pub.type === 'ec') {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type');
        return ecVerify(sig, hash, pub);
    } else if (pub.type === 'dsa') {
        if (signType !== 'dsa') throw new Error('wrong public key type');
        return dsaVerify(sig, hash, pub);
    }
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type');
    hash = Buffer.concat([
        tag,
        hash
    ]);
    var len = pub.modulus.byteLength();
    var pad = [
        1
    ];
    var padNum = 0;
    while(hash.length + pad.length + 2 < len){
        pad.push(0xff);
        padNum += 1;
    }
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    pad = Buffer.from(pad);
    var red = BN.mont(pub.modulus);
    sig = new BN(sig).toRed(red);
    sig = sig.redPow(new BN(pub.publicExponent));
    sig = Buffer.from(sig.fromRed().toArray());
    var out = padNum < 8 ? 1 : 0;
    len = Math.min(sig.length, pad.length);
    if (sig.length !== pad.length) out = 1;
    i = -1;
    while(++i < len)out |= sig[i] ^ pad[i];
    return out === 0;
}
function ecVerify(sig, hash, pub) {
    var curveId = curves[pub.data.algorithm.curve.join('.')];
    if (!curveId) throw new Error('unknown curve ' + pub.data.algorithm.curve.join('.'));
    var curve = new EC(curveId);
    var pubkey = pub.data.subjectPrivateKey.data;
    return curve.verify(hash, sig, pubkey);
}
function dsaVerify(sig, hash, pub) {
    var p = pub.data.p;
    var q = pub.data.q;
    var g = pub.data.g;
    var y = pub.data.pub_key;
    var unpacked = parseKeys.signature.decode(sig, 'der');
    var s = unpacked.s;
    var r = unpacked.r;
    checkValue(s, q);
    checkValue(r, q);
    var montp = BN.mont(p);
    var w = s.invm(q);
    var v = g.toRed(montp).redPow(new BN(hash).mul(w).mod(q)).fromRed().mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed()).mod(p).mod(q);
    return v.cmp(r) === 0;
}
function checkValue(b, q) {
    if (b.cmpn(0) <= 0) throw new Error('invalid sig');
    if (b.cmp(q) >= 0) throw new Error('invalid sig');
}
module.exports = verify;

},{"c893e8283afd176a":"1Yph5","18576d045784617e":"cohIo","9429de8047bf329a":"djGmg","88de5f3d7e6f8c00":"4ddHc","69d69f2e18a199ce":"d1eQF"}],"hGQW9":[function(require,module,exports,__globalThis) {
var Buffer = require("59d8fd0d64d5aa42").Buffer;
var elliptic = require("a6b1ec3b8e72335c");
var BN = require("8c5a992927812eef");
module.exports = function createECDH(curve) {
    return new ECDH(curve);
};
var aliases = {
    secp256k1: {
        name: 'secp256k1',
        byteLength: 32
    },
    secp224r1: {
        name: 'p224',
        byteLength: 28
    },
    prime256v1: {
        name: 'p256',
        byteLength: 32
    },
    prime192v1: {
        name: 'p192',
        byteLength: 24
    },
    ed25519: {
        name: 'ed25519',
        byteLength: 32
    },
    secp384r1: {
        name: 'p384',
        byteLength: 48
    },
    secp521r1: {
        name: 'p521',
        byteLength: 66
    }
};
aliases.p224 = aliases.secp224r1;
aliases.p256 = aliases.secp256r1 = aliases.prime256v1;
aliases.p192 = aliases.secp192r1 = aliases.prime192v1;
aliases.p384 = aliases.secp384r1;
aliases.p521 = aliases.secp521r1;
function ECDH(curve) {
    this.curveType = aliases[curve];
    if (!this.curveType) this.curveType = {
        name: curve
    };
    this.curve = new elliptic.ec(this.curveType.name) // eslint-disable-line new-cap
    ;
    this.keys = void 0;
}
ECDH.prototype.generateKeys = function(enc, format) {
    this.keys = this.curve.genKeyPair();
    return this.getPublicKey(enc, format);
};
ECDH.prototype.computeSecret = function(other, inenc, enc) {
    inenc = inenc || 'utf8';
    if (!Buffer.isBuffer(other)) other = new Buffer(other, inenc);
    var otherPub = this.curve.keyFromPublic(other).getPublic();
    var out = otherPub.mul(this.keys.getPrivate()).getX();
    return formatReturnValue(out, enc, this.curveType.byteLength);
};
ECDH.prototype.getPublicKey = function(enc, format) {
    var key = this.keys.getPublic(format === 'compressed', true);
    if (format === 'hybrid') {
        if (key[key.length - 1] % 2) key[0] = 7;
        else key[0] = 6;
    }
    return formatReturnValue(key, enc);
};
ECDH.prototype.getPrivateKey = function(enc) {
    return formatReturnValue(this.keys.getPrivate(), enc);
};
ECDH.prototype.setPublicKey = function(pub, enc) {
    enc = enc || 'utf8';
    if (!Buffer.isBuffer(pub)) pub = new Buffer(pub, enc);
    this.keys._importPublic(pub);
    return this;
};
ECDH.prototype.setPrivateKey = function(priv, enc) {
    enc = enc || 'utf8';
    if (!Buffer.isBuffer(priv)) priv = new Buffer(priv, enc);
    var _priv = new BN(priv);
    _priv = _priv.toString(16);
    this.keys = this.curve.genKeyPair();
    this.keys._importPrivate(_priv);
    return this;
};
function formatReturnValue(bn, enc, len) {
    if (!Array.isArray(bn)) bn = bn.toArray();
    var buf = new Buffer(bn);
    if (len && buf.length < len) {
        var zeros = new Buffer(len - buf.length);
        zeros.fill(0);
        buf = Buffer.concat([
            zeros,
            buf
        ]);
    }
    if (!enc) return buf;
    else return buf.toString(enc);
}

},{"59d8fd0d64d5aa42":"cjdyz","a6b1ec3b8e72335c":"djGmg","8c5a992927812eef":"llniD"}],"llniD":[function(require,module,exports,__globalThis) {
(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = require("1b9e2dcc2d1e58c5").Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) {
            this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
            i++;
        }
        // Clear words above the requested width so the result stays below 2 ** width
        for(; i < this.length; i++)this.words[i] = 0;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        if (num === 0) {
            this.length = 1;
            this._normSign();
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.mod.abs();
        var half = num.abs().iushrn(1);
        var r2 = num.words[0] & 1;
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up, away from zero
        var up = new BN(1);
        up.negative = this.negative ^ num.negative;
        return dm.div.iadd(up);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

},{"1b9e2dcc2d1e58c5":"4TE4R"}],"iUbRY":[function(require,module,exports,__globalThis) {
exports.publicEncrypt = require("d84cba4f52311cc8");
exports.privateDecrypt = require("f9c6d8fbe09b61c");
exports.privateEncrypt = function privateEncrypt(key, buf) {
    return exports.publicEncrypt(key, buf, true);
};
exports.publicDecrypt = function publicDecrypt(key, buf) {
    return exports.privateDecrypt(key, buf, true);
};

},{"d84cba4f52311cc8":"4MYNK","f9c6d8fbe09b61c":"kNYMl"}],"4MYNK":[function(require,module,exports,__globalThis) {
var parseKeys = require("ca2697dbde558d1");
var randomBytes = require("4704ad09aa96a56b");
var createHash = require("b8a92fd1d9e43252");
var mgf = require("469be15a31031bba");
var xor = require("f9f3694c0f7388b6");
var BN = require("cb7a38ec1a0039d7");
var withPublic = require("969e1e2dd90e2fbe");
var crt = require("9022efe01867a612");
var Buffer = require("d610bb618706f42f").Buffer;
module.exports = function publicEncrypt(publicKey, msg, reverse) {
    var padding;
    if (publicKey.padding) padding = publicKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = parseKeys(publicKey);
    var paddedMsg;
    if (padding === 4) paddedMsg = oaep(key, msg);
    else if (padding === 1) paddedMsg = pkcs1(key, msg, reverse);
    else if (padding === 3) {
        paddedMsg = new BN(msg);
        if (paddedMsg.cmp(key.modulus) >= 0) throw new Error('data too long for modulus');
    } else throw new Error('unknown padding');
    if (reverse) return crt(paddedMsg, key);
    else return withPublic(paddedMsg, key);
};
function oaep(key, msg) {
    var k = key.modulus.byteLength();
    var mLen = msg.length;
    var iHash = createHash('sha1').update(Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    var hLen2 = 2 * hLen;
    if (mLen > k - hLen2 - 2) throw new Error('message too long');
    var ps = Buffer.alloc(k - mLen - hLen2 - 2);
    var dblen = k - hLen - 1;
    var seed = randomBytes(hLen);
    var maskedDb = xor(Buffer.concat([
        iHash,
        ps,
        Buffer.alloc(1, 1),
        msg
    ], dblen), mgf(seed, dblen));
    var maskedSeed = xor(seed, mgf(maskedDb, hLen));
    return new BN(Buffer.concat([
        Buffer.alloc(1),
        maskedSeed,
        maskedDb
    ], k));
}
function pkcs1(key, msg, reverse) {
    var mLen = msg.length;
    var k = key.modulus.byteLength();
    if (mLen > k - 11) throw new Error('message too long');
    var ps;
    if (reverse) ps = Buffer.alloc(k - mLen - 3, 0xff);
    else ps = nonZero(k - mLen - 3);
    return new BN(Buffer.concat([
        Buffer.from([
            0,
            reverse ? 1 : 2
        ]),
        ps,
        Buffer.alloc(1),
        msg
    ], k));
}
function nonZero(len) {
    var out = Buffer.allocUnsafe(len);
    var i = 0;
    var cache = randomBytes(len * 2);
    var cur = 0;
    var num;
    while(i < len){
        if (cur === cache.length) {
            cache = randomBytes(len * 2);
            cur = 0;
        }
        num = cache[cur++];
        if (num) out[i++] = num;
    }
    return out;
}

},{"ca2697dbde558d1":"4ddHc","4704ad09aa96a56b":"jXr3f","b8a92fd1d9e43252":"aPKzt","469be15a31031bba":"2ZUyP","f9f3694c0f7388b6":"9YYMN","cb7a38ec1a0039d7":"grxMf","969e1e2dd90e2fbe":"62cp6","9022efe01867a612":"kxPiZ","d610bb618706f42f":"1Yph5"}],"2ZUyP":[function(require,module,exports,__globalThis) {
var createHash = require("b36bb21196daa39");
var Buffer = require("cfa1ea60eac1ebfa").Buffer;
module.exports = function(seed, len) {
    var t = Buffer.alloc(0);
    var i = 0;
    var c;
    while(t.length < len){
        c = i2ops(i++);
        t = Buffer.concat([
            t,
            createHash('sha1').update(seed).update(c).digest()
        ]);
    }
    return t.slice(0, len);
};
function i2ops(c) {
    var out = Buffer.allocUnsafe(4);
    out.writeUInt32BE(c, 0);
    return out;
}

},{"b36bb21196daa39":"aPKzt","cfa1ea60eac1ebfa":"1Yph5"}],"9YYMN":[function(require,module,exports,__globalThis) {
module.exports = function xor(a, b) {
    var len = a.length;
    var i = -1;
    while(++i < len)a[i] ^= b[i];
    return a;
};

},{}],"grxMf":[function(require,module,exports,__globalThis) {
(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = require("64c9d23ade4c9eaa").Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) {
            this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
            i++;
        }
        // Clear words above the requested width so the result stays below 2 ** width
        for(; i < this.length; i++)this.words[i] = 0;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        if (num === 0) {
            this.length = 1;
            this._normSign();
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.mod.abs();
        var half = num.abs().iushrn(1);
        var r2 = num.words[0] & 1;
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up, away from zero
        var up = new BN(1);
        up.negative = this.negative ^ num.negative;
        return dm.div.iadd(up);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

},{"64c9d23ade4c9eaa":"4TE4R"}],"62cp6":[function(require,module,exports,__globalThis) {
var BN = require("94162e508c4195c3");
var Buffer = require("1bab2adfd8072b94").Buffer;
function withPublic(paddedMsg, key) {
    return Buffer.from(paddedMsg.toRed(BN.mont(key.modulus)).redPow(new BN(key.publicExponent)).fromRed().toArray());
}
module.exports = withPublic;

},{"94162e508c4195c3":"grxMf","1bab2adfd8072b94":"1Yph5"}],"kNYMl":[function(require,module,exports,__globalThis) {
var parseKeys = require("6c46b1d8bb7eae7b");
var mgf = require("9e51003323ea065d");
var xor = require("637b57d34a8dda25");
var BN = require("3927561f39566b29");
var crt = require("521cbc4ce6042d5b");
var createHash = require("95282d7c0e66f364");
var withPublic = require("1bc2f92e3c398dbe");
var Buffer = require("802d086fb6d63368").Buffer;
module.exports = function privateDecrypt(privateKey, enc, reverse) {
    var padding;
    if (privateKey.padding) padding = privateKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = parseKeys(privateKey);
    var k = key.modulus.byteLength();
    if (enc.length > k || new BN(enc).cmp(key.modulus) >= 0) throw new Error('decryption error');
    var msg;
    if (reverse) msg = withPublic(new BN(enc), key);
    else msg = crt(enc, key);
    var zBuffer = Buffer.alloc(k - msg.length);
    msg = Buffer.concat([
        zBuffer,
        msg
    ], k);
    if (padding === 4) return oaep(key, msg);
    else if (padding === 1) return pkcs1(key, msg, reverse);
    else if (padding === 3) return msg;
    else throw new Error('unknown padding');
};
function oaep(key, msg) {
    var k = key.modulus.byteLength();
    var iHash = createHash('sha1').update(Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    if (msg[0] !== 0) throw new Error('decryption error');
    var maskedSeed = msg.slice(1, hLen + 1);
    var maskedDb = msg.slice(hLen + 1);
    var seed = xor(maskedSeed, mgf(maskedDb, hLen));
    var db = xor(maskedDb, mgf(seed, k - hLen - 1));
    if (compare(iHash, db.slice(0, hLen))) throw new Error('decryption error');
    var i = hLen;
    while(db[i] === 0)i++;
    if (db[i++] !== 1) throw new Error('decryption error');
    return db.slice(i);
}
function pkcs1(key, msg, reverse) {
    var p1 = msg.slice(0, 2);
    var i = 2;
    var status = 0;
    while(msg[i++] !== 0)if (i >= msg.length) {
        status++;
        break;
    }
    var ps = msg.slice(2, i - 1);
    if (p1.toString('hex') !== '0002' && !reverse || p1.toString('hex') !== '0001' && reverse) status++;
    if (ps.length < 8) status++;
    if (status) throw new Error('decryption error');
    return msg.slice(i);
}
function compare(a, b) {
    a = Buffer.from(a);
    b = Buffer.from(b);
    var dif = 0;
    var len = a.length;
    if (a.length !== b.length) {
        dif++;
        len = Math.min(a.length, b.length);
    }
    var i = -1;
    while(++i < len)dif += a[i] ^ b[i];
    return dif;
}

},{"6c46b1d8bb7eae7b":"4ddHc","9e51003323ea065d":"2ZUyP","637b57d34a8dda25":"9YYMN","3927561f39566b29":"grxMf","521cbc4ce6042d5b":"kxPiZ","95282d7c0e66f364":"aPKzt","1bc2f92e3c398dbe":"62cp6","802d086fb6d63368":"1Yph5"}],"dmZ1q":[function(require,module,exports,__globalThis) {
var global = arguments[3];
var process = require("e52c82591caff1d7");
'use strict';
function oldBrowser() {
    throw new Error('secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11');
}
var safeBuffer = require("954d667c0302f12c");
var randombytes = require("7041a0e993c249ef");
var Buffer = safeBuffer.Buffer;
var kBufferMaxLength = safeBuffer.kMaxLength;
var crypto = global.crypto || global.msCrypto;
var kMaxUint32 = Math.pow(2, 32) - 1;
function assertOffset(offset, length) {
    if (typeof offset !== 'number' || offset !== offset) throw new TypeError('offset must be a number');
    if (offset > kMaxUint32 || offset < 0) throw new TypeError('offset must be a uint32');
    if (offset > kBufferMaxLength || offset > length) throw new RangeError('offset out of range');
}
function assertSize(size, offset, length) {
    if (typeof size !== 'number' || size !== size) throw new TypeError('size must be a number');
    if (size > kMaxUint32 || size < 0) throw new TypeError('size must be a uint32');
    if (size + offset > length || size > kBufferMaxLength) throw new RangeError('buffer too small');
}
if (crypto && crypto.getRandomValues || false) {
    exports.randomFill = randomFill;
    exports.randomFillSync = randomFillSync;
} else {
    exports.randomFill = oldBrowser;
    exports.randomFillSync = oldBrowser;
}
function randomFill(buf, offset, size, cb) {
    if (!Buffer.isBuffer(buf) && !(buf instanceof global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    if (typeof offset === 'function') {
        cb = offset;
        offset = 0;
        size = buf.length;
    } else if (typeof size === 'function') {
        cb = size;
        size = buf.length - offset;
    } else if (typeof cb !== 'function') throw new TypeError('"cb" argument must be a function');
    assertOffset(offset, buf.length);
    assertSize(size, offset, buf.length);
    return actualFill(buf, offset, size, cb);
}
function actualFill(buf, offset, size, cb) {
    var ourBuf = buf.buffer;
    var uint = new Uint8Array(ourBuf, offset, size);
    crypto.getRandomValues(uint);
    if (cb) {
        process.nextTick(function() {
            cb(null, buf);
        });
        return;
    }
    return buf;
    if (cb) {
        randombytes(size, function(err, bytes) {
            if (err) return cb(err);
            bytes.copy(buf, offset);
            cb(null, buf);
        });
        return;
    }
    var bytes = randombytes(size);
    bytes.copy(buf, offset);
    return buf;
}
function randomFillSync(buf, offset, size) {
    if (typeof offset === 'undefined') offset = 0;
    if (!Buffer.isBuffer(buf) && !(buf instanceof global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    assertOffset(offset, buf.length);
    if (size === undefined) size = buf.length - offset;
    assertSize(size, offset, buf.length);
    return actualFill(buf, offset, size);
}

},{"e52c82591caff1d7":"4jeNM","954d667c0302f12c":"1Yph5","7041a0e993c249ef":"jXr3f"}],"iSK2q":[function(require,module,exports,__globalThis) {
// #region Type aliases (2)
/**
 * File data
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createFolderStructure", ()=>createFolderStructure);
const createFolderStructure = (files)=>{
    let folderStructure = {};
    // Create the folder structure
    for(let i = 0; i < files.length; i++){
        // Split the file path into parts
        const parts = files[i].href.split("/");
        // Create the file data
        const fileData = {
            name: parts[parts.length - 2],
            href: files[i].href,
            codeSandBox: files[i].codeSandBoxUrl,
            github: files[i].githubUrl,
            folders: parts.slice(1, parts.length - 2),
            description: files[i].description
        };
        // Add the file data to the folder structure
        let currentFolder = folderStructure;
        for(let j = 0; j < fileData.folders.length; j++){
            if (!currentFolder[fileData.folders[j]]) currentFolder[fileData.folders[j]] = {};
            if (j === fileData.folders.length - 1) // in the last folder add the file data
            currentFolder[fileData.folders[j]][fileData.name] = fileData;
            else // go deeper into the folder structure
            currentFolder = currentFolder[fileData.folders[j]];
        }
    }
    return folderStructure;
} // #endregion Variables (1)
;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}]},["gOt5b"], "gOt5b", "parcelRequire842f", {})

//# sourceMappingURL=ViewerExamples.0e3edbe8.js.map
